var bL = Object.defineProperty;
var wL = (e, n, t) => n in e ? bL(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var N = (e, n, t) => (wL(e, typeof n != "symbol" ? n + "" : n, t), t);
import { defineComponent as oe, resolveComponent as D, openBlock as V, createElementBlock as ue, Fragment as st, renderSlot as Ke, createVNode as z, withCtx as k, createElementVNode as ae, normalizeClass as J, createBlock as X, createSlots as Tt, createCommentVNode as Ze, renderList as Et, resolveDynamicComponent as Gi, toDisplayString as wt, withKeys as Ma, createTextVNode as $h, markRaw as Le, withModifiers as fo, isRef as af, ref as Xt, getCurrentScope as LL, onScopeDispose as SL, unref as Er, toRef as CL, readonly as Vm, customRef as ML, getCurrentInstance as Su, onMounted as Hm, nextTick as Cu, watch as xr, computed as mt, shallowRef as TL, watchEffect as EL, h as ss, reactive as lf, normalizeStyle as lu, warn as AL, inject as Mu, provide as PL, Transition as xL, withDirectives as OL, vShow as NL, createApp as IL, toRefs as kL, effectScope as DL } from "vue";
const Ta = {
  en: "en-GB",
  fr: "fr-FR"
}, gi = {
  lat: 0,
  lng: 0,
  get center() {
    return [this.lat, this.lng];
  },
  zoom: 3,
  nearZoom: 10,
  levelDeepPolygon: 1
}, $L = {
  className: "marker",
  iconSize: [20, 30],
  iconAnchor: [10, 30]
}, RL = {
  color: "#1976d2",
  errorColor: "#C10015",
  stroke: !0,
  weight: 3,
  opacity: 1,
  fill: !0
}, Rh = {
  maxZoom: 24,
  type: "roadmap",
  styles: [
    { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "transit", elementType: "labels", stylers: [{ visibility: "off" }] }
  ]
}, jm = [10, 20, 50, 100], vR = "all", zL = jm[0], BL = 1, Lp = {
  and: "and",
  or: "or"
}, FL = {
  superAdmin: "SUPERADMIN"
}, yR = {
  countryList: "LIST_MBO_COUNTRY",
  eventsAdmin: "ADMIN_MBO_EVENT",
  eventsRead: "READ_MBO_EVENT",
  eventsList: "LIST_MBO_EVENT",
  eventsWrite: "WRITE_MBO_EVENT",
  templateRender: "RENDER_MBO_EVENT_TEMPLATE",
  eventsDelete: "DELETE_MBO_EVENT",
  regionsAdmin: "ADMIN_MBO_REGION",
  regionsRead: "READ_MBO_REGION",
  regionsList: "LIST_MBO_REGION",
  regionsWrite: "WRITE_MBO_REGION",
  regionsDelete: "DELETE_MBO_REGION",
  usersAdmin: "ADMIN_MAILING_SUBSCRIPTIONS",
  usersRead: "READ_MAILING_SUBSCRIPTIONS",
  usersList: "LIST_MAILING_SUBSCRIPTIONS",
  usersWrite: "WRITE_MAILING_SUBSCRIPTIONS",
  usersDelete: "DELETE_MAILING_SUBSCRIPTIONS",
  riskLevelSourcesList: "LIST_MBO_RISK_LEVEL_SOURCE",
  riskLevelSourcesWrite: "WRITE_MBO_RISK_LEVEL_SOURCE",
  riskLevelSourcesDelete: "WRITE_MBO_RISK_LEVEL_SOURCE",
  riskLevelCategoriesList: "LIST_MBO_RISK_LEVELS_CATEGORY",
  riskLevelCategoriesWrite: "WRITE_MBO_RISK_LEVELS_CATEGORY",
  riskLevelCategoriesDelete: "DELETE_MBO_RISK_LEVELS_CATEGORY",
  riskLevelCountriesList: "LIST_MBO_COUNTRY_RISK_LEVEL",
  riskLevelCountriesWrite: "WRITE_MBO_COUNTRY_RISK_LEVEL",
  riskLevelCountriesDelete: "DELETE_MBO_COUNTRY_RISK_LEVEL",
  riskLevelCountryFilesAdmin: "ADMIN_MBO_COUNTRY_FILES",
  riskLevelCountryFilesRead: "READ_MBO_COUNTRY_FILES",
  riskLevelCountryFilesWrite: "WRITE_MBO_COUNTRY_FILES",
  riskLevelCountryFilesDelete: "DELETE_MBO_COUNTRY_FILES",
  riskLevelCountryFilesPublish: "PUBLISH_MBO_COUNTRY_FILES",
  riskLevelCountryFilesList: "LIST_MBO_COUNTRY_FILES"
}, cs = {
  alert: 1,
  confirm: 2
}, UL = oe({
  emits: ["opened", "closed", "open", "close"],
  props: {
    width: {
      type: [String, Number]
    }
  },
  data() {
    return {
      dialog: !1,
      dialogOpen: !1,
      dialogOpened: !1
    };
  },
  methods: {
    open() {
      this.dialog = !0;
    },
    close() {
      this.dialog = !1;
    },
    onOpen() {
      this.dialogOpen = !0, this.$emit("open");
    },
    onClose() {
      this.$emit("close"), this.dialogOpen = !1;
    },
    onOpened() {
      this.dialogOpened = !0, this.$emit("opened");
    },
    onClosed() {
      this.$emit("closed"), this.dialogOpened = !1;
    }
  }
}), VL = "_footer_1sbu6_19", HL = {
  footer: VL
}, ce = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [a, u] of n)
    t[a] = u;
  return t;
};
function jL(e, n, t, a, u, f) {
  const d = D("el-dialog");
  return V(), ue(st, null, [
    Ke(e.$slots, "activator", { open: e.open }),
    z(d, {
      modelValue: e.dialog,
      "onUpdate:modelValue": n[0] || (n[0] = (m) => e.dialog = m),
      width: e.width || "auto",
      "append-to-body": "",
      "align-center": "",
      onOpen: e.onOpen,
      onClose: e.onClose,
      onOpened: e.onOpened,
      onClosed: e.onClosed
    }, {
      header: k(() => [
        Ke(e.$slots, "header")
      ]),
      default: k(() => [
        Ke(e.$slots, "default", {
          dialogOpened: e.dialogOpened,
          dialogOpen: e.dialogOpen
        })
      ]),
      footer: k(() => [
        ae("div", {
          class: J(e.$style.footer)
        }, [
          Ke(e.$slots, "footer", { close: e.close })
        ], 2)
      ]),
      _: 3
    }, 8, ["modelValue", "width", "onOpen", "onClose", "onOpened", "onClosed"])
  ], 64);
}
const ZL = {
  $style: HL
}, Ls = /* @__PURE__ */ ce(UL, [["render", jL], ["__cssModules", ZL]]), WL = "_content_573rj_1", GL = "_footer_573rj_5", qL = {
  content: WL,
  footer: GL
}, KL = oe({
  type: cs.alert,
  emits: ["result"],
  props: {
    title: {
      type: String
    },
    content: {
      type: [String, Array]
    },
    options: {
      type: Object
    }
  },
  computed: {
    contentHtml() {
      return (Array.isArray(this.content) ? this.content : [this.content]).join(",<br>");
    }
  },
  methods: {
    cancel() {
      this.$refs.dialogComponent.close();
    },
    closed() {
      this.$emit("result", !1);
    }
  },
  components: {
    DialogComponent: Ls
  }
}), YL = ["innerHTML"], QL = ["innerHTML"], JL = /* @__PURE__ */ ae("span", null, "Ok", -1);
function XL(e, n, t, a, u, f) {
  const d = D("el-button"), m = D("dialog-component");
  return V(), X(m, {
    width: e.options.width,
    ref: "dialogComponent",
    onClosed: e.closed
  }, Tt({
    footer: k(() => [
      ae("div", {
        class: J(e.$style.footer)
      }, [
        z(d, {
          text: "",
          type: "primary",
          onClick: e.cancel
        }, {
          default: k(() => [
            JL
          ]),
          _: 1
        }, 8, ["onClick"])
      ], 2)
    ]),
    default: k(() => [
      e.content ? (V(), ue("div", {
        key: 0,
        class: J(e.$style.content)
      }, [
        ae("span", { innerHTML: e.contentHtml }, null, 8, QL)
      ], 2)) : Ze("", !0)
    ]),
    _: 2
  }, [
    e.title ? {
      name: "header",
      fn: k(() => [
        ae("span", { innerHTML: e.title }, null, 8, YL)
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["width", "onClosed"]);
}
const eS = {
  $style: qL
}, tS = /* @__PURE__ */ ce(KL, [["render", XL], ["__cssModules", eS]]), nS = "_content_o20ns_1", iS = "_footer_o20ns_5", rS = {
  content: nS,
  footer: iS
}, oS = oe({
  type: cs.confirm,
  emits: ["result"],
  props: {
    title: {
      type: String
    },
    content: {
      type: String
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      result: !1
    };
  },
  mounted() {
    this.result = !1, this.$refs.dialogComponent.open();
  },
  methods: {
    agree() {
      this.result = !0, this.$refs.dialogComponent.close();
    },
    cancel() {
      this.result = !1, this.$refs.dialogComponent.close();
    },
    closed() {
      this.$emit("result", this.result);
    }
  },
  components: {
    DialogComponent: Ls
  }
}), sS = ["innerHTML"], aS = ["innerHTML"], lS = /* @__PURE__ */ ae("span", null, "Cancel", -1), uS = /* @__PURE__ */ ae("span", null, "Ok", -1);
function cS(e, n, t, a, u, f) {
  const d = D("el-button"), m = D("dialog-component");
  return V(), X(m, {
    width: e.options.width,
    ref: "dialogComponent",
    onClosed: e.closed
  }, {
    header: k(() => [
      ae("span", {
        innerHTML: e.title || "Are you sure?"
      }, null, 8, sS)
    ]),
    footer: k(() => [
      ae("div", {
        class: J(e.$style.footer)
      }, [
        z(d, {
          text: "",
          type: "primary",
          onClick: e.cancel
        }, {
          default: k(() => [
            lS
          ]),
          _: 1
        }, 8, ["onClick"]),
        z(d, {
          text: "",
          type: "primary",
          onClick: e.agree
        }, {
          default: k(() => [
            uS
          ]),
          _: 1
        }, 8, ["onClick"])
      ], 2)
    ]),
    default: k(() => [
      e.content ? (V(), ue("div", {
        key: 0,
        class: J(e.$style.content)
      }, [
        ae("span", { innerHTML: e.content }, null, 8, aS)
      ], 2)) : Ze("", !0)
    ]),
    _: 1
  }, 8, ["width", "onClosed"]);
}
const hS = {
  $style: rS
}, fS = /* @__PURE__ */ ce(oS, [["render", cS], ["__cssModules", hS]]), dS = {
  AlertComponent: tS,
  ConfirmComponent: fS
};
function pS(e) {
  return Object.values(dS).find((n) => n.type === e);
}
const mS = oe({
  data() {
    return {
      options: {
        width: 500
      },
      alerts: [],
      confirms: []
    };
  },
  methods: {
    getComponentByType: pS,
    createDialog(e) {
      return new Promise((n, t) => {
        const a = {
          options: this.options,
          ...e,
          resolve: n,
          reject: t
        };
        a.type === cs.alert && (this.alerts = this.alerts.concat(a)), a.type === cs.confirm && (this.confirms = this.confirms.concat(a));
      });
    },
    alert(e) {
      const n = { ...e, type: cs.alert };
      return this.createDialog(n);
    },
    confirm(e) {
      const n = { ...e, type: cs.confirm };
      return this.createDialog(n);
    },
    onConfirmResult(e, n) {
      this.confirms[e].resolve(n), this.confirms = this.confirms.filter((a, u) => u !== e);
    },
    onAlertResult(e, n) {
      this.alerts[e].resolve(n), this.alerts = this.alerts.filter((a, u) => u !== e);
    }
  }
});
function _S(e, n, t, a, u, f) {
  return V(), ue("div", null, [
    (V(!0), ue(st, null, Et(e.alerts, (d, m) => (V(), X(Gi(e.getComponentByType(d.type)), {
      key: m,
      title: d.title,
      content: d.content,
      options: d.options,
      onResult: (g) => e.onAlertResult(m, g)
    }, null, 40, ["title", "content", "options", "onResult"]))), 128)),
    (V(!0), ue(st, null, Et(e.confirms, (d, m) => (V(), X(Gi(e.getComponentByType(d.type)), {
      key: m,
      title: d.title,
      content: d.content,
      options: d.options,
      onResult: (g) => e.onConfirmResult(m, g)
    }, null, 40, ["title", "content", "options", "onResult"]))), 128))
  ]);
}
const gS = /* @__PURE__ */ ce(mS, [["render", _S]]), vS = oe({
  props: {
    route: {
      type: Object,
      required: !0
    }
  },
  computed: {
    breadcrumbs() {
      return this.route.path.split("/");
    }
  }
}), yS = "_component_h78lz_1", bS = "_component__divider_h78lz_5", wS = "_component__container_h78lz_8", LS = "_component__breadcrumbs_h78lz_13", SS = "_component__path_h78lz_22", CS = "_component__status_h78lz_26", MS = {
  component: yS,
  component__divider: bS,
  component__container: wS,
  component__breadcrumbs: LS,
  component__path: SS,
  component__status: CS
}, TS = /* @__PURE__ */ ae("span", null, "Data loaded", -1), ES = [
  TS
];
function AS(e, n, t, a, u, f) {
  const d = D("el-divider"), m = D("icon-home-filled"), g = D("el-icon"), y = D("helper-link"), w = D("el-breadcrumb-item"), h = D("el-breadcrumb"), b = D("el-footer");
  return V(), X(b, {
    class: J(e.$style.component)
  }, {
    default: k(() => [
      z(d, {
        class: J(e.$style.component__divider)
      }, null, 8, ["class"]),
      ae("div", {
        class: J(e.$style.component__container)
      }, [
        ae("div", {
          class: J(e.$style.component__breadcrumbs)
        }, [
          z(h, { separator: "/" }, {
            default: k(() => [
              (V(!0), ue(st, null, Et(e.breadcrumbs, (T, A) => (V(), X(w, { key: A }, {
                default: k(() => [
                  z(y, {
                    href: T ? `${e.breadcrumbs.slice(0, A + 1).join("/")}` : "/"
                  }, {
                    default: k(() => [
                      T ? (V(), ue("span", {
                        key: 0,
                        class: J(e.$style.component__path)
                      }, wt(T), 3)) : (V(), X(g, { key: 1 }, {
                        default: k(() => [
                          z(m)
                        ]),
                        _: 1
                      }))
                    ]),
                    _: 2
                  }, 1032, ["href"])
                ]),
                _: 2
              }, 1024))), 128))
            ]),
            _: 1
          })
        ], 2),
        ae("div", {
          class: J(e.$style.component__status)
        }, ES, 2)
      ], 2)
    ]),
    _: 1
  }, 8, ["class"]);
}
const PS = {
  $style: MS
}, xS = /* @__PURE__ */ ce(vS, [["render", AS], ["__cssModules", PS]]), OS = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgYXJpYS1oaWRkZW49InRydWUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjFlbSIgaGVpZ2h0PSIxZW0iIGZpbGw9IiNGMkYwRTQiPjxwYXRoIGQ9Ik0wIDk2YzAtMTMuMjU1IDEwLjc0NS0yNCAyNC0yNGg0NjRjMTMuMjU1IDAgMjQgMTAuNzQ1IDI0IDI0cy0xMC43NDUgMjQtMjQgMjRIMjRjLTEzLjI1NSAwLTI0LTEwLjc0NS0yNC0yNHptMCAxNjBjMC0xMy4yNTUgMTAuNzQ1LTI0IDI0LTI0aDQ2NGMxMy4yNTUgMCAyNCAxMC43NDUgMjQgMjRzLTEwLjc0NSAyNC0yNCAyNEgyNGMtMTMuMjU1IDAtMjQtMTAuNzQ1LTI0LTI0em0wIDE2MGMwLTEzLjI1NSAxMC43NDUtMjQgMjQtMjRoNDY0YzEzLjI1NSAwIDI0IDEwLjc0NSAyNCAyNHMtMTAuNzQ1IDI0LTI0IDI0SDI0Yy0xMy4yNTUgMC0yNC0xMC43NDUtMjQtMjR6Ij48L3BhdGg+PC9zdmc+Cg==", NS = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgYXJpYS1oaWRkZW49InRydWUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjFlbSIgaGVpZ2h0PSIxZW0iIGZpbGw9IiMwRjNENDQiPjxwYXRoIGQ9Ik0wIDk2YzAtMTMuMjU1IDEwLjc0NS0yNCAyNC0yNGg0NjRjMTMuMjU1IDAgMjQgMTAuNzQ1IDI0IDI0cy0xMC43NDUgMjQtMjQgMjRIMjRjLTEzLjI1NSAwLTI0LTEwLjc0NS0yNC0yNHptMCAxNjBjMC0xMy4yNTUgMTAuNzQ1LTI0IDI0LTI0aDQ2NGMxMy4yNTUgMCAyNCAxMC43NDUgMjQgMjRzLTEwLjc0NSAyNC0yNCAyNEgyNGMtMTMuMjU1IDAtMjQtMTAuNzQ1LTI0LTI0em0wIDE2MGMwLTEzLjI1NSAxMC43NDUtMjQgMjQtMjRoNDY0YzEzLjI1NSAwIDI0IDEwLjc0NSAyNCAyNHMtMTAuNzQ1IDI0LTI0IDI0SDI0Yy0xMy4yNTUgMC0yNC0xMC43NDUtMjQtMjR6Ij48L3BhdGg+PC9zdmc+Cg==", IS = oe({
  emits: ["update:model-value"],
  props: {
    modelValue: {
      type: Boolean
    },
    mainMenu: {
      type: Array,
      required: !0
    }
  },
  computed: {
    drawer: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:model-value", e);
      }
    }
  },
  methods: {
    onCloseClick() {
      this.drawer = !1;
    },
    onMenuKeyupEnter(e) {
      this.$refs.menu.open(`${e}`);
    }
  }
}), kS = "_drawer_2a5bt_1", DS = "_drawer__link_2a5bt_9", $S = "_drawer__logo_2a5bt_15", RS = "_drawer__close_2a5bt_18", zS = "_nav_2a5bt_34", BS = "_menu_2a5bt_39", FS = "_profile_2a5bt_55", US = "_profile__avatar_2a5bt_62", VS = {
  drawer: kS,
  drawer__link: DS,
  drawer__logo: $S,
  drawer__close: RS,
  nav: zS,
  menu: BS,
  profile: FS,
  profile__avatar: US
};
function HS(e, n, t, a, u, f) {
  const d = D("icon-close"), m = D("el-icon"), g = D("el-button"), y = D("helper-link"), w = D("el-menu-item"), h = D("el-sub-menu"), b = D("el-menu"), T = D("el-divider"), A = D("el-drawer");
  return V(), ue("div", null, [
    z(A, {
      modelValue: e.drawer,
      "onUpdate:modelValue": n[2] || (n[2] = (x) => e.drawer = x),
      class: J(e.$style.drawer),
      "show-close": !1,
      size: "100%"
    }, {
      header: k(() => [
        ae("div", {
          class: J(e.$style.drawer__logo)
        }, [
          Ke(e.$slots, "logo")
        ], 2),
        z(g, {
          class: J(e.$style.drawer__close),
          text: "",
          onClick: e.onCloseClick
        }, {
          default: k(() => [
            z(m, {
              size: "28",
              color: "var(--el-color-primary)"
            }, {
              default: k(() => [
                z(d)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class", "onClick"])
      ]),
      default: k(() => [
        ae("nav", {
          class: J(e.$style.nav)
        }, [
          z(b, {
            class: J(e.$style.menu),
            ref: "menu"
          }, {
            default: k(() => [
              (V(!0), ue(st, null, Et(e.mainMenu, (x, Z) => (V(), ue(st, { key: Z }, [
                x.href ? (V(), X(w, { key: 0 }, {
                  default: k(() => [
                    x.href ? (V(), X(y, {
                      key: 0,
                      href: x.href,
                      class: J(e.$style.link),
                      onClick: n[0] || (n[0] = (H) => e.drawer = !1)
                    }, {
                      default: k(() => [
                        ae("span", null, wt(x.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["href", "class"])) : Ze("", !0)
                  ]),
                  _: 2
                }, 1024)) : (V(), X(h, {
                  key: 1,
                  index: `${Z}`
                }, {
                  title: k(() => [
                    z(y, {
                      class: J(e.$style.link),
                      tabindex: "0",
                      onKeyup: Ma((H) => e.onMenuKeyupEnter(Z), ["enter"])
                    }, {
                      default: k(() => [
                        ae("span", null, wt(x.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["class", "onKeyup"])
                  ]),
                  default: k(() => [
                    (V(!0), ue(st, null, Et(x.children, (H, Y) => (V(), X(w, { key: Y }, {
                      default: k(() => [
                        z(y, {
                          href: H.href,
                          class: J(e.$style.link),
                          onClick: n[1] || (n[1] = (ee) => e.drawer = !1)
                        }, {
                          default: k(() => [
                            ae("span", null, wt(H.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["href", "class"])
                      ]),
                      _: 2
                    }, 1024))), 128))
                  ]),
                  _: 2
                }, 1032, ["index"]))
              ], 64))), 128))
            ]),
            _: 1
          }, 8, ["class"]),
          e.$slots.submenu ? (V(), ue(st, { key: 0 }, [
            z(T, {
              class: J(e.$style.drawer__divider)
            }, null, 8, ["class"]),
            ae("ul", {
              class: J(e.$style.profile)
            }, [
              Ke(e.$slots, "submenu")
            ], 2)
          ], 64)) : Ze("", !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["modelValue", "class"])
  ]);
}
const jS = {
  $style: VS
}, ZS = /* @__PURE__ */ ce(IS, [["render", HS], ["__cssModules", jS]]), WS = oe({
  props: {
    mainMenu: {
      type: Array,
      required: !0
    },
    route: {
      type: Object,
      required: !0
    },
    isDark: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      hamburgerMenuDarkSvg: OS,
      hamburgerMenuLightSvg: NS,
      drawer: !1
    };
  },
  methods: {
    onHamburgerClick() {
      this.drawer = !this.drawer;
    },
    onLinkClick(e) {
      const [n] = this.$refs[`elPopover${e}`];
      n.hide();
    }
  },
  components: {
    DrawerComponent: ZS
  }
}), GS = "_component_36zn8_1", qS = "_component__container_36zn8_5", KS = "_component__logo_36zn8_17", YS = "_component__divider_36zn8_26", QS = "_profile_36zn8_40", JS = "_profile__avatar_36zn8_43", XS = "_profile__menu_36zn8_53", eC = "_menu_36zn8_73", tC = "_menu__link_36zn8_79", nC = "_active_36zn8_93", iC = "_submenu_36zn8_98", rC = "_submenu__link_36zn8_103", oC = "_submenu__avatar_36zn8_111", sC = "_submenu__arrow_36zn8_114", aC = "_submenu__text_36zn8_127", lC = "_submenu__title_36zn8_130", uC = "_submenu__description_36zn8_135", cC = "_hamburger__button_36zn8_144", hC = "_hamburger__img_36zn8_159", fC = {
  component: GS,
  component__container: qS,
  component__logo: KS,
  component__divider: YS,
  profile: QS,
  "profile__avatar-btn": "_profile__avatar-btn_36zn8_43",
  profile__avatar: JS,
  profile__menu: XS,
  menu: eC,
  menu__link: tC,
  active: nC,
  submenu: iC,
  submenu__link: rC,
  submenu__avatar: oC,
  submenu__arrow: sC,
  submenu__text: aC,
  submenu__title: lC,
  submenu__description: uC,
  hamburger__button: cC,
  hamburger__img: hC
};
function dC(e, n, t, a, u, f) {
  const d = D("helper-link"), m = D("el-avatar"), g = D("icon-right"), y = D("el-icon"), w = D("el-popover"), h = D("el-image"), b = D("el-button"), T = D("el-menu"), A = D("el-divider"), x = D("drawer-component"), Z = D("el-header");
  return V(), X(Z, {
    class: J(e.$style.component)
  }, {
    default: k(() => [
      ae("div", {
        class: J(e.$style.component__container)
      }, [
        e.$slots.logo ? (V(), ue("div", {
          key: 0,
          class: J(e.$style.component__logo)
        }, [
          Ke(e.$slots, "logo")
        ], 2)) : Ze("", !0),
        ae("ul", {
          class: J([e.$style.menu, "hidden-sm-and-down"])
        }, [
          (V(!0), ue(st, null, Et(e.mainMenu, (H, Y) => (V(), ue("li", { key: Y }, [
            H.href ? (V(), X(d, {
              key: 0,
              href: H.href,
              class: J([e.$style.menu__link, { [e.$style.active]: e.route.fullPath.includes(H.active) }])
            }, {
              default: k(() => [
                ae("span", null, wt(H.title), 1)
              ]),
              _: 2
            }, 1032, ["href", "class"])) : (V(), X(w, {
              key: 1,
              offset: 0,
              "hide-after": 0,
              teleported: !1,
              width: 400,
              ref_for: !0,
              ref: `elPopover${Y}`
            }, {
              reference: k(() => [
                z(d, {
                  class: J([e.$style.menu__link, { [e.$style.active]: e.route.fullPath.includes(H.active) }]),
                  tabindex: "0"
                }, {
                  default: k(() => [
                    ae("span", null, wt(H.title), 1)
                  ]),
                  _: 2
                }, 1032, ["class"])
              ]),
              default: k(() => [
                ae("ul", {
                  class: J(e.$style.submenu)
                }, [
                  (V(!0), ue(st, null, Et(H.children, (ee, re) => (V(), ue("li", {
                    key: re,
                    class: J(e.$style.submenu__item)
                  }, [
                    z(d, {
                      href: ee.href,
                      class: J(e.$style.submenu__link),
                      onClick: (be) => e.onLinkClick(Y)
                    }, {
                      default: k(() => [
                        z(m, {
                          class: J(e.$style.submenu__avatar),
                          size: 36,
                          icon: ee.icon,
                          shape: "square"
                        }, null, 8, ["class", "icon"]),
                        ae("div", {
                          class: J(e.$style.submenu__text)
                        }, [
                          ae("div", {
                            class: J(e.$style.submenu__title)
                          }, wt(ee.title), 3),
                          ae("p", {
                            class: J(e.$style.submenu__description)
                          }, wt(ee.description), 3)
                        ], 2),
                        z(y, {
                          class: J(e.$style.submenu__arrow)
                        }, {
                          default: k(() => [
                            z(g)
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 2
                    }, 1032, ["href", "class", "onClick"])
                  ], 2))), 128))
                ], 2)
              ]),
              _: 2
            }, 1536))
          ]))), 128))
        ], 2),
        z(b, {
          class: J([e.$style.hamburger__button, "hidden-md-and-up"]),
          underline: !1,
          text: "",
          onClick: e.onHamburgerClick
        }, {
          default: k(() => [
            z(h, {
              src: e.isDark ? e.hamburgerMenuDarkSvg : e.hamburgerMenuLightSvg,
              class: J(e.$style.hamburger__img)
            }, null, 8, ["src", "class"])
          ]),
          _: 1
        }, 8, ["class", "onClick"]),
        e.$slots.submenu ? (V(), X(w, {
          key: 1,
          offset: 5,
          "hide-after": 100,
          width: 270,
          teleported: !1,
          "popper-class": e.$style.profile
        }, {
          reference: k(() => [
            z(d, {
              class: J([e.$style["profile__avatar-btn"], "hidden-sm-and-down"]),
              tabindex: "0"
            }, {
              default: k(() => [
                z(m, {
                  class: J(e.$style.profile__avatar),
                  size: 52,
                  icon: "IconUser",
                  color: "primary"
                }, null, 8, ["class"])
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          default: k(() => [
            z(T, {
              class: J(e.$style.profile__menu)
            }, {
              default: k(() => [
                Ke(e.$slots, "submenu")
              ]),
              _: 3
            }, 8, ["class"])
          ]),
          _: 3
        }, 8, ["popper-class"])) : Ze("", !0)
      ], 2),
      z(A, {
        class: J(e.$style.component__divider)
      }, null, 8, ["class"]),
      z(x, {
        modelValue: e.drawer,
        "onUpdate:modelValue": n[0] || (n[0] = (H) => e.drawer = H),
        "main-menu": e.mainMenu,
        class: "hidden-md-and-up"
      }, Tt({ _: 2 }, [
        e.$slots.logo ? {
          name: "logo",
          fn: k(() => [
            Ke(e.$slots, "logo")
          ]),
          key: "0"
        } : void 0,
        e.$slots.submenu ? {
          name: "submenu",
          fn: k(() => [
            Ke(e.$slots, "submenu")
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["modelValue", "main-menu"])
    ]),
    _: 3
  }, 8, ["class"]);
}
const pC = {
  $style: fC
}, mC = /* @__PURE__ */ ce(WS, [["render", dC], ["__cssModules", pC]]), _C = oe({
  props: {
    error: {
      type: String
    }
  }
}), gC = "_component_yrikm_1", vC = "_component__icon_yrikm_7", yC = {
  component: gC,
  component__icon: vC
}, bC = ["innerHTML"];
function wC(e, n, t, a, u, f) {
  const d = D("icon-warning-filled");
  return V(), ue("span", {
    class: J(e.$style.component)
  }, [
    z(d, {
      class: J(e.$style.component__icon)
    }, null, 8, ["class"]),
    ae("span", { innerHTML: e.error }, null, 8, bC)
  ], 2);
}
const LC = {
  $style: yC
}, uf = /* @__PURE__ */ ce(_C, [["render", wC], ["__cssModules", LC]]);
var as = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Zm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function SC(e) {
  if (e.__esModule)
    return e;
  var n = e.default;
  if (typeof n == "function") {
    var t = function a() {
      if (this instanceof a) {
        var u = [null];
        u.push.apply(u, arguments);
        var f = Function.bind.apply(n, u);
        return new f();
      }
      return n.apply(this, arguments);
    };
    t.prototype = n.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(e).forEach(function(a) {
    var u = Object.getOwnPropertyDescriptor(e, a);
    Object.defineProperty(t, a, u.get ? u : {
      enumerable: !0,
      get: function() {
        return e[a];
      }
    });
  }), t;
}
var uu = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
uu.exports;
(function(e, n) {
  (function() {
    var t, a = "4.17.21", u = 200, f = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", d = "Expected a function", m = "Invalid `variable` option passed into `_.template`", g = "__lodash_hash_undefined__", y = 500, w = "__lodash_placeholder__", h = 1, b = 2, T = 4, A = 1, x = 2, Z = 1, H = 2, Y = 4, ee = 8, re = 16, be = 32, Xe = 64, Fe = 128, ge = 256, qe = 512, at = 30, _t = "...", nt = 800, wn = 16, At = 1, Ki = 2, gt = 3, Ln = 1 / 0, fe = 9007199254740991, Fa = 17976931348623157e292, _e = 0 / 0, Ue = 4294967295, Ht = Ue - 1, jt = Ue >>> 1, vt = [
      ["ary", Fe],
      ["bind", Z],
      ["bindKey", H],
      ["curry", ee],
      ["curryRight", re],
      ["flip", qe],
      ["partial", be],
      ["partialRight", Xe],
      ["rearg", ge]
    ], Re = "[object Arguments]", Pe = "[object Array]", Zn = "[object AsyncFunction]", fn = "[object Boolean]", Yi = "[object Date]", Ps = "[object DOMException]", Qi = "[object Error]", oi = "[object Function]", Co = "[object GeneratorFunction]", Sn = "[object Map]", Ji = "[object Number]", Ua = "[object Null]", Cn = "[object Object]", Ir = "[object Promise]", Hu = "[object Proxy]", Xi = "[object RegExp]", en = "[object Set]", er = "[object String]", kr = "[object Symbol]", ju = "[object Undefined]", Dr = "[object WeakMap]", xs = "[object WeakSet]", tr = "[object ArrayBuffer]", Ci = "[object DataView]", Os = "[object Float32Array]", Mo = "[object Float64Array]", To = "[object Int8Array]", Ns = "[object Int16Array]", Eo = "[object Int32Array]", $r = "[object Uint8Array]", Ao = "[object Uint8ClampedArray]", Is = "[object Uint16Array]", Mi = "[object Uint32Array]", Zu = /\b__p \+= '';/g, Wu = /\b(__p \+=) '' \+/g, Va = /(__e\(.*?\)|\b__t\)) \+\n'';/g, ks = /&(?:amp|lt|gt|quot|#39);/g, Ds = /[&<>"']/g, Gu = RegExp(ks.source), qu = RegExp(Ds.source), Ku = /<%-([\s\S]+?)%>/g, Yu = /<%([\s\S]+?)%>/g, Ha = /<%=([\s\S]+?)%>/g, Qu = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $s = /^\w*$/, Ju = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Rs = /[\\^$.*+?()[\]{}|]/g, Xu = RegExp(Rs.source), zs = /^\s+/, In = /\s/, le = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, ja = /\{\n\/\* \[wrapped with (.+)\] \*/, Za = /,? & /, Wa = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ga = /[()=,{}\[\]\/\s]/, Bs = /\\(\\)?/g, qa = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ti = /\w*$/, Ka = /^[-+]0x[0-9a-f]+$/i, ec = /^0b[01]+$/i, tc = /^\[object .+?Constructor\]$/, nc = /^0o[0-7]+$/i, ic = /^(?:0|[1-9]\d*)$/, Ya = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Po = /($^)/, xo = /['\n\r\u2028\u2029\\]/g, Oo = "\\ud800-\\udfff", rc = "\\u0300-\\u036f", oc = "\\ufe20-\\ufe2f", sc = "\\u20d0-\\u20ff", Qa = rc + oc + sc, No = "\\u2700-\\u27bf", nr = "a-z\\xdf-\\xf6\\xf8-\\xff", Ja = "\\xac\\xb1\\xd7\\xf7", Xa = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Rr = "\\u2000-\\u206f", Ve = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", it = "A-Z\\xc0-\\xd6\\xd8-\\xde", zr = "\\ufe0e\\ufe0f", Ei = Ja + Xa + Rr + Ve, si = "['’]", Fs = "[" + Oo + "]", Se = "[" + Ei + "]", rt = "[" + Qa + "]", Io = "\\d+", ko = "[" + No + "]", tn = "[" + nr + "]", el = "[^" + Oo + Ei + Io + No + nr + it + "]", ir = "\\ud83c[\\udffb-\\udfff]", Ai = "(?:" + rt + "|" + ir + ")", ft = "[^" + Oo + "]", Wn = "(?:\\ud83c[\\udde6-\\uddff]){2}", Pi = "[\\ud800-\\udbff][\\udc00-\\udfff]", kn = "[" + it + "]", Do = "\\u200d", rr = "(?:" + tn + "|" + el + ")", Us = "(?:" + kn + "|" + el + ")", $o = "(?:" + si + "(?:d|ll|m|re|s|t|ve))?", Br = "(?:" + si + "(?:D|LL|M|RE|S|T|VE))?", Ro = Ai + "?", zo = "[" + zr + "]?", Bo = "(?:" + Do + "(?:" + [ft, Wn, Pi].join("|") + ")" + zo + Ro + ")*", tl = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Vs = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", nl = zo + Ro + Bo, we = "(?:" + [ko, Wn, Pi].join("|") + ")" + nl, Dn = "(?:" + [ft + rt + "?", rt, Wn, Pi, Fs].join("|") + ")", et = RegExp(si, "g"), il = RegExp(rt, "g"), Fr = RegExp(ir + "(?=" + ir + ")|" + Dn + nl, "g"), Hs = RegExp([
      kn + "?" + tn + "+" + $o + "(?=" + [Se, kn, "$"].join("|") + ")",
      Us + "+" + Br + "(?=" + [Se, kn + rr, "$"].join("|") + ")",
      kn + "?" + rr + "+" + $o,
      kn + "+" + Br,
      Vs,
      tl,
      Io,
      we
    ].join("|"), "g"), js = RegExp("[" + Do + Oo + Qa + zr + "]"), xi = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Zs = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Ur = -1, Ce = {};
    Ce[Os] = Ce[Mo] = Ce[To] = Ce[Ns] = Ce[Eo] = Ce[$r] = Ce[Ao] = Ce[Is] = Ce[Mi] = !0, Ce[Re] = Ce[Pe] = Ce[tr] = Ce[fn] = Ce[Ci] = Ce[Yi] = Ce[Qi] = Ce[oi] = Ce[Sn] = Ce[Ji] = Ce[Cn] = Ce[Xi] = Ce[en] = Ce[er] = Ce[Dr] = !1;
    var He = {};
    He[Re] = He[Pe] = He[tr] = He[Ci] = He[fn] = He[Yi] = He[Os] = He[Mo] = He[To] = He[Ns] = He[Eo] = He[Sn] = He[Ji] = He[Cn] = He[Xi] = He[en] = He[er] = He[kr] = He[$r] = He[Ao] = He[Is] = He[Mi] = !0, He[Qi] = He[oi] = He[Dr] = !1;
    var rl = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, ol = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, ac = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, sl = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Ws = parseFloat, lc = parseInt, Gs = typeof as == "object" && as && as.Object === Object && as, De = typeof self == "object" && self && self.Object === Object && self, Pt = Gs || De || Function("return this")(), nn = n && !n.nodeType && n, Mn = nn && !0 && e && !e.nodeType && e, qs = Mn && Mn.exports === nn, Ks = qs && Gs.process, Zt = function() {
      try {
        var $ = Mn && Mn.require && Mn.require("util").types;
        return $ || Ks && Ks.binding && Ks.binding("util");
      } catch {
      }
    }(), al = Zt && Zt.isArrayBuffer, Ys = Zt && Zt.isDate, ll = Zt && Zt.isMap, ul = Zt && Zt.isRegExp, Fo = Zt && Zt.isSet, cl = Zt && Zt.isTypedArray;
    function ut($, j, U) {
      switch (U.length) {
        case 0:
          return $.call(j);
        case 1:
          return $.call(j, U[0]);
        case 2:
          return $.call(j, U[0], U[1]);
        case 3:
          return $.call(j, U[0], U[1], U[2]);
      }
      return $.apply(j, U);
    }
    function uc($, j, U, ie) {
      for (var ve = -1, je = $ == null ? 0 : $.length; ++ve < je; ) {
        var Lt = $[ve];
        j(ie, Lt, U(Lt), $);
      }
      return ie;
    }
    function rn($, j) {
      for (var U = -1, ie = $ == null ? 0 : $.length; ++U < ie && j($[U], U, $) !== !1; )
        ;
      return $;
    }
    function ai($, j) {
      for (var U = $ == null ? 0 : $.length; U-- && j($[U], U, $) !== !1; )
        ;
      return $;
    }
    function Qs($, j) {
      for (var U = -1, ie = $ == null ? 0 : $.length; ++U < ie; )
        if (!j($[U], U, $))
          return !1;
      return !0;
    }
    function Gn($, j) {
      for (var U = -1, ie = $ == null ? 0 : $.length, ve = 0, je = []; ++U < ie; ) {
        var Lt = $[U];
        j(Lt, U, $) && (je[ve++] = Lt);
      }
      return je;
    }
    function or($, j) {
      var U = $ == null ? 0 : $.length;
      return !!U && sr($, j, 0) > -1;
    }
    function Js($, j, U) {
      for (var ie = -1, ve = $ == null ? 0 : $.length; ++ie < ve; )
        if (U(j, $[ie]))
          return !0;
      return !1;
    }
    function tt($, j) {
      for (var U = -1, ie = $ == null ? 0 : $.length, ve = Array(ie); ++U < ie; )
        ve[U] = j($[U], U, $);
      return ve;
    }
    function qn($, j) {
      for (var U = -1, ie = j.length, ve = $.length; ++U < ie; )
        $[ve + U] = j[U];
      return $;
    }
    function Xs($, j, U, ie) {
      var ve = -1, je = $ == null ? 0 : $.length;
      for (ie && je && (U = $[++ve]); ++ve < je; )
        U = j(U, $[ve], ve, $);
      return U;
    }
    function cc($, j, U, ie) {
      var ve = $ == null ? 0 : $.length;
      for (ie && ve && (U = $[--ve]); ve--; )
        U = j(U, $[ve], ve, $);
      return U;
    }
    function Vr($, j) {
      for (var U = -1, ie = $ == null ? 0 : $.length; ++U < ie; )
        if (j($[U], U, $))
          return !0;
      return !1;
    }
    var hc = Uo("length");
    function hl($) {
      return $.split("");
    }
    function fl($) {
      return $.match(Wa) || [];
    }
    function Hr($, j, U) {
      var ie;
      return U($, function(ve, je, Lt) {
        if (j(ve, je, Lt))
          return ie = je, !1;
      }), ie;
    }
    function $n($, j, U, ie) {
      for (var ve = $.length, je = U + (ie ? 1 : -1); ie ? je-- : ++je < ve; )
        if (j($[je], je, $))
          return je;
      return -1;
    }
    function sr($, j, U) {
      return j === j ? ur($, j, U) : $n($, on, U);
    }
    function jr($, j, U, ie) {
      for (var ve = U - 1, je = $.length; ++ve < je; )
        if (ie($[ve], j))
          return ve;
      return -1;
    }
    function on($) {
      return $ !== $;
    }
    function ea($, j) {
      var U = $ == null ? 0 : $.length;
      return U ? ia($, j) / U : _e;
    }
    function Uo($) {
      return function(j) {
        return j == null ? t : j[$];
      };
    }
    function ta($) {
      return function(j) {
        return $ == null ? t : $[j];
      };
    }
    function Vo($, j, U, ie, ve) {
      return ve($, function(je, Lt, Qe) {
        U = ie ? (ie = !1, je) : j(U, je, Lt, Qe);
      }), U;
    }
    function na($, j) {
      var U = $.length;
      for ($.sort(j); U--; )
        $[U] = $[U].value;
      return $;
    }
    function ia($, j) {
      for (var U, ie = -1, ve = $.length; ++ie < ve; ) {
        var je = j($[ie]);
        je !== t && (U = U === t ? je : U + je);
      }
      return U;
    }
    function ra($, j) {
      for (var U = -1, ie = Array($); ++U < $; )
        ie[U] = j(U);
      return ie;
    }
    function dl($, j) {
      return tt(j, function(U) {
        return [U, $[U]];
      });
    }
    function pl($) {
      return $ && $.slice(0, sa($) + 1).replace(zs, "");
    }
    function lt($) {
      return function(j) {
        return $(j);
      };
    }
    function li($, j) {
      return tt(j, function(U) {
        return $[U];
      });
    }
    function Zr($, j) {
      return $.has(j);
    }
    function Rn($, j) {
      for (var U = -1, ie = $.length; ++U < ie && sr(j, $[U], 0) > -1; )
        ;
      return U;
    }
    function ml($, j) {
      for (var U = $.length; U-- && sr(j, $[U], 0) > -1; )
        ;
      return U;
    }
    function ar($, j) {
      for (var U = $.length, ie = 0; U--; )
        $[U] === j && ++ie;
      return ie;
    }
    var fc = ta(rl), Wr = ta(ol);
    function _l($) {
      return "\\" + sl[$];
    }
    function Ho($, j) {
      return $ == null ? t : $[j];
    }
    function lr($) {
      return js.test($);
    }
    function ui($) {
      return xi.test($);
    }
    function jo($) {
      for (var j, U = []; !(j = $.next()).done; )
        U.push(j.value);
      return U;
    }
    function oa($) {
      var j = -1, U = Array($.size);
      return $.forEach(function(ie, ve) {
        U[++j] = [ve, ie];
      }), U;
    }
    function Zo($, j) {
      return function(U) {
        return $(j(U));
      };
    }
    function ci($, j) {
      for (var U = -1, ie = $.length, ve = 0, je = []; ++U < ie; ) {
        var Lt = $[U];
        (Lt === j || Lt === w) && ($[U] = w, je[ve++] = U);
      }
      return je;
    }
    function dn($) {
      var j = -1, U = Array($.size);
      return $.forEach(function(ie) {
        U[++j] = ie;
      }), U;
    }
    function dc($) {
      var j = -1, U = Array($.size);
      return $.forEach(function(ie) {
        U[++j] = [ie, ie];
      }), U;
    }
    function ur($, j, U) {
      for (var ie = U - 1, ve = $.length; ++ie < ve; )
        if ($[ie] === j)
          return ie;
      return -1;
    }
    function pc($, j, U) {
      for (var ie = U + 1; ie--; )
        if ($[ie] === j)
          return ie;
      return ie;
    }
    function Wt($) {
      return lr($) ? Wo($) : hc($);
    }
    function Gt($) {
      return lr($) ? la($) : hl($);
    }
    function sa($) {
      for (var j = $.length; j-- && In.test($.charAt(j)); )
        ;
      return j;
    }
    var aa = ta(ac);
    function Wo($) {
      for (var j = Fr.lastIndex = 0; Fr.test($); )
        ++j;
      return j;
    }
    function la($) {
      return $.match(Fr) || [];
    }
    function Go($) {
      return $.match(Hs) || [];
    }
    var cr = function $(j) {
      j = j == null ? Pt : Kn.defaults(Pt.Object(), j, Kn.pick(Pt, Zs));
      var U = j.Array, ie = j.Date, ve = j.Error, je = j.Function, Lt = j.Math, Qe = j.Object, ua = j.RegExp, zn = j.String, Bt = j.TypeError, qo = U.prototype, Ko = je.prototype, hr = Qe.prototype, Gr = j["__core-js_shared__"], Yo = Ko.toString, ze = hr.hasOwnProperty, mc = 0, Oi = function() {
        var r = /[^.]+$/.exec(Gr && Gr.keys && Gr.keys.IE_PROTO || "");
        return r ? "Symbol(src)_1." + r : "";
      }(), qr = hr.toString, gl = Yo.call(Qe), _c = Pt._, Yn = ua(
        "^" + Yo.call(ze).replace(Rs, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Kr = qs ? j.Buffer : t, Qn = j.Symbol, hi = j.Uint8Array, vl = Kr ? Kr.allocUnsafe : t, Ni = Zo(Qe.getPrototypeOf, Qe), fr = Qe.create, ca = hr.propertyIsEnumerable, Yr = qo.splice, yl = Qn ? Qn.isConcatSpreadable : t, dr = Qn ? Qn.iterator : t, fi = Qn ? Qn.toStringTag : t, Qr = function() {
        try {
          var r = so(Qe, "defineProperty");
          return r({}, "", {}), r;
        } catch {
        }
      }(), bl = j.clearTimeout !== Pt.clearTimeout && j.clearTimeout, wl = ie && ie.now !== Pt.Date.now && ie.now, gc = j.setTimeout !== Pt.setTimeout && j.setTimeout, Jr = Lt.ceil, Xr = Lt.floor, ha = Qe.getOwnPropertySymbols, i = Kr ? Kr.isBuffer : t, o = j.isFinite, l = qo.join, p = Zo(Qe.keys, Qe), v = Lt.max, C = Lt.min, O = ie.now, B = j.parseInt, F = Lt.random, K = qo.reverse, ne = so(j, "DataView"), he = so(j, "Map"), Te = so(j, "Promise"), yt = so(j, "Set"), ct = so(j, "WeakMap"), kt = so(Qe, "create"), xt = ct && new ct(), Tn = {}, vc = ao(ne), yc = ao(he), bc = ao(Te), Ll = ao(yt), wc = ao(ct), eo = Qn ? Qn.prototype : t, ot = eo ? eo.valueOf : t, to = eo ? eo.toString : t;
      function M(r) {
        if (bt(r) && !Me(r) && !(r instanceof xe)) {
          if (r instanceof qt)
            return r;
          if (ze.call(r, "__wrapped__"))
            return Ud(r);
        }
        return new qt(r);
      }
      var pr = function() {
        function r() {
        }
        return function(s) {
          if (!dt(s))
            return {};
          if (fr)
            return fr(s);
          r.prototype = s;
          var c = new r();
          return r.prototype = t, c;
        };
      }();
      function Qo() {
      }
      function qt(r, s) {
        this.__wrapped__ = r, this.__actions__ = [], this.__chain__ = !!s, this.__index__ = 0, this.__values__ = t;
      }
      M.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Ku,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Yu,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Ha,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: M
        }
      }, M.prototype = Qo.prototype, M.prototype.constructor = M, qt.prototype = pr(Qo.prototype), qt.prototype.constructor = qt;
      function xe(r) {
        this.__wrapped__ = r, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Ue, this.__views__ = [];
      }
      function Lc() {
        var r = new xe(this.__wrapped__);
        return r.__actions__ = pn(this.__actions__), r.__dir__ = this.__dir__, r.__filtered__ = this.__filtered__, r.__iteratees__ = pn(this.__iteratees__), r.__takeCount__ = this.__takeCount__, r.__views__ = pn(this.__views__), r;
      }
      function kg() {
        if (this.__filtered__) {
          var r = new xe(this);
          r.__dir__ = -1, r.__filtered__ = !0;
        } else
          r = this.clone(), r.__dir__ *= -1;
        return r;
      }
      function Dg() {
        var r = this.__wrapped__.value(), s = this.__dir__, c = Me(r), _ = s < 0, S = c ? r.length : 0, E = Gv(0, S, this.__views__), P = E.start, I = E.end, R = I - P, G = _ ? I : P - 1, q = this.__iteratees__, Q = q.length, te = 0, se = C(R, this.__takeCount__);
        if (!c || !_ && S == R && se == R)
          return cd(r, this.__actions__);
        var pe = [];
        e:
          for (; R-- && te < se; ) {
            G += s;
            for (var Ae = -1, me = r[G]; ++Ae < Q; ) {
              var Ie = q[Ae], Be = Ie.iteratee, Pn = Ie.type, ln = Be(me);
              if (Pn == Ki)
                me = ln;
              else if (!ln) {
                if (Pn == At)
                  continue e;
                break e;
              }
            }
            pe[te++] = me;
          }
        return pe;
      }
      xe.prototype = pr(Qo.prototype), xe.prototype.constructor = xe;
      function no(r) {
        var s = -1, c = r == null ? 0 : r.length;
        for (this.clear(); ++s < c; ) {
          var _ = r[s];
          this.set(_[0], _[1]);
        }
      }
      function $g() {
        this.__data__ = kt ? kt(null) : {}, this.size = 0;
      }
      function Rg(r) {
        var s = this.has(r) && delete this.__data__[r];
        return this.size -= s ? 1 : 0, s;
      }
      function zg(r) {
        var s = this.__data__;
        if (kt) {
          var c = s[r];
          return c === g ? t : c;
        }
        return ze.call(s, r) ? s[r] : t;
      }
      function Bg(r) {
        var s = this.__data__;
        return kt ? s[r] !== t : ze.call(s, r);
      }
      function Fg(r, s) {
        var c = this.__data__;
        return this.size += this.has(r) ? 0 : 1, c[r] = kt && s === t ? g : s, this;
      }
      no.prototype.clear = $g, no.prototype.delete = Rg, no.prototype.get = zg, no.prototype.has = Bg, no.prototype.set = Fg;
      function Ii(r) {
        var s = -1, c = r == null ? 0 : r.length;
        for (this.clear(); ++s < c; ) {
          var _ = r[s];
          this.set(_[0], _[1]);
        }
      }
      function Ug() {
        this.__data__ = [], this.size = 0;
      }
      function Vg(r) {
        var s = this.__data__, c = Sl(s, r);
        if (c < 0)
          return !1;
        var _ = s.length - 1;
        return c == _ ? s.pop() : Yr.call(s, c, 1), --this.size, !0;
      }
      function Hg(r) {
        var s = this.__data__, c = Sl(s, r);
        return c < 0 ? t : s[c][1];
      }
      function jg(r) {
        return Sl(this.__data__, r) > -1;
      }
      function Zg(r, s) {
        var c = this.__data__, _ = Sl(c, r);
        return _ < 0 ? (++this.size, c.push([r, s])) : c[_][1] = s, this;
      }
      Ii.prototype.clear = Ug, Ii.prototype.delete = Vg, Ii.prototype.get = Hg, Ii.prototype.has = jg, Ii.prototype.set = Zg;
      function ki(r) {
        var s = -1, c = r == null ? 0 : r.length;
        for (this.clear(); ++s < c; ) {
          var _ = r[s];
          this.set(_[0], _[1]);
        }
      }
      function Wg() {
        this.size = 0, this.__data__ = {
          hash: new no(),
          map: new (he || Ii)(),
          string: new no()
        };
      }
      function Gg(r) {
        var s = Dl(this, r).delete(r);
        return this.size -= s ? 1 : 0, s;
      }
      function qg(r) {
        return Dl(this, r).get(r);
      }
      function Kg(r) {
        return Dl(this, r).has(r);
      }
      function Yg(r, s) {
        var c = Dl(this, r), _ = c.size;
        return c.set(r, s), this.size += c.size == _ ? 0 : 1, this;
      }
      ki.prototype.clear = Wg, ki.prototype.delete = Gg, ki.prototype.get = qg, ki.prototype.has = Kg, ki.prototype.set = Yg;
      function io(r) {
        var s = -1, c = r == null ? 0 : r.length;
        for (this.__data__ = new ki(); ++s < c; )
          this.add(r[s]);
      }
      function Qg(r) {
        return this.__data__.set(r, g), this;
      }
      function Jg(r) {
        return this.__data__.has(r);
      }
      io.prototype.add = io.prototype.push = Qg, io.prototype.has = Jg;
      function Jn(r) {
        var s = this.__data__ = new Ii(r);
        this.size = s.size;
      }
      function Xg() {
        this.__data__ = new Ii(), this.size = 0;
      }
      function ev(r) {
        var s = this.__data__, c = s.delete(r);
        return this.size = s.size, c;
      }
      function tv(r) {
        return this.__data__.get(r);
      }
      function nv(r) {
        return this.__data__.has(r);
      }
      function iv(r, s) {
        var c = this.__data__;
        if (c instanceof Ii) {
          var _ = c.__data__;
          if (!he || _.length < u - 1)
            return _.push([r, s]), this.size = ++c.size, this;
          c = this.__data__ = new ki(_);
        }
        return c.set(r, s), this.size = c.size, this;
      }
      Jn.prototype.clear = Xg, Jn.prototype.delete = ev, Jn.prototype.get = tv, Jn.prototype.has = nv, Jn.prototype.set = iv;
      function Uf(r, s) {
        var c = Me(r), _ = !c && lo(r), S = !c && !_ && yr(r), E = !c && !_ && !S && ts(r), P = c || _ || S || E, I = P ? ra(r.length, zn) : [], R = I.length;
        for (var G in r)
          (s || ze.call(r, G)) && !(P && // Safari 9 has enumerable `arguments.length` in strict mode.
          (G == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          S && (G == "offset" || G == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          E && (G == "buffer" || G == "byteLength" || G == "byteOffset") || // Skip index properties.
          zi(G, R))) && I.push(G);
        return I;
      }
      function Vf(r) {
        var s = r.length;
        return s ? r[Ic(0, s - 1)] : t;
      }
      function rv(r, s) {
        return $l(pn(r), ro(s, 0, r.length));
      }
      function ov(r) {
        return $l(pn(r));
      }
      function Sc(r, s, c) {
        (c !== t && !Xn(r[s], c) || c === t && !(s in r)) && Di(r, s, c);
      }
      function fa(r, s, c) {
        var _ = r[s];
        (!(ze.call(r, s) && Xn(_, c)) || c === t && !(s in r)) && Di(r, s, c);
      }
      function Sl(r, s) {
        for (var c = r.length; c--; )
          if (Xn(r[c][0], s))
            return c;
        return -1;
      }
      function sv(r, s, c, _) {
        return mr(r, function(S, E, P) {
          s(_, S, c(S), P);
        }), _;
      }
      function Hf(r, s) {
        return r && pi(s, Dt(s), r);
      }
      function av(r, s) {
        return r && pi(s, _n(s), r);
      }
      function Di(r, s, c) {
        s == "__proto__" && Qr ? Qr(r, s, {
          configurable: !0,
          enumerable: !0,
          value: c,
          writable: !0
        }) : r[s] = c;
      }
      function Cc(r, s) {
        for (var c = -1, _ = s.length, S = U(_), E = r == null; ++c < _; )
          S[c] = E ? t : rh(r, s[c]);
        return S;
      }
      function ro(r, s, c) {
        return r === r && (c !== t && (r = r <= c ? r : c), s !== t && (r = r >= s ? r : s)), r;
      }
      function Bn(r, s, c, _, S, E) {
        var P, I = s & h, R = s & b, G = s & T;
        if (c && (P = S ? c(r, _, S, E) : c(r)), P !== t)
          return P;
        if (!dt(r))
          return r;
        var q = Me(r);
        if (q) {
          if (P = Kv(r), !I)
            return pn(r, P);
        } else {
          var Q = Kt(r), te = Q == oi || Q == Co;
          if (yr(r))
            return dd(r, I);
          if (Q == Cn || Q == Re || te && !S) {
            if (P = R || te ? {} : Nd(r), !I)
              return R ? zv(r, av(P, r)) : Rv(r, Hf(P, r));
          } else {
            if (!He[Q])
              return S ? r : {};
            P = Yv(r, Q, I);
          }
        }
        E || (E = new Jn());
        var se = E.get(r);
        if (se)
          return se;
        E.set(r, P), ap(r) ? r.forEach(function(me) {
          P.add(Bn(me, s, c, me, r, E));
        }) : op(r) && r.forEach(function(me, Ie) {
          P.set(Ie, Bn(me, s, c, Ie, r, E));
        });
        var pe = G ? R ? jc : Hc : R ? _n : Dt, Ae = q ? t : pe(r);
        return rn(Ae || r, function(me, Ie) {
          Ae && (Ie = me, me = r[Ie]), fa(P, Ie, Bn(me, s, c, Ie, r, E));
        }), P;
      }
      function lv(r) {
        var s = Dt(r);
        return function(c) {
          return jf(c, r, s);
        };
      }
      function jf(r, s, c) {
        var _ = c.length;
        if (r == null)
          return !_;
        for (r = Qe(r); _--; ) {
          var S = c[_], E = s[S], P = r[S];
          if (P === t && !(S in r) || !E(P))
            return !1;
        }
        return !0;
      }
      function Zf(r, s, c) {
        if (typeof r != "function")
          throw new Bt(d);
        return ya(function() {
          r.apply(t, c);
        }, s);
      }
      function da(r, s, c, _) {
        var S = -1, E = or, P = !0, I = r.length, R = [], G = s.length;
        if (!I)
          return R;
        c && (s = tt(s, lt(c))), _ ? (E = Js, P = !1) : s.length >= u && (E = Zr, P = !1, s = new io(s));
        e:
          for (; ++S < I; ) {
            var q = r[S], Q = c == null ? q : c(q);
            if (q = _ || q !== 0 ? q : 0, P && Q === Q) {
              for (var te = G; te--; )
                if (s[te] === Q)
                  continue e;
              R.push(q);
            } else
              E(s, Q, _) || R.push(q);
          }
        return R;
      }
      var mr = vd(di), Wf = vd(Tc, !0);
      function uv(r, s) {
        var c = !0;
        return mr(r, function(_, S, E) {
          return c = !!s(_, S, E), c;
        }), c;
      }
      function Cl(r, s, c) {
        for (var _ = -1, S = r.length; ++_ < S; ) {
          var E = r[_], P = s(E);
          if (P != null && (I === t ? P === P && !An(P) : c(P, I)))
            var I = P, R = E;
        }
        return R;
      }
      function cv(r, s, c, _) {
        var S = r.length;
        for (c = Ee(c), c < 0 && (c = -c > S ? 0 : S + c), _ = _ === t || _ > S ? S : Ee(_), _ < 0 && (_ += S), _ = c > _ ? 0 : up(_); c < _; )
          r[c++] = s;
        return r;
      }
      function Gf(r, s) {
        var c = [];
        return mr(r, function(_, S, E) {
          s(_, S, E) && c.push(_);
        }), c;
      }
      function Ft(r, s, c, _, S) {
        var E = -1, P = r.length;
        for (c || (c = Jv), S || (S = []); ++E < P; ) {
          var I = r[E];
          s > 0 && c(I) ? s > 1 ? Ft(I, s - 1, c, _, S) : qn(S, I) : _ || (S[S.length] = I);
        }
        return S;
      }
      var Mc = yd(), qf = yd(!0);
      function di(r, s) {
        return r && Mc(r, s, Dt);
      }
      function Tc(r, s) {
        return r && qf(r, s, Dt);
      }
      function Ml(r, s) {
        return Gn(s, function(c) {
          return Bi(r[c]);
        });
      }
      function oo(r, s) {
        s = gr(s, r);
        for (var c = 0, _ = s.length; r != null && c < _; )
          r = r[mi(s[c++])];
        return c && c == _ ? r : t;
      }
      function Kf(r, s, c) {
        var _ = s(r);
        return Me(r) ? _ : qn(_, c(r));
      }
      function sn(r) {
        return r == null ? r === t ? ju : Ua : fi && fi in Qe(r) ? Wv(r) : oy(r);
      }
      function Ec(r, s) {
        return r > s;
      }
      function hv(r, s) {
        return r != null && ze.call(r, s);
      }
      function fv(r, s) {
        return r != null && s in Qe(r);
      }
      function dv(r, s, c) {
        return r >= C(s, c) && r < v(s, c);
      }
      function Ac(r, s, c) {
        for (var _ = c ? Js : or, S = r[0].length, E = r.length, P = E, I = U(E), R = 1 / 0, G = []; P--; ) {
          var q = r[P];
          P && s && (q = tt(q, lt(s))), R = C(q.length, R), I[P] = !c && (s || S >= 120 && q.length >= 120) ? new io(P && q) : t;
        }
        q = r[0];
        var Q = -1, te = I[0];
        e:
          for (; ++Q < S && G.length < R; ) {
            var se = q[Q], pe = s ? s(se) : se;
            if (se = c || se !== 0 ? se : 0, !(te ? Zr(te, pe) : _(G, pe, c))) {
              for (P = E; --P; ) {
                var Ae = I[P];
                if (!(Ae ? Zr(Ae, pe) : _(r[P], pe, c)))
                  continue e;
              }
              te && te.push(pe), G.push(se);
            }
          }
        return G;
      }
      function pv(r, s, c, _) {
        return di(r, function(S, E, P) {
          s(_, c(S), E, P);
        }), _;
      }
      function pa(r, s, c) {
        s = gr(s, r), r = $d(r, s);
        var _ = r == null ? r : r[mi(Un(s))];
        return _ == null ? t : ut(_, r, c);
      }
      function Yf(r) {
        return bt(r) && sn(r) == Re;
      }
      function mv(r) {
        return bt(r) && sn(r) == tr;
      }
      function _v(r) {
        return bt(r) && sn(r) == Yi;
      }
      function ma(r, s, c, _, S) {
        return r === s ? !0 : r == null || s == null || !bt(r) && !bt(s) ? r !== r && s !== s : gv(r, s, c, _, ma, S);
      }
      function gv(r, s, c, _, S, E) {
        var P = Me(r), I = Me(s), R = P ? Pe : Kt(r), G = I ? Pe : Kt(s);
        R = R == Re ? Cn : R, G = G == Re ? Cn : G;
        var q = R == Cn, Q = G == Cn, te = R == G;
        if (te && yr(r)) {
          if (!yr(s))
            return !1;
          P = !0, q = !1;
        }
        if (te && !q)
          return E || (E = new Jn()), P || ts(r) ? Pd(r, s, c, _, S, E) : jv(r, s, R, c, _, S, E);
        if (!(c & A)) {
          var se = q && ze.call(r, "__wrapped__"), pe = Q && ze.call(s, "__wrapped__");
          if (se || pe) {
            var Ae = se ? r.value() : r, me = pe ? s.value() : s;
            return E || (E = new Jn()), S(Ae, me, c, _, E);
          }
        }
        return te ? (E || (E = new Jn()), Zv(r, s, c, _, S, E)) : !1;
      }
      function vv(r) {
        return bt(r) && Kt(r) == Sn;
      }
      function Pc(r, s, c, _) {
        var S = c.length, E = S, P = !_;
        if (r == null)
          return !E;
        for (r = Qe(r); S--; ) {
          var I = c[S];
          if (P && I[2] ? I[1] !== r[I[0]] : !(I[0] in r))
            return !1;
        }
        for (; ++S < E; ) {
          I = c[S];
          var R = I[0], G = r[R], q = I[1];
          if (P && I[2]) {
            if (G === t && !(R in r))
              return !1;
          } else {
            var Q = new Jn();
            if (_)
              var te = _(G, q, R, r, s, Q);
            if (!(te === t ? ma(q, G, A | x, _, Q) : te))
              return !1;
          }
        }
        return !0;
      }
      function Qf(r) {
        if (!dt(r) || ey(r))
          return !1;
        var s = Bi(r) ? Yn : tc;
        return s.test(ao(r));
      }
      function yv(r) {
        return bt(r) && sn(r) == Xi;
      }
      function bv(r) {
        return bt(r) && Kt(r) == en;
      }
      function wv(r) {
        return bt(r) && Vl(r.length) && !!Ce[sn(r)];
      }
      function Jf(r) {
        return typeof r == "function" ? r : r == null ? gn : typeof r == "object" ? Me(r) ? td(r[0], r[1]) : ed(r) : bp(r);
      }
      function xc(r) {
        if (!va(r))
          return p(r);
        var s = [];
        for (var c in Qe(r))
          ze.call(r, c) && c != "constructor" && s.push(c);
        return s;
      }
      function Lv(r) {
        if (!dt(r))
          return ry(r);
        var s = va(r), c = [];
        for (var _ in r)
          _ == "constructor" && (s || !ze.call(r, _)) || c.push(_);
        return c;
      }
      function Oc(r, s) {
        return r < s;
      }
      function Xf(r, s) {
        var c = -1, _ = mn(r) ? U(r.length) : [];
        return mr(r, function(S, E, P) {
          _[++c] = s(S, E, P);
        }), _;
      }
      function ed(r) {
        var s = Wc(r);
        return s.length == 1 && s[0][2] ? kd(s[0][0], s[0][1]) : function(c) {
          return c === r || Pc(c, r, s);
        };
      }
      function td(r, s) {
        return qc(r) && Id(s) ? kd(mi(r), s) : function(c) {
          var _ = rh(c, r);
          return _ === t && _ === s ? oh(c, r) : ma(s, _, A | x);
        };
      }
      function Tl(r, s, c, _, S) {
        r !== s && Mc(s, function(E, P) {
          if (S || (S = new Jn()), dt(E))
            Sv(r, s, P, c, Tl, _, S);
          else {
            var I = _ ? _(Yc(r, P), E, P + "", r, s, S) : t;
            I === t && (I = E), Sc(r, P, I);
          }
        }, _n);
      }
      function Sv(r, s, c, _, S, E, P) {
        var I = Yc(r, c), R = Yc(s, c), G = P.get(R);
        if (G) {
          Sc(r, c, G);
          return;
        }
        var q = E ? E(I, R, c + "", r, s, P) : t, Q = q === t;
        if (Q) {
          var te = Me(R), se = !te && yr(R), pe = !te && !se && ts(R);
          q = R, te || se || pe ? Me(I) ? q = I : St(I) ? q = pn(I) : se ? (Q = !1, q = dd(R, !0)) : pe ? (Q = !1, q = pd(R, !0)) : q = [] : ba(R) || lo(R) ? (q = I, lo(I) ? q = cp(I) : (!dt(I) || Bi(I)) && (q = Nd(R))) : Q = !1;
        }
        Q && (P.set(R, q), S(q, R, _, E, P), P.delete(R)), Sc(r, c, q);
      }
      function nd(r, s) {
        var c = r.length;
        if (c)
          return s += s < 0 ? c : 0, zi(s, c) ? r[s] : t;
      }
      function id(r, s, c) {
        s.length ? s = tt(s, function(E) {
          return Me(E) ? function(P) {
            return oo(P, E.length === 1 ? E[0] : E);
          } : E;
        }) : s = [gn];
        var _ = -1;
        s = tt(s, lt(de()));
        var S = Xf(r, function(E, P, I) {
          var R = tt(s, function(G) {
            return G(E);
          });
          return { criteria: R, index: ++_, value: E };
        });
        return na(S, function(E, P) {
          return $v(E, P, c);
        });
      }
      function Cv(r, s) {
        return rd(r, s, function(c, _) {
          return oh(r, _);
        });
      }
      function rd(r, s, c) {
        for (var _ = -1, S = s.length, E = {}; ++_ < S; ) {
          var P = s[_], I = oo(r, P);
          c(I, P) && _a(E, gr(P, r), I);
        }
        return E;
      }
      function Mv(r) {
        return function(s) {
          return oo(s, r);
        };
      }
      function Nc(r, s, c, _) {
        var S = _ ? jr : sr, E = -1, P = s.length, I = r;
        for (r === s && (s = pn(s)), c && (I = tt(r, lt(c))); ++E < P; )
          for (var R = 0, G = s[E], q = c ? c(G) : G; (R = S(I, q, R, _)) > -1; )
            I !== r && Yr.call(I, R, 1), Yr.call(r, R, 1);
        return r;
      }
      function od(r, s) {
        for (var c = r ? s.length : 0, _ = c - 1; c--; ) {
          var S = s[c];
          if (c == _ || S !== E) {
            var E = S;
            zi(S) ? Yr.call(r, S, 1) : $c(r, S);
          }
        }
        return r;
      }
      function Ic(r, s) {
        return r + Xr(F() * (s - r + 1));
      }
      function Tv(r, s, c, _) {
        for (var S = -1, E = v(Jr((s - r) / (c || 1)), 0), P = U(E); E--; )
          P[_ ? E : ++S] = r, r += c;
        return P;
      }
      function kc(r, s) {
        var c = "";
        if (!r || s < 1 || s > fe)
          return c;
        do
          s % 2 && (c += r), s = Xr(s / 2), s && (r += r);
        while (s);
        return c;
      }
      function Oe(r, s) {
        return Qc(Dd(r, s, gn), r + "");
      }
      function Ev(r) {
        return Vf(ns(r));
      }
      function Av(r, s) {
        var c = ns(r);
        return $l(c, ro(s, 0, c.length));
      }
      function _a(r, s, c, _) {
        if (!dt(r))
          return r;
        s = gr(s, r);
        for (var S = -1, E = s.length, P = E - 1, I = r; I != null && ++S < E; ) {
          var R = mi(s[S]), G = c;
          if (R === "__proto__" || R === "constructor" || R === "prototype")
            return r;
          if (S != P) {
            var q = I[R];
            G = _ ? _(q, R, I) : t, G === t && (G = dt(q) ? q : zi(s[S + 1]) ? [] : {});
          }
          fa(I, R, G), I = I[R];
        }
        return r;
      }
      var sd = xt ? function(r, s) {
        return xt.set(r, s), r;
      } : gn, Pv = Qr ? function(r, s) {
        return Qr(r, "toString", {
          configurable: !0,
          enumerable: !1,
          value: ah(s),
          writable: !0
        });
      } : gn;
      function xv(r) {
        return $l(ns(r));
      }
      function Fn(r, s, c) {
        var _ = -1, S = r.length;
        s < 0 && (s = -s > S ? 0 : S + s), c = c > S ? S : c, c < 0 && (c += S), S = s > c ? 0 : c - s >>> 0, s >>>= 0;
        for (var E = U(S); ++_ < S; )
          E[_] = r[_ + s];
        return E;
      }
      function Ov(r, s) {
        var c;
        return mr(r, function(_, S, E) {
          return c = s(_, S, E), !c;
        }), !!c;
      }
      function El(r, s, c) {
        var _ = 0, S = r == null ? _ : r.length;
        if (typeof s == "number" && s === s && S <= jt) {
          for (; _ < S; ) {
            var E = _ + S >>> 1, P = r[E];
            P !== null && !An(P) && (c ? P <= s : P < s) ? _ = E + 1 : S = E;
          }
          return S;
        }
        return Dc(r, s, gn, c);
      }
      function Dc(r, s, c, _) {
        var S = 0, E = r == null ? 0 : r.length;
        if (E === 0)
          return 0;
        s = c(s);
        for (var P = s !== s, I = s === null, R = An(s), G = s === t; S < E; ) {
          var q = Xr((S + E) / 2), Q = c(r[q]), te = Q !== t, se = Q === null, pe = Q === Q, Ae = An(Q);
          if (P)
            var me = _ || pe;
          else
            G ? me = pe && (_ || te) : I ? me = pe && te && (_ || !se) : R ? me = pe && te && !se && (_ || !Ae) : se || Ae ? me = !1 : me = _ ? Q <= s : Q < s;
          me ? S = q + 1 : E = q;
        }
        return C(E, Ht);
      }
      function ad(r, s) {
        for (var c = -1, _ = r.length, S = 0, E = []; ++c < _; ) {
          var P = r[c], I = s ? s(P) : P;
          if (!c || !Xn(I, R)) {
            var R = I;
            E[S++] = P === 0 ? 0 : P;
          }
        }
        return E;
      }
      function ld(r) {
        return typeof r == "number" ? r : An(r) ? _e : +r;
      }
      function En(r) {
        if (typeof r == "string")
          return r;
        if (Me(r))
          return tt(r, En) + "";
        if (An(r))
          return to ? to.call(r) : "";
        var s = r + "";
        return s == "0" && 1 / r == -Ln ? "-0" : s;
      }
      function _r(r, s, c) {
        var _ = -1, S = or, E = r.length, P = !0, I = [], R = I;
        if (c)
          P = !1, S = Js;
        else if (E >= u) {
          var G = s ? null : Vv(r);
          if (G)
            return dn(G);
          P = !1, S = Zr, R = new io();
        } else
          R = s ? [] : I;
        e:
          for (; ++_ < E; ) {
            var q = r[_], Q = s ? s(q) : q;
            if (q = c || q !== 0 ? q : 0, P && Q === Q) {
              for (var te = R.length; te--; )
                if (R[te] === Q)
                  continue e;
              s && R.push(Q), I.push(q);
            } else
              S(R, Q, c) || (R !== I && R.push(Q), I.push(q));
          }
        return I;
      }
      function $c(r, s) {
        return s = gr(s, r), r = $d(r, s), r == null || delete r[mi(Un(s))];
      }
      function ud(r, s, c, _) {
        return _a(r, s, c(oo(r, s)), _);
      }
      function Al(r, s, c, _) {
        for (var S = r.length, E = _ ? S : -1; (_ ? E-- : ++E < S) && s(r[E], E, r); )
          ;
        return c ? Fn(r, _ ? 0 : E, _ ? E + 1 : S) : Fn(r, _ ? E + 1 : 0, _ ? S : E);
      }
      function cd(r, s) {
        var c = r;
        return c instanceof xe && (c = c.value()), Xs(s, function(_, S) {
          return S.func.apply(S.thisArg, qn([_], S.args));
        }, c);
      }
      function Rc(r, s, c) {
        var _ = r.length;
        if (_ < 2)
          return _ ? _r(r[0]) : [];
        for (var S = -1, E = U(_); ++S < _; )
          for (var P = r[S], I = -1; ++I < _; )
            I != S && (E[S] = da(E[S] || P, r[I], s, c));
        return _r(Ft(E, 1), s, c);
      }
      function hd(r, s, c) {
        for (var _ = -1, S = r.length, E = s.length, P = {}; ++_ < S; ) {
          var I = _ < E ? s[_] : t;
          c(P, r[_], I);
        }
        return P;
      }
      function zc(r) {
        return St(r) ? r : [];
      }
      function Bc(r) {
        return typeof r == "function" ? r : gn;
      }
      function gr(r, s) {
        return Me(r) ? r : qc(r, s) ? [r] : Fd(Je(r));
      }
      var Nv = Oe;
      function vr(r, s, c) {
        var _ = r.length;
        return c = c === t ? _ : c, !s && c >= _ ? r : Fn(r, s, c);
      }
      var fd = bl || function(r) {
        return Pt.clearTimeout(r);
      };
      function dd(r, s) {
        if (s)
          return r.slice();
        var c = r.length, _ = vl ? vl(c) : new r.constructor(c);
        return r.copy(_), _;
      }
      function Fc(r) {
        var s = new r.constructor(r.byteLength);
        return new hi(s).set(new hi(r)), s;
      }
      function Iv(r, s) {
        var c = s ? Fc(r.buffer) : r.buffer;
        return new r.constructor(c, r.byteOffset, r.byteLength);
      }
      function kv(r) {
        var s = new r.constructor(r.source, Ti.exec(r));
        return s.lastIndex = r.lastIndex, s;
      }
      function Dv(r) {
        return ot ? Qe(ot.call(r)) : {};
      }
      function pd(r, s) {
        var c = s ? Fc(r.buffer) : r.buffer;
        return new r.constructor(c, r.byteOffset, r.length);
      }
      function md(r, s) {
        if (r !== s) {
          var c = r !== t, _ = r === null, S = r === r, E = An(r), P = s !== t, I = s === null, R = s === s, G = An(s);
          if (!I && !G && !E && r > s || E && P && R && !I && !G || _ && P && R || !c && R || !S)
            return 1;
          if (!_ && !E && !G && r < s || G && c && S && !_ && !E || I && c && S || !P && S || !R)
            return -1;
        }
        return 0;
      }
      function $v(r, s, c) {
        for (var _ = -1, S = r.criteria, E = s.criteria, P = S.length, I = c.length; ++_ < P; ) {
          var R = md(S[_], E[_]);
          if (R) {
            if (_ >= I)
              return R;
            var G = c[_];
            return R * (G == "desc" ? -1 : 1);
          }
        }
        return r.index - s.index;
      }
      function _d(r, s, c, _) {
        for (var S = -1, E = r.length, P = c.length, I = -1, R = s.length, G = v(E - P, 0), q = U(R + G), Q = !_; ++I < R; )
          q[I] = s[I];
        for (; ++S < P; )
          (Q || S < E) && (q[c[S]] = r[S]);
        for (; G--; )
          q[I++] = r[S++];
        return q;
      }
      function gd(r, s, c, _) {
        for (var S = -1, E = r.length, P = -1, I = c.length, R = -1, G = s.length, q = v(E - I, 0), Q = U(q + G), te = !_; ++S < q; )
          Q[S] = r[S];
        for (var se = S; ++R < G; )
          Q[se + R] = s[R];
        for (; ++P < I; )
          (te || S < E) && (Q[se + c[P]] = r[S++]);
        return Q;
      }
      function pn(r, s) {
        var c = -1, _ = r.length;
        for (s || (s = U(_)); ++c < _; )
          s[c] = r[c];
        return s;
      }
      function pi(r, s, c, _) {
        var S = !c;
        c || (c = {});
        for (var E = -1, P = s.length; ++E < P; ) {
          var I = s[E], R = _ ? _(c[I], r[I], I, c, r) : t;
          R === t && (R = r[I]), S ? Di(c, I, R) : fa(c, I, R);
        }
        return c;
      }
      function Rv(r, s) {
        return pi(r, Gc(r), s);
      }
      function zv(r, s) {
        return pi(r, xd(r), s);
      }
      function Pl(r, s) {
        return function(c, _) {
          var S = Me(c) ? uc : sv, E = s ? s() : {};
          return S(c, r, de(_, 2), E);
        };
      }
      function Jo(r) {
        return Oe(function(s, c) {
          var _ = -1, S = c.length, E = S > 1 ? c[S - 1] : t, P = S > 2 ? c[2] : t;
          for (E = r.length > 3 && typeof E == "function" ? (S--, E) : t, P && an(c[0], c[1], P) && (E = S < 3 ? t : E, S = 1), s = Qe(s); ++_ < S; ) {
            var I = c[_];
            I && r(s, I, _, E);
          }
          return s;
        });
      }
      function vd(r, s) {
        return function(c, _) {
          if (c == null)
            return c;
          if (!mn(c))
            return r(c, _);
          for (var S = c.length, E = s ? S : -1, P = Qe(c); (s ? E-- : ++E < S) && _(P[E], E, P) !== !1; )
            ;
          return c;
        };
      }
      function yd(r) {
        return function(s, c, _) {
          for (var S = -1, E = Qe(s), P = _(s), I = P.length; I--; ) {
            var R = P[r ? I : ++S];
            if (c(E[R], R, E) === !1)
              break;
          }
          return s;
        };
      }
      function Bv(r, s, c) {
        var _ = s & Z, S = ga(r);
        function E() {
          var P = this && this !== Pt && this instanceof E ? S : r;
          return P.apply(_ ? c : this, arguments);
        }
        return E;
      }
      function bd(r) {
        return function(s) {
          s = Je(s);
          var c = lr(s) ? Gt(s) : t, _ = c ? c[0] : s.charAt(0), S = c ? vr(c, 1).join("") : s.slice(1);
          return _[r]() + S;
        };
      }
      function Xo(r) {
        return function(s) {
          return Xs(vp(gp(s).replace(et, "")), r, "");
        };
      }
      function ga(r) {
        return function() {
          var s = arguments;
          switch (s.length) {
            case 0:
              return new r();
            case 1:
              return new r(s[0]);
            case 2:
              return new r(s[0], s[1]);
            case 3:
              return new r(s[0], s[1], s[2]);
            case 4:
              return new r(s[0], s[1], s[2], s[3]);
            case 5:
              return new r(s[0], s[1], s[2], s[3], s[4]);
            case 6:
              return new r(s[0], s[1], s[2], s[3], s[4], s[5]);
            case 7:
              return new r(s[0], s[1], s[2], s[3], s[4], s[5], s[6]);
          }
          var c = pr(r.prototype), _ = r.apply(c, s);
          return dt(_) ? _ : c;
        };
      }
      function Fv(r, s, c) {
        var _ = ga(r);
        function S() {
          for (var E = arguments.length, P = U(E), I = E, R = es(S); I--; )
            P[I] = arguments[I];
          var G = E < 3 && P[0] !== R && P[E - 1] !== R ? [] : ci(P, R);
          if (E -= G.length, E < c)
            return Md(
              r,
              s,
              xl,
              S.placeholder,
              t,
              P,
              G,
              t,
              t,
              c - E
            );
          var q = this && this !== Pt && this instanceof S ? _ : r;
          return ut(q, this, P);
        }
        return S;
      }
      function wd(r) {
        return function(s, c, _) {
          var S = Qe(s);
          if (!mn(s)) {
            var E = de(c, 3);
            s = Dt(s), c = function(I) {
              return E(S[I], I, S);
            };
          }
          var P = r(s, c, _);
          return P > -1 ? S[E ? s[P] : P] : t;
        };
      }
      function Ld(r) {
        return Ri(function(s) {
          var c = s.length, _ = c, S = qt.prototype.thru;
          for (r && s.reverse(); _--; ) {
            var E = s[_];
            if (typeof E != "function")
              throw new Bt(d);
            if (S && !P && kl(E) == "wrapper")
              var P = new qt([], !0);
          }
          for (_ = P ? _ : c; ++_ < c; ) {
            E = s[_];
            var I = kl(E), R = I == "wrapper" ? Zc(E) : t;
            R && Kc(R[0]) && R[1] == (Fe | ee | be | ge) && !R[4].length && R[9] == 1 ? P = P[kl(R[0])].apply(P, R[3]) : P = E.length == 1 && Kc(E) ? P[I]() : P.thru(E);
          }
          return function() {
            var G = arguments, q = G[0];
            if (P && G.length == 1 && Me(q))
              return P.plant(q).value();
            for (var Q = 0, te = c ? s[Q].apply(this, G) : q; ++Q < c; )
              te = s[Q].call(this, te);
            return te;
          };
        });
      }
      function xl(r, s, c, _, S, E, P, I, R, G) {
        var q = s & Fe, Q = s & Z, te = s & H, se = s & (ee | re), pe = s & qe, Ae = te ? t : ga(r);
        function me() {
          for (var Ie = arguments.length, Be = U(Ie), Pn = Ie; Pn--; )
            Be[Pn] = arguments[Pn];
          if (se)
            var ln = es(me), xn = ar(Be, ln);
          if (_ && (Be = _d(Be, _, S, se)), E && (Be = gd(Be, E, P, se)), Ie -= xn, se && Ie < G) {
            var Ct = ci(Be, ln);
            return Md(
              r,
              s,
              xl,
              me.placeholder,
              c,
              Be,
              Ct,
              I,
              R,
              G - Ie
            );
          }
          var ei = Q ? c : this, Ui = te ? ei[r] : r;
          return Ie = Be.length, I ? Be = sy(Be, I) : pe && Ie > 1 && Be.reverse(), q && R < Ie && (Be.length = R), this && this !== Pt && this instanceof me && (Ui = Ae || ga(Ui)), Ui.apply(ei, Be);
        }
        return me;
      }
      function Sd(r, s) {
        return function(c, _) {
          return pv(c, r, s(_), {});
        };
      }
      function Ol(r, s) {
        return function(c, _) {
          var S;
          if (c === t && _ === t)
            return s;
          if (c !== t && (S = c), _ !== t) {
            if (S === t)
              return _;
            typeof c == "string" || typeof _ == "string" ? (c = En(c), _ = En(_)) : (c = ld(c), _ = ld(_)), S = r(c, _);
          }
          return S;
        };
      }
      function Uc(r) {
        return Ri(function(s) {
          return s = tt(s, lt(de())), Oe(function(c) {
            var _ = this;
            return r(s, function(S) {
              return ut(S, _, c);
            });
          });
        });
      }
      function Nl(r, s) {
        s = s === t ? " " : En(s);
        var c = s.length;
        if (c < 2)
          return c ? kc(s, r) : s;
        var _ = kc(s, Jr(r / Wt(s)));
        return lr(s) ? vr(Gt(_), 0, r).join("") : _.slice(0, r);
      }
      function Uv(r, s, c, _) {
        var S = s & Z, E = ga(r);
        function P() {
          for (var I = -1, R = arguments.length, G = -1, q = _.length, Q = U(q + R), te = this && this !== Pt && this instanceof P ? E : r; ++G < q; )
            Q[G] = _[G];
          for (; R--; )
            Q[G++] = arguments[++I];
          return ut(te, S ? c : this, Q);
        }
        return P;
      }
      function Cd(r) {
        return function(s, c, _) {
          return _ && typeof _ != "number" && an(s, c, _) && (c = _ = t), s = Fi(s), c === t ? (c = s, s = 0) : c = Fi(c), _ = _ === t ? s < c ? 1 : -1 : Fi(_), Tv(s, c, _, r);
        };
      }
      function Il(r) {
        return function(s, c) {
          return typeof s == "string" && typeof c == "string" || (s = Vn(s), c = Vn(c)), r(s, c);
        };
      }
      function Md(r, s, c, _, S, E, P, I, R, G) {
        var q = s & ee, Q = q ? P : t, te = q ? t : P, se = q ? E : t, pe = q ? t : E;
        s |= q ? be : Xe, s &= ~(q ? Xe : be), s & Y || (s &= ~(Z | H));
        var Ae = [
          r,
          s,
          S,
          se,
          Q,
          pe,
          te,
          I,
          R,
          G
        ], me = c.apply(t, Ae);
        return Kc(r) && Rd(me, Ae), me.placeholder = _, zd(me, r, s);
      }
      function Vc(r) {
        var s = Lt[r];
        return function(c, _) {
          if (c = Vn(c), _ = _ == null ? 0 : C(Ee(_), 292), _ && o(c)) {
            var S = (Je(c) + "e").split("e"), E = s(S[0] + "e" + (+S[1] + _));
            return S = (Je(E) + "e").split("e"), +(S[0] + "e" + (+S[1] - _));
          }
          return s(c);
        };
      }
      var Vv = yt && 1 / dn(new yt([, -0]))[1] == Ln ? function(r) {
        return new yt(r);
      } : ch;
      function Td(r) {
        return function(s) {
          var c = Kt(s);
          return c == Sn ? oa(s) : c == en ? dc(s) : dl(s, r(s));
        };
      }
      function $i(r, s, c, _, S, E, P, I) {
        var R = s & H;
        if (!R && typeof r != "function")
          throw new Bt(d);
        var G = _ ? _.length : 0;
        if (G || (s &= ~(be | Xe), _ = S = t), P = P === t ? P : v(Ee(P), 0), I = I === t ? I : Ee(I), G -= S ? S.length : 0, s & Xe) {
          var q = _, Q = S;
          _ = S = t;
        }
        var te = R ? t : Zc(r), se = [
          r,
          s,
          c,
          _,
          S,
          q,
          Q,
          E,
          P,
          I
        ];
        if (te && iy(se, te), r = se[0], s = se[1], c = se[2], _ = se[3], S = se[4], I = se[9] = se[9] === t ? R ? 0 : r.length : v(se[9] - G, 0), !I && s & (ee | re) && (s &= ~(ee | re)), !s || s == Z)
          var pe = Bv(r, s, c);
        else
          s == ee || s == re ? pe = Fv(r, s, I) : (s == be || s == (Z | be)) && !S.length ? pe = Uv(r, s, c, _) : pe = xl.apply(t, se);
        var Ae = te ? sd : Rd;
        return zd(Ae(pe, se), r, s);
      }
      function Ed(r, s, c, _) {
        return r === t || Xn(r, hr[c]) && !ze.call(_, c) ? s : r;
      }
      function Ad(r, s, c, _, S, E) {
        return dt(r) && dt(s) && (E.set(s, r), Tl(r, s, t, Ad, E), E.delete(s)), r;
      }
      function Hv(r) {
        return ba(r) ? t : r;
      }
      function Pd(r, s, c, _, S, E) {
        var P = c & A, I = r.length, R = s.length;
        if (I != R && !(P && R > I))
          return !1;
        var G = E.get(r), q = E.get(s);
        if (G && q)
          return G == s && q == r;
        var Q = -1, te = !0, se = c & x ? new io() : t;
        for (E.set(r, s), E.set(s, r); ++Q < I; ) {
          var pe = r[Q], Ae = s[Q];
          if (_)
            var me = P ? _(Ae, pe, Q, s, r, E) : _(pe, Ae, Q, r, s, E);
          if (me !== t) {
            if (me)
              continue;
            te = !1;
            break;
          }
          if (se) {
            if (!Vr(s, function(Ie, Be) {
              if (!Zr(se, Be) && (pe === Ie || S(pe, Ie, c, _, E)))
                return se.push(Be);
            })) {
              te = !1;
              break;
            }
          } else if (!(pe === Ae || S(pe, Ae, c, _, E))) {
            te = !1;
            break;
          }
        }
        return E.delete(r), E.delete(s), te;
      }
      function jv(r, s, c, _, S, E, P) {
        switch (c) {
          case Ci:
            if (r.byteLength != s.byteLength || r.byteOffset != s.byteOffset)
              return !1;
            r = r.buffer, s = s.buffer;
          case tr:
            return !(r.byteLength != s.byteLength || !E(new hi(r), new hi(s)));
          case fn:
          case Yi:
          case Ji:
            return Xn(+r, +s);
          case Qi:
            return r.name == s.name && r.message == s.message;
          case Xi:
          case er:
            return r == s + "";
          case Sn:
            var I = oa;
          case en:
            var R = _ & A;
            if (I || (I = dn), r.size != s.size && !R)
              return !1;
            var G = P.get(r);
            if (G)
              return G == s;
            _ |= x, P.set(r, s);
            var q = Pd(I(r), I(s), _, S, E, P);
            return P.delete(r), q;
          case kr:
            if (ot)
              return ot.call(r) == ot.call(s);
        }
        return !1;
      }
      function Zv(r, s, c, _, S, E) {
        var P = c & A, I = Hc(r), R = I.length, G = Hc(s), q = G.length;
        if (R != q && !P)
          return !1;
        for (var Q = R; Q--; ) {
          var te = I[Q];
          if (!(P ? te in s : ze.call(s, te)))
            return !1;
        }
        var se = E.get(r), pe = E.get(s);
        if (se && pe)
          return se == s && pe == r;
        var Ae = !0;
        E.set(r, s), E.set(s, r);
        for (var me = P; ++Q < R; ) {
          te = I[Q];
          var Ie = r[te], Be = s[te];
          if (_)
            var Pn = P ? _(Be, Ie, te, s, r, E) : _(Ie, Be, te, r, s, E);
          if (!(Pn === t ? Ie === Be || S(Ie, Be, c, _, E) : Pn)) {
            Ae = !1;
            break;
          }
          me || (me = te == "constructor");
        }
        if (Ae && !me) {
          var ln = r.constructor, xn = s.constructor;
          ln != xn && "constructor" in r && "constructor" in s && !(typeof ln == "function" && ln instanceof ln && typeof xn == "function" && xn instanceof xn) && (Ae = !1);
        }
        return E.delete(r), E.delete(s), Ae;
      }
      function Ri(r) {
        return Qc(Dd(r, t, jd), r + "");
      }
      function Hc(r) {
        return Kf(r, Dt, Gc);
      }
      function jc(r) {
        return Kf(r, _n, xd);
      }
      var Zc = xt ? function(r) {
        return xt.get(r);
      } : ch;
      function kl(r) {
        for (var s = r.name + "", c = Tn[s], _ = ze.call(Tn, s) ? c.length : 0; _--; ) {
          var S = c[_], E = S.func;
          if (E == null || E == r)
            return S.name;
        }
        return s;
      }
      function es(r) {
        var s = ze.call(M, "placeholder") ? M : r;
        return s.placeholder;
      }
      function de() {
        var r = M.iteratee || lh;
        return r = r === lh ? Jf : r, arguments.length ? r(arguments[0], arguments[1]) : r;
      }
      function Dl(r, s) {
        var c = r.__data__;
        return Xv(s) ? c[typeof s == "string" ? "string" : "hash"] : c.map;
      }
      function Wc(r) {
        for (var s = Dt(r), c = s.length; c--; ) {
          var _ = s[c], S = r[_];
          s[c] = [_, S, Id(S)];
        }
        return s;
      }
      function so(r, s) {
        var c = Ho(r, s);
        return Qf(c) ? c : t;
      }
      function Wv(r) {
        var s = ze.call(r, fi), c = r[fi];
        try {
          r[fi] = t;
          var _ = !0;
        } catch {
        }
        var S = qr.call(r);
        return _ && (s ? r[fi] = c : delete r[fi]), S;
      }
      var Gc = ha ? function(r) {
        return r == null ? [] : (r = Qe(r), Gn(ha(r), function(s) {
          return ca.call(r, s);
        }));
      } : hh, xd = ha ? function(r) {
        for (var s = []; r; )
          qn(s, Gc(r)), r = Ni(r);
        return s;
      } : hh, Kt = sn;
      (ne && Kt(new ne(new ArrayBuffer(1))) != Ci || he && Kt(new he()) != Sn || Te && Kt(Te.resolve()) != Ir || yt && Kt(new yt()) != en || ct && Kt(new ct()) != Dr) && (Kt = function(r) {
        var s = sn(r), c = s == Cn ? r.constructor : t, _ = c ? ao(c) : "";
        if (_)
          switch (_) {
            case vc:
              return Ci;
            case yc:
              return Sn;
            case bc:
              return Ir;
            case Ll:
              return en;
            case wc:
              return Dr;
          }
        return s;
      });
      function Gv(r, s, c) {
        for (var _ = -1, S = c.length; ++_ < S; ) {
          var E = c[_], P = E.size;
          switch (E.type) {
            case "drop":
              r += P;
              break;
            case "dropRight":
              s -= P;
              break;
            case "take":
              s = C(s, r + P);
              break;
            case "takeRight":
              r = v(r, s - P);
              break;
          }
        }
        return { start: r, end: s };
      }
      function qv(r) {
        var s = r.match(ja);
        return s ? s[1].split(Za) : [];
      }
      function Od(r, s, c) {
        s = gr(s, r);
        for (var _ = -1, S = s.length, E = !1; ++_ < S; ) {
          var P = mi(s[_]);
          if (!(E = r != null && c(r, P)))
            break;
          r = r[P];
        }
        return E || ++_ != S ? E : (S = r == null ? 0 : r.length, !!S && Vl(S) && zi(P, S) && (Me(r) || lo(r)));
      }
      function Kv(r) {
        var s = r.length, c = new r.constructor(s);
        return s && typeof r[0] == "string" && ze.call(r, "index") && (c.index = r.index, c.input = r.input), c;
      }
      function Nd(r) {
        return typeof r.constructor == "function" && !va(r) ? pr(Ni(r)) : {};
      }
      function Yv(r, s, c) {
        var _ = r.constructor;
        switch (s) {
          case tr:
            return Fc(r);
          case fn:
          case Yi:
            return new _(+r);
          case Ci:
            return Iv(r, c);
          case Os:
          case Mo:
          case To:
          case Ns:
          case Eo:
          case $r:
          case Ao:
          case Is:
          case Mi:
            return pd(r, c);
          case Sn:
            return new _();
          case Ji:
          case er:
            return new _(r);
          case Xi:
            return kv(r);
          case en:
            return new _();
          case kr:
            return Dv(r);
        }
      }
      function Qv(r, s) {
        var c = s.length;
        if (!c)
          return r;
        var _ = c - 1;
        return s[_] = (c > 1 ? "& " : "") + s[_], s = s.join(c > 2 ? ", " : " "), r.replace(le, `{
/* [wrapped with ` + s + `] */
`);
      }
      function Jv(r) {
        return Me(r) || lo(r) || !!(yl && r && r[yl]);
      }
      function zi(r, s) {
        var c = typeof r;
        return s = s ?? fe, !!s && (c == "number" || c != "symbol" && ic.test(r)) && r > -1 && r % 1 == 0 && r < s;
      }
      function an(r, s, c) {
        if (!dt(c))
          return !1;
        var _ = typeof s;
        return (_ == "number" ? mn(c) && zi(s, c.length) : _ == "string" && s in c) ? Xn(c[s], r) : !1;
      }
      function qc(r, s) {
        if (Me(r))
          return !1;
        var c = typeof r;
        return c == "number" || c == "symbol" || c == "boolean" || r == null || An(r) ? !0 : $s.test(r) || !Qu.test(r) || s != null && r in Qe(s);
      }
      function Xv(r) {
        var s = typeof r;
        return s == "string" || s == "number" || s == "symbol" || s == "boolean" ? r !== "__proto__" : r === null;
      }
      function Kc(r) {
        var s = kl(r), c = M[s];
        if (typeof c != "function" || !(s in xe.prototype))
          return !1;
        if (r === c)
          return !0;
        var _ = Zc(c);
        return !!_ && r === _[0];
      }
      function ey(r) {
        return !!Oi && Oi in r;
      }
      var ty = Gr ? Bi : fh;
      function va(r) {
        var s = r && r.constructor, c = typeof s == "function" && s.prototype || hr;
        return r === c;
      }
      function Id(r) {
        return r === r && !dt(r);
      }
      function kd(r, s) {
        return function(c) {
          return c == null ? !1 : c[r] === s && (s !== t || r in Qe(c));
        };
      }
      function ny(r) {
        var s = Fl(r, function(_) {
          return c.size === y && c.clear(), _;
        }), c = s.cache;
        return s;
      }
      function iy(r, s) {
        var c = r[1], _ = s[1], S = c | _, E = S < (Z | H | Fe), P = _ == Fe && c == ee || _ == Fe && c == ge && r[7].length <= s[8] || _ == (Fe | ge) && s[7].length <= s[8] && c == ee;
        if (!(E || P))
          return r;
        _ & Z && (r[2] = s[2], S |= c & Z ? 0 : Y);
        var I = s[3];
        if (I) {
          var R = r[3];
          r[3] = R ? _d(R, I, s[4]) : I, r[4] = R ? ci(r[3], w) : s[4];
        }
        return I = s[5], I && (R = r[5], r[5] = R ? gd(R, I, s[6]) : I, r[6] = R ? ci(r[5], w) : s[6]), I = s[7], I && (r[7] = I), _ & Fe && (r[8] = r[8] == null ? s[8] : C(r[8], s[8])), r[9] == null && (r[9] = s[9]), r[0] = s[0], r[1] = S, r;
      }
      function ry(r) {
        var s = [];
        if (r != null)
          for (var c in Qe(r))
            s.push(c);
        return s;
      }
      function oy(r) {
        return qr.call(r);
      }
      function Dd(r, s, c) {
        return s = v(s === t ? r.length - 1 : s, 0), function() {
          for (var _ = arguments, S = -1, E = v(_.length - s, 0), P = U(E); ++S < E; )
            P[S] = _[s + S];
          S = -1;
          for (var I = U(s + 1); ++S < s; )
            I[S] = _[S];
          return I[s] = c(P), ut(r, this, I);
        };
      }
      function $d(r, s) {
        return s.length < 2 ? r : oo(r, Fn(s, 0, -1));
      }
      function sy(r, s) {
        for (var c = r.length, _ = C(s.length, c), S = pn(r); _--; ) {
          var E = s[_];
          r[_] = zi(E, c) ? S[E] : t;
        }
        return r;
      }
      function Yc(r, s) {
        if (!(s === "constructor" && typeof r[s] == "function") && s != "__proto__")
          return r[s];
      }
      var Rd = Bd(sd), ya = gc || function(r, s) {
        return Pt.setTimeout(r, s);
      }, Qc = Bd(Pv);
      function zd(r, s, c) {
        var _ = s + "";
        return Qc(r, Qv(_, ay(qv(_), c)));
      }
      function Bd(r) {
        var s = 0, c = 0;
        return function() {
          var _ = O(), S = wn - (_ - c);
          if (c = _, S > 0) {
            if (++s >= nt)
              return arguments[0];
          } else
            s = 0;
          return r.apply(t, arguments);
        };
      }
      function $l(r, s) {
        var c = -1, _ = r.length, S = _ - 1;
        for (s = s === t ? _ : s; ++c < s; ) {
          var E = Ic(c, S), P = r[E];
          r[E] = r[c], r[c] = P;
        }
        return r.length = s, r;
      }
      var Fd = ny(function(r) {
        var s = [];
        return r.charCodeAt(0) === 46 && s.push(""), r.replace(Ju, function(c, _, S, E) {
          s.push(S ? E.replace(Bs, "$1") : _ || c);
        }), s;
      });
      function mi(r) {
        if (typeof r == "string" || An(r))
          return r;
        var s = r + "";
        return s == "0" && 1 / r == -Ln ? "-0" : s;
      }
      function ao(r) {
        if (r != null) {
          try {
            return Yo.call(r);
          } catch {
          }
          try {
            return r + "";
          } catch {
          }
        }
        return "";
      }
      function ay(r, s) {
        return rn(vt, function(c) {
          var _ = "_." + c[0];
          s & c[1] && !or(r, _) && r.push(_);
        }), r.sort();
      }
      function Ud(r) {
        if (r instanceof xe)
          return r.clone();
        var s = new qt(r.__wrapped__, r.__chain__);
        return s.__actions__ = pn(r.__actions__), s.__index__ = r.__index__, s.__values__ = r.__values__, s;
      }
      function ly(r, s, c) {
        (c ? an(r, s, c) : s === t) ? s = 1 : s = v(Ee(s), 0);
        var _ = r == null ? 0 : r.length;
        if (!_ || s < 1)
          return [];
        for (var S = 0, E = 0, P = U(Jr(_ / s)); S < _; )
          P[E++] = Fn(r, S, S += s);
        return P;
      }
      function uy(r) {
        for (var s = -1, c = r == null ? 0 : r.length, _ = 0, S = []; ++s < c; ) {
          var E = r[s];
          E && (S[_++] = E);
        }
        return S;
      }
      function cy() {
        var r = arguments.length;
        if (!r)
          return [];
        for (var s = U(r - 1), c = arguments[0], _ = r; _--; )
          s[_ - 1] = arguments[_];
        return qn(Me(c) ? pn(c) : [c], Ft(s, 1));
      }
      var hy = Oe(function(r, s) {
        return St(r) ? da(r, Ft(s, 1, St, !0)) : [];
      }), fy = Oe(function(r, s) {
        var c = Un(s);
        return St(c) && (c = t), St(r) ? da(r, Ft(s, 1, St, !0), de(c, 2)) : [];
      }), dy = Oe(function(r, s) {
        var c = Un(s);
        return St(c) && (c = t), St(r) ? da(r, Ft(s, 1, St, !0), t, c) : [];
      });
      function py(r, s, c) {
        var _ = r == null ? 0 : r.length;
        return _ ? (s = c || s === t ? 1 : Ee(s), Fn(r, s < 0 ? 0 : s, _)) : [];
      }
      function my(r, s, c) {
        var _ = r == null ? 0 : r.length;
        return _ ? (s = c || s === t ? 1 : Ee(s), s = _ - s, Fn(r, 0, s < 0 ? 0 : s)) : [];
      }
      function _y(r, s) {
        return r && r.length ? Al(r, de(s, 3), !0, !0) : [];
      }
      function gy(r, s) {
        return r && r.length ? Al(r, de(s, 3), !0) : [];
      }
      function vy(r, s, c, _) {
        var S = r == null ? 0 : r.length;
        return S ? (c && typeof c != "number" && an(r, s, c) && (c = 0, _ = S), cv(r, s, c, _)) : [];
      }
      function Vd(r, s, c) {
        var _ = r == null ? 0 : r.length;
        if (!_)
          return -1;
        var S = c == null ? 0 : Ee(c);
        return S < 0 && (S = v(_ + S, 0)), $n(r, de(s, 3), S);
      }
      function Hd(r, s, c) {
        var _ = r == null ? 0 : r.length;
        if (!_)
          return -1;
        var S = _ - 1;
        return c !== t && (S = Ee(c), S = c < 0 ? v(_ + S, 0) : C(S, _ - 1)), $n(r, de(s, 3), S, !0);
      }
      function jd(r) {
        var s = r == null ? 0 : r.length;
        return s ? Ft(r, 1) : [];
      }
      function yy(r) {
        var s = r == null ? 0 : r.length;
        return s ? Ft(r, Ln) : [];
      }
      function by(r, s) {
        var c = r == null ? 0 : r.length;
        return c ? (s = s === t ? 1 : Ee(s), Ft(r, s)) : [];
      }
      function wy(r) {
        for (var s = -1, c = r == null ? 0 : r.length, _ = {}; ++s < c; ) {
          var S = r[s];
          _[S[0]] = S[1];
        }
        return _;
      }
      function Zd(r) {
        return r && r.length ? r[0] : t;
      }
      function Ly(r, s, c) {
        var _ = r == null ? 0 : r.length;
        if (!_)
          return -1;
        var S = c == null ? 0 : Ee(c);
        return S < 0 && (S = v(_ + S, 0)), sr(r, s, S);
      }
      function Sy(r) {
        var s = r == null ? 0 : r.length;
        return s ? Fn(r, 0, -1) : [];
      }
      var Cy = Oe(function(r) {
        var s = tt(r, zc);
        return s.length && s[0] === r[0] ? Ac(s) : [];
      }), My = Oe(function(r) {
        var s = Un(r), c = tt(r, zc);
        return s === Un(c) ? s = t : c.pop(), c.length && c[0] === r[0] ? Ac(c, de(s, 2)) : [];
      }), Ty = Oe(function(r) {
        var s = Un(r), c = tt(r, zc);
        return s = typeof s == "function" ? s : t, s && c.pop(), c.length && c[0] === r[0] ? Ac(c, t, s) : [];
      });
      function Ey(r, s) {
        return r == null ? "" : l.call(r, s);
      }
      function Un(r) {
        var s = r == null ? 0 : r.length;
        return s ? r[s - 1] : t;
      }
      function Ay(r, s, c) {
        var _ = r == null ? 0 : r.length;
        if (!_)
          return -1;
        var S = _;
        return c !== t && (S = Ee(c), S = S < 0 ? v(_ + S, 0) : C(S, _ - 1)), s === s ? pc(r, s, S) : $n(r, on, S, !0);
      }
      function Py(r, s) {
        return r && r.length ? nd(r, Ee(s)) : t;
      }
      var xy = Oe(Wd);
      function Wd(r, s) {
        return r && r.length && s && s.length ? Nc(r, s) : r;
      }
      function Oy(r, s, c) {
        return r && r.length && s && s.length ? Nc(r, s, de(c, 2)) : r;
      }
      function Ny(r, s, c) {
        return r && r.length && s && s.length ? Nc(r, s, t, c) : r;
      }
      var Iy = Ri(function(r, s) {
        var c = r == null ? 0 : r.length, _ = Cc(r, s);
        return od(r, tt(s, function(S) {
          return zi(S, c) ? +S : S;
        }).sort(md)), _;
      });
      function ky(r, s) {
        var c = [];
        if (!(r && r.length))
          return c;
        var _ = -1, S = [], E = r.length;
        for (s = de(s, 3); ++_ < E; ) {
          var P = r[_];
          s(P, _, r) && (c.push(P), S.push(_));
        }
        return od(r, S), c;
      }
      function Jc(r) {
        return r == null ? r : K.call(r);
      }
      function Dy(r, s, c) {
        var _ = r == null ? 0 : r.length;
        return _ ? (c && typeof c != "number" && an(r, s, c) ? (s = 0, c = _) : (s = s == null ? 0 : Ee(s), c = c === t ? _ : Ee(c)), Fn(r, s, c)) : [];
      }
      function $y(r, s) {
        return El(r, s);
      }
      function Ry(r, s, c) {
        return Dc(r, s, de(c, 2));
      }
      function zy(r, s) {
        var c = r == null ? 0 : r.length;
        if (c) {
          var _ = El(r, s);
          if (_ < c && Xn(r[_], s))
            return _;
        }
        return -1;
      }
      function By(r, s) {
        return El(r, s, !0);
      }
      function Fy(r, s, c) {
        return Dc(r, s, de(c, 2), !0);
      }
      function Uy(r, s) {
        var c = r == null ? 0 : r.length;
        if (c) {
          var _ = El(r, s, !0) - 1;
          if (Xn(r[_], s))
            return _;
        }
        return -1;
      }
      function Vy(r) {
        return r && r.length ? ad(r) : [];
      }
      function Hy(r, s) {
        return r && r.length ? ad(r, de(s, 2)) : [];
      }
      function jy(r) {
        var s = r == null ? 0 : r.length;
        return s ? Fn(r, 1, s) : [];
      }
      function Zy(r, s, c) {
        return r && r.length ? (s = c || s === t ? 1 : Ee(s), Fn(r, 0, s < 0 ? 0 : s)) : [];
      }
      function Wy(r, s, c) {
        var _ = r == null ? 0 : r.length;
        return _ ? (s = c || s === t ? 1 : Ee(s), s = _ - s, Fn(r, s < 0 ? 0 : s, _)) : [];
      }
      function Gy(r, s) {
        return r && r.length ? Al(r, de(s, 3), !1, !0) : [];
      }
      function qy(r, s) {
        return r && r.length ? Al(r, de(s, 3)) : [];
      }
      var Ky = Oe(function(r) {
        return _r(Ft(r, 1, St, !0));
      }), Yy = Oe(function(r) {
        var s = Un(r);
        return St(s) && (s = t), _r(Ft(r, 1, St, !0), de(s, 2));
      }), Qy = Oe(function(r) {
        var s = Un(r);
        return s = typeof s == "function" ? s : t, _r(Ft(r, 1, St, !0), t, s);
      });
      function Jy(r) {
        return r && r.length ? _r(r) : [];
      }
      function Xy(r, s) {
        return r && r.length ? _r(r, de(s, 2)) : [];
      }
      function eb(r, s) {
        return s = typeof s == "function" ? s : t, r && r.length ? _r(r, t, s) : [];
      }
      function Xc(r) {
        if (!(r && r.length))
          return [];
        var s = 0;
        return r = Gn(r, function(c) {
          if (St(c))
            return s = v(c.length, s), !0;
        }), ra(s, function(c) {
          return tt(r, Uo(c));
        });
      }
      function Gd(r, s) {
        if (!(r && r.length))
          return [];
        var c = Xc(r);
        return s == null ? c : tt(c, function(_) {
          return ut(s, t, _);
        });
      }
      var tb = Oe(function(r, s) {
        return St(r) ? da(r, s) : [];
      }), nb = Oe(function(r) {
        return Rc(Gn(r, St));
      }), ib = Oe(function(r) {
        var s = Un(r);
        return St(s) && (s = t), Rc(Gn(r, St), de(s, 2));
      }), rb = Oe(function(r) {
        var s = Un(r);
        return s = typeof s == "function" ? s : t, Rc(Gn(r, St), t, s);
      }), ob = Oe(Xc);
      function sb(r, s) {
        return hd(r || [], s || [], fa);
      }
      function ab(r, s) {
        return hd(r || [], s || [], _a);
      }
      var lb = Oe(function(r) {
        var s = r.length, c = s > 1 ? r[s - 1] : t;
        return c = typeof c == "function" ? (r.pop(), c) : t, Gd(r, c);
      });
      function qd(r) {
        var s = M(r);
        return s.__chain__ = !0, s;
      }
      function ub(r, s) {
        return s(r), r;
      }
      function Rl(r, s) {
        return s(r);
      }
      var cb = Ri(function(r) {
        var s = r.length, c = s ? r[0] : 0, _ = this.__wrapped__, S = function(E) {
          return Cc(E, r);
        };
        return s > 1 || this.__actions__.length || !(_ instanceof xe) || !zi(c) ? this.thru(S) : (_ = _.slice(c, +c + (s ? 1 : 0)), _.__actions__.push({
          func: Rl,
          args: [S],
          thisArg: t
        }), new qt(_, this.__chain__).thru(function(E) {
          return s && !E.length && E.push(t), E;
        }));
      });
      function hb() {
        return qd(this);
      }
      function fb() {
        return new qt(this.value(), this.__chain__);
      }
      function db() {
        this.__values__ === t && (this.__values__ = lp(this.value()));
        var r = this.__index__ >= this.__values__.length, s = r ? t : this.__values__[this.__index__++];
        return { done: r, value: s };
      }
      function pb() {
        return this;
      }
      function mb(r) {
        for (var s, c = this; c instanceof Qo; ) {
          var _ = Ud(c);
          _.__index__ = 0, _.__values__ = t, s ? S.__wrapped__ = _ : s = _;
          var S = _;
          c = c.__wrapped__;
        }
        return S.__wrapped__ = r, s;
      }
      function _b() {
        var r = this.__wrapped__;
        if (r instanceof xe) {
          var s = r;
          return this.__actions__.length && (s = new xe(this)), s = s.reverse(), s.__actions__.push({
            func: Rl,
            args: [Jc],
            thisArg: t
          }), new qt(s, this.__chain__);
        }
        return this.thru(Jc);
      }
      function gb() {
        return cd(this.__wrapped__, this.__actions__);
      }
      var vb = Pl(function(r, s, c) {
        ze.call(r, c) ? ++r[c] : Di(r, c, 1);
      });
      function yb(r, s, c) {
        var _ = Me(r) ? Qs : uv;
        return c && an(r, s, c) && (s = t), _(r, de(s, 3));
      }
      function bb(r, s) {
        var c = Me(r) ? Gn : Gf;
        return c(r, de(s, 3));
      }
      var wb = wd(Vd), Lb = wd(Hd);
      function Sb(r, s) {
        return Ft(zl(r, s), 1);
      }
      function Cb(r, s) {
        return Ft(zl(r, s), Ln);
      }
      function Mb(r, s, c) {
        return c = c === t ? 1 : Ee(c), Ft(zl(r, s), c);
      }
      function Kd(r, s) {
        var c = Me(r) ? rn : mr;
        return c(r, de(s, 3));
      }
      function Yd(r, s) {
        var c = Me(r) ? ai : Wf;
        return c(r, de(s, 3));
      }
      var Tb = Pl(function(r, s, c) {
        ze.call(r, c) ? r[c].push(s) : Di(r, c, [s]);
      });
      function Eb(r, s, c, _) {
        r = mn(r) ? r : ns(r), c = c && !_ ? Ee(c) : 0;
        var S = r.length;
        return c < 0 && (c = v(S + c, 0)), Hl(r) ? c <= S && r.indexOf(s, c) > -1 : !!S && sr(r, s, c) > -1;
      }
      var Ab = Oe(function(r, s, c) {
        var _ = -1, S = typeof s == "function", E = mn(r) ? U(r.length) : [];
        return mr(r, function(P) {
          E[++_] = S ? ut(s, P, c) : pa(P, s, c);
        }), E;
      }), Pb = Pl(function(r, s, c) {
        Di(r, c, s);
      });
      function zl(r, s) {
        var c = Me(r) ? tt : Xf;
        return c(r, de(s, 3));
      }
      function xb(r, s, c, _) {
        return r == null ? [] : (Me(s) || (s = s == null ? [] : [s]), c = _ ? t : c, Me(c) || (c = c == null ? [] : [c]), id(r, s, c));
      }
      var Ob = Pl(function(r, s, c) {
        r[c ? 0 : 1].push(s);
      }, function() {
        return [[], []];
      });
      function Nb(r, s, c) {
        var _ = Me(r) ? Xs : Vo, S = arguments.length < 3;
        return _(r, de(s, 4), c, S, mr);
      }
      function Ib(r, s, c) {
        var _ = Me(r) ? cc : Vo, S = arguments.length < 3;
        return _(r, de(s, 4), c, S, Wf);
      }
      function kb(r, s) {
        var c = Me(r) ? Gn : Gf;
        return c(r, Ul(de(s, 3)));
      }
      function Db(r) {
        var s = Me(r) ? Vf : Ev;
        return s(r);
      }
      function $b(r, s, c) {
        (c ? an(r, s, c) : s === t) ? s = 1 : s = Ee(s);
        var _ = Me(r) ? rv : Av;
        return _(r, s);
      }
      function Rb(r) {
        var s = Me(r) ? ov : xv;
        return s(r);
      }
      function zb(r) {
        if (r == null)
          return 0;
        if (mn(r))
          return Hl(r) ? Wt(r) : r.length;
        var s = Kt(r);
        return s == Sn || s == en ? r.size : xc(r).length;
      }
      function Bb(r, s, c) {
        var _ = Me(r) ? Vr : Ov;
        return c && an(r, s, c) && (s = t), _(r, de(s, 3));
      }
      var Fb = Oe(function(r, s) {
        if (r == null)
          return [];
        var c = s.length;
        return c > 1 && an(r, s[0], s[1]) ? s = [] : c > 2 && an(s[0], s[1], s[2]) && (s = [s[0]]), id(r, Ft(s, 1), []);
      }), Bl = wl || function() {
        return Pt.Date.now();
      };
      function Ub(r, s) {
        if (typeof s != "function")
          throw new Bt(d);
        return r = Ee(r), function() {
          if (--r < 1)
            return s.apply(this, arguments);
        };
      }
      function Qd(r, s, c) {
        return s = c ? t : s, s = r && s == null ? r.length : s, $i(r, Fe, t, t, t, t, s);
      }
      function Jd(r, s) {
        var c;
        if (typeof s != "function")
          throw new Bt(d);
        return r = Ee(r), function() {
          return --r > 0 && (c = s.apply(this, arguments)), r <= 1 && (s = t), c;
        };
      }
      var eh = Oe(function(r, s, c) {
        var _ = Z;
        if (c.length) {
          var S = ci(c, es(eh));
          _ |= be;
        }
        return $i(r, _, s, c, S);
      }), Xd = Oe(function(r, s, c) {
        var _ = Z | H;
        if (c.length) {
          var S = ci(c, es(Xd));
          _ |= be;
        }
        return $i(s, _, r, c, S);
      });
      function ep(r, s, c) {
        s = c ? t : s;
        var _ = $i(r, ee, t, t, t, t, t, s);
        return _.placeholder = ep.placeholder, _;
      }
      function tp(r, s, c) {
        s = c ? t : s;
        var _ = $i(r, re, t, t, t, t, t, s);
        return _.placeholder = tp.placeholder, _;
      }
      function np(r, s, c) {
        var _, S, E, P, I, R, G = 0, q = !1, Q = !1, te = !0;
        if (typeof r != "function")
          throw new Bt(d);
        s = Vn(s) || 0, dt(c) && (q = !!c.leading, Q = "maxWait" in c, E = Q ? v(Vn(c.maxWait) || 0, s) : E, te = "trailing" in c ? !!c.trailing : te);
        function se(Ct) {
          var ei = _, Ui = S;
          return _ = S = t, G = Ct, P = r.apply(Ui, ei), P;
        }
        function pe(Ct) {
          return G = Ct, I = ya(Ie, s), q ? se(Ct) : P;
        }
        function Ae(Ct) {
          var ei = Ct - R, Ui = Ct - G, wp = s - ei;
          return Q ? C(wp, E - Ui) : wp;
        }
        function me(Ct) {
          var ei = Ct - R, Ui = Ct - G;
          return R === t || ei >= s || ei < 0 || Q && Ui >= E;
        }
        function Ie() {
          var Ct = Bl();
          if (me(Ct))
            return Be(Ct);
          I = ya(Ie, Ae(Ct));
        }
        function Be(Ct) {
          return I = t, te && _ ? se(Ct) : (_ = S = t, P);
        }
        function Pn() {
          I !== t && fd(I), G = 0, _ = R = S = I = t;
        }
        function ln() {
          return I === t ? P : Be(Bl());
        }
        function xn() {
          var Ct = Bl(), ei = me(Ct);
          if (_ = arguments, S = this, R = Ct, ei) {
            if (I === t)
              return pe(R);
            if (Q)
              return fd(I), I = ya(Ie, s), se(R);
          }
          return I === t && (I = ya(Ie, s)), P;
        }
        return xn.cancel = Pn, xn.flush = ln, xn;
      }
      var Vb = Oe(function(r, s) {
        return Zf(r, 1, s);
      }), Hb = Oe(function(r, s, c) {
        return Zf(r, Vn(s) || 0, c);
      });
      function jb(r) {
        return $i(r, qe);
      }
      function Fl(r, s) {
        if (typeof r != "function" || s != null && typeof s != "function")
          throw new Bt(d);
        var c = function() {
          var _ = arguments, S = s ? s.apply(this, _) : _[0], E = c.cache;
          if (E.has(S))
            return E.get(S);
          var P = r.apply(this, _);
          return c.cache = E.set(S, P) || E, P;
        };
        return c.cache = new (Fl.Cache || ki)(), c;
      }
      Fl.Cache = ki;
      function Ul(r) {
        if (typeof r != "function")
          throw new Bt(d);
        return function() {
          var s = arguments;
          switch (s.length) {
            case 0:
              return !r.call(this);
            case 1:
              return !r.call(this, s[0]);
            case 2:
              return !r.call(this, s[0], s[1]);
            case 3:
              return !r.call(this, s[0], s[1], s[2]);
          }
          return !r.apply(this, s);
        };
      }
      function Zb(r) {
        return Jd(2, r);
      }
      var Wb = Nv(function(r, s) {
        s = s.length == 1 && Me(s[0]) ? tt(s[0], lt(de())) : tt(Ft(s, 1), lt(de()));
        var c = s.length;
        return Oe(function(_) {
          for (var S = -1, E = C(_.length, c); ++S < E; )
            _[S] = s[S].call(this, _[S]);
          return ut(r, this, _);
        });
      }), th = Oe(function(r, s) {
        var c = ci(s, es(th));
        return $i(r, be, t, s, c);
      }), ip = Oe(function(r, s) {
        var c = ci(s, es(ip));
        return $i(r, Xe, t, s, c);
      }), Gb = Ri(function(r, s) {
        return $i(r, ge, t, t, t, s);
      });
      function qb(r, s) {
        if (typeof r != "function")
          throw new Bt(d);
        return s = s === t ? s : Ee(s), Oe(r, s);
      }
      function Kb(r, s) {
        if (typeof r != "function")
          throw new Bt(d);
        return s = s == null ? 0 : v(Ee(s), 0), Oe(function(c) {
          var _ = c[s], S = vr(c, 0, s);
          return _ && qn(S, _), ut(r, this, S);
        });
      }
      function Yb(r, s, c) {
        var _ = !0, S = !0;
        if (typeof r != "function")
          throw new Bt(d);
        return dt(c) && (_ = "leading" in c ? !!c.leading : _, S = "trailing" in c ? !!c.trailing : S), np(r, s, {
          leading: _,
          maxWait: s,
          trailing: S
        });
      }
      function Qb(r) {
        return Qd(r, 1);
      }
      function Jb(r, s) {
        return th(Bc(s), r);
      }
      function Xb() {
        if (!arguments.length)
          return [];
        var r = arguments[0];
        return Me(r) ? r : [r];
      }
      function ew(r) {
        return Bn(r, T);
      }
      function tw(r, s) {
        return s = typeof s == "function" ? s : t, Bn(r, T, s);
      }
      function nw(r) {
        return Bn(r, h | T);
      }
      function iw(r, s) {
        return s = typeof s == "function" ? s : t, Bn(r, h | T, s);
      }
      function rw(r, s) {
        return s == null || jf(r, s, Dt(s));
      }
      function Xn(r, s) {
        return r === s || r !== r && s !== s;
      }
      var ow = Il(Ec), sw = Il(function(r, s) {
        return r >= s;
      }), lo = Yf(function() {
        return arguments;
      }()) ? Yf : function(r) {
        return bt(r) && ze.call(r, "callee") && !ca.call(r, "callee");
      }, Me = U.isArray, aw = al ? lt(al) : mv;
      function mn(r) {
        return r != null && Vl(r.length) && !Bi(r);
      }
      function St(r) {
        return bt(r) && mn(r);
      }
      function lw(r) {
        return r === !0 || r === !1 || bt(r) && sn(r) == fn;
      }
      var yr = i || fh, uw = Ys ? lt(Ys) : _v;
      function cw(r) {
        return bt(r) && r.nodeType === 1 && !ba(r);
      }
      function hw(r) {
        if (r == null)
          return !0;
        if (mn(r) && (Me(r) || typeof r == "string" || typeof r.splice == "function" || yr(r) || ts(r) || lo(r)))
          return !r.length;
        var s = Kt(r);
        if (s == Sn || s == en)
          return !r.size;
        if (va(r))
          return !xc(r).length;
        for (var c in r)
          if (ze.call(r, c))
            return !1;
        return !0;
      }
      function fw(r, s) {
        return ma(r, s);
      }
      function dw(r, s, c) {
        c = typeof c == "function" ? c : t;
        var _ = c ? c(r, s) : t;
        return _ === t ? ma(r, s, t, c) : !!_;
      }
      function nh(r) {
        if (!bt(r))
          return !1;
        var s = sn(r);
        return s == Qi || s == Ps || typeof r.message == "string" && typeof r.name == "string" && !ba(r);
      }
      function pw(r) {
        return typeof r == "number" && o(r);
      }
      function Bi(r) {
        if (!dt(r))
          return !1;
        var s = sn(r);
        return s == oi || s == Co || s == Zn || s == Hu;
      }
      function rp(r) {
        return typeof r == "number" && r == Ee(r);
      }
      function Vl(r) {
        return typeof r == "number" && r > -1 && r % 1 == 0 && r <= fe;
      }
      function dt(r) {
        var s = typeof r;
        return r != null && (s == "object" || s == "function");
      }
      function bt(r) {
        return r != null && typeof r == "object";
      }
      var op = ll ? lt(ll) : vv;
      function mw(r, s) {
        return r === s || Pc(r, s, Wc(s));
      }
      function _w(r, s, c) {
        return c = typeof c == "function" ? c : t, Pc(r, s, Wc(s), c);
      }
      function gw(r) {
        return sp(r) && r != +r;
      }
      function vw(r) {
        if (ty(r))
          throw new ve(f);
        return Qf(r);
      }
      function yw(r) {
        return r === null;
      }
      function bw(r) {
        return r == null;
      }
      function sp(r) {
        return typeof r == "number" || bt(r) && sn(r) == Ji;
      }
      function ba(r) {
        if (!bt(r) || sn(r) != Cn)
          return !1;
        var s = Ni(r);
        if (s === null)
          return !0;
        var c = ze.call(s, "constructor") && s.constructor;
        return typeof c == "function" && c instanceof c && Yo.call(c) == gl;
      }
      var ih = ul ? lt(ul) : yv;
      function ww(r) {
        return rp(r) && r >= -fe && r <= fe;
      }
      var ap = Fo ? lt(Fo) : bv;
      function Hl(r) {
        return typeof r == "string" || !Me(r) && bt(r) && sn(r) == er;
      }
      function An(r) {
        return typeof r == "symbol" || bt(r) && sn(r) == kr;
      }
      var ts = cl ? lt(cl) : wv;
      function Lw(r) {
        return r === t;
      }
      function Sw(r) {
        return bt(r) && Kt(r) == Dr;
      }
      function Cw(r) {
        return bt(r) && sn(r) == xs;
      }
      var Mw = Il(Oc), Tw = Il(function(r, s) {
        return r <= s;
      });
      function lp(r) {
        if (!r)
          return [];
        if (mn(r))
          return Hl(r) ? Gt(r) : pn(r);
        if (dr && r[dr])
          return jo(r[dr]());
        var s = Kt(r), c = s == Sn ? oa : s == en ? dn : ns;
        return c(r);
      }
      function Fi(r) {
        if (!r)
          return r === 0 ? r : 0;
        if (r = Vn(r), r === Ln || r === -Ln) {
          var s = r < 0 ? -1 : 1;
          return s * Fa;
        }
        return r === r ? r : 0;
      }
      function Ee(r) {
        var s = Fi(r), c = s % 1;
        return s === s ? c ? s - c : s : 0;
      }
      function up(r) {
        return r ? ro(Ee(r), 0, Ue) : 0;
      }
      function Vn(r) {
        if (typeof r == "number")
          return r;
        if (An(r))
          return _e;
        if (dt(r)) {
          var s = typeof r.valueOf == "function" ? r.valueOf() : r;
          r = dt(s) ? s + "" : s;
        }
        if (typeof r != "string")
          return r === 0 ? r : +r;
        r = pl(r);
        var c = ec.test(r);
        return c || nc.test(r) ? lc(r.slice(2), c ? 2 : 8) : Ka.test(r) ? _e : +r;
      }
      function cp(r) {
        return pi(r, _n(r));
      }
      function Ew(r) {
        return r ? ro(Ee(r), -fe, fe) : r === 0 ? r : 0;
      }
      function Je(r) {
        return r == null ? "" : En(r);
      }
      var Aw = Jo(function(r, s) {
        if (va(s) || mn(s)) {
          pi(s, Dt(s), r);
          return;
        }
        for (var c in s)
          ze.call(s, c) && fa(r, c, s[c]);
      }), hp = Jo(function(r, s) {
        pi(s, _n(s), r);
      }), jl = Jo(function(r, s, c, _) {
        pi(s, _n(s), r, _);
      }), Pw = Jo(function(r, s, c, _) {
        pi(s, Dt(s), r, _);
      }), xw = Ri(Cc);
      function Ow(r, s) {
        var c = pr(r);
        return s == null ? c : Hf(c, s);
      }
      var Nw = Oe(function(r, s) {
        r = Qe(r);
        var c = -1, _ = s.length, S = _ > 2 ? s[2] : t;
        for (S && an(s[0], s[1], S) && (_ = 1); ++c < _; )
          for (var E = s[c], P = _n(E), I = -1, R = P.length; ++I < R; ) {
            var G = P[I], q = r[G];
            (q === t || Xn(q, hr[G]) && !ze.call(r, G)) && (r[G] = E[G]);
          }
        return r;
      }), Iw = Oe(function(r) {
        return r.push(t, Ad), ut(fp, t, r);
      });
      function kw(r, s) {
        return Hr(r, de(s, 3), di);
      }
      function Dw(r, s) {
        return Hr(r, de(s, 3), Tc);
      }
      function $w(r, s) {
        return r == null ? r : Mc(r, de(s, 3), _n);
      }
      function Rw(r, s) {
        return r == null ? r : qf(r, de(s, 3), _n);
      }
      function zw(r, s) {
        return r && di(r, de(s, 3));
      }
      function Bw(r, s) {
        return r && Tc(r, de(s, 3));
      }
      function Fw(r) {
        return r == null ? [] : Ml(r, Dt(r));
      }
      function Uw(r) {
        return r == null ? [] : Ml(r, _n(r));
      }
      function rh(r, s, c) {
        var _ = r == null ? t : oo(r, s);
        return _ === t ? c : _;
      }
      function Vw(r, s) {
        return r != null && Od(r, s, hv);
      }
      function oh(r, s) {
        return r != null && Od(r, s, fv);
      }
      var Hw = Sd(function(r, s, c) {
        s != null && typeof s.toString != "function" && (s = qr.call(s)), r[s] = c;
      }, ah(gn)), jw = Sd(function(r, s, c) {
        s != null && typeof s.toString != "function" && (s = qr.call(s)), ze.call(r, s) ? r[s].push(c) : r[s] = [c];
      }, de), Zw = Oe(pa);
      function Dt(r) {
        return mn(r) ? Uf(r) : xc(r);
      }
      function _n(r) {
        return mn(r) ? Uf(r, !0) : Lv(r);
      }
      function Ww(r, s) {
        var c = {};
        return s = de(s, 3), di(r, function(_, S, E) {
          Di(c, s(_, S, E), _);
        }), c;
      }
      function Gw(r, s) {
        var c = {};
        return s = de(s, 3), di(r, function(_, S, E) {
          Di(c, S, s(_, S, E));
        }), c;
      }
      var qw = Jo(function(r, s, c) {
        Tl(r, s, c);
      }), fp = Jo(function(r, s, c, _) {
        Tl(r, s, c, _);
      }), Kw = Ri(function(r, s) {
        var c = {};
        if (r == null)
          return c;
        var _ = !1;
        s = tt(s, function(E) {
          return E = gr(E, r), _ || (_ = E.length > 1), E;
        }), pi(r, jc(r), c), _ && (c = Bn(c, h | b | T, Hv));
        for (var S = s.length; S--; )
          $c(c, s[S]);
        return c;
      });
      function Yw(r, s) {
        return dp(r, Ul(de(s)));
      }
      var Qw = Ri(function(r, s) {
        return r == null ? {} : Cv(r, s);
      });
      function dp(r, s) {
        if (r == null)
          return {};
        var c = tt(jc(r), function(_) {
          return [_];
        });
        return s = de(s), rd(r, c, function(_, S) {
          return s(_, S[0]);
        });
      }
      function Jw(r, s, c) {
        s = gr(s, r);
        var _ = -1, S = s.length;
        for (S || (S = 1, r = t); ++_ < S; ) {
          var E = r == null ? t : r[mi(s[_])];
          E === t && (_ = S, E = c), r = Bi(E) ? E.call(r) : E;
        }
        return r;
      }
      function Xw(r, s, c) {
        return r == null ? r : _a(r, s, c);
      }
      function e0(r, s, c, _) {
        return _ = typeof _ == "function" ? _ : t, r == null ? r : _a(r, s, c, _);
      }
      var pp = Td(Dt), mp = Td(_n);
      function t0(r, s, c) {
        var _ = Me(r), S = _ || yr(r) || ts(r);
        if (s = de(s, 4), c == null) {
          var E = r && r.constructor;
          S ? c = _ ? new E() : [] : dt(r) ? c = Bi(E) ? pr(Ni(r)) : {} : c = {};
        }
        return (S ? rn : di)(r, function(P, I, R) {
          return s(c, P, I, R);
        }), c;
      }
      function n0(r, s) {
        return r == null ? !0 : $c(r, s);
      }
      function i0(r, s, c) {
        return r == null ? r : ud(r, s, Bc(c));
      }
      function r0(r, s, c, _) {
        return _ = typeof _ == "function" ? _ : t, r == null ? r : ud(r, s, Bc(c), _);
      }
      function ns(r) {
        return r == null ? [] : li(r, Dt(r));
      }
      function o0(r) {
        return r == null ? [] : li(r, _n(r));
      }
      function s0(r, s, c) {
        return c === t && (c = s, s = t), c !== t && (c = Vn(c), c = c === c ? c : 0), s !== t && (s = Vn(s), s = s === s ? s : 0), ro(Vn(r), s, c);
      }
      function a0(r, s, c) {
        return s = Fi(s), c === t ? (c = s, s = 0) : c = Fi(c), r = Vn(r), dv(r, s, c);
      }
      function l0(r, s, c) {
        if (c && typeof c != "boolean" && an(r, s, c) && (s = c = t), c === t && (typeof s == "boolean" ? (c = s, s = t) : typeof r == "boolean" && (c = r, r = t)), r === t && s === t ? (r = 0, s = 1) : (r = Fi(r), s === t ? (s = r, r = 0) : s = Fi(s)), r > s) {
          var _ = r;
          r = s, s = _;
        }
        if (c || r % 1 || s % 1) {
          var S = F();
          return C(r + S * (s - r + Ws("1e-" + ((S + "").length - 1))), s);
        }
        return Ic(r, s);
      }
      var u0 = Xo(function(r, s, c) {
        return s = s.toLowerCase(), r + (c ? _p(s) : s);
      });
      function _p(r) {
        return sh(Je(r).toLowerCase());
      }
      function gp(r) {
        return r = Je(r), r && r.replace(Ya, fc).replace(il, "");
      }
      function c0(r, s, c) {
        r = Je(r), s = En(s);
        var _ = r.length;
        c = c === t ? _ : ro(Ee(c), 0, _);
        var S = c;
        return c -= s.length, c >= 0 && r.slice(c, S) == s;
      }
      function h0(r) {
        return r = Je(r), r && qu.test(r) ? r.replace(Ds, Wr) : r;
      }
      function f0(r) {
        return r = Je(r), r && Xu.test(r) ? r.replace(Rs, "\\$&") : r;
      }
      var d0 = Xo(function(r, s, c) {
        return r + (c ? "-" : "") + s.toLowerCase();
      }), p0 = Xo(function(r, s, c) {
        return r + (c ? " " : "") + s.toLowerCase();
      }), m0 = bd("toLowerCase");
      function _0(r, s, c) {
        r = Je(r), s = Ee(s);
        var _ = s ? Wt(r) : 0;
        if (!s || _ >= s)
          return r;
        var S = (s - _) / 2;
        return Nl(Xr(S), c) + r + Nl(Jr(S), c);
      }
      function g0(r, s, c) {
        r = Je(r), s = Ee(s);
        var _ = s ? Wt(r) : 0;
        return s && _ < s ? r + Nl(s - _, c) : r;
      }
      function v0(r, s, c) {
        r = Je(r), s = Ee(s);
        var _ = s ? Wt(r) : 0;
        return s && _ < s ? Nl(s - _, c) + r : r;
      }
      function y0(r, s, c) {
        return c || s == null ? s = 0 : s && (s = +s), B(Je(r).replace(zs, ""), s || 0);
      }
      function b0(r, s, c) {
        return (c ? an(r, s, c) : s === t) ? s = 1 : s = Ee(s), kc(Je(r), s);
      }
      function w0() {
        var r = arguments, s = Je(r[0]);
        return r.length < 3 ? s : s.replace(r[1], r[2]);
      }
      var L0 = Xo(function(r, s, c) {
        return r + (c ? "_" : "") + s.toLowerCase();
      });
      function S0(r, s, c) {
        return c && typeof c != "number" && an(r, s, c) && (s = c = t), c = c === t ? Ue : c >>> 0, c ? (r = Je(r), r && (typeof s == "string" || s != null && !ih(s)) && (s = En(s), !s && lr(r)) ? vr(Gt(r), 0, c) : r.split(s, c)) : [];
      }
      var C0 = Xo(function(r, s, c) {
        return r + (c ? " " : "") + sh(s);
      });
      function M0(r, s, c) {
        return r = Je(r), c = c == null ? 0 : ro(Ee(c), 0, r.length), s = En(s), r.slice(c, c + s.length) == s;
      }
      function T0(r, s, c) {
        var _ = M.templateSettings;
        c && an(r, s, c) && (s = t), r = Je(r), s = jl({}, s, _, Ed);
        var S = jl({}, s.imports, _.imports, Ed), E = Dt(S), P = li(S, E), I, R, G = 0, q = s.interpolate || Po, Q = "__p += '", te = ua(
          (s.escape || Po).source + "|" + q.source + "|" + (q === Ha ? qa : Po).source + "|" + (s.evaluate || Po).source + "|$",
          "g"
        ), se = "//# sourceURL=" + (ze.call(s, "sourceURL") ? (s.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Ur + "]") + `
`;
        r.replace(te, function(me, Ie, Be, Pn, ln, xn) {
          return Be || (Be = Pn), Q += r.slice(G, xn).replace(xo, _l), Ie && (I = !0, Q += `' +
__e(` + Ie + `) +
'`), ln && (R = !0, Q += `';
` + ln + `;
__p += '`), Be && (Q += `' +
((__t = (` + Be + `)) == null ? '' : __t) +
'`), G = xn + me.length, me;
        }), Q += `';
`;
        var pe = ze.call(s, "variable") && s.variable;
        if (!pe)
          Q = `with (obj) {
` + Q + `
}
`;
        else if (Ga.test(pe))
          throw new ve(m);
        Q = (R ? Q.replace(Zu, "") : Q).replace(Wu, "$1").replace(Va, "$1;"), Q = "function(" + (pe || "obj") + `) {
` + (pe ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (I ? ", __e = _.escape" : "") + (R ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Q + `return __p
}`;
        var Ae = yp(function() {
          return je(E, se + "return " + Q).apply(t, P);
        });
        if (Ae.source = Q, nh(Ae))
          throw Ae;
        return Ae;
      }
      function E0(r) {
        return Je(r).toLowerCase();
      }
      function A0(r) {
        return Je(r).toUpperCase();
      }
      function P0(r, s, c) {
        if (r = Je(r), r && (c || s === t))
          return pl(r);
        if (!r || !(s = En(s)))
          return r;
        var _ = Gt(r), S = Gt(s), E = Rn(_, S), P = ml(_, S) + 1;
        return vr(_, E, P).join("");
      }
      function x0(r, s, c) {
        if (r = Je(r), r && (c || s === t))
          return r.slice(0, sa(r) + 1);
        if (!r || !(s = En(s)))
          return r;
        var _ = Gt(r), S = ml(_, Gt(s)) + 1;
        return vr(_, 0, S).join("");
      }
      function O0(r, s, c) {
        if (r = Je(r), r && (c || s === t))
          return r.replace(zs, "");
        if (!r || !(s = En(s)))
          return r;
        var _ = Gt(r), S = Rn(_, Gt(s));
        return vr(_, S).join("");
      }
      function N0(r, s) {
        var c = at, _ = _t;
        if (dt(s)) {
          var S = "separator" in s ? s.separator : S;
          c = "length" in s ? Ee(s.length) : c, _ = "omission" in s ? En(s.omission) : _;
        }
        r = Je(r);
        var E = r.length;
        if (lr(r)) {
          var P = Gt(r);
          E = P.length;
        }
        if (c >= E)
          return r;
        var I = c - Wt(_);
        if (I < 1)
          return _;
        var R = P ? vr(P, 0, I).join("") : r.slice(0, I);
        if (S === t)
          return R + _;
        if (P && (I += R.length - I), ih(S)) {
          if (r.slice(I).search(S)) {
            var G, q = R;
            for (S.global || (S = ua(S.source, Je(Ti.exec(S)) + "g")), S.lastIndex = 0; G = S.exec(q); )
              var Q = G.index;
            R = R.slice(0, Q === t ? I : Q);
          }
        } else if (r.indexOf(En(S), I) != I) {
          var te = R.lastIndexOf(S);
          te > -1 && (R = R.slice(0, te));
        }
        return R + _;
      }
      function I0(r) {
        return r = Je(r), r && Gu.test(r) ? r.replace(ks, aa) : r;
      }
      var k0 = Xo(function(r, s, c) {
        return r + (c ? " " : "") + s.toUpperCase();
      }), sh = bd("toUpperCase");
      function vp(r, s, c) {
        return r = Je(r), s = c ? t : s, s === t ? ui(r) ? Go(r) : fl(r) : r.match(s) || [];
      }
      var yp = Oe(function(r, s) {
        try {
          return ut(r, t, s);
        } catch (c) {
          return nh(c) ? c : new ve(c);
        }
      }), D0 = Ri(function(r, s) {
        return rn(s, function(c) {
          c = mi(c), Di(r, c, eh(r[c], r));
        }), r;
      });
      function $0(r) {
        var s = r == null ? 0 : r.length, c = de();
        return r = s ? tt(r, function(_) {
          if (typeof _[1] != "function")
            throw new Bt(d);
          return [c(_[0]), _[1]];
        }) : [], Oe(function(_) {
          for (var S = -1; ++S < s; ) {
            var E = r[S];
            if (ut(E[0], this, _))
              return ut(E[1], this, _);
          }
        });
      }
      function R0(r) {
        return lv(Bn(r, h));
      }
      function ah(r) {
        return function() {
          return r;
        };
      }
      function z0(r, s) {
        return r == null || r !== r ? s : r;
      }
      var B0 = Ld(), F0 = Ld(!0);
      function gn(r) {
        return r;
      }
      function lh(r) {
        return Jf(typeof r == "function" ? r : Bn(r, h));
      }
      function U0(r) {
        return ed(Bn(r, h));
      }
      function V0(r, s) {
        return td(r, Bn(s, h));
      }
      var H0 = Oe(function(r, s) {
        return function(c) {
          return pa(c, r, s);
        };
      }), j0 = Oe(function(r, s) {
        return function(c) {
          return pa(r, c, s);
        };
      });
      function uh(r, s, c) {
        var _ = Dt(s), S = Ml(s, _);
        c == null && !(dt(s) && (S.length || !_.length)) && (c = s, s = r, r = this, S = Ml(s, Dt(s)));
        var E = !(dt(c) && "chain" in c) || !!c.chain, P = Bi(r);
        return rn(S, function(I) {
          var R = s[I];
          r[I] = R, P && (r.prototype[I] = function() {
            var G = this.__chain__;
            if (E || G) {
              var q = r(this.__wrapped__), Q = q.__actions__ = pn(this.__actions__);
              return Q.push({ func: R, args: arguments, thisArg: r }), q.__chain__ = G, q;
            }
            return R.apply(r, qn([this.value()], arguments));
          });
        }), r;
      }
      function Z0() {
        return Pt._ === this && (Pt._ = _c), this;
      }
      function ch() {
      }
      function W0(r) {
        return r = Ee(r), Oe(function(s) {
          return nd(s, r);
        });
      }
      var G0 = Uc(tt), q0 = Uc(Qs), K0 = Uc(Vr);
      function bp(r) {
        return qc(r) ? Uo(mi(r)) : Mv(r);
      }
      function Y0(r) {
        return function(s) {
          return r == null ? t : oo(r, s);
        };
      }
      var Q0 = Cd(), J0 = Cd(!0);
      function hh() {
        return [];
      }
      function fh() {
        return !1;
      }
      function X0() {
        return {};
      }
      function eL() {
        return "";
      }
      function tL() {
        return !0;
      }
      function nL(r, s) {
        if (r = Ee(r), r < 1 || r > fe)
          return [];
        var c = Ue, _ = C(r, Ue);
        s = de(s), r -= Ue;
        for (var S = ra(_, s); ++c < r; )
          s(c);
        return S;
      }
      function iL(r) {
        return Me(r) ? tt(r, mi) : An(r) ? [r] : pn(Fd(Je(r)));
      }
      function rL(r) {
        var s = ++mc;
        return Je(r) + s;
      }
      var oL = Ol(function(r, s) {
        return r + s;
      }, 0), sL = Vc("ceil"), aL = Ol(function(r, s) {
        return r / s;
      }, 1), lL = Vc("floor");
      function uL(r) {
        return r && r.length ? Cl(r, gn, Ec) : t;
      }
      function cL(r, s) {
        return r && r.length ? Cl(r, de(s, 2), Ec) : t;
      }
      function hL(r) {
        return ea(r, gn);
      }
      function fL(r, s) {
        return ea(r, de(s, 2));
      }
      function dL(r) {
        return r && r.length ? Cl(r, gn, Oc) : t;
      }
      function pL(r, s) {
        return r && r.length ? Cl(r, de(s, 2), Oc) : t;
      }
      var mL = Ol(function(r, s) {
        return r * s;
      }, 1), _L = Vc("round"), gL = Ol(function(r, s) {
        return r - s;
      }, 0);
      function vL(r) {
        return r && r.length ? ia(r, gn) : 0;
      }
      function yL(r, s) {
        return r && r.length ? ia(r, de(s, 2)) : 0;
      }
      return M.after = Ub, M.ary = Qd, M.assign = Aw, M.assignIn = hp, M.assignInWith = jl, M.assignWith = Pw, M.at = xw, M.before = Jd, M.bind = eh, M.bindAll = D0, M.bindKey = Xd, M.castArray = Xb, M.chain = qd, M.chunk = ly, M.compact = uy, M.concat = cy, M.cond = $0, M.conforms = R0, M.constant = ah, M.countBy = vb, M.create = Ow, M.curry = ep, M.curryRight = tp, M.debounce = np, M.defaults = Nw, M.defaultsDeep = Iw, M.defer = Vb, M.delay = Hb, M.difference = hy, M.differenceBy = fy, M.differenceWith = dy, M.drop = py, M.dropRight = my, M.dropRightWhile = _y, M.dropWhile = gy, M.fill = vy, M.filter = bb, M.flatMap = Sb, M.flatMapDeep = Cb, M.flatMapDepth = Mb, M.flatten = jd, M.flattenDeep = yy, M.flattenDepth = by, M.flip = jb, M.flow = B0, M.flowRight = F0, M.fromPairs = wy, M.functions = Fw, M.functionsIn = Uw, M.groupBy = Tb, M.initial = Sy, M.intersection = Cy, M.intersectionBy = My, M.intersectionWith = Ty, M.invert = Hw, M.invertBy = jw, M.invokeMap = Ab, M.iteratee = lh, M.keyBy = Pb, M.keys = Dt, M.keysIn = _n, M.map = zl, M.mapKeys = Ww, M.mapValues = Gw, M.matches = U0, M.matchesProperty = V0, M.memoize = Fl, M.merge = qw, M.mergeWith = fp, M.method = H0, M.methodOf = j0, M.mixin = uh, M.negate = Ul, M.nthArg = W0, M.omit = Kw, M.omitBy = Yw, M.once = Zb, M.orderBy = xb, M.over = G0, M.overArgs = Wb, M.overEvery = q0, M.overSome = K0, M.partial = th, M.partialRight = ip, M.partition = Ob, M.pick = Qw, M.pickBy = dp, M.property = bp, M.propertyOf = Y0, M.pull = xy, M.pullAll = Wd, M.pullAllBy = Oy, M.pullAllWith = Ny, M.pullAt = Iy, M.range = Q0, M.rangeRight = J0, M.rearg = Gb, M.reject = kb, M.remove = ky, M.rest = qb, M.reverse = Jc, M.sampleSize = $b, M.set = Xw, M.setWith = e0, M.shuffle = Rb, M.slice = Dy, M.sortBy = Fb, M.sortedUniq = Vy, M.sortedUniqBy = Hy, M.split = S0, M.spread = Kb, M.tail = jy, M.take = Zy, M.takeRight = Wy, M.takeRightWhile = Gy, M.takeWhile = qy, M.tap = ub, M.throttle = Yb, M.thru = Rl, M.toArray = lp, M.toPairs = pp, M.toPairsIn = mp, M.toPath = iL, M.toPlainObject = cp, M.transform = t0, M.unary = Qb, M.union = Ky, M.unionBy = Yy, M.unionWith = Qy, M.uniq = Jy, M.uniqBy = Xy, M.uniqWith = eb, M.unset = n0, M.unzip = Xc, M.unzipWith = Gd, M.update = i0, M.updateWith = r0, M.values = ns, M.valuesIn = o0, M.without = tb, M.words = vp, M.wrap = Jb, M.xor = nb, M.xorBy = ib, M.xorWith = rb, M.zip = ob, M.zipObject = sb, M.zipObjectDeep = ab, M.zipWith = lb, M.entries = pp, M.entriesIn = mp, M.extend = hp, M.extendWith = jl, uh(M, M), M.add = oL, M.attempt = yp, M.camelCase = u0, M.capitalize = _p, M.ceil = sL, M.clamp = s0, M.clone = ew, M.cloneDeep = nw, M.cloneDeepWith = iw, M.cloneWith = tw, M.conformsTo = rw, M.deburr = gp, M.defaultTo = z0, M.divide = aL, M.endsWith = c0, M.eq = Xn, M.escape = h0, M.escapeRegExp = f0, M.every = yb, M.find = wb, M.findIndex = Vd, M.findKey = kw, M.findLast = Lb, M.findLastIndex = Hd, M.findLastKey = Dw, M.floor = lL, M.forEach = Kd, M.forEachRight = Yd, M.forIn = $w, M.forInRight = Rw, M.forOwn = zw, M.forOwnRight = Bw, M.get = rh, M.gt = ow, M.gte = sw, M.has = Vw, M.hasIn = oh, M.head = Zd, M.identity = gn, M.includes = Eb, M.indexOf = Ly, M.inRange = a0, M.invoke = Zw, M.isArguments = lo, M.isArray = Me, M.isArrayBuffer = aw, M.isArrayLike = mn, M.isArrayLikeObject = St, M.isBoolean = lw, M.isBuffer = yr, M.isDate = uw, M.isElement = cw, M.isEmpty = hw, M.isEqual = fw, M.isEqualWith = dw, M.isError = nh, M.isFinite = pw, M.isFunction = Bi, M.isInteger = rp, M.isLength = Vl, M.isMap = op, M.isMatch = mw, M.isMatchWith = _w, M.isNaN = gw, M.isNative = vw, M.isNil = bw, M.isNull = yw, M.isNumber = sp, M.isObject = dt, M.isObjectLike = bt, M.isPlainObject = ba, M.isRegExp = ih, M.isSafeInteger = ww, M.isSet = ap, M.isString = Hl, M.isSymbol = An, M.isTypedArray = ts, M.isUndefined = Lw, M.isWeakMap = Sw, M.isWeakSet = Cw, M.join = Ey, M.kebabCase = d0, M.last = Un, M.lastIndexOf = Ay, M.lowerCase = p0, M.lowerFirst = m0, M.lt = Mw, M.lte = Tw, M.max = uL, M.maxBy = cL, M.mean = hL, M.meanBy = fL, M.min = dL, M.minBy = pL, M.stubArray = hh, M.stubFalse = fh, M.stubObject = X0, M.stubString = eL, M.stubTrue = tL, M.multiply = mL, M.nth = Py, M.noConflict = Z0, M.noop = ch, M.now = Bl, M.pad = _0, M.padEnd = g0, M.padStart = v0, M.parseInt = y0, M.random = l0, M.reduce = Nb, M.reduceRight = Ib, M.repeat = b0, M.replace = w0, M.result = Jw, M.round = _L, M.runInContext = $, M.sample = Db, M.size = zb, M.snakeCase = L0, M.some = Bb, M.sortedIndex = $y, M.sortedIndexBy = Ry, M.sortedIndexOf = zy, M.sortedLastIndex = By, M.sortedLastIndexBy = Fy, M.sortedLastIndexOf = Uy, M.startCase = C0, M.startsWith = M0, M.subtract = gL, M.sum = vL, M.sumBy = yL, M.template = T0, M.times = nL, M.toFinite = Fi, M.toInteger = Ee, M.toLength = up, M.toLower = E0, M.toNumber = Vn, M.toSafeInteger = Ew, M.toString = Je, M.toUpper = A0, M.trim = P0, M.trimEnd = x0, M.trimStart = O0, M.truncate = N0, M.unescape = I0, M.uniqueId = rL, M.upperCase = k0, M.upperFirst = sh, M.each = Kd, M.eachRight = Yd, M.first = Zd, uh(M, function() {
        var r = {};
        return di(M, function(s, c) {
          ze.call(M.prototype, c) || (r[c] = s);
        }), r;
      }(), { chain: !1 }), M.VERSION = a, rn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(r) {
        M[r].placeholder = M;
      }), rn(["drop", "take"], function(r, s) {
        xe.prototype[r] = function(c) {
          c = c === t ? 1 : v(Ee(c), 0);
          var _ = this.__filtered__ && !s ? new xe(this) : this.clone();
          return _.__filtered__ ? _.__takeCount__ = C(c, _.__takeCount__) : _.__views__.push({
            size: C(c, Ue),
            type: r + (_.__dir__ < 0 ? "Right" : "")
          }), _;
        }, xe.prototype[r + "Right"] = function(c) {
          return this.reverse()[r](c).reverse();
        };
      }), rn(["filter", "map", "takeWhile"], function(r, s) {
        var c = s + 1, _ = c == At || c == gt;
        xe.prototype[r] = function(S) {
          var E = this.clone();
          return E.__iteratees__.push({
            iteratee: de(S, 3),
            type: c
          }), E.__filtered__ = E.__filtered__ || _, E;
        };
      }), rn(["head", "last"], function(r, s) {
        var c = "take" + (s ? "Right" : "");
        xe.prototype[r] = function() {
          return this[c](1).value()[0];
        };
      }), rn(["initial", "tail"], function(r, s) {
        var c = "drop" + (s ? "" : "Right");
        xe.prototype[r] = function() {
          return this.__filtered__ ? new xe(this) : this[c](1);
        };
      }), xe.prototype.compact = function() {
        return this.filter(gn);
      }, xe.prototype.find = function(r) {
        return this.filter(r).head();
      }, xe.prototype.findLast = function(r) {
        return this.reverse().find(r);
      }, xe.prototype.invokeMap = Oe(function(r, s) {
        return typeof r == "function" ? new xe(this) : this.map(function(c) {
          return pa(c, r, s);
        });
      }), xe.prototype.reject = function(r) {
        return this.filter(Ul(de(r)));
      }, xe.prototype.slice = function(r, s) {
        r = Ee(r);
        var c = this;
        return c.__filtered__ && (r > 0 || s < 0) ? new xe(c) : (r < 0 ? c = c.takeRight(-r) : r && (c = c.drop(r)), s !== t && (s = Ee(s), c = s < 0 ? c.dropRight(-s) : c.take(s - r)), c);
      }, xe.prototype.takeRightWhile = function(r) {
        return this.reverse().takeWhile(r).reverse();
      }, xe.prototype.toArray = function() {
        return this.take(Ue);
      }, di(xe.prototype, function(r, s) {
        var c = /^(?:filter|find|map|reject)|While$/.test(s), _ = /^(?:head|last)$/.test(s), S = M[_ ? "take" + (s == "last" ? "Right" : "") : s], E = _ || /^find/.test(s);
        S && (M.prototype[s] = function() {
          var P = this.__wrapped__, I = _ ? [1] : arguments, R = P instanceof xe, G = I[0], q = R || Me(P), Q = function(Ie) {
            var Be = S.apply(M, qn([Ie], I));
            return _ && te ? Be[0] : Be;
          };
          q && c && typeof G == "function" && G.length != 1 && (R = q = !1);
          var te = this.__chain__, se = !!this.__actions__.length, pe = E && !te, Ae = R && !se;
          if (!E && q) {
            P = Ae ? P : new xe(this);
            var me = r.apply(P, I);
            return me.__actions__.push({ func: Rl, args: [Q], thisArg: t }), new qt(me, te);
          }
          return pe && Ae ? r.apply(this, I) : (me = this.thru(Q), pe ? _ ? me.value()[0] : me.value() : me);
        });
      }), rn(["pop", "push", "shift", "sort", "splice", "unshift"], function(r) {
        var s = qo[r], c = /^(?:push|sort|unshift)$/.test(r) ? "tap" : "thru", _ = /^(?:pop|shift)$/.test(r);
        M.prototype[r] = function() {
          var S = arguments;
          if (_ && !this.__chain__) {
            var E = this.value();
            return s.apply(Me(E) ? E : [], S);
          }
          return this[c](function(P) {
            return s.apply(Me(P) ? P : [], S);
          });
        };
      }), di(xe.prototype, function(r, s) {
        var c = M[s];
        if (c) {
          var _ = c.name + "";
          ze.call(Tn, _) || (Tn[_] = []), Tn[_].push({ name: s, func: c });
        }
      }), Tn[xl(t, H).name] = [{
        name: "wrapper",
        func: t
      }], xe.prototype.clone = Lc, xe.prototype.reverse = kg, xe.prototype.value = Dg, M.prototype.at = cb, M.prototype.chain = hb, M.prototype.commit = fb, M.prototype.next = db, M.prototype.plant = mb, M.prototype.reverse = _b, M.prototype.toJSON = M.prototype.valueOf = M.prototype.value = gb, M.prototype.first = M.prototype.head, dr && (M.prototype[dr] = pb), M;
    }, Kn = cr();
    Mn ? ((Mn.exports = Kn)._ = Kn, nn._ = Kn) : Pt._ = Kn;
  }).call(as);
})(uu, uu.exports);
var ke = uu.exports;
class Ss {
  constructor(n) {
    N(this, "scope");
    N(this, "operator");
    N(this, "value");
    this.scope = (n == null ? void 0 : n.scope) || "", this.operator = n == null ? void 0 : n.operator, this.value = n == null ? void 0 : n.value;
  }
}
var Ea = /* @__PURE__ */ ((e) => (e.equal = "equal", e.notEqual = "notEqual", e.less = "less", e.greater = "greater", e))(Ea || {}), vn = /* @__PURE__ */ ((e) => (e.asc = "ascending", e.desc = "descending", e[e.time = 750] = "time", e))(vn || {});
class Ye {
  constructor(n) {
    Object.values(Ta).forEach((t) => {
      this[t] = (n == null ? void 0 : n[t]) || "";
    });
  }
}
class bR {
  constructor({ id: n, module: t, code: a, rendition: u }) {
    N(this, "id");
    N(this, "module");
    N(this, "code");
    N(this, "rendition");
    this.id = n, this.module = t, this.code = a, this.rendition = u;
  }
}
class wR {
  constructor(n) {
    N(this, "filter");
    N(this, "sort");
    N(this, "page");
    N(this, "perPage");
    this.sort = n == null ? void 0 : n.sort, this.page = (n == null ? void 0 : n.page) || BL, this.perPage = (n == null ? void 0 : n.perPage) || zL;
  }
  get request() {
    return {
      filter: { ...ke.omitBy(this.filter || {}, ke.isNil) },
      sort: { ...this.sort },
      page: this.page,
      perPage: this.perPage
    };
  }
}
class LR {
  constructor(n) {
    N(this, "search");
    this.search = n == null ? void 0 : n.search;
  }
}
class SR {
  constructor(n) {
    N(this, "page");
    N(this, "perPage");
    N(this, "pages");
    N(this, "totalRecords");
    N(this, "allRecords");
    this.page = n.page, this.perPage = n.perPage, this.pages = n.pages, this.totalRecords = n.totalRecords, this.allRecords = n.allRecords;
  }
}
let Zl;
const CC = new Uint8Array(16);
function MC() {
  if (!Zl && (Zl = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Zl))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Zl(CC);
}
const Ut = [];
for (let e = 0; e < 256; ++e)
  Ut.push((e + 256).toString(16).slice(1));
function TC(e, n = 0) {
  return (Ut[e[n + 0]] + Ut[e[n + 1]] + Ut[e[n + 2]] + Ut[e[n + 3]] + "-" + Ut[e[n + 4]] + Ut[e[n + 5]] + "-" + Ut[e[n + 6]] + Ut[e[n + 7]] + "-" + Ut[e[n + 8]] + Ut[e[n + 9]] + "-" + Ut[e[n + 10]] + Ut[e[n + 11]] + Ut[e[n + 12]] + Ut[e[n + 13]] + Ut[e[n + 14]] + Ut[e[n + 15]]).toLowerCase();
}
const EC = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Sp = {
  randomUUID: EC
};
function Wm(e, n, t) {
  if (Sp.randomUUID && !n && !e)
    return Sp.randomUUID();
  e = e || {};
  const a = e.random || (e.rng || MC)();
  if (a[6] = a[6] & 15 | 64, a[8] = a[8] & 63 | 128, n) {
    t = t || 0;
    for (let u = 0; u < 16; ++u)
      n[t + u] = a[u];
    return n;
  }
  return TC(a);
}
function cf(e) {
  return e.type === We.button ? new PC(e) : e.type === We.control ? new OC(e) : e.type === We.layout ? new hf(e) : e.type === We.tab ? new Gm(e) : e.type === We.table ? new kC(e) : e.type === We.tabs ? new DC(e) : e.type === We.text ? new RC(e) : new NC(e);
}
let Or = class {
  constructor({ id: n }) {
    N(this, "id");
    this.id = n || Wm();
  }
};
function AC(e) {
  const n = {
    [_o.mapSelect]: zC,
    [_o.submit]: BC
  };
  return new n[e.type](e);
}
class PC extends Or {
  constructor({ id: t, properties: a }) {
    super({ id: t });
    N(this, "type");
    N(this, "properties");
    this.type = We.button, this.properties = AC(a);
  }
}
function xC(e) {
  const n = {
    [ye.arrayStrings]: FC,
    [ye.checkbox]: UC,
    [ye.date]: VC,
    [ye.editor]: HC,
    [ye.mapDraw]: jC,
    [ye.number]: ZC,
    [ye.radio]: WC,
    [ye.select]: GC,
    [ye.selectRemote]: qC,
    [ye.selectSearch]: KC,
    [ye.selectTree]: YC,
    [ye.string]: QC,
    [ye.switch]: JC,
    [ye.textarea]: XC,
    [ye.time]: e1
  };
  return new n[e.type](e);
}
class OC extends Or {
  constructor({ id: t, scope: a, properties: u }) {
    super({ id: t });
    N(this, "type");
    N(this, "scope");
    N(this, "properties");
    this.type = We.control, this.scope = a || "", this.properties = xC(u);
  }
}
class NC extends Or {
  constructor(t) {
    super({ id: t == null ? void 0 : t.id });
    N(this, "type");
    N(this, "properties");
    this.type = We.watcher, this.properties = new l1(t == null ? void 0 : t.properties);
  }
}
function IC(e) {
  const n = {
    [Ar.horizontal]: t1,
    [Ar.vertical]: Km
  };
  return new n[e.type](e);
}
class hf extends Or {
  constructor({ id: t, properties: a, elements: u }) {
    super({ id: t });
    N(this, "type");
    N(this, "properties");
    N(this, "elements");
    this.type = We.layout, this.properties = IC(a), this.elements = (u == null ? void 0 : u.map((f) => cf(f))) || [];
  }
}
class Gm extends Or {
  constructor(t) {
    var a;
    super({ id: t == null ? void 0 : t.id });
    N(this, "type");
    N(this, "title");
    N(this, "elements");
    this.type = We.tab, this.title = new Ye(t == null ? void 0 : t.title), this.elements = ((a = t == null ? void 0 : t.elements) == null ? void 0 : a.map((u) => cf(u))) || [];
  }
}
class kC extends Or {
  constructor(t) {
    super({ id: t == null ? void 0 : t.id });
    N(this, "type");
    N(this, "scope");
    N(this, "properties");
    this.type = We.table, this.scope = (t == null ? void 0 : t.scope) || "", this.properties = new n1(t == null ? void 0 : t.properties);
  }
}
class DC extends Or {
  constructor(t) {
    var a;
    super({ id: t == null ? void 0 : t.id });
    N(this, "type");
    N(this, "properties");
    N(this, "elements");
    this.type = We.tabs, this.properties = new i1(t == null ? void 0 : t.properties), this.elements = ((a = t == null ? void 0 : t.elements) == null ? void 0 : a.map((u) => new Gm(u))) || [];
  }
}
function $C(e) {
  const n = {
    [Nn.alert]: r1,
    [Nn.description]: o1,
    [Nn.headline]: s1,
    [Nn.label]: a1
  };
  return new n[e.type](e);
}
class RC extends Or {
  constructor({ id: t, properties: a }) {
    super({ id: t });
    N(this, "type");
    N(this, "properties");
    this.type = We.text, this.properties = $C(a);
  }
}
var We = /* @__PURE__ */ ((e) => (e.button = "Button", e.control = "Control", e.layout = "Layout", e.tab = "Tab", e.table = "Table", e.tabs = "Tabs", e.text = "Text", e.watcher = "Watcher", e))(We || {});
class zC {
  constructor(n) {
    N(this, "type");
    N(this, "confirmationText");
    N(this, "scopeLat");
    N(this, "scopeLng");
    N(this, "readonly");
    N(this, "conditions");
    N(this, "logicalCondition");
    var t;
    this.type = _o.mapSelect, this.confirmationText = new Ye(n == null ? void 0 : n.confirmationText), this.scopeLat = (n == null ? void 0 : n.scopeLat) || "", this.scopeLng = (n == null ? void 0 : n.scopeLng) || "", this.readonly = n == null ? void 0 : n.readonly, this.conditions = (t = n == null ? void 0 : n.conditions) == null ? void 0 : t.map((a) => new Ss(a)), this.logicalCondition = n == null ? void 0 : n.logicalCondition;
  }
}
class BC {
  constructor(n) {
    N(this, "type");
    N(this, "label");
    N(this, "readonly");
    N(this, "align");
    N(this, "conditions");
    N(this, "logicalCondition");
    var t;
    this.type = _o.submit, this.label = new Ye(n == null ? void 0 : n.label), this.readonly = n == null ? void 0 : n.readonly, this.align = (n == null ? void 0 : n.align) || Qm.left, this.conditions = (t = n == null ? void 0 : n.conditions) == null ? void 0 : t.map((a) => new Ss(a)), this.logicalCondition = n == null ? void 0 : n.logicalCondition;
  }
}
class cn {
  constructor(n) {
    N(this, "label");
    N(this, "readonly");
    N(this, "rules");
    N(this, "conditions");
    N(this, "logicalCondition");
    var t;
    this.label = new Ye(n == null ? void 0 : n.label), this.readonly = n == null ? void 0 : n.readonly, this.rules = n == null ? void 0 : n.rules, this.conditions = (t = n == null ? void 0 : n.conditions) == null ? void 0 : t.map((a) => new Ss(a)), this.logicalCondition = n == null ? void 0 : n.logicalCondition;
  }
}
class FC extends cn {
  constructor(t) {
    super({
      label: t == null ? void 0 : t.label,
      readonly: t == null ? void 0 : t.readonly,
      rules: t == null ? void 0 : t.rules,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    N(this, "placeholder");
    N(this, "value");
    this.type = ye.arrayStrings, this.placeholder = new Ye(t == null ? void 0 : t.placeholder), this.value = t == null ? void 0 : t.value;
  }
}
class UC extends cn {
  constructor(t) {
    super({
      label: t == null ? void 0 : t.label,
      readonly: t == null ? void 0 : t.readonly,
      rules: t == null ? void 0 : t.rules,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    N(this, "value");
    this.type = ye.checkbox, this.value = t == null ? void 0 : t.value;
  }
}
class VC extends cn {
  constructor(t) {
    super({
      label: t == null ? void 0 : t.label,
      readonly: t == null ? void 0 : t.readonly,
      rules: t == null ? void 0 : t.rules,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    N(this, "placeholder");
    N(this, "startPlaceholder");
    N(this, "endPlaceholder");
    N(this, "value");
    N(this, "picker");
    N(this, "format");
    N(this, "fullWidth");
    this.type = ye.date, this.placeholder = new Ye(t == null ? void 0 : t.placeholder), this.startPlaceholder = new Ye(t == null ? void 0 : t.startPlaceholder), this.endPlaceholder = new Ye(t == null ? void 0 : t.endPlaceholder), this.value = t == null ? void 0 : t.value, this.picker = t == null ? void 0 : t.picker, this.format = t == null ? void 0 : t.format, this.fullWidth = (t == null ? void 0 : t.fullWidth) || !1;
  }
}
class HC extends cn {
  constructor(t) {
    super({
      label: t == null ? void 0 : t.label,
      readonly: t == null ? void 0 : t.readonly,
      rules: t == null ? void 0 : t.rules,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    N(this, "value");
    this.type = ye.editor, this.value = t == null ? void 0 : t.value;
  }
}
class jC extends cn {
  constructor(t) {
    super({
      label: t == null ? void 0 : t.label,
      readonly: t == null ? void 0 : t.readonly,
      rules: t == null ? void 0 : t.rules,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    N(this, "value");
    N(this, "polygon");
    N(this, "rectangle");
    this.type = ye.mapDraw, this.value = t == null ? void 0 : t.value, this.polygon = t == null ? void 0 : t.polygon, this.rectangle = t == null ? void 0 : t.rectangle;
  }
}
class ZC extends cn {
  constructor(t) {
    super({
      label: t == null ? void 0 : t.label,
      readonly: t == null ? void 0 : t.readonly,
      rules: t == null ? void 0 : t.rules,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    N(this, "placeholder");
    N(this, "value");
    N(this, "min");
    N(this, "max");
    N(this, "hideControls");
    this.type = ye.number, this.placeholder = new Ye(t == null ? void 0 : t.placeholder), this.value = t == null ? void 0 : t.value, this.min = t == null ? void 0 : t.min, this.max = t == null ? void 0 : t.max, this.hideControls = t == null ? void 0 : t.hideControls;
  }
}
class WC extends cn {
  constructor(t) {
    var a;
    super({
      label: t == null ? void 0 : t.label,
      readonly: t == null ? void 0 : t.readonly,
      rules: t == null ? void 0 : t.rules,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    N(this, "value");
    N(this, "enum");
    this.type = ye.radio, this.value = t == null ? void 0 : t.value, this.enum = ((a = t == null ? void 0 : t.enum) == null ? void 0 : a.map((u) => new cu(u))) || [new cu({ text: new Ye(), value: "" })];
  }
}
class GC extends cn {
  constructor(t) {
    var a;
    super({
      label: t == null ? void 0 : t.label,
      readonly: t == null ? void 0 : t.readonly,
      rules: t == null ? void 0 : t.rules,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    N(this, "placeholder");
    N(this, "multiple");
    N(this, "clearable");
    N(this, "value");
    N(this, "enum");
    this.type = ye.select, this.placeholder = new Ye(t == null ? void 0 : t.placeholder), this.multiple = t == null ? void 0 : t.multiple, this.clearable = t == null ? void 0 : t.clearable, this.value = t == null ? void 0 : t.value, this.enum = (a = t == null ? void 0 : t.enum) == null ? void 0 : a.map((u) => new cu(u));
  }
}
class qC extends cn {
  constructor(t) {
    super({
      label: t == null ? void 0 : t.label,
      readonly: t == null ? void 0 : t.readonly,
      rules: t == null ? void 0 : t.rules,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    N(this, "placeholder");
    N(this, "text");
    N(this, "multiple");
    N(this, "clearable");
    N(this, "value");
    N(this, "url");
    this.type = ye.selectRemote, this.placeholder = new Ye(t == null ? void 0 : t.placeholder), this.text = new Ye(t == null ? void 0 : t.text), this.multiple = t == null ? void 0 : t.multiple, this.clearable = t == null ? void 0 : t.clearable, this.value = t == null ? void 0 : t.value, this.url = (t == null ? void 0 : t.url) || "";
  }
}
class KC extends cn {
  constructor(t) {
    var a;
    super({
      label: t == null ? void 0 : t.label,
      readonly: t == null ? void 0 : t.readonly,
      rules: t == null ? void 0 : t.rules,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    N(this, "placeholder");
    N(this, "multiple");
    N(this, "clearable");
    N(this, "value");
    N(this, "enum");
    this.type = ye.selectSearch, this.placeholder = new Ye(t == null ? void 0 : t.placeholder), this.multiple = t == null ? void 0 : t.multiple, this.clearable = t == null ? void 0 : t.clearable, this.value = t == null ? void 0 : t.value, this.enum = (a = t == null ? void 0 : t.enum) == null ? void 0 : a.map((u) => new cu(u));
  }
}
class YC extends cn {
  constructor(t) {
    var a;
    super({
      label: t == null ? void 0 : t.label,
      readonly: t == null ? void 0 : t.readonly,
      rules: t == null ? void 0 : t.rules,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    N(this, "placeholder");
    N(this, "multiple");
    N(this, "checkStrictly");
    N(this, "clearable");
    N(this, "value");
    N(this, "tree");
    this.type = ye.selectTree, this.placeholder = new Ye(t == null ? void 0 : t.placeholder), this.multiple = t == null ? void 0 : t.multiple, this.checkStrictly = t == null ? void 0 : t.checkStrictly, this.clearable = t == null ? void 0 : t.clearable, this.value = t == null ? void 0 : t.value, this.tree = ((a = t == null ? void 0 : t.tree) == null ? void 0 : a.map((u) => new ff(u))) || [];
  }
}
class QC extends cn {
  constructor(t) {
    super({
      label: t == null ? void 0 : t.label,
      readonly: t == null ? void 0 : t.readonly,
      rules: t == null ? void 0 : t.rules,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    N(this, "placeholder");
    N(this, "value");
    N(this, "maxlength");
    this.type = ye.string, this.placeholder = new Ye(t == null ? void 0 : t.placeholder), this.value = t == null ? void 0 : t.value, this.maxlength = t == null ? void 0 : t.maxlength;
  }
}
class JC extends cn {
  constructor(t) {
    super({
      label: t == null ? void 0 : t.label,
      readonly: t == null ? void 0 : t.readonly,
      rules: t == null ? void 0 : t.rules,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    N(this, "value");
    this.type = ye.switch, this.value = t == null ? void 0 : t.value;
  }
}
class XC extends cn {
  constructor(t) {
    super({
      label: t == null ? void 0 : t.label,
      readonly: t == null ? void 0 : t.readonly,
      rules: t == null ? void 0 : t.rules,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    N(this, "placeholder");
    N(this, "value");
    N(this, "maxlength");
    this.type = ye.textarea, this.placeholder = new Ye(t == null ? void 0 : t.placeholder), this.value = t == null ? void 0 : t.value, this.maxlength = t == null ? void 0 : t.maxlength;
  }
}
class e1 extends cn {
  constructor(t) {
    super({
      label: t == null ? void 0 : t.label,
      readonly: t == null ? void 0 : t.readonly,
      rules: t == null ? void 0 : t.rules,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    N(this, "placeholder");
    N(this, "startPlaceholder");
    N(this, "endPlaceholder");
    N(this, "value");
    N(this, "format");
    N(this, "range");
    this.type = ye.time, this.placeholder = new Ye(t == null ? void 0 : t.placeholder), this.startPlaceholder = new Ye(t == null ? void 0 : t.startPlaceholder), this.endPlaceholder = new Ye(t == null ? void 0 : t.endPlaceholder), this.value = t == null ? void 0 : t.value, this.format = t == null ? void 0 : t.format, this.range = t == null ? void 0 : t.range;
  }
}
class qm {
  constructor(n) {
    N(this, "conditions");
    N(this, "logicalCondition");
    this.conditions = n == null ? void 0 : n.conditions, this.logicalCondition = n == null ? void 0 : n.logicalCondition;
  }
}
class t1 extends qm {
  constructor(t) {
    super({
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    this.type = Ar.horizontal;
  }
}
class Km extends qm {
  constructor(t) {
    super({
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    this.type = Ar.vertical;
  }
}
class n1 {
  constructor(n) {
    N(this, "label");
    N(this, "readonly");
    N(this, "columns");
    N(this, "value");
    N(this, "dialogTitle");
    N(this, "dialogConfirmation");
    N(this, "dialogWidth");
    N(this, "dialogElements");
    N(this, "rules");
    N(this, "conditions");
    N(this, "logicalCondition");
    var t, a, u;
    this.label = new Ye(n == null ? void 0 : n.label), this.readonly = n == null ? void 0 : n.readonly, this.columns = ((t = n == null ? void 0 : n.columns) == null ? void 0 : t.map((f) => new f1(f))) || [], this.value = (n == null ? void 0 : n.value) || [], this.dialogTitle = new Ye(n == null ? void 0 : n.dialogTitle), this.dialogConfirmation = new Ye(n == null ? void 0 : n.dialogConfirmation), this.dialogWidth = n == null ? void 0 : n.dialogWidth, this.dialogElements = ((a = n == null ? void 0 : n.dialogElements) == null ? void 0 : a.map((f) => cf(f))) || [], this.rules = n == null ? void 0 : n.rules, this.conditions = (u = n == null ? void 0 : n.conditions) == null ? void 0 : u.map((f) => new Ss(f)), this.logicalCondition = n == null ? void 0 : n.logicalCondition;
  }
}
class i1 {
  constructor(n) {
    N(this, "conditions");
    N(this, "logicalCondition");
    var t;
    this.conditions = (t = n == null ? void 0 : n.conditions) == null ? void 0 : t.map((a) => new Ss(a)), this.logicalCondition = n == null ? void 0 : n.logicalCondition;
  }
}
class Tu {
  constructor(n) {
    N(this, "text");
    N(this, "conditions");
    N(this, "logicalCondition");
    var t;
    this.text = new Ye(n == null ? void 0 : n.text), this.conditions = (t = n == null ? void 0 : n.conditions) == null ? void 0 : t.map((a) => new Ss(a)), this.logicalCondition = n == null ? void 0 : n.logicalCondition;
  }
}
class r1 extends Tu {
  constructor(t) {
    super({
      text: t == null ? void 0 : t.text,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    this.type = Nn.alert;
  }
}
class o1 extends Tu {
  constructor(t) {
    super({
      text: t == null ? void 0 : t.text,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    this.type = Nn.description;
  }
}
class s1 extends Tu {
  constructor(t) {
    super({
      text: t == null ? void 0 : t.text,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    this.type = Nn.headline;
  }
}
class a1 extends Tu {
  constructor(t) {
    super({
      text: t == null ? void 0 : t.text,
      conditions: t == null ? void 0 : t.conditions,
      logicalCondition: t == null ? void 0 : t.logicalCondition
    });
    N(this, "type");
    this.type = Nn.label;
  }
}
class l1 {
  constructor(n) {
    N(this, "watchingScope");
    N(this, "responseScope");
    N(this, "url");
    N(this, "queryKey");
    this.watchingScope = (n == null ? void 0 : n.watchingScope) || "", this.responseScope = (n == null ? void 0 : n.responseScope) || "", this.url = (n == null ? void 0 : n.url) || "", this.queryKey = (n == null ? void 0 : n.queryKey) || "";
  }
}
var _o = /* @__PURE__ */ ((e) => (e.mapSelect = "MapSelect", e.submit = "Submit", e))(_o || {}), ye = /* @__PURE__ */ ((e) => (e.arrayStrings = "ArrayStrings", e.checkbox = "Checkbox", e.date = "Date", e.editor = "Editor", e.mapDraw = "MapDraw", e.number = "Number", e.radio = "Radio", e.select = "Select", e.selectRemote = "SelectRemote", e.selectSearch = "SelectSearch", e.selectTree = "SelectTree", e.string = "String", e.switch = "Switch", e.textarea = "Textarea", e.time = "Time", e))(ye || {}), Ar = /* @__PURE__ */ ((e) => (e.horizontal = "Horizontal", e.vertical = "Vertical", e))(Ar || {}), Nn = /* @__PURE__ */ ((e) => (e.alert = "Alert", e.description = "Description", e.headline = "Headline", e.label = "Label", e))(Nn || {}), Ym = /* @__PURE__ */ ((e) => (e.and = "and", e.or = "or", e))(Ym || {}), u1 = /* @__PURE__ */ ((e) => (e.year = "year", e.month = "month", e.date = "date", e.dates = "dates", e.datetime = "datetime", e.week = "week", e.datetimerange = "datetimerange", e.daterange = "daterange", e.monthrange = "monthrange", e))(u1 || {}), Qm = /* @__PURE__ */ ((e) => (e.left = "left", e.center = "center", e.right = "right", e))(Qm || {}), c1 = /* @__PURE__ */ ((e) => (e.any = "any", e.array = "array", e.boolean = "boolean", e.date = "date", e.email = "email", e.enum = "enum", e.float = "float", e.hex = "hex", e.integer = "integer", e.method = "method", e.number = "number", e.object = "object", e.regexp = "regexp", e.string = "string", e.url = "url", e))(c1 || {}), h1 = /* @__PURE__ */ ((e) => (e.blur = "blur", e.change = "change", e))(h1 || {});
class f1 {
  constructor(n) {
    N(this, "prop");
    N(this, "label");
    N(this, "sortable");
    N(this, "width");
    N(this, "minWidth");
    N(this, "align");
    this.prop = (n == null ? void 0 : n.prop) || "", this.label = new Ye(n == null ? void 0 : n.label), this.sortable = n == null ? void 0 : n.sortable, this.width = n == null ? void 0 : n.width, this.minWidth = n == null ? void 0 : n.minWidth, this.align = n == null ? void 0 : n.align;
  }
}
class cu {
  constructor(n) {
    N(this, "text");
    N(this, "value");
    this.text = new Ye(n == null ? void 0 : n.text), this.value = (n == null ? void 0 : n.value) || "";
  }
}
class MR {
  constructor(n) {
    N(this, "type");
    N(this, "required");
    N(this, "message");
    N(this, "pattern");
    N(this, "min");
    N(this, "max");
    N(this, "len");
    N(this, "trigger");
    this.required = n == null ? void 0 : n.required, this.message = new Ye(n == null ? void 0 : n.message), this.type = n == null ? void 0 : n.type, this.pattern = n == null ? void 0 : n.pattern, this.min = n == null ? void 0 : n.min, this.max = n == null ? void 0 : n.max, this.len = n == null ? void 0 : n.len, this.trigger = n == null ? void 0 : n.trigger;
  }
}
class ff {
  constructor(n) {
    N(this, "id");
    N(this, "text");
    N(this, "value");
    N(this, "children");
    var t;
    this.id = (n == null ? void 0 : n.id) || Wm(), this.text = new Ye(n == null ? void 0 : n.text), this.value = (n == null ? void 0 : n.value) || "", this.children = (t = n == null ? void 0 : n.children) == null ? void 0 : t.map((a) => new ff(a));
  }
}
class TR {
  constructor(n) {
    N(this, "headline");
    N(this, "description");
    N(this, "schema");
    this.headline = new Ye(n == null ? void 0 : n.headline), this.description = new Ye(n == null ? void 0 : n.description), this.schema = new hf((n == null ? void 0 : n.schema) || {
      properties: new Km()
    });
  }
}
class ER {
  constructor({ success: n, answers: t, message: a }) {
    N(this, "success");
    N(this, "answers");
    N(this, "message");
    this.success = n, this.answers = t, this.message = new Ye(a);
  }
}
const Cs = oe({
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    schema: {
      type: Object,
      required: !0
    },
    locale: {
      type: String,
      required: !0
    },
    readonly: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    isShown() {
      var e, n;
      if (((n = (e = this.schema.properties) == null ? void 0 : e.conditions) == null ? void 0 : n.length) > 0) {
        const { conditions: t, logicalCondition: a } = this.schema.properties;
        return a === Ym.and ? t.every(this.checkOperator) : t.some(this.checkOperator);
      }
      return !0;
    }
  },
  methods: {
    checkOperator({ scope: e, operator: n, value: t }) {
      return n ? n === Ea.equal ? ke.get(this.modelValue, e) === t : n === Ea.notEqual ? ke.get(this.modelValue, e) !== t : ke.isNumber(t) && n === Ea.less ? ke.get(this.modelValue, e) < t : ke.isNumber(t) && n === Ea.greater ? ke.get(this.modelValue, e) > t : null : !!ke.get(this.modelValue, e);
    }
  }
}), d1 = "_component_1ezca_1", p1 = "_component__slot_1ezca_12", m1 = {
  component: d1,
  component__slot: p1
}, _1 = {};
function g1(e, n) {
  return V(), ue("div", {
    class: J(e.$style.component)
  }, [
    Ke(e.$slots, "default", {
      className: e.$style.component__slot
    })
  ], 2);
}
const v1 = {
  $style: m1
}, y1 = /* @__PURE__ */ ce(_1, [["render", g1], ["__cssModules", v1]]), b1 = "_component_1lm9k_1", w1 = {
  component: b1
}, L1 = {};
function S1(e, n) {
  return V(), ue("div", {
    class: J(e.$style.component)
  }, [
    Ke(e.$slots, "default", { className: null })
  ], 2);
}
const C1 = {
  $style: w1
}, M1 = /* @__PURE__ */ ce(L1, [["render", S1], ["__cssModules", C1]]);
var Wl = { exports: {} };
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */
var Cp;
function Jm() {
  return Cp || (Cp = 1, function(e, n) {
    (function(t, a) {
      a(n);
    })(as, function(t) {
      var a = "1.9.4";
      function u(i) {
        var o, l, p, v;
        for (l = 1, p = arguments.length; l < p; l++) {
          v = arguments[l];
          for (o in v)
            i[o] = v[o];
        }
        return i;
      }
      var f = Object.create || function() {
        function i() {
        }
        return function(o) {
          return i.prototype = o, new i();
        };
      }();
      function d(i, o) {
        var l = Array.prototype.slice;
        if (i.bind)
          return i.bind.apply(i, l.call(arguments, 1));
        var p = l.call(arguments, 2);
        return function() {
          return i.apply(o, p.length ? p.concat(l.call(arguments)) : arguments);
        };
      }
      var m = 0;
      function g(i) {
        return "_leaflet_id" in i || (i._leaflet_id = ++m), i._leaflet_id;
      }
      function y(i, o, l) {
        var p, v, C, O;
        return O = function() {
          p = !1, v && (C.apply(l, v), v = !1);
        }, C = function() {
          p ? v = arguments : (i.apply(l, arguments), setTimeout(O, o), p = !0);
        }, C;
      }
      function w(i, o, l) {
        var p = o[1], v = o[0], C = p - v;
        return i === p && l ? i : ((i - v) % C + C) % C + v;
      }
      function h() {
        return !1;
      }
      function b(i, o) {
        if (o === !1)
          return i;
        var l = Math.pow(10, o === void 0 ? 6 : o);
        return Math.round(i * l) / l;
      }
      function T(i) {
        return i.trim ? i.trim() : i.replace(/^\s+|\s+$/g, "");
      }
      function A(i) {
        return T(i).split(/\s+/);
      }
      function x(i, o) {
        Object.prototype.hasOwnProperty.call(i, "options") || (i.options = i.options ? f(i.options) : {});
        for (var l in o)
          i.options[l] = o[l];
        return i.options;
      }
      function Z(i, o, l) {
        var p = [];
        for (var v in i)
          p.push(encodeURIComponent(l ? v.toUpperCase() : v) + "=" + encodeURIComponent(i[v]));
        return (!o || o.indexOf("?") === -1 ? "?" : "&") + p.join("&");
      }
      var H = /\{ *([\w_ -]+) *\}/g;
      function Y(i, o) {
        return i.replace(H, function(l, p) {
          var v = o[p];
          if (v === void 0)
            throw new Error("No value provided for variable " + l);
          return typeof v == "function" && (v = v(o)), v;
        });
      }
      var ee = Array.isArray || function(i) {
        return Object.prototype.toString.call(i) === "[object Array]";
      };
      function re(i, o) {
        for (var l = 0; l < i.length; l++)
          if (i[l] === o)
            return l;
        return -1;
      }
      var be = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
      function Xe(i) {
        return window["webkit" + i] || window["moz" + i] || window["ms" + i];
      }
      var Fe = 0;
      function ge(i) {
        var o = +/* @__PURE__ */ new Date(), l = Math.max(0, 16 - (o - Fe));
        return Fe = o + l, window.setTimeout(i, l);
      }
      var qe = window.requestAnimationFrame || Xe("RequestAnimationFrame") || ge, at = window.cancelAnimationFrame || Xe("CancelAnimationFrame") || Xe("CancelRequestAnimationFrame") || function(i) {
        window.clearTimeout(i);
      };
      function _t(i, o, l) {
        if (l && qe === ge)
          i.call(o);
        else
          return qe.call(window, d(i, o));
      }
      function nt(i) {
        i && at.call(window, i);
      }
      var wn = {
        __proto__: null,
        extend: u,
        create: f,
        bind: d,
        get lastId() {
          return m;
        },
        stamp: g,
        throttle: y,
        wrapNum: w,
        falseFn: h,
        formatNum: b,
        trim: T,
        splitWords: A,
        setOptions: x,
        getParamString: Z,
        template: Y,
        isArray: ee,
        indexOf: re,
        emptyImageUrl: be,
        requestFn: qe,
        cancelFn: at,
        requestAnimFrame: _t,
        cancelAnimFrame: nt
      };
      function At() {
      }
      At.extend = function(i) {
        var o = function() {
          x(this), this.initialize && this.initialize.apply(this, arguments), this.callInitHooks();
        }, l = o.__super__ = this.prototype, p = f(l);
        p.constructor = o, o.prototype = p;
        for (var v in this)
          Object.prototype.hasOwnProperty.call(this, v) && v !== "prototype" && v !== "__super__" && (o[v] = this[v]);
        return i.statics && u(o, i.statics), i.includes && (Ki(i.includes), u.apply(null, [p].concat(i.includes))), u(p, i), delete p.statics, delete p.includes, p.options && (p.options = l.options ? f(l.options) : {}, u(p.options, i.options)), p._initHooks = [], p.callInitHooks = function() {
          if (!this._initHooksCalled) {
            l.callInitHooks && l.callInitHooks.call(this), this._initHooksCalled = !0;
            for (var C = 0, O = p._initHooks.length; C < O; C++)
              p._initHooks[C].call(this);
          }
        }, o;
      }, At.include = function(i) {
        var o = this.prototype.options;
        return u(this.prototype, i), i.options && (this.prototype.options = o, this.mergeOptions(i.options)), this;
      }, At.mergeOptions = function(i) {
        return u(this.prototype.options, i), this;
      }, At.addInitHook = function(i) {
        var o = Array.prototype.slice.call(arguments, 1), l = typeof i == "function" ? i : function() {
          this[i].apply(this, o);
        };
        return this.prototype._initHooks = this.prototype._initHooks || [], this.prototype._initHooks.push(l), this;
      };
      function Ki(i) {
        if (!(typeof L > "u" || !L || !L.Mixin)) {
          i = ee(i) ? i : [i];
          for (var o = 0; o < i.length; o++)
            i[o] === L.Mixin.Events && console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
        }
      }
      var gt = {
        /* @method on(type: String, fn: Function, context?: Object): this
         * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
         *
         * @alternative
         * @method on(eventMap: Object): this
         * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
         */
        on: function(i, o, l) {
          if (typeof i == "object")
            for (var p in i)
              this._on(p, i[p], o);
          else {
            i = A(i);
            for (var v = 0, C = i.length; v < C; v++)
              this._on(i[v], o, l);
          }
          return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
         * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
         *
         * @alternative
         * @method off(eventMap: Object): this
         * Removes a set of type/listener pairs.
         *
         * @alternative
         * @method off: this
         * Removes all listeners to all events on the object. This includes implicitly attached events.
         */
        off: function(i, o, l) {
          if (!arguments.length)
            delete this._events;
          else if (typeof i == "object")
            for (var p in i)
              this._off(p, i[p], o);
          else {
            i = A(i);
            for (var v = arguments.length === 1, C = 0, O = i.length; C < O; C++)
              v ? this._off(i[C]) : this._off(i[C], o, l);
          }
          return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(i, o, l, p) {
          if (typeof o != "function") {
            console.warn("wrong listener type: " + typeof o);
            return;
          }
          if (this._listens(i, o, l) === !1) {
            l === this && (l = void 0);
            var v = { fn: o, ctx: l };
            p && (v.once = !0), this._events = this._events || {}, this._events[i] = this._events[i] || [], this._events[i].push(v);
          }
        },
        _off: function(i, o, l) {
          var p, v, C;
          if (this._events && (p = this._events[i], !!p)) {
            if (arguments.length === 1) {
              if (this._firingCount)
                for (v = 0, C = p.length; v < C; v++)
                  p[v].fn = h;
              delete this._events[i];
              return;
            }
            if (typeof o != "function") {
              console.warn("wrong listener type: " + typeof o);
              return;
            }
            var O = this._listens(i, o, l);
            if (O !== !1) {
              var B = p[O];
              this._firingCount && (B.fn = h, this._events[i] = p = p.slice()), p.splice(O, 1);
            }
          }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(i, o, l) {
          if (!this.listens(i, l))
            return this;
          var p = u({}, o, {
            type: i,
            target: this,
            sourceTarget: o && o.sourceTarget || this
          });
          if (this._events) {
            var v = this._events[i];
            if (v) {
              this._firingCount = this._firingCount + 1 || 1;
              for (var C = 0, O = v.length; C < O; C++) {
                var B = v[C], F = B.fn;
                B.once && this.off(i, F, B.ctx), F.call(B.ctx || this, p);
              }
              this._firingCount--;
            }
          }
          return l && this._propagateEvent(p), this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(i, o, l, p) {
          typeof i != "string" && console.warn('"string" type argument expected');
          var v = o;
          typeof o != "function" && (p = !!o, v = void 0, l = void 0);
          var C = this._events && this._events[i];
          if (C && C.length && this._listens(i, v, l) !== !1)
            return !0;
          if (p) {
            for (var O in this._eventParents)
              if (this._eventParents[O].listens(i, o, l, p))
                return !0;
          }
          return !1;
        },
        // returns the index (number) or false
        _listens: function(i, o, l) {
          if (!this._events)
            return !1;
          var p = this._events[i] || [];
          if (!o)
            return !!p.length;
          l === this && (l = void 0);
          for (var v = 0, C = p.length; v < C; v++)
            if (p[v].fn === o && p[v].ctx === l)
              return v;
          return !1;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(i, o, l) {
          if (typeof i == "object")
            for (var p in i)
              this._on(p, i[p], o, !0);
          else {
            i = A(i);
            for (var v = 0, C = i.length; v < C; v++)
              this._on(i[v], o, l, !0);
          }
          return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(i) {
          return this._eventParents = this._eventParents || {}, this._eventParents[g(i)] = i, this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(i) {
          return this._eventParents && delete this._eventParents[g(i)], this;
        },
        _propagateEvent: function(i) {
          for (var o in this._eventParents)
            this._eventParents[o].fire(i.type, u({
              layer: i.target,
              propagatedFrom: i.target
            }, i), !0);
        }
      };
      gt.addEventListener = gt.on, gt.removeEventListener = gt.clearAllEventListeners = gt.off, gt.addOneTimeEventListener = gt.once, gt.fireEvent = gt.fire, gt.hasEventListeners = gt.listens;
      var Ln = At.extend(gt);
      function fe(i, o, l) {
        this.x = l ? Math.round(i) : i, this.y = l ? Math.round(o) : o;
      }
      var Fa = Math.trunc || function(i) {
        return i > 0 ? Math.floor(i) : Math.ceil(i);
      };
      fe.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
          return new fe(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(i) {
          return this.clone()._add(_e(i));
        },
        _add: function(i) {
          return this.x += i.x, this.y += i.y, this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(i) {
          return this.clone()._subtract(_e(i));
        },
        _subtract: function(i) {
          return this.x -= i.x, this.y -= i.y, this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(i) {
          return this.clone()._divideBy(i);
        },
        _divideBy: function(i) {
          return this.x /= i, this.y /= i, this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(i) {
          return this.clone()._multiplyBy(i);
        },
        _multiplyBy: function(i) {
          return this.x *= i, this.y *= i, this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(i) {
          return new fe(this.x * i.x, this.y * i.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(i) {
          return new fe(this.x / i.x, this.y / i.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
          return this.clone()._round();
        },
        _round: function() {
          return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
          return this.clone()._floor();
        },
        _floor: function() {
          return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
          return this.clone()._ceil();
        },
        _ceil: function() {
          return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
          return this.clone()._trunc();
        },
        _trunc: function() {
          return this.x = Fa(this.x), this.y = Fa(this.y), this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(i) {
          i = _e(i);
          var o = i.x - this.x, l = i.y - this.y;
          return Math.sqrt(o * o + l * l);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(i) {
          return i = _e(i), i.x === this.x && i.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(i) {
          return i = _e(i), Math.abs(i.x) <= Math.abs(this.x) && Math.abs(i.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
          return "Point(" + b(this.x) + ", " + b(this.y) + ")";
        }
      };
      function _e(i, o, l) {
        return i instanceof fe ? i : ee(i) ? new fe(i[0], i[1]) : i == null ? i : typeof i == "object" && "x" in i && "y" in i ? new fe(i.x, i.y) : new fe(i, o, l);
      }
      function Ue(i, o) {
        if (i)
          for (var l = o ? [i, o] : i, p = 0, v = l.length; p < v; p++)
            this.extend(l[p]);
      }
      Ue.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(i) {
          var o, l;
          if (!i)
            return this;
          if (i instanceof fe || typeof i[0] == "number" || "x" in i)
            o = l = _e(i);
          else if (i = Ht(i), o = i.min, l = i.max, !o || !l)
            return this;
          return !this.min && !this.max ? (this.min = o.clone(), this.max = l.clone()) : (this.min.x = Math.min(o.x, this.min.x), this.max.x = Math.max(l.x, this.max.x), this.min.y = Math.min(o.y, this.min.y), this.max.y = Math.max(l.y, this.max.y)), this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(i) {
          return _e(
            (this.min.x + this.max.x) / 2,
            (this.min.y + this.max.y) / 2,
            i
          );
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
          return _e(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
          return _e(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
          return this.min;
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
          return this.max;
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
          return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(i) {
          var o, l;
          return typeof i[0] == "number" || i instanceof fe ? i = _e(i) : i = Ht(i), i instanceof Ue ? (o = i.min, l = i.max) : o = l = i, o.x >= this.min.x && l.x <= this.max.x && o.y >= this.min.y && l.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(i) {
          i = Ht(i);
          var o = this.min, l = this.max, p = i.min, v = i.max, C = v.x >= o.x && p.x <= l.x, O = v.y >= o.y && p.y <= l.y;
          return C && O;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(i) {
          i = Ht(i);
          var o = this.min, l = this.max, p = i.min, v = i.max, C = v.x > o.x && p.x < l.x, O = v.y > o.y && p.y < l.y;
          return C && O;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
          return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(i) {
          var o = this.min, l = this.max, p = Math.abs(o.x - l.x) * i, v = Math.abs(o.y - l.y) * i;
          return Ht(
            _e(o.x - p, o.y - v),
            _e(l.x + p, l.y + v)
          );
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(i) {
          return i ? (i = Ht(i), this.min.equals(i.getTopLeft()) && this.max.equals(i.getBottomRight())) : !1;
        }
      };
      function Ht(i, o) {
        return !i || i instanceof Ue ? i : new Ue(i, o);
      }
      function jt(i, o) {
        if (i)
          for (var l = o ? [i, o] : i, p = 0, v = l.length; p < v; p++)
            this.extend(l[p]);
      }
      jt.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(i) {
          var o = this._southWest, l = this._northEast, p, v;
          if (i instanceof Re)
            p = i, v = i;
          else if (i instanceof jt) {
            if (p = i._southWest, v = i._northEast, !p || !v)
              return this;
          } else
            return i ? this.extend(Pe(i) || vt(i)) : this;
          return !o && !l ? (this._southWest = new Re(p.lat, p.lng), this._northEast = new Re(v.lat, v.lng)) : (o.lat = Math.min(p.lat, o.lat), o.lng = Math.min(p.lng, o.lng), l.lat = Math.max(v.lat, l.lat), l.lng = Math.max(v.lng, l.lng)), this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(i) {
          var o = this._southWest, l = this._northEast, p = Math.abs(o.lat - l.lat) * i, v = Math.abs(o.lng - l.lng) * i;
          return new jt(
            new Re(o.lat - p, o.lng - v),
            new Re(l.lat + p, l.lng + v)
          );
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
          return new Re(
            (this._southWest.lat + this._northEast.lat) / 2,
            (this._southWest.lng + this._northEast.lng) / 2
          );
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
          return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
          return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
          return new Re(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
          return new Re(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
          return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
          return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
          return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
          return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(i) {
          typeof i[0] == "number" || i instanceof Re || "lat" in i ? i = Pe(i) : i = vt(i);
          var o = this._southWest, l = this._northEast, p, v;
          return i instanceof jt ? (p = i.getSouthWest(), v = i.getNorthEast()) : p = v = i, p.lat >= o.lat && v.lat <= l.lat && p.lng >= o.lng && v.lng <= l.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(i) {
          i = vt(i);
          var o = this._southWest, l = this._northEast, p = i.getSouthWest(), v = i.getNorthEast(), C = v.lat >= o.lat && p.lat <= l.lat, O = v.lng >= o.lng && p.lng <= l.lng;
          return C && O;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(i) {
          i = vt(i);
          var o = this._southWest, l = this._northEast, p = i.getSouthWest(), v = i.getNorthEast(), C = v.lat > o.lat && p.lat < l.lat, O = v.lng > o.lng && p.lng < l.lng;
          return C && O;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
          return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(",");
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(i, o) {
          return i ? (i = vt(i), this._southWest.equals(i.getSouthWest(), o) && this._northEast.equals(i.getNorthEast(), o)) : !1;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
          return !!(this._southWest && this._northEast);
        }
      };
      function vt(i, o) {
        return i instanceof jt ? i : new jt(i, o);
      }
      function Re(i, o, l) {
        if (isNaN(i) || isNaN(o))
          throw new Error("Invalid LatLng object: (" + i + ", " + o + ")");
        this.lat = +i, this.lng = +o, l !== void 0 && (this.alt = +l);
      }
      Re.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(i, o) {
          if (!i)
            return !1;
          i = Pe(i);
          var l = Math.max(
            Math.abs(this.lat - i.lat),
            Math.abs(this.lng - i.lng)
          );
          return l <= (o === void 0 ? 1e-9 : o);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(i) {
          return "LatLng(" + b(this.lat, i) + ", " + b(this.lng, i) + ")";
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(i) {
          return fn.distance(this, Pe(i));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
          return fn.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(i) {
          var o = 180 * i / 40075017, l = o / Math.cos(Math.PI / 180 * this.lat);
          return vt(
            [this.lat - o, this.lng - l],
            [this.lat + o, this.lng + l]
          );
        },
        clone: function() {
          return new Re(this.lat, this.lng, this.alt);
        }
      };
      function Pe(i, o, l) {
        return i instanceof Re ? i : ee(i) && typeof i[0] != "object" ? i.length === 3 ? new Re(i[0], i[1], i[2]) : i.length === 2 ? new Re(i[0], i[1]) : null : i == null ? i : typeof i == "object" && "lat" in i ? new Re(i.lat, "lng" in i ? i.lng : i.lon, i.alt) : o === void 0 ? null : new Re(i, o, l);
      }
      var Zn = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(i, o) {
          var l = this.projection.project(i), p = this.scale(o);
          return this.transformation._transform(l, p);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(i, o) {
          var l = this.scale(o), p = this.transformation.untransform(i, l);
          return this.projection.unproject(p);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(i) {
          return this.projection.project(i);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(i) {
          return this.projection.unproject(i);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(i) {
          return 256 * Math.pow(2, i);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(i) {
          return Math.log(i / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(i) {
          if (this.infinite)
            return null;
          var o = this.projection.bounds, l = this.scale(i), p = this.transformation.transform(o.min, l), v = this.transformation.transform(o.max, l);
          return new Ue(p, v);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: !1,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(i) {
          var o = this.wrapLng ? w(i.lng, this.wrapLng, !0) : i.lng, l = this.wrapLat ? w(i.lat, this.wrapLat, !0) : i.lat, p = i.alt;
          return new Re(l, o, p);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(i) {
          var o = i.getCenter(), l = this.wrapLatLng(o), p = o.lat - l.lat, v = o.lng - l.lng;
          if (p === 0 && v === 0)
            return i;
          var C = i.getSouthWest(), O = i.getNorthEast(), B = new Re(C.lat - p, C.lng - v), F = new Re(O.lat - p, O.lng - v);
          return new jt(B, F);
        }
      }, fn = u({}, Zn, {
        wrapLng: [-180, 180],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371e3,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(i, o) {
          var l = Math.PI / 180, p = i.lat * l, v = o.lat * l, C = Math.sin((o.lat - i.lat) * l / 2), O = Math.sin((o.lng - i.lng) * l / 2), B = C * C + Math.cos(p) * Math.cos(v) * O * O, F = 2 * Math.atan2(Math.sqrt(B), Math.sqrt(1 - B));
          return this.R * F;
        }
      }), Yi = 6378137, Ps = {
        R: Yi,
        MAX_LATITUDE: 85.0511287798,
        project: function(i) {
          var o = Math.PI / 180, l = this.MAX_LATITUDE, p = Math.max(Math.min(l, i.lat), -l), v = Math.sin(p * o);
          return new fe(
            this.R * i.lng * o,
            this.R * Math.log((1 + v) / (1 - v)) / 2
          );
        },
        unproject: function(i) {
          var o = 180 / Math.PI;
          return new Re(
            (2 * Math.atan(Math.exp(i.y / this.R)) - Math.PI / 2) * o,
            i.x * o / this.R
          );
        },
        bounds: function() {
          var i = Yi * Math.PI;
          return new Ue([-i, -i], [i, i]);
        }()
      };
      function Qi(i, o, l, p) {
        if (ee(i)) {
          this._a = i[0], this._b = i[1], this._c = i[2], this._d = i[3];
          return;
        }
        this._a = i, this._b = o, this._c = l, this._d = p;
      }
      Qi.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(i, o) {
          return this._transform(i.clone(), o);
        },
        // destructive transform (faster)
        _transform: function(i, o) {
          return o = o || 1, i.x = o * (this._a * i.x + this._b), i.y = o * (this._c * i.y + this._d), i;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(i, o) {
          return o = o || 1, new fe(
            (i.x / o - this._b) / this._a,
            (i.y / o - this._d) / this._c
          );
        }
      };
      function oi(i, o, l, p) {
        return new Qi(i, o, l, p);
      }
      var Co = u({}, fn, {
        code: "EPSG:3857",
        projection: Ps,
        transformation: function() {
          var i = 0.5 / (Math.PI * Ps.R);
          return oi(i, 0.5, -i, 0.5);
        }()
      }), Sn = u({}, Co, {
        code: "EPSG:900913"
      });
      function Ji(i) {
        return document.createElementNS("http://www.w3.org/2000/svg", i);
      }
      function Ua(i, o) {
        var l = "", p, v, C, O, B, F;
        for (p = 0, C = i.length; p < C; p++) {
          for (B = i[p], v = 0, O = B.length; v < O; v++)
            F = B[v], l += (v ? "L" : "M") + F.x + " " + F.y;
          l += o ? le.svg ? "z" : "x" : "";
        }
        return l || "M0 0";
      }
      var Cn = document.documentElement.style, Ir = "ActiveXObject" in window, Hu = Ir && !document.addEventListener, Xi = "msLaunchUri" in navigator && !("documentMode" in document), en = In("webkit"), er = In("android"), kr = In("android 2") || In("android 3"), ju = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10), Dr = er && In("Google") && ju < 537 && !("AudioNode" in window), xs = !!window.opera, tr = !Xi && In("chrome"), Ci = In("gecko") && !en && !xs && !Ir, Os = !tr && In("safari"), Mo = In("phantom"), To = "OTransition" in Cn, Ns = navigator.platform.indexOf("Win") === 0, Eo = Ir && "transition" in Cn, $r = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !kr, Ao = "MozPerspective" in Cn, Is = !window.L_DISABLE_3D && (Eo || $r || Ao) && !To && !Mo, Mi = typeof orientation < "u" || In("mobile"), Zu = Mi && en, Wu = Mi && $r, Va = !window.PointerEvent && window.MSPointerEvent, ks = !!(window.PointerEvent || Va), Ds = "ontouchstart" in window || !!window.TouchEvent, Gu = !window.L_NO_TOUCH && (Ds || ks), qu = Mi && xs, Ku = Mi && Ci, Yu = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1, Ha = function() {
        var i = !1;
        try {
          var o = Object.defineProperty({}, "passive", {
            get: function() {
              i = !0;
            }
          });
          window.addEventListener("testPassiveEventSupport", h, o), window.removeEventListener("testPassiveEventSupport", h, o);
        } catch {
        }
        return i;
      }(), Qu = function() {
        return !!document.createElement("canvas").getContext;
      }(), $s = !!(document.createElementNS && Ji("svg").createSVGRect), Ju = !!$s && function() {
        var i = document.createElement("div");
        return i.innerHTML = "<svg/>", (i.firstChild && i.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
      }(), Rs = !$s && function() {
        try {
          var i = document.createElement("div");
          i.innerHTML = '<v:shape adj="1"/>';
          var o = i.firstChild;
          return o.style.behavior = "url(#default#VML)", o && typeof o.adj == "object";
        } catch {
          return !1;
        }
      }(), Xu = navigator.platform.indexOf("Mac") === 0, zs = navigator.platform.indexOf("Linux") === 0;
      function In(i) {
        return navigator.userAgent.toLowerCase().indexOf(i) >= 0;
      }
      var le = {
        ie: Ir,
        ielt9: Hu,
        edge: Xi,
        webkit: en,
        android: er,
        android23: kr,
        androidStock: Dr,
        opera: xs,
        chrome: tr,
        gecko: Ci,
        safari: Os,
        phantom: Mo,
        opera12: To,
        win: Ns,
        ie3d: Eo,
        webkit3d: $r,
        gecko3d: Ao,
        any3d: Is,
        mobile: Mi,
        mobileWebkit: Zu,
        mobileWebkit3d: Wu,
        msPointer: Va,
        pointer: ks,
        touch: Gu,
        touchNative: Ds,
        mobileOpera: qu,
        mobileGecko: Ku,
        retina: Yu,
        passiveEvents: Ha,
        canvas: Qu,
        svg: $s,
        vml: Rs,
        inlineSvg: Ju,
        mac: Xu,
        linux: zs
      }, ja = le.msPointer ? "MSPointerDown" : "pointerdown", Za = le.msPointer ? "MSPointerMove" : "pointermove", Wa = le.msPointer ? "MSPointerUp" : "pointerup", Ga = le.msPointer ? "MSPointerCancel" : "pointercancel", Bs = {
        touchstart: ja,
        touchmove: Za,
        touchend: Wa,
        touchcancel: Ga
      }, qa = {
        touchstart: Oo,
        touchmove: xo,
        touchend: xo,
        touchcancel: xo
      }, Ti = {}, Ka = !1;
      function ec(i, o, l) {
        return o === "touchstart" && Po(), qa[o] ? (l = qa[o].bind(this, l), i.addEventListener(Bs[o], l, !1), l) : (console.warn("wrong event specified:", o), h);
      }
      function tc(i, o, l) {
        if (!Bs[o]) {
          console.warn("wrong event specified:", o);
          return;
        }
        i.removeEventListener(Bs[o], l, !1);
      }
      function nc(i) {
        Ti[i.pointerId] = i;
      }
      function ic(i) {
        Ti[i.pointerId] && (Ti[i.pointerId] = i);
      }
      function Ya(i) {
        delete Ti[i.pointerId];
      }
      function Po() {
        Ka || (document.addEventListener(ja, nc, !0), document.addEventListener(Za, ic, !0), document.addEventListener(Wa, Ya, !0), document.addEventListener(Ga, Ya, !0), Ka = !0);
      }
      function xo(i, o) {
        if (o.pointerType !== (o.MSPOINTER_TYPE_MOUSE || "mouse")) {
          o.touches = [];
          for (var l in Ti)
            o.touches.push(Ti[l]);
          o.changedTouches = [o], i(o);
        }
      }
      function Oo(i, o) {
        o.MSPOINTER_TYPE_TOUCH && o.pointerType === o.MSPOINTER_TYPE_TOUCH && Ce(o), xo(i, o);
      }
      function rc(i) {
        var o = {}, l, p;
        for (p in i)
          l = i[p], o[p] = l && l.bind ? l.bind(i) : l;
        return i = o, o.type = "dblclick", o.detail = 2, o.isTrusted = !1, o._simulated = !0, o;
      }
      var oc = 200;
      function sc(i, o) {
        i.addEventListener("dblclick", o);
        var l = 0, p;
        function v(C) {
          if (C.detail !== 1) {
            p = C.detail;
            return;
          }
          if (!(C.pointerType === "mouse" || C.sourceCapabilities && !C.sourceCapabilities.firesTouchEvents)) {
            var O = rl(C);
            if (!(O.some(function(F) {
              return F instanceof HTMLLabelElement && F.attributes.for;
            }) && !O.some(function(F) {
              return F instanceof HTMLInputElement || F instanceof HTMLSelectElement;
            }))) {
              var B = Date.now();
              B - l <= oc ? (p++, p === 2 && o(rc(C))) : p = 1, l = B;
            }
          }
        }
        return i.addEventListener("click", v), {
          dblclick: o,
          simDblclick: v
        };
      }
      function Qa(i, o) {
        i.removeEventListener("dblclick", o.dblclick), i.removeEventListener("click", o.simDblclick);
      }
      var No = ir(
        ["transform", "webkitTransform", "OTransform", "MozTransform", "msTransform"]
      ), nr = ir(
        ["webkitTransition", "transition", "OTransition", "MozTransition", "msTransition"]
      ), Ja = nr === "webkitTransition" || nr === "OTransition" ? nr + "End" : "transitionend";
      function Xa(i) {
        return typeof i == "string" ? document.getElementById(i) : i;
      }
      function Rr(i, o) {
        var l = i.style[o] || i.currentStyle && i.currentStyle[o];
        if ((!l || l === "auto") && document.defaultView) {
          var p = document.defaultView.getComputedStyle(i, null);
          l = p ? p[o] : null;
        }
        return l === "auto" ? null : l;
      }
      function Ve(i, o, l) {
        var p = document.createElement(i);
        return p.className = o || "", l && l.appendChild(p), p;
      }
      function it(i) {
        var o = i.parentNode;
        o && o.removeChild(i);
      }
      function zr(i) {
        for (; i.firstChild; )
          i.removeChild(i.firstChild);
      }
      function Ei(i) {
        var o = i.parentNode;
        o && o.lastChild !== i && o.appendChild(i);
      }
      function si(i) {
        var o = i.parentNode;
        o && o.firstChild !== i && o.insertBefore(i, o.firstChild);
      }
      function Fs(i, o) {
        if (i.classList !== void 0)
          return i.classList.contains(o);
        var l = ko(i);
        return l.length > 0 && new RegExp("(^|\\s)" + o + "(\\s|$)").test(l);
      }
      function Se(i, o) {
        if (i.classList !== void 0)
          for (var l = A(o), p = 0, v = l.length; p < v; p++)
            i.classList.add(l[p]);
        else if (!Fs(i, o)) {
          var C = ko(i);
          Io(i, (C ? C + " " : "") + o);
        }
      }
      function rt(i, o) {
        i.classList !== void 0 ? i.classList.remove(o) : Io(i, T((" " + ko(i) + " ").replace(" " + o + " ", " ")));
      }
      function Io(i, o) {
        i.className.baseVal === void 0 ? i.className = o : i.className.baseVal = o;
      }
      function ko(i) {
        return i.correspondingElement && (i = i.correspondingElement), i.className.baseVal === void 0 ? i.className : i.className.baseVal;
      }
      function tn(i, o) {
        "opacity" in i.style ? i.style.opacity = o : "filter" in i.style && el(i, o);
      }
      function el(i, o) {
        var l = !1, p = "DXImageTransform.Microsoft.Alpha";
        try {
          l = i.filters.item(p);
        } catch {
          if (o === 1)
            return;
        }
        o = Math.round(o * 100), l ? (l.Enabled = o !== 100, l.Opacity = o) : i.style.filter += " progid:" + p + "(opacity=" + o + ")";
      }
      function ir(i) {
        for (var o = document.documentElement.style, l = 0; l < i.length; l++)
          if (i[l] in o)
            return i[l];
        return !1;
      }
      function Ai(i, o, l) {
        var p = o || new fe(0, 0);
        i.style[No] = (le.ie3d ? "translate(" + p.x + "px," + p.y + "px)" : "translate3d(" + p.x + "px," + p.y + "px,0)") + (l ? " scale(" + l + ")" : "");
      }
      function ft(i, o) {
        i._leaflet_pos = o, le.any3d ? Ai(i, o) : (i.style.left = o.x + "px", i.style.top = o.y + "px");
      }
      function Wn(i) {
        return i._leaflet_pos || new fe(0, 0);
      }
      var Pi, kn, Do;
      if ("onselectstart" in document)
        Pi = function() {
          we(window, "selectstart", Ce);
        }, kn = function() {
          et(window, "selectstart", Ce);
        };
      else {
        var rr = ir(
          ["userSelect", "WebkitUserSelect", "OUserSelect", "MozUserSelect", "msUserSelect"]
        );
        Pi = function() {
          if (rr) {
            var i = document.documentElement.style;
            Do = i[rr], i[rr] = "none";
          }
        }, kn = function() {
          rr && (document.documentElement.style[rr] = Do, Do = void 0);
        };
      }
      function Us() {
        we(window, "dragstart", Ce);
      }
      function $o() {
        et(window, "dragstart", Ce);
      }
      var Br, Ro;
      function zo(i) {
        for (; i.tabIndex === -1; )
          i = i.parentNode;
        i.style && (Bo(), Br = i, Ro = i.style.outlineStyle, i.style.outlineStyle = "none", we(window, "keydown", Bo));
      }
      function Bo() {
        Br && (Br.style.outlineStyle = Ro, Br = void 0, Ro = void 0, et(window, "keydown", Bo));
      }
      function tl(i) {
        do
          i = i.parentNode;
        while ((!i.offsetWidth || !i.offsetHeight) && i !== document.body);
        return i;
      }
      function Vs(i) {
        var o = i.getBoundingClientRect();
        return {
          x: o.width / i.offsetWidth || 1,
          y: o.height / i.offsetHeight || 1,
          boundingClientRect: o
        };
      }
      var nl = {
        __proto__: null,
        TRANSFORM: No,
        TRANSITION: nr,
        TRANSITION_END: Ja,
        get: Xa,
        getStyle: Rr,
        create: Ve,
        remove: it,
        empty: zr,
        toFront: Ei,
        toBack: si,
        hasClass: Fs,
        addClass: Se,
        removeClass: rt,
        setClass: Io,
        getClass: ko,
        setOpacity: tn,
        testProp: ir,
        setTransform: Ai,
        setPosition: ft,
        getPosition: Wn,
        get disableTextSelection() {
          return Pi;
        },
        get enableTextSelection() {
          return kn;
        },
        disableImageDrag: Us,
        enableImageDrag: $o,
        preventOutline: zo,
        restoreOutline: Bo,
        getSizedParentNode: tl,
        getScale: Vs
      };
      function we(i, o, l, p) {
        if (o && typeof o == "object")
          for (var v in o)
            Hs(i, v, o[v], l);
        else {
          o = A(o);
          for (var C = 0, O = o.length; C < O; C++)
            Hs(i, o[C], l, p);
        }
        return this;
      }
      var Dn = "_leaflet_events";
      function et(i, o, l, p) {
        if (arguments.length === 1)
          il(i), delete i[Dn];
        else if (o && typeof o == "object")
          for (var v in o)
            js(i, v, o[v], l);
        else if (o = A(o), arguments.length === 2)
          il(i, function(B) {
            return re(o, B) !== -1;
          });
        else
          for (var C = 0, O = o.length; C < O; C++)
            js(i, o[C], l, p);
        return this;
      }
      function il(i, o) {
        for (var l in i[Dn]) {
          var p = l.split(/\d/)[0];
          (!o || o(p)) && js(i, p, null, null, l);
        }
      }
      var Fr = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
      };
      function Hs(i, o, l, p) {
        var v = o + g(l) + (p ? "_" + g(p) : "");
        if (i[Dn] && i[Dn][v])
          return this;
        var C = function(B) {
          return l.call(p || i, B || window.event);
        }, O = C;
        !le.touchNative && le.pointer && o.indexOf("touch") === 0 ? C = ec(i, o, C) : le.touch && o === "dblclick" ? C = sc(i, C) : "addEventListener" in i ? o === "touchstart" || o === "touchmove" || o === "wheel" || o === "mousewheel" ? i.addEventListener(Fr[o] || o, C, le.passiveEvents ? { passive: !1 } : !1) : o === "mouseenter" || o === "mouseleave" ? (C = function(B) {
          B = B || window.event, Ws(i, B) && O(B);
        }, i.addEventListener(Fr[o], C, !1)) : i.addEventListener(o, O, !1) : i.attachEvent("on" + o, C), i[Dn] = i[Dn] || {}, i[Dn][v] = C;
      }
      function js(i, o, l, p, v) {
        v = v || o + g(l) + (p ? "_" + g(p) : "");
        var C = i[Dn] && i[Dn][v];
        if (!C)
          return this;
        !le.touchNative && le.pointer && o.indexOf("touch") === 0 ? tc(i, o, C) : le.touch && o === "dblclick" ? Qa(i, C) : "removeEventListener" in i ? i.removeEventListener(Fr[o] || o, C, !1) : i.detachEvent("on" + o, C), i[Dn][v] = null;
      }
      function xi(i) {
        return i.stopPropagation ? i.stopPropagation() : i.originalEvent ? i.originalEvent._stopped = !0 : i.cancelBubble = !0, this;
      }
      function Zs(i) {
        return Hs(i, "wheel", xi), this;
      }
      function Ur(i) {
        return we(i, "mousedown touchstart dblclick contextmenu", xi), i._leaflet_disable_click = !0, this;
      }
      function Ce(i) {
        return i.preventDefault ? i.preventDefault() : i.returnValue = !1, this;
      }
      function He(i) {
        return Ce(i), xi(i), this;
      }
      function rl(i) {
        if (i.composedPath)
          return i.composedPath();
        for (var o = [], l = i.target; l; )
          o.push(l), l = l.parentNode;
        return o;
      }
      function ol(i, o) {
        if (!o)
          return new fe(i.clientX, i.clientY);
        var l = Vs(o), p = l.boundingClientRect;
        return new fe(
          // offset.left/top values are in page scale (like clientX/Y),
          // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
          (i.clientX - p.left) / l.x - o.clientLeft,
          (i.clientY - p.top) / l.y - o.clientTop
        );
      }
      var ac = le.linux && le.chrome ? window.devicePixelRatio : le.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
      function sl(i) {
        return le.edge ? i.wheelDeltaY / 2 : (
          // Don't trust window-geometry-based delta
          i.deltaY && i.deltaMode === 0 ? -i.deltaY / ac : (
            // Pixels
            i.deltaY && i.deltaMode === 1 ? -i.deltaY * 20 : (
              // Lines
              i.deltaY && i.deltaMode === 2 ? -i.deltaY * 60 : (
                // Pages
                i.deltaX || i.deltaZ ? 0 : (
                  // Skip horizontal/depth wheel events
                  i.wheelDelta ? (i.wheelDeltaY || i.wheelDelta) / 2 : (
                    // Legacy IE pixels
                    i.detail && Math.abs(i.detail) < 32765 ? -i.detail * 20 : (
                      // Legacy Moz lines
                      i.detail ? i.detail / -32765 * 60 : (
                        // Legacy Moz pages
                        0
                      )
                    )
                  )
                )
              )
            )
          )
        );
      }
      function Ws(i, o) {
        var l = o.relatedTarget;
        if (!l)
          return !0;
        try {
          for (; l && l !== i; )
            l = l.parentNode;
        } catch {
          return !1;
        }
        return l !== i;
      }
      var lc = {
        __proto__: null,
        on: we,
        off: et,
        stopPropagation: xi,
        disableScrollPropagation: Zs,
        disableClickPropagation: Ur,
        preventDefault: Ce,
        stop: He,
        getPropagationPath: rl,
        getMousePosition: ol,
        getWheelDelta: sl,
        isExternalTarget: Ws,
        addListener: we,
        removeListener: et
      }, Gs = Ln.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(i, o, l, p) {
          this.stop(), this._el = i, this._inProgress = !0, this._duration = l || 0.25, this._easeOutPower = 1 / Math.max(p || 0.5, 0.2), this._startPos = Wn(i), this._offset = o.subtract(this._startPos), this._startTime = +/* @__PURE__ */ new Date(), this.fire("start"), this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
          this._inProgress && (this._step(!0), this._complete());
        },
        _animate: function() {
          this._animId = _t(this._animate, this), this._step();
        },
        _step: function(i) {
          var o = +/* @__PURE__ */ new Date() - this._startTime, l = this._duration * 1e3;
          o < l ? this._runFrame(this._easeOut(o / l), i) : (this._runFrame(1), this._complete());
        },
        _runFrame: function(i, o) {
          var l = this._startPos.add(this._offset.multiplyBy(i));
          o && l._round(), ft(this._el, l), this.fire("step");
        },
        _complete: function() {
          nt(this._animId), this._inProgress = !1, this.fire("end");
        },
        _easeOut: function(i) {
          return 1 - Math.pow(1 - i, this._easeOutPower);
        }
      }), De = Ln.extend({
        options: {
          // @section Map State Options
          // @option crs: CRS = L.CRS.EPSG3857
          // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
          // sure what it means.
          crs: Co,
          // @option center: LatLng = undefined
          // Initial geographic center of the map
          center: void 0,
          // @option zoom: Number = undefined
          // Initial map zoom level
          zoom: void 0,
          // @option minZoom: Number = *
          // Minimum zoom level of the map.
          // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
          // the lowest of their `minZoom` options will be used instead.
          minZoom: void 0,
          // @option maxZoom: Number = *
          // Maximum zoom level of the map.
          // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
          // the highest of their `maxZoom` options will be used instead.
          maxZoom: void 0,
          // @option layers: Layer[] = []
          // Array of layers that will be added to the map initially
          layers: [],
          // @option maxBounds: LatLngBounds = null
          // When this option is set, the map restricts the view to the given
          // geographical bounds, bouncing the user back if the user tries to pan
          // outside the view. To set the restriction dynamically, use
          // [`setMaxBounds`](#map-setmaxbounds) method.
          maxBounds: void 0,
          // @option renderer: Renderer = *
          // The default method for drawing vector layers on the map. `L.SVG`
          // or `L.Canvas` by default depending on browser support.
          renderer: void 0,
          // @section Animation Options
          // @option zoomAnimation: Boolean = true
          // Whether the map zoom animation is enabled. By default it's enabled
          // in all browsers that support CSS3 Transitions except Android.
          zoomAnimation: !0,
          // @option zoomAnimationThreshold: Number = 4
          // Won't animate zoom if the zoom difference exceeds this value.
          zoomAnimationThreshold: 4,
          // @option fadeAnimation: Boolean = true
          // Whether the tile fade animation is enabled. By default it's enabled
          // in all browsers that support CSS3 Transitions except Android.
          fadeAnimation: !0,
          // @option markerZoomAnimation: Boolean = true
          // Whether markers animate their zoom with the zoom animation, if disabled
          // they will disappear for the length of the animation. By default it's
          // enabled in all browsers that support CSS3 Transitions except Android.
          markerZoomAnimation: !0,
          // @option transform3DLimit: Number = 2^23
          // Defines the maximum size of a CSS translation transform. The default
          // value should not be changed unless a web browser positions layers in
          // the wrong place after doing a large `panBy`.
          transform3DLimit: 8388608,
          // Precision limit of a 32-bit float
          // @section Interaction Options
          // @option zoomSnap: Number = 1
          // Forces the map's zoom level to always be a multiple of this, particularly
          // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
          // By default, the zoom level snaps to the nearest integer; lower values
          // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
          // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
          zoomSnap: 1,
          // @option zoomDelta: Number = 1
          // Controls how much the map's zoom level will change after a
          // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
          // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
          // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
          zoomDelta: 1,
          // @option trackResize: Boolean = true
          // Whether the map automatically handles browser window resize to update itself.
          trackResize: !0
        },
        initialize: function(i, o) {
          o = x(this, o), this._handlers = [], this._layers = {}, this._zoomBoundLayers = {}, this._sizeChanged = !0, this._initContainer(i), this._initLayout(), this._onResize = d(this._onResize, this), this._initEvents(), o.maxBounds && this.setMaxBounds(o.maxBounds), o.zoom !== void 0 && (this._zoom = this._limitZoom(o.zoom)), o.center && o.zoom !== void 0 && this.setView(Pe(o.center), o.zoom, { reset: !0 }), this.callInitHooks(), this._zoomAnimated = nr && le.any3d && !le.mobileOpera && this.options.zoomAnimation, this._zoomAnimated && (this._createAnimProxy(), we(this._proxy, Ja, this._catchTransitionEnd, this)), this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(i, o, l) {
          if (o = o === void 0 ? this._zoom : this._limitZoom(o), i = this._limitCenter(Pe(i), o, this.options.maxBounds), l = l || {}, this._stop(), this._loaded && !l.reset && l !== !0) {
            l.animate !== void 0 && (l.zoom = u({ animate: l.animate }, l.zoom), l.pan = u({ animate: l.animate, duration: l.duration }, l.pan));
            var p = this._zoom !== o ? this._tryAnimatedZoom && this._tryAnimatedZoom(i, o, l.zoom) : this._tryAnimatedPan(i, l.pan);
            if (p)
              return clearTimeout(this._sizeTimer), this;
          }
          return this._resetView(i, o, l.pan && l.pan.noMoveStart), this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(i, o) {
          return this._loaded ? this.setView(this.getCenter(), i, { zoom: o }) : (this._zoom = i, this);
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(i, o) {
          return i = i || (le.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom + i, o);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(i, o) {
          return i = i || (le.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom - i, o);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(i, o, l) {
          var p = this.getZoomScale(o), v = this.getSize().divideBy(2), C = i instanceof fe ? i : this.latLngToContainerPoint(i), O = C.subtract(v).multiplyBy(1 - 1 / p), B = this.containerPointToLatLng(v.add(O));
          return this.setView(B, o, { zoom: l });
        },
        _getBoundsCenterZoom: function(i, o) {
          o = o || {}, i = i.getBounds ? i.getBounds() : vt(i);
          var l = _e(o.paddingTopLeft || o.padding || [0, 0]), p = _e(o.paddingBottomRight || o.padding || [0, 0]), v = this.getBoundsZoom(i, !1, l.add(p));
          if (v = typeof o.maxZoom == "number" ? Math.min(o.maxZoom, v) : v, v === 1 / 0)
            return {
              center: i.getCenter(),
              zoom: v
            };
          var C = p.subtract(l).divideBy(2), O = this.project(i.getSouthWest(), v), B = this.project(i.getNorthEast(), v), F = this.unproject(O.add(B).divideBy(2).add(C), v);
          return {
            center: F,
            zoom: v
          };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(i, o) {
          if (i = vt(i), !i.isValid())
            throw new Error("Bounds are not valid.");
          var l = this._getBoundsCenterZoom(i, o);
          return this.setView(l.center, l.zoom, o);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(i) {
          return this.fitBounds([[-90, -180], [90, 180]], i);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(i, o) {
          return this.setView(i, this._zoom, { pan: o });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(i, o) {
          if (i = _e(i).round(), o = o || {}, !i.x && !i.y)
            return this.fire("moveend");
          if (o.animate !== !0 && !this.getSize().contains(i))
            return this._resetView(this.unproject(this.project(this.getCenter()).add(i)), this.getZoom()), this;
          if (this._panAnim || (this._panAnim = new Gs(), this._panAnim.on({
            step: this._onPanTransitionStep,
            end: this._onPanTransitionEnd
          }, this)), o.noMoveStart || this.fire("movestart"), o.animate !== !1) {
            Se(this._mapPane, "leaflet-pan-anim");
            var l = this._getMapPanePos().subtract(i).round();
            this._panAnim.run(this._mapPane, l, o.duration || 0.25, o.easeLinearity);
          } else
            this._rawPanBy(i), this.fire("move").fire("moveend");
          return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(i, o, l) {
          if (l = l || {}, l.animate === !1 || !le.any3d)
            return this.setView(i, o, l);
          this._stop();
          var p = this.project(this.getCenter()), v = this.project(i), C = this.getSize(), O = this._zoom;
          i = Pe(i), o = o === void 0 ? O : o;
          var B = Math.max(C.x, C.y), F = B * this.getZoomScale(O, o), K = v.distanceTo(p) || 1, ne = 1.42, he = ne * ne;
          function Te(ot) {
            var to = ot ? -1 : 1, M = ot ? F : B, pr = F * F - B * B + to * he * he * K * K, Qo = 2 * M * he * K, qt = pr / Qo, xe = Math.sqrt(qt * qt + 1) - qt, Lc = xe < 1e-9 ? -18 : Math.log(xe);
            return Lc;
          }
          function yt(ot) {
            return (Math.exp(ot) - Math.exp(-ot)) / 2;
          }
          function ct(ot) {
            return (Math.exp(ot) + Math.exp(-ot)) / 2;
          }
          function kt(ot) {
            return yt(ot) / ct(ot);
          }
          var xt = Te(0);
          function Tn(ot) {
            return B * (ct(xt) / ct(xt + ne * ot));
          }
          function vc(ot) {
            return B * (ct(xt) * kt(xt + ne * ot) - yt(xt)) / he;
          }
          function yc(ot) {
            return 1 - Math.pow(1 - ot, 1.5);
          }
          var bc = Date.now(), Ll = (Te(1) - xt) / ne, wc = l.duration ? 1e3 * l.duration : 1e3 * Ll * 0.8;
          function eo() {
            var ot = (Date.now() - bc) / wc, to = yc(ot) * Ll;
            ot <= 1 ? (this._flyToFrame = _t(eo, this), this._move(
              this.unproject(p.add(v.subtract(p).multiplyBy(vc(to) / K)), O),
              this.getScaleZoom(B / Tn(to), O),
              { flyTo: !0 }
            )) : this._move(i, o)._moveEnd(!0);
          }
          return this._moveStart(!0, l.noMoveStart), eo.call(this), this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(i, o) {
          var l = this._getBoundsCenterZoom(i, o);
          return this.flyTo(l.center, l.zoom, o);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(i) {
          return i = vt(i), this.listens("moveend", this._panInsideMaxBounds) && this.off("moveend", this._panInsideMaxBounds), i.isValid() ? (this.options.maxBounds = i, this._loaded && this._panInsideMaxBounds(), this.on("moveend", this._panInsideMaxBounds)) : (this.options.maxBounds = null, this);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(i) {
          var o = this.options.minZoom;
          return this.options.minZoom = i, this._loaded && o !== i && (this.fire("zoomlevelschange"), this.getZoom() < this.options.minZoom) ? this.setZoom(i) : this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(i) {
          var o = this.options.maxZoom;
          return this.options.maxZoom = i, this._loaded && o !== i && (this.fire("zoomlevelschange"), this.getZoom() > this.options.maxZoom) ? this.setZoom(i) : this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(i, o) {
          this._enforcingBounds = !0;
          var l = this.getCenter(), p = this._limitCenter(l, this._zoom, vt(i));
          return l.equals(p) || this.panTo(p, o), this._enforcingBounds = !1, this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(i, o) {
          o = o || {};
          var l = _e(o.paddingTopLeft || o.padding || [0, 0]), p = _e(o.paddingBottomRight || o.padding || [0, 0]), v = this.project(this.getCenter()), C = this.project(i), O = this.getPixelBounds(), B = Ht([O.min.add(l), O.max.subtract(p)]), F = B.getSize();
          if (!B.contains(C)) {
            this._enforcingBounds = !0;
            var K = C.subtract(B.getCenter()), ne = B.extend(C).getSize().subtract(F);
            v.x += K.x < 0 ? -ne.x : ne.x, v.y += K.y < 0 ? -ne.y : ne.y, this.panTo(this.unproject(v), o), this._enforcingBounds = !1;
          }
          return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(i) {
          if (!this._loaded)
            return this;
          i = u({
            animate: !1,
            pan: !0
          }, i === !0 ? { animate: !0 } : i);
          var o = this.getSize();
          this._sizeChanged = !0, this._lastCenter = null;
          var l = this.getSize(), p = o.divideBy(2).round(), v = l.divideBy(2).round(), C = p.subtract(v);
          return !C.x && !C.y ? this : (i.animate && i.pan ? this.panBy(C) : (i.pan && this._rawPanBy(C), this.fire("move"), i.debounceMoveend ? (clearTimeout(this._sizeTimer), this._sizeTimer = setTimeout(d(this.fire, this, "moveend"), 200)) : this.fire("moveend")), this.fire("resize", {
            oldSize: o,
            newSize: l
          }));
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
          return this.setZoom(this._limitZoom(this._zoom)), this.options.zoomSnap || this.fire("viewreset"), this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(i) {
          if (i = this._locateOptions = u({
            timeout: 1e4,
            watch: !1
            // setView: false
            // maxZoom: <Number>
            // maximumAge: 0
            // enableHighAccuracy: false
          }, i), !("geolocation" in navigator))
            return this._handleGeolocationError({
              code: 0,
              message: "Geolocation not supported."
            }), this;
          var o = d(this._handleGeolocationResponse, this), l = d(this._handleGeolocationError, this);
          return i.watch ? this._locationWatchId = navigator.geolocation.watchPosition(o, l, i) : navigator.geolocation.getCurrentPosition(o, l, i), this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
          return navigator.geolocation && navigator.geolocation.clearWatch && navigator.geolocation.clearWatch(this._locationWatchId), this._locateOptions && (this._locateOptions.setView = !1), this;
        },
        _handleGeolocationError: function(i) {
          if (this._container._leaflet_id) {
            var o = i.code, l = i.message || (o === 1 ? "permission denied" : o === 2 ? "position unavailable" : "timeout");
            this._locateOptions.setView && !this._loaded && this.fitWorld(), this.fire("locationerror", {
              code: o,
              message: "Geolocation error: " + l + "."
            });
          }
        },
        _handleGeolocationResponse: function(i) {
          if (this._container._leaflet_id) {
            var o = i.coords.latitude, l = i.coords.longitude, p = new Re(o, l), v = p.toBounds(i.coords.accuracy * 2), C = this._locateOptions;
            if (C.setView) {
              var O = this.getBoundsZoom(v);
              this.setView(p, C.maxZoom ? Math.min(O, C.maxZoom) : O);
            }
            var B = {
              latlng: p,
              bounds: v,
              timestamp: i.timestamp
            };
            for (var F in i.coords)
              typeof i.coords[F] == "number" && (B[F] = i.coords[F]);
            this.fire("locationfound", B);
          }
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(i, o) {
          if (!o)
            return this;
          var l = this[i] = new o(this);
          return this._handlers.push(l), this.options[i] && l.enable(), this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
          if (this._initEvents(!0), this.options.maxBounds && this.off("moveend", this._panInsideMaxBounds), this._containerId !== this._container._leaflet_id)
            throw new Error("Map container is being reused by another instance");
          try {
            delete this._container._leaflet_id, delete this._containerId;
          } catch {
            this._container._leaflet_id = void 0, this._containerId = void 0;
          }
          this._locationWatchId !== void 0 && this.stopLocate(), this._stop(), it(this._mapPane), this._clearControlPos && this._clearControlPos(), this._resizeRequest && (nt(this._resizeRequest), this._resizeRequest = null), this._clearHandlers(), this._loaded && this.fire("unload");
          var i;
          for (i in this._layers)
            this._layers[i].remove();
          for (i in this._panes)
            it(this._panes[i]);
          return this._layers = [], this._panes = [], delete this._mapPane, delete this._renderer, this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(i, o) {
          var l = "leaflet-pane" + (i ? " leaflet-" + i.replace("Pane", "") + "-pane" : ""), p = Ve("div", l, o || this._mapPane);
          return i && (this._panes[i] = p), p;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
          return this._checkIfLoaded(), this._lastCenter && !this._moved() ? this._lastCenter.clone() : this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
          return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
          var i = this.getPixelBounds(), o = this.unproject(i.getBottomLeft()), l = this.unproject(i.getTopRight());
          return new jt(o, l);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
          return this.options.minZoom === void 0 ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
          return this.options.maxZoom === void 0 ? this._layersMaxZoom === void 0 ? 1 / 0 : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(i, o, l) {
          i = vt(i), l = _e(l || [0, 0]);
          var p = this.getZoom() || 0, v = this.getMinZoom(), C = this.getMaxZoom(), O = i.getNorthWest(), B = i.getSouthEast(), F = this.getSize().subtract(l), K = Ht(this.project(B, p), this.project(O, p)).getSize(), ne = le.any3d ? this.options.zoomSnap : 1, he = F.x / K.x, Te = F.y / K.y, yt = o ? Math.max(he, Te) : Math.min(he, Te);
          return p = this.getScaleZoom(yt, p), ne && (p = Math.round(p / (ne / 100)) * (ne / 100), p = o ? Math.ceil(p / ne) * ne : Math.floor(p / ne) * ne), Math.max(v, Math.min(C, p));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
          return (!this._size || this._sizeChanged) && (this._size = new fe(
            this._container.clientWidth || 0,
            this._container.clientHeight || 0
          ), this._sizeChanged = !1), this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(i, o) {
          var l = this._getTopLeftPoint(i, o);
          return new Ue(l, l.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
          return this._checkIfLoaded(), this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(i) {
          return this.options.crs.getProjectedBounds(i === void 0 ? this.getZoom() : i);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(i) {
          return typeof i == "string" ? this._panes[i] : i;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
          return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
          return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(i, o) {
          var l = this.options.crs;
          return o = o === void 0 ? this._zoom : o, l.scale(i) / l.scale(o);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(i, o) {
          var l = this.options.crs;
          o = o === void 0 ? this._zoom : o;
          var p = l.zoom(i * l.scale(o));
          return isNaN(p) ? 1 / 0 : p;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(i, o) {
          return o = o === void 0 ? this._zoom : o, this.options.crs.latLngToPoint(Pe(i), o);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(i, o) {
          return o = o === void 0 ? this._zoom : o, this.options.crs.pointToLatLng(_e(i), o);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(i) {
          var o = _e(i).add(this.getPixelOrigin());
          return this.unproject(o);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(i) {
          var o = this.project(Pe(i))._round();
          return o._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(i) {
          return this.options.crs.wrapLatLng(Pe(i));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(i) {
          return this.options.crs.wrapLatLngBounds(vt(i));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(i, o) {
          return this.options.crs.distance(Pe(i), Pe(o));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(i) {
          return _e(i).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(i) {
          return _e(i).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(i) {
          var o = this.containerPointToLayerPoint(_e(i));
          return this.layerPointToLatLng(o);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(i) {
          return this.layerPointToContainerPoint(this.latLngToLayerPoint(Pe(i)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(i) {
          return ol(i, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(i) {
          return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(i));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(i) {
          return this.layerPointToLatLng(this.mouseEventToLayerPoint(i));
        },
        // map initialization methods
        _initContainer: function(i) {
          var o = this._container = Xa(i);
          if (o) {
            if (o._leaflet_id)
              throw new Error("Map container is already initialized.");
          } else
            throw new Error("Map container not found.");
          we(o, "scroll", this._onScroll, this), this._containerId = g(o);
        },
        _initLayout: function() {
          var i = this._container;
          this._fadeAnimated = this.options.fadeAnimation && le.any3d, Se(i, "leaflet-container" + (le.touch ? " leaflet-touch" : "") + (le.retina ? " leaflet-retina" : "") + (le.ielt9 ? " leaflet-oldie" : "") + (le.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
          var o = Rr(i, "position");
          o !== "absolute" && o !== "relative" && o !== "fixed" && o !== "sticky" && (i.style.position = "relative"), this._initPanes(), this._initControlPos && this._initControlPos();
        },
        _initPanes: function() {
          var i = this._panes = {};
          this._paneRenderers = {}, this._mapPane = this.createPane("mapPane", this._container), ft(this._mapPane, new fe(0, 0)), this.createPane("tilePane"), this.createPane("overlayPane"), this.createPane("shadowPane"), this.createPane("markerPane"), this.createPane("tooltipPane"), this.createPane("popupPane"), this.options.markerZoomAnimation || (Se(i.markerPane, "leaflet-zoom-hide"), Se(i.shadowPane, "leaflet-zoom-hide"));
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(i, o, l) {
          ft(this._mapPane, new fe(0, 0));
          var p = !this._loaded;
          this._loaded = !0, o = this._limitZoom(o), this.fire("viewprereset");
          var v = this._zoom !== o;
          this._moveStart(v, l)._move(i, o)._moveEnd(v), this.fire("viewreset"), p && this.fire("load");
        },
        _moveStart: function(i, o) {
          return i && this.fire("zoomstart"), o || this.fire("movestart"), this;
        },
        _move: function(i, o, l, p) {
          o === void 0 && (o = this._zoom);
          var v = this._zoom !== o;
          return this._zoom = o, this._lastCenter = i, this._pixelOrigin = this._getNewPixelOrigin(i), p ? l && l.pinch && this.fire("zoom", l) : ((v || l && l.pinch) && this.fire("zoom", l), this.fire("move", l)), this;
        },
        _moveEnd: function(i) {
          return i && this.fire("zoomend"), this.fire("moveend");
        },
        _stop: function() {
          return nt(this._flyToFrame), this._panAnim && this._panAnim.stop(), this;
        },
        _rawPanBy: function(i) {
          ft(this._mapPane, this._getMapPanePos().subtract(i));
        },
        _getZoomSpan: function() {
          return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
          this._enforcingBounds || this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
          if (!this._loaded)
            throw new Error("Set map center and zoom first.");
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(i) {
          this._targets = {}, this._targets[g(this._container)] = this;
          var o = i ? et : we;
          o(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this), this.options.trackResize && o(window, "resize", this._onResize, this), le.any3d && this.options.transform3DLimit && (i ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
          nt(this._resizeRequest), this._resizeRequest = _t(
            function() {
              this.invalidateSize({ debounceMoveend: !0 });
            },
            this
          );
        },
        _onScroll: function() {
          this._container.scrollTop = 0, this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
          var i = this._getMapPanePos();
          Math.max(Math.abs(i.x), Math.abs(i.y)) >= this.options.transform3DLimit && this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(i, o) {
          for (var l = [], p, v = o === "mouseout" || o === "mouseover", C = i.target || i.srcElement, O = !1; C; ) {
            if (p = this._targets[g(C)], p && (o === "click" || o === "preclick") && this._draggableMoved(p)) {
              O = !0;
              break;
            }
            if (p && p.listens(o, !0) && (v && !Ws(C, i) || (l.push(p), v)) || C === this._container)
              break;
            C = C.parentNode;
          }
          return !l.length && !O && !v && this.listens(o, !0) && (l = [this]), l;
        },
        _isClickDisabled: function(i) {
          for (; i && i !== this._container; ) {
            if (i._leaflet_disable_click)
              return !0;
            i = i.parentNode;
          }
        },
        _handleDOMEvent: function(i) {
          var o = i.target || i.srcElement;
          if (!(!this._loaded || o._leaflet_disable_events || i.type === "click" && this._isClickDisabled(o))) {
            var l = i.type;
            l === "mousedown" && zo(o), this._fireDOMEvent(i, l);
          }
        },
        _mouseEvents: ["click", "dblclick", "mouseover", "mouseout", "contextmenu"],
        _fireDOMEvent: function(i, o, l) {
          if (i.type === "click") {
            var p = u({}, i);
            p.type = "preclick", this._fireDOMEvent(p, p.type, l);
          }
          var v = this._findEventTargets(i, o);
          if (l) {
            for (var C = [], O = 0; O < l.length; O++)
              l[O].listens(o, !0) && C.push(l[O]);
            v = C.concat(v);
          }
          if (v.length) {
            o === "contextmenu" && Ce(i);
            var B = v[0], F = {
              originalEvent: i
            };
            if (i.type !== "keypress" && i.type !== "keydown" && i.type !== "keyup") {
              var K = B.getLatLng && (!B._radius || B._radius <= 10);
              F.containerPoint = K ? this.latLngToContainerPoint(B.getLatLng()) : this.mouseEventToContainerPoint(i), F.layerPoint = this.containerPointToLayerPoint(F.containerPoint), F.latlng = K ? B.getLatLng() : this.layerPointToLatLng(F.layerPoint);
            }
            for (O = 0; O < v.length; O++)
              if (v[O].fire(o, F, !0), F.originalEvent._stopped || v[O].options.bubblingMouseEvents === !1 && re(this._mouseEvents, o) !== -1)
                return;
          }
        },
        _draggableMoved: function(i) {
          return i = i.dragging && i.dragging.enabled() ? i : this, i.dragging && i.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
          for (var i = 0, o = this._handlers.length; i < o; i++)
            this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(i, o) {
          return this._loaded ? i.call(o || this, { target: this }) : this.on("load", i, o), this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
          return Wn(this._mapPane) || new fe(0, 0);
        },
        _moved: function() {
          var i = this._getMapPanePos();
          return i && !i.equals([0, 0]);
        },
        _getTopLeftPoint: function(i, o) {
          var l = i && o !== void 0 ? this._getNewPixelOrigin(i, o) : this.getPixelOrigin();
          return l.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(i, o) {
          var l = this.getSize()._divideBy(2);
          return this.project(i, o)._subtract(l)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(i, o, l) {
          var p = this._getNewPixelOrigin(l, o);
          return this.project(i, o)._subtract(p);
        },
        _latLngBoundsToNewLayerBounds: function(i, o, l) {
          var p = this._getNewPixelOrigin(l, o);
          return Ht([
            this.project(i.getSouthWest(), o)._subtract(p),
            this.project(i.getNorthWest(), o)._subtract(p),
            this.project(i.getSouthEast(), o)._subtract(p),
            this.project(i.getNorthEast(), o)._subtract(p)
          ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
          return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(i) {
          return this.latLngToLayerPoint(i).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(i, o, l) {
          if (!l)
            return i;
          var p = this.project(i, o), v = this.getSize().divideBy(2), C = new Ue(p.subtract(v), p.add(v)), O = this._getBoundsOffset(C, l, o);
          return Math.abs(O.x) <= 1 && Math.abs(O.y) <= 1 ? i : this.unproject(p.add(O), o);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(i, o) {
          if (!o)
            return i;
          var l = this.getPixelBounds(), p = new Ue(l.min.add(i), l.max.add(i));
          return i.add(this._getBoundsOffset(p, o));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(i, o, l) {
          var p = Ht(
            this.project(o.getNorthEast(), l),
            this.project(o.getSouthWest(), l)
          ), v = p.min.subtract(i.min), C = p.max.subtract(i.max), O = this._rebound(v.x, -C.x), B = this._rebound(v.y, -C.y);
          return new fe(O, B);
        },
        _rebound: function(i, o) {
          return i + o > 0 ? Math.round(i - o) / 2 : Math.max(0, Math.ceil(i)) - Math.max(0, Math.floor(o));
        },
        _limitZoom: function(i) {
          var o = this.getMinZoom(), l = this.getMaxZoom(), p = le.any3d ? this.options.zoomSnap : 1;
          return p && (i = Math.round(i / p) * p), Math.max(o, Math.min(l, i));
        },
        _onPanTransitionStep: function() {
          this.fire("move");
        },
        _onPanTransitionEnd: function() {
          rt(this._mapPane, "leaflet-pan-anim"), this.fire("moveend");
        },
        _tryAnimatedPan: function(i, o) {
          var l = this._getCenterOffset(i)._trunc();
          return (o && o.animate) !== !0 && !this.getSize().contains(l) ? !1 : (this.panBy(l, o), !0);
        },
        _createAnimProxy: function() {
          var i = this._proxy = Ve("div", "leaflet-proxy leaflet-zoom-animated");
          this._panes.mapPane.appendChild(i), this.on("zoomanim", function(o) {
            var l = No, p = this._proxy.style[l];
            Ai(this._proxy, this.project(o.center, o.zoom), this.getZoomScale(o.zoom, 1)), p === this._proxy.style[l] && this._animatingZoom && this._onZoomTransitionEnd();
          }, this), this.on("load moveend", this._animMoveEnd, this), this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
          it(this._proxy), this.off("load moveend", this._animMoveEnd, this), delete this._proxy;
        },
        _animMoveEnd: function() {
          var i = this.getCenter(), o = this.getZoom();
          Ai(this._proxy, this.project(i, o), this.getZoomScale(o, 1));
        },
        _catchTransitionEnd: function(i) {
          this._animatingZoom && i.propertyName.indexOf("transform") >= 0 && this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
          return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(i, o, l) {
          if (this._animatingZoom)
            return !0;
          if (l = l || {}, !this._zoomAnimated || l.animate === !1 || this._nothingToAnimate() || Math.abs(o - this._zoom) > this.options.zoomAnimationThreshold)
            return !1;
          var p = this.getZoomScale(o), v = this._getCenterOffset(i)._divideBy(1 - 1 / p);
          return l.animate !== !0 && !this.getSize().contains(v) ? !1 : (_t(function() {
            this._moveStart(!0, l.noMoveStart || !1)._animateZoom(i, o, !0);
          }, this), !0);
        },
        _animateZoom: function(i, o, l, p) {
          this._mapPane && (l && (this._animatingZoom = !0, this._animateToCenter = i, this._animateToZoom = o, Se(this._mapPane, "leaflet-zoom-anim")), this.fire("zoomanim", {
            center: i,
            zoom: o,
            noUpdate: p
          }), this._tempFireZoomEvent || (this._tempFireZoomEvent = this._zoom !== this._animateToZoom), this._move(this._animateToCenter, this._animateToZoom, void 0, !0), setTimeout(d(this._onZoomTransitionEnd, this), 250));
        },
        _onZoomTransitionEnd: function() {
          this._animatingZoom && (this._mapPane && rt(this._mapPane, "leaflet-zoom-anim"), this._animatingZoom = !1, this._move(this._animateToCenter, this._animateToZoom, void 0, !0), this._tempFireZoomEvent && this.fire("zoom"), delete this._tempFireZoomEvent, this.fire("move"), this._moveEnd(!0));
        }
      });
      function Pt(i, o) {
        return new De(i, o);
      }
      var nn = At.extend({
        // @section
        // @aka Control Options
        options: {
          // @option position: String = 'topright'
          // The position of the control (one of the map corners). Possible values are `'topleft'`,
          // `'topright'`, `'bottomleft'` or `'bottomright'`
          position: "topright"
        },
        initialize: function(i) {
          x(this, i);
        },
        /* @section
         * Classes extending L.Control will inherit the following methods:
         *
         * @method getPosition: string
         * Returns the position of the control.
         */
        getPosition: function() {
          return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(i) {
          var o = this._map;
          return o && o.removeControl(this), this.options.position = i, o && o.addControl(this), this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
          return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(i) {
          this.remove(), this._map = i;
          var o = this._container = this.onAdd(i), l = this.getPosition(), p = i._controlCorners[l];
          return Se(o, "leaflet-control"), l.indexOf("bottom") !== -1 ? p.insertBefore(o, p.firstChild) : p.appendChild(o), this._map.on("unload", this.remove, this), this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
          return this._map ? (it(this._container), this.onRemove && this.onRemove(this._map), this._map.off("unload", this.remove, this), this._map = null, this) : this;
        },
        _refocusOnMap: function(i) {
          this._map && i && i.screenX > 0 && i.screenY > 0 && this._map.getContainer().focus();
        }
      }), Mn = function(i) {
        return new nn(i);
      };
      De.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(i) {
          return i.addTo(this), this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(i) {
          return i.remove(), this;
        },
        _initControlPos: function() {
          var i = this._controlCorners = {}, o = "leaflet-", l = this._controlContainer = Ve("div", o + "control-container", this._container);
          function p(v, C) {
            var O = o + v + " " + o + C;
            i[v + C] = Ve("div", O, l);
          }
          p("top", "left"), p("top", "right"), p("bottom", "left"), p("bottom", "right");
        },
        _clearControlPos: function() {
          for (var i in this._controlCorners)
            it(this._controlCorners[i]);
          it(this._controlContainer), delete this._controlCorners, delete this._controlContainer;
        }
      });
      var qs = nn.extend({
        // @section
        // @aka Control.Layers options
        options: {
          // @option collapsed: Boolean = true
          // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
          collapsed: !0,
          position: "topright",
          // @option autoZIndex: Boolean = true
          // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
          autoZIndex: !0,
          // @option hideSingleBase: Boolean = false
          // If `true`, the base layers in the control will be hidden when there is only one.
          hideSingleBase: !1,
          // @option sortLayers: Boolean = false
          // Whether to sort the layers. When `false`, layers will keep the order
          // in which they were added to the control.
          sortLayers: !1,
          // @option sortFunction: Function = *
          // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
          // that will be used for sorting the layers, when `sortLayers` is `true`.
          // The function receives both the `L.Layer` instances and their names, as in
          // `sortFunction(layerA, layerB, nameA, nameB)`.
          // By default, it sorts layers alphabetically by their name.
          sortFunction: function(i, o, l, p) {
            return l < p ? -1 : p < l ? 1 : 0;
          }
        },
        initialize: function(i, o, l) {
          x(this, l), this._layerControlInputs = [], this._layers = [], this._lastZIndex = 0, this._handlingClick = !1, this._preventClick = !1;
          for (var p in i)
            this._addLayer(i[p], p);
          for (p in o)
            this._addLayer(o[p], p, !0);
        },
        onAdd: function(i) {
          this._initLayout(), this._update(), this._map = i, i.on("zoomend", this._checkDisabledLayers, this);
          for (var o = 0; o < this._layers.length; o++)
            this._layers[o].layer.on("add remove", this._onLayerChange, this);
          return this._container;
        },
        addTo: function(i) {
          return nn.prototype.addTo.call(this, i), this._expandIfNotCollapsed();
        },
        onRemove: function() {
          this._map.off("zoomend", this._checkDisabledLayers, this);
          for (var i = 0; i < this._layers.length; i++)
            this._layers[i].layer.off("add remove", this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(i, o) {
          return this._addLayer(i, o), this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(i, o) {
          return this._addLayer(i, o, !0), this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(i) {
          i.off("add remove", this._onLayerChange, this);
          var o = this._getLayer(g(i));
          return o && this._layers.splice(this._layers.indexOf(o), 1), this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
          Se(this._container, "leaflet-control-layers-expanded"), this._section.style.height = null;
          var i = this._map.getSize().y - (this._container.offsetTop + 50);
          return i < this._section.clientHeight ? (Se(this._section, "leaflet-control-layers-scrollbar"), this._section.style.height = i + "px") : rt(this._section, "leaflet-control-layers-scrollbar"), this._checkDisabledLayers(), this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
          return rt(this._container, "leaflet-control-layers-expanded"), this;
        },
        _initLayout: function() {
          var i = "leaflet-control-layers", o = this._container = Ve("div", i), l = this.options.collapsed;
          o.setAttribute("aria-haspopup", !0), Ur(o), Zs(o);
          var p = this._section = Ve("section", i + "-list");
          l && (this._map.on("click", this.collapse, this), we(o, {
            mouseenter: this._expandSafely,
            mouseleave: this.collapse
          }, this));
          var v = this._layersLink = Ve("a", i + "-toggle", o);
          v.href = "#", v.title = "Layers", v.setAttribute("role", "button"), we(v, {
            keydown: function(C) {
              C.keyCode === 13 && this._expandSafely();
            },
            // Certain screen readers intercept the key event and instead send a click event
            click: function(C) {
              Ce(C), this._expandSafely();
            }
          }, this), l || this.expand(), this._baseLayersList = Ve("div", i + "-base", p), this._separator = Ve("div", i + "-separator", p), this._overlaysList = Ve("div", i + "-overlays", p), o.appendChild(p);
        },
        _getLayer: function(i) {
          for (var o = 0; o < this._layers.length; o++)
            if (this._layers[o] && g(this._layers[o].layer) === i)
              return this._layers[o];
        },
        _addLayer: function(i, o, l) {
          this._map && i.on("add remove", this._onLayerChange, this), this._layers.push({
            layer: i,
            name: o,
            overlay: l
          }), this.options.sortLayers && this._layers.sort(d(function(p, v) {
            return this.options.sortFunction(p.layer, v.layer, p.name, v.name);
          }, this)), this.options.autoZIndex && i.setZIndex && (this._lastZIndex++, i.setZIndex(this._lastZIndex)), this._expandIfNotCollapsed();
        },
        _update: function() {
          if (!this._container)
            return this;
          zr(this._baseLayersList), zr(this._overlaysList), this._layerControlInputs = [];
          var i, o, l, p, v = 0;
          for (l = 0; l < this._layers.length; l++)
            p = this._layers[l], this._addItem(p), o = o || p.overlay, i = i || !p.overlay, v += p.overlay ? 0 : 1;
          return this.options.hideSingleBase && (i = i && v > 1, this._baseLayersList.style.display = i ? "" : "none"), this._separator.style.display = o && i ? "" : "none", this;
        },
        _onLayerChange: function(i) {
          this._handlingClick || this._update();
          var o = this._getLayer(g(i.target)), l = o.overlay ? i.type === "add" ? "overlayadd" : "overlayremove" : i.type === "add" ? "baselayerchange" : null;
          l && this._map.fire(l, o);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(i, o) {
          var l = '<input type="radio" class="leaflet-control-layers-selector" name="' + i + '"' + (o ? ' checked="checked"' : "") + "/>", p = document.createElement("div");
          return p.innerHTML = l, p.firstChild;
        },
        _addItem: function(i) {
          var o = document.createElement("label"), l = this._map.hasLayer(i.layer), p;
          i.overlay ? (p = document.createElement("input"), p.type = "checkbox", p.className = "leaflet-control-layers-selector", p.defaultChecked = l) : p = this._createRadioElement("leaflet-base-layers_" + g(this), l), this._layerControlInputs.push(p), p.layerId = g(i.layer), we(p, "click", this._onInputClick, this);
          var v = document.createElement("span");
          v.innerHTML = " " + i.name;
          var C = document.createElement("span");
          o.appendChild(C), C.appendChild(p), C.appendChild(v);
          var O = i.overlay ? this._overlaysList : this._baseLayersList;
          return O.appendChild(o), this._checkDisabledLayers(), o;
        },
        _onInputClick: function() {
          if (!this._preventClick) {
            var i = this._layerControlInputs, o, l, p = [], v = [];
            this._handlingClick = !0;
            for (var C = i.length - 1; C >= 0; C--)
              o = i[C], l = this._getLayer(o.layerId).layer, o.checked ? p.push(l) : o.checked || v.push(l);
            for (C = 0; C < v.length; C++)
              this._map.hasLayer(v[C]) && this._map.removeLayer(v[C]);
            for (C = 0; C < p.length; C++)
              this._map.hasLayer(p[C]) || this._map.addLayer(p[C]);
            this._handlingClick = !1, this._refocusOnMap();
          }
        },
        _checkDisabledLayers: function() {
          for (var i = this._layerControlInputs, o, l, p = this._map.getZoom(), v = i.length - 1; v >= 0; v--)
            o = i[v], l = this._getLayer(o.layerId).layer, o.disabled = l.options.minZoom !== void 0 && p < l.options.minZoom || l.options.maxZoom !== void 0 && p > l.options.maxZoom;
        },
        _expandIfNotCollapsed: function() {
          return this._map && !this.options.collapsed && this.expand(), this;
        },
        _expandSafely: function() {
          var i = this._section;
          this._preventClick = !0, we(i, "click", Ce), this.expand();
          var o = this;
          setTimeout(function() {
            et(i, "click", Ce), o._preventClick = !1;
          });
        }
      }), Ks = function(i, o, l) {
        return new qs(i, o, l);
      }, Zt = nn.extend({
        // @section
        // @aka Control.Zoom options
        options: {
          position: "topleft",
          // @option zoomInText: String = '<span aria-hidden="true">+</span>'
          // The text set on the 'zoom in' button.
          zoomInText: '<span aria-hidden="true">+</span>',
          // @option zoomInTitle: String = 'Zoom in'
          // The title set on the 'zoom in' button.
          zoomInTitle: "Zoom in",
          // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
          // The text set on the 'zoom out' button.
          zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
          // @option zoomOutTitle: String = 'Zoom out'
          // The title set on the 'zoom out' button.
          zoomOutTitle: "Zoom out"
        },
        onAdd: function(i) {
          var o = "leaflet-control-zoom", l = Ve("div", o + " leaflet-bar"), p = this.options;
          return this._zoomInButton = this._createButton(
            p.zoomInText,
            p.zoomInTitle,
            o + "-in",
            l,
            this._zoomIn
          ), this._zoomOutButton = this._createButton(
            p.zoomOutText,
            p.zoomOutTitle,
            o + "-out",
            l,
            this._zoomOut
          ), this._updateDisabled(), i.on("zoomend zoomlevelschange", this._updateDisabled, this), l;
        },
        onRemove: function(i) {
          i.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
          return this._disabled = !0, this._updateDisabled(), this;
        },
        enable: function() {
          return this._disabled = !1, this._updateDisabled(), this;
        },
        _zoomIn: function(i) {
          !this._disabled && this._map._zoom < this._map.getMaxZoom() && this._map.zoomIn(this._map.options.zoomDelta * (i.shiftKey ? 3 : 1));
        },
        _zoomOut: function(i) {
          !this._disabled && this._map._zoom > this._map.getMinZoom() && this._map.zoomOut(this._map.options.zoomDelta * (i.shiftKey ? 3 : 1));
        },
        _createButton: function(i, o, l, p, v) {
          var C = Ve("a", l, p);
          return C.innerHTML = i, C.href = "#", C.title = o, C.setAttribute("role", "button"), C.setAttribute("aria-label", o), Ur(C), we(C, "click", He), we(C, "click", v, this), we(C, "click", this._refocusOnMap, this), C;
        },
        _updateDisabled: function() {
          var i = this._map, o = "leaflet-disabled";
          rt(this._zoomInButton, o), rt(this._zoomOutButton, o), this._zoomInButton.setAttribute("aria-disabled", "false"), this._zoomOutButton.setAttribute("aria-disabled", "false"), (this._disabled || i._zoom === i.getMinZoom()) && (Se(this._zoomOutButton, o), this._zoomOutButton.setAttribute("aria-disabled", "true")), (this._disabled || i._zoom === i.getMaxZoom()) && (Se(this._zoomInButton, o), this._zoomInButton.setAttribute("aria-disabled", "true"));
        }
      });
      De.mergeOptions({
        zoomControl: !0
      }), De.addInitHook(function() {
        this.options.zoomControl && (this.zoomControl = new Zt(), this.addControl(this.zoomControl));
      });
      var al = function(i) {
        return new Zt(i);
      }, Ys = nn.extend({
        // @section
        // @aka Control.Scale options
        options: {
          position: "bottomleft",
          // @option maxWidth: Number = 100
          // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
          maxWidth: 100,
          // @option metric: Boolean = True
          // Whether to show the metric scale line (m/km).
          metric: !0,
          // @option imperial: Boolean = True
          // Whether to show the imperial scale line (mi/ft).
          imperial: !0
          // @option updateWhenIdle: Boolean = false
          // If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
        },
        onAdd: function(i) {
          var o = "leaflet-control-scale", l = Ve("div", o), p = this.options;
          return this._addScales(p, o + "-line", l), i.on(p.updateWhenIdle ? "moveend" : "move", this._update, this), i.whenReady(this._update, this), l;
        },
        onRemove: function(i) {
          i.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(i, o, l) {
          i.metric && (this._mScale = Ve("div", o, l)), i.imperial && (this._iScale = Ve("div", o, l));
        },
        _update: function() {
          var i = this._map, o = i.getSize().y / 2, l = i.distance(
            i.containerPointToLatLng([0, o]),
            i.containerPointToLatLng([this.options.maxWidth, o])
          );
          this._updateScales(l);
        },
        _updateScales: function(i) {
          this.options.metric && i && this._updateMetric(i), this.options.imperial && i && this._updateImperial(i);
        },
        _updateMetric: function(i) {
          var o = this._getRoundNum(i), l = o < 1e3 ? o + " m" : o / 1e3 + " km";
          this._updateScale(this._mScale, l, o / i);
        },
        _updateImperial: function(i) {
          var o = i * 3.2808399, l, p, v;
          o > 5280 ? (l = o / 5280, p = this._getRoundNum(l), this._updateScale(this._iScale, p + " mi", p / l)) : (v = this._getRoundNum(o), this._updateScale(this._iScale, v + " ft", v / o));
        },
        _updateScale: function(i, o, l) {
          i.style.width = Math.round(this.options.maxWidth * l) + "px", i.innerHTML = o;
        },
        _getRoundNum: function(i) {
          var o = Math.pow(10, (Math.floor(i) + "").length - 1), l = i / o;
          return l = l >= 10 ? 10 : l >= 5 ? 5 : l >= 3 ? 3 : l >= 2 ? 2 : 1, o * l;
        }
      }), ll = function(i) {
        return new Ys(i);
      }, ul = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>', Fo = nn.extend({
        // @section
        // @aka Control.Attribution options
        options: {
          position: "bottomright",
          // @option prefix: String|false = 'Leaflet'
          // The HTML text shown before the attributions. Pass `false` to disable.
          prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (le.inlineSvg ? ul + " " : "") + "Leaflet</a>"
        },
        initialize: function(i) {
          x(this, i), this._attributions = {};
        },
        onAdd: function(i) {
          i.attributionControl = this, this._container = Ve("div", "leaflet-control-attribution"), Ur(this._container);
          for (var o in i._layers)
            i._layers[o].getAttribution && this.addAttribution(i._layers[o].getAttribution());
          return this._update(), i.on("layeradd", this._addAttribution, this), this._container;
        },
        onRemove: function(i) {
          i.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(i) {
          i.layer.getAttribution && (this.addAttribution(i.layer.getAttribution()), i.layer.once("remove", function() {
            this.removeAttribution(i.layer.getAttribution());
          }, this));
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(i) {
          return this.options.prefix = i, this._update(), this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(i) {
          return i ? (this._attributions[i] || (this._attributions[i] = 0), this._attributions[i]++, this._update(), this) : this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(i) {
          return i ? (this._attributions[i] && (this._attributions[i]--, this._update()), this) : this;
        },
        _update: function() {
          if (this._map) {
            var i = [];
            for (var o in this._attributions)
              this._attributions[o] && i.push(o);
            var l = [];
            this.options.prefix && l.push(this.options.prefix), i.length && l.push(i.join(", ")), this._container.innerHTML = l.join(' <span aria-hidden="true">|</span> ');
          }
        }
      });
      De.mergeOptions({
        attributionControl: !0
      }), De.addInitHook(function() {
        this.options.attributionControl && new Fo().addTo(this);
      });
      var cl = function(i) {
        return new Fo(i);
      };
      nn.Layers = qs, nn.Zoom = Zt, nn.Scale = Ys, nn.Attribution = Fo, Mn.layers = Ks, Mn.zoom = al, Mn.scale = ll, Mn.attribution = cl;
      var ut = At.extend({
        initialize: function(i) {
          this._map = i;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
          return this._enabled ? this : (this._enabled = !0, this.addHooks(), this);
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
          return this._enabled ? (this._enabled = !1, this.removeHooks(), this) : this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
          return !!this._enabled;
        }
        // @section Extension methods
        // Classes inheriting from `Handler` must implement the two following methods:
        // @method addHooks()
        // Called when the handler is enabled, should add event hooks.
        // @method removeHooks()
        // Called when the handler is disabled, should remove the event hooks added previously.
      });
      ut.addTo = function(i, o) {
        return i.addHandler(o, this), this;
      };
      var uc = { Events: gt }, rn = le.touch ? "touchstart mousedown" : "mousedown", ai = Ln.extend({
        options: {
          // @section
          // @aka Draggable options
          // @option clickTolerance: Number = 3
          // The max number of pixels a user can shift the mouse pointer during a click
          // for it to be considered a valid click (as opposed to a mouse drag).
          clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(i, o, l, p) {
          x(this, p), this._element = i, this._dragStartTarget = o || i, this._preventOutline = l;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
          this._enabled || (we(this._dragStartTarget, rn, this._onDown, this), this._enabled = !0);
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
          this._enabled && (ai._dragging === this && this.finishDrag(!0), et(this._dragStartTarget, rn, this._onDown, this), this._enabled = !1, this._moved = !1);
        },
        _onDown: function(i) {
          if (this._enabled && (this._moved = !1, !Fs(this._element, "leaflet-zoom-anim"))) {
            if (i.touches && i.touches.length !== 1) {
              ai._dragging === this && this.finishDrag();
              return;
            }
            if (!(ai._dragging || i.shiftKey || i.which !== 1 && i.button !== 1 && !i.touches) && (ai._dragging = this, this._preventOutline && zo(this._element), Us(), Pi(), !this._moving)) {
              this.fire("down");
              var o = i.touches ? i.touches[0] : i, l = tl(this._element);
              this._startPoint = new fe(o.clientX, o.clientY), this._startPos = Wn(this._element), this._parentScale = Vs(l);
              var p = i.type === "mousedown";
              we(document, p ? "mousemove" : "touchmove", this._onMove, this), we(document, p ? "mouseup" : "touchend touchcancel", this._onUp, this);
            }
          }
        },
        _onMove: function(i) {
          if (this._enabled) {
            if (i.touches && i.touches.length > 1) {
              this._moved = !0;
              return;
            }
            var o = i.touches && i.touches.length === 1 ? i.touches[0] : i, l = new fe(o.clientX, o.clientY)._subtract(this._startPoint);
            !l.x && !l.y || Math.abs(l.x) + Math.abs(l.y) < this.options.clickTolerance || (l.x /= this._parentScale.x, l.y /= this._parentScale.y, Ce(i), this._moved || (this.fire("dragstart"), this._moved = !0, Se(document.body, "leaflet-dragging"), this._lastTarget = i.target || i.srcElement, window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance && (this._lastTarget = this._lastTarget.correspondingUseElement), Se(this._lastTarget, "leaflet-drag-target")), this._newPos = this._startPos.add(l), this._moving = !0, this._lastEvent = i, this._updatePosition());
          }
        },
        _updatePosition: function() {
          var i = { originalEvent: this._lastEvent };
          this.fire("predrag", i), ft(this._element, this._newPos), this.fire("drag", i);
        },
        _onUp: function() {
          this._enabled && this.finishDrag();
        },
        finishDrag: function(i) {
          rt(document.body, "leaflet-dragging"), this._lastTarget && (rt(this._lastTarget, "leaflet-drag-target"), this._lastTarget = null), et(document, "mousemove touchmove", this._onMove, this), et(document, "mouseup touchend touchcancel", this._onUp, this), $o(), kn();
          var o = this._moved && this._moving;
          this._moving = !1, ai._dragging = !1, o && this.fire("dragend", {
            noInertia: i,
            distance: this._newPos.distanceTo(this._startPos)
          });
        }
      });
      function Qs(i, o, l) {
        var p, v = [1, 4, 2, 8], C, O, B, F, K, ne, he, Te;
        for (C = 0, ne = i.length; C < ne; C++)
          i[C]._code = $n(i[C], o);
        for (B = 0; B < 4; B++) {
          for (he = v[B], p = [], C = 0, ne = i.length, O = ne - 1; C < ne; O = C++)
            F = i[C], K = i[O], F._code & he ? K._code & he || (Te = Hr(K, F, he, o, l), Te._code = $n(Te, o), p.push(Te)) : (K._code & he && (Te = Hr(K, F, he, o, l), Te._code = $n(Te, o), p.push(Te)), p.push(F));
          i = p;
        }
        return i;
      }
      function Gn(i, o) {
        var l, p, v, C, O, B, F, K, ne;
        if (!i || i.length === 0)
          throw new Error("latlngs not passed");
        on(i) || (console.warn("latlngs are not flat! Only the first ring will be used"), i = i[0]);
        var he = Pe([0, 0]), Te = vt(i), yt = Te.getNorthWest().distanceTo(Te.getSouthWest()) * Te.getNorthEast().distanceTo(Te.getNorthWest());
        yt < 1700 && (he = or(i));
        var ct = i.length, kt = [];
        for (l = 0; l < ct; l++) {
          var xt = Pe(i[l]);
          kt.push(o.project(Pe([xt.lat - he.lat, xt.lng - he.lng])));
        }
        for (B = F = K = 0, l = 0, p = ct - 1; l < ct; p = l++)
          v = kt[l], C = kt[p], O = v.y * C.x - C.y * v.x, F += (v.x + C.x) * O, K += (v.y + C.y) * O, B += O * 3;
        B === 0 ? ne = kt[0] : ne = [F / B, K / B];
        var Tn = o.unproject(_e(ne));
        return Pe([Tn.lat + he.lat, Tn.lng + he.lng]);
      }
      function or(i) {
        for (var o = 0, l = 0, p = 0, v = 0; v < i.length; v++) {
          var C = Pe(i[v]);
          o += C.lat, l += C.lng, p++;
        }
        return Pe([o / p, l / p]);
      }
      var Js = {
        __proto__: null,
        clipPolygon: Qs,
        polygonCenter: Gn,
        centroid: or
      };
      function tt(i, o) {
        if (!o || !i.length)
          return i.slice();
        var l = o * o;
        return i = hc(i, l), i = cc(i, l), i;
      }
      function qn(i, o, l) {
        return Math.sqrt(jr(i, o, l, !0));
      }
      function Xs(i, o, l) {
        return jr(i, o, l);
      }
      function cc(i, o) {
        var l = i.length, p = typeof Uint8Array != void 0 + "" ? Uint8Array : Array, v = new p(l);
        v[0] = v[l - 1] = 1, Vr(i, v, o, 0, l - 1);
        var C, O = [];
        for (C = 0; C < l; C++)
          v[C] && O.push(i[C]);
        return O;
      }
      function Vr(i, o, l, p, v) {
        var C = 0, O, B, F;
        for (B = p + 1; B <= v - 1; B++)
          F = jr(i[B], i[p], i[v], !0), F > C && (O = B, C = F);
        C > l && (o[O] = 1, Vr(i, o, l, p, O), Vr(i, o, l, O, v));
      }
      function hc(i, o) {
        for (var l = [i[0]], p = 1, v = 0, C = i.length; p < C; p++)
          sr(i[p], i[v]) > o && (l.push(i[p]), v = p);
        return v < C - 1 && l.push(i[C - 1]), l;
      }
      var hl;
      function fl(i, o, l, p, v) {
        var C = p ? hl : $n(i, l), O = $n(o, l), B, F, K;
        for (hl = O; ; ) {
          if (!(C | O))
            return [i, o];
          if (C & O)
            return !1;
          B = C || O, F = Hr(i, o, B, l, v), K = $n(F, l), B === C ? (i = F, C = K) : (o = F, O = K);
        }
      }
      function Hr(i, o, l, p, v) {
        var C = o.x - i.x, O = o.y - i.y, B = p.min, F = p.max, K, ne;
        return l & 8 ? (K = i.x + C * (F.y - i.y) / O, ne = F.y) : l & 4 ? (K = i.x + C * (B.y - i.y) / O, ne = B.y) : l & 2 ? (K = F.x, ne = i.y + O * (F.x - i.x) / C) : l & 1 && (K = B.x, ne = i.y + O * (B.x - i.x) / C), new fe(K, ne, v);
      }
      function $n(i, o) {
        var l = 0;
        return i.x < o.min.x ? l |= 1 : i.x > o.max.x && (l |= 2), i.y < o.min.y ? l |= 4 : i.y > o.max.y && (l |= 8), l;
      }
      function sr(i, o) {
        var l = o.x - i.x, p = o.y - i.y;
        return l * l + p * p;
      }
      function jr(i, o, l, p) {
        var v = o.x, C = o.y, O = l.x - v, B = l.y - C, F = O * O + B * B, K;
        return F > 0 && (K = ((i.x - v) * O + (i.y - C) * B) / F, K > 1 ? (v = l.x, C = l.y) : K > 0 && (v += O * K, C += B * K)), O = i.x - v, B = i.y - C, p ? O * O + B * B : new fe(v, C);
      }
      function on(i) {
        return !ee(i[0]) || typeof i[0][0] != "object" && typeof i[0][0] < "u";
      }
      function ea(i) {
        return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."), on(i);
      }
      function Uo(i, o) {
        var l, p, v, C, O, B, F, K;
        if (!i || i.length === 0)
          throw new Error("latlngs not passed");
        on(i) || (console.warn("latlngs are not flat! Only the first ring will be used"), i = i[0]);
        var ne = Pe([0, 0]), he = vt(i), Te = he.getNorthWest().distanceTo(he.getSouthWest()) * he.getNorthEast().distanceTo(he.getNorthWest());
        Te < 1700 && (ne = or(i));
        var yt = i.length, ct = [];
        for (l = 0; l < yt; l++) {
          var kt = Pe(i[l]);
          ct.push(o.project(Pe([kt.lat - ne.lat, kt.lng - ne.lng])));
        }
        for (l = 0, p = 0; l < yt - 1; l++)
          p += ct[l].distanceTo(ct[l + 1]) / 2;
        if (p === 0)
          K = ct[0];
        else
          for (l = 0, C = 0; l < yt - 1; l++)
            if (O = ct[l], B = ct[l + 1], v = O.distanceTo(B), C += v, C > p) {
              F = (C - p) / v, K = [
                B.x - F * (B.x - O.x),
                B.y - F * (B.y - O.y)
              ];
              break;
            }
        var xt = o.unproject(_e(K));
        return Pe([xt.lat + ne.lat, xt.lng + ne.lng]);
      }
      var ta = {
        __proto__: null,
        simplify: tt,
        pointToSegmentDistance: qn,
        closestPointOnSegment: Xs,
        clipSegment: fl,
        _getEdgeIntersection: Hr,
        _getBitCode: $n,
        _sqClosestPointOnSegment: jr,
        isFlat: on,
        _flat: ea,
        polylineCenter: Uo
      }, Vo = {
        project: function(i) {
          return new fe(i.lng, i.lat);
        },
        unproject: function(i) {
          return new Re(i.y, i.x);
        },
        bounds: new Ue([-180, -90], [180, 90])
      }, na = {
        R: 6378137,
        R_MINOR: 6356752314245179e-9,
        bounds: new Ue([-2003750834279e-5, -1549657073972e-5], [2003750834279e-5, 1876465623138e-5]),
        project: function(i) {
          var o = Math.PI / 180, l = this.R, p = i.lat * o, v = this.R_MINOR / l, C = Math.sqrt(1 - v * v), O = C * Math.sin(p), B = Math.tan(Math.PI / 4 - p / 2) / Math.pow((1 - O) / (1 + O), C / 2);
          return p = -l * Math.log(Math.max(B, 1e-10)), new fe(i.lng * o * l, p);
        },
        unproject: function(i) {
          for (var o = 180 / Math.PI, l = this.R, p = this.R_MINOR / l, v = Math.sqrt(1 - p * p), C = Math.exp(-i.y / l), O = Math.PI / 2 - 2 * Math.atan(C), B = 0, F = 0.1, K; B < 15 && Math.abs(F) > 1e-7; B++)
            K = v * Math.sin(O), K = Math.pow((1 - K) / (1 + K), v / 2), F = Math.PI / 2 - 2 * Math.atan(C * K) - O, O += F;
          return new Re(O * o, i.x * o / l);
        }
      }, ia = {
        __proto__: null,
        LonLat: Vo,
        Mercator: na,
        SphericalMercator: Ps
      }, ra = u({}, fn, {
        code: "EPSG:3395",
        projection: na,
        transformation: function() {
          var i = 0.5 / (Math.PI * na.R);
          return oi(i, 0.5, -i, 0.5);
        }()
      }), dl = u({}, fn, {
        code: "EPSG:4326",
        projection: Vo,
        transformation: oi(1 / 180, 1, -1 / 180, 0.5)
      }), pl = u({}, Zn, {
        projection: Vo,
        transformation: oi(1, 0, -1, 0),
        scale: function(i) {
          return Math.pow(2, i);
        },
        zoom: function(i) {
          return Math.log(i) / Math.LN2;
        },
        distance: function(i, o) {
          var l = o.lng - i.lng, p = o.lat - i.lat;
          return Math.sqrt(l * l + p * p);
        },
        infinite: !0
      });
      Zn.Earth = fn, Zn.EPSG3395 = ra, Zn.EPSG3857 = Co, Zn.EPSG900913 = Sn, Zn.EPSG4326 = dl, Zn.Simple = pl;
      var lt = Ln.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
          // @option pane: String = 'overlayPane'
          // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
          pane: "overlayPane",
          // @option attribution: String = null
          // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
          attribution: null,
          bubblingMouseEvents: !0
        },
        /* @section
         * Classes extending `L.Layer` will inherit the following methods:
         *
         * @method addTo(map: Map|LayerGroup): this
         * Adds the layer to the given map or layer group.
         */
        addTo: function(i) {
          return i.addLayer(this), this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
          return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(i) {
          return i && i.removeLayer(this), this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(i) {
          return this._map.getPane(i ? this.options[i] || i : this.options.pane);
        },
        addInteractiveTarget: function(i) {
          return this._map._targets[g(i)] = this, this;
        },
        removeInteractiveTarget: function(i) {
          return delete this._map._targets[g(i)], this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
          return this.options.attribution;
        },
        _layerAdd: function(i) {
          var o = i.target;
          if (o.hasLayer(this)) {
            if (this._map = o, this._zoomAnimated = o._zoomAnimated, this.getEvents) {
              var l = this.getEvents();
              o.on(l, this), this.once("remove", function() {
                o.off(l, this);
              }, this);
            }
            this.onAdd(o), this.fire("add"), o.fire("layeradd", { layer: this });
          }
        }
      });
      De.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(i) {
          if (!i._layerAdd)
            throw new Error("The provided object is not a Layer.");
          var o = g(i);
          return this._layers[o] ? this : (this._layers[o] = i, i._mapToAdd = this, i.beforeAdd && i.beforeAdd(this), this.whenReady(i._layerAdd, i), this);
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(i) {
          var o = g(i);
          return this._layers[o] ? (this._loaded && i.onRemove(this), delete this._layers[o], this._loaded && (this.fire("layerremove", { layer: i }), i.fire("remove")), i._map = i._mapToAdd = null, this) : this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(i) {
          return g(i) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
         * Iterates over the layers of the map, optionally specifying context of the iterator function.
         * ```
         * map.eachLayer(function(layer){
         *     layer.bindPopup('Hello');
         * });
         * ```
         */
        eachLayer: function(i, o) {
          for (var l in this._layers)
            i.call(o, this._layers[l]);
          return this;
        },
        _addLayers: function(i) {
          i = i ? ee(i) ? i : [i] : [];
          for (var o = 0, l = i.length; o < l; o++)
            this.addLayer(i[o]);
        },
        _addZoomLimit: function(i) {
          (!isNaN(i.options.maxZoom) || !isNaN(i.options.minZoom)) && (this._zoomBoundLayers[g(i)] = i, this._updateZoomLevels());
        },
        _removeZoomLimit: function(i) {
          var o = g(i);
          this._zoomBoundLayers[o] && (delete this._zoomBoundLayers[o], this._updateZoomLevels());
        },
        _updateZoomLevels: function() {
          var i = 1 / 0, o = -1 / 0, l = this._getZoomSpan();
          for (var p in this._zoomBoundLayers) {
            var v = this._zoomBoundLayers[p].options;
            i = v.minZoom === void 0 ? i : Math.min(i, v.minZoom), o = v.maxZoom === void 0 ? o : Math.max(o, v.maxZoom);
          }
          this._layersMaxZoom = o === -1 / 0 ? void 0 : o, this._layersMinZoom = i === 1 / 0 ? void 0 : i, l !== this._getZoomSpan() && this.fire("zoomlevelschange"), this.options.maxZoom === void 0 && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom && this.setZoom(this._layersMaxZoom), this.options.minZoom === void 0 && this._layersMinZoom && this.getZoom() < this._layersMinZoom && this.setZoom(this._layersMinZoom);
        }
      });
      var li = lt.extend({
        initialize: function(i, o) {
          x(this, o), this._layers = {};
          var l, p;
          if (i)
            for (l = 0, p = i.length; l < p; l++)
              this.addLayer(i[l]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(i) {
          var o = this.getLayerId(i);
          return this._layers[o] = i, this._map && this._map.addLayer(i), this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(i) {
          var o = i in this._layers ? i : this.getLayerId(i);
          return this._map && this._layers[o] && this._map.removeLayer(this._layers[o]), delete this._layers[o], this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(i) {
          var o = typeof i == "number" ? i : this.getLayerId(i);
          return o in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
          return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(i) {
          var o = Array.prototype.slice.call(arguments, 1), l, p;
          for (l in this._layers)
            p = this._layers[l], p[i] && p[i].apply(p, o);
          return this;
        },
        onAdd: function(i) {
          this.eachLayer(i.addLayer, i);
        },
        onRemove: function(i) {
          this.eachLayer(i.removeLayer, i);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(i, o) {
          for (var l in this._layers)
            i.call(o, this._layers[l]);
          return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(i) {
          return this._layers[i];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
          var i = [];
          return this.eachLayer(i.push, i), i;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(i) {
          return this.invoke("setZIndex", i);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(i) {
          return g(i);
        }
      }), Zr = function(i, o) {
        return new li(i, o);
      }, Rn = li.extend({
        addLayer: function(i) {
          return this.hasLayer(i) ? this : (i.addEventParent(this), li.prototype.addLayer.call(this, i), this.fire("layeradd", { layer: i }));
        },
        removeLayer: function(i) {
          return this.hasLayer(i) ? (i in this._layers && (i = this._layers[i]), i.removeEventParent(this), li.prototype.removeLayer.call(this, i), this.fire("layerremove", { layer: i })) : this;
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(i) {
          return this.invoke("setStyle", i);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
          return this.invoke("bringToFront");
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
          return this.invoke("bringToBack");
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
          var i = new jt();
          for (var o in this._layers) {
            var l = this._layers[o];
            i.extend(l.getBounds ? l.getBounds() : l.getLatLng());
          }
          return i;
        }
      }), ml = function(i, o) {
        return new Rn(i, o);
      }, ar = At.extend({
        /* @section
         * @aka Icon options
         *
         * @option iconUrl: String = null
         * **(required)** The URL to the icon image (absolute or relative to your script path).
         *
         * @option iconRetinaUrl: String = null
         * The URL to a retina sized version of the icon image (absolute or relative to your
         * script path). Used for Retina screen devices.
         *
         * @option iconSize: Point = null
         * Size of the icon image in pixels.
         *
         * @option iconAnchor: Point = null
         * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
         * will be aligned so that this point is at the marker's geographical location. Centered
         * by default if size is specified, also can be set in CSS with negative margins.
         *
         * @option popupAnchor: Point = [0, 0]
         * The coordinates of the point from which popups will "open", relative to the icon anchor.
         *
         * @option tooltipAnchor: Point = [0, 0]
         * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
         *
         * @option shadowUrl: String = null
         * The URL to the icon shadow image. If not specified, no shadow image will be created.
         *
         * @option shadowRetinaUrl: String = null
         *
         * @option shadowSize: Point = null
         * Size of the shadow image in pixels.
         *
         * @option shadowAnchor: Point = null
         * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
         * as iconAnchor if not specified).
         *
         * @option className: String = ''
         * A custom class name to assign to both icon and shadow images. Empty by default.
         */
        options: {
          popupAnchor: [0, 0],
          tooltipAnchor: [0, 0],
          // @option crossOrigin: Boolean|String = false
          // Whether the crossOrigin attribute will be added to the tiles.
          // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
          // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
          crossOrigin: !1
        },
        initialize: function(i) {
          x(this, i);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(i) {
          return this._createIcon("icon", i);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(i) {
          return this._createIcon("shadow", i);
        },
        _createIcon: function(i, o) {
          var l = this._getIconUrl(i);
          if (!l) {
            if (i === "icon")
              throw new Error("iconUrl not set in Icon options (see the docs).");
            return null;
          }
          var p = this._createImg(l, o && o.tagName === "IMG" ? o : null);
          return this._setIconStyles(p, i), (this.options.crossOrigin || this.options.crossOrigin === "") && (p.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), p;
        },
        _setIconStyles: function(i, o) {
          var l = this.options, p = l[o + "Size"];
          typeof p == "number" && (p = [p, p]);
          var v = _e(p), C = _e(o === "shadow" && l.shadowAnchor || l.iconAnchor || v && v.divideBy(2, !0));
          i.className = "leaflet-marker-" + o + " " + (l.className || ""), C && (i.style.marginLeft = -C.x + "px", i.style.marginTop = -C.y + "px"), v && (i.style.width = v.x + "px", i.style.height = v.y + "px");
        },
        _createImg: function(i, o) {
          return o = o || document.createElement("img"), o.src = i, o;
        },
        _getIconUrl: function(i) {
          return le.retina && this.options[i + "RetinaUrl"] || this.options[i + "Url"];
        }
      });
      function fc(i) {
        return new ar(i);
      }
      var Wr = ar.extend({
        options: {
          iconUrl: "marker-icon.png",
          iconRetinaUrl: "marker-icon-2x.png",
          shadowUrl: "marker-shadow.png",
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          tooltipAnchor: [16, -28],
          shadowSize: [41, 41]
        },
        _getIconUrl: function(i) {
          return typeof Wr.imagePath != "string" && (Wr.imagePath = this._detectIconPath()), (this.options.imagePath || Wr.imagePath) + ar.prototype._getIconUrl.call(this, i);
        },
        _stripUrl: function(i) {
          var o = function(l, p, v) {
            var C = p.exec(l);
            return C && C[v];
          };
          return i = o(i, /^url\((['"])?(.+)\1\)$/, 2), i && o(i, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
          var i = Ve("div", "leaflet-default-icon-path", document.body), o = Rr(i, "background-image") || Rr(i, "backgroundImage");
          if (document.body.removeChild(i), o = this._stripUrl(o), o)
            return o;
          var l = document.querySelector('link[href$="leaflet.css"]');
          return l ? l.href.substring(0, l.href.length - 11 - 1) : "";
        }
      }), _l = ut.extend({
        initialize: function(i) {
          this._marker = i;
        },
        addHooks: function() {
          var i = this._marker._icon;
          this._draggable || (this._draggable = new ai(i, i, !0)), this._draggable.on({
            dragstart: this._onDragStart,
            predrag: this._onPreDrag,
            drag: this._onDrag,
            dragend: this._onDragEnd
          }, this).enable(), Se(i, "leaflet-marker-draggable");
        },
        removeHooks: function() {
          this._draggable.off({
            dragstart: this._onDragStart,
            predrag: this._onPreDrag,
            drag: this._onDrag,
            dragend: this._onDragEnd
          }, this).disable(), this._marker._icon && rt(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
          return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(i) {
          var o = this._marker, l = o._map, p = this._marker.options.autoPanSpeed, v = this._marker.options.autoPanPadding, C = Wn(o._icon), O = l.getPixelBounds(), B = l.getPixelOrigin(), F = Ht(
            O.min._subtract(B).add(v),
            O.max._subtract(B).subtract(v)
          );
          if (!F.contains(C)) {
            var K = _e(
              (Math.max(F.max.x, C.x) - F.max.x) / (O.max.x - F.max.x) - (Math.min(F.min.x, C.x) - F.min.x) / (O.min.x - F.min.x),
              (Math.max(F.max.y, C.y) - F.max.y) / (O.max.y - F.max.y) - (Math.min(F.min.y, C.y) - F.min.y) / (O.min.y - F.min.y)
            ).multiplyBy(p);
            l.panBy(K, { animate: !1 }), this._draggable._newPos._add(K), this._draggable._startPos._add(K), ft(o._icon, this._draggable._newPos), this._onDrag(i), this._panRequest = _t(this._adjustPan.bind(this, i));
          }
        },
        _onDragStart: function() {
          this._oldLatLng = this._marker.getLatLng(), this._marker.closePopup && this._marker.closePopup(), this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(i) {
          this._marker.options.autoPan && (nt(this._panRequest), this._panRequest = _t(this._adjustPan.bind(this, i)));
        },
        _onDrag: function(i) {
          var o = this._marker, l = o._shadow, p = Wn(o._icon), v = o._map.layerPointToLatLng(p);
          l && ft(l, p), o._latlng = v, i.latlng = v, i.oldLatLng = this._oldLatLng, o.fire("move", i).fire("drag", i);
        },
        _onDragEnd: function(i) {
          nt(this._panRequest), delete this._oldLatLng, this._marker.fire("moveend").fire("dragend", i);
        }
      }), Ho = lt.extend({
        // @section
        // @aka Marker options
        options: {
          // @option icon: Icon = *
          // Icon instance to use for rendering the marker.
          // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
          // If not specified, a common instance of `L.Icon.Default` is used.
          icon: new Wr(),
          // Option inherited from "Interactive layer" abstract class
          interactive: !0,
          // @option keyboard: Boolean = true
          // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
          keyboard: !0,
          // @option title: String = ''
          // Text for the browser tooltip that appear on marker hover (no tooltip by default).
          // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
          title: "",
          // @option alt: String = 'Marker'
          // Text for the `alt` attribute of the icon image.
          // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
          alt: "Marker",
          // @option zIndexOffset: Number = 0
          // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
          zIndexOffset: 0,
          // @option opacity: Number = 1.0
          // The opacity of the marker.
          opacity: 1,
          // @option riseOnHover: Boolean = false
          // If `true`, the marker will get on top of others when you hover the mouse over it.
          riseOnHover: !1,
          // @option riseOffset: Number = 250
          // The z-index offset used for the `riseOnHover` feature.
          riseOffset: 250,
          // @option pane: String = 'markerPane'
          // `Map pane` where the markers icon will be added.
          pane: "markerPane",
          // @option shadowPane: String = 'shadowPane'
          // `Map pane` where the markers shadow will be added.
          shadowPane: "shadowPane",
          // @option bubblingMouseEvents: Boolean = false
          // When `true`, a mouse event on this marker will trigger the same event on the map
          // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
          bubblingMouseEvents: !1,
          // @option autoPanOnFocus: Boolean = true
          // When `true`, the map will pan whenever the marker is focused (via
          // e.g. pressing `tab` on the keyboard) to ensure the marker is
          // visible within the map's bounds
          autoPanOnFocus: !0,
          // @section Draggable marker options
          // @option draggable: Boolean = false
          // Whether the marker is draggable with mouse/touch or not.
          draggable: !1,
          // @option autoPan: Boolean = false
          // Whether to pan the map when dragging this marker near its edge or not.
          autoPan: !1,
          // @option autoPanPadding: Point = Point(50, 50)
          // Distance (in pixels to the left/right and to the top/bottom) of the
          // map edge to start panning the map.
          autoPanPadding: [50, 50],
          // @option autoPanSpeed: Number = 10
          // Number of pixels the map should pan by.
          autoPanSpeed: 10
        },
        /* @section
         *
         * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
         */
        initialize: function(i, o) {
          x(this, o), this._latlng = Pe(i);
        },
        onAdd: function(i) {
          this._zoomAnimated = this._zoomAnimated && i.options.markerZoomAnimation, this._zoomAnimated && i.on("zoomanim", this._animateZoom, this), this._initIcon(), this.update();
        },
        onRemove: function(i) {
          this.dragging && this.dragging.enabled() && (this.options.draggable = !0, this.dragging.removeHooks()), delete this.dragging, this._zoomAnimated && i.off("zoomanim", this._animateZoom, this), this._removeIcon(), this._removeShadow();
        },
        getEvents: function() {
          return {
            zoom: this.update,
            viewreset: this.update
          };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
          return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(i) {
          var o = this._latlng;
          return this._latlng = Pe(i), this.update(), this.fire("move", { oldLatLng: o, latlng: this._latlng });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(i) {
          return this.options.zIndexOffset = i, this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
          return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(i) {
          return this.options.icon = i, this._map && (this._initIcon(), this.update()), this._popup && this.bindPopup(this._popup, this._popup.options), this;
        },
        getElement: function() {
          return this._icon;
        },
        update: function() {
          if (this._icon && this._map) {
            var i = this._map.latLngToLayerPoint(this._latlng).round();
            this._setPos(i);
          }
          return this;
        },
        _initIcon: function() {
          var i = this.options, o = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide"), l = i.icon.createIcon(this._icon), p = !1;
          l !== this._icon && (this._icon && this._removeIcon(), p = !0, i.title && (l.title = i.title), l.tagName === "IMG" && (l.alt = i.alt || "")), Se(l, o), i.keyboard && (l.tabIndex = "0", l.setAttribute("role", "button")), this._icon = l, i.riseOnHover && this.on({
            mouseover: this._bringToFront,
            mouseout: this._resetZIndex
          }), this.options.autoPanOnFocus && we(l, "focus", this._panOnFocus, this);
          var v = i.icon.createShadow(this._shadow), C = !1;
          v !== this._shadow && (this._removeShadow(), C = !0), v && (Se(v, o), v.alt = ""), this._shadow = v, i.opacity < 1 && this._updateOpacity(), p && this.getPane().appendChild(this._icon), this._initInteraction(), v && C && this.getPane(i.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
          this.options.riseOnHover && this.off({
            mouseover: this._bringToFront,
            mouseout: this._resetZIndex
          }), this.options.autoPanOnFocus && et(this._icon, "focus", this._panOnFocus, this), it(this._icon), this.removeInteractiveTarget(this._icon), this._icon = null;
        },
        _removeShadow: function() {
          this._shadow && it(this._shadow), this._shadow = null;
        },
        _setPos: function(i) {
          this._icon && ft(this._icon, i), this._shadow && ft(this._shadow, i), this._zIndex = i.y + this.options.zIndexOffset, this._resetZIndex();
        },
        _updateZIndex: function(i) {
          this._icon && (this._icon.style.zIndex = this._zIndex + i);
        },
        _animateZoom: function(i) {
          var o = this._map._latLngToNewLayerPoint(this._latlng, i.zoom, i.center).round();
          this._setPos(o);
        },
        _initInteraction: function() {
          if (this.options.interactive && (Se(this._icon, "leaflet-interactive"), this.addInteractiveTarget(this._icon), _l)) {
            var i = this.options.draggable;
            this.dragging && (i = this.dragging.enabled(), this.dragging.disable()), this.dragging = new _l(this), i && this.dragging.enable();
          }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(i) {
          return this.options.opacity = i, this._map && this._updateOpacity(), this;
        },
        _updateOpacity: function() {
          var i = this.options.opacity;
          this._icon && tn(this._icon, i), this._shadow && tn(this._shadow, i);
        },
        _bringToFront: function() {
          this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
          this._updateZIndex(0);
        },
        _panOnFocus: function() {
          var i = this._map;
          if (i) {
            var o = this.options.icon.options, l = o.iconSize ? _e(o.iconSize) : _e(0, 0), p = o.iconAnchor ? _e(o.iconAnchor) : _e(0, 0);
            i.panInside(this._latlng, {
              paddingTopLeft: p,
              paddingBottomRight: l.subtract(p)
            });
          }
        },
        _getPopupAnchor: function() {
          return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
          return this.options.icon.options.tooltipAnchor;
        }
      });
      function lr(i, o) {
        return new Ho(i, o);
      }
      var ui = lt.extend({
        // @section
        // @aka Path options
        options: {
          // @option stroke: Boolean = true
          // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
          stroke: !0,
          // @option color: String = '#3388ff'
          // Stroke color
          color: "#3388ff",
          // @option weight: Number = 3
          // Stroke width in pixels
          weight: 3,
          // @option opacity: Number = 1.0
          // Stroke opacity
          opacity: 1,
          // @option lineCap: String= 'round'
          // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
          lineCap: "round",
          // @option lineJoin: String = 'round'
          // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
          lineJoin: "round",
          // @option dashArray: String = null
          // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
          dashArray: null,
          // @option dashOffset: String = null
          // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
          dashOffset: null,
          // @option fill: Boolean = depends
          // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
          fill: !1,
          // @option fillColor: String = *
          // Fill color. Defaults to the value of the [`color`](#path-color) option
          fillColor: null,
          // @option fillOpacity: Number = 0.2
          // Fill opacity.
          fillOpacity: 0.2,
          // @option fillRule: String = 'evenodd'
          // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
          fillRule: "evenodd",
          // className: '',
          // Option inherited from "Interactive layer" abstract class
          interactive: !0,
          // @option bubblingMouseEvents: Boolean = true
          // When `true`, a mouse event on this path will trigger the same event on the map
          // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
          bubblingMouseEvents: !0
        },
        beforeAdd: function(i) {
          this._renderer = i.getRenderer(this);
        },
        onAdd: function() {
          this._renderer._initPath(this), this._reset(), this._renderer._addPath(this);
        },
        onRemove: function() {
          this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
          return this._map && this._renderer._updatePath(this), this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(i) {
          return x(this, i), this._renderer && (this._renderer._updateStyle(this), this.options.stroke && i && Object.prototype.hasOwnProperty.call(i, "weight") && this._updateBounds()), this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
          return this._renderer && this._renderer._bringToFront(this), this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
          return this._renderer && this._renderer._bringToBack(this), this;
        },
        getElement: function() {
          return this._path;
        },
        _reset: function() {
          this._project(), this._update();
        },
        _clickTolerance: function() {
          return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
      }), jo = ui.extend({
        // @section
        // @aka CircleMarker options
        options: {
          fill: !0,
          // @option radius: Number = 10
          // Radius of the circle marker, in pixels
          radius: 10
        },
        initialize: function(i, o) {
          x(this, o), this._latlng = Pe(i), this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(i) {
          var o = this._latlng;
          return this._latlng = Pe(i), this.redraw(), this.fire("move", { oldLatLng: o, latlng: this._latlng });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
          return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(i) {
          return this.options.radius = this._radius = i, this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
          return this._radius;
        },
        setStyle: function(i) {
          var o = i && i.radius || this._radius;
          return ui.prototype.setStyle.call(this, i), this.setRadius(o), this;
        },
        _project: function() {
          this._point = this._map.latLngToLayerPoint(this._latlng), this._updateBounds();
        },
        _updateBounds: function() {
          var i = this._radius, o = this._radiusY || i, l = this._clickTolerance(), p = [i + l, o + l];
          this._pxBounds = new Ue(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
          this._map && this._updatePath();
        },
        _updatePath: function() {
          this._renderer._updateCircle(this);
        },
        _empty: function() {
          return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(i) {
          return i.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
      });
      function oa(i, o) {
        return new jo(i, o);
      }
      var Zo = jo.extend({
        initialize: function(i, o, l) {
          if (typeof o == "number" && (o = u({}, l, { radius: o })), x(this, o), this._latlng = Pe(i), isNaN(this.options.radius))
            throw new Error("Circle radius cannot be NaN");
          this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(i) {
          return this._mRadius = i, this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
          return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
          var i = [this._radius, this._radiusY || this._radius];
          return new jt(
            this._map.layerPointToLatLng(this._point.subtract(i)),
            this._map.layerPointToLatLng(this._point.add(i))
          );
        },
        setStyle: ui.prototype.setStyle,
        _project: function() {
          var i = this._latlng.lng, o = this._latlng.lat, l = this._map, p = l.options.crs;
          if (p.distance === fn.distance) {
            var v = Math.PI / 180, C = this._mRadius / fn.R / v, O = l.project([o + C, i]), B = l.project([o - C, i]), F = O.add(B).divideBy(2), K = l.unproject(F).lat, ne = Math.acos((Math.cos(C * v) - Math.sin(o * v) * Math.sin(K * v)) / (Math.cos(o * v) * Math.cos(K * v))) / v;
            (isNaN(ne) || ne === 0) && (ne = C / Math.cos(Math.PI / 180 * o)), this._point = F.subtract(l.getPixelOrigin()), this._radius = isNaN(ne) ? 0 : F.x - l.project([K, i - ne]).x, this._radiusY = F.y - O.y;
          } else {
            var he = p.unproject(p.project(this._latlng).subtract([this._mRadius, 0]));
            this._point = l.latLngToLayerPoint(this._latlng), this._radius = this._point.x - l.latLngToLayerPoint(he).x;
          }
          this._updateBounds();
        }
      });
      function ci(i, o, l) {
        return new Zo(i, o, l);
      }
      var dn = ui.extend({
        // @section
        // @aka Polyline options
        options: {
          // @option smoothFactor: Number = 1.0
          // How much to simplify the polyline on each zoom level. More means
          // better performance and smoother look, and less means more accurate representation.
          smoothFactor: 1,
          // @option noClip: Boolean = false
          // Disable polyline clipping.
          noClip: !1
        },
        initialize: function(i, o) {
          x(this, o), this._setLatLngs(i);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
          return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(i) {
          return this._setLatLngs(i), this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
          return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(i) {
          for (var o = 1 / 0, l = null, p = jr, v, C, O = 0, B = this._parts.length; O < B; O++)
            for (var F = this._parts[O], K = 1, ne = F.length; K < ne; K++) {
              v = F[K - 1], C = F[K];
              var he = p(i, v, C, !0);
              he < o && (o = he, l = p(i, v, C));
            }
          return l && (l.distance = Math.sqrt(o)), l;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
          if (!this._map)
            throw new Error("Must add layer to map before using getCenter()");
          return Uo(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
          return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(i, o) {
          return o = o || this._defaultShape(), i = Pe(i), o.push(i), this._bounds.extend(i), this.redraw();
        },
        _setLatLngs: function(i) {
          this._bounds = new jt(), this._latlngs = this._convertLatLngs(i);
        },
        _defaultShape: function() {
          return on(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(i) {
          for (var o = [], l = on(i), p = 0, v = i.length; p < v; p++)
            l ? (o[p] = Pe(i[p]), this._bounds.extend(o[p])) : o[p] = this._convertLatLngs(i[p]);
          return o;
        },
        _project: function() {
          var i = new Ue();
          this._rings = [], this._projectLatlngs(this._latlngs, this._rings, i), this._bounds.isValid() && i.isValid() && (this._rawPxBounds = i, this._updateBounds());
        },
        _updateBounds: function() {
          var i = this._clickTolerance(), o = new fe(i, i);
          this._rawPxBounds && (this._pxBounds = new Ue([
            this._rawPxBounds.min.subtract(o),
            this._rawPxBounds.max.add(o)
          ]));
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(i, o, l) {
          var p = i[0] instanceof Re, v = i.length, C, O;
          if (p) {
            for (O = [], C = 0; C < v; C++)
              O[C] = this._map.latLngToLayerPoint(i[C]), l.extend(O[C]);
            o.push(O);
          } else
            for (C = 0; C < v; C++)
              this._projectLatlngs(i[C], o, l);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
          var i = this._renderer._bounds;
          if (this._parts = [], !(!this._pxBounds || !this._pxBounds.intersects(i))) {
            if (this.options.noClip) {
              this._parts = this._rings;
              return;
            }
            var o = this._parts, l, p, v, C, O, B, F;
            for (l = 0, v = 0, C = this._rings.length; l < C; l++)
              for (F = this._rings[l], p = 0, O = F.length; p < O - 1; p++)
                B = fl(F[p], F[p + 1], i, p, !0), B && (o[v] = o[v] || [], o[v].push(B[0]), (B[1] !== F[p + 1] || p === O - 2) && (o[v].push(B[1]), v++));
          }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
          for (var i = this._parts, o = this.options.smoothFactor, l = 0, p = i.length; l < p; l++)
            i[l] = tt(i[l], o);
        },
        _update: function() {
          this._map && (this._clipPoints(), this._simplifyPoints(), this._updatePath());
        },
        _updatePath: function() {
          this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(i, o) {
          var l, p, v, C, O, B, F = this._clickTolerance();
          if (!this._pxBounds || !this._pxBounds.contains(i))
            return !1;
          for (l = 0, C = this._parts.length; l < C; l++)
            for (B = this._parts[l], p = 0, O = B.length, v = O - 1; p < O; v = p++)
              if (!(!o && p === 0) && qn(i, B[v], B[p]) <= F)
                return !0;
          return !1;
        }
      });
      function dc(i, o) {
        return new dn(i, o);
      }
      dn._flat = ea;
      var ur = dn.extend({
        options: {
          fill: !0
        },
        isEmpty: function() {
          return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
          if (!this._map)
            throw new Error("Must add layer to map before using getCenter()");
          return Gn(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(i) {
          var o = dn.prototype._convertLatLngs.call(this, i), l = o.length;
          return l >= 2 && o[0] instanceof Re && o[0].equals(o[l - 1]) && o.pop(), o;
        },
        _setLatLngs: function(i) {
          dn.prototype._setLatLngs.call(this, i), on(this._latlngs) && (this._latlngs = [this._latlngs]);
        },
        _defaultShape: function() {
          return on(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
          var i = this._renderer._bounds, o = this.options.weight, l = new fe(o, o);
          if (i = new Ue(i.min.subtract(l), i.max.add(l)), this._parts = [], !(!this._pxBounds || !this._pxBounds.intersects(i))) {
            if (this.options.noClip) {
              this._parts = this._rings;
              return;
            }
            for (var p = 0, v = this._rings.length, C; p < v; p++)
              C = Qs(this._rings[p], i, !0), C.length && this._parts.push(C);
          }
        },
        _updatePath: function() {
          this._renderer._updatePoly(this, !0);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(i) {
          var o = !1, l, p, v, C, O, B, F, K;
          if (!this._pxBounds || !this._pxBounds.contains(i))
            return !1;
          for (C = 0, F = this._parts.length; C < F; C++)
            for (l = this._parts[C], O = 0, K = l.length, B = K - 1; O < K; B = O++)
              p = l[O], v = l[B], p.y > i.y != v.y > i.y && i.x < (v.x - p.x) * (i.y - p.y) / (v.y - p.y) + p.x && (o = !o);
          return o || dn.prototype._containsPoint.call(this, i, !0);
        }
      });
      function pc(i, o) {
        return new ur(i, o);
      }
      var Wt = Rn.extend({
        /* @section
         * @aka GeoJSON options
         *
         * @option pointToLayer: Function = *
         * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
         * called when data is added, passing the GeoJSON point feature and its `LatLng`.
         * The default is to spawn a default `Marker`:
         * ```js
         * function(geoJsonPoint, latlng) {
         * 	return L.marker(latlng);
         * }
         * ```
         *
         * @option style: Function = *
         * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
         * called internally when data is added.
         * The default value is to not override any defaults:
         * ```js
         * function (geoJsonFeature) {
         * 	return {}
         * }
         * ```
         *
         * @option onEachFeature: Function = *
         * A `Function` that will be called once for each created `Feature`, after it has
         * been created and styled. Useful for attaching events and popups to features.
         * The default is to do nothing with the newly created layers:
         * ```js
         * function (feature, layer) {}
         * ```
         *
         * @option filter: Function = *
         * A `Function` that will be used to decide whether to include a feature or not.
         * The default is to include all features:
         * ```js
         * function (geoJsonFeature) {
         * 	return true;
         * }
         * ```
         * Note: dynamically changing the `filter` option will have effect only on newly
         * added data. It will _not_ re-evaluate already included features.
         *
         * @option coordsToLatLng: Function = *
         * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
         * The default is the `coordsToLatLng` static method.
         *
         * @option markersInheritOptions: Boolean = false
         * Whether default Markers for "Point" type Features inherit from group options.
         */
        initialize: function(i, o) {
          x(this, o), this._layers = {}, i && this.addData(i);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(i) {
          var o = ee(i) ? i : i.features, l, p, v;
          if (o) {
            for (l = 0, p = o.length; l < p; l++)
              v = o[l], (v.geometries || v.geometry || v.features || v.coordinates) && this.addData(v);
            return this;
          }
          var C = this.options;
          if (C.filter && !C.filter(i))
            return this;
          var O = Gt(i, C);
          return O ? (O.feature = Kn(i), O.defaultOptions = O.options, this.resetStyle(O), C.onEachFeature && C.onEachFeature(i, O), this.addLayer(O)) : this;
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(i) {
          return i === void 0 ? this.eachLayer(this.resetStyle, this) : (i.options = u({}, i.defaultOptions), this._setLayerStyle(i, this.options.style), this);
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(i) {
          return this.eachLayer(function(o) {
            this._setLayerStyle(o, i);
          }, this);
        },
        _setLayerStyle: function(i, o) {
          i.setStyle && (typeof o == "function" && (o = o(i.feature)), i.setStyle(o));
        }
      });
      function Gt(i, o) {
        var l = i.type === "Feature" ? i.geometry : i, p = l ? l.coordinates : null, v = [], C = o && o.pointToLayer, O = o && o.coordsToLatLng || aa, B, F, K, ne;
        if (!p && !l)
          return null;
        switch (l.type) {
          case "Point":
            return B = O(p), sa(C, i, B, o);
          case "MultiPoint":
            for (K = 0, ne = p.length; K < ne; K++)
              B = O(p[K]), v.push(sa(C, i, B, o));
            return new Rn(v);
          case "LineString":
          case "MultiLineString":
            return F = Wo(p, l.type === "LineString" ? 0 : 1, O), new dn(F, o);
          case "Polygon":
          case "MultiPolygon":
            return F = Wo(p, l.type === "Polygon" ? 1 : 2, O), new ur(F, o);
          case "GeometryCollection":
            for (K = 0, ne = l.geometries.length; K < ne; K++) {
              var he = Gt({
                geometry: l.geometries[K],
                type: "Feature",
                properties: i.properties
              }, o);
              he && v.push(he);
            }
            return new Rn(v);
          case "FeatureCollection":
            for (K = 0, ne = l.features.length; K < ne; K++) {
              var Te = Gt(l.features[K], o);
              Te && v.push(Te);
            }
            return new Rn(v);
          default:
            throw new Error("Invalid GeoJSON object.");
        }
      }
      function sa(i, o, l, p) {
        return i ? i(o, l) : new Ho(l, p && p.markersInheritOptions && p);
      }
      function aa(i) {
        return new Re(i[1], i[0], i[2]);
      }
      function Wo(i, o, l) {
        for (var p = [], v = 0, C = i.length, O; v < C; v++)
          O = o ? Wo(i[v], o - 1, l) : (l || aa)(i[v]), p.push(O);
        return p;
      }
      function la(i, o) {
        return i = Pe(i), i.alt !== void 0 ? [b(i.lng, o), b(i.lat, o), b(i.alt, o)] : [b(i.lng, o), b(i.lat, o)];
      }
      function Go(i, o, l, p) {
        for (var v = [], C = 0, O = i.length; C < O; C++)
          v.push(o ? Go(i[C], on(i[C]) ? 0 : o - 1, l, p) : la(i[C], p));
        return !o && l && v.length > 0 && v.push(v[0].slice()), v;
      }
      function cr(i, o) {
        return i.feature ? u({}, i.feature, { geometry: o }) : Kn(o);
      }
      function Kn(i) {
        return i.type === "Feature" || i.type === "FeatureCollection" ? i : {
          type: "Feature",
          properties: {},
          geometry: i
        };
      }
      var $ = {
        toGeoJSON: function(i) {
          return cr(this, {
            type: "Point",
            coordinates: la(this.getLatLng(), i)
          });
        }
      };
      Ho.include($), Zo.include($), jo.include($), dn.include({
        toGeoJSON: function(i) {
          var o = !on(this._latlngs), l = Go(this._latlngs, o ? 1 : 0, !1, i);
          return cr(this, {
            type: (o ? "Multi" : "") + "LineString",
            coordinates: l
          });
        }
      }), ur.include({
        toGeoJSON: function(i) {
          var o = !on(this._latlngs), l = o && !on(this._latlngs[0]), p = Go(this._latlngs, l ? 2 : o ? 1 : 0, !0, i);
          return o || (p = [p]), cr(this, {
            type: (l ? "Multi" : "") + "Polygon",
            coordinates: p
          });
        }
      }), li.include({
        toMultiPoint: function(i) {
          var o = [];
          return this.eachLayer(function(l) {
            o.push(l.toGeoJSON(i).geometry.coordinates);
          }), cr(this, {
            type: "MultiPoint",
            coordinates: o
          });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(i) {
          var o = this.feature && this.feature.geometry && this.feature.geometry.type;
          if (o === "MultiPoint")
            return this.toMultiPoint(i);
          var l = o === "GeometryCollection", p = [];
          return this.eachLayer(function(v) {
            if (v.toGeoJSON) {
              var C = v.toGeoJSON(i);
              if (l)
                p.push(C.geometry);
              else {
                var O = Kn(C);
                O.type === "FeatureCollection" ? p.push.apply(p, O.features) : p.push(O);
              }
            }
          }), l ? cr(this, {
            geometries: p,
            type: "GeometryCollection"
          }) : {
            type: "FeatureCollection",
            features: p
          };
        }
      });
      function j(i, o) {
        return new Wt(i, o);
      }
      var U = j, ie = lt.extend({
        // @section
        // @aka ImageOverlay options
        options: {
          // @option opacity: Number = 1.0
          // The opacity of the image overlay.
          opacity: 1,
          // @option alt: String = ''
          // Text for the `alt` attribute of the image (useful for accessibility).
          alt: "",
          // @option interactive: Boolean = false
          // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
          interactive: !1,
          // @option crossOrigin: Boolean|String = false
          // Whether the crossOrigin attribute will be added to the image.
          // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
          // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
          crossOrigin: !1,
          // @option errorOverlayUrl: String = ''
          // URL to the overlay image to show in place of the overlay that failed to load.
          errorOverlayUrl: "",
          // @option zIndex: Number = 1
          // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
          zIndex: 1,
          // @option className: String = ''
          // A custom class name to assign to the image. Empty by default.
          className: ""
        },
        initialize: function(i, o, l) {
          this._url = i, this._bounds = vt(o), x(this, l);
        },
        onAdd: function() {
          this._image || (this._initImage(), this.options.opacity < 1 && this._updateOpacity()), this.options.interactive && (Se(this._image, "leaflet-interactive"), this.addInteractiveTarget(this._image)), this.getPane().appendChild(this._image), this._reset();
        },
        onRemove: function() {
          it(this._image), this.options.interactive && this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(i) {
          return this.options.opacity = i, this._image && this._updateOpacity(), this;
        },
        setStyle: function(i) {
          return i.opacity && this.setOpacity(i.opacity), this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
          return this._map && Ei(this._image), this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
          return this._map && si(this._image), this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(i) {
          return this._url = i, this._image && (this._image.src = i), this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(i) {
          return this._bounds = vt(i), this._map && this._reset(), this;
        },
        getEvents: function() {
          var i = {
            zoom: this._reset,
            viewreset: this._reset
          };
          return this._zoomAnimated && (i.zoomanim = this._animateZoom), i;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(i) {
          return this.options.zIndex = i, this._updateZIndex(), this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
          return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
          return this._image;
        },
        _initImage: function() {
          var i = this._url.tagName === "IMG", o = this._image = i ? this._url : Ve("img");
          if (Se(o, "leaflet-image-layer"), this._zoomAnimated && Se(o, "leaflet-zoom-animated"), this.options.className && Se(o, this.options.className), o.onselectstart = h, o.onmousemove = h, o.onload = d(this.fire, this, "load"), o.onerror = d(this._overlayOnError, this, "error"), (this.options.crossOrigin || this.options.crossOrigin === "") && (o.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), this.options.zIndex && this._updateZIndex(), i) {
            this._url = o.src;
            return;
          }
          o.src = this._url, o.alt = this.options.alt;
        },
        _animateZoom: function(i) {
          var o = this._map.getZoomScale(i.zoom), l = this._map._latLngBoundsToNewLayerBounds(this._bounds, i.zoom, i.center).min;
          Ai(this._image, l, o);
        },
        _reset: function() {
          var i = this._image, o = new Ue(
            this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
            this._map.latLngToLayerPoint(this._bounds.getSouthEast())
          ), l = o.getSize();
          ft(i, o.min), i.style.width = l.x + "px", i.style.height = l.y + "px";
        },
        _updateOpacity: function() {
          tn(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
          this._image && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._image.style.zIndex = this.options.zIndex);
        },
        _overlayOnError: function() {
          this.fire("error");
          var i = this.options.errorOverlayUrl;
          i && this._url !== i && (this._url = i, this._image.src = i);
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
          return this._bounds.getCenter();
        }
      }), ve = function(i, o, l) {
        return new ie(i, o, l);
      }, je = ie.extend({
        // @section
        // @aka VideoOverlay options
        options: {
          // @option autoplay: Boolean = true
          // Whether the video starts playing automatically when loaded.
          // On some browsers autoplay will only work with `muted: true`
          autoplay: !0,
          // @option loop: Boolean = true
          // Whether the video will loop back to the beginning when played.
          loop: !0,
          // @option keepAspectRatio: Boolean = true
          // Whether the video will save aspect ratio after the projection.
          // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
          keepAspectRatio: !0,
          // @option muted: Boolean = false
          // Whether the video starts on mute when loaded.
          muted: !1,
          // @option playsInline: Boolean = true
          // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
          playsInline: !0
        },
        _initImage: function() {
          var i = this._url.tagName === "VIDEO", o = this._image = i ? this._url : Ve("video");
          if (Se(o, "leaflet-image-layer"), this._zoomAnimated && Se(o, "leaflet-zoom-animated"), this.options.className && Se(o, this.options.className), o.onselectstart = h, o.onmousemove = h, o.onloadeddata = d(this.fire, this, "load"), i) {
            for (var l = o.getElementsByTagName("source"), p = [], v = 0; v < l.length; v++)
              p.push(l[v].src);
            this._url = l.length > 0 ? p : [o.src];
            return;
          }
          ee(this._url) || (this._url = [this._url]), !this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(o.style, "objectFit") && (o.style.objectFit = "fill"), o.autoplay = !!this.options.autoplay, o.loop = !!this.options.loop, o.muted = !!this.options.muted, o.playsInline = !!this.options.playsInline;
          for (var C = 0; C < this._url.length; C++) {
            var O = Ve("source");
            O.src = this._url[C], o.appendChild(O);
          }
        }
        // @method getElement(): HTMLVideoElement
        // Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
        // used by this overlay.
      });
      function Lt(i, o, l) {
        return new je(i, o, l);
      }
      var Qe = ie.extend({
        _initImage: function() {
          var i = this._image = this._url;
          Se(i, "leaflet-image-layer"), this._zoomAnimated && Se(i, "leaflet-zoom-animated"), this.options.className && Se(i, this.options.className), i.onselectstart = h, i.onmousemove = h;
        }
        // @method getElement(): SVGElement
        // Returns the instance of [`SVGElement`](https://developer.mozilla.org/docs/Web/API/SVGElement)
        // used by this overlay.
      });
      function ua(i, o, l) {
        return new Qe(i, o, l);
      }
      var zn = lt.extend({
        // @section
        // @aka DivOverlay options
        options: {
          // @option interactive: Boolean = false
          // If true, the popup/tooltip will listen to the mouse events.
          interactive: !1,
          // @option offset: Point = Point(0, 0)
          // The offset of the overlay position.
          offset: [0, 0],
          // @option className: String = ''
          // A custom CSS class name to assign to the overlay.
          className: "",
          // @option pane: String = undefined
          // `Map pane` where the overlay will be added.
          pane: void 0,
          // @option content: String|HTMLElement|Function = ''
          // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
          // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
          content: ""
        },
        initialize: function(i, o) {
          i && (i instanceof Re || ee(i)) ? (this._latlng = Pe(i), x(this, o)) : (x(this, i), this._source = o), this.options.content && (this._content = this.options.content);
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(i) {
          return i = arguments.length ? i : this._source._map, i.hasLayer(this) || i.addLayer(this), this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
          return this._map && this._map.removeLayer(this), this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(i) {
          return this._map ? this.close() : (arguments.length ? this._source = i : i = this._source, this._prepareOpen(), this.openOn(i._map)), this;
        },
        onAdd: function(i) {
          this._zoomAnimated = i._zoomAnimated, this._container || this._initLayout(), i._fadeAnimated && tn(this._container, 0), clearTimeout(this._removeTimeout), this.getPane().appendChild(this._container), this.update(), i._fadeAnimated && tn(this._container, 1), this.bringToFront(), this.options.interactive && (Se(this._container, "leaflet-interactive"), this.addInteractiveTarget(this._container));
        },
        onRemove: function(i) {
          i._fadeAnimated ? (tn(this._container, 0), this._removeTimeout = setTimeout(d(it, void 0, this._container), 200)) : it(this._container), this.options.interactive && (rt(this._container, "leaflet-interactive"), this.removeInteractiveTarget(this._container));
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
          return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(i) {
          return this._latlng = Pe(i), this._map && (this._updatePosition(), this._adjustPan()), this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
          return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(i) {
          return this._content = i, this.update(), this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
          return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
          this._map && (this._container.style.visibility = "hidden", this._updateContent(), this._updateLayout(), this._updatePosition(), this._container.style.visibility = "", this._adjustPan());
        },
        getEvents: function() {
          var i = {
            zoom: this._updatePosition,
            viewreset: this._updatePosition
          };
          return this._zoomAnimated && (i.zoomanim = this._animateZoom), i;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
          return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
          return this._map && Ei(this._container), this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
          return this._map && si(this._container), this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(i) {
          var o = this._source;
          if (!o._map)
            return !1;
          if (o instanceof Rn) {
            o = null;
            var l = this._source._layers;
            for (var p in l)
              if (l[p]._map) {
                o = l[p];
                break;
              }
            if (!o)
              return !1;
            this._source = o;
          }
          if (!i)
            if (o.getCenter)
              i = o.getCenter();
            else if (o.getLatLng)
              i = o.getLatLng();
            else if (o.getBounds)
              i = o.getBounds().getCenter();
            else
              throw new Error("Unable to get source layer LatLng.");
          return this.setLatLng(i), this._map && this.update(), !0;
        },
        _updateContent: function() {
          if (this._content) {
            var i = this._contentNode, o = typeof this._content == "function" ? this._content(this._source || this) : this._content;
            if (typeof o == "string")
              i.innerHTML = o;
            else {
              for (; i.hasChildNodes(); )
                i.removeChild(i.firstChild);
              i.appendChild(o);
            }
            this.fire("contentupdate");
          }
        },
        _updatePosition: function() {
          if (this._map) {
            var i = this._map.latLngToLayerPoint(this._latlng), o = _e(this.options.offset), l = this._getAnchor();
            this._zoomAnimated ? ft(this._container, i.add(l)) : o = o.add(i).add(l);
            var p = this._containerBottom = -o.y, v = this._containerLeft = -Math.round(this._containerWidth / 2) + o.x;
            this._container.style.bottom = p + "px", this._container.style.left = v + "px";
          }
        },
        _getAnchor: function() {
          return [0, 0];
        }
      });
      De.include({
        _initOverlay: function(i, o, l, p) {
          var v = o;
          return v instanceof i || (v = new i(p).setContent(o)), l && v.setLatLng(l), v;
        }
      }), lt.include({
        _initOverlay: function(i, o, l, p) {
          var v = l;
          return v instanceof i ? (x(v, p), v._source = this) : (v = o && !p ? o : new i(p, this), v.setContent(l)), v;
        }
      });
      var Bt = zn.extend({
        // @section
        // @aka Popup options
        options: {
          // @option pane: String = 'popupPane'
          // `Map pane` where the popup will be added.
          pane: "popupPane",
          // @option offset: Point = Point(0, 7)
          // The offset of the popup position.
          offset: [0, 7],
          // @option maxWidth: Number = 300
          // Max width of the popup, in pixels.
          maxWidth: 300,
          // @option minWidth: Number = 50
          // Min width of the popup, in pixels.
          minWidth: 50,
          // @option maxHeight: Number = null
          // If set, creates a scrollable container of the given height
          // inside a popup if its content exceeds it.
          // The scrollable container can be styled using the
          // `leaflet-popup-scrolled` CSS class selector.
          maxHeight: null,
          // @option autoPan: Boolean = true
          // Set it to `false` if you don't want the map to do panning animation
          // to fit the opened popup.
          autoPan: !0,
          // @option autoPanPaddingTopLeft: Point = null
          // The margin between the popup and the top left corner of the map
          // view after autopanning was performed.
          autoPanPaddingTopLeft: null,
          // @option autoPanPaddingBottomRight: Point = null
          // The margin between the popup and the bottom right corner of the map
          // view after autopanning was performed.
          autoPanPaddingBottomRight: null,
          // @option autoPanPadding: Point = Point(5, 5)
          // Equivalent of setting both top left and bottom right autopan padding to the same value.
          autoPanPadding: [5, 5],
          // @option keepInView: Boolean = false
          // Set it to `true` if you want to prevent users from panning the popup
          // off of the screen while it is open.
          keepInView: !1,
          // @option closeButton: Boolean = true
          // Controls the presence of a close button in the popup.
          closeButton: !0,
          // @option autoClose: Boolean = true
          // Set it to `false` if you want to override the default behavior of
          // the popup closing when another popup is opened.
          autoClose: !0,
          // @option closeOnEscapeKey: Boolean = true
          // Set it to `false` if you want to override the default behavior of
          // the ESC key for closing of the popup.
          closeOnEscapeKey: !0,
          // @option closeOnClick: Boolean = *
          // Set it if you want to override the default behavior of the popup closing when user clicks
          // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
          // @option className: String = ''
          // A custom CSS class name to assign to the popup.
          className: ""
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(i) {
          return i = arguments.length ? i : this._source._map, !i.hasLayer(this) && i._popup && i._popup.options.autoClose && i.removeLayer(i._popup), i._popup = this, zn.prototype.openOn.call(this, i);
        },
        onAdd: function(i) {
          zn.prototype.onAdd.call(this, i), i.fire("popupopen", { popup: this }), this._source && (this._source.fire("popupopen", { popup: this }, !0), this._source instanceof ui || this._source.on("preclick", xi));
        },
        onRemove: function(i) {
          zn.prototype.onRemove.call(this, i), i.fire("popupclose", { popup: this }), this._source && (this._source.fire("popupclose", { popup: this }, !0), this._source instanceof ui || this._source.off("preclick", xi));
        },
        getEvents: function() {
          var i = zn.prototype.getEvents.call(this);
          return (this.options.closeOnClick !== void 0 ? this.options.closeOnClick : this._map.options.closePopupOnClick) && (i.preclick = this.close), this.options.keepInView && (i.moveend = this._adjustPan), i;
        },
        _initLayout: function() {
          var i = "leaflet-popup", o = this._container = Ve(
            "div",
            i + " " + (this.options.className || "") + " leaflet-zoom-animated"
          ), l = this._wrapper = Ve("div", i + "-content-wrapper", o);
          if (this._contentNode = Ve("div", i + "-content", l), Ur(o), Zs(this._contentNode), we(o, "contextmenu", xi), this._tipContainer = Ve("div", i + "-tip-container", o), this._tip = Ve("div", i + "-tip", this._tipContainer), this.options.closeButton) {
            var p = this._closeButton = Ve("a", i + "-close-button", o);
            p.setAttribute("role", "button"), p.setAttribute("aria-label", "Close popup"), p.href = "#close", p.innerHTML = '<span aria-hidden="true">&#215;</span>', we(p, "click", function(v) {
              Ce(v), this.close();
            }, this);
          }
        },
        _updateLayout: function() {
          var i = this._contentNode, o = i.style;
          o.width = "", o.whiteSpace = "nowrap";
          var l = i.offsetWidth;
          l = Math.min(l, this.options.maxWidth), l = Math.max(l, this.options.minWidth), o.width = l + 1 + "px", o.whiteSpace = "", o.height = "";
          var p = i.offsetHeight, v = this.options.maxHeight, C = "leaflet-popup-scrolled";
          v && p > v ? (o.height = v + "px", Se(i, C)) : rt(i, C), this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(i) {
          var o = this._map._latLngToNewLayerPoint(this._latlng, i.zoom, i.center), l = this._getAnchor();
          ft(this._container, o.add(l));
        },
        _adjustPan: function() {
          if (this.options.autoPan) {
            if (this._map._panAnim && this._map._panAnim.stop(), this._autopanning) {
              this._autopanning = !1;
              return;
            }
            var i = this._map, o = parseInt(Rr(this._container, "marginBottom"), 10) || 0, l = this._container.offsetHeight + o, p = this._containerWidth, v = new fe(this._containerLeft, -l - this._containerBottom);
            v._add(Wn(this._container));
            var C = i.layerPointToContainerPoint(v), O = _e(this.options.autoPanPadding), B = _e(this.options.autoPanPaddingTopLeft || O), F = _e(this.options.autoPanPaddingBottomRight || O), K = i.getSize(), ne = 0, he = 0;
            C.x + p + F.x > K.x && (ne = C.x + p - K.x + F.x), C.x - ne - B.x < 0 && (ne = C.x - B.x), C.y + l + F.y > K.y && (he = C.y + l - K.y + F.y), C.y - he - B.y < 0 && (he = C.y - B.y), (ne || he) && (this.options.keepInView && (this._autopanning = !0), i.fire("autopanstart").panBy([ne, he]));
          }
        },
        _getAnchor: function() {
          return _e(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
        }
      }), qo = function(i, o) {
        return new Bt(i, o);
      };
      De.mergeOptions({
        closePopupOnClick: !0
      }), De.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(i, o, l) {
          return this._initOverlay(Bt, i, o, l).openOn(this), this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(i) {
          return i = arguments.length ? i : this._popup, i && i.close(), this;
        }
      }), lt.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(i, o) {
          return this._popup = this._initOverlay(Bt, this._popup, i, o), this._popupHandlersAdded || (this.on({
            click: this._openPopup,
            keypress: this._onKeyPress,
            remove: this.closePopup,
            move: this._movePopup
          }), this._popupHandlersAdded = !0), this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
          return this._popup && (this.off({
            click: this._openPopup,
            keypress: this._onKeyPress,
            remove: this.closePopup,
            move: this._movePopup
          }), this._popupHandlersAdded = !1, this._popup = null), this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(i) {
          return this._popup && (this instanceof Rn || (this._popup._source = this), this._popup._prepareOpen(i || this._latlng) && this._popup.openOn(this._map)), this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
          return this._popup && this._popup.close(), this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
          return this._popup && this._popup.toggle(this), this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
          return this._popup ? this._popup.isOpen() : !1;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(i) {
          return this._popup && this._popup.setContent(i), this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
          return this._popup;
        },
        _openPopup: function(i) {
          if (!(!this._popup || !this._map)) {
            He(i);
            var o = i.layer || i.target;
            if (this._popup._source === o && !(o instanceof ui)) {
              this._map.hasLayer(this._popup) ? this.closePopup() : this.openPopup(i.latlng);
              return;
            }
            this._popup._source = o, this.openPopup(i.latlng);
          }
        },
        _movePopup: function(i) {
          this._popup.setLatLng(i.latlng);
        },
        _onKeyPress: function(i) {
          i.originalEvent.keyCode === 13 && this._openPopup(i);
        }
      });
      var Ko = zn.extend({
        // @section
        // @aka Tooltip options
        options: {
          // @option pane: String = 'tooltipPane'
          // `Map pane` where the tooltip will be added.
          pane: "tooltipPane",
          // @option offset: Point = Point(0, 0)
          // Optional offset of the tooltip position.
          offset: [0, 0],
          // @option direction: String = 'auto'
          // Direction where to open the tooltip. Possible values are: `right`, `left`,
          // `top`, `bottom`, `center`, `auto`.
          // `auto` will dynamically switch between `right` and `left` according to the tooltip
          // position on the map.
          direction: "auto",
          // @option permanent: Boolean = false
          // Whether to open the tooltip permanently or only on mouseover.
          permanent: !1,
          // @option sticky: Boolean = false
          // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
          sticky: !1,
          // @option opacity: Number = 0.9
          // Tooltip container opacity.
          opacity: 0.9
        },
        onAdd: function(i) {
          zn.prototype.onAdd.call(this, i), this.setOpacity(this.options.opacity), i.fire("tooltipopen", { tooltip: this }), this._source && (this.addEventParent(this._source), this._source.fire("tooltipopen", { tooltip: this }, !0));
        },
        onRemove: function(i) {
          zn.prototype.onRemove.call(this, i), i.fire("tooltipclose", { tooltip: this }), this._source && (this.removeEventParent(this._source), this._source.fire("tooltipclose", { tooltip: this }, !0));
        },
        getEvents: function() {
          var i = zn.prototype.getEvents.call(this);
          return this.options.permanent || (i.preclick = this.close), i;
        },
        _initLayout: function() {
          var i = "leaflet-tooltip", o = i + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
          this._contentNode = this._container = Ve("div", o), this._container.setAttribute("role", "tooltip"), this._container.setAttribute("id", "leaflet-tooltip-" + g(this));
        },
        _updateLayout: function() {
        },
        _adjustPan: function() {
        },
        _setPosition: function(i) {
          var o, l, p = this._map, v = this._container, C = p.latLngToContainerPoint(p.getCenter()), O = p.layerPointToContainerPoint(i), B = this.options.direction, F = v.offsetWidth, K = v.offsetHeight, ne = _e(this.options.offset), he = this._getAnchor();
          B === "top" ? (o = F / 2, l = K) : B === "bottom" ? (o = F / 2, l = 0) : B === "center" ? (o = F / 2, l = K / 2) : B === "right" ? (o = 0, l = K / 2) : B === "left" ? (o = F, l = K / 2) : O.x < C.x ? (B = "right", o = 0, l = K / 2) : (B = "left", o = F + (ne.x + he.x) * 2, l = K / 2), i = i.subtract(_e(o, l, !0)).add(ne).add(he), rt(v, "leaflet-tooltip-right"), rt(v, "leaflet-tooltip-left"), rt(v, "leaflet-tooltip-top"), rt(v, "leaflet-tooltip-bottom"), Se(v, "leaflet-tooltip-" + B), ft(v, i);
        },
        _updatePosition: function() {
          var i = this._map.latLngToLayerPoint(this._latlng);
          this._setPosition(i);
        },
        setOpacity: function(i) {
          this.options.opacity = i, this._container && tn(this._container, i);
        },
        _animateZoom: function(i) {
          var o = this._map._latLngToNewLayerPoint(this._latlng, i.zoom, i.center);
          this._setPosition(o);
        },
        _getAnchor: function() {
          return _e(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
        }
      }), hr = function(i, o) {
        return new Ko(i, o);
      };
      De.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(i, o, l) {
          return this._initOverlay(Ko, i, o, l).openOn(this), this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(i) {
          return i.close(), this;
        }
      }), lt.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(i, o) {
          return this._tooltip && this.isTooltipOpen() && this.unbindTooltip(), this._tooltip = this._initOverlay(Ko, this._tooltip, i, o), this._initTooltipInteractions(), this._tooltip.options.permanent && this._map && this._map.hasLayer(this) && this.openTooltip(), this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
          return this._tooltip && (this._initTooltipInteractions(!0), this.closeTooltip(), this._tooltip = null), this;
        },
        _initTooltipInteractions: function(i) {
          if (!(!i && this._tooltipHandlersAdded)) {
            var o = i ? "off" : "on", l = {
              remove: this.closeTooltip,
              move: this._moveTooltip
            };
            this._tooltip.options.permanent ? l.add = this._openTooltip : (l.mouseover = this._openTooltip, l.mouseout = this.closeTooltip, l.click = this._openTooltip, this._map ? this._addFocusListeners() : l.add = this._addFocusListeners), this._tooltip.options.sticky && (l.mousemove = this._moveTooltip), this[o](l), this._tooltipHandlersAdded = !i;
          }
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(i) {
          return this._tooltip && (this instanceof Rn || (this._tooltip._source = this), this._tooltip._prepareOpen(i) && (this._tooltip.openOn(this._map), this.getElement ? this._setAriaDescribedByOnLayer(this) : this.eachLayer && this.eachLayer(this._setAriaDescribedByOnLayer, this))), this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
          if (this._tooltip)
            return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
          return this._tooltip && this._tooltip.toggle(this), this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
          return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(i) {
          return this._tooltip && this._tooltip.setContent(i), this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
          return this._tooltip;
        },
        _addFocusListeners: function() {
          this.getElement ? this._addFocusListenersOnLayer(this) : this.eachLayer && this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(i) {
          var o = typeof i.getElement == "function" && i.getElement();
          o && (we(o, "focus", function() {
            this._tooltip._source = i, this.openTooltip();
          }, this), we(o, "blur", this.closeTooltip, this));
        },
        _setAriaDescribedByOnLayer: function(i) {
          var o = typeof i.getElement == "function" && i.getElement();
          o && o.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(i) {
          if (!(!this._tooltip || !this._map)) {
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
              this._openOnceFlag = !0;
              var o = this;
              this._map.once("moveend", function() {
                o._openOnceFlag = !1, o._openTooltip(i);
              });
              return;
            }
            this._tooltip._source = i.layer || i.target, this.openTooltip(this._tooltip.options.sticky ? i.latlng : void 0);
          }
        },
        _moveTooltip: function(i) {
          var o = i.latlng, l, p;
          this._tooltip.options.sticky && i.originalEvent && (l = this._map.mouseEventToContainerPoint(i.originalEvent), p = this._map.containerPointToLayerPoint(l), o = this._map.layerPointToLatLng(p)), this._tooltip.setLatLng(o);
        }
      });
      var Gr = ar.extend({
        options: {
          // @section
          // @aka DivIcon options
          iconSize: [12, 12],
          // also can be set through CSS
          // iconAnchor: (Point),
          // popupAnchor: (Point),
          // @option html: String|HTMLElement = ''
          // Custom HTML code to put inside the div element, empty by default. Alternatively,
          // an instance of `HTMLElement`.
          html: !1,
          // @option bgPos: Point = [0, 0]
          // Optional relative position of the background, in pixels
          bgPos: null,
          className: "leaflet-div-icon"
        },
        createIcon: function(i) {
          var o = i && i.tagName === "DIV" ? i : document.createElement("div"), l = this.options;
          if (l.html instanceof Element ? (zr(o), o.appendChild(l.html)) : o.innerHTML = l.html !== !1 ? l.html : "", l.bgPos) {
            var p = _e(l.bgPos);
            o.style.backgroundPosition = -p.x + "px " + -p.y + "px";
          }
          return this._setIconStyles(o, "icon"), o;
        },
        createShadow: function() {
          return null;
        }
      });
      function Yo(i) {
        return new Gr(i);
      }
      ar.Default = Wr;
      var ze = lt.extend({
        // @section
        // @aka GridLayer options
        options: {
          // @option tileSize: Number|Point = 256
          // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
          tileSize: 256,
          // @option opacity: Number = 1.0
          // Opacity of the tiles. Can be used in the `createTile()` function.
          opacity: 1,
          // @option updateWhenIdle: Boolean = (depends)
          // Load new tiles only when panning ends.
          // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
          // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
          // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
          updateWhenIdle: le.mobile,
          // @option updateWhenZooming: Boolean = true
          // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
          updateWhenZooming: !0,
          // @option updateInterval: Number = 200
          // Tiles will not update more than once every `updateInterval` milliseconds when panning.
          updateInterval: 200,
          // @option zIndex: Number = 1
          // The explicit zIndex of the tile layer.
          zIndex: 1,
          // @option bounds: LatLngBounds = undefined
          // If set, tiles will only be loaded inside the set `LatLngBounds`.
          bounds: null,
          // @option minZoom: Number = 0
          // The minimum zoom level down to which this layer will be displayed (inclusive).
          minZoom: 0,
          // @option maxZoom: Number = undefined
          // The maximum zoom level up to which this layer will be displayed (inclusive).
          maxZoom: void 0,
          // @option maxNativeZoom: Number = undefined
          // Maximum zoom number the tile source has available. If it is specified,
          // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
          // from `maxNativeZoom` level and auto-scaled.
          maxNativeZoom: void 0,
          // @option minNativeZoom: Number = undefined
          // Minimum zoom number the tile source has available. If it is specified,
          // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
          // from `minNativeZoom` level and auto-scaled.
          minNativeZoom: void 0,
          // @option noWrap: Boolean = false
          // Whether the layer is wrapped around the antimeridian. If `true`, the
          // GridLayer will only be displayed once at low zoom levels. Has no
          // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
          // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
          // tiles outside the CRS limits.
          noWrap: !1,
          // @option pane: String = 'tilePane'
          // `Map pane` where the grid layer will be added.
          pane: "tilePane",
          // @option className: String = ''
          // A custom class name to assign to the tile layer. Empty by default.
          className: "",
          // @option keepBuffer: Number = 2
          // When panning the map, keep this many rows and columns of tiles before unloading them.
          keepBuffer: 2
        },
        initialize: function(i) {
          x(this, i);
        },
        onAdd: function() {
          this._initContainer(), this._levels = {}, this._tiles = {}, this._resetView();
        },
        beforeAdd: function(i) {
          i._addZoomLimit(this);
        },
        onRemove: function(i) {
          this._removeAllTiles(), it(this._container), i._removeZoomLimit(this), this._container = null, this._tileZoom = void 0;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
          return this._map && (Ei(this._container), this._setAutoZIndex(Math.max)), this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
          return this._map && (si(this._container), this._setAutoZIndex(Math.min)), this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
          return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(i) {
          return this.options.opacity = i, this._updateOpacity(), this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(i) {
          return this.options.zIndex = i, this._updateZIndex(), this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
          return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
          if (this._map) {
            this._removeAllTiles();
            var i = this._clampZoom(this._map.getZoom());
            i !== this._tileZoom && (this._tileZoom = i, this._updateLevels()), this._update();
          }
          return this;
        },
        getEvents: function() {
          var i = {
            viewprereset: this._invalidateAll,
            viewreset: this._resetView,
            zoom: this._resetView,
            moveend: this._onMoveEnd
          };
          return this.options.updateWhenIdle || (this._onMove || (this._onMove = y(this._onMoveEnd, this.options.updateInterval, this)), i.move = this._onMove), this._zoomAnimated && (i.zoomanim = this._animateZoom), i;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
          return document.createElement("div");
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
          var i = this.options.tileSize;
          return i instanceof fe ? i : new fe(i, i);
        },
        _updateZIndex: function() {
          this._container && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._container.style.zIndex = this.options.zIndex);
        },
        _setAutoZIndex: function(i) {
          for (var o = this.getPane().children, l = -i(-1 / 0, 1 / 0), p = 0, v = o.length, C; p < v; p++)
            C = o[p].style.zIndex, o[p] !== this._container && C && (l = i(l, +C));
          isFinite(l) && (this.options.zIndex = l + i(-1, 1), this._updateZIndex());
        },
        _updateOpacity: function() {
          if (this._map && !le.ielt9) {
            tn(this._container, this.options.opacity);
            var i = +/* @__PURE__ */ new Date(), o = !1, l = !1;
            for (var p in this._tiles) {
              var v = this._tiles[p];
              if (!(!v.current || !v.loaded)) {
                var C = Math.min(1, (i - v.loaded) / 200);
                tn(v.el, C), C < 1 ? o = !0 : (v.active ? l = !0 : this._onOpaqueTile(v), v.active = !0);
              }
            }
            l && !this._noPrune && this._pruneTiles(), o && (nt(this._fadeFrame), this._fadeFrame = _t(this._updateOpacity, this));
          }
        },
        _onOpaqueTile: h,
        _initContainer: function() {
          this._container || (this._container = Ve("div", "leaflet-layer " + (this.options.className || "")), this._updateZIndex(), this.options.opacity < 1 && this._updateOpacity(), this.getPane().appendChild(this._container));
        },
        _updateLevels: function() {
          var i = this._tileZoom, o = this.options.maxZoom;
          if (i !== void 0) {
            for (var l in this._levels)
              l = Number(l), this._levels[l].el.children.length || l === i ? (this._levels[l].el.style.zIndex = o - Math.abs(i - l), this._onUpdateLevel(l)) : (it(this._levels[l].el), this._removeTilesAtZoom(l), this._onRemoveLevel(l), delete this._levels[l]);
            var p = this._levels[i], v = this._map;
            return p || (p = this._levels[i] = {}, p.el = Ve("div", "leaflet-tile-container leaflet-zoom-animated", this._container), p.el.style.zIndex = o, p.origin = v.project(v.unproject(v.getPixelOrigin()), i).round(), p.zoom = i, this._setZoomTransform(p, v.getCenter(), v.getZoom()), h(p.el.offsetWidth), this._onCreateLevel(p)), this._level = p, p;
          }
        },
        _onUpdateLevel: h,
        _onRemoveLevel: h,
        _onCreateLevel: h,
        _pruneTiles: function() {
          if (this._map) {
            var i, o, l = this._map.getZoom();
            if (l > this.options.maxZoom || l < this.options.minZoom) {
              this._removeAllTiles();
              return;
            }
            for (i in this._tiles)
              o = this._tiles[i], o.retain = o.current;
            for (i in this._tiles)
              if (o = this._tiles[i], o.current && !o.active) {
                var p = o.coords;
                this._retainParent(p.x, p.y, p.z, p.z - 5) || this._retainChildren(p.x, p.y, p.z, p.z + 2);
              }
            for (i in this._tiles)
              this._tiles[i].retain || this._removeTile(i);
          }
        },
        _removeTilesAtZoom: function(i) {
          for (var o in this._tiles)
            this._tiles[o].coords.z === i && this._removeTile(o);
        },
        _removeAllTiles: function() {
          for (var i in this._tiles)
            this._removeTile(i);
        },
        _invalidateAll: function() {
          for (var i in this._levels)
            it(this._levels[i].el), this._onRemoveLevel(Number(i)), delete this._levels[i];
          this._removeAllTiles(), this._tileZoom = void 0;
        },
        _retainParent: function(i, o, l, p) {
          var v = Math.floor(i / 2), C = Math.floor(o / 2), O = l - 1, B = new fe(+v, +C);
          B.z = +O;
          var F = this._tileCoordsToKey(B), K = this._tiles[F];
          return K && K.active ? (K.retain = !0, !0) : (K && K.loaded && (K.retain = !0), O > p ? this._retainParent(v, C, O, p) : !1);
        },
        _retainChildren: function(i, o, l, p) {
          for (var v = 2 * i; v < 2 * i + 2; v++)
            for (var C = 2 * o; C < 2 * o + 2; C++) {
              var O = new fe(v, C);
              O.z = l + 1;
              var B = this._tileCoordsToKey(O), F = this._tiles[B];
              if (F && F.active) {
                F.retain = !0;
                continue;
              } else
                F && F.loaded && (F.retain = !0);
              l + 1 < p && this._retainChildren(v, C, l + 1, p);
            }
        },
        _resetView: function(i) {
          var o = i && (i.pinch || i.flyTo);
          this._setView(this._map.getCenter(), this._map.getZoom(), o, o);
        },
        _animateZoom: function(i) {
          this._setView(i.center, i.zoom, !0, i.noUpdate);
        },
        _clampZoom: function(i) {
          var o = this.options;
          return o.minNativeZoom !== void 0 && i < o.minNativeZoom ? o.minNativeZoom : o.maxNativeZoom !== void 0 && o.maxNativeZoom < i ? o.maxNativeZoom : i;
        },
        _setView: function(i, o, l, p) {
          var v = Math.round(o);
          this.options.maxZoom !== void 0 && v > this.options.maxZoom || this.options.minZoom !== void 0 && v < this.options.minZoom ? v = void 0 : v = this._clampZoom(v);
          var C = this.options.updateWhenZooming && v !== this._tileZoom;
          (!p || C) && (this._tileZoom = v, this._abortLoading && this._abortLoading(), this._updateLevels(), this._resetGrid(), v !== void 0 && this._update(i), l || this._pruneTiles(), this._noPrune = !!l), this._setZoomTransforms(i, o);
        },
        _setZoomTransforms: function(i, o) {
          for (var l in this._levels)
            this._setZoomTransform(this._levels[l], i, o);
        },
        _setZoomTransform: function(i, o, l) {
          var p = this._map.getZoomScale(l, i.zoom), v = i.origin.multiplyBy(p).subtract(this._map._getNewPixelOrigin(o, l)).round();
          le.any3d ? Ai(i.el, v, p) : ft(i.el, v);
        },
        _resetGrid: function() {
          var i = this._map, o = i.options.crs, l = this._tileSize = this.getTileSize(), p = this._tileZoom, v = this._map.getPixelWorldBounds(this._tileZoom);
          v && (this._globalTileRange = this._pxBoundsToTileRange(v)), this._wrapX = o.wrapLng && !this.options.noWrap && [
            Math.floor(i.project([0, o.wrapLng[0]], p).x / l.x),
            Math.ceil(i.project([0, o.wrapLng[1]], p).x / l.y)
          ], this._wrapY = o.wrapLat && !this.options.noWrap && [
            Math.floor(i.project([o.wrapLat[0], 0], p).y / l.x),
            Math.ceil(i.project([o.wrapLat[1], 0], p).y / l.y)
          ];
        },
        _onMoveEnd: function() {
          !this._map || this._map._animatingZoom || this._update();
        },
        _getTiledPixelBounds: function(i) {
          var o = this._map, l = o._animatingZoom ? Math.max(o._animateToZoom, o.getZoom()) : o.getZoom(), p = o.getZoomScale(l, this._tileZoom), v = o.project(i, this._tileZoom).floor(), C = o.getSize().divideBy(p * 2);
          return new Ue(v.subtract(C), v.add(C));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(i) {
          var o = this._map;
          if (o) {
            var l = this._clampZoom(o.getZoom());
            if (i === void 0 && (i = o.getCenter()), this._tileZoom !== void 0) {
              var p = this._getTiledPixelBounds(i), v = this._pxBoundsToTileRange(p), C = v.getCenter(), O = [], B = this.options.keepBuffer, F = new Ue(
                v.getBottomLeft().subtract([B, -B]),
                v.getTopRight().add([B, -B])
              );
              if (!(isFinite(v.min.x) && isFinite(v.min.y) && isFinite(v.max.x) && isFinite(v.max.y)))
                throw new Error("Attempted to load an infinite number of tiles");
              for (var K in this._tiles) {
                var ne = this._tiles[K].coords;
                (ne.z !== this._tileZoom || !F.contains(new fe(ne.x, ne.y))) && (this._tiles[K].current = !1);
              }
              if (Math.abs(l - this._tileZoom) > 1) {
                this._setView(i, l);
                return;
              }
              for (var he = v.min.y; he <= v.max.y; he++)
                for (var Te = v.min.x; Te <= v.max.x; Te++) {
                  var yt = new fe(Te, he);
                  if (yt.z = this._tileZoom, !!this._isValidTile(yt)) {
                    var ct = this._tiles[this._tileCoordsToKey(yt)];
                    ct ? ct.current = !0 : O.push(yt);
                  }
                }
              if (O.sort(function(xt, Tn) {
                return xt.distanceTo(C) - Tn.distanceTo(C);
              }), O.length !== 0) {
                this._loading || (this._loading = !0, this.fire("loading"));
                var kt = document.createDocumentFragment();
                for (Te = 0; Te < O.length; Te++)
                  this._addTile(O[Te], kt);
                this._level.el.appendChild(kt);
              }
            }
          }
        },
        _isValidTile: function(i) {
          var o = this._map.options.crs;
          if (!o.infinite) {
            var l = this._globalTileRange;
            if (!o.wrapLng && (i.x < l.min.x || i.x > l.max.x) || !o.wrapLat && (i.y < l.min.y || i.y > l.max.y))
              return !1;
          }
          if (!this.options.bounds)
            return !0;
          var p = this._tileCoordsToBounds(i);
          return vt(this.options.bounds).overlaps(p);
        },
        _keyToBounds: function(i) {
          return this._tileCoordsToBounds(this._keyToTileCoords(i));
        },
        _tileCoordsToNwSe: function(i) {
          var o = this._map, l = this.getTileSize(), p = i.scaleBy(l), v = p.add(l), C = o.unproject(p, i.z), O = o.unproject(v, i.z);
          return [C, O];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(i) {
          var o = this._tileCoordsToNwSe(i), l = new jt(o[0], o[1]);
          return this.options.noWrap || (l = this._map.wrapLatLngBounds(l)), l;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(i) {
          return i.x + ":" + i.y + ":" + i.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(i) {
          var o = i.split(":"), l = new fe(+o[0], +o[1]);
          return l.z = +o[2], l;
        },
        _removeTile: function(i) {
          var o = this._tiles[i];
          o && (it(o.el), delete this._tiles[i], this.fire("tileunload", {
            tile: o.el,
            coords: this._keyToTileCoords(i)
          }));
        },
        _initTile: function(i) {
          Se(i, "leaflet-tile");
          var o = this.getTileSize();
          i.style.width = o.x + "px", i.style.height = o.y + "px", i.onselectstart = h, i.onmousemove = h, le.ielt9 && this.options.opacity < 1 && tn(i, this.options.opacity);
        },
        _addTile: function(i, o) {
          var l = this._getTilePos(i), p = this._tileCoordsToKey(i), v = this.createTile(this._wrapCoords(i), d(this._tileReady, this, i));
          this._initTile(v), this.createTile.length < 2 && _t(d(this._tileReady, this, i, null, v)), ft(v, l), this._tiles[p] = {
            el: v,
            coords: i,
            current: !0
          }, o.appendChild(v), this.fire("tileloadstart", {
            tile: v,
            coords: i
          });
        },
        _tileReady: function(i, o, l) {
          o && this.fire("tileerror", {
            error: o,
            tile: l,
            coords: i
          });
          var p = this._tileCoordsToKey(i);
          l = this._tiles[p], l && (l.loaded = +/* @__PURE__ */ new Date(), this._map._fadeAnimated ? (tn(l.el, 0), nt(this._fadeFrame), this._fadeFrame = _t(this._updateOpacity, this)) : (l.active = !0, this._pruneTiles()), o || (Se(l.el, "leaflet-tile-loaded"), this.fire("tileload", {
            tile: l.el,
            coords: i
          })), this._noTilesToLoad() && (this._loading = !1, this.fire("load"), le.ielt9 || !this._map._fadeAnimated ? _t(this._pruneTiles, this) : setTimeout(d(this._pruneTiles, this), 250)));
        },
        _getTilePos: function(i) {
          return i.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(i) {
          var o = new fe(
            this._wrapX ? w(i.x, this._wrapX) : i.x,
            this._wrapY ? w(i.y, this._wrapY) : i.y
          );
          return o.z = i.z, o;
        },
        _pxBoundsToTileRange: function(i) {
          var o = this.getTileSize();
          return new Ue(
            i.min.unscaleBy(o).floor(),
            i.max.unscaleBy(o).ceil().subtract([1, 1])
          );
        },
        _noTilesToLoad: function() {
          for (var i in this._tiles)
            if (!this._tiles[i].loaded)
              return !1;
          return !0;
        }
      });
      function mc(i) {
        return new ze(i);
      }
      var Oi = ze.extend({
        // @section
        // @aka TileLayer options
        options: {
          // @option minZoom: Number = 0
          // The minimum zoom level down to which this layer will be displayed (inclusive).
          minZoom: 0,
          // @option maxZoom: Number = 18
          // The maximum zoom level up to which this layer will be displayed (inclusive).
          maxZoom: 18,
          // @option subdomains: String|String[] = 'abc'
          // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
          subdomains: "abc",
          // @option errorTileUrl: String = ''
          // URL to the tile image to show in place of the tile that failed to load.
          errorTileUrl: "",
          // @option zoomOffset: Number = 0
          // The zoom number used in tile URLs will be offset with this value.
          zoomOffset: 0,
          // @option tms: Boolean = false
          // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
          tms: !1,
          // @option zoomReverse: Boolean = false
          // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
          zoomReverse: !1,
          // @option detectRetina: Boolean = false
          // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
          detectRetina: !1,
          // @option crossOrigin: Boolean|String = false
          // Whether the crossOrigin attribute will be added to the tiles.
          // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
          // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
          crossOrigin: !1,
          // @option referrerPolicy: Boolean|String = false
          // Whether the referrerPolicy attribute will be added to the tiles.
          // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
          // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
          // (e.g. to validate an API token).
          // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
          referrerPolicy: !1
        },
        initialize: function(i, o) {
          this._url = i, o = x(this, o), o.detectRetina && le.retina && o.maxZoom > 0 ? (o.tileSize = Math.floor(o.tileSize / 2), o.zoomReverse ? (o.zoomOffset--, o.minZoom = Math.min(o.maxZoom, o.minZoom + 1)) : (o.zoomOffset++, o.maxZoom = Math.max(o.minZoom, o.maxZoom - 1)), o.minZoom = Math.max(0, o.minZoom)) : o.zoomReverse ? o.minZoom = Math.min(o.maxZoom, o.minZoom) : o.maxZoom = Math.max(o.minZoom, o.maxZoom), typeof o.subdomains == "string" && (o.subdomains = o.subdomains.split("")), this.on("tileunload", this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(i, o) {
          return this._url === i && o === void 0 && (o = !0), this._url = i, o || this.redraw(), this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(i, o) {
          var l = document.createElement("img");
          return we(l, "load", d(this._tileOnLoad, this, o, l)), we(l, "error", d(this._tileOnError, this, o, l)), (this.options.crossOrigin || this.options.crossOrigin === "") && (l.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), typeof this.options.referrerPolicy == "string" && (l.referrerPolicy = this.options.referrerPolicy), l.alt = "", l.src = this.getTileUrl(i), l;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(i) {
          var o = {
            r: le.retina ? "@2x" : "",
            s: this._getSubdomain(i),
            x: i.x,
            y: i.y,
            z: this._getZoomForUrl()
          };
          if (this._map && !this._map.options.crs.infinite) {
            var l = this._globalTileRange.max.y - i.y;
            this.options.tms && (o.y = l), o["-y"] = l;
          }
          return Y(this._url, u(o, this.options));
        },
        _tileOnLoad: function(i, o) {
          le.ielt9 ? setTimeout(d(i, this, null, o), 0) : i(null, o);
        },
        _tileOnError: function(i, o, l) {
          var p = this.options.errorTileUrl;
          p && o.getAttribute("src") !== p && (o.src = p), i(l, o);
        },
        _onTileRemove: function(i) {
          i.tile.onload = null;
        },
        _getZoomForUrl: function() {
          var i = this._tileZoom, o = this.options.maxZoom, l = this.options.zoomReverse, p = this.options.zoomOffset;
          return l && (i = o - i), i + p;
        },
        _getSubdomain: function(i) {
          var o = Math.abs(i.x + i.y) % this.options.subdomains.length;
          return this.options.subdomains[o];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
          var i, o;
          for (i in this._tiles)
            if (this._tiles[i].coords.z !== this._tileZoom && (o = this._tiles[i].el, o.onload = h, o.onerror = h, !o.complete)) {
              o.src = be;
              var l = this._tiles[i].coords;
              it(o), delete this._tiles[i], this.fire("tileabort", {
                tile: o,
                coords: l
              });
            }
        },
        _removeTile: function(i) {
          var o = this._tiles[i];
          if (o)
            return o.el.setAttribute("src", be), ze.prototype._removeTile.call(this, i);
        },
        _tileReady: function(i, o, l) {
          if (!(!this._map || l && l.getAttribute("src") === be))
            return ze.prototype._tileReady.call(this, i, o, l);
        }
      });
      function qr(i, o) {
        return new Oi(i, o);
      }
      var gl = Oi.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
          service: "WMS",
          request: "GetMap",
          // @option layers: String = ''
          // **(required)** Comma-separated list of WMS layers to show.
          layers: "",
          // @option styles: String = ''
          // Comma-separated list of WMS styles.
          styles: "",
          // @option format: String = 'image/jpeg'
          // WMS image format (use `'image/png'` for layers with transparency).
          format: "image/jpeg",
          // @option transparent: Boolean = false
          // If `true`, the WMS service will return images with transparency.
          transparent: !1,
          // @option version: String = '1.1.1'
          // Version of the WMS service to use
          version: "1.1.1"
        },
        options: {
          // @option crs: CRS = null
          // Coordinate Reference System to use for the WMS requests, defaults to
          // map CRS. Don't change this if you're not sure what it means.
          crs: null,
          // @option uppercase: Boolean = false
          // If `true`, WMS request parameter keys will be uppercase.
          uppercase: !1
        },
        initialize: function(i, o) {
          this._url = i;
          var l = u({}, this.defaultWmsParams);
          for (var p in o)
            p in this.options || (l[p] = o[p]);
          o = x(this, o);
          var v = o.detectRetina && le.retina ? 2 : 1, C = this.getTileSize();
          l.width = C.x * v, l.height = C.y * v, this.wmsParams = l;
        },
        onAdd: function(i) {
          this._crs = this.options.crs || i.options.crs, this._wmsVersion = parseFloat(this.wmsParams.version);
          var o = this._wmsVersion >= 1.3 ? "crs" : "srs";
          this.wmsParams[o] = this._crs.code, Oi.prototype.onAdd.call(this, i);
        },
        getTileUrl: function(i) {
          var o = this._tileCoordsToNwSe(i), l = this._crs, p = Ht(l.project(o[0]), l.project(o[1])), v = p.min, C = p.max, O = (this._wmsVersion >= 1.3 && this._crs === dl ? [v.y, v.x, C.y, C.x] : [v.x, v.y, C.x, C.y]).join(","), B = Oi.prototype.getTileUrl.call(this, i);
          return B + Z(this.wmsParams, B, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + O;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(i, o) {
          return u(this.wmsParams, i), o || this.redraw(), this;
        }
      });
      function _c(i, o) {
        return new gl(i, o);
      }
      Oi.WMS = gl, qr.wms = _c;
      var Yn = lt.extend({
        // @section
        // @aka Renderer options
        options: {
          // @option padding: Number = 0.1
          // How much to extend the clip area around the map view (relative to its size)
          // e.g. 0.1 would be 10% of map view in each direction
          padding: 0.1
        },
        initialize: function(i) {
          x(this, i), g(this), this._layers = this._layers || {};
        },
        onAdd: function() {
          this._container || (this._initContainer(), Se(this._container, "leaflet-zoom-animated")), this.getPane().appendChild(this._container), this._update(), this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
          this.off("update", this._updatePaths, this), this._destroyContainer();
        },
        getEvents: function() {
          var i = {
            viewreset: this._reset,
            zoom: this._onZoom,
            moveend: this._update,
            zoomend: this._onZoomEnd
          };
          return this._zoomAnimated && (i.zoomanim = this._onAnimZoom), i;
        },
        _onAnimZoom: function(i) {
          this._updateTransform(i.center, i.zoom);
        },
        _onZoom: function() {
          this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(i, o) {
          var l = this._map.getZoomScale(o, this._zoom), p = this._map.getSize().multiplyBy(0.5 + this.options.padding), v = this._map.project(this._center, o), C = p.multiplyBy(-l).add(v).subtract(this._map._getNewPixelOrigin(i, o));
          le.any3d ? Ai(this._container, C, l) : ft(this._container, C);
        },
        _reset: function() {
          this._update(), this._updateTransform(this._center, this._zoom);
          for (var i in this._layers)
            this._layers[i]._reset();
        },
        _onZoomEnd: function() {
          for (var i in this._layers)
            this._layers[i]._project();
        },
        _updatePaths: function() {
          for (var i in this._layers)
            this._layers[i]._update();
        },
        _update: function() {
          var i = this.options.padding, o = this._map.getSize(), l = this._map.containerPointToLayerPoint(o.multiplyBy(-i)).round();
          this._bounds = new Ue(l, l.add(o.multiplyBy(1 + i * 2)).round()), this._center = this._map.getCenter(), this._zoom = this._map.getZoom();
        }
      }), Kr = Yn.extend({
        // @section
        // @aka Canvas options
        options: {
          // @option tolerance: Number = 0
          // How much to extend the click tolerance around a path/object on the map.
          tolerance: 0
        },
        getEvents: function() {
          var i = Yn.prototype.getEvents.call(this);
          return i.viewprereset = this._onViewPreReset, i;
        },
        _onViewPreReset: function() {
          this._postponeUpdatePaths = !0;
        },
        onAdd: function() {
          Yn.prototype.onAdd.call(this), this._draw();
        },
        _initContainer: function() {
          var i = this._container = document.createElement("canvas");
          we(i, "mousemove", this._onMouseMove, this), we(i, "click dblclick mousedown mouseup contextmenu", this._onClick, this), we(i, "mouseout", this._handleMouseOut, this), i._leaflet_disable_events = !0, this._ctx = i.getContext("2d");
        },
        _destroyContainer: function() {
          nt(this._redrawRequest), delete this._ctx, it(this._container), et(this._container), delete this._container;
        },
        _updatePaths: function() {
          if (!this._postponeUpdatePaths) {
            var i;
            this._redrawBounds = null;
            for (var o in this._layers)
              i = this._layers[o], i._update();
            this._redraw();
          }
        },
        _update: function() {
          if (!(this._map._animatingZoom && this._bounds)) {
            Yn.prototype._update.call(this);
            var i = this._bounds, o = this._container, l = i.getSize(), p = le.retina ? 2 : 1;
            ft(o, i.min), o.width = p * l.x, o.height = p * l.y, o.style.width = l.x + "px", o.style.height = l.y + "px", le.retina && this._ctx.scale(2, 2), this._ctx.translate(-i.min.x, -i.min.y), this.fire("update");
          }
        },
        _reset: function() {
          Yn.prototype._reset.call(this), this._postponeUpdatePaths && (this._postponeUpdatePaths = !1, this._updatePaths());
        },
        _initPath: function(i) {
          this._updateDashArray(i), this._layers[g(i)] = i;
          var o = i._order = {
            layer: i,
            prev: this._drawLast,
            next: null
          };
          this._drawLast && (this._drawLast.next = o), this._drawLast = o, this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(i) {
          this._requestRedraw(i);
        },
        _removePath: function(i) {
          var o = i._order, l = o.next, p = o.prev;
          l ? l.prev = p : this._drawLast = p, p ? p.next = l : this._drawFirst = l, delete i._order, delete this._layers[g(i)], this._requestRedraw(i);
        },
        _updatePath: function(i) {
          this._extendRedrawBounds(i), i._project(), i._update(), this._requestRedraw(i);
        },
        _updateStyle: function(i) {
          this._updateDashArray(i), this._requestRedraw(i);
        },
        _updateDashArray: function(i) {
          if (typeof i.options.dashArray == "string") {
            var o = i.options.dashArray.split(/[, ]+/), l = [], p, v;
            for (v = 0; v < o.length; v++) {
              if (p = Number(o[v]), isNaN(p))
                return;
              l.push(p);
            }
            i.options._dashArray = l;
          } else
            i.options._dashArray = i.options.dashArray;
        },
        _requestRedraw: function(i) {
          this._map && (this._extendRedrawBounds(i), this._redrawRequest = this._redrawRequest || _t(this._redraw, this));
        },
        _extendRedrawBounds: function(i) {
          if (i._pxBounds) {
            var o = (i.options.weight || 0) + 1;
            this._redrawBounds = this._redrawBounds || new Ue(), this._redrawBounds.extend(i._pxBounds.min.subtract([o, o])), this._redrawBounds.extend(i._pxBounds.max.add([o, o]));
          }
        },
        _redraw: function() {
          this._redrawRequest = null, this._redrawBounds && (this._redrawBounds.min._floor(), this._redrawBounds.max._ceil()), this._clear(), this._draw(), this._redrawBounds = null;
        },
        _clear: function() {
          var i = this._redrawBounds;
          if (i) {
            var o = i.getSize();
            this._ctx.clearRect(i.min.x, i.min.y, o.x, o.y);
          } else
            this._ctx.save(), this._ctx.setTransform(1, 0, 0, 1, 0, 0), this._ctx.clearRect(0, 0, this._container.width, this._container.height), this._ctx.restore();
        },
        _draw: function() {
          var i, o = this._redrawBounds;
          if (this._ctx.save(), o) {
            var l = o.getSize();
            this._ctx.beginPath(), this._ctx.rect(o.min.x, o.min.y, l.x, l.y), this._ctx.clip();
          }
          this._drawing = !0;
          for (var p = this._drawFirst; p; p = p.next)
            i = p.layer, (!o || i._pxBounds && i._pxBounds.intersects(o)) && i._updatePath();
          this._drawing = !1, this._ctx.restore();
        },
        _updatePoly: function(i, o) {
          if (this._drawing) {
            var l, p, v, C, O = i._parts, B = O.length, F = this._ctx;
            if (B) {
              for (F.beginPath(), l = 0; l < B; l++) {
                for (p = 0, v = O[l].length; p < v; p++)
                  C = O[l][p], F[p ? "lineTo" : "moveTo"](C.x, C.y);
                o && F.closePath();
              }
              this._fillStroke(F, i);
            }
          }
        },
        _updateCircle: function(i) {
          if (!(!this._drawing || i._empty())) {
            var o = i._point, l = this._ctx, p = Math.max(Math.round(i._radius), 1), v = (Math.max(Math.round(i._radiusY), 1) || p) / p;
            v !== 1 && (l.save(), l.scale(1, v)), l.beginPath(), l.arc(o.x, o.y / v, p, 0, Math.PI * 2, !1), v !== 1 && l.restore(), this._fillStroke(l, i);
          }
        },
        _fillStroke: function(i, o) {
          var l = o.options;
          l.fill && (i.globalAlpha = l.fillOpacity, i.fillStyle = l.fillColor || l.color, i.fill(l.fillRule || "evenodd")), l.stroke && l.weight !== 0 && (i.setLineDash && i.setLineDash(o.options && o.options._dashArray || []), i.globalAlpha = l.opacity, i.lineWidth = l.weight, i.strokeStyle = l.color, i.lineCap = l.lineCap, i.lineJoin = l.lineJoin, i.stroke());
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(i) {
          for (var o = this._map.mouseEventToLayerPoint(i), l, p, v = this._drawFirst; v; v = v.next)
            l = v.layer, l.options.interactive && l._containsPoint(o) && (!(i.type === "click" || i.type === "preclick") || !this._map._draggableMoved(l)) && (p = l);
          this._fireEvent(p ? [p] : !1, i);
        },
        _onMouseMove: function(i) {
          if (!(!this._map || this._map.dragging.moving() || this._map._animatingZoom)) {
            var o = this._map.mouseEventToLayerPoint(i);
            this._handleMouseHover(i, o);
          }
        },
        _handleMouseOut: function(i) {
          var o = this._hoveredLayer;
          o && (rt(this._container, "leaflet-interactive"), this._fireEvent([o], i, "mouseout"), this._hoveredLayer = null, this._mouseHoverThrottled = !1);
        },
        _handleMouseHover: function(i, o) {
          if (!this._mouseHoverThrottled) {
            for (var l, p, v = this._drawFirst; v; v = v.next)
              l = v.layer, l.options.interactive && l._containsPoint(o) && (p = l);
            p !== this._hoveredLayer && (this._handleMouseOut(i), p && (Se(this._container, "leaflet-interactive"), this._fireEvent([p], i, "mouseover"), this._hoveredLayer = p)), this._fireEvent(this._hoveredLayer ? [this._hoveredLayer] : !1, i), this._mouseHoverThrottled = !0, setTimeout(d(function() {
              this._mouseHoverThrottled = !1;
            }, this), 32);
          }
        },
        _fireEvent: function(i, o, l) {
          this._map._fireDOMEvent(o, l || o.type, i);
        },
        _bringToFront: function(i) {
          var o = i._order;
          if (o) {
            var l = o.next, p = o.prev;
            if (l)
              l.prev = p;
            else
              return;
            p ? p.next = l : l && (this._drawFirst = l), o.prev = this._drawLast, this._drawLast.next = o, o.next = null, this._drawLast = o, this._requestRedraw(i);
          }
        },
        _bringToBack: function(i) {
          var o = i._order;
          if (o) {
            var l = o.next, p = o.prev;
            if (p)
              p.next = l;
            else
              return;
            l ? l.prev = p : p && (this._drawLast = p), o.prev = null, o.next = this._drawFirst, this._drawFirst.prev = o, this._drawFirst = o, this._requestRedraw(i);
          }
        }
      });
      function Qn(i) {
        return le.canvas ? new Kr(i) : null;
      }
      var hi = function() {
        try {
          return document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml"), function(i) {
            return document.createElement("<lvml:" + i + ' class="lvml">');
          };
        } catch {
        }
        return function(i) {
          return document.createElement("<" + i + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
      }(), vl = {
        _initContainer: function() {
          this._container = Ve("div", "leaflet-vml-container");
        },
        _update: function() {
          this._map._animatingZoom || (Yn.prototype._update.call(this), this.fire("update"));
        },
        _initPath: function(i) {
          var o = i._container = hi("shape");
          Se(o, "leaflet-vml-shape " + (this.options.className || "")), o.coordsize = "1 1", i._path = hi("path"), o.appendChild(i._path), this._updateStyle(i), this._layers[g(i)] = i;
        },
        _addPath: function(i) {
          var o = i._container;
          this._container.appendChild(o), i.options.interactive && i.addInteractiveTarget(o);
        },
        _removePath: function(i) {
          var o = i._container;
          it(o), i.removeInteractiveTarget(o), delete this._layers[g(i)];
        },
        _updateStyle: function(i) {
          var o = i._stroke, l = i._fill, p = i.options, v = i._container;
          v.stroked = !!p.stroke, v.filled = !!p.fill, p.stroke ? (o || (o = i._stroke = hi("stroke")), v.appendChild(o), o.weight = p.weight + "px", o.color = p.color, o.opacity = p.opacity, p.dashArray ? o.dashStyle = ee(p.dashArray) ? p.dashArray.join(" ") : p.dashArray.replace(/( *, *)/g, " ") : o.dashStyle = "", o.endcap = p.lineCap.replace("butt", "flat"), o.joinstyle = p.lineJoin) : o && (v.removeChild(o), i._stroke = null), p.fill ? (l || (l = i._fill = hi("fill")), v.appendChild(l), l.color = p.fillColor || p.color, l.opacity = p.fillOpacity) : l && (v.removeChild(l), i._fill = null);
        },
        _updateCircle: function(i) {
          var o = i._point.round(), l = Math.round(i._radius), p = Math.round(i._radiusY || l);
          this._setPath(i, i._empty() ? "M0 0" : "AL " + o.x + "," + o.y + " " + l + "," + p + " 0," + 65535 * 360);
        },
        _setPath: function(i, o) {
          i._path.v = o;
        },
        _bringToFront: function(i) {
          Ei(i._container);
        },
        _bringToBack: function(i) {
          si(i._container);
        }
      }, Ni = le.vml ? hi : Ji, fr = Yn.extend({
        _initContainer: function() {
          this._container = Ni("svg"), this._container.setAttribute("pointer-events", "none"), this._rootGroup = Ni("g"), this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
          it(this._container), et(this._container), delete this._container, delete this._rootGroup, delete this._svgSize;
        },
        _update: function() {
          if (!(this._map._animatingZoom && this._bounds)) {
            Yn.prototype._update.call(this);
            var i = this._bounds, o = i.getSize(), l = this._container;
            (!this._svgSize || !this._svgSize.equals(o)) && (this._svgSize = o, l.setAttribute("width", o.x), l.setAttribute("height", o.y)), ft(l, i.min), l.setAttribute("viewBox", [i.min.x, i.min.y, o.x, o.y].join(" ")), this.fire("update");
          }
        },
        // methods below are called by vector layers implementations
        _initPath: function(i) {
          var o = i._path = Ni("path");
          i.options.className && Se(o, i.options.className), i.options.interactive && Se(o, "leaflet-interactive"), this._updateStyle(i), this._layers[g(i)] = i;
        },
        _addPath: function(i) {
          this._rootGroup || this._initContainer(), this._rootGroup.appendChild(i._path), i.addInteractiveTarget(i._path);
        },
        _removePath: function(i) {
          it(i._path), i.removeInteractiveTarget(i._path), delete this._layers[g(i)];
        },
        _updatePath: function(i) {
          i._project(), i._update();
        },
        _updateStyle: function(i) {
          var o = i._path, l = i.options;
          o && (l.stroke ? (o.setAttribute("stroke", l.color), o.setAttribute("stroke-opacity", l.opacity), o.setAttribute("stroke-width", l.weight), o.setAttribute("stroke-linecap", l.lineCap), o.setAttribute("stroke-linejoin", l.lineJoin), l.dashArray ? o.setAttribute("stroke-dasharray", l.dashArray) : o.removeAttribute("stroke-dasharray"), l.dashOffset ? o.setAttribute("stroke-dashoffset", l.dashOffset) : o.removeAttribute("stroke-dashoffset")) : o.setAttribute("stroke", "none"), l.fill ? (o.setAttribute("fill", l.fillColor || l.color), o.setAttribute("fill-opacity", l.fillOpacity), o.setAttribute("fill-rule", l.fillRule || "evenodd")) : o.setAttribute("fill", "none"));
        },
        _updatePoly: function(i, o) {
          this._setPath(i, Ua(i._parts, o));
        },
        _updateCircle: function(i) {
          var o = i._point, l = Math.max(Math.round(i._radius), 1), p = Math.max(Math.round(i._radiusY), 1) || l, v = "a" + l + "," + p + " 0 1,0 ", C = i._empty() ? "M0 0" : "M" + (o.x - l) + "," + o.y + v + l * 2 + ",0 " + v + -l * 2 + ",0 ";
          this._setPath(i, C);
        },
        _setPath: function(i, o) {
          i._path.setAttribute("d", o);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(i) {
          Ei(i._path);
        },
        _bringToBack: function(i) {
          si(i._path);
        }
      });
      le.vml && fr.include(vl);
      function ca(i) {
        return le.svg || le.vml ? new fr(i) : null;
      }
      De.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(i) {
          var o = i.options.renderer || this._getPaneRenderer(i.options.pane) || this.options.renderer || this._renderer;
          return o || (o = this._renderer = this._createRenderer()), this.hasLayer(o) || this.addLayer(o), o;
        },
        _getPaneRenderer: function(i) {
          if (i === "overlayPane" || i === void 0)
            return !1;
          var o = this._paneRenderers[i];
          return o === void 0 && (o = this._createRenderer({ pane: i }), this._paneRenderers[i] = o), o;
        },
        _createRenderer: function(i) {
          return this.options.preferCanvas && Qn(i) || ca(i);
        }
      });
      var Yr = ur.extend({
        initialize: function(i, o) {
          ur.prototype.initialize.call(this, this._boundsToLatLngs(i), o);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(i) {
          return this.setLatLngs(this._boundsToLatLngs(i));
        },
        _boundsToLatLngs: function(i) {
          return i = vt(i), [
            i.getSouthWest(),
            i.getNorthWest(),
            i.getNorthEast(),
            i.getSouthEast()
          ];
        }
      });
      function yl(i, o) {
        return new Yr(i, o);
      }
      fr.create = Ni, fr.pointsToPath = Ua, Wt.geometryToLayer = Gt, Wt.coordsToLatLng = aa, Wt.coordsToLatLngs = Wo, Wt.latLngToCoords = la, Wt.latLngsToCoords = Go, Wt.getFeature = cr, Wt.asFeature = Kn, De.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: !0
      });
      var dr = ut.extend({
        initialize: function(i) {
          this._map = i, this._container = i._container, this._pane = i._panes.overlayPane, this._resetStateTimeout = 0, i.on("unload", this._destroy, this);
        },
        addHooks: function() {
          we(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
          et(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
          return this._moved;
        },
        _destroy: function() {
          it(this._pane), delete this._pane;
        },
        _resetState: function() {
          this._resetStateTimeout = 0, this._moved = !1;
        },
        _clearDeferredResetState: function() {
          this._resetStateTimeout !== 0 && (clearTimeout(this._resetStateTimeout), this._resetStateTimeout = 0);
        },
        _onMouseDown: function(i) {
          if (!i.shiftKey || i.which !== 1 && i.button !== 1)
            return !1;
          this._clearDeferredResetState(), this._resetState(), Pi(), Us(), this._startPoint = this._map.mouseEventToContainerPoint(i), we(document, {
            contextmenu: He,
            mousemove: this._onMouseMove,
            mouseup: this._onMouseUp,
            keydown: this._onKeyDown
          }, this);
        },
        _onMouseMove: function(i) {
          this._moved || (this._moved = !0, this._box = Ve("div", "leaflet-zoom-box", this._container), Se(this._container, "leaflet-crosshair"), this._map.fire("boxzoomstart")), this._point = this._map.mouseEventToContainerPoint(i);
          var o = new Ue(this._point, this._startPoint), l = o.getSize();
          ft(this._box, o.min), this._box.style.width = l.x + "px", this._box.style.height = l.y + "px";
        },
        _finish: function() {
          this._moved && (it(this._box), rt(this._container, "leaflet-crosshair")), kn(), $o(), et(document, {
            contextmenu: He,
            mousemove: this._onMouseMove,
            mouseup: this._onMouseUp,
            keydown: this._onKeyDown
          }, this);
        },
        _onMouseUp: function(i) {
          if (!(i.which !== 1 && i.button !== 1) && (this._finish(), !!this._moved)) {
            this._clearDeferredResetState(), this._resetStateTimeout = setTimeout(d(this._resetState, this), 0);
            var o = new jt(
              this._map.containerPointToLatLng(this._startPoint),
              this._map.containerPointToLatLng(this._point)
            );
            this._map.fitBounds(o).fire("boxzoomend", { boxZoomBounds: o });
          }
        },
        _onKeyDown: function(i) {
          i.keyCode === 27 && (this._finish(), this._clearDeferredResetState(), this._resetState());
        }
      });
      De.addInitHook("addHandler", "boxZoom", dr), De.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: !0
      });
      var fi = ut.extend({
        addHooks: function() {
          this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
          this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(i) {
          var o = this._map, l = o.getZoom(), p = o.options.zoomDelta, v = i.originalEvent.shiftKey ? l - p : l + p;
          o.options.doubleClickZoom === "center" ? o.setZoom(v) : o.setZoomAround(i.containerPoint, v);
        }
      });
      De.addInitHook("addHandler", "doubleClickZoom", fi), De.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: !0,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: !0,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // px/s^2
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: 1 / 0,
        // px/s
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: !1,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0
      });
      var Qr = ut.extend({
        addHooks: function() {
          if (!this._draggable) {
            var i = this._map;
            this._draggable = new ai(i._mapPane, i._container), this._draggable.on({
              dragstart: this._onDragStart,
              drag: this._onDrag,
              dragend: this._onDragEnd
            }, this), this._draggable.on("predrag", this._onPreDragLimit, this), i.options.worldCopyJump && (this._draggable.on("predrag", this._onPreDragWrap, this), i.on("zoomend", this._onZoomEnd, this), i.whenReady(this._onZoomEnd, this));
          }
          Se(this._map._container, "leaflet-grab leaflet-touch-drag"), this._draggable.enable(), this._positions = [], this._times = [];
        },
        removeHooks: function() {
          rt(this._map._container, "leaflet-grab"), rt(this._map._container, "leaflet-touch-drag"), this._draggable.disable();
        },
        moved: function() {
          return this._draggable && this._draggable._moved;
        },
        moving: function() {
          return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
          var i = this._map;
          if (i._stop(), this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
            var o = vt(this._map.options.maxBounds);
            this._offsetLimit = Ht(
              this._map.latLngToContainerPoint(o.getNorthWest()).multiplyBy(-1),
              this._map.latLngToContainerPoint(o.getSouthEast()).multiplyBy(-1).add(this._map.getSize())
            ), this._viscosity = Math.min(1, Math.max(0, this._map.options.maxBoundsViscosity));
          } else
            this._offsetLimit = null;
          i.fire("movestart").fire("dragstart"), i.options.inertia && (this._positions = [], this._times = []);
        },
        _onDrag: function(i) {
          if (this._map.options.inertia) {
            var o = this._lastTime = +/* @__PURE__ */ new Date(), l = this._lastPos = this._draggable._absPos || this._draggable._newPos;
            this._positions.push(l), this._times.push(o), this._prunePositions(o);
          }
          this._map.fire("move", i).fire("drag", i);
        },
        _prunePositions: function(i) {
          for (; this._positions.length > 1 && i - this._times[0] > 50; )
            this._positions.shift(), this._times.shift();
        },
        _onZoomEnd: function() {
          var i = this._map.getSize().divideBy(2), o = this._map.latLngToLayerPoint([0, 0]);
          this._initialWorldOffset = o.subtract(i).x, this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(i, o) {
          return i - (i - o) * this._viscosity;
        },
        _onPreDragLimit: function() {
          if (!(!this._viscosity || !this._offsetLimit)) {
            var i = this._draggable._newPos.subtract(this._draggable._startPos), o = this._offsetLimit;
            i.x < o.min.x && (i.x = this._viscousLimit(i.x, o.min.x)), i.y < o.min.y && (i.y = this._viscousLimit(i.y, o.min.y)), i.x > o.max.x && (i.x = this._viscousLimit(i.x, o.max.x)), i.y > o.max.y && (i.y = this._viscousLimit(i.y, o.max.y)), this._draggable._newPos = this._draggable._startPos.add(i);
          }
        },
        _onPreDragWrap: function() {
          var i = this._worldWidth, o = Math.round(i / 2), l = this._initialWorldOffset, p = this._draggable._newPos.x, v = (p - o + l) % i + o - l, C = (p + o + l) % i - o - l, O = Math.abs(v + l) < Math.abs(C + l) ? v : C;
          this._draggable._absPos = this._draggable._newPos.clone(), this._draggable._newPos.x = O;
        },
        _onDragEnd: function(i) {
          var o = this._map, l = o.options, p = !l.inertia || i.noInertia || this._times.length < 2;
          if (o.fire("dragend", i), p)
            o.fire("moveend");
          else {
            this._prunePositions(+/* @__PURE__ */ new Date());
            var v = this._lastPos.subtract(this._positions[0]), C = (this._lastTime - this._times[0]) / 1e3, O = l.easeLinearity, B = v.multiplyBy(O / C), F = B.distanceTo([0, 0]), K = Math.min(l.inertiaMaxSpeed, F), ne = B.multiplyBy(K / F), he = K / (l.inertiaDeceleration * O), Te = ne.multiplyBy(-he / 2).round();
            !Te.x && !Te.y ? o.fire("moveend") : (Te = o._limitOffset(Te, o.options.maxBounds), _t(function() {
              o.panBy(Te, {
                duration: he,
                easeLinearity: O,
                noMoveStart: !0,
                animate: !0
              });
            }));
          }
        }
      });
      De.addInitHook("addHandler", "dragging", Qr), De.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: !0,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
      });
      var bl = ut.extend({
        keyCodes: {
          left: [37],
          right: [39],
          down: [40],
          up: [38],
          zoomIn: [187, 107, 61, 171],
          zoomOut: [189, 109, 54, 173]
        },
        initialize: function(i) {
          this._map = i, this._setPanDelta(i.options.keyboardPanDelta), this._setZoomDelta(i.options.zoomDelta);
        },
        addHooks: function() {
          var i = this._map._container;
          i.tabIndex <= 0 && (i.tabIndex = "0"), we(i, {
            focus: this._onFocus,
            blur: this._onBlur,
            mousedown: this._onMouseDown
          }, this), this._map.on({
            focus: this._addHooks,
            blur: this._removeHooks
          }, this);
        },
        removeHooks: function() {
          this._removeHooks(), et(this._map._container, {
            focus: this._onFocus,
            blur: this._onBlur,
            mousedown: this._onMouseDown
          }, this), this._map.off({
            focus: this._addHooks,
            blur: this._removeHooks
          }, this);
        },
        _onMouseDown: function() {
          if (!this._focused) {
            var i = document.body, o = document.documentElement, l = i.scrollTop || o.scrollTop, p = i.scrollLeft || o.scrollLeft;
            this._map._container.focus(), window.scrollTo(p, l);
          }
        },
        _onFocus: function() {
          this._focused = !0, this._map.fire("focus");
        },
        _onBlur: function() {
          this._focused = !1, this._map.fire("blur");
        },
        _setPanDelta: function(i) {
          var o = this._panKeys = {}, l = this.keyCodes, p, v;
          for (p = 0, v = l.left.length; p < v; p++)
            o[l.left[p]] = [-1 * i, 0];
          for (p = 0, v = l.right.length; p < v; p++)
            o[l.right[p]] = [i, 0];
          for (p = 0, v = l.down.length; p < v; p++)
            o[l.down[p]] = [0, i];
          for (p = 0, v = l.up.length; p < v; p++)
            o[l.up[p]] = [0, -1 * i];
        },
        _setZoomDelta: function(i) {
          var o = this._zoomKeys = {}, l = this.keyCodes, p, v;
          for (p = 0, v = l.zoomIn.length; p < v; p++)
            o[l.zoomIn[p]] = i;
          for (p = 0, v = l.zoomOut.length; p < v; p++)
            o[l.zoomOut[p]] = -i;
        },
        _addHooks: function() {
          we(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
          et(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(i) {
          if (!(i.altKey || i.ctrlKey || i.metaKey)) {
            var o = i.keyCode, l = this._map, p;
            if (o in this._panKeys) {
              if (!l._panAnim || !l._panAnim._inProgress)
                if (p = this._panKeys[o], i.shiftKey && (p = _e(p).multiplyBy(3)), l.options.maxBounds && (p = l._limitOffset(_e(p), l.options.maxBounds)), l.options.worldCopyJump) {
                  var v = l.wrapLatLng(l.unproject(l.project(l.getCenter()).add(p)));
                  l.panTo(v);
                } else
                  l.panBy(p);
            } else if (o in this._zoomKeys)
              l.setZoom(l.getZoom() + (i.shiftKey ? 3 : 1) * this._zoomKeys[o]);
            else if (o === 27 && l._popup && l._popup.options.closeOnEscapeKey)
              l.closePopup();
            else
              return;
            He(i);
          }
        }
      });
      De.addInitHook("addHandler", "keyboard", bl), De.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: !0,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
      });
      var wl = ut.extend({
        addHooks: function() {
          we(this._map._container, "wheel", this._onWheelScroll, this), this._delta = 0;
        },
        removeHooks: function() {
          et(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(i) {
          var o = sl(i), l = this._map.options.wheelDebounceTime;
          this._delta += o, this._lastMousePos = this._map.mouseEventToContainerPoint(i), this._startTime || (this._startTime = +/* @__PURE__ */ new Date());
          var p = Math.max(l - (+/* @__PURE__ */ new Date() - this._startTime), 0);
          clearTimeout(this._timer), this._timer = setTimeout(d(this._performZoom, this), p), He(i);
        },
        _performZoom: function() {
          var i = this._map, o = i.getZoom(), l = this._map.options.zoomSnap || 0;
          i._stop();
          var p = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), v = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(p)))) / Math.LN2, C = l ? Math.ceil(v / l) * l : v, O = i._limitZoom(o + (this._delta > 0 ? C : -C)) - o;
          this._delta = 0, this._startTime = null, O && (i.options.scrollWheelZoom === "center" ? i.setZoom(o + O) : i.setZoomAround(this._lastMousePos, o + O));
        }
      });
      De.addInitHook("addHandler", "scrollWheelZoom", wl);
      var gc = 600;
      De.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: le.touchNative && le.safari && le.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
      });
      var Jr = ut.extend({
        addHooks: function() {
          we(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
          et(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(i) {
          if (clearTimeout(this._holdTimeout), i.touches.length === 1) {
            var o = i.touches[0];
            this._startPos = this._newPos = new fe(o.clientX, o.clientY), this._holdTimeout = setTimeout(d(function() {
              this._cancel(), this._isTapValid() && (we(document, "touchend", Ce), we(document, "touchend touchcancel", this._cancelClickPrevent), this._simulateEvent("contextmenu", o));
            }, this), gc), we(document, "touchend touchcancel contextmenu", this._cancel, this), we(document, "touchmove", this._onMove, this);
          }
        },
        _cancelClickPrevent: function i() {
          et(document, "touchend", Ce), et(document, "touchend touchcancel", i);
        },
        _cancel: function() {
          clearTimeout(this._holdTimeout), et(document, "touchend touchcancel contextmenu", this._cancel, this), et(document, "touchmove", this._onMove, this);
        },
        _onMove: function(i) {
          var o = i.touches[0];
          this._newPos = new fe(o.clientX, o.clientY);
        },
        _isTapValid: function() {
          return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(i, o) {
          var l = new MouseEvent(i, {
            bubbles: !0,
            cancelable: !0,
            view: window,
            // detail: 1,
            screenX: o.screenX,
            screenY: o.screenY,
            clientX: o.clientX,
            clientY: o.clientY
            // button: 2,
            // buttons: 2
          });
          l._simulated = !0, o.target.dispatchEvent(l);
        }
      });
      De.addInitHook("addHandler", "tapHold", Jr), De.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: le.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: !0
      });
      var Xr = ut.extend({
        addHooks: function() {
          Se(this._map._container, "leaflet-touch-zoom"), we(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
          rt(this._map._container, "leaflet-touch-zoom"), et(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(i) {
          var o = this._map;
          if (!(!i.touches || i.touches.length !== 2 || o._animatingZoom || this._zooming)) {
            var l = o.mouseEventToContainerPoint(i.touches[0]), p = o.mouseEventToContainerPoint(i.touches[1]);
            this._centerPoint = o.getSize()._divideBy(2), this._startLatLng = o.containerPointToLatLng(this._centerPoint), o.options.touchZoom !== "center" && (this._pinchStartLatLng = o.containerPointToLatLng(l.add(p)._divideBy(2))), this._startDist = l.distanceTo(p), this._startZoom = o.getZoom(), this._moved = !1, this._zooming = !0, o._stop(), we(document, "touchmove", this._onTouchMove, this), we(document, "touchend touchcancel", this._onTouchEnd, this), Ce(i);
          }
        },
        _onTouchMove: function(i) {
          if (!(!i.touches || i.touches.length !== 2 || !this._zooming)) {
            var o = this._map, l = o.mouseEventToContainerPoint(i.touches[0]), p = o.mouseEventToContainerPoint(i.touches[1]), v = l.distanceTo(p) / this._startDist;
            if (this._zoom = o.getScaleZoom(v, this._startZoom), !o.options.bounceAtZoomLimits && (this._zoom < o.getMinZoom() && v < 1 || this._zoom > o.getMaxZoom() && v > 1) && (this._zoom = o._limitZoom(this._zoom)), o.options.touchZoom === "center") {
              if (this._center = this._startLatLng, v === 1)
                return;
            } else {
              var C = l._add(p)._divideBy(2)._subtract(this._centerPoint);
              if (v === 1 && C.x === 0 && C.y === 0)
                return;
              this._center = o.unproject(o.project(this._pinchStartLatLng, this._zoom).subtract(C), this._zoom);
            }
            this._moved || (o._moveStart(!0, !1), this._moved = !0), nt(this._animRequest);
            var O = d(o._move, o, this._center, this._zoom, { pinch: !0, round: !1 }, void 0);
            this._animRequest = _t(O, this, !0), Ce(i);
          }
        },
        _onTouchEnd: function() {
          if (!this._moved || !this._zooming) {
            this._zooming = !1;
            return;
          }
          this._zooming = !1, nt(this._animRequest), et(document, "touchmove", this._onTouchMove, this), et(document, "touchend touchcancel", this._onTouchEnd, this), this._map.options.zoomAnimation ? this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), !0, this._map.options.zoomSnap) : this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
      });
      De.addInitHook("addHandler", "touchZoom", Xr), De.BoxZoom = dr, De.DoubleClickZoom = fi, De.Drag = Qr, De.Keyboard = bl, De.ScrollWheelZoom = wl, De.TapHold = Jr, De.TouchZoom = Xr, t.Bounds = Ue, t.Browser = le, t.CRS = Zn, t.Canvas = Kr, t.Circle = Zo, t.CircleMarker = jo, t.Class = At, t.Control = nn, t.DivIcon = Gr, t.DivOverlay = zn, t.DomEvent = lc, t.DomUtil = nl, t.Draggable = ai, t.Evented = Ln, t.FeatureGroup = Rn, t.GeoJSON = Wt, t.GridLayer = ze, t.Handler = ut, t.Icon = ar, t.ImageOverlay = ie, t.LatLng = Re, t.LatLngBounds = jt, t.Layer = lt, t.LayerGroup = li, t.LineUtil = ta, t.Map = De, t.Marker = Ho, t.Mixin = uc, t.Path = ui, t.Point = fe, t.PolyUtil = Js, t.Polygon = ur, t.Polyline = dn, t.Popup = Bt, t.PosAnimation = Gs, t.Projection = ia, t.Rectangle = Yr, t.Renderer = Yn, t.SVG = fr, t.SVGOverlay = Qe, t.TileLayer = Oi, t.Tooltip = Ko, t.Transformation = Qi, t.Util = wn, t.VideoOverlay = je, t.bind = d, t.bounds = Ht, t.canvas = Qn, t.circle = ci, t.circleMarker = oa, t.control = Mn, t.divIcon = Yo, t.extend = u, t.featureGroup = ml, t.geoJSON = j, t.geoJson = U, t.gridLayer = mc, t.icon = fc, t.imageOverlay = ve, t.latLng = Pe, t.latLngBounds = vt, t.layerGroup = Zr, t.map = Pt, t.marker = lr, t.point = _e, t.polygon = pc, t.polyline = dc, t.popup = qo, t.rectangle = yl, t.setOptions = x, t.stamp = g, t.svg = ca, t.svgOverlay = ua, t.tileLayer = qr, t.tooltip = hr, t.transformation = oi, t.version = a, t.videoOverlay = Lt;
      var ha = window.L;
      t.noConflict = function() {
        return window.L = ha, this;
      }, window.L = t;
    });
  }(Wl, Wl.exports)), Wl.exports;
}
var T1 = Jm();
const vi = /* @__PURE__ */ Zm(T1);
(function() {
  var e = Symbol("newer"), n = Symbol("older"), t = function(y, w) {
    typeof y != "number" && (w = y, y = 0), this.size = 0, this.limit = y, this.oldest = this.newest = void 0, this._keymap = /* @__PURE__ */ new Map(), w && (this.assign(w), y < 1 && (this.limit = this.size));
  };
  t.prototype._markEntryAsUsed = function(y) {
    y !== this.newest && (y[e] && (y === this.oldest && (this.oldest = y[e]), y[e][n] = y[n]), y[n] && (y[n][e] = y[e]), y[e] = void 0, y[n] = this.newest, this.newest && (this.newest[e] = y), this.newest = y);
  }, t.prototype.assign = function(y) {
    var w, h = this.limit || Number.MAX_VALUE;
    this._keymap.clear();
    for (var b = y[Symbol.iterator](), T = b.next(); !T.done; T = b.next()) {
      var A = new a(T.value[0], T.value[1]);
      if (this._keymap.set(A.key, A), w ? (w[e] = A, A[n] = w) : this.oldest = A, w = A, h-- == 0)
        throw new Error("overflow");
    }
    this.newest = w, this.size = this._keymap.size;
  }, t.prototype.get = function(y) {
    var w = this._keymap.get(y);
    if (w)
      return this._markEntryAsUsed(w), w.value;
  }, t.prototype.set = function(y, w) {
    var h = this._keymap.get(y);
    return h ? (h.value = w, this._markEntryAsUsed(h), this) : (this._keymap.set(y, h = new a(y, w)), this.newest ? (this.newest[e] = h, h[n] = this.newest) : this.oldest = h, this.newest = h, ++this.size, this.size > this.limit && this.shift(), this);
  }, t.prototype.shift = function() {
    var y = this.oldest;
    if (y)
      return this.oldest[e] ? (this.oldest = this.oldest[e], this.oldest[n] = void 0) : (this.oldest = void 0, this.newest = void 0), y[e] = y[n] = void 0, this._keymap.delete(y.key), --this.size, [y.key, y.value];
  }, t.prototype.find = function(y) {
    var w = this._keymap.get(y);
    return w ? w.value : void 0;
  }, t.prototype.has = function(y) {
    return this._keymap.has(y);
  }, t.prototype.delete = function(y) {
    var w = this._keymap.get(y);
    if (w)
      return this._keymap.delete(w.key), w[e] && w[n] ? (w[n][e] = w[e], w[e][n] = w[n]) : w[e] ? (w[e][n] = void 0, this.oldest = w[e]) : w[n] ? (w[n][e] = void 0, this.newest = w[n]) : this.oldest = this.newest = void 0, this.size--, w.value;
  }, t.prototype.clear = function() {
    this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
  }, t.prototype.keys = function() {
    return new f(this.oldest);
  }, t.prototype.values = function() {
    return new d(this.oldest);
  }, t.prototype.entries = function() {
    return this;
  }, t.prototype[Symbol.iterator] = function() {
    return new u(this.oldest);
  }, t.prototype.forEach = function(y, w) {
    typeof w != "object" && (w = this);
    for (var h = this.oldest; h; )
      y.call(w, h.value, h.key, this), h = h[e];
  }, t.prototype.toJSON = function() {
    for (var y = new Array(this.size), w = 0, h = this.oldest; h; )
      y[w++] = { key: h.key, value: h.value }, h = h[e];
    return y;
  }, t.prototype.toString = function() {
    for (var y = "", w = this.oldest; w; )
      y += String(w.key) + ":" + w.value, w = w[e], w && (y += " < ");
    return y;
  };
  function a(g, y) {
    this.key = g, this.value = y, this[e] = void 0, this[n] = void 0;
  }
  function u(g) {
    this.entry = g;
  }
  u.prototype[Symbol.iterator] = function() {
    return this;
  }, u.prototype.next = function() {
    var g = this.entry;
    return g ? (this.entry = g[e], { done: !1, value: [g.key, g.value] }) : { done: !0, value: void 0 };
  };
  function f(g) {
    this.entry = g;
  }
  f.prototype[Symbol.iterator] = function() {
    return this;
  }, f.prototype.next = function() {
    var g = this.entry;
    return g ? (this.entry = g[e], { done: !1, value: g.key }) : { done: !0, value: void 0 };
  };
  function d(g) {
    this.entry = g;
  }
  d.prototype[Symbol.iterator] = function() {
    return this;
  }, d.prototype.next = function() {
    var g = this.entry;
    return g ? (this.entry = g[e], { done: !1, value: g.value }) : { done: !0, value: void 0 };
  };
  function m(g, y) {
    var w = 0, h = null;
    h = setInterval(function() {
      if (w >= 20)
        throw clearInterval(h), new Error("window.google not found after 10 seconds");
      window.google && window.google.maps && window.google.maps.Map && (clearInterval(h), g.call(y)), ++w;
    }, 500);
  }
  L.GridLayer.GoogleMutant = L.GridLayer.extend({
    options: {
      maxZoom: 21,
      // can be 23, but ugly if more than maxNativeZoom
      // 🍂option type: String = 'roadmap'
      // Google's map type. Valid values are 'roadmap', 'satellite', 'terrain' or 'hybrid'.
      type: "roadmap",
      maxNativeZoom: 21
    },
    initialize: function(g) {
      L.GridLayer.prototype.initialize.call(this, g), this._tileCallbacks = {}, this._lru = new t(100), this._imagesPerTile = this.options.type === "hybrid" ? 2 : 1, this._boundOnMutatedImage = this._onMutatedImage.bind(this);
    },
    onAdd: function(g) {
      var y = this;
      L.GridLayer.prototype.onAdd.call(this, g), this._initMutantContainer(), this._logoContainer && g._controlCorners.bottomleft.appendChild(this._logoContainer), this._attributionContainer && g._controlCorners.bottomright.appendChild(this._attributionContainer), m(function() {
        y._map && (y._initMutant(), google.maps.event.addListenerOnce(y._mutant, "idle", function() {
          y._map && (y._checkZoomLevels(), y._mutantIsReady = !0);
        }));
      });
    },
    onRemove: function(g) {
      L.GridLayer.prototype.onRemove.call(this, g), this._observer.disconnect(), g._container.removeChild(this._mutantContainer), this._logoContainer && L.DomUtil.remove(this._logoContainer), this._attributionContainer && L.DomUtil.remove(this._attributionContainer), this._mutant && google.maps.event.clearListeners(this._mutant, "idle");
    },
    // 🍂method addGoogleLayer(name: String, options?: Object): this
    // Adds layer with the given name and options to the google Map instance.
    // `name`: one of the google maps API layers, with it's constructor available in `google.maps` object.
    // currently following values supported: 'TrafficLayer', 'TransitLayer', 'BicyclingLayer'.
    // `options`: see https://developers.google.com/maps/documentation/javascript/reference/map
    addGoogleLayer: function(g, y) {
      var w = this;
      return this._subLayers || (this._subLayers = {}), this.whenReady(function() {
        var h = google.maps[g], b = new h(y);
        b.setMap(w._mutant), w._subLayers[g] = b;
      }), this;
    },
    // 🍂method removeGoogleLayer(name: String): this
    // Removes layer with the given name from the google Map instance.
    removeGoogleLayer: function(g) {
      var y = this;
      return this.whenReady(function() {
        var w = y._subLayers && y._subLayers[g];
        w && (w.setMap(null), delete y._subLayers[g]);
      }), this;
    },
    _initMutantContainer: function() {
      this._mutantContainer || (this._mutantContainer = L.DomUtil.create(
        "div",
        "leaflet-google-mutant leaflet-top leaflet-left"
      ), this._mutantContainer.id = "_MutantContainer_" + L.Util.stamp(this._mutantContainer), this._mutantContainer.style.pointerEvents = "none", this._mutantContainer.style.visibility = "hidden", L.DomEvent.off(this._mutantContainer)), this._map.getContainer().appendChild(this._mutantContainer), this.setOpacity(this.options.opacity);
      var g = this._mutantContainer.style;
      this._map.options.zoomSnap < 1 ? (g.width = "180%", g.height = "180%") : (g.width = "100%", g.height = "100%"), g.zIndex = -1, this._attachObserver(this._mutantContainer);
    },
    _initMutant: function() {
      if (!this._mutant) {
        var g = new google.maps.Map(this._mutantContainer, {
          center: { lat: 0, lng: 0 },
          zoom: 0,
          tilt: 0,
          mapTypeId: this.options.type,
          disableDefaultUI: !0,
          keyboardShortcuts: !1,
          draggable: !1,
          disableDoubleClickZoom: !0,
          scrollwheel: !1,
          styles: this.options.styles || [],
          backgroundColor: "transparent"
        });
        this._mutant = g, this._update(), this.fire("spawned", { mapObject: g }), this._waitControls(), this.once("controls_ready", this._setupAttribution);
      }
    },
    _attachObserver: function(y) {
      this._observer || (this._observer = new MutationObserver(this._onMutations.bind(this))), this._observer.observe(y, { childList: !0, subtree: !0 }), Array.prototype.forEach.call(y.querySelectorAll("img"), this._boundOnMutatedImage);
    },
    _waitControls: function() {
      var g = this, y = setInterval(function() {
        var w = g._mutant.__gm.layoutManager;
        if (w) {
          clearInterval(y);
          var h;
          Object.keys(w).forEach(function(b) {
            var T = w[b];
            T.get && T.get(1) instanceof Node && (h = T);
          }), g.fire("controls_ready", { positions: h });
        }
      }, 50);
    },
    _setupAttribution: function(g) {
      if (this._map) {
        var y = google.maps.ControlPosition, w = this._attributionContainer = g.positions.get(y.BOTTOM_RIGHT);
        L.DomUtil.addClass(w, "leaflet-control leaflet-control-attribution"), L.DomEvent.disableClickPropagation(w), w.style.height = "14px", this._map._controlCorners.bottomright.appendChild(w), this._logoContainer = g.positions.get(y.BOTTOM_LEFT), this._logoContainer.style.pointerEvents = "auto", this._map._controlCorners.bottomleft.appendChild(this._logoContainer);
      }
    },
    _onMutations: function(y) {
      for (var w = 0; w < y.length; ++w)
        for (var h = y[w], b = 0; b < h.addedNodes.length; ++b) {
          var T = h.addedNodes[b];
          T instanceof HTMLImageElement ? this._onMutatedImage(T) : T instanceof HTMLElement && Array.prototype.forEach.call(
            T.querySelectorAll("img"),
            this._boundOnMutatedImage
          );
        }
    },
    // Only images which 'src' attrib match this will be considered for moving around.
    // Looks like some kind of string-based protobuf, maybe??
    // Only the roads (and terrain, and vector-based stuff) match this pattern
    _roadRegexp: /!1i(\d+)!2i(\d+)!3i(\d+|VinaFnapurmBegrtn)!/,
    // On the other hand, raster imagery matches this other pattern
    _satRegexp: /x=(\d+)&y=(\d+)&z=(\d+|VinaFnapurmBegrtn)/,
    _onMutatedImage: function(y) {
      var w, h = y.src.match(this._roadRegexp), b = 0;
      if (h ? (w = {
        z: h[1],
        x: h[2],
        y: h[3]
      }, this._imagesPerTile > 1 && (y.style.zIndex = 1, b = 1)) : (h = y.src.match(this._satRegexp), h && (w = {
        x: h[1],
        y: h[2],
        z: h[3]
      }), b = 0), w) {
        var T = this._tileCoordsToKey(w);
        y.style.position = "absolute";
        var A = T + "/" + b;
        this._lru.set(A, y), A in this._tileCallbacks && this._tileCallbacks[A] && (this._tileCallbacks[A].forEach(function(x) {
          return x(y);
        }), delete this._tileCallbacks[A]);
      }
    },
    createTile: function(g, y) {
      var w = this._tileCoordsToKey(g), h = L.DomUtil.create("div");
      h.style.textAlign = "left", h.dataset.pending = this._imagesPerTile, y = y.bind(this, null, h);
      for (var b = 0; b < this._imagesPerTile; ++b) {
        var T = w + "/" + b, A = this._lru.get(T);
        A ? (h.appendChild(this._clone(A)), --h.dataset.pending) : (this._tileCallbacks[T] = this._tileCallbacks[T] || [], this._tileCallbacks[T].push(
          function(x) {
            return function(Z) {
              x.appendChild(this._clone(Z)), --x.dataset.pending, parseInt(x.dataset.pending) || y();
            }.bind(this);
          }.bind(this)(
            h
            /*, key2*/
          )
        ));
      }
      return parseInt(h.dataset.pending) || L.Util.requestAnimFrame(y), h;
    },
    _clone: function(g) {
      var y = g.cloneNode(!0);
      return y.style.visibility = "visible", y;
    },
    _checkZoomLevels: function() {
      var g = this._map.getZoom(), y = this._mutant.getZoom();
      !g || !y || (y !== g || //zoom levels are out of sync, Google doesn't have data
      y > this.options.maxNativeZoom) && this._setMaxNativeZoom(y);
    },
    _setMaxNativeZoom: function(g) {
      g !== this.options.maxNativeZoom && (this.options.maxNativeZoom = g, this._resetView());
    },
    _update: function(g) {
      if (this._mutant) {
        g = g || this._map.getCenter();
        var y = new google.maps.LatLng(g.lat, g.lng), w = Math.round(this._map.getZoom()), h = this._mutant.getZoom();
        this._mutant.setCenter(y), w !== h && (this._mutant.setZoom(w), this._mutantIsReady && this._checkZoomLevels());
      }
      L.GridLayer.prototype._update.call(this, g);
    },
    // @method whenReady(fn: Function, context?: Object): this
    // Runs the given function `fn` when the mutant gets initialized, or immediately
    // if it's already initialized, optionally passing a function context.
    whenReady: function(g, y) {
      return this._mutant ? g.call(y || this, { target: this }) : this.on("spawned", g, y), this;
    }
  }), L.gridLayer.googleMutant = function(g) {
    return new L.GridLayer.GoogleMutant(g);
  };
})();
const dh = 8, E1 = oe({
  emits: ["update:model-value", "validate-field"],
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    properties: {
      type: Object,
      required: !0
    },
    locale: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      TO_FIXED: dh,
      map: null,
      dialogMap: null,
      marker: null,
      dialogLat: null,
      dialogLng: null
    };
  },
  computed: {
    scopeLat() {
      return ke.get(this.modelValue, this.properties.scopeLat);
    },
    scopeLng() {
      return ke.get(this.modelValue, this.properties.scopeLng);
    },
    latLng() {
      return [this.scopeLat, this.scopeLng];
    },
    hasLatLng() {
      return this.latLng.every((e) => e || e === 0);
    }
  },
  mounted() {
    this.map = vi.map(this.$refs.mapContainer, {
      dragging: !1,
      touchZoom: !1,
      doubleClickZoom: !1,
      scrollWheelZoom: !1,
      keyboard: !1,
      tap: !1
    }), this.map.setView(gi.center, gi.zoom), vi.gridLayer.googleMutant(Rh).addTo(this.map), this.marker = vi.marker(gi.center, {
      icon: vi.divIcon($L)
    });
  },
  methods: {
    onDialogOpened() {
      this.dialogMap = vi.map(this.$refs.dialogMapContainer), this.dialogMap.setView(
        this.hasLatLng ? this.latLng : gi.center,
        this.hasLatLng ? gi.nearZoom : gi.zoom
      ), vi.gridLayer.googleMutant(Rh).addTo(this.dialogMap), this.dialogMap.on("moveend", this.setDialogLatLng), this.dialogMap.on("zoomend", this.setDialogLatLng), this.setDialogLatLng();
    },
    onDialogClose() {
      this.dialogMap.off("moveend", this.setDialogLatLng), this.dialogMap.off("zoomend", this.setDialogLatLng), this.dialogLat = null, this.dialogLng = null;
    },
    setDialogLatLng() {
      const { lat: e, lng: n } = this.dialogMap.getCenter().wrap();
      this.dialogLat = parseFloat(e.toFixed(dh)), this.dialogLng = parseFloat(n.toFixed(dh));
    },
    select() {
      let e = this.modelValue;
      e = ke.set(e, this.properties.scopeLat, this.dialogLat), e = ke.set(e, this.properties.scopeLng, this.dialogLng), this.$emit("update:model-value", e), this.$emit("validate-field", this.properties.scopeLat), this.$emit("validate-field", this.properties.scopeLng), this.$refs.dialog.close();
    }
  },
  watch: {
    latLng() {
      this.hasLatLng ? (this.map.flyTo(this.latLng), this.marker.setLatLng(this.latLng), this.marker.addTo(this.map)) : (this.map.flyTo(gi.center), this.marker.removeFrom(this.map));
    }
  },
  components: {
    DialogComponent: Ls
  }
}), A1 = "_button_1nooi_1", P1 = "_button__map_1nooi_10", x1 = "_edit_1nooi_17", O1 = "_dialog__title_1nooi_39", N1 = "_dialog__content_1nooi_45", I1 = "_dialog__map_1nooi_51", k1 = {
  button: A1,
  button__map: P1,
  edit: x1,
  dialog__title: O1,
  dialog__content: N1,
  dialog__map: I1
}, D1 = /* @__PURE__ */ ae("div", { class: "marker" }, null, -1);
function $1(e, n, t, a, u, f) {
  const d = D("icon-edit-pen"), m = D("el-icon"), g = D("el-avatar"), y = D("el-button"), w = D("dialog-component"), h = D("el-form-item");
  return V(), X(h, null, {
    default: k(() => [
      z(w, {
        width: "1000px",
        ref: "dialog",
        onOpened: e.onDialogOpened,
        onClose: e.onDialogClose
      }, Tt({
        activator: k(({ open: b }) => [
          z(y, {
            class: J(e.$style.button),
            disabled: e.disabled,
            onClick: b
          }, {
            default: k(() => [
              ae("div", {
                class: J(e.$style.button__map),
                ref: "mapContainer"
              }, null, 2),
              z(g, {
                class: J(e.$style.edit),
                size: 30
              }, {
                default: k(() => [
                  z(m, { size: "16" }, {
                    default: k(() => [
                      z(d)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 2
          }, 1032, ["class", "disabled", "onClick"])
        ]),
        default: k(({ dialogOpen: b }) => [
          b ? (V(), ue("div", {
            key: 0,
            class: J(e.$style.dialog__content)
          }, [
            ae("div", {
              class: J(e.$style.dialog__map),
              ref: "dialogMapContainer"
            }, null, 2),
            D1
          ], 2)) : Ze("", !0)
        ]),
        footer: k(() => [
          z(y, { onClick: e.select }, {
            default: k(() => [
              $h(wt(e.properties.confirmationText[e.locale]), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 2
      }, [
        e.dialogLat || e.dialogLng ? {
          name: "header",
          fn: k(() => [
            ae("div", {
              class: J(e.$style.dialog__title)
            }, [
              ae("span", null, wt(e.dialogLat), 1),
              ae("span", null, wt(e.dialogLng), 1)
            ], 2)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["onOpened", "onClose"])
    ]),
    _: 1
  });
}
const R1 = {
  $style: k1
}, z1 = /* @__PURE__ */ ce(E1, [["render", $1], ["__cssModules", R1]]), ph = {
  left: "left",
  center: "center",
  right: "right"
}, B1 = oe({
  emits: ["submit"],
  props: {
    properties: {
      type: Object,
      required: !0
    },
    locale: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    text() {
      return this.properties.label[this.locale];
    },
    left() {
      return this.properties.align === ph.left;
    },
    center() {
      return this.properties.align === ph.center;
    },
    right() {
      return this.properties.align === ph.right;
    }
  },
  methods: {
    onButtonClick() {
      this.$emit("submit");
    }
  }
}), F1 = "_left_lpbbo_1", U1 = "_center_lpbbo_5", V1 = "_right_lpbbo_9", H1 = {
  left: F1,
  center: U1,
  right: V1
}, j1 = ["innerHTML"];
function Z1(e, n, t, a, u, f) {
  const d = D("el-button"), m = D("el-form-item");
  return V(), X(m, null, {
    default: k(() => [
      z(d, {
        class: J({ [e.$style.left]: e.left, [e.$style.center]: e.center, [e.$style.right]: e.right }),
        disabled: e.disabled,
        onClick: e.onButtonClick
      }, {
        default: k(() => [
          ae("span", { innerHTML: e.text }, null, 8, j1)
        ]),
        _: 1
      }, 8, ["class", "disabled", "onClick"])
    ]),
    _: 1
  });
}
const W1 = {
  $style: H1
}, G1 = /* @__PURE__ */ ce(B1, [["render", Z1], ["__cssModules", W1]]), q1 = oe({
  mixins: [Cs],
  emits: ["update:model-value", "submit", "validate-field"],
  data() {
    return {
      ButtonComponent: {
        [`${_o.mapSelect}`]: Le(z1),
        [`${_o.submit}`]: Le(G1)
      }
    };
  },
  computed: {
    properties() {
      return this.schema.properties;
    },
    disabled() {
      return this.readonly || this.properties.readonly;
    },
    model: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:model-value", e);
      }
    }
  },
  methods: {
    onSubmitForm() {
      this.$emit("submit");
    },
    validateField(e) {
      this.$emit("validate-field", e);
    }
  }
});
function K1(e, n, t, a, u, f) {
  return e.isShown ? (V(), X(Gi(e.ButtonComponent[e.properties.type]), {
    key: 0,
    modelValue: e.model,
    "onUpdate:modelValue": n[0] || (n[0] = (d) => e.model = d),
    id: e.schema.id,
    properties: e.properties,
    locale: e.locale,
    disabled: e.disabled,
    onSubmit: e.onSubmitForm,
    onValidateField: e.validateField
  }, null, 40, ["modelValue", "id", "properties", "locale", "disabled", "onSubmit", "onValidateField"])) : Ze("", !0);
}
const Xm = /* @__PURE__ */ ce(q1, [["render", K1]]), Y1 = oe({
  props: {
    label: {
      type: String
    },
    rules: {
      type: Array
    }
  },
  computed: {
    hasRules() {
      return this.rules && this.rules.length > 0;
    }
  }
}), Q1 = "_label_hgnjd_1", J1 = "_star_hgnjd_5", X1 = {
  label: Q1,
  star: J1
}, eM = ["innerHTML"];
function tM(e, n, t, a, u, f) {
  return V(), ue(st, null, [
    ae("span", {
      innerHTML: e.label,
      class: J(e.$style.label)
    }, null, 10, eM),
    e.hasRules ? (V(), ue("span", {
      key: 0,
      class: J(e.$style.star)
    }, " *", 2)) : Ze("", !0)
  ], 64);
}
const nM = {
  $style: X1
}, e_ = /* @__PURE__ */ ce(Y1, [["render", tM], ["__cssModules", nM]]), hn = oe({
  emits: ["update:model-value"],
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    scope: {
      type: String,
      required: !0
    },
    properties: {
      type: Object,
      required: !0
    },
    errorScopes: {
      type: Array,
      default: () => []
    },
    locale: {
      type: String,
      required: !0
    },
    readonly: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      path: this.scope.split(".")
    };
  },
  computed: {
    label() {
      var e, n;
      return (n = (e = this.properties) == null ? void 0 : e.label) == null ? void 0 : n[this.locale];
    },
    value() {
      return ke.get(this.modelValue, this.path);
    },
    rules() {
      return this.properties.rules;
    },
    disabled() {
      return this.readonly || this.properties.readonly;
    },
    model: {
      get() {
        return this.value;
      },
      set(e) {
        this.$emit("update:model-value", ke.set(this.modelValue, this.path, e));
      }
    }
  },
  mounted() {
    this.properties.value && (this.model = this.properties.value);
  },
  unmounted() {
    ke.unset(this.modelValue, this.path);
  },
  components: {
    FormLabelComponent: e_,
    FormErrorComponent: uf
  }
}), iM = oe({
  mixins: [hn],
  emits: ["update:model-value"],
  computed: {
    model: {
      get() {
        return this.value || [];
      },
      set(e) {
        const n = Array.isArray(e) && e.length > 0 ? e : [{ key: Date.now(), value: null }];
        this.$emit("update:model-value", ke.set(this.modelValue, this.path, n));
      }
    }
  },
  mounted() {
    Array.isArray(this.properties.value) && this.properties.value.length > 0 && (this.model = this.properties.value), this.model = [{ key: Date.now(), value: null }];
  },
  methods: {
    onAddClick() {
      this.model = this.model.concat({ key: Date.now(), value: null });
    },
    onDeleteClick(e) {
      this.model = this.value.filter((n, t) => t !== e);
    }
  }
}), rM = "_component__input_1bb9s_1", oM = "_component__prepend_1bb9s_8", sM = "_component_1bb9s_1", aM = "_component__item_1bb9s_12", lM = {
  component__input: rM,
  "component__input--append": "_component__input--append_1bb9s_4",
  component__prepend: oM,
  component: sM,
  component__item: aM
};
function uM(e, n, t, a, u, f) {
  const d = D("form-label-component"), m = D("el-button"), g = D("el-input"), y = D("form-error-component"), w = D("el-form-item");
  return V(), X(w, {
    class: J(e.$style.component)
  }, Tt({
    default: k(() => [
      (V(!0), ue(st, null, Et(e.model, (h, b) => (V(), X(w, {
        key: h.key,
        class: J(e.$style.component__item),
        prop: `${e.scope}.${b}.value`,
        rules: e.rules
      }, {
        error: k(({ error: T }) => [
          z(y, {
            error: T[e.locale]
          }, null, 8, ["error"])
        ]),
        default: k(() => {
          var T;
          return [
            z(g, {
              modelValue: h.value,
              "onUpdate:modelValue": (A) => h.value = A,
              class: J([e.$style.component__input, { [e.$style["component__input--append"]]: e.model.length > 1 }]),
              placeholder: (T = e.properties.placeholder) == null ? void 0 : T[e.locale],
              disabled: e.disabled
            }, Tt({
              prepend: k(() => [
                ae("div", {
                  class: J(e.$style.component__prepend)
                }, wt(b + 1), 3)
              ]),
              _: 2
            }, [
              e.model.length > 1 && !e.disabled ? {
                name: "append",
                fn: k(() => [
                  z(m, {
                    class: J(e.$style.component__append),
                    icon: "icon-delete",
                    onClick: (A) => e.onDeleteClick(b)
                  }, null, 8, ["class", "onClick"])
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["modelValue", "onUpdate:modelValue", "class", "placeholder", "disabled"])
          ];
        }),
        _: 2
      }, 1032, ["class", "prop", "rules"]))), 128)),
      e.disabled ? Ze("", !0) : (V(), X(m, {
        key: 0,
        icon: "icon-plus",
        onClick: e.onAddClick
      }, null, 8, ["onClick"]))
    ]),
    _: 2
  }, [
    e.label ? {
      name: "label",
      fn: k(() => [
        z(d, {
          label: e.label,
          rules: e.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["class"]);
}
const cM = {
  $style: lM
}, hM = /* @__PURE__ */ ce(iM, [["render", uM], ["__cssModules", cM]]), fM = oe({
  mixins: [hn],
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(e) {
        this.$emit("update:model-value", ke.set(this.modelValue, this.path, e || null));
      }
    }
  }
});
function dM(e, n, t, a, u, f) {
  const d = D("form-label-component"), m = D("el-checkbox"), g = D("form-error-component"), y = D("el-form-item");
  return V(), X(y, {
    prop: e.scope,
    rules: e.rules
  }, {
    error: k(({ error: w }) => [
      z(g, {
        error: w[e.locale]
      }, null, 8, ["error"])
    ]),
    default: k(() => [
      z(m, {
        modelValue: e.model,
        "onUpdate:modelValue": n[0] || (n[0] = (w) => e.model = w),
        disabled: e.disabled,
        size: "default",
        id: "test"
      }, {
        default: k(() => [
          e.label ? (V(), X(d, {
            key: 0,
            label: e.label,
            rules: e.rules
          }, null, 8, ["label", "rules"])) : Ze("", !0)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ]),
    _: 1
  }, 8, ["prop", "rules"]);
}
const pM = /* @__PURE__ */ ce(fM, [["render", dM]]), mM = "YYYY-MM-DD HH:mm:ss", _M = oe({
  mixins: [hn],
  data() {
    return {
      format: mM
    };
  }
}), gM = {
  "full-width": "_full-width_1852g_1"
};
function vM(e, n, t, a, u, f) {
  const d = D("form-label-component"), m = D("el-date-picker"), g = D("form-error-component"), y = D("el-form-item");
  return V(), X(y, {
    prop: e.scope,
    rules: e.rules
  }, Tt({
    error: k(({ error: w }) => [
      z(g, {
        error: w[e.locale]
      }, null, 8, ["error"])
    ]),
    default: k(() => {
      var w, h, b;
      return [
        z(m, {
          modelValue: e.model,
          "onUpdate:modelValue": n[0] || (n[0] = (T) => e.model = T),
          class: J({ [e.$style["full-width"]]: e.properties.fullWidth }),
          placeholder: (w = e.properties.placeholder) == null ? void 0 : w[e.locale],
          "start-placeholder": (h = e.properties.startPlaceholder) == null ? void 0 : h[e.locale],
          "end-placeholder": (b = e.properties.endPlaceholder) == null ? void 0 : b[e.locale],
          type: e.properties.picker,
          format: e.properties.format,
          "value-format": e.properties.format || e.format,
          disabled: e.disabled
        }, null, 8, ["modelValue", "class", "placeholder", "start-placeholder", "end-placeholder", "type", "format", "value-format", "disabled"])
      ];
    }),
    _: 2
  }, [
    e.label ? {
      name: "label",
      fn: k(() => [
        z(d, {
          label: e.label,
          rules: e.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const yM = {
  $style: gM
}, bM = /* @__PURE__ */ ce(_M, [["render", vM], ["__cssModules", yM]]);
var wM = () => !0, On = class {
  constructor(e, n, t) {
    N(this, "root");
    N(this, "currentNode");
    N(this, "nodeType");
    N(this, "filter");
    this.root = e, this.currentNode = e, this.nodeType = n, this.filter = t || wM;
  }
  isAcceptableNode(e) {
    let n = e.nodeType;
    return !!((n === Node.ELEMENT_NODE ? 1 : n === Node.TEXT_NODE ? 4 : 0) & this.nodeType) && this.filter(e);
  }
  nextNode() {
    let e = this.root, n = this.currentNode, t;
    for (; ; ) {
      for (t = n.firstChild; !t && n && n !== e; )
        t = n.nextSibling, t || (n = n.parentNode);
      if (!t)
        return null;
      if (this.isAcceptableNode(t))
        return this.currentNode = t, t;
      n = t;
    }
  }
  previousNode() {
    let e = this.root, n = this.currentNode, t;
    for (; ; ) {
      if (n === e)
        return null;
      if (t = n.previousSibling, t)
        for (; n = t.lastChild; )
          t = n;
      else
        t = n.parentNode;
      if (!t)
        return null;
      if (this.isAcceptableNode(t))
        return this.currentNode = t, t;
      n = t;
    }
  }
  previousPONode() {
    let e = this.root, n = this.currentNode, t;
    for (; ; ) {
      for (t = n.lastChild; !t && n && n !== e; )
        t = n.previousSibling, t || (n = n.parentNode);
      if (!t)
        return null;
      if (this.isAcceptableNode(t))
        return this.currentNode = t, t;
      n = t;
    }
  }
}, fs = "​", yo = navigator.userAgent, df = /Mac OS X/.test(yo), t_ = /Windows NT/.test(yo), n_ = /iP(?:ad|hone|od)/.test(yo) || df && !!navigator.maxTouchPoints, LM = /Android/.test(yo), SM = /Gecko\//.test(yo), hu = /Edge\//.test(yo), CM = !hu && /WebKit\//.test(yo), yn = df || n_ ? "Meta-" : "Ctrl-", zh = CM, MM = "onbeforeinput" in document && "inputType" in new InputEvent("input"), ji = /[^ \t\r\n]/, TM = /^(?:#text|A(?:BBR|CRONYM)?|B(?:R|D[IO])?|C(?:ITE|ODE)|D(?:ATA|EL|FN)|EM|FONT|HR|I(?:FRAME|MG|NPUT|NS)?|KBD|Q|R(?:P|T|UBY)|S(?:AMP|MALL|PAN|TR(?:IKE|ONG)|U[BP])?|TIME|U|VAR|WBR)$/, EM = /* @__PURE__ */ new Set(["BR", "HR", "IFRAME", "IMG", "INPUT"]), AM = 0, Bh = 1, i_ = 2, r_ = 3, nu = /* @__PURE__ */ new WeakMap(), PM = () => {
  nu = /* @__PURE__ */ new WeakMap();
}, Tr = (e) => EM.has(e.nodeName), pf = (e) => {
  switch (e.nodeType) {
    case 3:
      return Bh;
    case 1:
    case 11:
      if (nu.has(e))
        return nu.get(e);
      break;
    default:
      return AM;
  }
  let n;
  return Array.from(e.childNodes).every(ht) ? TM.test(e.nodeName) ? n = Bh : n = i_ : n = r_, nu.set(e, n), n;
}, ht = (e) => pf(e) === Bh, Sr = (e) => pf(e) === i_, ps = (e) => pf(e) === r_, Ne = (e, n, t) => {
  let a = document.createElement(e);
  if (n instanceof Array && (t = n, n = null), n)
    for (let u in n) {
      let f = n[u];
      f !== void 0 && a.setAttribute(u, f);
    }
  return t && t.forEach((u) => a.appendChild(u)), a;
}, o_ = (e, n) => Tr(e) || e.nodeType !== n.nodeType || e.nodeName !== n.nodeName ? !1 : e instanceof HTMLElement && n instanceof HTMLElement ? e.nodeName !== "A" && e.className === n.className && e.style.cssText === n.style.cssText : !0, Fh = (e, n, t) => {
  if (e.nodeName !== n)
    return !1;
  for (let a in t)
    if (!("getAttribute" in e) || e.getAttribute(a) !== t[a])
      return !1;
  return !0;
}, pt = (e, n, t, a) => {
  for (; e && e !== n; ) {
    if (Fh(e, t, a))
      return e;
    e = e.parentNode;
  }
  return null;
}, mf = (e, n) => {
  let t = e.childNodes;
  for (; n && e instanceof Element; )
    e = t[n - 1], t = e.childNodes, n = t.length;
  return e;
}, s_ = (e, n) => {
  let t = e;
  if (t instanceof Element) {
    let a = t.childNodes;
    if (n < a.length)
      t = a[n];
    else {
      for (; t && !t.nextSibling; )
        t = t.parentNode;
      t && (t = t.nextSibling);
    }
  }
  return t;
}, ti = (e) => e instanceof Element || e instanceof DocumentFragment ? e.childNodes.length : e instanceof CharacterData ? e.length : 0, Mt = (e) => {
  let n = document.createDocumentFragment(), t = e.firstChild;
  for (; t; )
    n.appendChild(t), t = e.firstChild;
  return n;
}, Vt = (e) => {
  let n = e.parentNode;
  return n && n.removeChild(e), e;
}, un = (e, n) => {
  let t = e.parentNode;
  t && t.replaceChild(n, e);
}, xM = (e) => e instanceof Element ? e.nodeName === "BR" : ji.test(e.data), Eu = (e, n) => {
  let t = e.parentNode;
  for (; ht(t); )
    t = t.parentNode;
  let a = new On(t, 5, xM);
  return a.currentNode = e, !!a.nextNode() || n && !a.previousNode();
}, mh = (e, n) => {
  let t = new On(e, 4), a, u;
  for (; a = t.nextNode(); )
    for (; (u = a.data.indexOf(fs)) > -1 && (!n || a.parentNode !== n); )
      if (a.length === 1) {
        let f = a, d = f.parentNode;
        for (; d && (d.removeChild(f), t.currentNode = d, !(!ht(d) || ti(d))); )
          f = d, d = f.parentNode;
        break;
      } else
        a.deleteData(u, 1);
}, OM = 0, NM = 1, IM = 2, kM = 3, wr = (e, n, t) => {
  let a = document.createRange();
  if (a.selectNode(n), t) {
    let u = e.compareBoundaryPoints(kM, a) > -1, f = e.compareBoundaryPoints(NM, a) < 1;
    return !u && !f;
  } else {
    let u = e.compareBoundaryPoints(OM, a) < 1, f = e.compareBoundaryPoints(IM, a) > -1;
    return u && f;
  }
}, Qt = (e) => {
  let { startContainer: n, startOffset: t, endContainer: a, endOffset: u } = e;
  for (; !(n instanceof Text); ) {
    let f = n.childNodes[t];
    if (!f || Tr(f)) {
      if (t && (f = n.childNodes[t - 1], f instanceof Text)) {
        let d = f, m;
        for (; !d.length && (m = d.previousSibling) && m instanceof Text; )
          d.remove(), d = m;
        n = d, t = d.data.length;
      }
      break;
    }
    n = f, t = 0;
  }
  if (u)
    for (; !(a instanceof Text); ) {
      let f = a.childNodes[u - 1];
      if (!f || Tr(f)) {
        if (f && f.nodeName === "BR" && !Eu(f, !1)) {
          u -= 1;
          continue;
        }
        break;
      }
      a = f, u = ti(a);
    }
  else
    for (; !(a instanceof Text); ) {
      let f = a.firstChild;
      if (!f || Tr(f))
        break;
      a = f;
    }
  e.setStart(n, t), e.setEnd(a, u);
}, Pr = (e, n, t, a) => {
  let u = e.startContainer, f = e.startOffset, d = e.endContainer, m = e.endOffset, g;
  for (n || (n = e.commonAncestorContainer), t || (t = n); !f && u !== n && u !== a; )
    g = u.parentNode, f = Array.from(g.childNodes).indexOf(u), u = g;
  for (; !(d === t || d === a || (d.nodeType !== 3 && d.childNodes[m] && d.childNodes[m].nodeName === "BR" && !Eu(d.childNodes[m], !1) && (m += 1), m !== ti(d))); )
    g = d.parentNode, m = Array.from(g.childNodes).indexOf(d) + 1, d = g;
  e.setStart(u, f), e.setEnd(d, m);
}, Mp = (e, n, t) => {
  let a = pt(e.endContainer, t, n);
  if (a && (a = a.parentNode)) {
    let u = e.cloneRange();
    Pr(u, a, a, t), u.endContainer === a && (e.setStart(u.endContainer, u.endOffset), e.setEnd(u.endContainer, u.endOffset));
  }
  return e;
}, zt = (e) => {
  let n = null;
  if (e instanceof Text)
    return e;
  if (ht(e)) {
    let t = e.firstChild;
    if (zh)
      for (; t && t instanceof Text && !t.data; )
        e.removeChild(t), t = e.firstChild;
    t || (zh ? n = document.createTextNode(fs) : n = document.createTextNode(""));
  } else if (e instanceof Element && !e.querySelector("BR")) {
    n = Ne("BR");
    let t = e, a;
    for (; (a = t.lastElementChild) && !ht(a); )
      t = a;
  }
  if (n)
    try {
      e.appendChild(n);
    } catch {
    }
  return e;
}, bi = (e, n) => {
  let t = null;
  return Array.from(e.childNodes).forEach((a) => {
    let u = a.nodeName === "BR";
    !u && ht(a) ? (t || (t = Ne("DIV")), t.appendChild(a)) : (u || t) && (t || (t = Ne("DIV")), zt(t), u ? e.replaceChild(t, a) : e.insertBefore(t, a), t = null), ps(a) && bi(a);
  }), t && e.appendChild(zt(t)), e;
}, Hn = (e, n, t, a) => {
  if (e instanceof Text && e !== t) {
    if (typeof n != "number")
      throw new Error("Offset must be a number to split text node!");
    if (!e.parentNode)
      throw new Error("Cannot split text node with no parent!");
    return Hn(e.parentNode, e.splitText(n), t, a);
  }
  let u = typeof n == "number" ? n < e.childNodes.length ? e.childNodes[n] : null : n, f = e.parentNode;
  if (!f || e === t || !(e instanceof Element))
    return u;
  let d = e.cloneNode(!1);
  for (; u; ) {
    let m = u.nextSibling;
    d.appendChild(u), u = m;
  }
  return e instanceof HTMLOListElement && pt(e, a, "BLOCKQUOTE") && (d.start = (+e.start || 1) + e.childNodes.length - 1), zt(e), zt(d), f.insertBefore(d, e.nextSibling), Hn(f, d, t, a);
}, a_ = (e, n) => {
  let t = e.childNodes, a = t.length, u = [];
  for (; a--; ) {
    let f = t[a], d = a ? t[a - 1] : null;
    if (d && ht(f) && o_(f, d))
      n.startContainer === f && (n.startContainer = d, n.startOffset += ti(d)), n.endContainer === f && (n.endContainer = d, n.endOffset += ti(d)), n.startContainer === e && (n.startOffset > a ? n.startOffset -= 1 : n.startOffset === a && (n.startContainer = d, n.startOffset = ti(d))), n.endContainer === e && (n.endOffset > a ? n.endOffset -= 1 : n.endOffset === a && (n.endContainer = d, n.endOffset = ti(d))), Vt(f), f instanceof Text ? d.appendData(f.data) : u.push(Mt(f));
    else if (f instanceof Element) {
      let m;
      for (; m = u.pop(); )
        f.appendChild(m);
      a_(f, n);
    }
  }
}, ls = (e, n) => {
  let t = e instanceof Text ? e.parentNode : e;
  if (t instanceof Element) {
    let a = { startContainer: n.startContainer, startOffset: n.startOffset, endContainer: n.endContainer, endOffset: n.endOffset };
    a_(t, a), n.setStart(a.startContainer, a.startOffset), n.setEnd(a.endContainer, a.endOffset);
  }
}, Ia = (e, n, t, a) => {
  let u = n, f, d;
  for (; (f = u.parentNode) && f !== a && f instanceof Element && f.childNodes.length === 1; )
    u = f;
  Vt(u), d = e.childNodes.length;
  let m = e.lastChild;
  m && m.nodeName === "BR" && (e.removeChild(m), d -= 1), e.appendChild(Mt(n)), t.setStart(e, d), t.collapse(!0), ls(e, t);
}, Zi = (e, n) => {
  let t = e.previousSibling, a = e.firstChild, u = e.nodeName === "LI";
  if (!(u && (!a || !/^[OU]L$/.test(a.nodeName)))) {
    if (t && o_(t, e)) {
      if (!ps(t))
        if (u) {
          let d = Ne("DIV");
          d.appendChild(Mt(t)), t.appendChild(d);
        } else
          return;
      Vt(e);
      let f = !ps(e);
      t.appendChild(Mt(e)), f && bi(t), a && Zi(a);
    } else if (u) {
      let f = Ne("DIV");
      e.insertBefore(f, a), zt(f);
    }
  }
}, Tp = { "font-weight": { regexp: /^bold|^700/i, replace() {
  return Ne("B");
} }, "font-style": { regexp: /^italic/i, replace() {
  return Ne("I");
} }, "font-family": { regexp: ji, replace(e, n) {
  return Ne("SPAN", { class: e.fontFamily, style: "font-family:" + n });
} }, "font-size": { regexp: ji, replace(e, n) {
  return Ne("SPAN", { class: e.fontSize, style: "font-size:" + n });
} }, "text-decoration": { regexp: /^underline/i, replace() {
  return Ne("U");
} } }, DM = (e, n, t) => {
  let a = e.style, u, f;
  for (let d in Tp) {
    let m = Tp[d], g = a.getPropertyValue(d);
    if (g && m.regexp.test(g)) {
      let y = m.replace(t.classNames, g);
      if (y.nodeName === e.nodeName && y.className === e.className)
        continue;
      f || (f = y), u && u.appendChild(y), u = y, e.style.removeProperty(d);
    }
  }
  return f && u && (u.appendChild(Mt(e)), e.style.cssText ? e.appendChild(f) : un(e, f)), u || e;
}, Gl = (e) => (n, t) => {
  let a = Ne(e), u = n.attributes;
  for (let f = 0, d = u.length; f < d; f += 1) {
    let m = u[f];
    a.setAttribute(m.name, m.value);
  }
  return t.replaceChild(a, n), a.appendChild(Mt(n)), a;
}, $M = { 1: "10", 2: "13", 3: "16", 4: "18", 5: "24", 6: "32", 7: "48" }, RM = { STRONG: Gl("B"), EM: Gl("I"), INS: Gl("U"), STRIKE: Gl("S"), SPAN: DM, FONT: (e, n, t) => {
  let a = e, u = a.face, f = a.size, d = a.color, m = t.classNames, g, y, w, h, b;
  return u && (g = Ne("SPAN", { class: m.fontFamily, style: "font-family:" + u }), b = g, h = g), f && (y = Ne("SPAN", { class: m.fontSize, style: "font-size:" + $M[f] + "px" }), b || (b = y), h && h.appendChild(y), h = y), d && /^#?([\dA-F]{3}){1,2}$/i.test(d) && (d.charAt(0) !== "#" && (d = "#" + d), w = Ne("SPAN", { class: m.color, style: "color:" + d }), b || (b = w), h && h.appendChild(w), h = w), (!b || !h) && (b = h = Ne("SPAN")), n.replaceChild(b, a), h.appendChild(Mt(a)), h;
}, TT: (e, n, t) => {
  let a = Ne("SPAN", { class: t.classNames.fontFamily, style: 'font-family:menlo,consolas,"courier new",monospace' });
  return n.replaceChild(a, e), a.appendChild(Mt(e)), a;
} }, zM = /^(?:A(?:DDRESS|RTICLE|SIDE|UDIO)|BLOCKQUOTE|CAPTION|D(?:[DLT]|IV)|F(?:IGURE|IGCAPTION|OOTER)|H[1-6]|HEADER|L(?:ABEL|EGEND|I)|O(?:L|UTPUT)|P(?:RE)?|SECTION|T(?:ABLE|BODY|D|FOOT|H|HEAD|R)|COL(?:GROUP)?|UL)$/, BM = /^(?:HEAD|META|STYLE)/, Uh = (e, n, t) => {
  let a = e.childNodes, u = e;
  for (; ht(u); )
    u = u.parentNode;
  let f = new On(u, 5);
  for (let d = 0, m = a.length; d < m; d += 1) {
    let g = a[d], y = g.nodeName, w = RM[y];
    if (g instanceof HTMLElement) {
      let h = g.childNodes.length;
      if (w)
        g = w(g, e, n);
      else if (BM.test(y)) {
        e.removeChild(g), d -= 1, m -= 1;
        continue;
      } else if (!zM.test(y) && !ht(g)) {
        d -= 1, m += h - 1, e.replaceChild(Mt(g), g);
        continue;
      }
      h && Uh(g, n, t || y === "PRE");
    } else {
      if (g instanceof Text) {
        let h = g.data, b = !ji.test(h.charAt(0)), T = !ji.test(h.charAt(h.length - 1));
        if (t || !b && !T)
          continue;
        if (b) {
          f.currentNode = g;
          let A;
          for (; (A = f.previousPONode()) && !(A.nodeName === "IMG" || A instanceof Text && ji.test(A.data)); )
            if (!ht(A)) {
              A = null;
              break;
            }
          h = h.replace(/^[ \t\r\n]+/g, A ? " " : "");
        }
        if (T) {
          f.currentNode = g;
          let A;
          for (; (A = f.nextNode()) && !(A.nodeName === "IMG" || A instanceof Text && ji.test(A.data)); )
            if (!ht(A)) {
              A = null;
              break;
            }
          h = h.replace(/[ \t\r\n]+$/g, A ? " " : "");
        }
        if (h) {
          g.data = h;
          continue;
        }
      }
      e.removeChild(g), d -= 1, m -= 1;
    }
  }
  return e;
}, Vh = (e) => {
  let n = e.childNodes, t = n.length;
  for (; t--; ) {
    let a = n[t];
    a instanceof Element && !Tr(a) ? (Vh(a), ht(a) && !a.firstChild && e.removeChild(a)) : a instanceof Text && !a.data && e.removeChild(a);
  }
}, fu = (e, n, t) => {
  let a = e.querySelectorAll("BR"), u = [], f = a.length;
  for (let d = 0; d < f; d += 1)
    u[d] = Eu(a[d], t);
  for (; f--; ) {
    let d = a[f], m = d.parentNode;
    m && (u[f] ? ht(m) || bi(m) : Vt(d));
  }
}, Ep = (e) => e.split("&").join("&amp;").split("<").join("&lt;").split(">").join("&gt;").split('"').join("&quot;"), du = (e, n) => {
  let t = new On(n, 1, Sr);
  return t.currentNode = e, t;
}, ms = (e, n) => {
  let t = du(e, n).previousNode();
  return t !== n ? t : null;
}, Cr = (e, n) => {
  let t = du(e, n).nextNode();
  return t !== n ? t : null;
}, Hh = (e) => !e.textContent && !e.querySelector("IMG"), ni = (e, n) => {
  let t = e.startContainer, a;
  if (ht(t))
    a = ms(t, n);
  else if (t !== n && t instanceof HTMLElement && Sr(t))
    a = t;
  else {
    let u = mf(t, e.startOffset);
    a = Cr(u, n);
  }
  return a && wr(e, a, !0) ? a : null;
}, go = (e, n) => {
  let t = e.endContainer, a;
  if (ht(t))
    a = ms(t, n);
  else if (t !== n && t instanceof HTMLElement && Sr(t))
    a = t;
  else {
    let u = s_(t, e.endOffset);
    if (!u || !n.contains(u)) {
      u = n;
      let f;
      for (; f = u.lastChild; )
        u = f;
    }
    a = ms(u, n);
  }
  return a && wr(e, a, !0) ? a : null;
}, l_ = (e) => e instanceof Text ? ji.test(e.data) : e.nodeName === "IMG", $a = (e, n) => {
  let t = e.startContainer, a = e.startOffset, u;
  if (t instanceof Text) {
    if (a)
      return !1;
    u = t;
  } else if (u = s_(t, a), u && !n.contains(u) && (u = null), !u && (u = mf(t, a), u instanceof Text && u.length))
    return !1;
  let f = ni(e, n);
  if (!f)
    return !1;
  let d = new On(f, 5, l_);
  return d.currentNode = u, !d.previousNode();
}, Au = (e, n) => {
  let t = e.endContainer, a = e.endOffset, u;
  if (t instanceof Text) {
    let m = t.data.length;
    if (m && a < m)
      return !1;
    u = t;
  } else
    u = mf(t, a);
  let f = go(e, n);
  if (!f)
    return !1;
  let d = new On(f, 5, l_);
  return d.currentNode = u, !d.nextNode();
}, Ap = (e, n) => {
  let t = ni(e, n), a = go(e, n), u;
  t && a && (u = t.parentNode, e.setStart(u, Array.from(u.childNodes).indexOf(t)), u = a.parentNode, e.setEnd(u, Array.from(u.childNodes).indexOf(a) + 1));
};
function co(e, n, t, a) {
  let u = document.createRange();
  return u.setStart(e, n), t && typeof a == "number" ? u.setEnd(t, a) : u.setEnd(e, n), u;
}
var Vi = (e, n) => {
  let { startContainer: t, startOffset: a, endContainer: u, endOffset: f } = e, d;
  if (t instanceof Text) {
    let g = t.parentNode;
    if (d = g.childNodes, a === t.length)
      a = Array.from(d).indexOf(t) + 1, e.collapsed && (u = g, f = a);
    else {
      if (a) {
        let y = t.splitText(a);
        u === t ? (f -= a, u = y) : u === g && (f += 1), t = y;
      }
      a = Array.from(d).indexOf(t);
    }
    t = g;
  } else
    d = t.childNodes;
  let m = d.length;
  a === m ? t.appendChild(n) : t.insertBefore(n, d[a]), t === u && (f += d.length - m), e.setStart(t, a), e.setEnd(u, f);
}, u_ = (e, n, t) => {
  let a = document.createDocumentFragment();
  if (e.collapsed)
    return a;
  n || (n = e.commonAncestorContainer), n instanceof Text && (n = n.parentNode);
  let u = e.startContainer, f = e.startOffset, d = Hn(e.endContainer, e.endOffset, n, t), m = 0, g = Hn(u, f, n, t);
  for (; g && g !== d; ) {
    let y = g.nextSibling;
    a.appendChild(g), g = y;
  }
  return u instanceof Text && d instanceof Text && (u.appendData(d.data), Vt(d), d = u, m = f), e.setStart(u, f), d ? e.setEnd(d, m) : e.setEnd(n, n.childNodes.length), zt(n), a;
}, Pp = (e, n, t) => {
  e.currentNode = t;
  let a;
  for (; a = e[n](); ) {
    if (a instanceof Text || Tr(a))
      return a;
    if (!ht(a))
      return null;
  }
  return null;
}, bo = (e, n) => {
  let t = ni(e, n), a = go(e, n), u = t !== a;
  t && a && (Qt(e), Pr(e, t, a, n));
  let f = u_(e, null, n);
  Qt(e), u && (a = go(e, n), t && a && t !== a && Ia(t, a, e, n)), t && zt(t);
  let d = n.firstChild;
  (!d || d.nodeName === "BR") && (zt(n), n.firstChild && e.selectNodeContents(n.firstChild)), e.collapse(!0);
  let m = e.startContainer, g = e.startOffset, y = new On(n, 5), w = m, h = g;
  (!(w instanceof Text) || h === w.data.length) && (w = Pp(y, "nextNode", w), h = 0);
  let b = m, T = g - 1;
  (!(b instanceof Text) || T === -1) && (b = Pp(y, "previousPONode", w || (m instanceof Text ? m : m.childNodes[g] || m)), b instanceof Text && (T = b.data.length));
  let A = null, x = 0;
  return w instanceof Text && w.data.charAt(h) === " " && $a(e, n) ? (A = w, x = h) : b instanceof Text && b.data.charAt(T) === " " && (w instanceof Text && w.data.charAt(h) === " " || Au(e, n)) && (A = b, x = T), A && A.replaceData(x, 1, " "), e.setStart(m, g), e.collapse(!0), f;
}, FM = (e, n, t) => {
  let a = n.firstChild && ht(n.firstChild), u;
  for (bi(n), u = n; u = Cr(u, t); )
    zt(u);
  e.collapsed || bo(e, t), Qt(e), e.collapse(!1);
  let f = pt(e.endContainer, t, "BLOCKQUOTE") || t, d = ni(e, t), m = null, g = Cr(n, n), y = !a && !!d && Hh(d);
  if (d && g && !y && !pt(g, n, "PRE") && !pt(g, n, "TABLE")) {
    Pr(e, d, d, t), e.collapse(!0);
    let w = e.endContainer, h = e.endOffset;
    if (fu(d, t, !1), ht(w)) {
      let b = Hn(w, h, ms(w, t) || t, t);
      w = b.parentNode, h = Array.from(w.childNodes).indexOf(b);
    }
    if (h !== ti(w))
      for (m = document.createDocumentFragment(); u = w.childNodes[h]; )
        m.appendChild(u);
    Ia(w, g, e, t), h = Array.from(w.parentNode.childNodes).indexOf(w) + 1, w = w.parentNode, e.setEnd(w, h);
  }
  if (ti(n)) {
    y && d && (e.setEndBefore(d), e.collapse(!1), Vt(d)), Pr(e, f, f, t);
    let w = Hn(e.endContainer, e.endOffset, f, t), h = w ? w.previousSibling : f.lastChild;
    f.insertBefore(n, w), w ? e.setEndBefore(w) : e.setEnd(f, ti(f)), d = go(e, t), Qt(e);
    let b = e.endContainer, T = e.endOffset;
    w && ps(w) && Zi(w), w = h && h.nextSibling, w && ps(w) && Zi(w), e.setEnd(b, T);
  }
  if (m && d) {
    let w = e.cloneRange();
    Ia(d, m, w, t), e.setEnd(w.endContainer, w.endOffset);
  }
  Qt(e);
}, _h = Array.prototype.indexOf, UM = (e, n, t, a, u, f) => {
  let d = e.clipboardData, m = document.body, g = Ne("DIV"), y, w;
  n.childNodes.length === 1 && n.childNodes[0] instanceof Text ? (w = n.childNodes[0].data.replace(/ /g, " "), f = !0) : (g.appendChild(n), y = g.innerHTML, a && (y = a(y))), w !== void 0 || (u && y !== void 0 ? w = u(y) : (fu(g, t, !0), g.setAttribute("style", "position:fixed;overflow:hidden;bottom:100%;right:100%;"), m.appendChild(g), w = g.innerText || g.textContent, w = w.replace(/ /g, " "), m.removeChild(g))), t_ && (w = w.replace(/\r?\n/g, `\r
`)), !f && y && w !== y && d.setData("text/html", y), d.setData("text/plain", w), e.preventDefault();
}, c_ = (e, n, t, a, u, f, d) => {
  if (!hu && e.clipboardData) {
    let m = ni(n, t), g = go(n, t), y = t;
    m === g && (m != null && m.contains(n.commonAncestorContainer)) && (y = m);
    let w;
    a ? w = bo(n, t) : (n = n.cloneRange(), Qt(n), Pr(n, y, y, t), w = n.cloneContents());
    let h = n.commonAncestorContainer;
    for (h instanceof Text && (h = h.parentNode); h && h !== y; ) {
      let b = h.cloneNode(!1);
      b.appendChild(w), w = b, h = h.parentNode;
    }
    return UM(e, w, t, u, f, d), !0;
  }
  return !1;
}, VM = function(e) {
  let n = this.getSelection(), t = this._root;
  if (n.collapsed) {
    e.preventDefault();
    return;
  }
  this.saveUndoState(n), c_(e, n, t, !0, this._config.willCutCopy, null, !1) || setTimeout(() => {
    try {
      this._ensureBottomLine();
    } catch (a) {
      this._config.didError(a);
    }
  }, 0), this.setSelection(n);
}, HM = function(e) {
  c_(e, this.getSelection(), this._root, !1, this._config.willCutCopy, null, !1);
}, xp = function(e) {
  this._isShiftDown = e.shiftKey;
}, jM = function(e) {
  let n = e.clipboardData, t = n == null ? void 0 : n.items, a = this._isShiftDown, u = !1, f = !1, d = null, m = null;
  if (t) {
    let Z = t.length;
    for (; Z--; ) {
      let H = t[Z], Y = H.type;
      Y === "text/html" ? m = H : Y === "text/plain" || Y === "text/uri-list" ? d = H : Y === "text/rtf" ? u = !0 : /^image\/.*/.test(Y) && (f = !0);
    }
    if (f && !(u && m)) {
      e.preventDefault(), this.fireEvent("pasteImage", { clipboardData: n });
      return;
    }
    if (!hu) {
      e.preventDefault(), m && (!a || !d) ? m.getAsString((H) => {
        this.insertHTML(H, !0);
      }) : d && d.getAsString((H) => {
        let Y = !1, ee = this.getSelection();
        if (!ee.collapsed && ji.test(ee.toString())) {
          let re = this.linkRegExp.exec(H);
          Y = !!re && re[0].length === H.length;
        }
        Y ? this.makeLink(H) : this.insertPlainText(H, !0);
      });
      return;
    }
  }
  let g = n == null ? void 0 : n.types;
  if (!hu && g && (_h.call(g, "text/html") > -1 || !SM && _h.call(g, "text/plain") > -1 && _h.call(g, "text/rtf") < 0)) {
    e.preventDefault();
    let Z;
    !a && (Z = n.getData("text/html")) ? this.insertHTML(Z, !0) : ((Z = n.getData("text/plain")) || (Z = n.getData("text/uri-list"))) && this.insertPlainText(Z, !0);
    return;
  }
  let y = document.body, w = this.getSelection(), h = w.startContainer, b = w.startOffset, T = w.endContainer, A = w.endOffset, x = Ne("DIV", { contenteditable: "true", style: "position:fixed; overflow:hidden; top:0; right:100%; width:1px; height:1px;" });
  y.appendChild(x), w.selectNodeContents(x), this.setSelection(w), setTimeout(() => {
    try {
      let Z = "", H = x, Y;
      for (; x = H; )
        H = x.nextSibling, Vt(x), Y = x.firstChild, Y && Y === x.lastChild && Y instanceof HTMLDivElement && (x = Y), Z += x.innerHTML;
      this.setSelection(co(h, b, T, A)), Z && this.insertHTML(Z, !0);
    } catch (Z) {
      this._config.didError(Z);
    }
  }, 0);
}, ZM = function(e) {
  if (!e.dataTransfer)
    return;
  let n = e.dataTransfer.types, t = n.length, a = !1, u = !1;
  for (; t--; )
    switch (n[t]) {
      case "text/plain":
        a = !0;
        break;
      case "text/html":
        u = !0;
        break;
      default:
        return;
    }
  (u || a && this.saveUndoState) && this.saveUndoState();
}, Op = (e, n, t) => {
  n.preventDefault(), e.splitBlock(n.shiftKey, t);
}, Aa = (e, n) => {
  try {
    n || (n = e.getSelection());
    let t = n.startContainer;
    t instanceof Text && (t = t.parentNode);
    let a = t;
    for (; ht(a) && (!a.textContent || a.textContent === fs); )
      t = a, a = t.parentNode;
    t !== a && (n.setStart(a, Array.from(a.childNodes).indexOf(t)), n.collapse(!0), a.removeChild(t), Sr(a) || (a = ms(a, e._root) || e._root), zt(a), Qt(n)), t === e._root && (t = t.firstChild) && t.nodeName === "BR" && Vt(t), e._ensureBottomLine(), e.setSelection(n), e._updatePath(n, !0);
  } catch (t) {
    e._config.didError(t);
  }
}, h_ = (e, n) => {
  let t;
  for (; (t = e.parentNode) && !(t === n || t.isContentEditable); )
    e = t;
  Vt(e);
}, f_ = (e, n, t) => {
  if (pt(n, e._root, "A"))
    return;
  let a = n.data || "", u = Math.max(a.lastIndexOf(" ", t - 1), a.lastIndexOf(" ", t - 1)) + 1, f = a.slice(u, t), d = e.linkRegExp.exec(f);
  if (d) {
    let m = e.getSelection();
    e._docWasChanged(), e._recordUndoState(m), e._getRangeAndRemoveBookmark(m);
    let g = u + d.index, y = g + d[0].length, w = m.startContainer === n, h = m.startOffset - y;
    g && (n = n.splitText(g));
    let b = e._config.tagAttributes.a, T = Ne("A", Object.assign({ href: d[1] ? /^(?:ht|f)tps?:/i.test(d[1]) ? d[1] : "http://" + d[1] : "mailto:" + d[0] }, b));
    T.textContent = a.slice(g, y), n.parentNode.insertBefore(T, n), n.data = a.slice(y), w && (m.setStart(n, h), m.setEnd(n, h)), e.setSelection(m);
  }
}, WM = (e, n, t) => {
  let a = e._root;
  if (e._removeZWS(), e.saveUndoState(t), !t.collapsed)
    n.preventDefault(), bo(t, a), Aa(e, t);
  else if ($a(t, a)) {
    n.preventDefault();
    let u = ni(t, a);
    if (!u)
      return;
    let f = u;
    bi(f.parentNode);
    let d = ms(f, a);
    if (d) {
      if (!d.isContentEditable) {
        h_(d, a);
        return;
      }
      for (Ia(d, f, t, a), f = d.parentNode; f !== a && !f.nextSibling; )
        f = f.parentNode;
      f !== a && (f = f.nextSibling) && Zi(f), e.setSelection(t);
    } else if (f) {
      if (pt(f, a, "UL") || pt(f, a, "OL")) {
        e.decreaseListLevel(t);
        return;
      } else if (pt(f, a, "BLOCKQUOTE")) {
        e.removeQuote(t);
        return;
      }
      e.setSelection(t), e._updatePath(t, !0);
    }
  } else {
    Qt(t);
    let u = t.startContainer, f = t.startOffset, d = u.parentNode;
    u instanceof Text && d instanceof HTMLAnchorElement && f && d.href.includes(u.data) ? (u.deleteData(f - 1, 1), e.setSelection(t), e.removeLink(), n.preventDefault()) : (e.setSelection(t), setTimeout(() => {
      Aa(e);
    }, 0));
  }
}, GM = (e, n, t) => {
  let a = e._root, u, f, d, m, g, y;
  if (e._removeZWS(), e.saveUndoState(t), !t.collapsed)
    n.preventDefault(), bo(t, a), Aa(e, t);
  else if (Au(t, a)) {
    if (n.preventDefault(), u = ni(t, a), !u)
      return;
    if (bi(u.parentNode), f = Cr(u, a), f) {
      if (!f.isContentEditable) {
        h_(f, a);
        return;
      }
      for (Ia(u, f, t, a), f = u.parentNode; f !== a && !f.nextSibling; )
        f = f.parentNode;
      f !== a && (f = f.nextSibling) && Zi(f), e.setSelection(t), e._updatePath(t, !0);
    }
  } else {
    if (d = t.cloneRange(), Pr(t, a, a, a), m = t.endContainer, g = t.endOffset, m instanceof Element && (y = m.childNodes[g], y && y.nodeName === "IMG")) {
      n.preventDefault(), Vt(y), Qt(t), Aa(e, t);
      return;
    }
    e.setSelection(d), setTimeout(() => {
      Aa(e);
    }, 0);
  }
}, qM = (e, n, t) => {
  let a = e._root;
  if (e._removeZWS(), t.collapsed && $a(t, a)) {
    let u = ni(t, a), f;
    for (; f = u.parentNode; ) {
      if (f.nodeName === "UL" || f.nodeName === "OL") {
        n.preventDefault(), e.increaseListLevel(t);
        break;
      }
      u = f;
    }
  }
}, KM = (e, n, t) => {
  let a = e._root;
  if (e._removeZWS(), t.collapsed && $a(t, a)) {
    let u = t.startContainer;
    (pt(u, a, "UL") || pt(u, a, "OL")) && (n.preventDefault(), e.decreaseListLevel(t));
  }
}, YM = (e, n, t) => {
  let a, u = e._root;
  if (e._recordUndoState(t), e._getRangeAndRemoveBookmark(t), t.collapsed || (bo(t, u), e._ensureBottomLine(), e.setSelection(t), e._updatePath(t, !0)), a = t.endContainer, t.endOffset === ti(a))
    do
      if (a.nodeName === "A") {
        t.setStartAfter(a);
        break;
      }
    while (!a.nextSibling && (a = a.parentNode) && a !== u);
  if (e._config.addLinks) {
    let f = t.cloneRange();
    Qt(f);
    let d = f.startContainer, m = f.startOffset;
    setTimeout(() => {
      f_(e, d, m);
    }, 0);
  }
  e.setSelection(t);
}, QM = { 8: "Backspace", 9: "Tab", 13: "Enter", 27: "Escape", 32: "Space", 33: "PageUp", 34: "PageDown", 37: "ArrowLeft", 38: "ArrowUp", 39: "ArrowRight", 40: "ArrowDown", 46: "Delete", 191: "/", 219: "[", 220: "\\", 221: "]" }, JM = function(e) {
  let n = e.keyCode, t = QM[n], a = "", u = this.getSelection();
  e.defaultPrevented || (t || (t = String.fromCharCode(n).toLowerCase(), /^[A-Za-z0-9]$/.test(t) || (t = "")), 111 < n && n < 124 && (t = "F" + (n - 111)), t !== "Backspace" && t !== "Delete" && (e.altKey && (a += "Alt-"), e.ctrlKey && (a += "Ctrl-"), e.metaKey && (a += "Meta-"), e.shiftKey && (a += "Shift-")), t_ && e.shiftKey && t === "Delete" && (a += "Shift-"), t = a + t, this._keyHandlers[t] ? this._keyHandlers[t](this, e, u) : !u.collapsed && !e.isComposing && !e.ctrlKey && !e.metaKey && (e.key || t).length === 1 && (this.saveUndoState(u), bo(u, this._root), this._ensureBottomLine(), this.setSelection(u), this._updatePath(u, !0)));
}, Nt = { Backspace: WM, Delete: GM, Tab: qM, "Shift-Tab": KM, Space: YM, ArrowLeft(e) {
  e._removeZWS();
}, ArrowRight(e, n, t) {
  e._removeZWS();
  let a = e.getRoot();
  if (Au(t, a)) {
    Qt(t);
    let u = t.endContainer;
    do
      if (u.nodeName === "CODE") {
        let f = u.nextSibling;
        if (!(f instanceof Text)) {
          let d = document.createTextNode(" ");
          u.parentNode.insertBefore(d, f), f = d;
        }
        t.setStart(f, 1), e.setSelection(t), n.preventDefault();
        break;
      }
    while (!u.nextSibling && (u = u.parentNode) && u !== a);
  }
} };
MM || (Nt.Enter = Op, Nt["Shift-Enter"] = Op);
!df && !n_ && (Nt.PageUp = (e) => {
  e.moveCursorToStart();
}, Nt.PageDown = (e) => {
  e.moveCursorToEnd();
});
var Ms = (e, n) => (n = n || null, (t, a) => {
  a.preventDefault();
  let u = t.getSelection();
  t.hasFormat(e, null, u) ? t.changeFormat(null, { tag: e }, u) : t.changeFormat({ tag: e }, n, u);
});
Nt[yn + "b"] = Ms("B");
Nt[yn + "i"] = Ms("I");
Nt[yn + "u"] = Ms("U");
Nt[yn + "Shift-7"] = Ms("S");
Nt[yn + "Shift-5"] = Ms("SUB", { tag: "SUP" });
Nt[yn + "Shift-6"] = Ms("SUP", { tag: "SUB" });
Nt[yn + "Shift-8"] = (e, n) => {
  n.preventDefault();
  let t = e.getPath();
  /(?:^|>)UL/.test(t) ? e.removeList() : e.makeUnorderedList();
};
Nt[yn + "Shift-9"] = (e, n) => {
  n.preventDefault();
  let t = e.getPath();
  /(?:^|>)OL/.test(t) ? e.removeList() : e.makeOrderedList();
};
Nt[yn + "["] = (e, n) => {
  n.preventDefault();
  let t = e.getPath();
  /(?:^|>)BLOCKQUOTE/.test(t) || !/(?:^|>)[OU]L/.test(t) ? e.decreaseQuoteLevel() : e.decreaseListLevel();
};
Nt[yn + "]"] = (e, n) => {
  n.preventDefault();
  let t = e.getPath();
  /(?:^|>)BLOCKQUOTE/.test(t) || !/(?:^|>)[OU]L/.test(t) ? e.increaseQuoteLevel() : e.increaseListLevel();
};
Nt[yn + "d"] = (e, n) => {
  n.preventDefault(), e.toggleCode();
};
Nt[yn + "z"] = (e, n) => {
  n.preventDefault(), e.undo();
};
Nt[yn + "y"] = Nt[yn + "Shift-z"] = (e, n) => {
  n.preventDefault(), e.redo();
};
var XM = class {
  constructor(e, n) {
    N(this, "_root");
    N(this, "_config");
    N(this, "_isFocused");
    N(this, "_lastSelection");
    N(this, "_willRestoreSelection");
    N(this, "_mayHaveZWS");
    N(this, "_lastAnchorNode");
    N(this, "_lastFocusNode");
    N(this, "_path");
    N(this, "_events");
    N(this, "_undoIndex");
    N(this, "_undoStack");
    N(this, "_undoStackLength");
    N(this, "_isInUndoState");
    N(this, "_ignoreChange");
    N(this, "_ignoreAllChanges");
    N(this, "_isShiftDown");
    N(this, "_keyHandlers");
    N(this, "_mutation");
    N(this, "customEvents", /* @__PURE__ */ new Set(["pathChange", "select", "input", "pasteImage", "undoStateChange"]));
    N(this, "startSelectionId", "squire-selection-start");
    N(this, "endSelectionId", "squire-selection-end");
    N(this, "linkRegExp", /\b(?:((?:(?:ht|f)tps?:\/\/|www\d{0,3}[.]|[a-z0-9][a-z0-9.\-]*[.][a-z]{2,}\/)(?:[^\s()<>]+|\([^\s()<>]+\))+(?:[^\s?&`!()\[\]{};:'".,<>«»“”‘’]|\([^\s()<>]+\)))|([\w\-.%+]+@(?:[\w\-]+\.)+[a-z]{2,}\b(?:[?][^&?\s]+=[^\s?&`!()\[\]{};:'".,<>«»“”‘’]+(?:&[^&?\s]+=[^\s?&`!()\[\]{};:'".,<>«»“”‘’]+)*)?))/i);
    N(this, "tagAfterSplit", { DT: "DD", DD: "DT", LI: "LI", PRE: "PRE" });
    this._root = e, this._config = this._makeConfig(n), this._isFocused = !1, this._lastSelection = co(e, 0), this._willRestoreSelection = !1, this._mayHaveZWS = !1, this._lastAnchorNode = null, this._lastFocusNode = null, this._path = "", this._events = /* @__PURE__ */ new Map(), this._undoIndex = -1, this._undoStack = [], this._undoStackLength = 0, this._isInUndoState = !1, this._ignoreChange = !1, this._ignoreAllChanges = !1, this.addEventListener("selectionchange", this._updatePathOnEvent), this.addEventListener("blur", this._enableRestoreSelection), this.addEventListener("mousedown", this._disableRestoreSelection), this.addEventListener("touchstart", this._disableRestoreSelection), this.addEventListener("focus", this._restoreSelection), this._isShiftDown = !1, this.addEventListener("cut", VM), this.addEventListener("copy", HM), this.addEventListener("paste", jM), this.addEventListener("drop", ZM), this.addEventListener("keydown", xp), this.addEventListener("keyup", xp), this.addEventListener("keydown", JM), this._keyHandlers = Object.create(Nt);
    let t = new MutationObserver(() => this._docWasChanged());
    t.observe(e, { childList: !0, attributes: !0, characterData: !0, subtree: !0 }), this._mutation = t, e.setAttribute("contenteditable", "true");
    try {
      document.execCommand("enableObjectResizing", !1, "false"), document.execCommand("enableInlineTableEditing", !1, "false");
    } catch {
    }
    this.addEventListener("beforeinput", this._beforeInput), this.setHTML("");
  }
  destroy() {
    this._events.forEach((e, n) => {
      this.removeEventListener(n);
    }), this._mutation.disconnect(), this._undoIndex = -1, this._undoStack = [], this._undoStackLength = 0;
  }
  _makeConfig(e) {
    let n = { blockTag: "DIV", blockAttributes: null, tagAttributes: {}, classNames: { color: "color", fontFamily: "font", fontSize: "size", highlight: "highlight" }, undo: { documentSizeThreshold: -1, undoLimit: -1 }, addLinks: !0, willCutCopy: null, sanitizeToDOMFragment: (t) => {
      let a = DOMPurify.sanitize(t, { ALLOW_UNKNOWN_PROTOCOLS: !0, WHOLE_DOCUMENT: !1, RETURN_DOM: !0, RETURN_DOM_FRAGMENT: !0, FORCE_BODY: !1 });
      return a ? document.importNode(a, !0) : document.createDocumentFragment();
    }, didError: (t) => console.log(t) };
    return e && (Object.assign(n, e), n.blockTag = n.blockTag.toUpperCase()), n;
  }
  setKeyHandler(e, n) {
    return this._keyHandlers[e] = n, this;
  }
  _beforeInput(e) {
    switch (e.inputType) {
      case "insertText":
        LM && e.data && e.data.includes(`
`) && e.preventDefault();
        break;
      case "insertLineBreak":
        e.preventDefault(), this.splitBlock(!0);
        break;
      case "insertParagraph":
        e.preventDefault(), this.splitBlock(!1);
        break;
      case "insertOrderedList":
        e.preventDefault(), this.makeOrderedList();
        break;
      case "insertUnoderedList":
        e.preventDefault(), this.makeUnorderedList();
        break;
      case "historyUndo":
        e.preventDefault(), this.undo();
        break;
      case "historyRedo":
        e.preventDefault(), this.redo();
        break;
      case "formatBold":
        e.preventDefault(), this.bold();
        break;
      case "formaItalic":
        e.preventDefault(), this.italic();
        break;
      case "formatUnderline":
        e.preventDefault(), this.underline();
        break;
      case "formatStrikeThrough":
        e.preventDefault(), this.strikethrough();
        break;
      case "formatSuperscript":
        e.preventDefault(), this.superscript();
        break;
      case "formatSubscript":
        e.preventDefault(), this.subscript();
        break;
      case "formatJustifyFull":
      case "formatJustifyCenter":
      case "formatJustifyRight":
      case "formatJustifyLeft": {
        e.preventDefault();
        let n = e.inputType.slice(13).toLowerCase();
        n === "full" && (n = "justify"), this.setTextAlignment(n);
        break;
      }
      case "formatRemove":
        e.preventDefault(), this.removeAllFormatting();
        break;
      case "formatSetBlockTextDirection": {
        e.preventDefault();
        let n = e.data;
        n === "null" && (n = null), this.setTextDirection(n);
        break;
      }
      case "formatBackColor":
        e.preventDefault(), this.setHighlightColor(e.data);
        break;
      case "formatFontColor":
        e.preventDefault(), this.setTextColor(e.data);
        break;
      case "formatFontName":
        e.preventDefault(), this.setFontFace(e.data);
        break;
    }
  }
  handleEvent(e) {
    this.fireEvent(e.type, e);
  }
  fireEvent(e, n) {
    let t = this._events.get(e);
    if (/^(?:focus|blur)/.test(e)) {
      let a = this._root === document.activeElement;
      if (e === "focus") {
        if (!a || this._isFocused)
          return this;
        this._isFocused = !0;
      } else {
        if (a || !this._isFocused)
          return this;
        this._isFocused = !1;
      }
    }
    if (t) {
      let a = n instanceof Event ? n : new CustomEvent(e, { detail: n });
      t = t.slice();
      for (let u of t)
        try {
          "handleEvent" in u ? u.handleEvent(a) : u.call(this, a);
        } catch (f) {
          this._config.didError(f);
        }
    }
    return this;
  }
  addEventListener(e, n) {
    let t = this._events.get(e), a = this._root;
    return t || (t = [], this._events.set(e, t), this.customEvents.has(e) || (e === "selectionchange" && (a = document), a.addEventListener(e, this, !0))), t.push(n), this;
  }
  removeEventListener(e, n) {
    let t = this._events.get(e), a = this._root;
    if (t) {
      if (n) {
        let u = t.length;
        for (; u--; )
          t[u] === n && t.splice(u, 1);
      } else
        t.length = 0;
      t.length || (this._events.delete(e), this.customEvents.has(e) || (e === "selectionchange" && (a = document), a.removeEventListener(e, this, !0)));
    }
    return this;
  }
  focus() {
    return this._root.focus({ preventScroll: !0 }), this;
  }
  blur() {
    return this._root.blur(), this;
  }
  _enableRestoreSelection() {
    this._willRestoreSelection = !0;
  }
  _disableRestoreSelection() {
    this._willRestoreSelection = !1;
  }
  _restoreSelection() {
    this._willRestoreSelection && this.setSelection(this._lastSelection);
  }
  _removeZWS() {
    this._mayHaveZWS && (mh(this._root), this._mayHaveZWS = !1);
  }
  _saveRangeToBookmark(e) {
    let n = Ne("INPUT", { id: this.startSelectionId, type: "hidden" }), t = Ne("INPUT", { id: this.endSelectionId, type: "hidden" }), a;
    Vi(e, n), e.collapse(!1), Vi(e, t), n.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_PRECEDING && (n.id = this.endSelectionId, t.id = this.startSelectionId, a = n, n = t, t = a), e.setStartAfter(n), e.setEndBefore(t);
  }
  _getRangeAndRemoveBookmark(e) {
    let n = this._root, t = n.querySelector("#" + this.startSelectionId), a = n.querySelector("#" + this.endSelectionId);
    if (t && a) {
      let u = t.parentNode, f = a.parentNode, d = Array.from(u.childNodes).indexOf(t), m = Array.from(f.childNodes).indexOf(a);
      u === f && (m -= 1), t.remove(), a.remove(), e || (e = document.createRange()), e.setStart(u, d), e.setEnd(f, m), ls(u, e), u !== f && ls(f, e), e.collapsed && (u = e.startContainer, u instanceof Text && (f = u.childNodes[e.startOffset], (!f || !(f instanceof Text)) && (f = u.childNodes[e.startOffset - 1]), f && f instanceof Text && (e.setStart(f, 0), e.collapse(!0))));
    }
    return e || null;
  }
  getSelection() {
    let e = window.getSelection(), n = this._root, t = null;
    if (this._isFocused && e && e.rangeCount) {
      t = e.getRangeAt(0).cloneRange();
      let a = t.startContainer, u = t.endContainer;
      a && Tr(a) && t.setStartBefore(a), u && Tr(u) && t.setEndBefore(u);
    }
    return t && n.contains(t.commonAncestorContainer) ? this._lastSelection = t : (t = this._lastSelection, document.contains(t.commonAncestorContainer) || (t = null)), t || (t = co(n.firstElementChild || n, 0)), t;
  }
  setSelection(e) {
    if (this._lastSelection = e, !this._isFocused)
      this._enableRestoreSelection();
    else {
      let n = window.getSelection();
      n && ("setBaseAndExtent" in Selection.prototype ? n.setBaseAndExtent(e.startContainer, e.startOffset, e.endContainer, e.endOffset) : (n.removeAllRanges(), n.addRange(e)));
    }
    return this;
  }
  _moveCursorTo(e) {
    let n = this._root, t = co(n, e ? 0 : n.childNodes.length);
    return Qt(t), this.setSelection(t), this;
  }
  moveCursorToStart() {
    return this._moveCursorTo(!0);
  }
  moveCursorToEnd() {
    return this._moveCursorTo(!1);
  }
  getCursorPosition() {
    let e = this.getSelection(), n = e.getBoundingClientRect();
    if (n && !n.top) {
      this._ignoreChange = !0;
      let t = Ne("SPAN");
      t.textContent = fs, Vi(e, t), n = t.getBoundingClientRect();
      let a = t.parentNode;
      a.removeChild(t), ls(a, e);
    }
    return n;
  }
  getPath() {
    return this._path;
  }
  _updatePathOnEvent() {
    this._isFocused && this._updatePath(this.getSelection());
  }
  _updatePath(e, n) {
    let t = e.startContainer, a = e.endContainer, u;
    (n || t !== this._lastAnchorNode || a !== this._lastFocusNode) && (this._lastAnchorNode = t, this._lastFocusNode = a, u = t && a ? t === a ? this._getPath(a) : "(selection)" : "", this._path !== u && (this._path = u, this.fireEvent("pathChange", { path: u }))), this.fireEvent(e.collapsed ? "cursor" : "select", { range: e });
  }
  _getPath(e) {
    let n = this._root, t = this._config, a = "";
    if (e && e !== n) {
      let u = e.parentNode;
      if (a = u ? this._getPath(u) : "", e instanceof HTMLElement) {
        let f = e.id, d = e.classList, m = Array.from(d).sort(), g = e.dir, y = t.classNames;
        a += (a ? ">" : "") + e.nodeName, f && (a += "#" + f), m.length && (a += ".", a += m.join(".")), g && (a += "[dir=" + g + "]"), d.contains(y.highlight) && (a += "[backgroundColor=" + e.style.backgroundColor.replace(/ /g, "") + "]"), d.contains(y.color) && (a += "[color=" + e.style.color.replace(/ /g, "") + "]"), d.contains(y.fontFamily) && (a += "[fontFamily=" + e.style.fontFamily.replace(/ /g, "") + "]"), d.contains(y.fontSize) && (a += "[fontSize=" + e.style.fontSize + "]");
      }
    }
    return a;
  }
  modifyDocument(e) {
    let n = this._mutation;
    return n && (n.takeRecords().length && this._docWasChanged(), n.disconnect()), this._ignoreAllChanges = !0, e(), this._ignoreAllChanges = !1, n && (n.observe(this._root, { childList: !0, attributes: !0, characterData: !0, subtree: !0 }), this._ignoreChange = !1), this;
  }
  _docWasChanged() {
    if (PM(), this._mayHaveZWS = !0, !this._ignoreAllChanges) {
      if (this._ignoreChange) {
        this._ignoreChange = !1;
        return;
      }
      this._isInUndoState && (this._isInUndoState = !1, this.fireEvent("undoStateChange", { canUndo: !0, canRedo: !1 })), this.fireEvent("input");
    }
  }
  _recordUndoState(e, n) {
    if (!this._isInUndoState || n) {
      let t = this._undoIndex, a = this._undoStack, u = this._config.undo, f = u.documentSizeThreshold, d = u.undoLimit;
      n || (t += 1), t < this._undoStackLength && (a.length = this._undoStackLength = t), e && this._saveRangeToBookmark(e);
      let m = this._getRawHTML();
      f > -1 && m.length * 2 > f && d > -1 && t > d && (a.splice(0, t - d), t = d, this._undoStackLength = d), a[t] = m, this._undoIndex = t, this._undoStackLength += 1, this._isInUndoState = !0;
    }
    return this;
  }
  saveUndoState(e) {
    return e || (e = this.getSelection()), this._recordUndoState(e, this._isInUndoState), this._getRangeAndRemoveBookmark(e), this;
  }
  undo() {
    if (this._undoIndex !== 0 || !this._isInUndoState) {
      this._recordUndoState(this.getSelection(), !1), this._undoIndex -= 1, this._setRawHTML(this._undoStack[this._undoIndex]);
      let e = this._getRangeAndRemoveBookmark();
      e && this.setSelection(e), this._isInUndoState = !0, this.fireEvent("undoStateChange", { canUndo: this._undoIndex !== 0, canRedo: !0 }), this.fireEvent("input");
    }
    return this;
  }
  redo() {
    let e = this._undoIndex, n = this._undoStackLength;
    if (e + 1 < n && this._isInUndoState) {
      this._undoIndex += 1, this._setRawHTML(this._undoStack[this._undoIndex]);
      let t = this._getRangeAndRemoveBookmark();
      t && this.setSelection(t), this.fireEvent("undoStateChange", { canUndo: !0, canRedo: e + 2 < n }), this.fireEvent("input");
    }
    return this;
  }
  getRoot() {
    return this._root;
  }
  _getRawHTML() {
    return this._root.innerHTML;
  }
  _setRawHTML(e) {
    let n = this._root;
    n.innerHTML = e;
    let t = n, a = t.firstChild;
    if (!a || a.nodeName === "BR") {
      let u = this.createDefaultBlock();
      a ? t.replaceChild(u, a) : t.appendChild(u);
    } else
      for (; t = Cr(t, n); )
        zt(t);
    return this._ignoreChange = !0, this;
  }
  getHTML(e) {
    let n;
    e && (n = this.getSelection(), this._saveRangeToBookmark(n));
    let t = this._getRawHTML().replace(/\u200B/g, "");
    return e && this._getRangeAndRemoveBookmark(n), t;
  }
  setHTML(e) {
    let n = this._config.sanitizeToDOMFragment(e, this), t = this._root;
    Uh(n, this._config), fu(n, t, !1), bi(n);
    let a = n, u = a.firstChild;
    if (!u || u.nodeName === "BR") {
      let d = this.createDefaultBlock();
      u ? a.replaceChild(d, u) : a.appendChild(d);
    } else
      for (; a = Cr(a, t); )
        zt(a);
    for (this._ignoreChange = !0; u = t.lastChild; )
      t.removeChild(u);
    t.appendChild(n), this._undoIndex = -1, this._undoStack.length = 0, this._undoStackLength = 0, this._isInUndoState = !1;
    let f = this._getRangeAndRemoveBookmark() || co(t.firstElementChild || t, 0);
    return this.saveUndoState(f), this.setSelection(f), this._updatePath(f, !0), this;
  }
  insertHTML(e, n) {
    let t = this._config, a = t.sanitizeToDOMFragment(e, this), u = this.getSelection();
    this.saveUndoState(u);
    try {
      let f = this._root;
      t.addLinks && this.addDetectedLinks(a, a), Uh(a, this._config), fu(a, f, !1), Vh(a), a.normalize();
      let d = a;
      for (; d = Cr(d, a); )
        zt(d);
      let m = !0;
      if (n) {
        let g = new CustomEvent("willPaste", { detail: { fragment: a } });
        this.fireEvent("willPaste", g), a = g.detail.fragment, m = !g.defaultPrevented;
      }
      m && (FM(u, a, f), u.collapse(!1), Mp(u, "A", f), this._ensureBottomLine()), this.setSelection(u), this._updatePath(u, !0), n && this.focus();
    } catch (f) {
      this._config.didError(f);
    }
    return this;
  }
  insertElement(e, n) {
    if (n || (n = this.getSelection()), n.collapse(!0), ht(e))
      Vi(n, e), n.setStartAfter(e);
    else {
      let t = this._root, a = ni(n, t), u = a || t, f = null;
      for (; u !== t && !u.nextSibling; )
        u = u.parentNode;
      if (u !== t) {
        let m = u.parentNode;
        f = Hn(m, u.nextSibling, t, t);
      }
      a && Hh(a) && Vt(a), t.insertBefore(e, f);
      let d = this.createDefaultBlock();
      t.insertBefore(d, f), n.setStart(d, 0), n.setEnd(d, 0), Qt(n);
    }
    return this.focus(), this.setSelection(n), this._updatePath(n), this;
  }
  insertImage(e, n) {
    let t = Ne("IMG", Object.assign({ src: e }, n));
    return this.insertElement(t), t;
  }
  insertPlainText(e, n) {
    let t = this.getSelection();
    if (t.collapsed && pt(t.startContainer, this._root, "PRE")) {
      let y = t.startContainer, w = t.startOffset, h;
      if (!y || !(y instanceof Text)) {
        let T = document.createTextNode("");
        y.insertBefore(T, y.childNodes[w]), h = T, w = 0;
      } else
        h = y;
      let b = !0;
      if (n) {
        let T = new CustomEvent("willPaste", { detail: { text: e } });
        this.fireEvent("willPaste", T), e = T.detail.text, b = !T.defaultPrevented;
      }
      return b && (h.insertData(w, e), t.setStart(h, w + e.length), t.collapse(!0)), this.setSelection(t), this;
    }
    let a = e.split(`
`), u = this._config, f = u.blockTag, d = u.blockAttributes, m = "</" + f + ">", g = "<" + f;
    for (let y in d)
      g += " " + y + '="' + Ep(d[y]) + '"';
    g += ">";
    for (let y = 0, w = a.length; y < w; y += 1) {
      let h = a[y];
      h = Ep(h).replace(/ (?=(?: |$))/g, "&nbsp;"), y && (h = g + (h || "<BR>") + m), a[y] = h;
    }
    return this.insertHTML(a.join(""), n);
  }
  getSelectedText() {
    let e = this.getSelection();
    if (e.collapsed)
      return "";
    let n = e.startContainer, t = e.endContainer, a = new On(e.commonAncestorContainer, 5, (g) => wr(e, g, !0));
    a.currentNode = n;
    let u = n, f = "", d = !1, m;
    for ((!(u instanceof Element) && !(u instanceof Text) || !a.filter(u)) && (u = a.nextNode()); u; )
      u instanceof Text ? (m = u.data, m && /\S/.test(m) && (u === t && (m = m.slice(0, e.endOffset)), u === n && (m = m.slice(e.startOffset)), f += m, d = !0)) : (u.nodeName === "BR" || d && !ht(u)) && (f += `
`, d = !1), u = a.nextNode();
    return f;
  }
  getFontInfo(e) {
    let n = { color: void 0, backgroundColor: void 0, fontFamily: void 0, fontSize: void 0 };
    e || (e = this.getSelection());
    let t = 0, a = e.commonAncestorContainer;
    if (e.collapsed || a instanceof Text)
      for (a instanceof Text && (a = a.parentNode); t < 4 && a; ) {
        let u = a.style;
        if (u) {
          let f = u.color;
          !n.color && f && (n.color = f, t += 1);
          let d = u.backgroundColor;
          !n.backgroundColor && d && (n.backgroundColor = d, t += 1);
          let m = u.fontFamily;
          !n.fontFamily && m && (n.fontFamily = m, t += 1);
          let g = u.fontSize;
          !n.fontSize && g && (n.fontSize = g, t += 1);
        }
        a = a.parentNode;
      }
    return n;
  }
  hasFormat(e, n, t) {
    e = e.toUpperCase(), n || (n = {}), t || (t = this.getSelection()), !t.collapsed && t.startContainer instanceof Text && t.startOffset === t.startContainer.length && t.startContainer.nextSibling && t.setStartBefore(t.startContainer.nextSibling), !t.collapsed && t.endContainer instanceof Text && t.endOffset === 0 && t.endContainer.previousSibling && t.setEndAfter(t.endContainer.previousSibling);
    let a = this._root, u = t.commonAncestorContainer;
    if (pt(u, a, e, n))
      return !0;
    if (u instanceof Text)
      return !1;
    let f = new On(u, 4, (g) => wr(t, g, !0)), d = !1, m;
    for (; m = f.nextNode(); ) {
      if (!pt(m, a, e, n))
        return !1;
      d = !0;
    }
    return d;
  }
  changeFormat(e, n, t, a) {
    return t || (t = this.getSelection()), this.saveUndoState(t), n && (t = this._removeFormat(n.tag.toUpperCase(), n.attributes || {}, t, a)), e && (t = this._addFormat(e.tag.toUpperCase(), e.attributes || {}, t)), this.setSelection(t), this._updatePath(t, !0), this.focus();
  }
  _addFormat(e, n, t) {
    let a = this._root;
    if (t.collapsed) {
      let u = zt(Ne(e, n));
      Vi(t, u);
      let f = u.firstChild || u, d = f instanceof Text ? f.length : 0;
      t.setStart(f, d), t.collapse(!0);
      let m = u;
      for (; ht(m); )
        m = m.parentNode;
      mh(m, u);
    } else {
      let u = new On(t.commonAncestorContainer, 5, (y) => (y instanceof Text || y.nodeName === "BR" || y.nodeName === "IMG") && wr(t, y, !0)), { startContainer: f, startOffset: d, endContainer: m, endOffset: g } = t;
      if (u.currentNode = f, !(f instanceof Element) && !(f instanceof Text) || !u.filter(f)) {
        let y = u.nextNode();
        if (!y)
          return t;
        f = y, d = 0;
      }
      do {
        let y = u.currentNode;
        if (!pt(y, a, e, n)) {
          y === m && y.length > g && y.splitText(g), y === f && d && (y = y.splitText(d), m === f ? (m = y, g -= d) : m === f.parentNode && (g += 1), f = y, d = 0);
          let w = Ne(e, n);
          un(y, w), w.appendChild(y);
        }
      } while (u.nextNode());
      t = co(f, d, m, g);
    }
    return t;
  }
  _removeFormat(e, n, t, a) {
    this._saveRangeToBookmark(t);
    let u;
    t.collapsed && (zh ? u = document.createTextNode(fs) : u = document.createTextNode(""), Vi(t, u));
    let f = t.commonAncestorContainer;
    for (; ht(f); )
      f = f.parentNode;
    let d = t.startContainer, m = t.startOffset, g = t.endContainer, y = t.endOffset, w = [], h = (T, A) => {
      if (wr(t, T, !1))
        return;
      let x, Z;
      if (!wr(t, T, !0)) {
        !(T instanceof HTMLInputElement) && (!(T instanceof Text) || T.data) && w.push([A, T]);
        return;
      }
      if (T instanceof Text)
        T === g && y !== T.length && w.push([A, T.splitText(y)]), T === d && m && (T.splitText(m), w.push([A, T]));
      else
        for (x = T.firstChild; x; x = Z)
          Z = x.nextSibling, h(x, A);
    }, b = Array.from(f.getElementsByTagName(e)).filter((T) => wr(t, T, !0) && Fh(T, e, n));
    return a || b.forEach((T) => {
      h(T, T);
    }), w.forEach(([T, A]) => {
      T = T.cloneNode(!1), un(A, T), T.appendChild(A);
    }), b.forEach((T) => {
      un(T, Mt(T));
    }), this._getRangeAndRemoveBookmark(t), u && t.collapse(!1), ls(f, t), t;
  }
  bold() {
    return this.changeFormat({ tag: "B" });
  }
  removeBold() {
    return this.changeFormat(null, { tag: "B" });
  }
  italic() {
    return this.changeFormat({ tag: "I" });
  }
  removeItalic() {
    return this.changeFormat(null, { tag: "I" });
  }
  underline() {
    return this.changeFormat({ tag: "U" });
  }
  removeUnderline() {
    return this.changeFormat(null, { tag: "U" });
  }
  strikethrough() {
    return this.changeFormat({ tag: "S" });
  }
  removeStrikethrough() {
    return this.changeFormat(null, { tag: "S" });
  }
  subscript() {
    return this.changeFormat({ tag: "SUB" }, { tag: "SUP" });
  }
  removeSubscript() {
    return this.changeFormat(null, { tag: "SUB" });
  }
  superscript() {
    return this.changeFormat({ tag: "SUP" }, { tag: "SUB" });
  }
  removeSuperscript() {
    return this.changeFormat(null, { tag: "SUP" });
  }
  makeLink(e, n) {
    let t = this.getSelection();
    if (t.collapsed) {
      let a = e.indexOf(":") + 1;
      if (a)
        for (; e[a] === "/"; )
          a += 1;
      Vi(t, document.createTextNode(e.slice(a)));
    }
    return n = Object.assign({ href: e }, this._config.tagAttributes.a, n), this.changeFormat({ tag: "A", attributes: n }, { tag: "A" }, t);
  }
  removeLink() {
    return this.changeFormat(null, { tag: "A" }, this.getSelection(), !0);
  }
  addDetectedLinks(e, n) {
    let t = new On(e, 4, (d) => !pt(d, n || this._root, "A")), a = this.linkRegExp, u = this._config.tagAttributes.a, f;
    for (; f = t.nextNode(); ) {
      let d = f.parentNode, m = f.data, g;
      for (; g = a.exec(m); ) {
        let y = g.index, w = y + g[0].length;
        y && d.insertBefore(document.createTextNode(m.slice(0, y)), f);
        let h = Ne("A", Object.assign({ href: g[1] ? /^(?:ht|f)tps?:/i.test(g[1]) ? g[1] : "http://" + g[1] : "mailto:" + g[0] }, u));
        h.textContent = m.slice(y, w), d.insertBefore(h, f), f.data = m = m.slice(w);
      }
    }
    return this;
  }
  setFontFace(e) {
    let n = this._config.classNames.fontFamily;
    return this.changeFormat(e ? { tag: "SPAN", attributes: { class: n, style: "font-family: " + e + ", sans-serif;" } } : null, { tag: "SPAN", attributes: { class: n } });
  }
  setFontSize(e) {
    let n = this._config.classNames.fontSize;
    return this.changeFormat(e ? { tag: "SPAN", attributes: { class: n, style: "font-size: " + (typeof e == "number" ? e + "px" : e) } } : null, { tag: "SPAN", attributes: { class: n } });
  }
  setTextColor(e) {
    let n = this._config.classNames.color;
    return this.changeFormat(e ? { tag: "SPAN", attributes: { class: n, style: "color:" + e } } : null, { tag: "SPAN", attributes: { class: n } });
  }
  setHighlightColor(e) {
    let n = this._config.classNames.highlight;
    return this.changeFormat(e ? { tag: "SPAN", attributes: { class: n, style: "background-color:" + e } } : null, { tag: "SPAN", attributes: { class: n } });
  }
  _ensureBottomLine() {
    let e = this._root, n = e.lastElementChild;
    (!n || n.nodeName !== this._config.blockTag || !Sr(n)) && e.appendChild(this.createDefaultBlock());
  }
  createDefaultBlock(e) {
    let n = this._config;
    return zt(Ne(n.blockTag, n.blockAttributes, e));
  }
  splitBlock(e, n) {
    n || (n = this.getSelection());
    let t = this._root, a, u, f, d;
    if (this._recordUndoState(n), this._removeZWS(), this._getRangeAndRemoveBookmark(n), n.collapsed || bo(n, t), this._config.addLinks) {
      Qt(n);
      let h = n.startContainer, b = n.startOffset;
      setTimeout(() => {
        f_(this, h, b);
      }, 0);
    }
    if (a = ni(n, t), a && (u = pt(a, t, "PRE"))) {
      Qt(n), f = n.startContainer;
      let h = n.startOffset;
      return f instanceof Text || (f = document.createTextNode(""), u.insertBefore(f, u.firstChild)), !e && f instanceof Text && (f.data.charAt(h - 1) === `
` || $a(n, t)) && (f.data.charAt(h) === `
` || Au(n, t)) ? (f.deleteData(h && h - 1, h ? 2 : 1), d = Hn(f, h && h - 1, t, t), f = d.previousSibling, f.textContent || Vt(f), f = this.createDefaultBlock(), d.parentNode.insertBefore(f, d), d.textContent || Vt(d), n.setStart(f, 0)) : (f.insertData(h, `
`), zt(u), f.length === h + 1 ? n.setStartAfter(f) : n.setStart(f, h + 1)), n.collapse(!0), this.setSelection(n), this._updatePath(n, !0), this._docWasChanged(), this;
    }
    if (!a || e || /^T[HD]$/.test(a.nodeName))
      return Mp(n, "A", t), Vi(n, Ne("BR")), n.collapse(!1), this.setSelection(n), this._updatePath(n, !0), this;
    if ((u = pt(a, t, "LI")) && (a = u), Hh(a)) {
      if (pt(a, t, "UL") || pt(a, t, "OL"))
        return this.decreaseListLevel(n), this;
      if (pt(a, t, "BLOCKQUOTE"))
        return this.removeQuote(n), this;
    }
    f = n.startContainer;
    let m = n.startOffset, g = this.tagAfterSplit[a.nodeName];
    d = Hn(f, m, a.parentNode, this._root);
    let y = this._config, w = null;
    for (g || (g = y.blockTag, w = y.blockAttributes), Fh(d, g, w) || (a = Ne(g, w), d.dir && (a.dir = d.dir), un(d, a), a.appendChild(Mt(d)), d = a), mh(a), Vh(a), zt(a); d instanceof Element; ) {
      let h = d.firstChild, b;
      if (d.nodeName === "A" && (!d.textContent || d.textContent === fs)) {
        h = document.createTextNode(""), un(d, h), d = h;
        break;
      }
      for (; h && h instanceof Text && !h.data && (b = h.nextSibling, !(!b || b.nodeName === "BR")); )
        Vt(h), h = b;
      if (!h || h.nodeName === "BR" || h instanceof Text)
        break;
      d = h;
    }
    return n = co(d, 0), this.setSelection(n), this._updatePath(n, !0), this;
  }
  forEachBlock(e, n, t) {
    t || (t = this.getSelection()), n && this.saveUndoState(t);
    let a = this._root, u = ni(t, a), f = go(t, a);
    if (u && f)
      do
        if (e(u) || u === f)
          break;
      while (u = Cr(u, a));
    return n && (this.setSelection(t), this._updatePath(t, !0)), this;
  }
  modifyBlocks(e, n) {
    n || (n = this.getSelection()), this._recordUndoState(n, this._isInUndoState);
    let t = this._root;
    Ap(n, t), Pr(n, t, t, t);
    let a = u_(n, t, t);
    if (!n.collapsed) {
      let u = n.endContainer;
      if (u === t)
        n.collapse(!1);
      else {
        for (; u.parentNode !== t; )
          u = u.parentNode;
        n.setStartBefore(u), n.collapse(!0);
      }
    }
    return Vi(n, e.call(this, a)), n.endOffset < n.endContainer.childNodes.length && Zi(n.endContainer.childNodes[n.endOffset]), Zi(n.startContainer.childNodes[n.startOffset]), this._getRangeAndRemoveBookmark(n), this.setSelection(n), this._updatePath(n, !0), this;
  }
  setTextAlignment(e) {
    return this.forEachBlock((n) => {
      let t = n.className.split(/\s+/).filter((a) => !!a && !/^align/.test(a)).join(" ");
      e ? (n.className = t + " align-" + e, n.style.textAlign = e) : (n.className = t, n.style.textAlign = "");
    }, !0), this.focus();
  }
  setTextDirection(e) {
    return this.forEachBlock((n) => {
      e ? n.dir = e : n.removeAttribute("dir");
    }, !0), this.focus();
  }
  _getListSelection(e, n) {
    let t = e.commonAncestorContainer, a = e.startContainer, u = e.endContainer;
    for (; t && t !== n && !/^[OU]L$/.test(t.nodeName); )
      t = t.parentNode;
    if (!t || t === n)
      return null;
    for (a === t && (a = a.childNodes[e.startOffset]), u === t && (u = u.childNodes[e.endOffset]); a && a.parentNode !== t; )
      a = a.parentNode;
    for (; u && u.parentNode !== t; )
      u = u.parentNode;
    return [t, a, u];
  }
  increaseListLevel(e) {
    e || (e = this.getSelection());
    let n = this._root, t = this._getListSelection(e, n);
    if (!t)
      return this.focus();
    let [a, u, f] = t;
    if (!u || u === a.firstChild)
      return this.focus();
    this._recordUndoState(e, this._isInUndoState);
    let d = a.nodeName, m = u.previousSibling, g, y;
    m.nodeName !== d && (g = this._config.tagAttributes[d.toLowerCase()], m = Ne(d, g), a.insertBefore(m, u));
    do
      y = u === f ? null : u.nextSibling, m.appendChild(u);
    while (u = y);
    return y = m.nextSibling, y && Zi(y), this._getRangeAndRemoveBookmark(e), this.setSelection(e), this._updatePath(e, !0), this.focus();
  }
  decreaseListLevel(e) {
    e || (e = this.getSelection());
    let n = this._root, t = this._getListSelection(e, n);
    if (!t)
      return this.focus();
    let [a, u, f] = t;
    u || (u = a.firstChild), f || (f = a.lastChild), this._recordUndoState(e, this._isInUndoState);
    let d, m = null;
    if (u) {
      let g = a.parentNode;
      if (m = f.nextSibling ? Hn(a, f.nextSibling, g, n) : a.nextSibling, g !== n && g.nodeName === "LI") {
        for (g = g.parentNode; m; )
          d = m.nextSibling, f.appendChild(m), m = d;
        m = a.parentNode.nextSibling;
      }
      let y = !/^[OU]L$/.test(g.nodeName);
      do
        d = u === f ? null : u.nextSibling, a.removeChild(u), y && u.nodeName === "LI" && (u = this.createDefaultBlock([Mt(u)])), g.insertBefore(u, m);
      while (u = d);
    }
    return a.firstChild || Vt(a), m && Zi(m), this._getRangeAndRemoveBookmark(e), this.setSelection(e), this._updatePath(e, !0), this.focus();
  }
  _makeList(e, n) {
    let t = du(e, this._root), a = this._config.tagAttributes, u = a[n.toLowerCase()], f = a.li, d;
    for (; d = t.nextNode(); )
      if (d.parentNode instanceof HTMLLIElement && (d = d.parentNode, t.currentNode = d.lastChild), d instanceof HTMLLIElement) {
        d = d.parentNode;
        let m = d.nodeName;
        m !== n && /^[OU]L$/.test(m) && un(d, Ne(n, u, [Mt(d)]));
      } else {
        let m = Ne("LI", f);
        d.dir && (m.dir = d.dir);
        let g = d.previousSibling;
        g && g.nodeName === n ? (g.appendChild(m), Vt(d)) : un(d, Ne(n, u, [m])), m.appendChild(Mt(d)), t.currentNode = m;
      }
    return e;
  }
  makeUnorderedList() {
    return this.modifyBlocks((e) => this._makeList(e, "UL")), this.focus();
  }
  makeOrderedList() {
    return this.modifyBlocks((e) => this._makeList(e, "OL")), this.focus();
  }
  removeList() {
    return this.modifyBlocks((e) => {
      let n = e.querySelectorAll("UL, OL"), t = e.querySelectorAll("LI");
      this._root;
      for (let a = 0, u = n.length; a < u; a += 1) {
        let f = n[a], d = Mt(f);
        bi(d), un(f, d);
      }
      for (let a = 0, u = t.length; a < u; a += 1) {
        let f = t[a];
        Sr(f) ? un(f, this.createDefaultBlock([Mt(f)])) : (bi(f), un(f, Mt(f)));
      }
      return e;
    }), this.focus();
  }
  increaseQuoteLevel(e) {
    return this.modifyBlocks((n) => Ne("BLOCKQUOTE", this._config.tagAttributes.blockquote, [n]), e), this.focus();
  }
  decreaseQuoteLevel(e) {
    return this.modifyBlocks((n) => (Array.from(n.querySelectorAll("blockquote")).filter((t) => !pt(t.parentNode, n, "BLOCKQUOTE")).forEach((t) => {
      un(t, Mt(t));
    }), n), e), this.focus();
  }
  removeQuote(e) {
    return this.modifyBlocks(() => this.createDefaultBlock([Ne("INPUT", { id: this.startSelectionId, type: "hidden" }), Ne("INPUT", { id: this.endSelectionId, type: "hidden" })]), e), this.focus();
  }
  code() {
    let e = this.getSelection();
    return e.collapsed || ps(e.commonAncestorContainer) ? (this.modifyBlocks((n) => {
      let t = this._root, a = document.createDocumentFragment(), u = du(n, t), f;
      for (; f = u.nextNode(); ) {
        let m = f.querySelectorAll("BR"), g = [], y = m.length;
        for (let w = 0; w < y; w += 1)
          g[w] = Eu(m[w], !1);
        for (; y--; ) {
          let w = m[y];
          g[y] ? un(w, document.createTextNode(`
`)) : Vt(w);
        }
        for (m = f.querySelectorAll("CODE"), y = m.length; y--; )
          un(m[y], Mt(m[y]));
        a.childNodes.length && a.appendChild(document.createTextNode(`
`)), a.appendChild(Mt(f));
      }
      let d = new On(a, 4);
      for (; f = d.nextNode(); )
        f.data = f.data.replace(/ /g, " ");
      return a.normalize(), zt(Ne("PRE", this._config.tagAttributes.pre, [a]));
    }, e), this.focus()) : this.changeFormat({ tag: "CODE", attributes: this._config.tagAttributes.code }, null, e), this;
  }
  removeCode() {
    let e = this.getSelection(), n = e.commonAncestorContainer;
    return pt(n, this._root, "PRE") ? (this.modifyBlocks((t) => {
      this._root;
      let a = t.querySelectorAll("PRE"), u = a.length;
      for (; u--; ) {
        let f = a[u], d = new On(f, 4), m;
        for (; m = d.nextNode(); ) {
          let g = m.data;
          g = g.replace(/ (?= )/g, " ");
          let y = document.createDocumentFragment(), w;
          for (; (w = g.indexOf(`
`)) > -1; )
            y.appendChild(document.createTextNode(g.slice(0, w))), y.appendChild(Ne("BR")), g = g.slice(w + 1);
          m.parentNode.insertBefore(y, m), m.data = g;
        }
        bi(f), un(f, Mt(f));
      }
      return t;
    }, e), this.focus()) : this.changeFormat(null, { tag: "CODE" }, e), this;
  }
  toggleCode() {
    return this.hasFormat("PRE") || this.hasFormat("CODE") ? this.removeCode() : this.code(), this;
  }
  _removeFormatting(e, n) {
    for (let t = e.firstChild, a; t; t = a) {
      if (a = t.nextSibling, ht(t)) {
        if (t instanceof Text || t.nodeName === "BR" || t.nodeName === "IMG") {
          n.appendChild(t);
          continue;
        }
      } else if (Sr(t)) {
        n.appendChild(this.createDefaultBlock([this._removeFormatting(t, document.createDocumentFragment())]));
        continue;
      }
      this._removeFormatting(t, n);
    }
    return n;
  }
  removeAllFormatting(e) {
    if (e || (e = this.getSelection()), e.collapsed)
      return this.focus();
    let n = this._root, t = e.commonAncestorContainer;
    for (; t && !Sr(t); )
      t = t.parentNode;
    if (t || (Ap(e, n), t = n), t instanceof Text)
      return this.focus();
    this.saveUndoState(e), Pr(e, t, t, n);
    let a = e.startContainer, u = e.startOffset, f = e.endContainer, d = e.endOffset, m = document.createDocumentFragment(), g = document.createDocumentFragment(), y = Hn(f, d, t, n), w = Hn(a, u, t, n), h;
    for (; w !== y; )
      h = w.nextSibling, m.appendChild(w), w = h;
    if (this._removeFormatting(m, g), g.normalize(), w = g.firstChild, h = g.lastChild, w) {
      t.insertBefore(g, y);
      let b = Array.from(t.childNodes);
      u = b.indexOf(w), d = h ? b.indexOf(h) + 1 : 0;
    } else
      y && (u = Array.from(t.childNodes).indexOf(y), d = u);
    return e.setStart(t, u), e.setEnd(t, d), ls(t, e), Qt(e), this.setSelection(e), this._updatePath(e, !0), this.focus();
  }
}, eT = XM;
const tT = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTE0IDM2VjhoMTEuNHEzLjMgMCA1LjcyNSAyLjF0Mi40MjUgNS4zcTAgMS45LTEuMDUgMy41dC0yLjggMi40NXYuM3EyLjE1LjcgMy40NzUgMi41IDEuMzI1IDEuOCAxLjMyNSA0LjA1IDAgMy40LTIuNjI1IDUuNlEyOS4yNSAzNiAyNS43NSAzNlptNC4zLTE2LjE1aDYuOHExLjc1IDAgMy4wMjUtMS4xNXQxLjI3NS0yLjlxMC0xLjc1LTEuMjc1LTIuOTI1UTI2Ljg1IDExLjcgMjUuMSAxMS43aC02LjhabTAgMTIuMzVoNy4ycTEuOSAwIDMuMy0xLjI1dDEuNC0zLjE1cTAtMS44NS0xLjQtMy4xdC0zLjMtMS4yNWgtNy4yWiIvPjwvc3ZnPg==", Ot = {
  separator: ">",
  paragraph: "P",
  bold: "B",
  italic: "I",
  code: "PRE",
  underline: "U",
  unorderedList: "UL",
  orderedList: "OL",
  link: "A"
}, nT = oe({
  props: {
    isActive: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  }
}), iT = "_component_wn3g0_2", rT = "_active_wn3g0_11", oT = "_disabled_wn3g0_15", sT = {
  component: iT,
  active: rT,
  disabled: oT
}, aT = ["disabled"];
function lT(e, n, t, a, u, f) {
  return V(), ue("button", {
    class: J([e.$style.component, { [e.$style.active]: e.isActive, [e.$style.disabled]: e.disabled }]),
    disabled: e.disabled,
    onClick: n[0] || (n[0] = fo(() => {
    }, ["prevent"]))
  }, [
    Ke(e.$slots, "default")
  ], 10, aT);
}
const uT = {
  $style: sT
}, cT = /* @__PURE__ */ ce(nT, [["render", lT], ["__cssModules", uT]]), Li = oe({
  emits: ["update"],
  props: {
    editor: {
      type: Object,
      required: !0
    },
    path: {
      type: String,
      default: Ot.paragraph
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  components: {
    ButtonComponent: cT
  }
}), hT = oe({
  mixins: [Li],
  data() {
    return {
      BoldSvg: tT
    };
  },
  computed: {
    isActive() {
      return this.path.split(Ot.separator).includes(Ot.bold);
    }
  },
  methods: {
    onButtonClick() {
      this.editor.hasFormat(Ot.bold) ? this.editor.removeBold() : this.editor.bold();
    }
  }
});
function fT(e, n, t, a, u, f) {
  const d = D("el-image"), m = D("button-component");
  return V(), X(m, {
    disabled: e.disabled,
    "is-active": e.isActive,
    onClick: n[0] || (n[0] = (g) => e.onButtonClick())
  }, {
    default: k(() => [
      z(d, { src: e.BoldSvg }, null, 8, ["src"])
    ]),
    _: 1
  }, 8, ["disabled", "is-active"]);
}
const dT = /* @__PURE__ */ ce(hT, [["render", fT]]), pT = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTEwIDQwdi01aDYuODVsOC45LTIySDE4VjhoMjB2NWgtNi44NWwtOC45IDIySDMwdjVaIi8+PC9zdmc+", mT = oe({
  mixins: [Li],
  data() {
    return {
      ItalicSvg: pT
    };
  },
  computed: {
    isActive() {
      return this.path.split(Ot.separator).includes(Ot.italic);
    }
  },
  methods: {
    onButtonClick() {
      this.editor.hasFormat(Ot.italic) ? this.editor.removeItalic() : this.editor.italic();
    }
  }
});
function _T(e, n, t, a, u, f) {
  const d = D("el-image"), m = D("button-component");
  return V(), X(m, {
    disabled: e.disabled,
    "is-active": e.isActive,
    onClick: n[0] || (n[0] = (g) => e.onButtonClick())
  }, {
    default: k(() => [
      z(d, { src: e.ItalicSvg }, null, 8, ["src"])
    ]),
    _: 1
  }, 8, ["disabled", "is-active"]);
}
const gT = /* @__PURE__ */ ce(mT, [["render", _T]]), vT = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTEwIDQydi0zaDI4djNabTE0LThxLTUuMDUgMC04LjUyNS0zLjQ1UTEyIDI3LjEgMTIgMjIuMVY2aDR2MTYuMnEwIDMuMyAyLjMgNS41NVQyNCAzMHEzLjQgMCA1LjctMi4yNVEzMiAyNS41IDMyIDIyLjJWNmg0djE2LjFxMCA1LTMuNDc1IDguNDVRMjkuMDUgMzQgMjQgMzRaIi8+PC9zdmc+", yT = oe({
  mixins: [Li],
  emits: ["update"],
  data() {
    return {
      UnderlineSvg: vT
    };
  },
  computed: {
    isActive() {
      return this.path.split(Ot.separator).includes(Ot.underline);
    }
  },
  methods: {
    onButtonClick() {
      this.editor.hasFormat(Ot.underline) ? this.editor.removeUnderline() : this.editor.underline();
    }
  }
});
function bT(e, n, t, a, u, f) {
  const d = D("el-image"), m = D("button-component");
  return V(), X(m, {
    disabled: e.disabled,
    "is-active": e.isActive,
    onClick: n[0] || (n[0] = (g) => e.onButtonClick())
  }, {
    default: k(() => [
      z(d, { src: e.UnderlineSvg }, null, 8, ["src"])
    ]),
    _: 1
  }, 8, ["disabled", "is-active"]);
}
const wT = /* @__PURE__ */ ce(yT, [["render", bT]]), Np = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTYgNDJ2LTNoMzZ2M1ptMC04LjI1di0zaDIzLjZ2M1ptMC04LjI1di0zaDM2djNabTAtOC4yNXYtM2gyMy42djNaTTYgOVY2aDM2djNaIi8+PC9zdmc+", LT = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTYgNDJ2LTNoMzZ2M1ptOC4yLTguMjV2LTNoMTkuNjV2M1pNNiAyNS41di0zaDM2djNabTguMi04LjI1di0zaDE5LjY1djNaTTYgOVY2aDM2djNaIi8+PC9zdmc+", ST = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTYgNDJ2LTNoMzZ2M1ptMTIuNDUtOC4yNXYtM0g0MnYzWk02IDI1LjV2LTNoMzZ2M1ptMTIuNDUtOC4yNXYtM0g0MnYzWk02IDlWNmgzNnYzWiIvPjwvc3ZnPg==", CT = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTYgNDJ2LTNoMzZ2M1ptMC04LjI1di0zaDM2djNabTAtOC4yNXYtM2gzNnYzWm0wLTguMjV2LTNoMzZ2M1pNNiA5VjZoMzZ2M1oiLz48L3N2Zz4=";
function Pu(e) {
  return LL() ? (SL(e), !0) : !1;
}
function qi(e) {
  return typeof e == "function" ? e() : Er(e);
}
const _f = typeof window < "u", xu = () => {
}, jh = /* @__PURE__ */ MT();
function MT() {
  var e;
  return _f && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && /* @__PURE__ */ /iP(ad|hone|od)/.test(window.navigator.userAgent);
}
function TT(e, n) {
  function t(...a) {
    return new Promise((u, f) => {
      Promise.resolve(e(() => n.apply(this, a), { fn: n, thisArg: this, args: a })).then(u).catch(f);
    });
  }
  return t;
}
const d_ = (e) => e();
function ET(e = d_) {
  const n = Xt(!0);
  function t() {
    n.value = !1;
  }
  function a() {
    n.value = !0;
  }
  const u = (...f) => {
    n.value && e(...f);
  };
  return { isActive: Vm(n), pause: t, resume: a, eventFilter: u };
}
function gf(...e) {
  if (e.length !== 1)
    return CL(...e);
  const n = e[0];
  return typeof n == "function" ? Vm(ML(() => ({ get: n, set: xu }))) : Xt(n);
}
function AT(e, n = !0) {
  Su() ? Hm(e) : n ? e() : Cu(e);
}
function PT(e = !1, n = {}) {
  const {
    truthyValue: t = !0,
    falsyValue: a = !1
  } = n, u = af(e), f = Xt(e);
  function d(m) {
    if (arguments.length)
      return f.value = m, f.value;
    {
      const g = qi(t);
      return f.value = f.value === g ? qi(a) : g, f.value;
    }
  }
  return u ? d : [f, d];
}
var Ip = Object.getOwnPropertySymbols, xT = Object.prototype.hasOwnProperty, OT = Object.prototype.propertyIsEnumerable, NT = (e, n) => {
  var t = {};
  for (var a in e)
    xT.call(e, a) && n.indexOf(a) < 0 && (t[a] = e[a]);
  if (e != null && Ip)
    for (var a of Ip(e))
      n.indexOf(a) < 0 && OT.call(e, a) && (t[a] = e[a]);
  return t;
};
function IT(e, n, t = {}) {
  const a = t, {
    eventFilter: u = d_
  } = a, f = NT(a, [
    "eventFilter"
  ]);
  return xr(
    e,
    TT(
      u,
      n
    ),
    f
  );
}
var kT = Object.defineProperty, DT = Object.defineProperties, $T = Object.getOwnPropertyDescriptors, pu = Object.getOwnPropertySymbols, p_ = Object.prototype.hasOwnProperty, m_ = Object.prototype.propertyIsEnumerable, kp = (e, n, t) => n in e ? kT(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, RT = (e, n) => {
  for (var t in n || (n = {}))
    p_.call(n, t) && kp(e, t, n[t]);
  if (pu)
    for (var t of pu(n))
      m_.call(n, t) && kp(e, t, n[t]);
  return e;
}, zT = (e, n) => DT(e, $T(n)), BT = (e, n) => {
  var t = {};
  for (var a in e)
    p_.call(e, a) && n.indexOf(a) < 0 && (t[a] = e[a]);
  if (e != null && pu)
    for (var a of pu(e))
      n.indexOf(a) < 0 && m_.call(e, a) && (t[a] = e[a]);
  return t;
};
function FT(e, n, t = {}) {
  const a = t, {
    eventFilter: u
  } = a, f = BT(a, [
    "eventFilter"
  ]), { eventFilter: d, pause: m, resume: g, isActive: y } = ET(u);
  return { stop: IT(
    e,
    n,
    zT(RT({}, f), {
      eventFilter: d
    })
  ), pause: m, resume: g, isActive: y };
}
function hs(e) {
  var n;
  const t = qi(e);
  return (n = t == null ? void 0 : t.$el) != null ? n : t;
}
const _s = _f ? window : void 0;
function Pa(...e) {
  let n, t, a, u;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([t, a, u] = e, n = _s) : [n, t, a, u] = e, !n)
    return xu;
  Array.isArray(t) || (t = [t]), Array.isArray(a) || (a = [a]);
  const f = [], d = () => {
    f.forEach((w) => w()), f.length = 0;
  }, m = (w, h, b, T) => (w.addEventListener(h, b, T), () => w.removeEventListener(h, b, T)), g = xr(
    () => [hs(n), qi(u)],
    ([w, h]) => {
      d(), w && f.push(
        ...t.flatMap((b) => a.map((T) => m(w, b, T, h)))
      );
    },
    { immediate: !0, flush: "post" }
  ), y = () => {
    g(), d();
  };
  return Pu(y), y;
}
let Dp = !1;
function UT(e, n, t = {}) {
  const { window: a = _s, ignore: u = [], capture: f = !0, detectIframe: d = !1 } = t;
  if (!a)
    return;
  jh && !Dp && (Dp = !0, Array.from(a.document.body.children).forEach((b) => b.addEventListener("click", xu)));
  let m = !0;
  const g = (b) => u.some((T) => {
    if (typeof T == "string")
      return Array.from(a.document.querySelectorAll(T)).some((A) => A === b.target || b.composedPath().includes(A));
    {
      const A = hs(T);
      return A && (b.target === A || b.composedPath().includes(A));
    }
  }), w = [
    Pa(a, "click", (b) => {
      const T = hs(e);
      if (!(!T || T === b.target || b.composedPath().includes(T))) {
        if (b.detail === 0 && (m = !g(b)), !m) {
          m = !0;
          return;
        }
        n(b);
      }
    }, { passive: !0, capture: f }),
    Pa(a, "pointerdown", (b) => {
      const T = hs(e);
      T && (m = !b.composedPath().includes(T) && !g(b));
    }, { passive: !0 }),
    d && Pa(a, "blur", (b) => {
      setTimeout(() => {
        var T;
        const A = hs(e);
        ((T = a.document.activeElement) == null ? void 0 : T.tagName) === "IFRAME" && !(A != null && A.contains(a.document.activeElement)) && n(b);
      }, 0);
    })
  ].filter(Boolean);
  return () => w.forEach((b) => b());
}
function VT() {
  const e = Xt(!1);
  return Su() && Hm(() => {
    e.value = !0;
  }), e;
}
function HT(e) {
  const n = VT();
  return mt(() => (n.value, !!e()));
}
function jT(e, n = {}) {
  const { window: t = _s } = n, a = HT(() => t && "matchMedia" in t && typeof t.matchMedia == "function");
  let u;
  const f = Xt(!1), d = () => {
    u && ("removeEventListener" in u ? u.removeEventListener("change", m) : u.removeListener(m));
  }, m = () => {
    a.value && (d(), u = t.matchMedia(gf(e).value), f.value = !!(u != null && u.matches), u && ("addEventListener" in u ? u.addEventListener("change", m) : u.addListener(m)));
  };
  return EL(m), Pu(() => d()), f;
}
const ql = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Kl = "__vueuse_ssr_handlers__", ZT = /* @__PURE__ */ WT();
function WT() {
  return Kl in ql || (ql[Kl] = ql[Kl] || {}), ql[Kl];
}
function __(e, n) {
  return ZT[e] || n;
}
function GT(e) {
  return e == null ? "any" : e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof Date ? "date" : typeof e == "boolean" ? "boolean" : typeof e == "string" ? "string" : typeof e == "object" ? "object" : Number.isNaN(e) ? "any" : "number";
}
var qT = Object.defineProperty, $p = Object.getOwnPropertySymbols, KT = Object.prototype.hasOwnProperty, YT = Object.prototype.propertyIsEnumerable, Rp = (e, n, t) => n in e ? qT(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, zp = (e, n) => {
  for (var t in n || (n = {}))
    KT.call(n, t) && Rp(e, t, n[t]);
  if ($p)
    for (var t of $p(n))
      YT.call(n, t) && Rp(e, t, n[t]);
  return e;
};
const QT = {
  boolean: {
    read: (e) => e === "true",
    write: (e) => String(e)
  },
  object: {
    read: (e) => JSON.parse(e),
    write: (e) => JSON.stringify(e)
  },
  number: {
    read: (e) => Number.parseFloat(e),
    write: (e) => String(e)
  },
  any: {
    read: (e) => e,
    write: (e) => String(e)
  },
  string: {
    read: (e) => e,
    write: (e) => String(e)
  },
  map: {
    read: (e) => new Map(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e.entries()))
  },
  set: {
    read: (e) => new Set(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e))
  },
  date: {
    read: (e) => new Date(e),
    write: (e) => e.toISOString()
  }
}, Bp = "vueuse-storage";
function JT(e, n, t, a = {}) {
  var u;
  const {
    flush: f = "pre",
    deep: d = !0,
    listenToStorageChanges: m = !0,
    writeDefaults: g = !0,
    mergeDefaults: y = !1,
    shallow: w,
    window: h = _s,
    eventFilter: b,
    onError: T = (ge) => {
      console.error(ge);
    }
  } = a, A = (w ? TL : Xt)(n);
  if (!t)
    try {
      t = __("getDefaultStorage", () => {
        var ge;
        return (ge = _s) == null ? void 0 : ge.localStorage;
      })();
    } catch (ge) {
      T(ge);
    }
  if (!t)
    return A;
  const x = qi(n), Z = GT(x), H = (u = a.serializer) != null ? u : QT[Z], { pause: Y, resume: ee } = FT(
    A,
    () => re(A.value),
    { flush: f, deep: d, eventFilter: b }
  );
  return h && m && (Pa(h, "storage", Fe), Pa(h, Bp, Xe)), Fe(), A;
  function re(ge) {
    try {
      if (ge == null)
        t.removeItem(e);
      else {
        const qe = H.write(ge), at = t.getItem(e);
        at !== qe && (t.setItem(e, qe), h && h.dispatchEvent(new CustomEvent(Bp, {
          detail: {
            key: e,
            oldValue: at,
            newValue: qe,
            storageArea: t
          }
        })));
      }
    } catch (qe) {
      T(qe);
    }
  }
  function be(ge) {
    const qe = ge ? ge.newValue : t.getItem(e);
    if (qe == null)
      return g && x !== null && t.setItem(e, H.write(x)), x;
    if (!ge && y) {
      const at = H.read(qe);
      return typeof y == "function" ? y(at, x) : Z === "object" && !Array.isArray(at) ? zp(zp({}, x), at) : at;
    } else
      return typeof qe != "string" ? qe : H.read(qe);
  }
  function Xe(ge) {
    Fe(ge.detail);
  }
  function Fe(ge) {
    if (!(ge && ge.storageArea !== t)) {
      if (ge && ge.key == null) {
        A.value = x;
        return;
      }
      if (!(ge && ge.key !== e)) {
        Y();
        try {
          A.value = be(ge);
        } catch (qe) {
          T(qe);
        } finally {
          ge ? Cu(ee) : ee();
        }
      }
    }
  }
}
function XT(e) {
  return jT("(prefers-color-scheme: dark)", e);
}
var eE = Object.defineProperty, Fp = Object.getOwnPropertySymbols, tE = Object.prototype.hasOwnProperty, nE = Object.prototype.propertyIsEnumerable, Up = (e, n, t) => n in e ? eE(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, iE = (e, n) => {
  for (var t in n || (n = {}))
    tE.call(n, t) && Up(e, t, n[t]);
  if (Fp)
    for (var t of Fp(n))
      nE.call(n, t) && Up(e, t, n[t]);
  return e;
};
function rE(e = {}) {
  const {
    selector: n = "html",
    attribute: t = "class",
    initialValue: a = "auto",
    window: u = _s,
    storage: f,
    storageKey: d = "vueuse-color-scheme",
    listenToStorageChanges: m = !0,
    storageRef: g,
    emitAuto: y,
    disableTransition: w = !0
  } = e, h = iE({
    auto: "",
    light: "light",
    dark: "dark"
  }, e.modes || {}), b = XT({ window: u }), T = mt(() => b.value ? "dark" : "light"), A = g || (d == null ? gf(a) : JT(d, a, f, { window: u, listenToStorageChanges: m })), x = mt(
    () => A.value === "auto" ? T.value : A.value
  ), Z = __(
    "updateHTMLAttrs",
    (re, be, Xe) => {
      const Fe = typeof re == "string" ? u == null ? void 0 : u.document.querySelector(re) : hs(re);
      if (!Fe)
        return;
      let ge;
      if (w) {
        ge = u.document.createElement("style");
        const qe = "*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
        ge.appendChild(document.createTextNode(qe)), u.document.head.appendChild(ge);
      }
      if (be === "class") {
        const qe = Xe.split(/\s/g);
        Object.values(h).flatMap((at) => (at || "").split(/\s/g)).filter(Boolean).forEach((at) => {
          qe.includes(at) ? Fe.classList.add(at) : Fe.classList.remove(at);
        });
      } else
        Fe.setAttribute(be, Xe);
      w && (u.getComputedStyle(ge).opacity, document.head.removeChild(ge));
    }
  );
  function H(re) {
    var be;
    Z(n, t, (be = h[re]) != null ? be : re);
  }
  function Y(re) {
    e.onChanged ? e.onChanged(re, H) : H(re);
  }
  xr(x, Y, { flush: "post", immediate: !0 }), AT(() => Y(x.value));
  const ee = mt({
    get() {
      return y ? A.value : x.value;
    },
    set(re) {
      A.value = re;
    }
  });
  try {
    return Object.assign(ee, { store: A, system: T, state: x });
  } catch {
    return ee;
  }
}
var oE = Object.defineProperty, sE = Object.defineProperties, aE = Object.getOwnPropertyDescriptors, Vp = Object.getOwnPropertySymbols, lE = Object.prototype.hasOwnProperty, uE = Object.prototype.propertyIsEnumerable, Hp = (e, n, t) => n in e ? oE(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, cE = (e, n) => {
  for (var t in n || (n = {}))
    lE.call(n, t) && Hp(e, t, n[t]);
  if (Vp)
    for (var t of Vp(n))
      uE.call(n, t) && Hp(e, t, n[t]);
  return e;
}, hE = (e, n) => sE(e, aE(n));
function fE(e = {}) {
  const {
    valueDark: n = "dark",
    valueLight: t = ""
  } = e, a = rE(hE(cE({}, e), {
    onChanged: (f, d) => {
      var m;
      e.onChanged ? (m = e.onChanged) == null || m.call(e, f === "dark", d, f) : d(f);
    },
    modes: {
      dark: n,
      light: t
    }
  }));
  return mt({
    get() {
      return a.value === "dark";
    },
    set(f) {
      const d = f ? "dark" : "light";
      a.system.value === d ? a.value = "auto" : a.value = d;
    }
  });
}
const g_ = /* @__PURE__ */ oe({
  name: "OnClickOutside",
  props: ["as", "options"],
  emits: ["trigger"],
  setup(e, { slots: n, emit: t }) {
    const a = Xt();
    return UT(a, (u) => {
      t("trigger", u);
    }, e.options), () => {
      if (n.default)
        return ss(e.as || "div", { ref: a }, n.default());
    };
  }
});
function dE(e) {
  var n;
  const t = qi(e);
  return (n = t == null ? void 0 : t.$el) != null ? n : t;
}
const pE = _f ? window : void 0;
function mE(...e) {
  let n, t, a, u;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([t, a, u] = e, n = pE) : [n, t, a, u] = e, !n)
    return xu;
  Array.isArray(t) || (t = [t]), Array.isArray(a) || (a = [a]);
  const f = [], d = () => {
    f.forEach((w) => w()), f.length = 0;
  }, m = (w, h, b, T) => (w.addEventListener(h, b, T), () => w.removeEventListener(h, b, T)), g = xr(
    () => [dE(n), qi(u)],
    ([w, h]) => {
      d(), w && f.push(
        ...t.flatMap((b) => a.map((T) => m(w, b, T, h)))
      );
    },
    { immediate: !0, flush: "post" }
  ), y = () => {
    g(), d();
  };
  return Pu(y), y;
}
const v_ = /* @__PURE__ */ oe({
  name: "UseDark",
  props: ["selector", "attribute", "valueDark", "valueLight", "onChanged", "storageKey", "storage"],
  setup(e, { slots: n }) {
    const t = fE(e), a = lf({
      isDark: t,
      toggleDark: PT(t)
    });
    return () => {
      if (n.default)
        return n.default(a);
    };
  }
});
function y_(e) {
  const n = window.getComputedStyle(e);
  if (n.overflowX === "scroll" || n.overflowY === "scroll" || n.overflowX === "auto" && e.clientWidth < e.scrollWidth || n.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const t = e.parentNode;
    return !t || t.tagName === "BODY" ? !1 : y_(t);
  }
}
function _E(e) {
  const n = e || window.event, t = n.target;
  return y_(t) ? !1 : n.touches.length > 1 ? !0 : (n.preventDefault && n.preventDefault(), !1);
}
function gE(e, n = !1) {
  const t = Xt(n);
  let a = null, u;
  xr(gf(e), (m) => {
    if (m) {
      const g = m;
      u = g.style.overflow, t.value && (g.style.overflow = "hidden");
    }
  }, {
    immediate: !0
  });
  const f = () => {
    const m = qi(e);
    !m || t.value || (jh && (a = mE(
      m,
      "touchmove",
      (g) => {
        _E(g);
      },
      { passive: !1 }
    )), m.style.overflow = "hidden", t.value = !0);
  }, d = () => {
    const m = qi(e);
    !m || !t.value || (jh && (a == null || a()), m.style.overflow = u, t.value = !1);
  };
  return Pu(d), mt({
    get() {
      return t.value;
    },
    set(m) {
      m ? f() : d();
    }
  });
}
function vE() {
  let e = !1;
  const n = Xt(!1);
  return (t, a) => {
    if (n.value = a.value, e)
      return;
    e = !0;
    const u = gE(t, a.value);
    xr(n, (f) => u.value = f);
  };
}
vE();
const yE = oe({
  props: {
    visible: {
      type: Boolean
    },
    width: {
      type: String,
      default: "400px"
    }
  },
  methods: {
    hide() {
      this.$emit("visible", !1);
    }
  },
  components: {
    OnClickOutside: g_
  }
}), bE = "_component__confirm_1qlyr_1", wE = {
  component__confirm: bE
};
function LE(e, n, t, a, u, f) {
  const d = D("on-click-outside"), m = D("el-popover");
  return V(), X(m, {
    "popper-class": e.$style.component,
    visible: e.visible,
    width: e.width
  }, {
    reference: k(() => [
      Ke(e.$slots, "reference")
    ]),
    default: k(() => [
      z(d, { onTrigger: e.hide }, {
        default: k(() => [
          Ke(e.$slots, "content"),
          ae("div", {
            class: J(e.$style.component__confirm)
          }, [
            Ke(e.$slots, "confirm")
          ], 2)
        ]),
        _: 3
      }, 8, ["onTrigger"])
    ]),
    _: 3
  }, 8, ["popper-class", "visible", "width"]);
}
const SE = {
  $style: wE
}, Ou = /* @__PURE__ */ ce(yE, [["render", LE], ["__cssModules", SE]]), Yl = {
  left: "left",
  center: "center",
  right: "right",
  justify: "justify"
}, Ql = {
  alignLeft: "align-left",
  alignCenter: "align-center",
  alignRight: "align-right",
  alignJustify: "align-justify"
}, CE = oe({
  mixins: [Li],
  data() {
    return {
      visible: !1,
      selection: null,
      AlignLeftSvg: Np,
      dropdown: [{
        type: Yl.left,
        class: Ql.alignLeft,
        image: Np
      }, {
        type: Yl.center,
        class: Ql.alignCenter,
        image: LT
      }, {
        type: Yl.right,
        class: Ql.alignRight,
        image: ST
      }, {
        type: Yl.justify,
        class: Ql.alignJustify,
        image: CT
      }]
    };
  },
  methods: {
    isActive(e) {
      return this.path.includes(e);
    },
    setTextAlignment(e) {
      this.selection = this.editor.getSelection(), this.path.includes(e) ? this.editor.setTextAlignment(null) : this.editor.setTextAlignment(e), this.setVisible(!1), this.$nextTick(() => {
        this.editor.focus(), this.editor.setSelection(this.selection);
      });
    },
    setVisible(e) {
      this.visible = e;
    },
    onReferenceClick() {
      this.setVisible(!0);
    }
  },
  components: {
    PopoverComponent: Ou
  }
}), ME = "_content_ydego_1", TE = {
  content: ME
};
function EE(e, n, t, a, u, f) {
  const d = D("el-image"), m = D("button-component"), g = D("icon-arrow-down"), y = D("el-icon"), w = D("popover-component");
  return V(), X(w, {
    visible: e.visible,
    width: "auto",
    onVisible: e.setVisible
  }, {
    content: k(() => [
      ae("div", {
        class: J(e.$style.content)
      }, [
        (V(!0), ue(st, null, Et(e.dropdown, (h, b) => (V(), X(m, {
          key: b,
          "is-active": e.isActive(h.class),
          disabled: e.disabled,
          onClick: (T) => e.setTextAlignment(h.type)
        }, {
          default: k(() => [
            z(d, {
              src: h.image
            }, null, 8, ["src"])
          ]),
          _: 2
        }, 1032, ["is-active", "disabled", "onClick"]))), 128))
      ], 2)
    ]),
    reference: k(() => [
      z(m, {
        disabled: e.disabled,
        onClick: e.onReferenceClick
      }, {
        default: k(() => [
          z(d, { src: e.AlignLeftSvg }, null, 8, ["src"]),
          z(y, { size: "12" }, {
            default: k(() => [
              z(g)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["visible", "onVisible"]);
}
const AE = {
  $style: TE
}, PE = /* @__PURE__ */ ce(CE, [["render", EE], ["__cssModules", AE]]), xE = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTguNTUgMzlxLTEuMDUgMC0xLjgtLjcyNVQ2IDM2LjU1cTAtMS4wNS43NS0xLjh0MS44LS43NXExIDAgMS43MjUuNzUuNzI1Ljc1LjcyNSAxLjggMCAxLS43MjUgMS43MjVROS41NSAzOSA4LjU1IDM5Wk0xNiAzOHYtM2gyNnYzWk04LjU1IDI2LjVxLTEuMDUgMC0xLjgtLjcyNVQ2IDI0cTAtMS4wNS43NS0xLjc3NS43NS0uNzI1IDEuOC0uNzI1IDEgMCAxLjcyNS43NVExMSAyMyAxMSAyNHQtLjcyNSAxLjc1cS0uNzI1Ljc1LTEuNzI1Ljc1Wm03LjQ1LTF2LTNoMjZ2M1pNOC41IDE0cS0xLjA1IDAtMS43NzUtLjcyNVE2IDEyLjU1IDYgMTEuNXEwLTEuMDUuNzI1LTEuNzc1UTcuNDUgOSA4LjUgOXExLjA1IDAgMS43NzUuNzI1UTExIDEwLjQ1IDExIDExLjVxMCAxLjA1LS43MjUgMS43NzVROS41NSAxNCA4LjUgMTRabTcuNS0xdi0zaDI2djNaIi8+PC9zdmc+", OE = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTYgNDB2LTEuN2g0LjJWMzdIOC4xdi0xLjdoMi4xVjM0SDZ2LTEuN2g1LjlWNDBabTEwLjQ1LTIuNDV2LTNINDJ2M1pNNiAyNy44NXYtMS42bDMuNzUtNC40SDZ2LTEuN2g1Ljl2MS42bC0zLjggNC40aDMuOHYxLjdabTEwLjQ1LTIuNDV2LTNINDJ2M1pNOC4xIDE1LjhWOS43SDZWOGgzLjh2Ny44Wm04LjM1LTIuNTV2LTNINDJ2M1oiLz48L3N2Zz4=", NE = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTYgNDJ2LTNoMzZ2M1ptMC0xMS4xNXYtMTMuOGw3LjA1IDYuOFpNNiA5VjZoMzZ2M1ptMTYuNjUgMjQuNzV2LTNINDJ2M1ptMC04LjI1di0zSDQydjNabTAtOC4yNXYtM0g0MnYzWiIvPjwvc3ZnPg==", IE = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTYgNDJ2LTNoMzZ2M1ptMTYuNjUtOC4yNXYtM0g0MnYzWm0tOS40LTIuOS03LjA1LTcgNy4wNS02LjhabTkuNC01LjM1di0zSDQydjNabTAtOC4yNXYtM0g0MnYzWk02IDlWNmgzNnYzWiIvPjwvc3ZnPg==", kE = oe({
  mixins: [Li],
  data() {
    return {
      ListBulletedSvg: xE,
      ListNumberedSvg: OE,
      IndentIncreaseSvg: NE,
      IndentDecreaseSvg: IE
    };
  },
  computed: {
    isActiveUnorderedList() {
      return this.path.split(Ot.separator).includes(Ot.unorderedList);
    },
    isActiveOrderedList() {
      return this.path.split(Ot.separator).includes(Ot.orderedList);
    }
  },
  methods: {
    makeUnorderedList() {
      this.isActiveUnorderedList ? this.editor.removeList() : this.editor.makeUnorderedList();
    },
    makeOrderedList() {
      this.isActiveOrderedList ? this.editor.removeList() : this.editor.makeOrderedList();
    },
    increaseListLevel() {
      this.editor.increaseListLevel();
    },
    decreaseListLevel() {
      this.editor.decreaseListLevel();
    }
  }
});
function DE(e, n, t, a, u, f) {
  const d = D("el-image"), m = D("button-component");
  return V(), ue(st, null, [
    z(m, {
      disabled: e.disabled,
      "is-active": e.isActiveUnorderedList,
      onClick: e.makeUnorderedList
    }, {
      default: k(() => [
        z(d, { src: e.ListBulletedSvg }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["disabled", "is-active", "onClick"]),
    z(m, {
      disabled: e.disabled,
      "is-active": e.isActiveOrderedList,
      onClick: e.makeOrderedList
    }, {
      default: k(() => [
        z(d, { src: e.ListNumberedSvg }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["disabled", "is-active", "onClick"]),
    z(m, {
      disabled: e.disabled,
      onClick: e.increaseListLevel
    }, {
      default: k(() => [
        z(d, { src: e.IndentIncreaseSvg }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["disabled", "onClick"]),
    z(m, {
      disabled: e.disabled,
      onClick: e.decreaseListLevel
    }, {
      default: k(() => [
        z(d, { src: e.IndentDecreaseSvg }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["disabled", "onClick"])
  ], 64);
}
const $E = /* @__PURE__ */ ce(kE, [["render", DE]]), RE = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQwIDQwIiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiPgoJPHRpdGxlPmZvcm1hdF9jb2xvcl90ZXh0X0ZJTEwwX3dnaHQ0MDBfR1JBRDBfb3BzejQ4LXN2ZzwvdGl0bGU+Cgk8c3R5bGU+CgkJLnMwIHsgZmlsbDogIzAwMDAwMCB9IAoJPC9zdHlsZT4KCTxwYXRoIGlkPSJMYXllciIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGFzcz0iczAiIGQ9Im0wLjUgNDh2LTdoMzl2N3ptNi41LTE0bDExLTI4aDRsMTEgMjhoLTMuOGwtMi44LTcuNWgtMTIuOGwtMi44IDcuNXptNy44LTEwLjdoMTAuNGwtNS4xLTEzLjZoLTAuMnoiLz4KPC9zdmc+", zE = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQwIDQwIiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiPgoJPHRpdGxlPmZvcm1hdF9jb2xvcl9maWxsX0ZJTEwwX3dnaHQ0MDBfR1JBRDBfb3BzejQ4LXN2ZzwvdGl0bGU+Cgk8c3R5bGU+CgkJLnMwIHsgZmlsbDogIzAwMDAwMCB9IAoJPC9zdHlsZT4KCTxwYXRoIGlkPSJMYXllciIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGFzcz0iczAiIGQ9Im04LjggMi4xbDIuMS0yLjEgMTcuNCAxNy40cTEuMSAxLjEgMS4xIDIuOCAwIDEuNy0xLjEgMi44bC04LjkgOC45cS0xLjEgMS4yLTIuNyAxLjItMS41IDAtMi43LTEuMmwtOC45LTguOXEtMS4xLTEuMS0xLjEtMi44IDAtMS43IDEuMS0yLjhsOS41LTkuNHptNy45IDcuOWwtOS45IDkuOWgxOS44em0xNi45IDIzLjlxLTEuNSAwLTIuNS0xLTEtMS4xLTEtMi42IDAtMC45IDAuMy0xLjkgMC40LTEgMS4yLTIgMC4zLTAuNyAwLjktMS40IDAuNi0wLjggMS4yLTEuNCAwLjUgMC42IDEuMSAxLjQgMC41IDAuNyAxIDEuNCAwLjcgMSAxLjEgMiAwLjQgMSAwLjQgMS45IDAgMS41LTEuMSAyLjUtMSAxLjEtMi42IDEuMXptLTMzLjUgMTQuMXYtNi4xaDQwdjYuMXoiLz4KPC9zdmc+", jp = "#0F3D45", BE = oe({
  mixins: [Li],
  data() {
    return {
      ColorTextSvg: RE,
      ColorFillSvg: zE,
      color: null,
      textColor: jp,
      highlightColor: jp
    };
  },
  methods: {
    setTextColor() {
      this.editor.setTextColor(this.textColor);
    },
    setHighlightColor() {
      this.editor.setHighlightColor(this.highlightColor);
    }
  },
  watch: {
    textColor() {
      this.setTextColor();
    },
    highlightColor() {
      this.setHighlightColor();
    }
  }
}), FE = "_component_mv3ll_1", UE = "_picker_mv3ll_39", VE = "_disabled_mv3ll_43", HE = "_image_mv3ll_49", jE = {
  component: FE,
  picker: UE,
  disabled: VE,
  image: HE
};
function ZE(e, n, t, a, u, f) {
  const d = D("el-image"), m = D("button-component"), g = D("el-color-picker");
  return V(), ue("div", {
    class: J(e.$style.component)
  }, [
    z(m, {
      disabled: e.disabled,
      onClick: e.setTextColor
    }, {
      default: k(() => [
        z(d, {
          src: e.ColorTextSvg,
          class: J(e.$style.image),
          style: lu({ borderBottomColor: e.textColor })
        }, null, 8, ["src", "class", "style"])
      ]),
      _: 1
    }, 8, ["disabled", "onClick"]),
    z(g, {
      modelValue: e.textColor,
      "onUpdate:modelValue": n[0] || (n[0] = (y) => e.textColor = y),
      "popper-class": e.$style.picker,
      disabled: e.disabled
    }, null, 8, ["modelValue", "popper-class", "disabled"]),
    z(m, {
      disabled: e.disabled,
      onClick: e.setHighlightColor
    }, {
      default: k(() => [
        z(d, {
          src: e.ColorFillSvg,
          class: J(e.$style.image),
          style: lu({ borderBottomColor: e.highlightColor })
        }, null, 8, ["src", "class", "style"])
      ]),
      _: 1
    }, 8, ["disabled", "onClick"]),
    z(g, {
      modelValue: e.highlightColor,
      "onUpdate:modelValue": n[1] || (n[1] = (y) => e.highlightColor = y),
      "popper-class": e.$style.picker,
      disabled: e.disabled
    }, null, 8, ["modelValue", "popper-class", "disabled"])
  ], 2);
}
const WE = {
  $style: jE
}, GE = /* @__PURE__ */ ce(BE, [["render", ZE], ["__cssModules", WE]]), qE = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTIyLjUgMzRIMTRxLTQuMTUgMC03LjA3NS0yLjkyNVQ0IDI0cTAtNC4xNSAyLjkyNS03LjA3NVQxNCAxNGg4LjV2M0gxNHEtMi45IDAtNC45NSAyLjA1UTcgMjEuMSA3IDI0cTAgMi45IDIuMDUgNC45NVExMS4xIDMxIDE0IDMxaDguNVptLTYuMjUtOC41di0zaDE1LjV2M1pNMjUuNSAzNHYtM0gzNHEyLjkgMCA0Ljk1LTIuMDVRNDEgMjYuOSA0MSAyNHEwLTIuOS0yLjA1LTQuOTVRMzYuOSAxNyAzNCAxN2gtOC41di0zSDM0cTQuMTUgMCA3LjA3NSAyLjkyNVQ0NCAyNHEwIDQuMTUtMi45MjUgNy4wNzVUMzQgMzRaIi8+PC9zdmc+", KE = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTM3LjUgMzMuNDUgMzUuMDUgMzFxMi41NS0uNSA0LjI1LTIuNCAxLjctMS45IDEuNy00LjQ1IDAtMi45LTIuMDUtNC45NS0yLjA1LTIuMDUtNC45NS0yLjA1aC03Ljc1di0zSDM0cTQuMTUgMCA3LjA3NSAyLjkyNVQ0NCAyNC4xNXEwIDMuMS0xLjggNS42LTEuOCAyLjUtNC43IDMuN1ptLTcuOC03LjgtMy0zaDUuMDV2M1ptMTEgMTkuNTVMMy4xNSA3LjY1IDUuMyA1LjVsMzcuNTUgMzcuNTVaTTIyLjUgMzRIMTRxLTQuMTUgMC03LjA3NS0yLjkyNVQ0IDI0cTAtMy42IDIuMjI1LTYuMzVROC40NSAxNC45IDExLjkgMTQuMmwyLjggMi44SDE0cS0yLjkgMC00Ljk1IDIuMDVRNyAyMS4xIDcgMjRxMCAyLjkgMi4wNSA0Ljk1UTExLjEgMzEgMTQgMzFoOC41Wm0tNi4yNS04LjV2LTNoMy45NWwzIDNaIi8+PC9zdmc+", Zp = {
  self: "_self",
  blank: "_blank"
}, YE = oe({
  mixins: [Li],
  data() {
    return {
      TARGET: Zp,
      LinkSvg: qE,
      LinkOffSvg: KE,
      visible: !1,
      href: null,
      target: Zp.self
    };
  },
  computed: {
    isActive() {
      return this.path.split(Ot.separator).includes(Ot.link);
    }
  },
  methods: {
    setVisible(e) {
      this.visible = e;
    },
    makeLink() {
      this.href && this.editor.makeLink(this.href, {
        target: this.target
      }), this.setVisible(!1), this.href = null;
    },
    onReferenceClick() {
      this.editor.hasFormat(Ot.link) ? this.editor.removeLink() : this.setVisible(!0);
    }
  },
  components: {
    PopoverComponent: Ou
  }
}), QE = /* @__PURE__ */ ae("span", null, "OK", -1);
function JE(e, n, t, a, u, f) {
  const d = D("el-input"), m = D("el-form-item"), g = D("el-option"), y = D("el-select"), w = D("el-form"), h = D("el-button"), b = D("el-image"), T = D("button-component"), A = D("popover-component");
  return V(), X(A, {
    visible: e.visible,
    width: "400px",
    onVisible: e.setVisible
  }, {
    content: k(() => [
      z(w, null, {
        default: k(() => [
          z(m, { size: "default" }, {
            default: k(() => [
              z(d, {
                modelValue: e.href,
                "onUpdate:modelValue": n[0] || (n[0] = (x) => e.href = x),
                placeholder: "Source",
                size: "default"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          z(m, { size: "default" }, {
            default: k(() => [
              z(y, {
                modelValue: e.target,
                "onUpdate:modelValue": n[3] || (n[3] = (x) => e.target = x),
                teleported: !1,
                placeholder: "Target",
                size: "default"
              }, {
                default: k(() => [
                  z(g, {
                    value: e.TARGET.self,
                    label: "Current window",
                    onClick: n[1] || (n[1] = fo(() => {
                    }, ["stop"]))
                  }, null, 8, ["value"]),
                  z(g, {
                    value: e.TARGET.blank,
                    label: "New window",
                    onClick: n[2] || (n[2] = fo(() => {
                    }, ["stop"]))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    confirm: k(() => [
      z(h, {
        size: "small",
        onClick: e.makeLink
      }, {
        default: k(() => [
          QE
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    reference: k(() => [
      z(T, {
        disabled: e.disabled,
        onClick: e.onReferenceClick
      }, {
        default: k(() => [
          z(b, {
            src: e.isActive ? e.LinkOffSvg : e.LinkSvg
          }, null, 8, ["src"])
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["visible", "onVisible"]);
}
const XE = /* @__PURE__ */ ce(YE, [["render", JE]]), eA = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTkgNDJxLTEuMiAwLTIuMS0uOVE2IDQwLjIgNiAzOVY5cTAtMS4yLjktMi4xUTcuOCA2IDkgNmgzMHExLjIgMCAyLjEuOS45LjkuOSAyLjF2MzBxMCAxLjItLjkgMi4xLS45LjktMi4xLjlabTAtM2gzMFY5SDl2MzBabTIuOC00Ljg1aDI0LjQ1bC03LjM1LTkuOC02LjYgOC41NS00LjY1LTYuMzVaTTkgMzlWOXYzMFoiLz48L3N2Zz4=", tA = oe({
  mixins: [Li],
  data() {
    return {
      ImageSvg: eA,
      visible: !1,
      src: null,
      alt: null,
      width: null,
      height: null
    };
  },
  methods: {
    setVisible(e) {
      this.visible = e;
    },
    insertImage() {
      this.src && this.editor.insertImage(this.src, {
        alt: this.alt,
        width: this.width,
        height: this.height
      }), this.setVisible(!1), this.src = null, this.alt = null, this.width = null, this.height = null;
    },
    onReferenceClick() {
      this.setVisible(!0);
    }
  },
  components: {
    PopoverComponent: Ou
  }
}), nA = /* @__PURE__ */ ae("span", null, "OK", -1);
function iA(e, n, t, a, u, f) {
  const d = D("el-input"), m = D("el-form-item"), g = D("el-col"), y = D("el-row"), w = D("el-form"), h = D("el-button"), b = D("el-image"), T = D("button-component"), A = D("popover-component");
  return V(), X(A, {
    visible: e.visible,
    width: "400px",
    onVisible: e.setVisible
  }, {
    content: k(() => [
      z(w, null, {
        default: k(() => [
          z(m, { size: "default" }, {
            default: k(() => [
              z(d, {
                modelValue: e.src,
                "onUpdate:modelValue": n[0] || (n[0] = (x) => e.src = x),
                placeholder: "Source",
                size: "default"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          z(m, { size: "default" }, {
            default: k(() => [
              z(d, {
                modelValue: e.alt,
                "onUpdate:modelValue": n[1] || (n[1] = (x) => e.alt = x),
                placeholder: "Description",
                size: "default"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          z(m, { size: "default" }, {
            default: k(() => [
              z(y, { gutter: 24 }, {
                default: k(() => [
                  z(g, { span: 12 }, {
                    default: k(() => [
                      z(d, {
                        modelValue: e.width,
                        "onUpdate:modelValue": n[2] || (n[2] = (x) => e.width = x),
                        size: "default",
                        placeholder: "Width"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  z(g, { span: 12 }, {
                    default: k(() => [
                      z(d, {
                        modelValue: e.height,
                        "onUpdate:modelValue": n[3] || (n[3] = (x) => e.height = x),
                        size: "default",
                        placeholder: "Height"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    confirm: k(() => [
      z(h, {
        size: "small",
        onClick: e.insertImage
      }, {
        default: k(() => [
          nA
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    reference: k(() => [
      z(T, {
        disabled: e.disabled,
        onClick: e.onReferenceClick
      }, {
        default: k(() => [
          z(b, { src: e.ImageSvg }, null, 8, ["src"])
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["visible", "onVisible"]);
}
const rA = /* @__PURE__ */ ce(tA, [["render", iA]]), oA = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTAgMzBWMThoMi40djQuNDVoNS40VjE4aDIuNHYxMkg3Ljh2LTUuMTVIMi40VjMwWm0xNS44IDB2LTkuNmgtMy41VjE4aDkuNHYyLjRoLTMuNVYzMFptOCAwVjE5LjdxMC0uNzUuNDc1LTEuMjI1UTI0Ljc1IDE4IDI1LjUgMThoMTBxLjc1IDAgMS4yMjUuNDc1LjQ3NS40NzUuNDc1IDEuMjI1VjMwaC0yLjR2LTkuNmgtMy4xdjcuNWgtMi40di03LjVoLTMuMVYzMFptMTYuMyAwVjE4aDIuNHY5LjZINDhWMzBaIi8+PC9zdmc+", sA = oe({
  mixins: [Li],
  data() {
    return {
      HtmlSvg: oA,
      visible: !1,
      html: null
    };
  },
  methods: {
    setVisible(e) {
      this.visible = e;
    },
    setHTML() {
      this.editor.setHTML(this.html), this.setVisible(!1), this.$emit("update", this.html), this.editor.focus(), this.editor.moveCursorToEnd();
    },
    onReferenceClick() {
      this.html = this.editor.getHTML(), this.setVisible(!0);
    }
  },
  components: {
    PopoverComponent: Ou
  }
}), aA = /* @__PURE__ */ ae("span", null, "OK", -1);
function lA(e, n, t, a, u, f) {
  const d = D("el-input"), m = D("el-form-item"), g = D("el-form"), y = D("el-button"), w = D("el-image"), h = D("button-component"), b = D("popover-component");
  return V(), X(b, {
    visible: e.visible,
    width: "500px",
    onVisible: e.setVisible
  }, {
    content: k(() => [
      z(g, null, {
        default: k(() => [
          z(m, { size: "default" }, {
            default: k(() => [
              z(d, {
                modelValue: e.html,
                "onUpdate:modelValue": n[0] || (n[0] = (T) => e.html = T),
                autosize: { minRows: 4, maxRows: 12 },
                type: "textarea",
                placeholder: "Html",
                size: "default"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    confirm: k(() => [
      z(y, {
        size: "small",
        onClick: e.setHTML
      }, {
        default: k(() => [
          aA
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    reference: k(() => [
      z(h, {
        disabled: e.disabled,
        onClick: e.onReferenceClick
      }, {
        default: k(() => [
          z(w, { src: e.HtmlSvg }, null, 8, ["src"])
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["visible", "onVisible"]);
}
const uA = /* @__PURE__ */ ce(sA, [["render", lA]]), cA = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTE0IDM4di0zaDE0LjQ1cTMuNSAwIDYuMDI1LTIuMzI1UTM3IDMwLjM1IDM3IDI2Ljl0LTIuNTI1LTUuNzc1UTMxLjk1IDE4LjggMjguNDUgMTguOEgxMy43bDUuNyA1LjctMi4xIDIuMUw4IDE3LjMgMTcuMyA4bDIuMSAyLjEtNS43IDUuN2gxNC43cTQuNzUgMCA4LjE3NSAzLjJRNDAgMjIuMiA0MCAyNi45dC0zLjQyNSA3LjlRMzMuMTUgMzggMjguNCAzOFoiLz48L3N2Zz4=", hA = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTE5LjYgMzhxLTQuNzUgMC04LjE3NS0zLjJROCAzMS42IDggMjYuOXQzLjQyNS03LjlxMy40MjUtMy4yIDguMTc1LTMuMmgxNC43bC01LjctNS43TDMwLjcgOGw5LjMgOS4zLTkuMyA5LjMtMi4xLTIuMSA1LjctNS43SDE5LjU1cS0zLjUgMC02LjAyNSAyLjMyNVExMSAyMy40NSAxMSAyNi45dDIuNTI1IDUuNzc1UTE2LjA1IDM1IDE5LjU1IDM1SDM0djNaIi8+PC9zdmc+", fA = oe({
  mixins: [Li],
  data() {
    return {
      UndoSvg: cA,
      RedoSvg: hA,
      canUndo: !1,
      canRedo: !1
    };
  },
  mounted() {
    this.editor.addEventListener("undoStateChange", this.undoStateChange);
  },
  unmounted() {
    this.editor.removeEventListener("undoStateChange", this.undoStateChange);
  },
  methods: {
    undoStateChange(e) {
      this.canUndo = e.canUndo, this.canRedo = e.canRedo;
    },
    onUndoClick() {
      this.editor.undo();
    },
    onRedoClick() {
      this.editor.redo();
    }
  }
});
function dA(e, n, t, a, u, f) {
  const d = D("el-image"), m = D("button-component");
  return V(), ue(st, null, [
    z(m, {
      disabled: !e.canUndo || e.disabled,
      onClick: n[0] || (n[0] = (g) => e.onUndoClick())
    }, {
      default: k(() => [
        z(d, { src: e.UndoSvg }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["disabled"]),
    z(m, {
      disabled: !e.canRedo || e.disabled,
      onClick: e.onRedoClick
    }, {
      default: k(() => [
        z(d, { src: e.RedoSvg }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["disabled", "onClick"])
  ], 64);
}
const pA = /* @__PURE__ */ ce(fA, [["render", dA]]), mA = {
  bold: Le(dT),
  italic: Le(gT),
  underline: Le(wT),
  alignment: Le(PE),
  list: Le($E),
  color: Le(GE),
  link: Le(XE),
  image: Le(rA),
  html: Le(uA),
  undoRedo: Le(pA)
}, _A = "_component_fdabb_2", gA = "_divider_fdabb_11", vA = "_header_fdabb_16", yA = "_editor_fdabb_26", bA = "_disabled_fdabb_42", wA = "_footer_fdabb_57", LA = {
  component: _A,
  divider: gA,
  header: vA,
  editor: yA,
  disabled: bA,
  footer: wA
}, gh = {
  paragraph: "<p><br></p>",
  div: "<div><br></div>"
}, SA = {
  emits: ["update:model-value", "blur"],
  props: {
    modelValue: {
      type: [String, null]
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      toolbar: Object.values(mA),
      editor: null,
      path: Ot.paragraph
    };
  },
  mounted() {
    this.editor = new eT(this.$refs.editor, {
      blockTag: Ot.paragraph,
      sanitizeToDOMFragment(e) {
        const n = new DOMParser().parseFromString(e, "text/html"), t = n.createDocumentFragment(), a = n.body;
        for (; a.firstChild; )
          t.appendChild(a.firstChild);
        return document.importNode(t, !0);
      }
    }), this.$nextTick(() => {
      this.editor.setHTML(this.modelValue || gh.paragraph);
    }), this.editor.addEventListener("pathChange", this.pathChange), this.editor.addEventListener("input", this.input), this.editor.addEventListener("blur", this.blur);
  },
  unmounted() {
    this.editor.removeEventListener("pathChange", this.pathChange), this.editor.removeEventListener("input", this.input), this.editor.removeEventListener("blur", this.blur), this.editor.destroy();
  },
  methods: {
    pathChange() {
      this.path = this.editor.getPath();
    },
    input() {
      let e = this.editor.getHTML();
      (e === gh.paragraph || e === gh.div) && (e = null), this.$emit("update:model-value", e);
    },
    blur() {
      this.$emit("blur");
    }
  }
};
function CA(e, n, t, a, u, f) {
  const d = D("el-divider");
  return V(), ue("div", {
    class: J(e.$style.component)
  }, [
    u.editor ? (V(), ue("header", {
      key: 0,
      class: J(e.$style.header)
    }, [
      (V(!0), ue(st, null, Et(u.toolbar, (m, g) => (V(), X(Gi(m), {
        key: g,
        editor: u.editor,
        path: u.path,
        disabled: t.disabled,
        onUpdate: f.input
      }, null, 40, ["editor", "path", "disabled", "onUpdate"]))), 128))
    ], 2)) : Ze("", !0),
    z(d, {
      class: J(e.$style.divider)
    }, null, 8, ["class"]),
    ae("div", {
      class: J({ [e.$style.disabled]: t.disabled })
    }, [
      ae("div", {
        class: J(e.$style.editor),
        ref: "editor"
      }, null, 2)
    ], 2),
    z(d, {
      class: J(e.$style.divider)
    }, null, 8, ["class"]),
    ae("footer", {
      class: J(e.$style.footer)
    }, [
      ae("span", null, wt(u.path), 1)
    ], 2)
  ], 2);
}
const MA = {
  $style: LA
}, TA = /* @__PURE__ */ ce(SA, [["render", CA], ["__cssModules", MA]]), EA = oe({
  emits: ["validate-field"],
  mixins: [hn],
  methods: {
    onUpdate() {
      this.$emit("validate-field", this.scope);
    },
    onBlur() {
      this.$emit("validate-field", this.scope);
    }
  },
  components: {
    EditorComponent: TA
  }
});
function AA(e, n, t, a, u, f) {
  const d = D("form-label-component"), m = D("editor-component"), g = D("form-error-component"), y = D("el-form-item");
  return V(), X(y, {
    prop: e.scope,
    rules: e.rules
  }, Tt({
    error: k(({ error: w }) => [
      z(g, {
        error: w[e.locale]
      }, null, 8, ["error"])
    ]),
    default: k(() => [
      z(m, {
        modelValue: e.model,
        "onUpdate:modelValue": [
          n[0] || (n[0] = (w) => e.model = w),
          e.onUpdate
        ],
        disabled: e.disabled,
        onBlur: e.onBlur
      }, null, 8, ["modelValue", "disabled", "onBlur", "onUpdate:modelValue"])
    ]),
    _: 2
  }, [
    e.label ? {
      name: "label",
      fn: k(() => [
        z(d, {
          label: e.label,
          rules: e.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const PA = /* @__PURE__ */ ce(EA, [["render", AA]]);
var vf = { exports: {} };
vf.exports = b_;
var xA = vf.exports.parse = b_, OA = vf.exports.stringify = w_, Wp = /[-+]?([0-9]*\.[0-9]+|[0-9]+)([eE][-+]?[0-9]+)?/, Gp = new RegExp("^" + Wp.source + "(\\s" + Wp.source + "){1,}");
function b_(e) {
  var n = e.split(";"), t = n.pop(), a = (n.shift() || "").split("=").pop(), u = 0;
  function f(Y) {
    var ee = t.substring(u).match(Y);
    return ee ? (u += ee[0].length, ee[0]) : null;
  }
  function d(Y) {
    return Y && a.match(/\d+/) && (Y.crs = {
      type: "name",
      properties: {
        name: "urn:ogc:def:crs:EPSG::" + a
      }
    }), Y;
  }
  function m() {
    f(/^\s*/);
  }
  function g() {
    m();
    for (var Y = 0, ee = [], re = [ee], be = ee, Xe; Xe = f(/^(\()/) || f(/^(\))/) || f(/^(,)/) || f(Gp); ) {
      if (Xe === "(")
        re.push(be), be = [], re[re.length - 1].push(be), Y++;
      else if (Xe === ")") {
        if (be.length === 0 || (be = re.pop(), !be))
          return null;
        if (Y--, Y === 0)
          break;
      } else if (Xe === ",")
        be = [], re[re.length - 1].push(be);
      else if (!Xe.split(/\s/g).some(isNaN))
        Array.prototype.push.apply(be, Xe.split(/\s/g).map(parseFloat));
      else
        return null;
      m();
    }
    return Y !== 0 ? null : ee;
  }
  function y() {
    for (var Y = [], ee, re; re = f(Gp) || f(/^(,)/); )
      re === "," ? (Y.push(ee), ee = []) : re.split(/\s/g).some(isNaN) || (ee || (ee = []), Array.prototype.push.apply(ee, re.split(/\s/g).map(parseFloat))), m();
    if (ee)
      Y.push(ee);
    else
      return null;
    return Y.length ? Y : null;
  }
  function w() {
    if (!f(/^(point(\sz)?)/i) || (m(), !f(/^(\()/)))
      return null;
    var Y = y();
    return !Y || (m(), !f(/^(\))/)) ? null : {
      type: "Point",
      coordinates: Y[0]
    };
  }
  function h() {
    if (!f(/^(multipoint)/i))
      return null;
    m();
    var Y = t.substring(t.indexOf("(") + 1, t.length - 1).replace(/\(/g, "").replace(/\)/g, "");
    t = "MULTIPOINT (" + Y + ")";
    var ee = g();
    return ee ? (m(), {
      type: "MultiPoint",
      coordinates: ee
    }) : null;
  }
  function b() {
    if (!f(/^(multilinestring)/i))
      return null;
    m();
    var Y = g();
    return Y ? (m(), {
      type: "MultiLineString",
      coordinates: Y
    }) : null;
  }
  function T() {
    if (!f(/^(linestring(\sz)?)/i) || (m(), !f(/^(\()/)))
      return null;
    var Y = y();
    return !Y || !f(/^(\))/) ? null : {
      type: "LineString",
      coordinates: Y
    };
  }
  function A() {
    if (!f(/^(polygon(\sz)?)/i))
      return null;
    m();
    var Y = g();
    return Y ? {
      type: "Polygon",
      coordinates: Y
    } : null;
  }
  function x() {
    if (!f(/^(multipolygon)/i))
      return null;
    m();
    var Y = g();
    return Y ? {
      type: "MultiPolygon",
      coordinates: Y
    } : null;
  }
  function Z() {
    var Y = [], ee;
    if (!f(/^(geometrycollection)/i) || (m(), !f(/^(\()/)))
      return null;
    for (; ee = H(); )
      Y.push(ee), m(), f(/^(,)/), m();
    return f(/^(\))/) ? {
      type: "GeometryCollection",
      geometries: Y
    } : null;
  }
  function H() {
    return w() || T() || A() || h() || b() || x() || Z();
  }
  return d(H());
}
function w_(e) {
  e.type === "Feature" && (e = e.geometry);
  function n(d) {
    return d.join(" ");
  }
  function t(d) {
    return d.map(n).join(", ");
  }
  function a(d) {
    return d.map(t).map(f).join(", ");
  }
  function u(d) {
    return d.map(a).map(f).join(", ");
  }
  function f(d) {
    return "(" + d + ")";
  }
  switch (e.type) {
    case "Point":
      return "POINT (" + n(e.coordinates) + ")";
    case "LineString":
      return "LINESTRING (" + t(e.coordinates) + ")";
    case "Polygon":
      return "POLYGON (" + a(e.coordinates) + ")";
    case "MultiPoint":
      return "MULTIPOINT (" + t(e.coordinates) + ")";
    case "MultiPolygon":
      return "MULTIPOLYGON (" + u(e.coordinates) + ")";
    case "MultiLineString":
      return "MULTILINESTRING (" + a(e.coordinates) + ")";
    case "GeometryCollection":
      return "GEOMETRYCOLLECTION (" + e.geometries.map(w_).join(", ") + ")";
    default:
      throw new Error("stringify requires a valid GeoJSON Feature or geometry object as input");
  }
}
var NA = { exports: {} };
(function(e, n) {
  (function(t, a) {
    e.exports = t(Jm()), typeof a < "u" && a.L && t(a.L);
  })(function(t) {
    t.Editable = t.Evented.extend({
      statics: {
        FORWARD: 1,
        BACKWARD: -1
      },
      options: {
        // You can pass them when creating a map using the `editOptions` key.
        // 🍂option zIndex: int = 1000
        // The default zIndex of the editing tools.
        zIndex: 1e3,
        // 🍂option polygonClass: class = L.Polygon
        // Class to be used when creating a new Polygon.
        polygonClass: t.Polygon,
        // 🍂option polylineClass: class = L.Polyline
        // Class to be used when creating a new Polyline.
        polylineClass: t.Polyline,
        // 🍂option markerClass: class = L.Marker
        // Class to be used when creating a new Marker.
        markerClass: t.Marker,
        // 🍂option rectangleClass: class = L.Rectangle
        // Class to be used when creating a new Rectangle.
        rectangleClass: t.Rectangle,
        // 🍂option circleClass: class = L.Circle
        // Class to be used when creating a new Circle.
        circleClass: t.Circle,
        // 🍂option drawingCSSClass: string = 'leaflet-editable-drawing'
        // CSS class to be added to the map container while drawing.
        drawingCSSClass: "leaflet-editable-drawing",
        // 🍂option drawingCursor: const = 'crosshair'
        // Cursor mode set to the map while drawing.
        drawingCursor: "crosshair",
        // 🍂option editLayer: Layer = new L.LayerGroup()
        // Layer used to store edit tools (vertex, line guide…).
        editLayer: void 0,
        // 🍂option featuresLayer: Layer = new L.LayerGroup()
        // Default layer used to store drawn features (Marker, Polyline…).
        featuresLayer: void 0,
        // 🍂option polylineEditorClass: class = PolylineEditor
        // Class to be used as Polyline editor.
        polylineEditorClass: void 0,
        // 🍂option polygonEditorClass: class = PolygonEditor
        // Class to be used as Polygon editor.
        polygonEditorClass: void 0,
        // 🍂option markerEditorClass: class = MarkerEditor
        // Class to be used as Marker editor.
        markerEditorClass: void 0,
        // 🍂option rectangleEditorClass: class = RectangleEditor
        // Class to be used as Rectangle editor.
        rectangleEditorClass: void 0,
        // 🍂option circleEditorClass: class = CircleEditor
        // Class to be used as Circle editor.
        circleEditorClass: void 0,
        // 🍂option lineGuideOptions: hash = {}
        // Options to be passed to the line guides.
        lineGuideOptions: {},
        // 🍂option skipMiddleMarkers: boolean = false
        // Set this to true if you don't want middle markers.
        skipMiddleMarkers: !1
      },
      initialize: function(h, b) {
        t.setOptions(this, b), this._lastZIndex = this.options.zIndex, this.map = h, this.editLayer = this.createEditLayer(), this.featuresLayer = this.createFeaturesLayer(), this.forwardLineGuide = this.createLineGuide(), this.backwardLineGuide = this.createLineGuide();
      },
      fireAndForward: function(h, b) {
        b = b || {}, b.editTools = this, this.fire(h, b), this.map.fire(h, b);
      },
      createLineGuide: function() {
        var h = t.extend({ dashArray: "5,10", weight: 1, interactive: !1 }, this.options.lineGuideOptions);
        return t.polyline([], h);
      },
      createVertexIcon: function(h) {
        return t.Browser.mobile && t.Browser.touch ? new t.Editable.TouchVertexIcon(h) : new t.Editable.VertexIcon(h);
      },
      createEditLayer: function() {
        return this.options.editLayer || new t.LayerGroup().addTo(this.map);
      },
      createFeaturesLayer: function() {
        return this.options.featuresLayer || new t.LayerGroup().addTo(this.map);
      },
      moveForwardLineGuide: function(h) {
        this.forwardLineGuide._latlngs.length && (this.forwardLineGuide._latlngs[1] = h, this.forwardLineGuide._bounds.extend(h), this.forwardLineGuide.redraw());
      },
      moveBackwardLineGuide: function(h) {
        this.backwardLineGuide._latlngs.length && (this.backwardLineGuide._latlngs[1] = h, this.backwardLineGuide._bounds.extend(h), this.backwardLineGuide.redraw());
      },
      anchorForwardLineGuide: function(h) {
        this.forwardLineGuide._latlngs[0] = h, this.forwardLineGuide._bounds.extend(h), this.forwardLineGuide.redraw();
      },
      anchorBackwardLineGuide: function(h) {
        this.backwardLineGuide._latlngs[0] = h, this.backwardLineGuide._bounds.extend(h), this.backwardLineGuide.redraw();
      },
      attachForwardLineGuide: function() {
        this.editLayer.addLayer(this.forwardLineGuide);
      },
      attachBackwardLineGuide: function() {
        this.editLayer.addLayer(this.backwardLineGuide);
      },
      detachForwardLineGuide: function() {
        this.forwardLineGuide.setLatLngs([]), this.editLayer.removeLayer(this.forwardLineGuide);
      },
      detachBackwardLineGuide: function() {
        this.backwardLineGuide.setLatLngs([]), this.editLayer.removeLayer(this.backwardLineGuide);
      },
      blockEvents: function() {
        this._oldTargets || (this._oldTargets = this.map._targets, this.map._targets = {});
      },
      unblockEvents: function() {
        this._oldTargets && (this.map._targets = t.extend(this.map._targets, this._oldTargets), delete this._oldTargets);
      },
      registerForDrawing: function(h) {
        this._drawingEditor && this.unregisterForDrawing(this._drawingEditor), this.blockEvents(), h.reset(), this._drawingEditor = h, this.map.on("mousemove touchmove", h.onDrawingMouseMove, h), this.map.on("mousedown", this.onMousedown, this), this.map.on("mouseup", this.onMouseup, this), t.DomUtil.addClass(this.map._container, this.options.drawingCSSClass), this.defaultMapCursor = this.map._container.style.cursor, this.map._container.style.cursor = this.options.drawingCursor;
      },
      unregisterForDrawing: function(h) {
        this.unblockEvents(), t.DomUtil.removeClass(this.map._container, this.options.drawingCSSClass), this.map._container.style.cursor = this.defaultMapCursor, h = h || this._drawingEditor, h && (this.map.off("mousemove touchmove", h.onDrawingMouseMove, h), this.map.off("mousedown", this.onMousedown, this), this.map.off("mouseup", this.onMouseup, this), h === this._drawingEditor && (delete this._drawingEditor, h._drawing && h.cancelDrawing()));
      },
      onMousedown: function(h) {
        h.originalEvent.which == 1 && (this._mouseDown = h, this._drawingEditor.onDrawingMouseDown(h));
      },
      onMouseup: function(h) {
        if (this._mouseDown) {
          var b = this._drawingEditor, T = this._mouseDown;
          if (this._mouseDown = null, b.onDrawingMouseUp(h), this._drawingEditor !== b)
            return;
          var A = t.point(T.originalEvent.clientX, T.originalEvent.clientY), x = t.point(h.originalEvent.clientX, h.originalEvent.clientY).distanceTo(A);
          Math.abs(x) < 9 * (window.devicePixelRatio || 1) && this._drawingEditor.onDrawingClick(h);
        }
      },
      // 🍂section Public methods
      // You will generally access them by the `map.editTools`
      // instance:
      //
      // `map.editTools.startPolyline();`
      // 🍂method drawing(): boolean
      // Return true if any drawing action is ongoing.
      drawing: function() {
        return this._drawingEditor && this._drawingEditor.drawing();
      },
      // 🍂method stopDrawing()
      // When you need to stop any ongoing drawing, without needing to know which editor is active.
      stopDrawing: function() {
        this.unregisterForDrawing();
      },
      // 🍂method commitDrawing()
      // When you need to commit any ongoing drawing, without needing to know which editor is active.
      commitDrawing: function(h) {
        this._drawingEditor && this._drawingEditor.commitDrawing(h);
      },
      connectCreatedToMap: function(h) {
        return this.featuresLayer.addLayer(h);
      },
      // 🍂method startPolyline(latlng: L.LatLng, options: hash): L.Polyline
      // Start drawing a Polyline. If `latlng` is given, a first point will be added. In any case, continuing on user click.
      // If `options` is given, it will be passed to the Polyline class constructor.
      startPolyline: function(h, b) {
        var T = this.createPolyline([], b);
        return T.enableEdit(this.map).newShape(h), T;
      },
      // 🍂method startPolygon(latlng: L.LatLng, options: hash): L.Polygon
      // Start drawing a Polygon. If `latlng` is given, a first point will be added. In any case, continuing on user click.
      // If `options` is given, it will be passed to the Polygon class constructor.
      startPolygon: function(h, b) {
        var T = this.createPolygon([], b);
        return T.enableEdit(this.map).newShape(h), T;
      },
      // 🍂method startMarker(latlng: L.LatLng, options: hash): L.Marker
      // Start adding a Marker. If `latlng` is given, the Marker will be shown first at this point.
      // In any case, it will follow the user mouse, and will have a final `latlng` on next click (or touch).
      // If `options` is given, it will be passed to the Marker class constructor.
      startMarker: function(h, b) {
        h = h || this.map.getCenter().clone();
        var T = this.createMarker(h, b);
        return T.enableEdit(this.map).startDrawing(), T;
      },
      // 🍂method startRectangle(latlng: L.LatLng, options: hash): L.Rectangle
      // Start drawing a Rectangle. If `latlng` is given, the Rectangle anchor will be added. In any case, continuing on user drag.
      // If `options` is given, it will be passed to the Rectangle class constructor.
      startRectangle: function(h, b) {
        var T = h || t.latLng([0, 0]), A = new t.LatLngBounds(T, T), x = this.createRectangle(A, b);
        return x.enableEdit(this.map).startDrawing(), x;
      },
      // 🍂method startCircle(latlng: L.LatLng, options: hash): L.Circle
      // Start drawing a Circle. If `latlng` is given, the Circle anchor will be added. In any case, continuing on user drag.
      // If `options` is given, it will be passed to the Circle class constructor.
      startCircle: function(h, b) {
        h = h || this.map.getCenter().clone();
        var T = this.createCircle(h, b);
        return T.enableEdit(this.map).startDrawing(), T;
      },
      startHole: function(h, b) {
        h.newHole(b);
      },
      createLayer: function(h, b, T) {
        T = t.Util.extend({ editOptions: { editTools: this } }, T);
        var A = new h(b, T);
        return this.fireAndForward("editable:created", { layer: A }), A;
      },
      createPolyline: function(h, b) {
        return this.createLayer(b && b.polylineClass || this.options.polylineClass, h, b);
      },
      createPolygon: function(h, b) {
        return this.createLayer(b && b.polygonClass || this.options.polygonClass, h, b);
      },
      createMarker: function(h, b) {
        return this.createLayer(b && b.markerClass || this.options.markerClass, h, b);
      },
      createRectangle: function(h, b) {
        return this.createLayer(b && b.rectangleClass || this.options.rectangleClass, h, b);
      },
      createCircle: function(h, b) {
        return this.createLayer(b && b.circleClass || this.options.circleClass, h, b);
      }
    }), t.extend(t.Editable, {
      makeCancellable: function(h) {
        h.cancel = function() {
          h._cancelled = !0;
        };
      }
    }), t.Map.mergeOptions({
      // 🍂namespace Map
      // 🍂section Map Options
      // 🍂option editToolsClass: class = L.Editable
      // Class to be used as vertex, for path editing.
      editToolsClass: t.Editable,
      // 🍂option editable: boolean = false
      // Whether to create a L.Editable instance at map init.
      editable: !1,
      // 🍂option editOptions: hash = {}
      // Options to pass to L.Editable when instantiating.
      editOptions: {}
    }), t.Map.addInitHook(function() {
      this.whenReady(function() {
        this.options.editable && (this.editTools = new this.options.editToolsClass(this, this.options.editOptions));
      });
    }), t.Editable.VertexIcon = t.DivIcon.extend({
      options: {
        iconSize: new t.Point(8, 8)
      }
    }), t.Editable.TouchVertexIcon = t.Editable.VertexIcon.extend({
      options: {
        iconSize: new t.Point(20, 20)
      }
    }), t.Editable.VertexMarker = t.Marker.extend({
      options: {
        draggable: !0,
        className: "leaflet-div-icon leaflet-vertex-icon"
      },
      // 🍂section Public methods
      // The marker used to handle path vertex. You will usually interact with a `VertexMarker`
      // instance when listening for events like `editable:vertex:ctrlclick`.
      initialize: function(h, b, T, A) {
        this.latlng = h, this.latlngs = b, this.editor = T, t.Marker.prototype.initialize.call(this, h, A), this.options.icon = this.editor.tools.createVertexIcon({ className: this.options.className }), this.latlng.__vertex = this, this.editor.editLayer.addLayer(this), this.setZIndexOffset(T.tools._lastZIndex + 1);
      },
      onAdd: function(h) {
        t.Marker.prototype.onAdd.call(this, h), this.on("drag", this.onDrag), this.on("dragstart", this.onDragStart), this.on("dragend", this.onDragEnd), this.on("mouseup", this.onMouseup), this.on("click", this.onClick), this.on("contextmenu", this.onContextMenu), this.on("mousedown touchstart", this.onMouseDown), this.on("mouseover", this.onMouseOver), this.on("mouseout", this.onMouseOut), this.addMiddleMarkers();
      },
      onRemove: function(h) {
        this.middleMarker && this.middleMarker.delete(), delete this.latlng.__vertex, this.off("drag", this.onDrag), this.off("dragstart", this.onDragStart), this.off("dragend", this.onDragEnd), this.off("mouseup", this.onMouseup), this.off("click", this.onClick), this.off("contextmenu", this.onContextMenu), this.off("mousedown touchstart", this.onMouseDown), this.off("mouseover", this.onMouseOver), this.off("mouseout", this.onMouseOut), t.Marker.prototype.onRemove.call(this, h);
      },
      onDrag: function(h) {
        h.vertex = this, this.editor.onVertexMarkerDrag(h);
        var b = t.DomUtil.getPosition(this._icon), T = this._map.layerPointToLatLng(b);
        this.latlng.update(T), this._latlng = this.latlng, this.editor.refresh(), this.middleMarker && this.middleMarker.updateLatLng();
        var A = this.getNext();
        A && A.middleMarker && A.middleMarker.updateLatLng();
      },
      onDragStart: function(h) {
        h.vertex = this, this.editor.onVertexMarkerDragStart(h);
      },
      onDragEnd: function(h) {
        h.vertex = this, this.editor.onVertexMarkerDragEnd(h);
      },
      onClick: function(h) {
        h.vertex = this, this.editor.onVertexMarkerClick(h);
      },
      onMouseup: function(h) {
        t.DomEvent.stop(h), h.vertex = this, this.editor.map.fire("mouseup", h);
      },
      onContextMenu: function(h) {
        h.vertex = this, this.editor.onVertexMarkerContextMenu(h);
      },
      onMouseDown: function(h) {
        h.vertex = this, this.editor.onVertexMarkerMouseDown(h);
      },
      onMouseOver: function(h) {
        h.vertex = this, this.editor.onVertexMarkerMouseOver(h);
      },
      onMouseOut: function(h) {
        h.vertex = this, this.editor.onVertexMarkerMouseOut(h);
      },
      // 🍂method delete()
      // Delete a vertex and the related LatLng.
      delete: function() {
        var h = this.getNext();
        this.latlngs.splice(this.getIndex(), 1), this.editor.editLayer.removeLayer(this), this.editor.onVertexDeleted({ latlng: this.latlng, vertex: this }), this.latlngs.length || this.editor.deleteShape(this.latlngs), h && h.resetMiddleMarker(), this.editor.refresh();
      },
      // 🍂method getIndex(): int
      // Get the index of the current vertex among others of the same LatLngs group.
      getIndex: function() {
        return this.latlngs.indexOf(this.latlng);
      },
      // 🍂method getLastIndex(): int
      // Get last vertex index of the LatLngs group of the current vertex.
      getLastIndex: function() {
        return this.latlngs.length - 1;
      },
      // 🍂method getPrevious(): VertexMarker
      // Get the previous VertexMarker in the same LatLngs group.
      getPrevious: function() {
        if (!(this.latlngs.length < 2)) {
          var h = this.getIndex(), b = h - 1;
          h === 0 && this.editor.CLOSED && (b = this.getLastIndex());
          var T = this.latlngs[b];
          if (T)
            return T.__vertex;
        }
      },
      // 🍂method getNext(): VertexMarker
      // Get the next VertexMarker in the same LatLngs group.
      getNext: function() {
        if (!(this.latlngs.length < 2)) {
          var h = this.getIndex(), b = h + 1;
          h === this.getLastIndex() && this.editor.CLOSED && (b = 0);
          var T = this.latlngs[b];
          if (T)
            return T.__vertex;
        }
      },
      addMiddleMarker: function(h) {
        this.editor.hasMiddleMarkers() && (h = h || this.getPrevious(), h && !this.middleMarker && (this.middleMarker = this.editor.addMiddleMarker(h, this, this.latlngs, this.editor)));
      },
      addMiddleMarkers: function() {
        if (this.editor.hasMiddleMarkers()) {
          var h = this.getPrevious();
          h && this.addMiddleMarker(h);
          var b = this.getNext();
          b && b.resetMiddleMarker();
        }
      },
      resetMiddleMarker: function() {
        this.middleMarker && this.middleMarker.delete(), this.addMiddleMarker();
      },
      // 🍂method split()
      // Split the vertex LatLngs group at its index, if possible.
      split: function() {
        this.editor.splitShape && this.editor.splitShape(this.latlngs, this.getIndex());
      },
      // 🍂method continue()
      // Continue the vertex LatLngs from this vertex. Only active for first and last vertices of a Polyline.
      continue: function() {
        if (this.editor.continueBackward) {
          var h = this.getIndex();
          h === 0 ? this.editor.continueBackward(this.latlngs) : h === this.getLastIndex() && this.editor.continueForward(this.latlngs);
        }
      }
    }), t.Editable.mergeOptions({
      // 🍂namespace Editable
      // 🍂option vertexMarkerClass: class = VertexMarker
      // Class to be used as vertex, for path editing.
      vertexMarkerClass: t.Editable.VertexMarker
    }), t.Editable.MiddleMarker = t.Marker.extend({
      options: {
        opacity: 0.5,
        className: "leaflet-div-icon leaflet-middle-icon",
        draggable: !0
      },
      initialize: function(h, b, T, A, x) {
        this.left = h, this.right = b, this.editor = A, this.latlngs = T, t.Marker.prototype.initialize.call(this, this.computeLatLng(), x), this._opacity = this.options.opacity, this.options.icon = this.editor.tools.createVertexIcon({ className: this.options.className }), this.editor.editLayer.addLayer(this), this.setVisibility();
      },
      setVisibility: function() {
        var h = this._map.latLngToContainerPoint(this.left.latlng), b = this._map.latLngToContainerPoint(this.right.latlng), T = t.point(this.options.icon.options.iconSize);
        h.distanceTo(b) < T.x * 3 ? this.hide() : this.show();
      },
      show: function() {
        this.setOpacity(this._opacity);
      },
      hide: function() {
        this.setOpacity(0);
      },
      updateLatLng: function() {
        this.setLatLng(this.computeLatLng()), this.setVisibility();
      },
      computeLatLng: function() {
        var h = this.editor.map.latLngToContainerPoint(this.left.latlng), b = this.editor.map.latLngToContainerPoint(this.right.latlng), T = (h.y + b.y) / 2, A = (h.x + b.x) / 2;
        return this.editor.map.containerPointToLatLng([A, T]);
      },
      onAdd: function(h) {
        t.Marker.prototype.onAdd.call(this, h), t.DomEvent.on(this._icon, "mousedown touchstart", this.onMouseDown, this), h.on("zoomend", this.setVisibility, this);
      },
      onRemove: function(h) {
        delete this.right.middleMarker, t.DomEvent.off(this._icon, "mousedown touchstart", this.onMouseDown, this), h.off("zoomend", this.setVisibility, this), t.Marker.prototype.onRemove.call(this, h);
      },
      onMouseDown: function(h) {
        var b = t.DomUtil.getPosition(this._icon), T = this.editor.map.layerPointToLatLng(b);
        if (h = {
          originalEvent: h,
          latlng: T
        }, this.options.opacity !== 0 && (t.Editable.makeCancellable(h), this.editor.onMiddleMarkerMouseDown(h), !h._cancelled)) {
          this.latlngs.splice(this.index(), 0, h.latlng), this.editor.refresh();
          var A = this._icon, x = this.editor.addVertexMarker(h.latlng, this.latlngs);
          this.editor.onNewVertex(x);
          var Z = x._icon.parentNode;
          Z.removeChild(x._icon), x._icon = A, Z.appendChild(x._icon), x._initIcon(), x._initInteraction(), x.setOpacity(1), t.Draggable._dragging = !1, x.dragging._draggable._onDown(h.originalEvent), this.delete();
        }
      },
      delete: function() {
        this.editor.editLayer.removeLayer(this);
      },
      index: function() {
        return this.latlngs.indexOf(this.right.latlng);
      }
    }), t.Editable.mergeOptions({
      // 🍂namespace Editable
      // 🍂option middleMarkerClass: class = VertexMarker
      // Class to be used as middle vertex, pulled by the user to create a new point in the middle of a path.
      middleMarkerClass: t.Editable.MiddleMarker
    }), t.Editable.BaseEditor = t.Handler.extend({
      initialize: function(h, b, T) {
        t.setOptions(this, T), this.map = h, this.feature = b, this.feature.editor = this, this.editLayer = new t.LayerGroup(), this.tools = this.options.editTools || h.editTools;
      },
      // 🍂method enable(): this
      // Set up the drawing tools for the feature to be editable.
      addHooks: function() {
        this.isConnected() ? this.onFeatureAdd() : this.feature.once("add", this.onFeatureAdd, this), this.onEnable(), this.feature.on(this._getEvents(), this);
      },
      // 🍂method disable(): this
      // Remove the drawing tools for the feature.
      removeHooks: function() {
        this.feature.off(this._getEvents(), this), this.feature.dragging && this.feature.dragging.disable(), this.editLayer.clearLayers(), this.tools.editLayer.removeLayer(this.editLayer), this.onDisable(), this._drawing && this.cancelDrawing();
      },
      // 🍂method drawing(): boolean
      // Return true if any drawing action is ongoing with this editor.
      drawing: function() {
        return !!this._drawing;
      },
      reset: function() {
      },
      onFeatureAdd: function() {
        this.tools.editLayer.addLayer(this.editLayer), this.feature.dragging && this.feature.dragging.enable();
      },
      hasMiddleMarkers: function() {
        return !this.options.skipMiddleMarkers && !this.tools.options.skipMiddleMarkers;
      },
      fireAndForward: function(h, b) {
        b = b || {}, b.layer = this.feature, this.feature.fire(h, b), this.tools.fireAndForward(h, b);
      },
      onEnable: function() {
        this.fireAndForward("editable:enable");
      },
      onDisable: function() {
        this.fireAndForward("editable:disable");
      },
      onEditing: function() {
        this.fireAndForward("editable:editing");
      },
      onStartDrawing: function() {
        this.fireAndForward("editable:drawing:start");
      },
      onEndDrawing: function() {
        this.fireAndForward("editable:drawing:end");
      },
      onCancelDrawing: function() {
        this.fireAndForward("editable:drawing:cancel");
      },
      onCommitDrawing: function(h) {
        this.fireAndForward("editable:drawing:commit", h);
      },
      onDrawingMouseDown: function(h) {
        this.fireAndForward("editable:drawing:mousedown", h);
      },
      onDrawingMouseUp: function(h) {
        this.fireAndForward("editable:drawing:mouseup", h);
      },
      startDrawing: function() {
        this._drawing || (this._drawing = t.Editable.FORWARD), this.tools.registerForDrawing(this), this.onStartDrawing();
      },
      commitDrawing: function(h) {
        this.onCommitDrawing(h), this.endDrawing();
      },
      cancelDrawing: function() {
        t.Draggable._dragging = !1, this.onCancelDrawing(), this.endDrawing();
      },
      endDrawing: function() {
        this._drawing = !1, this.tools.unregisterForDrawing(this), this.onEndDrawing();
      },
      onDrawingClick: function(h) {
        this.drawing() && (t.Editable.makeCancellable(h), this.fireAndForward("editable:drawing:click", h), !h._cancelled && (this.isConnected() || this.connect(h), this.processDrawingClick(h)));
      },
      isConnected: function() {
        return this.map.hasLayer(this.feature);
      },
      connect: function() {
        this.tools.connectCreatedToMap(this.feature), this.tools.editLayer.addLayer(this.editLayer);
      },
      onMove: function(h) {
        this.fireAndForward("editable:drawing:move", h);
      },
      onDrawingMouseMove: function(h) {
        this.onMove(h);
      },
      _getEvents: function() {
        return {
          dragstart: this.onDragStart,
          drag: this.onDrag,
          dragend: this.onDragEnd,
          remove: this.disable
        };
      },
      onDragStart: function(h) {
        this.onEditing(), this.fireAndForward("editable:dragstart", h);
      },
      onDrag: function(h) {
        this.onMove(h), this.fireAndForward("editable:drag", h);
      },
      onDragEnd: function(h) {
        this.fireAndForward("editable:dragend", h);
      }
    }), t.Editable.MarkerEditor = t.Editable.BaseEditor.extend({
      onDrawingMouseMove: function(h) {
        t.Editable.BaseEditor.prototype.onDrawingMouseMove.call(this, h), this._drawing && this.feature.setLatLng(h.latlng);
      },
      processDrawingClick: function(h) {
        this.fireAndForward("editable:drawing:clicked", h), this.commitDrawing(h);
      },
      connect: function(h) {
        h && (this.feature._latlng = h.latlng), t.Editable.BaseEditor.prototype.connect.call(this, h);
      }
    }), t.Editable.PathEditor = t.Editable.BaseEditor.extend({
      CLOSED: !1,
      MIN_VERTEX: 2,
      addHooks: function() {
        return t.Editable.BaseEditor.prototype.addHooks.call(this), this.feature && this.initVertexMarkers(), this;
      },
      initVertexMarkers: function(h) {
        if (this.enabled())
          if (h = h || this.getLatLngs(), w(h))
            this.addVertexMarkers(h);
          else
            for (var b = 0; b < h.length; b++)
              this.initVertexMarkers(h[b]);
      },
      getLatLngs: function() {
        return this.feature.getLatLngs();
      },
      // 🍂method reset()
      // Rebuild edit elements (Vertex, MiddleMarker, etc.).
      reset: function() {
        this.editLayer.clearLayers(), this.initVertexMarkers();
      },
      addVertexMarker: function(h, b) {
        return new this.tools.options.vertexMarkerClass(h, b, this);
      },
      onNewVertex: function(h) {
        this.fireAndForward("editable:vertex:new", { latlng: h.latlng, vertex: h });
      },
      addVertexMarkers: function(h) {
        for (var b = 0; b < h.length; b++)
          this.addVertexMarker(h[b], h);
      },
      refreshVertexMarkers: function(h) {
        h = h || this.getDefaultLatLngs();
        for (var b = 0; b < h.length; b++)
          h[b].__vertex.update();
      },
      addMiddleMarker: function(h, b, T) {
        return new this.tools.options.middleMarkerClass(h, b, T, this);
      },
      onVertexMarkerClick: function(h) {
        if (t.Editable.makeCancellable(h), this.fireAndForward("editable:vertex:click", h), !h._cancelled && !(this.tools.drawing() && this.tools._drawingEditor !== this)) {
          var b = h.vertex.getIndex(), T;
          h.originalEvent.ctrlKey ? this.onVertexMarkerCtrlClick(h) : h.originalEvent.altKey ? this.onVertexMarkerAltClick(h) : h.originalEvent.shiftKey ? this.onVertexMarkerShiftClick(h) : h.originalEvent.metaKey ? this.onVertexMarkerMetaKeyClick(h) : b === h.vertex.getLastIndex() && this._drawing === t.Editable.FORWARD ? b >= this.MIN_VERTEX - 1 && (T = !0) : b === 0 && this._drawing === t.Editable.BACKWARD && this._drawnLatLngs.length >= this.MIN_VERTEX || b === 0 && this._drawing === t.Editable.FORWARD && this._drawnLatLngs.length >= this.MIN_VERTEX && this.CLOSED ? T = !0 : this.onVertexRawMarkerClick(h), this.fireAndForward("editable:vertex:clicked", h), T && this.commitDrawing(h);
        }
      },
      onVertexRawMarkerClick: function(h) {
        this.fireAndForward("editable:vertex:rawclick", h), !h._cancelled && this.vertexCanBeDeleted(h.vertex) && h.vertex.delete();
      },
      vertexCanBeDeleted: function(h) {
        return h.latlngs.length > this.MIN_VERTEX;
      },
      onVertexDeleted: function(h) {
        this.fireAndForward("editable:vertex:deleted", h);
      },
      onVertexMarkerCtrlClick: function(h) {
        this.fireAndForward("editable:vertex:ctrlclick", h);
      },
      onVertexMarkerShiftClick: function(h) {
        this.fireAndForward("editable:vertex:shiftclick", h);
      },
      onVertexMarkerMetaKeyClick: function(h) {
        this.fireAndForward("editable:vertex:metakeyclick", h);
      },
      onVertexMarkerAltClick: function(h) {
        this.fireAndForward("editable:vertex:altclick", h);
      },
      onVertexMarkerContextMenu: function(h) {
        this.fireAndForward("editable:vertex:contextmenu", h);
      },
      onVertexMarkerMouseDown: function(h) {
        this.fireAndForward("editable:vertex:mousedown", h);
      },
      onVertexMarkerMouseOver: function(h) {
        this.fireAndForward("editable:vertex:mouseover", h);
      },
      onVertexMarkerMouseOut: function(h) {
        this.fireAndForward("editable:vertex:mouseout", h);
      },
      onMiddleMarkerMouseDown: function(h) {
        this.fireAndForward("editable:middlemarker:mousedown", h);
      },
      onVertexMarkerDrag: function(h) {
        this.onMove(h), this.feature._bounds && this.extendBounds(h), this.fireAndForward("editable:vertex:drag", h);
      },
      onVertexMarkerDragStart: function(h) {
        this.fireAndForward("editable:vertex:dragstart", h);
      },
      onVertexMarkerDragEnd: function(h) {
        this.fireAndForward("editable:vertex:dragend", h);
      },
      setDrawnLatLngs: function(h) {
        this._drawnLatLngs = h || this.getDefaultLatLngs();
      },
      startDrawing: function() {
        this._drawnLatLngs || this.setDrawnLatLngs(), t.Editable.BaseEditor.prototype.startDrawing.call(this);
      },
      startDrawingForward: function() {
        this.startDrawing();
      },
      endDrawing: function() {
        this.tools.detachForwardLineGuide(), this.tools.detachBackwardLineGuide(), this._drawnLatLngs && this._drawnLatLngs.length < this.MIN_VERTEX && this.deleteShape(this._drawnLatLngs), t.Editable.BaseEditor.prototype.endDrawing.call(this), delete this._drawnLatLngs;
      },
      addLatLng: function(h) {
        this._drawing === t.Editable.FORWARD ? this._drawnLatLngs.push(h) : this._drawnLatLngs.unshift(h), this.feature._bounds.extend(h);
        var b = this.addVertexMarker(h, this._drawnLatLngs);
        this.onNewVertex(b), this.refresh();
      },
      newPointForward: function(h) {
        this.addLatLng(h), this.tools.attachForwardLineGuide(), this.tools.anchorForwardLineGuide(h);
      },
      newPointBackward: function(h) {
        this.addLatLng(h), this.tools.anchorBackwardLineGuide(h);
      },
      // 🍂namespace PathEditor
      // 🍂method push()
      // Programmatically add a point while drawing.
      push: function(h) {
        if (!h)
          return console.error("L.Editable.PathEditor.push expect a valid latlng as parameter");
        this._drawing === t.Editable.FORWARD ? this.newPointForward(h) : this.newPointBackward(h);
      },
      removeLatLng: function(h) {
        h.__vertex.delete(), this.refresh();
      },
      // 🍂method pop(): L.LatLng or null
      // Programmatically remove last point (if any) while drawing.
      pop: function() {
        if (!(this._drawnLatLngs.length <= 1)) {
          var h;
          return this._drawing === t.Editable.FORWARD ? h = this._drawnLatLngs[this._drawnLatLngs.length - 1] : h = this._drawnLatLngs[0], this.removeLatLng(h), this._drawing === t.Editable.FORWARD ? this.tools.anchorForwardLineGuide(this._drawnLatLngs[this._drawnLatLngs.length - 1]) : this.tools.anchorForwardLineGuide(this._drawnLatLngs[0]), h;
        }
      },
      processDrawingClick: function(h) {
        h.vertex && h.vertex.editor === this || (this._drawing === t.Editable.FORWARD ? this.newPointForward(h.latlng) : this.newPointBackward(h.latlng), this.fireAndForward("editable:drawing:clicked", h));
      },
      onDrawingMouseMove: function(h) {
        t.Editable.BaseEditor.prototype.onDrawingMouseMove.call(this, h), this._drawing && (this.tools.moveForwardLineGuide(h.latlng), this.tools.moveBackwardLineGuide(h.latlng));
      },
      refresh: function() {
        this.feature.redraw(), this.onEditing();
      },
      // 🍂namespace PathEditor
      // 🍂method newShape(latlng?: L.LatLng)
      // Add a new shape (Polyline, Polygon) in a multi, and setup up drawing tools to draw it;
      // if optional `latlng` is given, start a path at this point.
      newShape: function(h) {
        var b = this.addNewEmptyShape();
        b && (this.setDrawnLatLngs(b[0] || b), this.startDrawingForward(), this.fireAndForward("editable:shape:new", { shape: b }), h && this.newPointForward(h));
      },
      deleteShape: function(h, b) {
        var T = { shape: h };
        if (t.Editable.makeCancellable(T), this.fireAndForward("editable:shape:delete", T), !T._cancelled)
          return h = this._deleteShape(h, b), this.ensureNotFlat && this.ensureNotFlat(), this.feature.setLatLngs(this.getLatLngs()), this.refresh(), this.reset(), this.fireAndForward("editable:shape:deleted", { shape: h }), h;
      },
      _deleteShape: function(h, b) {
        if (b = b || this.getLatLngs(), !!b.length) {
          var T = this, A = function(H, Y) {
            return Y = H.splice(0, Number.MAX_VALUE), Y;
          }, x = function(H, Y) {
            return H.splice(H.indexOf(Y), 1), H.length || T._deleteShape(H), Y;
          };
          if (b === h)
            return A(b, h);
          for (var Z = 0; Z < b.length; Z++) {
            if (b[Z] === h)
              return x(b, h);
            if (b[Z].indexOf(h) !== -1)
              return x(b[Z], h);
          }
        }
      },
      // 🍂namespace PathEditor
      // 🍂method deleteShapeAt(latlng: L.LatLng): Array
      // Remove a path shape at the given `latlng`.
      deleteShapeAt: function(h) {
        var b = this.feature.shapeAt(h);
        if (b)
          return this.deleteShape(b);
      },
      // 🍂method appendShape(shape: Array)
      // Append a new shape to the Polygon or Polyline.
      appendShape: function(h) {
        this.insertShape(h);
      },
      // 🍂method prependShape(shape: Array)
      // Prepend a new shape to the Polygon or Polyline.
      prependShape: function(h) {
        this.insertShape(h, 0);
      },
      // 🍂method insertShape(shape: Array, index: int)
      // Insert a new shape to the Polygon or Polyline at given index (default is to append).
      insertShape: function(h, b) {
        this.ensureMulti(), h = this.formatShape(h), typeof b > "u" && (b = this.feature._latlngs.length), this.feature._latlngs.splice(b, 0, h), this.feature.redraw(), this._enabled && this.reset();
      },
      extendBounds: function(h) {
        this.feature._bounds.extend(h.vertex.latlng);
      },
      onDragStart: function(h) {
        this.editLayer.clearLayers(), t.Editable.BaseEditor.prototype.onDragStart.call(this, h);
      },
      onDragEnd: function(h) {
        this.initVertexMarkers(), t.Editable.BaseEditor.prototype.onDragEnd.call(this, h);
      }
    }), t.Editable.PolylineEditor = t.Editable.PathEditor.extend({
      startDrawingBackward: function() {
        this._drawing = t.Editable.BACKWARD, this.startDrawing();
      },
      // 🍂method continueBackward(latlngs?: Array)
      // Set up drawing tools to continue the line backward.
      continueBackward: function(h) {
        this.drawing() || (h = h || this.getDefaultLatLngs(), this.setDrawnLatLngs(h), h.length > 0 && (this.tools.attachBackwardLineGuide(), this.tools.anchorBackwardLineGuide(h[0])), this.startDrawingBackward());
      },
      // 🍂method continueForward(latlngs?: Array)
      // Set up drawing tools to continue the line forward.
      continueForward: function(h) {
        this.drawing() || (h = h || this.getDefaultLatLngs(), this.setDrawnLatLngs(h), h.length > 0 && (this.tools.attachForwardLineGuide(), this.tools.anchorForwardLineGuide(h[h.length - 1])), this.startDrawingForward());
      },
      getDefaultLatLngs: function(h) {
        return h = h || this.feature._latlngs, !h.length || h[0] instanceof t.LatLng ? h : this.getDefaultLatLngs(h[0]);
      },
      ensureMulti: function() {
        this.feature._latlngs.length && w(this.feature._latlngs) && (this.feature._latlngs = [this.feature._latlngs]);
      },
      addNewEmptyShape: function() {
        if (this.feature._latlngs.length) {
          var h = [];
          return this.appendShape(h), h;
        } else
          return this.feature._latlngs;
      },
      formatShape: function(h) {
        if (w(h))
          return h;
        if (h[0])
          return this.formatShape(h[0]);
      },
      // 🍂method splitShape(latlngs?: Array, index: int)
      // Split the given `latlngs` shape at index `index` and integrate new shape in instance `latlngs`.
      splitShape: function(h, b) {
        if (!(!b || b >= h.length - 1)) {
          this.ensureMulti();
          var T = this.feature._latlngs.indexOf(h);
          if (T !== -1) {
            var A = h.slice(0, b + 1), x = h.slice(b);
            x[0] = t.latLng(x[0].lat, x[0].lng, x[0].alt), this.feature._latlngs.splice(T, 1, A, x), this.refresh(), this.reset();
          }
        }
      }
    }), t.Editable.PolygonEditor = t.Editable.PathEditor.extend({
      CLOSED: !0,
      MIN_VERTEX: 3,
      newPointForward: function(h) {
        t.Editable.PathEditor.prototype.newPointForward.call(this, h), this.tools.backwardLineGuide._latlngs.length || this.tools.anchorBackwardLineGuide(h), this._drawnLatLngs.length === 2 && this.tools.attachBackwardLineGuide();
      },
      addNewEmptyHole: function(h) {
        this.ensureNotFlat();
        var b = this.feature.shapeAt(h);
        if (b) {
          var T = [];
          return b.push(T), T;
        }
      },
      // 🍂method newHole(latlng?: L.LatLng, index: int)
      // Set up drawing tools for creating a new hole on the Polygon. If the `latlng` param is given, a first point is created.
      newHole: function(h) {
        var b = this.addNewEmptyHole(h);
        b && (this.setDrawnLatLngs(b), this.startDrawingForward(), h && this.newPointForward(h));
      },
      addNewEmptyShape: function() {
        if (this.feature._latlngs.length && this.feature._latlngs[0].length) {
          var h = [];
          return this.appendShape(h), h;
        } else
          return this.feature._latlngs;
      },
      ensureMulti: function() {
        this.feature._latlngs.length && w(this.feature._latlngs[0]) && (this.feature._latlngs = [this.feature._latlngs]);
      },
      ensureNotFlat: function() {
        (!this.feature._latlngs.length || w(this.feature._latlngs)) && (this.feature._latlngs = [this.feature._latlngs]);
      },
      vertexCanBeDeleted: function(h) {
        var b = this.feature.parentShape(h.latlngs), T = t.Util.indexOf(b, h.latlngs);
        return T > 0 ? !0 : t.Editable.PathEditor.prototype.vertexCanBeDeleted.call(this, h);
      },
      getDefaultLatLngs: function() {
        return this.feature._latlngs.length || this.feature._latlngs.push([]), this.feature._latlngs[0];
      },
      formatShape: function(h) {
        return w(h) && (!h[0] || h[0].length !== 0) ? [h] : h;
      }
    }), t.Editable.RectangleEditor = t.Editable.PathEditor.extend({
      CLOSED: !0,
      MIN_VERTEX: 4,
      options: {
        skipMiddleMarkers: !0
      },
      extendBounds: function(h) {
        var b = h.vertex.getIndex(), T = h.vertex.getNext(), A = h.vertex.getPrevious(), x = (b + 2) % 4, Z = h.vertex.latlngs[x], H = new t.LatLngBounds(h.latlng, Z);
        A.latlng.update([h.latlng.lat, Z.lng]), T.latlng.update([Z.lat, h.latlng.lng]), this.updateBounds(H), this.refreshVertexMarkers();
      },
      onDrawingMouseDown: function(h) {
        t.Editable.PathEditor.prototype.onDrawingMouseDown.call(this, h), this.connect();
        var b = this.getDefaultLatLngs();
        b.length === 3 && b.push(h.latlng);
        var T = new t.LatLngBounds(h.latlng, h.latlng);
        this.updateBounds(T), this.updateLatLngs(T), this.refresh(), this.reset(), h.originalEvent._simulated = !1, this.map.dragging._draggable._onUp(h.originalEvent), b[3].__vertex.dragging._draggable._onDown(h.originalEvent);
      },
      onDrawingMouseUp: function(h) {
        this.commitDrawing(h), h.originalEvent._simulated = !1, t.Editable.PathEditor.prototype.onDrawingMouseUp.call(this, h);
      },
      onDrawingMouseMove: function(h) {
        h.originalEvent._simulated = !1, t.Editable.PathEditor.prototype.onDrawingMouseMove.call(this, h);
      },
      getDefaultLatLngs: function(h) {
        return h || this.feature._latlngs[0];
      },
      updateBounds: function(h) {
        this.feature._bounds = h;
      },
      updateLatLngs: function(h) {
        for (var b = this.getDefaultLatLngs(), T = this.feature._boundsToLatLngs(h), A = 0; A < b.length; A++)
          b[A].update(T[A]);
      }
    }), t.Editable.CircleEditor = t.Editable.PathEditor.extend({
      MIN_VERTEX: 2,
      options: {
        skipMiddleMarkers: !0
      },
      initialize: function(h, b, T) {
        t.Editable.PathEditor.prototype.initialize.call(this, h, b, T), this._resizeLatLng = this.computeResizeLatLng();
      },
      computeResizeLatLng: function() {
        var h = (this.feature._radius || this.feature._mRadius) * Math.cos(Math.PI / 4), b = this.map.project(this.feature._latlng);
        return this.map.unproject([b.x + h, b.y - h]);
      },
      updateResizeLatLng: function() {
        this._resizeLatLng.update(this.computeResizeLatLng()), this._resizeLatLng.__vertex.update();
      },
      getLatLngs: function() {
        return [this.feature._latlng, this._resizeLatLng];
      },
      getDefaultLatLngs: function() {
        return this.getLatLngs();
      },
      onVertexMarkerDrag: function(h) {
        h.vertex.getIndex() === 1 ? this.resize(h) : this.updateResizeLatLng(h), t.Editable.PathEditor.prototype.onVertexMarkerDrag.call(this, h);
      },
      resize: function(h) {
        var b = this.feature._latlng.distanceTo(h.latlng);
        this.feature.setRadius(b);
      },
      onDrawingMouseDown: function(h) {
        t.Editable.PathEditor.prototype.onDrawingMouseDown.call(this, h), this._resizeLatLng.update(h.latlng), this.feature._latlng.update(h.latlng), this.connect(), h.originalEvent._simulated = !1, this.map.dragging._draggable._onUp(h.originalEvent), this._resizeLatLng.__vertex.dragging._draggable._onDown(h.originalEvent);
      },
      onDrawingMouseUp: function(h) {
        this.commitDrawing(h), h.originalEvent._simulated = !1, t.Editable.PathEditor.prototype.onDrawingMouseUp.call(this, h);
      },
      onDrawingMouseMove: function(h) {
        h.originalEvent._simulated = !1, t.Editable.PathEditor.prototype.onDrawingMouseMove.call(this, h);
      },
      onDrag: function(h) {
        t.Editable.PathEditor.prototype.onDrag.call(this, h), this.feature.dragging.updateLatLng(this._resizeLatLng);
      }
    });
    var a = {
      createEditor: function(h) {
        h = h || this._map;
        var b = (this.options.editOptions || {}).editTools || h.editTools;
        if (!b)
          throw Error("Unable to detect Editable instance.");
        var T = this.options.editorClass || this.getEditorClass(b);
        return new T(h, this, this.options.editOptions);
      },
      // 🍂method enableEdit(map?: L.Map): this.editor
      // Enable editing, by creating an editor if not existing, and then calling `enable` on it.
      enableEdit: function(h) {
        return this.editor || this.createEditor(h), this.editor.enable(), this.editor;
      },
      // 🍂method editEnabled(): boolean
      // Return true if current instance has an editor attached, and this editor is enabled.
      editEnabled: function() {
        return this.editor && this.editor.enabled();
      },
      // 🍂method disableEdit()
      // Disable editing, also remove the editor property reference.
      disableEdit: function() {
        this.editor && (this.editor.disable(), delete this.editor);
      },
      // 🍂method toggleEdit()
      // Enable or disable editing, according to current status.
      toggleEdit: function() {
        this.editEnabled() ? this.disableEdit() : this.enableEdit();
      },
      _onEditableAdd: function() {
        this.editor && this.enableEdit();
      }
    }, u = {
      getEditorClass: function(h) {
        return h && h.options.polylineEditorClass ? h.options.polylineEditorClass : t.Editable.PolylineEditor;
      },
      shapeAt: function(h, b) {
        var T = null;
        if (b = b || this._latlngs, b.length) {
          if (w(b) && this.isInLatLngs(h, b))
            T = b;
          else
            for (var A = 0; A < b.length; A++)
              if (this.isInLatLngs(h, b[A]))
                return b[A];
        } else
          return T;
        return T;
      },
      isInLatLngs: function(h, b) {
        if (!b)
          return !1;
        var T, A, x, Z = [], H, Y = this._clickTolerance();
        if (this._projectLatlngs(b, Z, this._pxBounds), Z = Z[0], H = this._map.latLngToLayerPoint(h), !this._pxBounds.contains(H))
          return !1;
        for (T = 1, x = Z.length, A = 0; T < x; A = T++)
          if (t.LineUtil.pointToSegmentDistance(H, Z[A], Z[T]) <= Y)
            return !0;
        return !1;
      }
    }, f = {
      getEditorClass: function(h) {
        return h && h.options.polygonEditorClass ? h.options.polygonEditorClass : t.Editable.PolygonEditor;
      },
      shapeAt: function(h, b) {
        var T = null;
        if (b = b || this._latlngs, b.length) {
          if (w(b) && this.isInLatLngs(h, b))
            T = b;
          else if (w(b[0]) && this.isInLatLngs(h, b[0]))
            T = b;
          else
            for (var A = 0; A < b.length; A++)
              if (this.isInLatLngs(h, b[A][0]))
                return b[A];
        } else
          return T;
        return T;
      },
      isInLatLngs: function(h, b) {
        var T = !1, A, x, Z, H, Y;
        for (Z = 0, Y = b.length, H = Y - 1; Z < Y; H = Z++)
          A = b[Z], x = b[H], A.lat > h.lat != x.lat > h.lat && h.lng < (x.lng - A.lng) * (h.lat - A.lat) / (x.lat - A.lat) + A.lng && (T = !T);
        return T;
      },
      parentShape: function(h, b) {
        if (b = b || this._latlngs, !!b) {
          var T = t.Util.indexOf(b, h);
          if (T !== -1)
            return b;
          for (var A = 0; A < b.length; A++)
            if (T = t.Util.indexOf(b[A], h), T !== -1)
              return b[A];
        }
      }
    }, d = {
      getEditorClass: function(h) {
        return h && h.options.markerEditorClass ? h.options.markerEditorClass : t.Editable.MarkerEditor;
      }
    }, m = {
      getEditorClass: function(h) {
        return h && h.options.rectangleEditorClass ? h.options.rectangleEditorClass : t.Editable.RectangleEditor;
      }
    }, g = {
      getEditorClass: function(h) {
        return h && h.options.circleEditorClass ? h.options.circleEditorClass : t.Editable.CircleEditor;
      }
    }, y = function() {
      this.on("add", this._onEditableAdd);
    }, w = t.LineUtil.isFlat || t.LineUtil._flat || t.Polyline._flat;
    t.Polyline && (t.Polyline.include(a), t.Polyline.include(u), t.Polyline.addInitHook(y)), t.Polygon && (t.Polygon.include(a), t.Polygon.include(f)), t.Marker && (t.Marker.include(a), t.Marker.include(d), t.Marker.addInitHook(y)), t.Rectangle && (t.Rectangle.include(a), t.Rectangle.include(m)), t.Circle && (t.Circle.include(a), t.Circle.include(g)), t.LatLng.prototype.update = function(h) {
      h = t.latLng(h), this.lat = h.lat, this.lng = h.lng;
    };
  }, window);
})(NA);
L.Control.Fullscreen = L.Control.extend({
  options: {
    position: "topleft",
    title: {
      false: "View Fullscreen",
      true: "Exit Fullscreen"
    }
  },
  onAdd: function(e) {
    var n = L.DomUtil.create("div", "leaflet-control-fullscreen leaflet-bar leaflet-control");
    return this.link = L.DomUtil.create("a", "leaflet-control-fullscreen-button leaflet-bar-part", n), this.link.href = "#", this._map = e, this._map.on("fullscreenchange", this._toggleTitle, this), this._toggleTitle(), L.DomEvent.on(this.link, "click", this._click, this), n;
  },
  _click: function(e) {
    L.DomEvent.stopPropagation(e), L.DomEvent.preventDefault(e), this._map.toggleFullscreen(this.options);
  },
  _toggleTitle: function() {
    this.link.title = this.options.title[this._map.isFullscreen()];
  }
});
L.Map.include({
  isFullscreen: function() {
    return this._isFullscreen || !1;
  },
  toggleFullscreen: function(e) {
    var n = this.getContainer();
    this.isFullscreen() ? e && e.pseudoFullscreen ? this._disablePseudoFullscreen(n) : document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitCancelFullScreen ? document.webkitCancelFullScreen() : document.msExitFullscreen ? document.msExitFullscreen() : this._disablePseudoFullscreen(n) : e && e.pseudoFullscreen ? this._enablePseudoFullscreen(n) : n.requestFullscreen ? n.requestFullscreen() : n.mozRequestFullScreen ? n.mozRequestFullScreen() : n.webkitRequestFullscreen ? n.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT) : n.msRequestFullscreen ? n.msRequestFullscreen() : this._enablePseudoFullscreen(n);
  },
  _enablePseudoFullscreen: function(e) {
    L.DomUtil.addClass(e, "leaflet-pseudo-fullscreen"), this._setFullscreen(!0), this.fire("fullscreenchange");
  },
  _disablePseudoFullscreen: function(e) {
    L.DomUtil.removeClass(e, "leaflet-pseudo-fullscreen"), this._setFullscreen(!1), this.fire("fullscreenchange");
  },
  _setFullscreen: function(e) {
    this._isFullscreen = e;
    var n = this.getContainer();
    e ? L.DomUtil.addClass(n, "leaflet-fullscreen-on") : L.DomUtil.removeClass(n, "leaflet-fullscreen-on"), this.invalidateSize();
  },
  _onFullscreenChange: function(e) {
    var n = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
    n === this.getContainer() && !this._isFullscreen ? (this._setFullscreen(!0), this.fire("fullscreenchange")) : n !== this.getContainer() && this._isFullscreen && (this._setFullscreen(!1), this.fire("fullscreenchange"));
  }
});
L.Map.mergeOptions({
  fullscreenControl: !1
});
L.Map.addInitHook(function() {
  this.options.fullscreenControl && (this.fullscreenControl = new L.Control.Fullscreen(this.options.fullscreenControl), this.addControl(this.fullscreenControl));
  var e;
  if ("onfullscreenchange" in document ? e = "fullscreenchange" : "onmozfullscreenchange" in document ? e = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? e = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (e = "MSFullscreenChange"), e) {
    var n = L.bind(this._onFullscreenChange, this);
    this.whenReady(function() {
      L.DomEvent.on(document, e, n);
    }), this.on("unload", function() {
      L.DomEvent.off(document, e, n);
    });
  }
});
L.control.fullscreen = function(e) {
  return new L.Control.Fullscreen(e);
};
const IA = oe({
  mixins: [hn],
  emits: ["update:model-value", "validate-field"],
  data() {
    return {
      map: null,
      layer: null
    };
  },
  computed: {
    canEditable() {
      return (this.properties.polygon || this.properties.rectangle) && !this.properties.readonly;
    }
  },
  mounted() {
    if (this.map = vi.map(this.$refs.mapContainer, {
      fullscreenControl: !0,
      editable: !this.properties.readonly
    }), this.map.setView(gi.center, gi.zoom), vi.gridLayer.googleMutant(Rh).addTo(this.map), this.value) {
      const e = xA(this.value), { type: n, coordinates: t } = e;
      if (n === "Polygon") {
        const a = vi.GeoJSON.coordsToLatLngs(t, gi.levelDeepPolygon), u = vi.polygon(a, { ...RL });
        u.addTo(this.map), this.canEditable && u.enableEdit(), this.map.fitBounds(u.getBounds()), this.layer = u;
      }
    }
    this.properties.readonly || (this.map.on("editable:drawing:end", this.updateModel), this.map.on("editable:vertex:dragend", this.updateModel), this.map.on("editable:vertex:deleted", this.updateModel));
  },
  unmounted() {
    this.properties.readonly || (this.map.off("editable:drawing:end", this.updateModel), this.map.off("editable:vertex:dragend", this.updateModel), this.map.off("editable:vertex:deleted", this.updateModel));
  },
  methods: {
    updateModel({ layer: e }) {
      this.layer = e;
      const n = e.toGeoJSON();
      this.model = OA(n), this.$emit("validate-field", this.scope);
    },
    onStartPolygonClick() {
      this.layer && (this.layer.removeFrom(this.map), this.model = null), this.map.editTools.startPolygon();
    },
    onStartRectangleClick() {
      this.layer && (this.layer.removeFrom(this.map), this.model = null), this.map.editTools.startRectangle();
    },
    onDeleteClick() {
      this.layer && (this.layer.removeFrom(this.map), this.model = null);
    }
  },
  components: {
    DialogComponent: Ls
  }
}), kA = "_component_kak15_1", DA = "_component__map_kak15_4", $A = "_component__draw_kak15_11", RA = "_component__button_kak15_22", zA = "_component__polygon_kak15_31", BA = "_component__rectangle_kak15_46", FA = {
  component: kA,
  component__map: DA,
  component__draw: $A,
  component__button: RA,
  component__polygon: zA,
  component__rectangle: BA
}, UA = ["disabled"], VA = ["disabled"], HA = ["disabled"];
function jA(e, n, t, a, u, f) {
  const d = D("form-label-component"), m = D("icon-delete-filled"), g = D("el-icon"), y = D("form-error-component"), w = D("el-form-item");
  return V(), X(w, {
    class: J(e.$style.component),
    prop: e.scope,
    rules: e.rules
  }, Tt({
    error: k(({ error: h }) => [
      z(y, {
        error: h[e.locale]
      }, null, 8, ["error"])
    ]),
    default: k(() => [
      ae("div", {
        class: J(e.$style.component__map),
        ref: "mapContainer"
      }, [
        e.canEditable ? (V(), ue("div", {
          key: 0,
          class: J(e.$style.component__draw)
        }, [
          e.properties.polygon ? (V(), ue("button", {
            key: 0,
            class: J([e.$style.component__button, e.$style.component__polygon]),
            disabled: e.disabled,
            onClick: n[0] || (n[0] = fo((...h) => e.onStartPolygonClick && e.onStartPolygonClick(...h), ["stop", "prevent"]))
          }, null, 10, UA)) : Ze("", !0),
          e.properties.rectangle ? (V(), ue("button", {
            key: 1,
            class: J([e.$style.component__button, e.$style.component__rectangle]),
            disabled: e.disabled,
            onClick: n[1] || (n[1] = fo((...h) => e.onStartRectangleClick && e.onStartRectangleClick(...h), ["stop", "prevent"]))
          }, null, 10, VA)) : Ze("", !0),
          ae("button", {
            class: J(e.$style.component__button),
            disabled: e.disabled,
            onClick: n[2] || (n[2] = fo((...h) => e.onDeleteClick && e.onDeleteClick(...h), ["stop", "prevent"]))
          }, [
            z(g, null, {
              default: k(() => [
                z(m)
              ]),
              _: 1
            })
          ], 10, HA)
        ], 2)) : Ze("", !0)
      ], 2)
    ]),
    _: 2
  }, [
    e.label ? {
      name: "label",
      fn: k(() => [
        z(d, {
          label: e.label,
          rules: e.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["class", "prop", "rules"]);
}
const ZA = {
  $style: FA
}, WA = /* @__PURE__ */ ce(IA, [["render", jA], ["__cssModules", ZA]]), GA = oe({
  mixins: [hn],
  methods: {
    onInput(e) {
      this.model = e;
    }
  }
}), qA = {
  "hide-controls": "_hide-controls_mcv3q_1"
};
function KA(e, n, t, a, u, f) {
  const d = D("form-label-component"), m = D("el-input-number"), g = D("form-error-component"), y = D("el-form-item");
  return V(), X(y, {
    prop: e.scope,
    rules: e.rules
  }, Tt({
    error: k(({ error: w }) => [
      z(g, {
        error: w[e.locale]
      }, null, 8, ["error"])
    ]),
    default: k(() => {
      var w;
      return [
        z(m, {
          "model-value": e.model,
          class: J({ [e.$style["hide-controls"]]: e.properties.hideControls }),
          placeholder: (w = e.properties.placeholder) == null ? void 0 : w[e.locale],
          min: e.properties.min,
          max: e.properties.max,
          controls: !e.properties.hideControls,
          disabled: e.disabled,
          onInput: e.onInput
        }, null, 8, ["model-value", "class", "placeholder", "min", "max", "controls", "disabled", "onInput"])
      ];
    }),
    _: 2
  }, [
    e.label ? {
      name: "label",
      fn: k(() => [
        z(d, {
          label: e.label,
          rules: e.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const YA = {
  $style: qA
}, QA = /* @__PURE__ */ ce(GA, [["render", KA], ["__cssModules", YA]]), JA = oe({
  mixins: [hn]
}), XA = ["innerHTML"];
function eP(e, n, t, a, u, f) {
  const d = D("form-label-component"), m = D("el-radio"), g = D("el-radio-group"), y = D("form-error-component"), w = D("el-form-item");
  return V(), X(w, {
    prop: e.scope,
    rules: e.rules
  }, Tt({
    error: k(({ error: h }) => [
      z(y, {
        error: h[e.locale]
      }, null, 8, ["error"])
    ]),
    default: k(() => [
      z(g, {
        modelValue: e.model,
        "onUpdate:modelValue": n[0] || (n[0] = (h) => e.model = h),
        disabled: e.disabled
      }, {
        default: k(() => [
          (V(!0), ue(st, null, Et(e.properties.enum, (h, b) => (V(), X(m, {
            key: b,
            label: h.value,
            size: "default"
          }, {
            default: k(() => [
              ae("span", {
                innerHTML: h.text[e.locale]
              }, null, 8, XA)
            ]),
            _: 2
          }, 1032, ["label"]))), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ]),
    _: 2
  }, [
    e.label ? {
      name: "label",
      fn: k(() => [
        z(d, {
          label: e.label,
          rules: e.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const tP = /* @__PURE__ */ ce(JA, [["render", eP]]), nP = oe({
  mixins: [hn],
  computed: {
    model: {
      get() {
        return this.properties.multiple ? Array.isArray(this.value) ? this.value : [] : this.value;
      },
      set(e) {
        e && this.$emit("update:model-value", ke.set(this.modelValue, this.path, e));
      }
    }
  },
  methods: {
    onClearClick() {
      this.$emit("update:model-value", ke.set(this.modelValue, this.path, null));
    }
  }
});
function iP(e, n, t, a, u, f) {
  const d = D("form-label-component"), m = D("el-option"), g = D("el-select"), y = D("form-error-component"), w = D("el-form-item");
  return V(), X(w, {
    prop: e.scope,
    rules: e.rules
  }, Tt({
    error: k(({ error: h }) => [
      z(y, {
        error: h[e.locale]
      }, null, 8, ["error"])
    ]),
    default: k(() => {
      var h;
      return [
        z(g, {
          modelValue: e.model,
          "onUpdate:modelValue": n[0] || (n[0] = (b) => e.model = b),
          placeholder: ((h = e.properties.placeholder) == null ? void 0 : h[e.locale]) || " ",
          multiple: e.properties.multiple,
          clearable: e.properties.clearable,
          disabled: e.disabled,
          onClear: e.onClearClick
        }, {
          default: k(() => [
            (V(!0), ue(st, null, Et(e.properties.enum, (b, T) => (V(), X(m, {
              key: T,
              label: b.text[e.locale],
              value: b.value
            }, null, 8, ["label", "value"]))), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "multiple", "clearable", "disabled", "onClear"])
      ];
    }),
    _: 2
  }, [
    e.label ? {
      name: "label",
      fn: k(() => [
        z(d, {
          label: e.label,
          rules: e.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const rP = /* @__PURE__ */ ce(nP, [["render", iP]]);
var oP = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var n = {}, t = Symbol("test"), a = Object(t);
  if (typeof t == "string" || Object.prototype.toString.call(t) !== "[object Symbol]" || Object.prototype.toString.call(a) !== "[object Symbol]")
    return !1;
  var u = 42;
  n[t] = u;
  for (t in n)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(n).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(n).length !== 0)
    return !1;
  var f = Object.getOwnPropertySymbols(n);
  if (f.length !== 1 || f[0] !== t || !Object.prototype.propertyIsEnumerable.call(n, t))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var d = Object.getOwnPropertyDescriptor(n, t);
    if (d.value !== u || d.enumerable !== !0)
      return !1;
  }
  return !0;
}, qp = typeof Symbol < "u" && Symbol, sP = oP, aP = function() {
  return typeof qp != "function" || typeof Symbol != "function" || typeof qp("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : sP();
}, Kp = {
  foo: {}
}, lP = Object, uP = function() {
  return { __proto__: Kp }.foo === Kp.foo && !({ __proto__: null } instanceof lP);
}, cP = "Function.prototype.bind called on incompatible ", vh = Array.prototype.slice, hP = Object.prototype.toString, fP = "[object Function]", dP = function(n) {
  var t = this;
  if (typeof t != "function" || hP.call(t) !== fP)
    throw new TypeError(cP + t);
  for (var a = vh.call(arguments, 1), u, f = function() {
    if (this instanceof u) {
      var w = t.apply(
        this,
        a.concat(vh.call(arguments))
      );
      return Object(w) === w ? w : this;
    } else
      return t.apply(
        n,
        a.concat(vh.call(arguments))
      );
  }, d = Math.max(0, t.length - a.length), m = [], g = 0; g < d; g++)
    m.push("$" + g);
  if (u = Function("binder", "return function (" + m.join(",") + "){ return binder.apply(this,arguments); }")(f), t.prototype) {
    var y = function() {
    };
    y.prototype = t.prototype, u.prototype = new y(), y.prototype = null;
  }
  return u;
}, pP = dP, yf = Function.prototype.bind || pP, mP = yf, _P = mP.call(Function.call, Object.prototype.hasOwnProperty), $e, gs = SyntaxError, L_ = Function, ds = TypeError, yh = function(e) {
  try {
    return L_('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, po = Object.getOwnPropertyDescriptor;
if (po)
  try {
    po({}, "");
  } catch {
    po = null;
  }
var bh = function() {
  throw new ds();
}, gP = po ? function() {
  try {
    return arguments.callee, bh;
  } catch {
    try {
      return po(arguments, "callee").get;
    } catch {
      return bh;
    }
  }
}() : bh, is = aP(), vP = uP(), Rt = Object.getPrototypeOf || (vP ? function(e) {
  return e.__proto__;
} : null), us = {}, yP = typeof Uint8Array > "u" || !Rt ? $e : Rt(Uint8Array), mo = {
  "%AggregateError%": typeof AggregateError > "u" ? $e : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? $e : ArrayBuffer,
  "%ArrayIteratorPrototype%": is && Rt ? Rt([][Symbol.iterator]()) : $e,
  "%AsyncFromSyncIteratorPrototype%": $e,
  "%AsyncFunction%": us,
  "%AsyncGenerator%": us,
  "%AsyncGeneratorFunction%": us,
  "%AsyncIteratorPrototype%": us,
  "%Atomics%": typeof Atomics > "u" ? $e : Atomics,
  "%BigInt%": typeof BigInt > "u" ? $e : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? $e : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? $e : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? $e : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? $e : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? $e : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? $e : FinalizationRegistry,
  "%Function%": L_,
  "%GeneratorFunction%": us,
  "%Int8Array%": typeof Int8Array > "u" ? $e : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? $e : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? $e : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": is && Rt ? Rt(Rt([][Symbol.iterator]())) : $e,
  "%JSON%": typeof JSON == "object" ? JSON : $e,
  "%Map%": typeof Map > "u" ? $e : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !is || !Rt ? $e : Rt((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? $e : Promise,
  "%Proxy%": typeof Proxy > "u" ? $e : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? $e : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? $e : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !is || !Rt ? $e : Rt((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? $e : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": is && Rt ? Rt(""[Symbol.iterator]()) : $e,
  "%Symbol%": is ? Symbol : $e,
  "%SyntaxError%": gs,
  "%ThrowTypeError%": gP,
  "%TypedArray%": yP,
  "%TypeError%": ds,
  "%Uint8Array%": typeof Uint8Array > "u" ? $e : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? $e : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? $e : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? $e : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? $e : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? $e : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? $e : WeakSet
};
if (Rt)
  try {
    null.error;
  } catch (e) {
    var bP = Rt(Rt(e));
    mo["%Error.prototype%"] = bP;
  }
var wP = function e(n) {
  var t;
  if (n === "%AsyncFunction%")
    t = yh("async function () {}");
  else if (n === "%GeneratorFunction%")
    t = yh("function* () {}");
  else if (n === "%AsyncGeneratorFunction%")
    t = yh("async function* () {}");
  else if (n === "%AsyncGenerator%") {
    var a = e("%AsyncGeneratorFunction%");
    a && (t = a.prototype);
  } else if (n === "%AsyncIteratorPrototype%") {
    var u = e("%AsyncGenerator%");
    u && Rt && (t = Rt(u.prototype));
  }
  return mo[n] = t, t;
}, Yp = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, Ra = yf, mu = _P, LP = Ra.call(Function.call, Array.prototype.concat), SP = Ra.call(Function.apply, Array.prototype.splice), Qp = Ra.call(Function.call, String.prototype.replace), _u = Ra.call(Function.call, String.prototype.slice), CP = Ra.call(Function.call, RegExp.prototype.exec), MP = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, TP = /\\(\\)?/g, EP = function(n) {
  var t = _u(n, 0, 1), a = _u(n, -1);
  if (t === "%" && a !== "%")
    throw new gs("invalid intrinsic syntax, expected closing `%`");
  if (a === "%" && t !== "%")
    throw new gs("invalid intrinsic syntax, expected opening `%`");
  var u = [];
  return Qp(n, MP, function(f, d, m, g) {
    u[u.length] = m ? Qp(g, TP, "$1") : d || f;
  }), u;
}, AP = function(n, t) {
  var a = n, u;
  if (mu(Yp, a) && (u = Yp[a], a = "%" + u[0] + "%"), mu(mo, a)) {
    var f = mo[a];
    if (f === us && (f = wP(a)), typeof f > "u" && !t)
      throw new ds("intrinsic " + n + " exists, but is not available. Please file an issue!");
    return {
      alias: u,
      name: a,
      value: f
    };
  }
  throw new gs("intrinsic " + n + " does not exist!");
}, bf = function(n, t) {
  if (typeof n != "string" || n.length === 0)
    throw new ds("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof t != "boolean")
    throw new ds('"allowMissing" argument must be a boolean');
  if (CP(/^%?[^%]*%?$/, n) === null)
    throw new gs("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var a = EP(n), u = a.length > 0 ? a[0] : "", f = AP("%" + u + "%", t), d = f.name, m = f.value, g = !1, y = f.alias;
  y && (u = y[0], SP(a, LP([0, 1], y)));
  for (var w = 1, h = !0; w < a.length; w += 1) {
    var b = a[w], T = _u(b, 0, 1), A = _u(b, -1);
    if ((T === '"' || T === "'" || T === "`" || A === '"' || A === "'" || A === "`") && T !== A)
      throw new gs("property names with quotes must have matching quotes");
    if ((b === "constructor" || !h) && (g = !0), u += "." + b, d = "%" + u + "%", mu(mo, d))
      m = mo[d];
    else if (m != null) {
      if (!(b in m)) {
        if (!t)
          throw new ds("base intrinsic for " + n + " exists, but the property is not available.");
        return;
      }
      if (po && w + 1 >= a.length) {
        var x = po(m, b);
        h = !!x, h && "get" in x && !("originalValue" in x.get) ? m = x.get : m = m[b];
      } else
        h = mu(m, b), m = m[b];
      h && !g && (mo[d] = m);
    }
  }
  return m;
}, S_ = { exports: {} };
(function(e) {
  var n = yf, t = bf, a = t("%Function.prototype.apply%"), u = t("%Function.prototype.call%"), f = t("%Reflect.apply%", !0) || n.call(u, a), d = t("%Object.getOwnPropertyDescriptor%", !0), m = t("%Object.defineProperty%", !0), g = t("%Math.max%");
  if (m)
    try {
      m({}, "a", { value: 1 });
    } catch {
      m = null;
    }
  e.exports = function(h) {
    var b = f(n, u, arguments);
    if (d && m) {
      var T = d(b, "length");
      T.configurable && m(
        b,
        "length",
        { value: 1 + g(0, h.length - (arguments.length - 1)) }
      );
    }
    return b;
  };
  var y = function() {
    return f(n, a, arguments);
  };
  m ? m(e.exports, "apply", { value: y }) : e.exports.apply = y;
})(S_);
var PP = S_.exports, C_ = bf, M_ = PP, xP = M_(C_("String.prototype.indexOf")), OP = function(n, t) {
  var a = C_(n, !!t);
  return typeof a == "function" && xP(n, ".prototype.") > -1 ? M_(a) : a;
};
const NP = {}, IP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NP
}, Symbol.toStringTag, { value: "Module" })), kP = /* @__PURE__ */ SC(IP);
var wf = typeof Map == "function" && Map.prototype, wh = Object.getOwnPropertyDescriptor && wf ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, gu = wf && wh && typeof wh.get == "function" ? wh.get : null, Jp = wf && Map.prototype.forEach, Lf = typeof Set == "function" && Set.prototype, Lh = Object.getOwnPropertyDescriptor && Lf ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, vu = Lf && Lh && typeof Lh.get == "function" ? Lh.get : null, Xp = Lf && Set.prototype.forEach, DP = typeof WeakMap == "function" && WeakMap.prototype, xa = DP ? WeakMap.prototype.has : null, $P = typeof WeakSet == "function" && WeakSet.prototype, Oa = $P ? WeakSet.prototype.has : null, RP = typeof WeakRef == "function" && WeakRef.prototype, em = RP ? WeakRef.prototype.deref : null, zP = Boolean.prototype.valueOf, BP = Object.prototype.toString, FP = Function.prototype.toString, UP = String.prototype.match, Sf = String.prototype.slice, Mr = String.prototype.replace, VP = String.prototype.toUpperCase, tm = String.prototype.toLowerCase, T_ = RegExp.prototype.test, nm = Array.prototype.concat, yi = Array.prototype.join, HP = Array.prototype.slice, im = Math.floor, Zh = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, Sh = Object.getOwnPropertySymbols, Wh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, vs = typeof Symbol == "function" && typeof Symbol.iterator == "object", Jt = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === vs || "symbol") ? Symbol.toStringTag : null, E_ = Object.prototype.propertyIsEnumerable, rm = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(e) {
  return e.__proto__;
} : null);
function om(e, n) {
  if (e === 1 / 0 || e === -1 / 0 || e !== e || e && e > -1e3 && e < 1e3 || T_.call(/e/, n))
    return n;
  var t = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof e == "number") {
    var a = e < 0 ? -im(-e) : im(e);
    if (a !== e) {
      var u = String(a), f = Sf.call(n, u.length + 1);
      return Mr.call(u, t, "$&_") + "." + Mr.call(Mr.call(f, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return Mr.call(n, t, "$&_");
}
var Gh = kP, sm = Gh.custom, am = P_(sm) ? sm : null, jP = function e(n, t, a, u) {
  var f = t || {};
  if (Lr(f, "quoteStyle") && f.quoteStyle !== "single" && f.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (Lr(f, "maxStringLength") && (typeof f.maxStringLength == "number" ? f.maxStringLength < 0 && f.maxStringLength !== 1 / 0 : f.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var d = Lr(f, "customInspect") ? f.customInspect : !0;
  if (typeof d != "boolean" && d !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (Lr(f, "indent") && f.indent !== null && f.indent !== "	" && !(parseInt(f.indent, 10) === f.indent && f.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (Lr(f, "numericSeparator") && typeof f.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var m = f.numericSeparator;
  if (typeof n > "u")
    return "undefined";
  if (n === null)
    return "null";
  if (typeof n == "boolean")
    return n ? "true" : "false";
  if (typeof n == "string")
    return O_(n, f);
  if (typeof n == "number") {
    if (n === 0)
      return 1 / 0 / n > 0 ? "0" : "-0";
    var g = String(n);
    return m ? om(n, g) : g;
  }
  if (typeof n == "bigint") {
    var y = String(n) + "n";
    return m ? om(n, y) : y;
  }
  var w = typeof f.depth > "u" ? 5 : f.depth;
  if (typeof a > "u" && (a = 0), a >= w && w > 0 && typeof n == "object")
    return qh(n) ? "[Array]" : "[Object]";
  var h = lx(f, a);
  if (typeof u > "u")
    u = [];
  else if (x_(u, n) >= 0)
    return "[Circular]";
  function b(wn, At, Ki) {
    if (At && (u = HP.call(u), u.push(At)), Ki) {
      var gt = {
        depth: f.depth
      };
      return Lr(f, "quoteStyle") && (gt.quoteStyle = f.quoteStyle), e(wn, gt, a + 1, u);
    }
    return e(wn, f, a + 1, u);
  }
  if (typeof n == "function" && !lm(n)) {
    var T = XP(n), A = Jl(n, b);
    return "[Function" + (T ? ": " + T : " (anonymous)") + "]" + (A.length > 0 ? " { " + yi.call(A, ", ") + " }" : "");
  }
  if (P_(n)) {
    var x = vs ? Mr.call(String(n), /^(Symbol\(.*\))_[^)]*$/, "$1") : Wh.call(n);
    return typeof n == "object" && !vs ? wa(x) : x;
  }
  if (ox(n)) {
    for (var Z = "<" + tm.call(String(n.nodeName)), H = n.attributes || [], Y = 0; Y < H.length; Y++)
      Z += " " + H[Y].name + "=" + A_(ZP(H[Y].value), "double", f);
    return Z += ">", n.childNodes && n.childNodes.length && (Z += "..."), Z += "</" + tm.call(String(n.nodeName)) + ">", Z;
  }
  if (qh(n)) {
    if (n.length === 0)
      return "[]";
    var ee = Jl(n, b);
    return h && !ax(ee) ? "[" + Kh(ee, h) + "]" : "[ " + yi.call(ee, ", ") + " ]";
  }
  if (GP(n)) {
    var re = Jl(n, b);
    return !("cause" in Error.prototype) && "cause" in n && !E_.call(n, "cause") ? "{ [" + String(n) + "] " + yi.call(nm.call("[cause]: " + b(n.cause), re), ", ") + " }" : re.length === 0 ? "[" + String(n) + "]" : "{ [" + String(n) + "] " + yi.call(re, ", ") + " }";
  }
  if (typeof n == "object" && d) {
    if (am && typeof n[am] == "function" && Gh)
      return Gh(n, { depth: w - a });
    if (d !== "symbol" && typeof n.inspect == "function")
      return n.inspect();
  }
  if (ex(n)) {
    var be = [];
    return Jp && Jp.call(n, function(wn, At) {
      be.push(b(At, n, !0) + " => " + b(wn, n));
    }), um("Map", gu.call(n), be, h);
  }
  if (ix(n)) {
    var Xe = [];
    return Xp && Xp.call(n, function(wn) {
      Xe.push(b(wn, n));
    }), um("Set", vu.call(n), Xe, h);
  }
  if (tx(n))
    return Ch("WeakMap");
  if (rx(n))
    return Ch("WeakSet");
  if (nx(n))
    return Ch("WeakRef");
  if (KP(n))
    return wa(b(Number(n)));
  if (QP(n))
    return wa(b(Zh.call(n)));
  if (YP(n))
    return wa(zP.call(n));
  if (qP(n))
    return wa(b(String(n)));
  if (!WP(n) && !lm(n)) {
    var Fe = Jl(n, b), ge = rm ? rm(n) === Object.prototype : n instanceof Object || n.constructor === Object, qe = n instanceof Object ? "" : "null prototype", at = !ge && Jt && Object(n) === n && Jt in n ? Sf.call(Nr(n), 8, -1) : qe ? "Object" : "", _t = ge || typeof n.constructor != "function" ? "" : n.constructor.name ? n.constructor.name + " " : "", nt = _t + (at || qe ? "[" + yi.call(nm.call([], at || [], qe || []), ": ") + "] " : "");
    return Fe.length === 0 ? nt + "{}" : h ? nt + "{" + Kh(Fe, h) + "}" : nt + "{ " + yi.call(Fe, ", ") + " }";
  }
  return String(n);
};
function A_(e, n, t) {
  var a = (t.quoteStyle || n) === "double" ? '"' : "'";
  return a + e + a;
}
function ZP(e) {
  return Mr.call(String(e), /"/g, "&quot;");
}
function qh(e) {
  return Nr(e) === "[object Array]" && (!Jt || !(typeof e == "object" && Jt in e));
}
function WP(e) {
  return Nr(e) === "[object Date]" && (!Jt || !(typeof e == "object" && Jt in e));
}
function lm(e) {
  return Nr(e) === "[object RegExp]" && (!Jt || !(typeof e == "object" && Jt in e));
}
function GP(e) {
  return Nr(e) === "[object Error]" && (!Jt || !(typeof e == "object" && Jt in e));
}
function qP(e) {
  return Nr(e) === "[object String]" && (!Jt || !(typeof e == "object" && Jt in e));
}
function KP(e) {
  return Nr(e) === "[object Number]" && (!Jt || !(typeof e == "object" && Jt in e));
}
function YP(e) {
  return Nr(e) === "[object Boolean]" && (!Jt || !(typeof e == "object" && Jt in e));
}
function P_(e) {
  if (vs)
    return e && typeof e == "object" && e instanceof Symbol;
  if (typeof e == "symbol")
    return !0;
  if (!e || typeof e != "object" || !Wh)
    return !1;
  try {
    return Wh.call(e), !0;
  } catch {
  }
  return !1;
}
function QP(e) {
  if (!e || typeof e != "object" || !Zh)
    return !1;
  try {
    return Zh.call(e), !0;
  } catch {
  }
  return !1;
}
var JP = Object.prototype.hasOwnProperty || function(e) {
  return e in this;
};
function Lr(e, n) {
  return JP.call(e, n);
}
function Nr(e) {
  return BP.call(e);
}
function XP(e) {
  if (e.name)
    return e.name;
  var n = UP.call(FP.call(e), /^function\s*([\w$]+)/);
  return n ? n[1] : null;
}
function x_(e, n) {
  if (e.indexOf)
    return e.indexOf(n);
  for (var t = 0, a = e.length; t < a; t++)
    if (e[t] === n)
      return t;
  return -1;
}
function ex(e) {
  if (!gu || !e || typeof e != "object")
    return !1;
  try {
    gu.call(e);
    try {
      vu.call(e);
    } catch {
      return !0;
    }
    return e instanceof Map;
  } catch {
  }
  return !1;
}
function tx(e) {
  if (!xa || !e || typeof e != "object")
    return !1;
  try {
    xa.call(e, xa);
    try {
      Oa.call(e, Oa);
    } catch {
      return !0;
    }
    return e instanceof WeakMap;
  } catch {
  }
  return !1;
}
function nx(e) {
  if (!em || !e || typeof e != "object")
    return !1;
  try {
    return em.call(e), !0;
  } catch {
  }
  return !1;
}
function ix(e) {
  if (!vu || !e || typeof e != "object")
    return !1;
  try {
    vu.call(e);
    try {
      gu.call(e);
    } catch {
      return !0;
    }
    return e instanceof Set;
  } catch {
  }
  return !1;
}
function rx(e) {
  if (!Oa || !e || typeof e != "object")
    return !1;
  try {
    Oa.call(e, Oa);
    try {
      xa.call(e, xa);
    } catch {
      return !0;
    }
    return e instanceof WeakSet;
  } catch {
  }
  return !1;
}
function ox(e) {
  return !e || typeof e != "object" ? !1 : typeof HTMLElement < "u" && e instanceof HTMLElement ? !0 : typeof e.nodeName == "string" && typeof e.getAttribute == "function";
}
function O_(e, n) {
  if (e.length > n.maxStringLength) {
    var t = e.length - n.maxStringLength, a = "... " + t + " more character" + (t > 1 ? "s" : "");
    return O_(Sf.call(e, 0, n.maxStringLength), n) + a;
  }
  var u = Mr.call(Mr.call(e, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, sx);
  return A_(u, "single", n);
}
function sx(e) {
  var n = e.charCodeAt(0), t = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[n];
  return t ? "\\" + t : "\\x" + (n < 16 ? "0" : "") + VP.call(n.toString(16));
}
function wa(e) {
  return "Object(" + e + ")";
}
function Ch(e) {
  return e + " { ? }";
}
function um(e, n, t, a) {
  var u = a ? Kh(t, a) : yi.call(t, ", ");
  return e + " (" + n + ") {" + u + "}";
}
function ax(e) {
  for (var n = 0; n < e.length; n++)
    if (x_(e[n], `
`) >= 0)
      return !1;
  return !0;
}
function lx(e, n) {
  var t;
  if (e.indent === "	")
    t = "	";
  else if (typeof e.indent == "number" && e.indent > 0)
    t = yi.call(Array(e.indent + 1), " ");
  else
    return null;
  return {
    base: t,
    prev: yi.call(Array(n + 1), t)
  };
}
function Kh(e, n) {
  if (e.length === 0)
    return "";
  var t = `
` + n.prev + n.base;
  return t + yi.call(e, "," + t) + `
` + n.prev;
}
function Jl(e, n) {
  var t = qh(e), a = [];
  if (t) {
    a.length = e.length;
    for (var u = 0; u < e.length; u++)
      a[u] = Lr(e, u) ? n(e[u], e) : "";
  }
  var f = typeof Sh == "function" ? Sh(e) : [], d;
  if (vs) {
    d = {};
    for (var m = 0; m < f.length; m++)
      d["$" + f[m]] = f[m];
  }
  for (var g in e)
    Lr(e, g) && (t && String(Number(g)) === g && g < e.length || vs && d["$" + g] instanceof Symbol || (T_.call(/[^\w$]/, g) ? a.push(n(g, e) + ": " + n(e[g], e)) : a.push(g + ": " + n(e[g], e))));
  if (typeof Sh == "function")
    for (var y = 0; y < f.length; y++)
      E_.call(e, f[y]) && a.push("[" + n(f[y]) + "]: " + n(e[f[y]], e));
  return a;
}
var Cf = bf, Ts = OP, ux = jP, cx = Cf("%TypeError%"), Xl = Cf("%WeakMap%", !0), eu = Cf("%Map%", !0), hx = Ts("WeakMap.prototype.get", !0), fx = Ts("WeakMap.prototype.set", !0), dx = Ts("WeakMap.prototype.has", !0), px = Ts("Map.prototype.get", !0), mx = Ts("Map.prototype.set", !0), _x = Ts("Map.prototype.has", !0), Mf = function(e, n) {
  for (var t = e, a; (a = t.next) !== null; t = a)
    if (a.key === n)
      return t.next = a.next, a.next = e.next, e.next = a, a;
}, gx = function(e, n) {
  var t = Mf(e, n);
  return t && t.value;
}, vx = function(e, n, t) {
  var a = Mf(e, n);
  a ? a.value = t : e.next = {
    // eslint-disable-line no-param-reassign
    key: n,
    next: e.next,
    value: t
  };
}, yx = function(e, n) {
  return !!Mf(e, n);
}, bx = function() {
  var n, t, a, u = {
    assert: function(f) {
      if (!u.has(f))
        throw new cx("Side channel does not contain " + ux(f));
    },
    get: function(f) {
      if (Xl && f && (typeof f == "object" || typeof f == "function")) {
        if (n)
          return hx(n, f);
      } else if (eu) {
        if (t)
          return px(t, f);
      } else if (a)
        return gx(a, f);
    },
    has: function(f) {
      if (Xl && f && (typeof f == "object" || typeof f == "function")) {
        if (n)
          return dx(n, f);
      } else if (eu) {
        if (t)
          return _x(t, f);
      } else if (a)
        return yx(a, f);
      return !1;
    },
    set: function(f, d) {
      Xl && f && (typeof f == "object" || typeof f == "function") ? (n || (n = new Xl()), fx(n, f, d)) : eu ? (t || (t = new eu()), mx(t, f, d)) : (a || (a = { key: {}, next: null }), vx(a, f, d));
    }
  };
  return u;
}, wx = String.prototype.replace, Lx = /%20/g, Mh = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, Tf = {
  default: Mh.RFC3986,
  formatters: {
    RFC1738: function(e) {
      return wx.call(e, Lx, "+");
    },
    RFC3986: function(e) {
      return String(e);
    }
  },
  RFC1738: Mh.RFC1738,
  RFC3986: Mh.RFC3986
}, Sx = Tf, Th = Object.prototype.hasOwnProperty, ho = Array.isArray, _i = function() {
  for (var e = [], n = 0; n < 256; ++n)
    e.push("%" + ((n < 16 ? "0" : "") + n.toString(16)).toUpperCase());
  return e;
}(), Cx = function(n) {
  for (; n.length > 1; ) {
    var t = n.pop(), a = t.obj[t.prop];
    if (ho(a)) {
      for (var u = [], f = 0; f < a.length; ++f)
        typeof a[f] < "u" && u.push(a[f]);
      t.obj[t.prop] = u;
    }
  }
}, N_ = function(n, t) {
  for (var a = t && t.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, u = 0; u < n.length; ++u)
    typeof n[u] < "u" && (a[u] = n[u]);
  return a;
}, Mx = function e(n, t, a) {
  if (!t)
    return n;
  if (typeof t != "object") {
    if (ho(n))
      n.push(t);
    else if (n && typeof n == "object")
      (a && (a.plainObjects || a.allowPrototypes) || !Th.call(Object.prototype, t)) && (n[t] = !0);
    else
      return [n, t];
    return n;
  }
  if (!n || typeof n != "object")
    return [n].concat(t);
  var u = n;
  return ho(n) && !ho(t) && (u = N_(n, a)), ho(n) && ho(t) ? (t.forEach(function(f, d) {
    if (Th.call(n, d)) {
      var m = n[d];
      m && typeof m == "object" && f && typeof f == "object" ? n[d] = e(m, f, a) : n.push(f);
    } else
      n[d] = f;
  }), n) : Object.keys(t).reduce(function(f, d) {
    var m = t[d];
    return Th.call(f, d) ? f[d] = e(f[d], m, a) : f[d] = m, f;
  }, u);
}, Tx = function(n, t) {
  return Object.keys(t).reduce(function(a, u) {
    return a[u] = t[u], a;
  }, n);
}, Ex = function(e, n, t) {
  var a = e.replace(/\+/g, " ");
  if (t === "iso-8859-1")
    return a.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(a);
  } catch {
    return a;
  }
}, Ax = function(n, t, a, u, f) {
  if (n.length === 0)
    return n;
  var d = n;
  if (typeof n == "symbol" ? d = Symbol.prototype.toString.call(n) : typeof n != "string" && (d = String(n)), a === "iso-8859-1")
    return escape(d).replace(/%u[0-9a-f]{4}/gi, function(w) {
      return "%26%23" + parseInt(w.slice(2), 16) + "%3B";
    });
  for (var m = "", g = 0; g < d.length; ++g) {
    var y = d.charCodeAt(g);
    if (y === 45 || y === 46 || y === 95 || y === 126 || y >= 48 && y <= 57 || y >= 65 && y <= 90 || y >= 97 && y <= 122 || f === Sx.RFC1738 && (y === 40 || y === 41)) {
      m += d.charAt(g);
      continue;
    }
    if (y < 128) {
      m = m + _i[y];
      continue;
    }
    if (y < 2048) {
      m = m + (_i[192 | y >> 6] + _i[128 | y & 63]);
      continue;
    }
    if (y < 55296 || y >= 57344) {
      m = m + (_i[224 | y >> 12] + _i[128 | y >> 6 & 63] + _i[128 | y & 63]);
      continue;
    }
    g += 1, y = 65536 + ((y & 1023) << 10 | d.charCodeAt(g) & 1023), m += _i[240 | y >> 18] + _i[128 | y >> 12 & 63] + _i[128 | y >> 6 & 63] + _i[128 | y & 63];
  }
  return m;
}, Px = function(n) {
  for (var t = [{ obj: { o: n }, prop: "o" }], a = [], u = 0; u < t.length; ++u)
    for (var f = t[u], d = f.obj[f.prop], m = Object.keys(d), g = 0; g < m.length; ++g) {
      var y = m[g], w = d[y];
      typeof w == "object" && w !== null && a.indexOf(w) === -1 && (t.push({ obj: d, prop: y }), a.push(w));
    }
  return Cx(t), n;
}, xx = function(n) {
  return Object.prototype.toString.call(n) === "[object RegExp]";
}, Ox = function(n) {
  return !n || typeof n != "object" ? !1 : !!(n.constructor && n.constructor.isBuffer && n.constructor.isBuffer(n));
}, Nx = function(n, t) {
  return [].concat(n, t);
}, Ix = function(n, t) {
  if (ho(n)) {
    for (var a = [], u = 0; u < n.length; u += 1)
      a.push(t(n[u]));
    return a;
  }
  return t(n);
}, I_ = {
  arrayToObject: N_,
  assign: Tx,
  combine: Nx,
  compact: Px,
  decode: Ex,
  encode: Ax,
  isBuffer: Ox,
  isRegExp: xx,
  maybeMap: Ix,
  merge: Mx
}, k_ = bx, iu = I_, Na = Tf, kx = Object.prototype.hasOwnProperty, cm = {
  brackets: function(n) {
    return n + "[]";
  },
  comma: "comma",
  indices: function(n, t) {
    return n + "[" + t + "]";
  },
  repeat: function(n) {
    return n;
  }
}, Hi = Array.isArray, Dx = Array.prototype.push, D_ = function(e, n) {
  Dx.apply(e, Hi(n) ? n : [n]);
}, $x = Date.prototype.toISOString, hm = Na.default, Yt = {
  addQueryPrefix: !1,
  allowDots: !1,
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encoder: iu.encode,
  encodeValuesOnly: !1,
  format: hm,
  formatter: Na.formatters[hm],
  // deprecated
  indices: !1,
  serializeDate: function(n) {
    return $x.call(n);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, Rx = function(n) {
  return typeof n == "string" || typeof n == "number" || typeof n == "boolean" || typeof n == "symbol" || typeof n == "bigint";
}, Eh = {}, zx = function e(n, t, a, u, f, d, m, g, y, w, h, b, T, A, x, Z) {
  for (var H = n, Y = Z, ee = 0, re = !1; (Y = Y.get(Eh)) !== void 0 && !re; ) {
    var be = Y.get(n);
    if (ee += 1, typeof be < "u") {
      if (be === ee)
        throw new RangeError("Cyclic object value");
      re = !0;
    }
    typeof Y.get(Eh) > "u" && (ee = 0);
  }
  if (typeof g == "function" ? H = g(t, H) : H instanceof Date ? H = h(H) : a === "comma" && Hi(H) && (H = iu.maybeMap(H, function(gt) {
    return gt instanceof Date ? h(gt) : gt;
  })), H === null) {
    if (f)
      return m && !A ? m(t, Yt.encoder, x, "key", b) : t;
    H = "";
  }
  if (Rx(H) || iu.isBuffer(H)) {
    if (m) {
      var Xe = A ? t : m(t, Yt.encoder, x, "key", b);
      return [T(Xe) + "=" + T(m(H, Yt.encoder, x, "value", b))];
    }
    return [T(t) + "=" + T(String(H))];
  }
  var Fe = [];
  if (typeof H > "u")
    return Fe;
  var ge;
  if (a === "comma" && Hi(H))
    A && m && (H = iu.maybeMap(H, m)), ge = [{ value: H.length > 0 ? H.join(",") || null : void 0 }];
  else if (Hi(g))
    ge = g;
  else {
    var qe = Object.keys(H);
    ge = y ? qe.sort(y) : qe;
  }
  for (var at = u && Hi(H) && H.length === 1 ? t + "[]" : t, _t = 0; _t < ge.length; ++_t) {
    var nt = ge[_t], wn = typeof nt == "object" && typeof nt.value < "u" ? nt.value : H[nt];
    if (!(d && wn === null)) {
      var At = Hi(H) ? typeof a == "function" ? a(at, nt) : at : at + (w ? "." + nt : "[" + nt + "]");
      Z.set(n, ee);
      var Ki = k_();
      Ki.set(Eh, Z), D_(Fe, e(
        wn,
        At,
        a,
        u,
        f,
        d,
        a === "comma" && A && Hi(H) ? null : m,
        g,
        y,
        w,
        h,
        b,
        T,
        A,
        x,
        Ki
      ));
    }
  }
  return Fe;
}, Bx = function(n) {
  if (!n)
    return Yt;
  if (n.encoder !== null && typeof n.encoder < "u" && typeof n.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var t = n.charset || Yt.charset;
  if (typeof n.charset < "u" && n.charset !== "utf-8" && n.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var a = Na.default;
  if (typeof n.format < "u") {
    if (!kx.call(Na.formatters, n.format))
      throw new TypeError("Unknown format option provided.");
    a = n.format;
  }
  var u = Na.formatters[a], f = Yt.filter;
  return (typeof n.filter == "function" || Hi(n.filter)) && (f = n.filter), {
    addQueryPrefix: typeof n.addQueryPrefix == "boolean" ? n.addQueryPrefix : Yt.addQueryPrefix,
    allowDots: typeof n.allowDots > "u" ? Yt.allowDots : !!n.allowDots,
    charset: t,
    charsetSentinel: typeof n.charsetSentinel == "boolean" ? n.charsetSentinel : Yt.charsetSentinel,
    delimiter: typeof n.delimiter > "u" ? Yt.delimiter : n.delimiter,
    encode: typeof n.encode == "boolean" ? n.encode : Yt.encode,
    encoder: typeof n.encoder == "function" ? n.encoder : Yt.encoder,
    encodeValuesOnly: typeof n.encodeValuesOnly == "boolean" ? n.encodeValuesOnly : Yt.encodeValuesOnly,
    filter: f,
    format: a,
    formatter: u,
    serializeDate: typeof n.serializeDate == "function" ? n.serializeDate : Yt.serializeDate,
    skipNulls: typeof n.skipNulls == "boolean" ? n.skipNulls : Yt.skipNulls,
    sort: typeof n.sort == "function" ? n.sort : null,
    strictNullHandling: typeof n.strictNullHandling == "boolean" ? n.strictNullHandling : Yt.strictNullHandling
  };
}, Fx = function(e, n) {
  var t = e, a = Bx(n), u, f;
  typeof a.filter == "function" ? (f = a.filter, t = f("", t)) : Hi(a.filter) && (f = a.filter, u = f);
  var d = [];
  if (typeof t != "object" || t === null)
    return "";
  var m;
  n && n.arrayFormat in cm ? m = n.arrayFormat : n && "indices" in n ? m = n.indices ? "indices" : "repeat" : m = "indices";
  var g = cm[m];
  if (n && "commaRoundTrip" in n && typeof n.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var y = g === "comma" && n && n.commaRoundTrip;
  u || (u = Object.keys(t)), a.sort && u.sort(a.sort);
  for (var w = k_(), h = 0; h < u.length; ++h) {
    var b = u[h];
    a.skipNulls && t[b] === null || D_(d, zx(
      t[b],
      b,
      g,
      y,
      a.strictNullHandling,
      a.skipNulls,
      a.encode ? a.encoder : null,
      a.filter,
      a.sort,
      a.allowDots,
      a.serializeDate,
      a.format,
      a.formatter,
      a.encodeValuesOnly,
      a.charset,
      w
    ));
  }
  var T = d.join(a.delimiter), A = a.addQueryPrefix === !0 ? "?" : "";
  return a.charsetSentinel && (a.charset === "iso-8859-1" ? A += "utf8=%26%2310003%3B&" : A += "utf8=%E2%9C%93&"), T.length > 0 ? A + T : "";
}, ys = I_, Yh = Object.prototype.hasOwnProperty, Ux = Array.isArray, $t = {
  allowDots: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decoder: ys.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, Vx = function(e) {
  return e.replace(/&#(\d+);/g, function(n, t) {
    return String.fromCharCode(parseInt(t, 10));
  });
}, $_ = function(e, n) {
  return e && typeof e == "string" && n.comma && e.indexOf(",") > -1 ? e.split(",") : e;
}, Hx = "utf8=%26%2310003%3B", jx = "utf8=%E2%9C%93", Zx = function(n, t) {
  var a = { __proto__: null }, u = t.ignoreQueryPrefix ? n.replace(/^\?/, "") : n, f = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit, d = u.split(t.delimiter, f), m = -1, g, y = t.charset;
  if (t.charsetSentinel)
    for (g = 0; g < d.length; ++g)
      d[g].indexOf("utf8=") === 0 && (d[g] === jx ? y = "utf-8" : d[g] === Hx && (y = "iso-8859-1"), m = g, g = d.length);
  for (g = 0; g < d.length; ++g)
    if (g !== m) {
      var w = d[g], h = w.indexOf("]="), b = h === -1 ? w.indexOf("=") : h + 1, T, A;
      b === -1 ? (T = t.decoder(w, $t.decoder, y, "key"), A = t.strictNullHandling ? null : "") : (T = t.decoder(w.slice(0, b), $t.decoder, y, "key"), A = ys.maybeMap(
        $_(w.slice(b + 1), t),
        function(x) {
          return t.decoder(x, $t.decoder, y, "value");
        }
      )), A && t.interpretNumericEntities && y === "iso-8859-1" && (A = Vx(A)), w.indexOf("[]=") > -1 && (A = Ux(A) ? [A] : A), Yh.call(a, T) ? a[T] = ys.combine(a[T], A) : a[T] = A;
    }
  return a;
}, Wx = function(e, n, t, a) {
  for (var u = a ? n : $_(n, t), f = e.length - 1; f >= 0; --f) {
    var d, m = e[f];
    if (m === "[]" && t.parseArrays)
      d = [].concat(u);
    else {
      d = t.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var g = m.charAt(0) === "[" && m.charAt(m.length - 1) === "]" ? m.slice(1, -1) : m, y = parseInt(g, 10);
      !t.parseArrays && g === "" ? d = { 0: u } : !isNaN(y) && m !== g && String(y) === g && y >= 0 && t.parseArrays && y <= t.arrayLimit ? (d = [], d[y] = u) : g !== "__proto__" && (d[g] = u);
    }
    u = d;
  }
  return u;
}, Gx = function(n, t, a, u) {
  if (n) {
    var f = a.allowDots ? n.replace(/\.([^.[]+)/g, "[$1]") : n, d = /(\[[^[\]]*])/, m = /(\[[^[\]]*])/g, g = a.depth > 0 && d.exec(f), y = g ? f.slice(0, g.index) : f, w = [];
    if (y) {
      if (!a.plainObjects && Yh.call(Object.prototype, y) && !a.allowPrototypes)
        return;
      w.push(y);
    }
    for (var h = 0; a.depth > 0 && (g = m.exec(f)) !== null && h < a.depth; ) {
      if (h += 1, !a.plainObjects && Yh.call(Object.prototype, g[1].slice(1, -1)) && !a.allowPrototypes)
        return;
      w.push(g[1]);
    }
    return g && w.push("[" + f.slice(g.index) + "]"), Wx(w, t, a, u);
  }
}, qx = function(n) {
  if (!n)
    return $t;
  if (n.decoder !== null && n.decoder !== void 0 && typeof n.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof n.charset < "u" && n.charset !== "utf-8" && n.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var t = typeof n.charset > "u" ? $t.charset : n.charset;
  return {
    allowDots: typeof n.allowDots > "u" ? $t.allowDots : !!n.allowDots,
    allowPrototypes: typeof n.allowPrototypes == "boolean" ? n.allowPrototypes : $t.allowPrototypes,
    allowSparse: typeof n.allowSparse == "boolean" ? n.allowSparse : $t.allowSparse,
    arrayLimit: typeof n.arrayLimit == "number" ? n.arrayLimit : $t.arrayLimit,
    charset: t,
    charsetSentinel: typeof n.charsetSentinel == "boolean" ? n.charsetSentinel : $t.charsetSentinel,
    comma: typeof n.comma == "boolean" ? n.comma : $t.comma,
    decoder: typeof n.decoder == "function" ? n.decoder : $t.decoder,
    delimiter: typeof n.delimiter == "string" || ys.isRegExp(n.delimiter) ? n.delimiter : $t.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof n.depth == "number" || n.depth === !1 ? +n.depth : $t.depth,
    ignoreQueryPrefix: n.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof n.interpretNumericEntities == "boolean" ? n.interpretNumericEntities : $t.interpretNumericEntities,
    parameterLimit: typeof n.parameterLimit == "number" ? n.parameterLimit : $t.parameterLimit,
    parseArrays: n.parseArrays !== !1,
    plainObjects: typeof n.plainObjects == "boolean" ? n.plainObjects : $t.plainObjects,
    strictNullHandling: typeof n.strictNullHandling == "boolean" ? n.strictNullHandling : $t.strictNullHandling
  };
}, Kx = function(e, n) {
  var t = qx(n);
  if (e === "" || e === null || typeof e > "u")
    return t.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var a = typeof e == "string" ? Zx(e, t) : e, u = t.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, f = Object.keys(a), d = 0; d < f.length; ++d) {
    var m = f[d], g = Gx(m, a[m], t, typeof e == "string");
    u = ys.merge(u, g, t);
  }
  return t.allowSparse === !0 ? u : ys.compact(u);
}, Yx = Fx, Qx = Kx, Jx = Tf, Xx = {
  formats: Jx,
  parse: Qx,
  stringify: Yx
};
const fm = /* @__PURE__ */ Zm(Xx);
function R_(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: eO } = Object.prototype, { getPrototypeOf: Ef } = Object, Nu = ((e) => (n) => {
  const t = eO.call(n);
  return e[t] || (e[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Si = (e) => (e = e.toLowerCase(), (n) => Nu(n) === e), Iu = (e) => (n) => typeof n === e, { isArray: Es } = Array, ka = Iu("undefined");
function tO(e) {
  return e !== null && !ka(e) && e.constructor !== null && !ka(e.constructor) && jn(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const z_ = Si("ArrayBuffer");
function nO(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && z_(e.buffer), n;
}
const iO = Iu("string"), jn = Iu("function"), B_ = Iu("number"), ku = (e) => e !== null && typeof e == "object", rO = (e) => e === !0 || e === !1, ru = (e) => {
  if (Nu(e) !== "object")
    return !1;
  const n = Ef(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, oO = Si("Date"), sO = Si("File"), aO = Si("Blob"), lO = Si("FileList"), uO = (e) => ku(e) && jn(e.pipe), cO = (e) => {
  let n;
  return e && (typeof FormData == "function" && e instanceof FormData || jn(e.append) && ((n = Nu(e)) === "formdata" || // detect form-data instance
  n === "object" && jn(e.toString) && e.toString() === "[object FormData]"));
}, hO = Si("URLSearchParams"), fO = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function za(e, n, { allOwnKeys: t = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let a, u;
  if (typeof e != "object" && (e = [e]), Es(e))
    for (a = 0, u = e.length; a < u; a++)
      n.call(null, e[a], a, e);
  else {
    const f = t ? Object.getOwnPropertyNames(e) : Object.keys(e), d = f.length;
    let m;
    for (a = 0; a < d; a++)
      m = f[a], n.call(null, e[m], m, e);
  }
}
function F_(e, n) {
  n = n.toLowerCase();
  const t = Object.keys(e);
  let a = t.length, u;
  for (; a-- > 0; )
    if (u = t[a], n === u.toLowerCase())
      return u;
  return null;
}
const U_ = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), V_ = (e) => !ka(e) && e !== U_;
function Qh() {
  const { caseless: e } = V_(this) && this || {}, n = {}, t = (a, u) => {
    const f = e && F_(n, u) || u;
    ru(n[f]) && ru(a) ? n[f] = Qh(n[f], a) : ru(a) ? n[f] = Qh({}, a) : Es(a) ? n[f] = a.slice() : n[f] = a;
  };
  for (let a = 0, u = arguments.length; a < u; a++)
    arguments[a] && za(arguments[a], t);
  return n;
}
const dO = (e, n, t, { allOwnKeys: a } = {}) => (za(n, (u, f) => {
  t && jn(u) ? e[f] = R_(u, t) : e[f] = u;
}, { allOwnKeys: a }), e), pO = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), mO = (e, n, t, a) => {
  e.prototype = Object.create(n.prototype, a), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: n.prototype
  }), t && Object.assign(e.prototype, t);
}, _O = (e, n, t, a) => {
  let u, f, d;
  const m = {};
  if (n = n || {}, e == null)
    return n;
  do {
    for (u = Object.getOwnPropertyNames(e), f = u.length; f-- > 0; )
      d = u[f], (!a || a(d, e, n)) && !m[d] && (n[d] = e[d], m[d] = !0);
    e = t !== !1 && Ef(e);
  } while (e && (!t || t(e, n)) && e !== Object.prototype);
  return n;
}, gO = (e, n, t) => {
  e = String(e), (t === void 0 || t > e.length) && (t = e.length), t -= n.length;
  const a = e.indexOf(n, t);
  return a !== -1 && a === t;
}, vO = (e) => {
  if (!e)
    return null;
  if (Es(e))
    return e;
  let n = e.length;
  if (!B_(n))
    return null;
  const t = new Array(n);
  for (; n-- > 0; )
    t[n] = e[n];
  return t;
}, yO = ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && Ef(Uint8Array)), bO = (e, n) => {
  const a = (e && e[Symbol.iterator]).call(e);
  let u;
  for (; (u = a.next()) && !u.done; ) {
    const f = u.value;
    n.call(e, f[0], f[1]);
  }
}, wO = (e, n) => {
  let t;
  const a = [];
  for (; (t = e.exec(n)) !== null; )
    a.push(t);
  return a;
}, LO = Si("HTMLFormElement"), SO = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, a, u) {
    return a.toUpperCase() + u;
  }
), dm = (({ hasOwnProperty: e }) => (n, t) => e.call(n, t))(Object.prototype), CO = Si("RegExp"), H_ = (e, n) => {
  const t = Object.getOwnPropertyDescriptors(e), a = {};
  za(t, (u, f) => {
    n(u, f, e) !== !1 && (a[f] = u);
  }), Object.defineProperties(e, a);
}, MO = (e) => {
  H_(e, (n, t) => {
    if (jn(e) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const a = e[t];
    if (jn(a)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, TO = (e, n) => {
  const t = {}, a = (u) => {
    u.forEach((f) => {
      t[f] = !0;
    });
  };
  return Es(e) ? a(e) : a(String(e).split(n)), t;
}, EO = () => {
}, AO = (e, n) => (e = +e, Number.isFinite(e) ? e : n), Ah = "abcdefghijklmnopqrstuvwxyz", pm = "0123456789", j_ = {
  DIGIT: pm,
  ALPHA: Ah,
  ALPHA_DIGIT: Ah + Ah.toUpperCase() + pm
}, PO = (e = 16, n = j_.ALPHA_DIGIT) => {
  let t = "";
  const { length: a } = n;
  for (; e--; )
    t += n[Math.random() * a | 0];
  return t;
};
function xO(e) {
  return !!(e && jn(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const OO = (e) => {
  const n = new Array(10), t = (a, u) => {
    if (ku(a)) {
      if (n.indexOf(a) >= 0)
        return;
      if (!("toJSON" in a)) {
        n[u] = a;
        const f = Es(a) ? [] : {};
        return za(a, (d, m) => {
          const g = t(d, u + 1);
          !ka(g) && (f[m] = g);
        }), n[u] = void 0, f;
      }
    }
    return a;
  };
  return t(e, 0);
}, NO = Si("AsyncFunction"), IO = (e) => e && (ku(e) || jn(e)) && jn(e.then) && jn(e.catch), W = {
  isArray: Es,
  isArrayBuffer: z_,
  isBuffer: tO,
  isFormData: cO,
  isArrayBufferView: nO,
  isString: iO,
  isNumber: B_,
  isBoolean: rO,
  isObject: ku,
  isPlainObject: ru,
  isUndefined: ka,
  isDate: oO,
  isFile: sO,
  isBlob: aO,
  isRegExp: CO,
  isFunction: jn,
  isStream: uO,
  isURLSearchParams: hO,
  isTypedArray: yO,
  isFileList: lO,
  forEach: za,
  merge: Qh,
  extend: dO,
  trim: fO,
  stripBOM: pO,
  inherits: mO,
  toFlatObject: _O,
  kindOf: Nu,
  kindOfTest: Si,
  endsWith: gO,
  toArray: vO,
  forEachEntry: bO,
  matchAll: wO,
  isHTMLForm: LO,
  hasOwnProperty: dm,
  hasOwnProp: dm,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: H_,
  freezeMethods: MO,
  toObjectSet: TO,
  toCamelCase: SO,
  noop: EO,
  toFiniteNumber: AO,
  findKey: F_,
  global: U_,
  isContextDefined: V_,
  ALPHABET: j_,
  generateString: PO,
  isSpecCompliantForm: xO,
  toJSONObject: OO,
  isAsyncFn: NO,
  isThenable: IO
};
function Ge(e, n, t, a, u) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), t && (this.config = t), a && (this.request = a), u && (this.response = u);
}
W.inherits(Ge, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: W.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Z_ = Ge.prototype, W_ = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  W_[e] = { value: e };
});
Object.defineProperties(Ge, W_);
Object.defineProperty(Z_, "isAxiosError", { value: !0 });
Ge.from = (e, n, t, a, u, f) => {
  const d = Object.create(Z_);
  return W.toFlatObject(e, d, function(g) {
    return g !== Error.prototype;
  }, (m) => m !== "isAxiosError"), Ge.call(d, e.message, n, t, a, u), d.cause = e, d.name = e.name, f && Object.assign(d, f), d;
};
const kO = null;
function Jh(e) {
  return W.isPlainObject(e) || W.isArray(e);
}
function G_(e) {
  return W.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function mm(e, n, t) {
  return e ? e.concat(n).map(function(u, f) {
    return u = G_(u), !t && f ? "[" + u + "]" : u;
  }).join(t ? "." : "") : n;
}
function DO(e) {
  return W.isArray(e) && !e.some(Jh);
}
const $O = W.toFlatObject(W, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Du(e, n, t) {
  if (!W.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), t = W.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(x, Z) {
    return !W.isUndefined(Z[x]);
  });
  const a = t.metaTokens, u = t.visitor || w, f = t.dots, d = t.indexes, g = (t.Blob || typeof Blob < "u" && Blob) && W.isSpecCompliantForm(n);
  if (!W.isFunction(u))
    throw new TypeError("visitor must be a function");
  function y(A) {
    if (A === null)
      return "";
    if (W.isDate(A))
      return A.toISOString();
    if (!g && W.isBlob(A))
      throw new Ge("Blob is not supported. Use a Buffer instead.");
    return W.isArrayBuffer(A) || W.isTypedArray(A) ? g && typeof Blob == "function" ? new Blob([A]) : Buffer.from(A) : A;
  }
  function w(A, x, Z) {
    let H = A;
    if (A && !Z && typeof A == "object") {
      if (W.endsWith(x, "{}"))
        x = a ? x : x.slice(0, -2), A = JSON.stringify(A);
      else if (W.isArray(A) && DO(A) || (W.isFileList(A) || W.endsWith(x, "[]")) && (H = W.toArray(A)))
        return x = G_(x), H.forEach(function(ee, re) {
          !(W.isUndefined(ee) || ee === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            d === !0 ? mm([x], re, f) : d === null ? x : x + "[]",
            y(ee)
          );
        }), !1;
    }
    return Jh(A) ? !0 : (n.append(mm(Z, x, f), y(A)), !1);
  }
  const h = [], b = Object.assign($O, {
    defaultVisitor: w,
    convertValue: y,
    isVisitable: Jh
  });
  function T(A, x) {
    if (!W.isUndefined(A)) {
      if (h.indexOf(A) !== -1)
        throw Error("Circular reference detected in " + x.join("."));
      h.push(A), W.forEach(A, function(H, Y) {
        (!(W.isUndefined(H) || H === null) && u.call(
          n,
          H,
          W.isString(Y) ? Y.trim() : Y,
          x,
          b
        )) === !0 && T(H, x ? x.concat(Y) : [Y]);
      }), h.pop();
    }
  }
  if (!W.isObject(e))
    throw new TypeError("data must be an object");
  return T(e), n;
}
function _m(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(a) {
    return n[a];
  });
}
function Af(e, n) {
  this._pairs = [], e && Du(e, this, n);
}
const q_ = Af.prototype;
q_.append = function(n, t) {
  this._pairs.push([n, t]);
};
q_.toString = function(n) {
  const t = n ? function(a) {
    return n.call(this, a, _m);
  } : _m;
  return this._pairs.map(function(u) {
    return t(u[0]) + "=" + t(u[1]);
  }, "").join("&");
};
function RO(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function K_(e, n, t) {
  if (!n)
    return e;
  const a = t && t.encode || RO, u = t && t.serialize;
  let f;
  if (u ? f = u(n, t) : f = W.isURLSearchParams(n) ? n.toString() : new Af(n, t).toString(a), f) {
    const d = e.indexOf("#");
    d !== -1 && (e = e.slice(0, d)), e += (e.indexOf("?") === -1 ? "?" : "&") + f;
  }
  return e;
}
class zO {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, t, a) {
    return this.handlers.push({
      fulfilled: n,
      rejected: t,
      synchronous: a ? a.synchronous : !1,
      runWhen: a ? a.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    W.forEach(this.handlers, function(a) {
      a !== null && n(a);
    });
  }
}
const gm = zO, Y_ = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, BO = typeof URLSearchParams < "u" ? URLSearchParams : Af, FO = typeof FormData < "u" ? FormData : null, UO = typeof Blob < "u" ? Blob : null, VO = (() => {
  let e;
  return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), HO = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), wi = {
  isBrowser: !0,
  classes: {
    URLSearchParams: BO,
    FormData: FO,
    Blob: UO
  },
  isStandardBrowserEnv: VO,
  isStandardBrowserWebWorkerEnv: HO,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function jO(e, n) {
  return Du(e, new wi.classes.URLSearchParams(), Object.assign({
    visitor: function(t, a, u, f) {
      return wi.isNode && W.isBuffer(t) ? (this.append(a, t.toString("base64")), !1) : f.defaultVisitor.apply(this, arguments);
    }
  }, n));
}
function ZO(e) {
  return W.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function WO(e) {
  const n = {}, t = Object.keys(e);
  let a;
  const u = t.length;
  let f;
  for (a = 0; a < u; a++)
    f = t[a], n[f] = e[f];
  return n;
}
function Q_(e) {
  function n(t, a, u, f) {
    let d = t[f++];
    const m = Number.isFinite(+d), g = f >= t.length;
    return d = !d && W.isArray(u) ? u.length : d, g ? (W.hasOwnProp(u, d) ? u[d] = [u[d], a] : u[d] = a, !m) : ((!u[d] || !W.isObject(u[d])) && (u[d] = []), n(t, a, u[d], f) && W.isArray(u[d]) && (u[d] = WO(u[d])), !m);
  }
  if (W.isFormData(e) && W.isFunction(e.entries)) {
    const t = {};
    return W.forEachEntry(e, (a, u) => {
      n(ZO(a), u, t, 0);
    }), t;
  }
  return null;
}
const GO = {
  "Content-Type": void 0
};
function qO(e, n, t) {
  if (W.isString(e))
    try {
      return (n || JSON.parse)(e), W.trim(e);
    } catch (a) {
      if (a.name !== "SyntaxError")
        throw a;
    }
  return (t || JSON.stringify)(e);
}
const $u = {
  transitional: Y_,
  adapter: ["xhr", "http"],
  transformRequest: [function(n, t) {
    const a = t.getContentType() || "", u = a.indexOf("application/json") > -1, f = W.isObject(n);
    if (f && W.isHTMLForm(n) && (n = new FormData(n)), W.isFormData(n))
      return u && u ? JSON.stringify(Q_(n)) : n;
    if (W.isArrayBuffer(n) || W.isBuffer(n) || W.isStream(n) || W.isFile(n) || W.isBlob(n))
      return n;
    if (W.isArrayBufferView(n))
      return n.buffer;
    if (W.isURLSearchParams(n))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let m;
    if (f) {
      if (a.indexOf("application/x-www-form-urlencoded") > -1)
        return jO(n, this.formSerializer).toString();
      if ((m = W.isFileList(n)) || a.indexOf("multipart/form-data") > -1) {
        const g = this.env && this.env.FormData;
        return Du(
          m ? { "files[]": n } : n,
          g && new g(),
          this.formSerializer
        );
      }
    }
    return f || u ? (t.setContentType("application/json", !1), qO(n)) : n;
  }],
  transformResponse: [function(n) {
    const t = this.transitional || $u.transitional, a = t && t.forcedJSONParsing, u = this.responseType === "json";
    if (n && W.isString(n) && (a && !this.responseType || u)) {
      const d = !(t && t.silentJSONParsing) && u;
      try {
        return JSON.parse(n);
      } catch (m) {
        if (d)
          throw m.name === "SyntaxError" ? Ge.from(m, Ge.ERR_BAD_RESPONSE, this, null, this.response) : m;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: wi.classes.FormData,
    Blob: wi.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
W.forEach(["delete", "get", "head"], function(n) {
  $u.headers[n] = {};
});
W.forEach(["post", "put", "patch"], function(n) {
  $u.headers[n] = W.merge(GO);
});
const Pf = $u, KO = W.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), YO = (e) => {
  const n = {};
  let t, a, u;
  return e && e.split(`
`).forEach(function(d) {
    u = d.indexOf(":"), t = d.substring(0, u).trim().toLowerCase(), a = d.substring(u + 1).trim(), !(!t || n[t] && KO[t]) && (t === "set-cookie" ? n[t] ? n[t].push(a) : n[t] = [a] : n[t] = n[t] ? n[t] + ", " + a : a);
  }), n;
}, vm = Symbol("internals");
function La(e) {
  return e && String(e).trim().toLowerCase();
}
function ou(e) {
  return e === !1 || e == null ? e : W.isArray(e) ? e.map(ou) : String(e);
}
function QO(e) {
  const n = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let a;
  for (; a = t.exec(e); )
    n[a[1]] = a[2];
  return n;
}
const JO = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Ph(e, n, t, a, u) {
  if (W.isFunction(a))
    return a.call(this, n, t);
  if (u && (n = t), !!W.isString(n)) {
    if (W.isString(a))
      return n.indexOf(a) !== -1;
    if (W.isRegExp(a))
      return a.test(n);
  }
}
function XO(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, t, a) => t.toUpperCase() + a);
}
function eN(e, n) {
  const t = W.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((a) => {
    Object.defineProperty(e, a + t, {
      value: function(u, f, d) {
        return this[a].call(this, n, u, f, d);
      },
      configurable: !0
    });
  });
}
class Ru {
  constructor(n) {
    n && this.set(n);
  }
  set(n, t, a) {
    const u = this;
    function f(m, g, y) {
      const w = La(g);
      if (!w)
        throw new Error("header name must be a non-empty string");
      const h = W.findKey(u, w);
      (!h || u[h] === void 0 || y === !0 || y === void 0 && u[h] !== !1) && (u[h || g] = ou(m));
    }
    const d = (m, g) => W.forEach(m, (y, w) => f(y, w, g));
    return W.isPlainObject(n) || n instanceof this.constructor ? d(n, t) : W.isString(n) && (n = n.trim()) && !JO(n) ? d(YO(n), t) : n != null && f(t, n, a), this;
  }
  get(n, t) {
    if (n = La(n), n) {
      const a = W.findKey(this, n);
      if (a) {
        const u = this[a];
        if (!t)
          return u;
        if (t === !0)
          return QO(u);
        if (W.isFunction(t))
          return t.call(this, u, a);
        if (W.isRegExp(t))
          return t.exec(u);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, t) {
    if (n = La(n), n) {
      const a = W.findKey(this, n);
      return !!(a && this[a] !== void 0 && (!t || Ph(this, this[a], a, t)));
    }
    return !1;
  }
  delete(n, t) {
    const a = this;
    let u = !1;
    function f(d) {
      if (d = La(d), d) {
        const m = W.findKey(a, d);
        m && (!t || Ph(a, a[m], m, t)) && (delete a[m], u = !0);
      }
    }
    return W.isArray(n) ? n.forEach(f) : f(n), u;
  }
  clear(n) {
    const t = Object.keys(this);
    let a = t.length, u = !1;
    for (; a--; ) {
      const f = t[a];
      (!n || Ph(this, this[f], f, n, !0)) && (delete this[f], u = !0);
    }
    return u;
  }
  normalize(n) {
    const t = this, a = {};
    return W.forEach(this, (u, f) => {
      const d = W.findKey(a, f);
      if (d) {
        t[d] = ou(u), delete t[f];
        return;
      }
      const m = n ? XO(f) : String(f).trim();
      m !== f && delete t[f], t[m] = ou(u), a[m] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const t = /* @__PURE__ */ Object.create(null);
    return W.forEach(this, (a, u) => {
      a != null && a !== !1 && (t[u] = n && W.isArray(a) ? a.join(", ") : a);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, t]) => n + ": " + t).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...t) {
    const a = new this(n);
    return t.forEach((u) => a.set(u)), a;
  }
  static accessor(n) {
    const a = (this[vm] = this[vm] = {
      accessors: {}
    }).accessors, u = this.prototype;
    function f(d) {
      const m = La(d);
      a[m] || (eN(u, d), a[m] = !0);
    }
    return W.isArray(n) ? n.forEach(f) : f(n), this;
  }
}
Ru.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
W.freezeMethods(Ru.prototype);
W.freezeMethods(Ru);
const Wi = Ru;
function xh(e, n) {
  const t = this || Pf, a = n || t, u = Wi.from(a.headers);
  let f = a.data;
  return W.forEach(e, function(m) {
    f = m.call(t, f, u.normalize(), n ? n.status : void 0);
  }), u.normalize(), f;
}
function J_(e) {
  return !!(e && e.__CANCEL__);
}
function Ba(e, n, t) {
  Ge.call(this, e ?? "canceled", Ge.ERR_CANCELED, n, t), this.name = "CanceledError";
}
W.inherits(Ba, Ge, {
  __CANCEL__: !0
});
function tN(e, n, t) {
  const a = t.config.validateStatus;
  !t.status || !a || a(t.status) ? e(t) : n(new Ge(
    "Request failed with status code " + t.status,
    [Ge.ERR_BAD_REQUEST, Ge.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
const nN = wi.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  function() {
    return {
      write: function(t, a, u, f, d, m) {
        const g = [];
        g.push(t + "=" + encodeURIComponent(a)), W.isNumber(u) && g.push("expires=" + new Date(u).toGMTString()), W.isString(f) && g.push("path=" + f), W.isString(d) && g.push("domain=" + d), m === !0 && g.push("secure"), document.cookie = g.join("; ");
      },
      read: function(t) {
        const a = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
        return a ? decodeURIComponent(a[3]) : null;
      },
      remove: function(t) {
        this.write(t, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function iN(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function rN(e, n) {
  return n ? e.replace(/\/+$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function X_(e, n) {
  return e && !iN(n) ? rN(e, n) : n;
}
const oN = wi.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const n = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a");
    let a;
    function u(f) {
      let d = f;
      return n && (t.setAttribute("href", d), d = t.href), t.setAttribute("href", d), {
        href: t.href,
        protocol: t.protocol ? t.protocol.replace(/:$/, "") : "",
        host: t.host,
        search: t.search ? t.search.replace(/^\?/, "") : "",
        hash: t.hash ? t.hash.replace(/^#/, "") : "",
        hostname: t.hostname,
        port: t.port,
        pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname
      };
    }
    return a = u(window.location.href), function(d) {
      const m = W.isString(d) ? u(d) : d;
      return m.protocol === a.protocol && m.host === a.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function sN(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function aN(e, n) {
  e = e || 10;
  const t = new Array(e), a = new Array(e);
  let u = 0, f = 0, d;
  return n = n !== void 0 ? n : 1e3, function(g) {
    const y = Date.now(), w = a[f];
    d || (d = y), t[u] = g, a[u] = y;
    let h = f, b = 0;
    for (; h !== u; )
      b += t[h++], h = h % e;
    if (u = (u + 1) % e, u === f && (f = (f + 1) % e), y - d < n)
      return;
    const T = w && y - w;
    return T ? Math.round(b * 1e3 / T) : void 0;
  };
}
function ym(e, n) {
  let t = 0;
  const a = aN(50, 250);
  return (u) => {
    const f = u.loaded, d = u.lengthComputable ? u.total : void 0, m = f - t, g = a(m), y = f <= d;
    t = f;
    const w = {
      loaded: f,
      total: d,
      progress: d ? f / d : void 0,
      bytes: m,
      rate: g || void 0,
      estimated: g && d && y ? (d - f) / g : void 0,
      event: u
    };
    w[n ? "download" : "upload"] = !0, e(w);
  };
}
const lN = typeof XMLHttpRequest < "u", uN = lN && function(e) {
  return new Promise(function(t, a) {
    let u = e.data;
    const f = Wi.from(e.headers).normalize(), d = e.responseType;
    let m;
    function g() {
      e.cancelToken && e.cancelToken.unsubscribe(m), e.signal && e.signal.removeEventListener("abort", m);
    }
    W.isFormData(u) && (wi.isStandardBrowserEnv || wi.isStandardBrowserWebWorkerEnv ? f.setContentType(!1) : f.setContentType("multipart/form-data;", !1));
    let y = new XMLHttpRequest();
    if (e.auth) {
      const T = e.auth.username || "", A = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      f.set("Authorization", "Basic " + btoa(T + ":" + A));
    }
    const w = X_(e.baseURL, e.url);
    y.open(e.method.toUpperCase(), K_(w, e.params, e.paramsSerializer), !0), y.timeout = e.timeout;
    function h() {
      if (!y)
        return;
      const T = Wi.from(
        "getAllResponseHeaders" in y && y.getAllResponseHeaders()
      ), x = {
        data: !d || d === "text" || d === "json" ? y.responseText : y.response,
        status: y.status,
        statusText: y.statusText,
        headers: T,
        config: e,
        request: y
      };
      tN(function(H) {
        t(H), g();
      }, function(H) {
        a(H), g();
      }, x), y = null;
    }
    if ("onloadend" in y ? y.onloadend = h : y.onreadystatechange = function() {
      !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(h);
    }, y.onabort = function() {
      y && (a(new Ge("Request aborted", Ge.ECONNABORTED, e, y)), y = null);
    }, y.onerror = function() {
      a(new Ge("Network Error", Ge.ERR_NETWORK, e, y)), y = null;
    }, y.ontimeout = function() {
      let A = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const x = e.transitional || Y_;
      e.timeoutErrorMessage && (A = e.timeoutErrorMessage), a(new Ge(
        A,
        x.clarifyTimeoutError ? Ge.ETIMEDOUT : Ge.ECONNABORTED,
        e,
        y
      )), y = null;
    }, wi.isStandardBrowserEnv) {
      const T = (e.withCredentials || oN(w)) && e.xsrfCookieName && nN.read(e.xsrfCookieName);
      T && f.set(e.xsrfHeaderName, T);
    }
    u === void 0 && f.setContentType(null), "setRequestHeader" in y && W.forEach(f.toJSON(), function(A, x) {
      y.setRequestHeader(x, A);
    }), W.isUndefined(e.withCredentials) || (y.withCredentials = !!e.withCredentials), d && d !== "json" && (y.responseType = e.responseType), typeof e.onDownloadProgress == "function" && y.addEventListener("progress", ym(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && y.upload && y.upload.addEventListener("progress", ym(e.onUploadProgress)), (e.cancelToken || e.signal) && (m = (T) => {
      y && (a(!T || T.type ? new Ba(null, e, y) : T), y.abort(), y = null);
    }, e.cancelToken && e.cancelToken.subscribe(m), e.signal && (e.signal.aborted ? m() : e.signal.addEventListener("abort", m)));
    const b = sN(w);
    if (b && wi.protocols.indexOf(b) === -1) {
      a(new Ge("Unsupported protocol " + b + ":", Ge.ERR_BAD_REQUEST, e));
      return;
    }
    y.send(u || null);
  });
}, su = {
  http: kO,
  xhr: uN
};
W.forEach(su, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const cN = {
  getAdapter: (e) => {
    e = W.isArray(e) ? e : [e];
    const { length: n } = e;
    let t, a;
    for (let u = 0; u < n && (t = e[u], !(a = W.isString(t) ? su[t.toLowerCase()] : t)); u++)
      ;
    if (!a)
      throw a === !1 ? new Ge(
        `Adapter ${t} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        W.hasOwnProp(su, t) ? `Adapter '${t}' is not available in the build` : `Unknown adapter '${t}'`
      );
    if (!W.isFunction(a))
      throw new TypeError("adapter is not a function");
    return a;
  },
  adapters: su
};
function Oh(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Ba(null, e);
}
function bm(e) {
  return Oh(e), e.headers = Wi.from(e.headers), e.data = xh.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), cN.getAdapter(e.adapter || Pf.adapter)(e).then(function(a) {
    return Oh(e), a.data = xh.call(
      e,
      e.transformResponse,
      a
    ), a.headers = Wi.from(a.headers), a;
  }, function(a) {
    return J_(a) || (Oh(e), a && a.response && (a.response.data = xh.call(
      e,
      e.transformResponse,
      a.response
    ), a.response.headers = Wi.from(a.response.headers))), Promise.reject(a);
  });
}
const wm = (e) => e instanceof Wi ? e.toJSON() : e;
function bs(e, n) {
  n = n || {};
  const t = {};
  function a(y, w, h) {
    return W.isPlainObject(y) && W.isPlainObject(w) ? W.merge.call({ caseless: h }, y, w) : W.isPlainObject(w) ? W.merge({}, w) : W.isArray(w) ? w.slice() : w;
  }
  function u(y, w, h) {
    if (W.isUndefined(w)) {
      if (!W.isUndefined(y))
        return a(void 0, y, h);
    } else
      return a(y, w, h);
  }
  function f(y, w) {
    if (!W.isUndefined(w))
      return a(void 0, w);
  }
  function d(y, w) {
    if (W.isUndefined(w)) {
      if (!W.isUndefined(y))
        return a(void 0, y);
    } else
      return a(void 0, w);
  }
  function m(y, w, h) {
    if (h in n)
      return a(y, w);
    if (h in e)
      return a(void 0, y);
  }
  const g = {
    url: f,
    method: f,
    data: f,
    baseURL: d,
    transformRequest: d,
    transformResponse: d,
    paramsSerializer: d,
    timeout: d,
    timeoutMessage: d,
    withCredentials: d,
    adapter: d,
    responseType: d,
    xsrfCookieName: d,
    xsrfHeaderName: d,
    onUploadProgress: d,
    onDownloadProgress: d,
    decompress: d,
    maxContentLength: d,
    maxBodyLength: d,
    beforeRedirect: d,
    transport: d,
    httpAgent: d,
    httpsAgent: d,
    cancelToken: d,
    socketPath: d,
    responseEncoding: d,
    validateStatus: m,
    headers: (y, w) => u(wm(y), wm(w), !0)
  };
  return W.forEach(Object.keys(Object.assign({}, e, n)), function(w) {
    const h = g[w] || u, b = h(e[w], n[w], w);
    W.isUndefined(b) && h !== m || (t[w] = b);
  }), t;
}
const eg = "1.4.0", xf = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  xf[e] = function(a) {
    return typeof a === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const Lm = {};
xf.transitional = function(n, t, a) {
  function u(f, d) {
    return "[Axios v" + eg + "] Transitional option '" + f + "'" + d + (a ? ". " + a : "");
  }
  return (f, d, m) => {
    if (n === !1)
      throw new Ge(
        u(d, " has been removed" + (t ? " in " + t : "")),
        Ge.ERR_DEPRECATED
      );
    return t && !Lm[d] && (Lm[d] = !0, console.warn(
      u(
        d,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), n ? n(f, d, m) : !0;
  };
};
function hN(e, n, t) {
  if (typeof e != "object")
    throw new Ge("options must be an object", Ge.ERR_BAD_OPTION_VALUE);
  const a = Object.keys(e);
  let u = a.length;
  for (; u-- > 0; ) {
    const f = a[u], d = n[f];
    if (d) {
      const m = e[f], g = m === void 0 || d(m, f, e);
      if (g !== !0)
        throw new Ge("option " + f + " must be " + g, Ge.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new Ge("Unknown option " + f, Ge.ERR_BAD_OPTION);
  }
}
const Xh = {
  assertOptions: hN,
  validators: xf
}, br = Xh.validators;
class yu {
  constructor(n) {
    this.defaults = n, this.interceptors = {
      request: new gm(),
      response: new gm()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(n, t) {
    typeof n == "string" ? (t = t || {}, t.url = n) : t = n || {}, t = bs(this.defaults, t);
    const { transitional: a, paramsSerializer: u, headers: f } = t;
    a !== void 0 && Xh.assertOptions(a, {
      silentJSONParsing: br.transitional(br.boolean),
      forcedJSONParsing: br.transitional(br.boolean),
      clarifyTimeoutError: br.transitional(br.boolean)
    }, !1), u != null && (W.isFunction(u) ? t.paramsSerializer = {
      serialize: u
    } : Xh.assertOptions(u, {
      encode: br.function,
      serialize: br.function
    }, !0)), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let d;
    d = f && W.merge(
      f.common,
      f[t.method]
    ), d && W.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (A) => {
        delete f[A];
      }
    ), t.headers = Wi.concat(d, f);
    const m = [];
    let g = !0;
    this.interceptors.request.forEach(function(x) {
      typeof x.runWhen == "function" && x.runWhen(t) === !1 || (g = g && x.synchronous, m.unshift(x.fulfilled, x.rejected));
    });
    const y = [];
    this.interceptors.response.forEach(function(x) {
      y.push(x.fulfilled, x.rejected);
    });
    let w, h = 0, b;
    if (!g) {
      const A = [bm.bind(this), void 0];
      for (A.unshift.apply(A, m), A.push.apply(A, y), b = A.length, w = Promise.resolve(t); h < b; )
        w = w.then(A[h++], A[h++]);
      return w;
    }
    b = m.length;
    let T = t;
    for (h = 0; h < b; ) {
      const A = m[h++], x = m[h++];
      try {
        T = A(T);
      } catch (Z) {
        x.call(this, Z);
        break;
      }
    }
    try {
      w = bm.call(this, T);
    } catch (A) {
      return Promise.reject(A);
    }
    for (h = 0, b = y.length; h < b; )
      w = w.then(y[h++], y[h++]);
    return w;
  }
  getUri(n) {
    n = bs(this.defaults, n);
    const t = X_(n.baseURL, n.url);
    return K_(t, n.params, n.paramsSerializer);
  }
}
W.forEach(["delete", "get", "head", "options"], function(n) {
  yu.prototype[n] = function(t, a) {
    return this.request(bs(a || {}, {
      method: n,
      url: t,
      data: (a || {}).data
    }));
  };
});
W.forEach(["post", "put", "patch"], function(n) {
  function t(a) {
    return function(f, d, m) {
      return this.request(bs(m || {}, {
        method: n,
        headers: a ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: f,
        data: d
      }));
    };
  }
  yu.prototype[n] = t(), yu.prototype[n + "Form"] = t(!0);
});
const au = yu;
class Of {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(f) {
      t = f;
    });
    const a = this;
    this.promise.then((u) => {
      if (!a._listeners)
        return;
      let f = a._listeners.length;
      for (; f-- > 0; )
        a._listeners[f](u);
      a._listeners = null;
    }), this.promise.then = (u) => {
      let f;
      const d = new Promise((m) => {
        a.subscribe(m), f = m;
      }).then(u);
      return d.cancel = function() {
        a.unsubscribe(f);
      }, d;
    }, n(function(f, d, m) {
      a.reason || (a.reason = new Ba(f, d, m), t(a.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(n);
    t !== -1 && this._listeners.splice(t, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new Of(function(u) {
        n = u;
      }),
      cancel: n
    };
  }
}
const fN = Of;
function dN(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function pN(e) {
  return W.isObject(e) && e.isAxiosError === !0;
}
const ef = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ef).forEach(([e, n]) => {
  ef[n] = e;
});
const mN = ef;
function tg(e) {
  const n = new au(e), t = R_(au.prototype.request, n);
  return W.extend(t, au.prototype, n, { allOwnKeys: !0 }), W.extend(t, n, null, { allOwnKeys: !0 }), t.create = function(u) {
    return tg(bs(e, u));
  }, t;
}
const It = tg(Pf);
It.Axios = au;
It.CanceledError = Ba;
It.CancelToken = fN;
It.isCancel = J_;
It.VERSION = eg;
It.toFormData = Du;
It.AxiosError = Ge;
It.Cancel = It.CanceledError;
It.all = function(n) {
  return Promise.all(n);
};
It.spread = dN;
It.isAxiosError = pN;
It.mergeConfig = bs;
It.AxiosHeaders = Wi;
It.formToJSON = (e) => Q_(W.isHTMLForm(e) ? new FormData(e) : e);
It.HttpStatusCode = mN;
It.default = It;
const _N = It, gN = {
  api: "/formapi"
}, Sm = _N.create({
  baseURL: gN.api,
  headers: {
    Pragma: "no-cache",
    "X-Requested-With": "XMLHttpRequest"
  }
});
class ng {
  static getEnumSelectRemote(n) {
    const t = fm.stringify({ query: n.query });
    return Sm.get(`${n.url}?${t}`, {
      headers: {
        "x-selected-language": n.locale
      }
    }).then(({ data: a }) => a);
  }
  static httpWatcher(n) {
    const t = fm.stringify(n.query);
    return Sm.get(`${n.url}?${t}`, {
      headers: {
        "x-selected-language": n.locale
      }
    }).then(({ data: a }) => a);
  }
}
const vN = 350, yN = oe({
  mixins: [hn],
  data() {
    return {
      DebounceTime: vN,
      loading: !1,
      isVisible: !1,
      selectedOption: null,
      options: []
    };
  },
  computed: {
    optionsLocale() {
      return this.options.map((e) => ({
        label: e.text[this.locale],
        value: e.value
      }));
    },
    model: {
      get() {
        return this.properties.multiple ? Array.isArray(this.value) ? this.value : [] : this.value;
      },
      set(e) {
        e && this.$emit("update:model-value", ke.set(this.modelValue, this.path, e));
      }
    }
  },
  mounted() {
    this.properties.value && this.properties.text && (this.selectedOption = {
      text: this.properties.text,
      value: this.properties.value
    }, this.options = [this.selectedOption]);
  },
  methods: {
    debounce: ke.debounce,
    onOptionsVisibleChange(e) {
      this.isVisible = e;
    },
    onOptionChange(e) {
      const n = this.options.find((t) => t.value === e);
      n && (this.selectedOption = n);
    },
    async filterRemoteMethod(e) {
      if (e) {
        this.loading = !0;
        try {
          this.options = await ng.getEnumSelectRemote({
            url: this.properties.url,
            query: e,
            locale: this.locale
          });
        } catch (n) {
          throw this.options = [], n;
        } finally {
          this.loading = !1;
        }
      } else
        this.options = [];
    },
    onClearClick() {
      this.$emit("update:model-value", ke.set(this.modelValue, this.path, null));
    }
  },
  watch: {
    locale() {
      this.options = this.selectedOption ? [this.selectedOption] : [];
    }
  }
});
function bN(e, n, t, a, u, f) {
  const d = D("form-label-component"), m = D("el-option"), g = D("el-select"), y = D("form-error-component"), w = D("el-form-item");
  return V(), X(w, {
    prop: e.scope,
    rules: e.rules
  }, Tt({
    error: k(({ error: h }) => [
      z(y, {
        error: h[e.locale]
      }, null, 8, ["error"])
    ]),
    default: k(() => {
      var h;
      return [
        z(g, {
          modelValue: e.model,
          "onUpdate:modelValue": n[0] || (n[0] = (b) => e.model = b),
          placeholder: ((h = e.properties.placeholder) == null ? void 0 : h[e.locale]) || " ",
          multiple: e.properties.multiple,
          clearable: e.properties.clearable,
          remote: e.isVisible,
          "filter-method": e.debounce(e.filterRemoteMethod, e.DebounceTime),
          loading: e.loading,
          disabled: e.disabled,
          "value-key": "value",
          filterable: "",
          onClear: e.onClearClick,
          onChange: e.onOptionChange,
          onVisibleChange: e.onOptionsVisibleChange
        }, {
          default: k(() => [
            (V(!0), ue(st, null, Et(e.optionsLocale, (b) => (V(), X(m, {
              key: b.value,
              value: b.value,
              label: b.label
            }, null, 8, ["value", "label"]))), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "multiple", "clearable", "remote", "filter-method", "loading", "disabled", "onClear", "onChange", "onVisibleChange"])
      ];
    }),
    _: 2
  }, [
    e.label ? {
      name: "label",
      fn: k(() => [
        z(d, {
          label: e.label,
          rules: e.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const wN = /* @__PURE__ */ ce(yN, [["render", bN]]), LN = oe({
  mixins: [hn],
  computed: {
    model: {
      get() {
        return this.properties.multiple ? Array.isArray(this.value) ? this.value : [] : this.value;
      },
      set(e) {
        e && this.$emit("update:model-value", ke.set(this.modelValue, this.path, e));
      }
    }
  },
  methods: {
    onClearClick() {
      this.$emit("update:model-value", ke.set(this.modelValue, this.path, null));
    }
  }
});
function SN(e, n, t, a, u, f) {
  const d = D("form-label-component"), m = D("el-option"), g = D("el-select"), y = D("form-error-component"), w = D("el-form-item");
  return V(), X(w, {
    prop: e.scope,
    rules: e.rules
  }, Tt({
    error: k(({ error: h }) => [
      z(y, {
        error: h[e.locale]
      }, null, 8, ["error"])
    ]),
    default: k(() => {
      var h;
      return [
        z(g, {
          modelValue: e.model,
          "onUpdate:modelValue": n[0] || (n[0] = (b) => e.model = b),
          placeholder: ((h = e.properties.placeholder) == null ? void 0 : h[e.locale]) || " ",
          multiple: e.properties.multiple,
          clearable: e.properties.clearable,
          disabled: e.disabled,
          filterable: "",
          onClear: e.onClearClick
        }, {
          default: k(() => [
            (V(!0), ue(st, null, Et(e.properties.enum, (b, T) => (V(), X(m, {
              key: T,
              label: b.text[e.locale],
              value: b.value
            }, null, 8, ["label", "value"]))), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "multiple", "clearable", "disabled", "onClear"])
      ];
    }),
    _: 2
  }, [
    e.label ? {
      name: "label",
      fn: k(() => [
        z(d, {
          label: e.label,
          rules: e.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const CN = /* @__PURE__ */ ce(LN, [["render", SN]]), MN = oe({
  mixins: [hn],
  computed: {
    model: {
      get() {
        return this.properties.multiple ? Array.isArray(this.value) ? this.value : [] : this.value;
      },
      set(e) {
        e && this.$emit("update:model-value", ke.set(this.modelValue, this.path, e));
      }
    }
  },
  methods: {
    filterNodeMethod(e, n) {
      const t = e.toLowerCase();
      return n.text[this.locale].toLowerCase().includes(t);
    },
    onClearClick() {
      this.$emit("update:model-value", ke.set(this.modelValue, this.path, null));
    }
  }
}), TN = "_label_1hbvh_1", EN = "_option_1hbvh_5", AN = {
  label: TN,
  option: EN
}, PN = ["innerHTML"];
function xN(e, n, t, a, u, f) {
  const d = D("form-label-component"), m = D("el-option"), g = D("el-tree-select"), y = D("form-error-component"), w = D("el-form-item");
  return V(), X(w, {
    prop: e.scope,
    rules: e.rules
  }, Tt({
    error: k(({ error: h }) => [
      z(y, {
        error: h[e.locale]
      }, null, 8, ["error"])
    ]),
    default: k(() => {
      var h;
      return [
        z(g, {
          modelValue: e.model,
          "onUpdate:modelValue": n[0] || (n[0] = (b) => e.model = b),
          placeholder: ((h = e.properties.placeholder) == null ? void 0 : h[e.locale]) || " ",
          data: e.properties.tree,
          multiple: e.properties.multiple,
          clearable: e.properties.clearable,
          "check-strictly": e.properties.checkStrictly,
          "filter-node-method": e.filterNodeMethod,
          disabled: e.disabled,
          filterable: "",
          onClear: e.onClearClick
        }, {
          default: k(({ data: b }) => [
            !e.properties.checkStrictly && b.children ? (V(), ue("div", {
              key: 0,
              class: J(e.$style.label)
            }, [
              ae("span", {
                innerHTML: b.text[e.locale]
              }, null, 8, PN)
            ], 2)) : (V(), X(m, {
              key: 1,
              label: b.text[e.locale],
              value: b.value,
              class: J(e.$style.option)
            }, null, 8, ["label", "value", "class"]))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "data", "multiple", "clearable", "check-strictly", "filter-node-method", "disabled", "onClear"])
      ];
    }),
    _: 2
  }, [
    e.label ? {
      name: "label",
      fn: k(() => [
        z(d, {
          label: e.label,
          rules: e.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const ON = {
  $style: AN
}, NN = /* @__PURE__ */ ce(MN, [["render", xN], ["__cssModules", ON]]), IN = oe({
  mixins: [hn]
});
function kN(e, n, t, a, u, f) {
  const d = D("form-label-component"), m = D("el-input"), g = D("form-error-component"), y = D("el-form-item");
  return V(), X(y, {
    prop: e.scope,
    rules: e.rules
  }, Tt({
    error: k(({ error: w }) => [
      z(g, {
        error: w[e.locale]
      }, null, 8, ["error"])
    ]),
    default: k(() => {
      var w;
      return [
        z(m, {
          modelValue: e.model,
          "onUpdate:modelValue": n[0] || (n[0] = (h) => e.model = h),
          placeholder: (w = e.properties.placeholder) == null ? void 0 : w[e.locale],
          maxlength: e.properties.maxlength,
          disabled: e.disabled,
          "show-word-limit": ""
        }, null, 8, ["modelValue", "placeholder", "maxlength", "disabled"])
      ];
    }),
    _: 2
  }, [
    e.label ? {
      name: "label",
      fn: k(() => [
        z(d, {
          label: e.label,
          rules: e.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const DN = /* @__PURE__ */ ce(IN, [["render", kN]]), $N = oe({
  mixins: [hn],
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(e) {
        this.$emit("update:model-value", ke.set(this.modelValue, this.path, e || null));
      }
    }
  }
});
function RN(e, n, t, a, u, f) {
  const d = D("el-switch"), m = D("el-form-item");
  return V(), X(m, null, {
    default: k(() => [
      z(d, {
        modelValue: e.model,
        "onUpdate:modelValue": n[0] || (n[0] = (g) => e.model = g),
        "active-text": e.label || "",
        disabled: e.disabled,
        size: "default"
      }, null, 8, ["modelValue", "active-text", "disabled"])
    ]),
    _: 1
  });
}
const zN = /* @__PURE__ */ ce($N, [["render", RN]]), Cm = {
  min: 3,
  max: 9
}, BN = oe({
  mixins: [hn],
  data() {
    return {
      minRows: Cm.min,
      maxRows: Cm.max
    };
  }
});
function FN(e, n, t, a, u, f) {
  const d = D("form-label-component"), m = D("el-input"), g = D("form-error-component"), y = D("el-form-item");
  return V(), X(y, {
    prop: e.scope,
    rules: e.rules
  }, Tt({
    error: k(({ error: w }) => [
      z(g, {
        error: w[e.locale]
      }, null, 8, ["error"])
    ]),
    default: k(() => {
      var w;
      return [
        z(m, {
          modelValue: e.model,
          "onUpdate:modelValue": n[0] || (n[0] = (h) => e.model = h),
          placeholder: (w = e.properties.placeholder) == null ? void 0 : w[e.locale],
          maxlength: e.properties.maxlength,
          autosize: { minRows: e.minRows, maxRows: e.maxRows },
          disabled: e.disabled,
          "show-word-limit": "",
          type: "textarea"
        }, null, 8, ["modelValue", "placeholder", "maxlength", "autosize", "disabled"])
      ];
    }),
    _: 2
  }, [
    e.label ? {
      name: "label",
      fn: k(() => [
        z(d, {
          label: e.label,
          rules: e.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const UN = /* @__PURE__ */ ce(BN, [["render", FN]]), VN = "HH:mm:ss", HN = oe({
  mixins: [hn],
  data() {
    return {
      format: VN
    };
  }
});
function jN(e, n, t, a, u, f) {
  const d = D("form-label-component"), m = D("el-time-picker"), g = D("form-error-component"), y = D("el-form-item");
  return V(), X(y, {
    prop: e.scope,
    rules: e.rules
  }, Tt({
    error: k(({ error: w }) => [
      z(g, {
        error: w[e.locale]
      }, null, 8, ["error"])
    ]),
    default: k(() => {
      var w, h, b;
      return [
        z(m, {
          modelValue: e.model,
          "onUpdate:modelValue": n[0] || (n[0] = (T) => e.model = T),
          placeholder: (w = e.properties.placeholder) == null ? void 0 : w[e.locale],
          "start-placeholder": (h = e.properties.startPlaceholder) == null ? void 0 : h[e.locale],
          "end-placeholder": (b = e.properties.endPlaceholder) == null ? void 0 : b[e.locale],
          "is-range": e.properties.range,
          format: e.properties.format,
          "value-format": e.properties.format || e.format,
          disabled: e.disabled
        }, null, 8, ["modelValue", "placeholder", "start-placeholder", "end-placeholder", "is-range", "format", "value-format", "disabled"])
      ];
    }),
    _: 2
  }, [
    e.label ? {
      name: "label",
      fn: k(() => [
        z(d, {
          label: e.label,
          rules: e.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const ZN = /* @__PURE__ */ ce(HN, [["render", jN]]), WN = oe({
  mixins: [Cs],
  emits: ["update:model-value", "validate-field"],
  data() {
    return {
      ControlComponent: {
        [`${ye.arrayStrings}`]: Le(hM),
        [`${ye.checkbox}`]: Le(pM),
        [`${ye.date}`]: Le(bM),
        [`${ye.editor}`]: Le(PA),
        [`${ye.mapDraw}`]: Le(WA),
        [`${ye.number}`]: Le(QA),
        [`${ye.radio}`]: Le(tP),
        [`${ye.select}`]: Le(rP),
        [`${ye.selectRemote}`]: Le(wN),
        [`${ye.selectSearch}`]: Le(CN),
        [`${ye.selectTree}`]: Le(NN),
        [`${ye.string}`]: Le(DN),
        [`${ye.switch}`]: Le(zN),
        [`${ye.textarea}`]: Le(UN),
        [`${ye.time}`]: Le(ZN)
      }
    };
  },
  computed: {
    key() {
      return JSON.stringify(this.schema);
    },
    properties() {
      return this.schema.properties;
    },
    model: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:model-value", e);
      }
    }
  },
  methods: {
    validateField(e) {
      this.$emit("validate-field", e);
    }
  }
});
function GN(e, n, t, a, u, f) {
  return e.isShown ? (V(), X(Gi(e.ControlComponent[e.properties.type]), {
    modelValue: e.model,
    "onUpdate:modelValue": n[0] || (n[0] = (d) => e.model = d),
    id: e.schema.id,
    scope: e.schema.scope,
    properties: e.properties,
    locale: e.locale,
    readonly: e.readonly,
    key: e.key,
    onValidateField: e.validateField
  }, null, 40, ["modelValue", "id", "scope", "properties", "locale", "readonly", "onValidateField"])) : Ze("", !0);
}
const ig = /* @__PURE__ */ ce(WN, [["render", GN]]), qN = {
  modify: {
    [Ta.en]: "Modify",
    [Ta.fr]: "Modifier"
  },
  delete: {
    [Ta.en]: "Delete",
    [Ta.fr]: "Supprimer"
  }
}, KN = oe({
  emits: ["update:model-value"],
  props: {
    title: {
      type: String,
      required: !0
    },
    confirmation: {
      type: String,
      required: !0
    },
    elements: {
      type: Array,
      required: !0
    },
    width: {
      type: String,
      default: "600px"
    },
    locale: {
      type: String
    }
  },
  data() {
    return {
      value: {}
    };
  },
  computed: {
    schema() {
      return new hf({
        properties: {
          type: Ar.vertical
        },
        elements: this.elements
      });
    }
  },
  methods: {
    open(e) {
      this.value = ke.cloneDeep(e) || {}, this.$refs.dialog.open();
    },
    onConfirmationClick() {
      this.$refs.mphFormSchema.$refs.elForm.validate((n) => {
        n && (this.$emit("update:model-value", this.value), this.$refs.dialog.close());
      });
    }
  },
  components: {
    DialogComponent: Ls
  }
}), YN = "_content_1cwuv_1", QN = {
  content: YN
};
function JN(e, n, t, a, u, f) {
  const d = D("helper-form-schema"), m = D("el-button"), g = D("dialog-component");
  return V(), X(g, {
    width: e.width,
    ref: "dialog"
  }, {
    activator: k(() => [
      Ke(e.$slots, "default", { open: e.open })
    ]),
    header: k(() => [
      ae("span", null, wt(e.title), 1)
    ]),
    default: k(({ dialogOpen: y }) => [
      y ? (V(), ue("div", {
        key: 0,
        class: J(e.$style.content)
      }, [
        e.elements ? (V(), X(d, {
          key: 0,
          modelValue: e.value,
          "onUpdate:modelValue": n[0] || (n[0] = (w) => e.value = w),
          schema: e.schema,
          locale: e.locale,
          ref: "mphFormSchema"
        }, null, 8, ["modelValue", "schema", "locale"])) : Ze("", !0)
      ], 2)) : Ze("", !0)
    ]),
    footer: k(({ close: y }) => [
      z(m, { onClick: e.onConfirmationClick }, {
        default: k(() => [
          ae("span", null, wt(e.confirmation), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 3
  }, 8, ["width"]);
}
const XN = {
  $style: QN
}, eI = /* @__PURE__ */ ce(KN, [["render", JN], ["__cssModules", XN]]), tI = oe({
  mixins: [Cs],
  data() {
    return {
      TableRendition: qN,
      path: this.schema.scope.split(".")
    };
  },
  computed: {
    properties() {
      return this.schema.properties;
    },
    label() {
      var e, n;
      return (n = (e = this.properties) == null ? void 0 : e.label) == null ? void 0 : n[this.locale];
    },
    value() {
      return ke.get(this.modelValue, this.path);
    },
    rules() {
      var e;
      return (e = this.properties) == null ? void 0 : e.rules;
    },
    disabled() {
      var e;
      return this.readonly || ((e = this.properties) == null ? void 0 : e.readonly);
    },
    model: {
      get() {
        return this.value;
      },
      set(e) {
        this.$emit("update:model-value", ke.set(this.modelValue, this.path, e));
      }
    }
  },
  methods: {
    onRowAdded(e) {
      this.model = this.model.concat(ke.cloneDeep(e));
    },
    onRowEdited(e, n) {
      this.model = this.model.map((t, a) => a === n ? ke.cloneDeep(e) : t);
    },
    onRowDeleted(e) {
      this.model = this.model.filter((n, t) => t !== e);
    }
  },
  mounted() {
    var e, n;
    (e = this.properties) != null && e.value && (this.model = (n = this.properties) == null ? void 0 : n.value);
  },
  unmounted() {
    ke.unset(this.modelValue, this.path);
  },
  components: {
    UseDark: v_,
    FormLabelComponent: e_,
    FormErrorComponent: uf,
    DialogFormSchemaComponent: eI
  }
});
function nI(e, n, t, a, u, f) {
  const d = D("form-label-component"), m = D("el-table-column"), g = D("icon-plus"), y = D("el-icon"), w = D("el-button"), h = D("dialog-form-schema-component"), b = D("icon-more-filled"), T = D("el-dropdown-item"), A = D("el-dropdown-menu"), x = D("el-dropdown"), Z = D("use-dark"), H = D("el-table"), Y = D("form-error-component"), ee = D("el-form-item");
  return e.isShown ? (V(), X(ee, {
    key: 0,
    id: e.schema.id,
    prop: e.schema.scope,
    rules: e.rules
  }, Tt({
    error: k(({ error: re }) => [
      z(Y, {
        error: re[e.locale]
      }, null, 8, ["error"])
    ]),
    default: k(() => [
      z(H, {
        data: e.model,
        size: "default",
        "table-layout": "fixed",
        border: ""
      }, {
        default: k(() => [
          (V(!0), ue(st, null, Et(e.properties.columns, (re, be) => (V(), X(m, {
            key: be,
            prop: re.prop,
            label: re.label[e.locale],
            sortable: re.sortable,
            width: re.width,
            "min-width": re.minWidth,
            align: re.align,
            resizable: !1
          }, null, 8, ["prop", "label", "sortable", "width", "min-width", "align"]))), 128)),
          e.disabled ? Ze("", !0) : (V(), X(m, {
            key: 0,
            resizable: !1,
            width: "80px",
            align: "center"
          }, {
            header: k(() => [
              z(h, {
                title: e.properties.dialogTitle[e.locale],
                confirmation: e.properties.dialogConfirmation[e.locale],
                elements: e.properties.dialogElements,
                locale: e.locale,
                "onUpdate:modelValue": e.onRowAdded
              }, {
                default: k(({ open: re }) => [
                  z(w, {
                    size: "default",
                    onClick: re
                  }, {
                    default: k(() => [
                      z(y, null, {
                        default: k(() => [
                          z(g)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }, 8, ["title", "confirmation", "elements", "locale", "onUpdate:modelValue"])
            ]),
            default: k(({ row: re, $index: be }) => [
              z(Z, null, {
                default: k(({ isDark: Xe }) => [
                  z(x, {
                    trigger: "click",
                    placement: "right"
                  }, {
                    dropdown: k(() => [
                      z(A, null, {
                        default: k(() => [
                          z(h, {
                            title: e.properties.dialogTitle[e.locale],
                            confirmation: e.properties.dialogConfirmation[e.locale],
                            elements: e.properties.dialogElements,
                            locale: e.locale,
                            "onUpdate:modelValue": (Fe) => e.onRowEdited(Fe, be)
                          }, {
                            default: k(({ open: Fe }) => [
                              z(T, { onClick: Fe }, {
                                default: k(() => [
                                  $h(wt(e.TableRendition.modify[e.locale]), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1032, ["title", "confirmation", "elements", "locale", "onUpdate:modelValue"]),
                          z(T, {
                            onClick: (Fe) => e.onRowDeleted(be)
                          }, {
                            default: k(() => [
                              $h(wt(e.TableRendition.delete[e.locale]), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: k(() => [
                      z(w, {
                        size: "default",
                        text: ""
                      }, {
                        default: k(() => [
                          z(y, {
                            color: Xe ? "white" : null,
                            size: "18"
                          }, {
                            default: k(() => [
                              z(b)
                            ]),
                            _: 2
                          }, 1032, ["color"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }))
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _: 2
  }, [
    e.label ? {
      name: "label",
      fn: k(() => [
        z(d, {
          label: e.label,
          rules: e.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["id", "prop", "rules"])) : Ze("", !0);
}
const rg = /* @__PURE__ */ ce(tI, [["render", nI]]), zu = oe({
  props: {
    modelValue: {},
    properties: {
      type: Object,
      required: !0
    },
    locale: {
      type: String,
      required: !0
    }
  },
  computed: {
    text() {
      return this.properties.text[this.locale];
    }
  }
}), iI = oe({
  mixins: [zu],
  components: {
    UseDark: v_
  }
}), rI = ["innerHTML"];
function oI(e, n, t, a, u, f) {
  const d = D("el-alert"), m = D("use-dark"), g = D("el-form-item");
  return V(), X(g, null, {
    default: k(() => [
      z(m, null, {
        default: k(({ isDark: y }) => [
          z(d, {
            effect: y ? "dark" : "light",
            type: "info",
            "show-icon": ""
          }, {
            default: k(() => [
              ae("span", { innerHTML: e.text }, null, 8, rI)
            ]),
            _: 2
          }, 1032, ["effect"])
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
const sI = /* @__PURE__ */ ce(iI, [["render", oI]]), aI = oe({
  mixins: [zu]
}), lI = ["innerHTML"];
function uI(e, n, t, a, u, f) {
  const d = D("el-form-item");
  return V(), X(d, null, {
    default: k(() => [
      ae("p", { innerHTML: e.text }, null, 8, lI)
    ]),
    _: 1
  });
}
const cI = /* @__PURE__ */ ce(aI, [["render", uI]]), hI = oe({
  mixins: [zu]
}), fI = ["innerHTML"];
function dI(e, n, t, a, u, f) {
  const d = D("el-form-item");
  return V(), X(d, null, {
    default: k(() => [
      ae("h3", { innerHTML: e.text }, null, 8, fI)
    ]),
    _: 1
  });
}
const pI = /* @__PURE__ */ ce(hI, [["render", dI]]), mI = oe({
  mixins: [zu]
}), _I = "_component_12mk6_1", gI = {
  component: _I
}, vI = ["innerHTML"];
function yI(e, n, t, a, u, f) {
  const d = D("el-divider"), m = D("el-form-item");
  return V(), X(m, {
    class: J(e.$style.component)
  }, {
    default: k(() => [
      ae("h6", { innerHTML: e.text }, null, 8, vI),
      z(d)
    ]),
    _: 1
  }, 8, ["class"]);
}
const bI = {
  $style: gI
}, wI = /* @__PURE__ */ ce(mI, [["render", yI], ["__cssModules", bI]]), LI = oe({
  mixins: [Cs],
  data() {
    return {
      TextComponent: {
        [`${Nn.alert}`]: Le(sI),
        [`${Nn.description}`]: Le(cI),
        [`${Nn.headline}`]: Le(pI),
        [`${Nn.label}`]: Le(wI)
      }
    };
  },
  computed: {
    properties() {
      return this.schema.properties;
    }
  }
});
function SI(e, n, t, a, u, f) {
  return e.isShown ? (V(), X(Gi(e.TextComponent[e.properties.type]), {
    key: 0,
    id: e.schema.id,
    properties: e.properties,
    locale: e.locale
  }, null, 8, ["id", "properties", "locale"])) : Ze("", !0);
}
const og = /* @__PURE__ */ ce(LI, [["render", SI]]);
var Mm;
const Nf = typeof window < "u";
Nf && ((Mm = window == null ? void 0 : window.navigator) != null && Mm.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
process.env.NODE_ENV !== "production" && Object.freeze({});
process.env.NODE_ENV !== "production" && Object.freeze([]);
const CI = Object.prototype.hasOwnProperty, Tm = (e, n) => CI.call(e, n), If = (e) => typeof e == "string", Bu = (e) => e !== null && typeof e == "object", sg = (e) => {
  const n = /* @__PURE__ */ Object.create(null);
  return (t) => n[t] || (n[t] = e(t));
}, MI = /-(\w)/g, TI = sg((e) => e.replace(MI, (n, t) => t ? t.toUpperCase() : "")), EI = /\B([A-Z])/g, AI = sg(
  (e) => e.replace(EI, "-$1").toLowerCase()
);
var PI = typeof global == "object" && global && global.Object === Object && global;
const xI = PI;
var OI = typeof self == "object" && self && self.Object === Object && self, NI = xI || OI || Function("return this")();
const kf = NI;
var II = kf.Symbol;
const ws = II;
var ag = Object.prototype, kI = ag.hasOwnProperty, DI = ag.toString, Sa = ws ? ws.toStringTag : void 0;
function $I(e) {
  var n = kI.call(e, Sa), t = e[Sa];
  try {
    e[Sa] = void 0;
    var a = !0;
  } catch {
  }
  var u = DI.call(e);
  return a && (n ? e[Sa] = t : delete e[Sa]), u;
}
var RI = Object.prototype, zI = RI.toString;
function BI(e) {
  return zI.call(e);
}
var FI = "[object Null]", UI = "[object Undefined]", Em = ws ? ws.toStringTag : void 0;
function lg(e) {
  return e == null ? e === void 0 ? UI : FI : Em && Em in Object(e) ? $I(e) : BI(e);
}
function VI(e) {
  return e != null && typeof e == "object";
}
var HI = "[object Symbol]";
function Df(e) {
  return typeof e == "symbol" || VI(e) && lg(e) == HI;
}
function jI(e, n) {
  for (var t = -1, a = e == null ? 0 : e.length, u = Array(a); ++t < a; )
    u[t] = n(e[t], t, e);
  return u;
}
var ZI = Array.isArray;
const $f = ZI;
var WI = 1 / 0, Am = ws ? ws.prototype : void 0, Pm = Am ? Am.toString : void 0;
function ug(e) {
  if (typeof e == "string")
    return e;
  if ($f(e))
    return jI(e, ug) + "";
  if (Df(e))
    return Pm ? Pm.call(e) : "";
  var n = e + "";
  return n == "0" && 1 / e == -WI ? "-0" : n;
}
function cg(e) {
  var n = typeof e;
  return e != null && (n == "object" || n == "function");
}
var GI = "[object AsyncFunction]", qI = "[object Function]", KI = "[object GeneratorFunction]", YI = "[object Proxy]";
function QI(e) {
  if (!cg(e))
    return !1;
  var n = lg(e);
  return n == qI || n == KI || n == GI || n == YI;
}
var JI = kf["__core-js_shared__"];
const Nh = JI;
var xm = function() {
  var e = /[^.]+$/.exec(Nh && Nh.keys && Nh.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function XI(e) {
  return !!xm && xm in e;
}
var ek = Function.prototype, tk = ek.toString;
function nk(e) {
  if (e != null) {
    try {
      return tk.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var ik = /[\\^$.*+?()[\]{}|]/g, rk = /^\[object .+?Constructor\]$/, ok = Function.prototype, sk = Object.prototype, ak = ok.toString, lk = sk.hasOwnProperty, uk = RegExp(
  "^" + ak.call(lk).replace(ik, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function ck(e) {
  if (!cg(e) || XI(e))
    return !1;
  var n = QI(e) ? uk : rk;
  return n.test(nk(e));
}
function hk(e, n) {
  return e == null ? void 0 : e[n];
}
function hg(e, n) {
  var t = hk(e, n);
  return ck(t) ? t : void 0;
}
function fk(e, n) {
  return e === n || e !== e && n !== n;
}
var dk = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, pk = /^\w*$/;
function mk(e, n) {
  if ($f(e))
    return !1;
  var t = typeof e;
  return t == "number" || t == "symbol" || t == "boolean" || e == null || Df(e) ? !0 : pk.test(e) || !dk.test(e) || n != null && e in Object(n);
}
var _k = hg(Object, "create");
const Da = _k;
function gk() {
  this.__data__ = Da ? Da(null) : {}, this.size = 0;
}
function vk(e) {
  var n = this.has(e) && delete this.__data__[e];
  return this.size -= n ? 1 : 0, n;
}
var yk = "__lodash_hash_undefined__", bk = Object.prototype, wk = bk.hasOwnProperty;
function Lk(e) {
  var n = this.__data__;
  if (Da) {
    var t = n[e];
    return t === yk ? void 0 : t;
  }
  return wk.call(n, e) ? n[e] : void 0;
}
var Sk = Object.prototype, Ck = Sk.hasOwnProperty;
function Mk(e) {
  var n = this.__data__;
  return Da ? n[e] !== void 0 : Ck.call(n, e);
}
var Tk = "__lodash_hash_undefined__";
function Ek(e, n) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = Da && n === void 0 ? Tk : n, this;
}
function vo(e) {
  var n = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++n < t; ) {
    var a = e[n];
    this.set(a[0], a[1]);
  }
}
vo.prototype.clear = gk;
vo.prototype.delete = vk;
vo.prototype.get = Lk;
vo.prototype.has = Mk;
vo.prototype.set = Ek;
function Ak() {
  this.__data__ = [], this.size = 0;
}
function Fu(e, n) {
  for (var t = e.length; t--; )
    if (fk(e[t][0], n))
      return t;
  return -1;
}
var Pk = Array.prototype, xk = Pk.splice;
function Ok(e) {
  var n = this.__data__, t = Fu(n, e);
  if (t < 0)
    return !1;
  var a = n.length - 1;
  return t == a ? n.pop() : xk.call(n, t, 1), --this.size, !0;
}
function Nk(e) {
  var n = this.__data__, t = Fu(n, e);
  return t < 0 ? void 0 : n[t][1];
}
function Ik(e) {
  return Fu(this.__data__, e) > -1;
}
function kk(e, n) {
  var t = this.__data__, a = Fu(t, e);
  return a < 0 ? (++this.size, t.push([e, n])) : t[a][1] = n, this;
}
function As(e) {
  var n = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++n < t; ) {
    var a = e[n];
    this.set(a[0], a[1]);
  }
}
As.prototype.clear = Ak;
As.prototype.delete = Ok;
As.prototype.get = Nk;
As.prototype.has = Ik;
As.prototype.set = kk;
var Dk = hg(kf, "Map");
const $k = Dk;
function Rk() {
  this.size = 0, this.__data__ = {
    hash: new vo(),
    map: new ($k || As)(),
    string: new vo()
  };
}
function zk(e) {
  var n = typeof e;
  return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
}
function Uu(e, n) {
  var t = e.__data__;
  return zk(n) ? t[typeof n == "string" ? "string" : "hash"] : t.map;
}
function Bk(e) {
  var n = Uu(this, e).delete(e);
  return this.size -= n ? 1 : 0, n;
}
function Fk(e) {
  return Uu(this, e).get(e);
}
function Uk(e) {
  return Uu(this, e).has(e);
}
function Vk(e, n) {
  var t = Uu(this, e), a = t.size;
  return t.set(e, n), this.size += t.size == a ? 0 : 1, this;
}
function wo(e) {
  var n = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++n < t; ) {
    var a = e[n];
    this.set(a[0], a[1]);
  }
}
wo.prototype.clear = Rk;
wo.prototype.delete = Bk;
wo.prototype.get = Fk;
wo.prototype.has = Uk;
wo.prototype.set = Vk;
var Hk = "Expected a function";
function Rf(e, n) {
  if (typeof e != "function" || n != null && typeof n != "function")
    throw new TypeError(Hk);
  var t = function() {
    var a = arguments, u = n ? n.apply(this, a) : a[0], f = t.cache;
    if (f.has(u))
      return f.get(u);
    var d = e.apply(this, a);
    return t.cache = f.set(u, d) || f, d;
  };
  return t.cache = new (Rf.Cache || wo)(), t;
}
Rf.Cache = wo;
var jk = 500;
function Zk(e) {
  var n = Rf(e, function(a) {
    return t.size === jk && t.clear(), a;
  }), t = n.cache;
  return n;
}
var Wk = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Gk = /\\(\\)?/g, qk = Zk(function(e) {
  var n = [];
  return e.charCodeAt(0) === 46 && n.push(""), e.replace(Wk, function(t, a, u, f) {
    n.push(u ? f.replace(Gk, "$1") : a || t);
  }), n;
});
const Kk = qk;
function Yk(e) {
  return e == null ? "" : ug(e);
}
function Qk(e, n) {
  return $f(e) ? e : mk(e, n) ? [e] : Kk(Yk(e));
}
var Jk = 1 / 0;
function Xk(e) {
  if (typeof e == "string" || Df(e))
    return e;
  var n = e + "";
  return n == "0" && 1 / e == -Jk ? "-0" : n;
}
function eD(e, n) {
  n = Qk(n, e);
  for (var t = 0, a = n.length; e != null && t < a; )
    e = e[Xk(n[t++])];
  return t && t == a ? e : void 0;
}
function tD(e, n, t) {
  var a = e == null ? void 0 : eD(e, n);
  return a === void 0 ? t : a;
}
const nD = (e) => typeof e == "number", Om = (e) => Object.keys(e);
class iD extends Error {
  constructor(n) {
    super(n), this.name = "ElementPlusError";
  }
}
function rD(e, n) {
  if (process.env.NODE_ENV !== "production") {
    const t = If(e) ? new iD(`[${e}] ${n}`) : e;
    console.warn(t);
  }
}
const fg = (e = "") => e.split(" ").filter((n) => !!n.trim()), Nm = (e, n) => {
  !e || !n.trim() || e.classList.add(...fg(n));
}, bu = (e, n) => {
  !e || !n.trim() || e.classList.remove(...fg(n));
}, Ca = (e, n) => {
  var t;
  if (!Nf || !e || !n)
    return "";
  let a = TI(n);
  a === "float" && (a = "cssFloat");
  try {
    const u = e.style[a];
    if (u)
      return u;
    const f = (t = document.defaultView) == null ? void 0 : t.getComputedStyle(e, "");
    return f ? f[a] : "";
  } catch {
    return e.style[a];
  }
}, dg = "__epPropKey", oD = (e) => Bu(e) && !!e[dg], sD = (e, n) => {
  if (!Bu(e) || oD(e))
    return e;
  const { values: t, required: a, default: u, type: f, validator: d } = e, g = {
    type: f,
    required: !!a,
    validator: t || d ? (y) => {
      let w = !1, h = [];
      if (t && (h = Array.from(t), Tm(e, "default") && h.push(u), w || (w = h.includes(y))), d && (w || (w = d(y))), !w && h.length > 0) {
        const b = [...new Set(h)].map((T) => JSON.stringify(T)).join(", ");
        AL(`Invalid prop: validation failed${n ? ` for prop "${n}"` : ""}. Expected one of [${b}], got value ${JSON.stringify(y)}.`);
      }
      return w;
    } : void 0,
    [dg]: !0
  };
  return Tm(e, "default") && (g.default = u), g;
}, aD = ["", "default", "small", "large"];
var lD = {
  name: "en",
  el: {
    colorpicker: {
      confirm: "OK",
      clear: "Clear",
      defaultLabel: "color picker",
      description: "current color is {color}. press enter to select a new color."
    },
    datepicker: {
      now: "Now",
      today: "Today",
      cancel: "Cancel",
      clear: "Clear",
      confirm: "OK",
      dateTablePrompt: "Use the arrow keys and enter to select the day of the month",
      monthTablePrompt: "Use the arrow keys and enter to select the month",
      yearTablePrompt: "Use the arrow keys and enter to select the year",
      selectedDate: "Selected date",
      selectDate: "Select date",
      selectTime: "Select time",
      startDate: "Start Date",
      startTime: "Start Time",
      endDate: "End Date",
      endTime: "End Time",
      prevYear: "Previous Year",
      nextYear: "Next Year",
      prevMonth: "Previous Month",
      nextMonth: "Next Month",
      year: "",
      month1: "January",
      month2: "February",
      month3: "March",
      month4: "April",
      month5: "May",
      month6: "June",
      month7: "July",
      month8: "August",
      month9: "September",
      month10: "October",
      month11: "November",
      month12: "December",
      week: "week",
      weeks: {
        sun: "Sun",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat"
      },
      weeksFull: {
        sun: "Sunday",
        mon: "Monday",
        tue: "Tuesday",
        wed: "Wednesday",
        thu: "Thursday",
        fri: "Friday",
        sat: "Saturday"
      },
      months: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec"
      }
    },
    inputNumber: {
      decrease: "decrease number",
      increase: "increase number"
    },
    select: {
      loading: "Loading",
      noMatch: "No matching data",
      noData: "No data",
      placeholder: "Select"
    },
    dropdown: {
      toggleDropdown: "Toggle Dropdown"
    },
    cascader: {
      noMatch: "No matching data",
      loading: "Loading",
      placeholder: "Select",
      noData: "No data"
    },
    pagination: {
      goto: "Go to",
      pagesize: "/page",
      total: "Total {total}",
      pageClassifier: "",
      page: "Page",
      prev: "Go to previous page",
      next: "Go to next page",
      currentPage: "page {pager}",
      prevPages: "Previous {pager} pages",
      nextPages: "Next {pager} pages",
      deprecationWarning: "Deprecated usages detected, please refer to the el-pagination documentation for more details"
    },
    dialog: {
      close: "Close this dialog"
    },
    drawer: {
      close: "Close this dialog"
    },
    messagebox: {
      title: "Message",
      confirm: "OK",
      cancel: "Cancel",
      error: "Illegal input",
      close: "Close this dialog"
    },
    upload: {
      deleteTip: "press delete to remove",
      delete: "Delete",
      preview: "Preview",
      continue: "Continue"
    },
    slider: {
      defaultLabel: "slider between {min} and {max}",
      defaultRangeStartLabel: "pick start value",
      defaultRangeEndLabel: "pick end value"
    },
    table: {
      emptyText: "No Data",
      confirmFilter: "Confirm",
      resetFilter: "Reset",
      clearFilter: "All",
      sumText: "Sum"
    },
    tree: {
      emptyText: "No Data"
    },
    transfer: {
      noMatch: "No matching data",
      noData: "No data",
      titles: ["List 1", "List 2"],
      filterPlaceholder: "Enter keyword",
      noCheckedFormat: "{total} items",
      hasCheckedFormat: "{checked}/{total} checked"
    },
    image: {
      error: "FAILED"
    },
    pageHeader: {
      title: "Back"
    },
    popconfirm: {
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    }
  }
};
const uD = (e) => (n, t) => cD(n, t, Er(e)), cD = (e, n, t) => tD(t, e, e).replace(/\{(\w+)\}/g, (a, u) => {
  var f;
  return `${(f = n == null ? void 0 : n[u]) != null ? f : `{${u}}`}`;
}), hD = (e) => {
  const n = mt(() => Er(e).name), t = af(e) ? e : Xt(e);
  return {
    lang: n,
    locale: t,
    t: uD(e)
  };
}, pg = Symbol("localeContextKey"), fD = (e) => {
  const n = e || Mu(pg, Xt());
  return hD(mt(() => n.value || lD));
}, tf = "el", dD = "is-", uo = (e, n, t, a, u) => {
  let f = `${e}-${n}`;
  return t && (f += `-${t}`), a && (f += `__${a}`), u && (f += `--${u}`), f;
}, mg = Symbol("namespaceContextKey"), pD = (e) => {
  const n = e || Mu(mg, Xt(tf));
  return mt(() => Er(n) || tf);
}, mD = (e, n) => {
  const t = pD(n);
  return {
    namespace: t,
    b: (x = "") => uo(t.value, e, x, "", ""),
    e: (x) => x ? uo(t.value, e, "", x, "") : "",
    m: (x) => x ? uo(t.value, e, "", "", x) : "",
    be: (x, Z) => x && Z ? uo(t.value, e, x, Z, "") : "",
    em: (x, Z) => x && Z ? uo(t.value, e, "", x, Z) : "",
    bm: (x, Z) => x && Z ? uo(t.value, e, x, "", Z) : "",
    bem: (x, Z, H) => x && Z && H ? uo(t.value, e, x, Z, H) : "",
    is: (x, ...Z) => {
      const H = Z.length >= 1 ? Z[0] : !0;
      return x && H ? `${dD}${x}` : "";
    },
    cssVar: (x) => {
      const Z = {};
      for (const H in x)
        x[H] && (Z[`--${t.value}-${H}`] = x[H]);
      return Z;
    },
    cssVarName: (x) => `--${t.value}-${x}`,
    cssVarBlock: (x) => {
      const Z = {};
      for (const H in x)
        x[H] && (Z[`--${t.value}-${e}-${H}`] = x[H]);
      return Z;
    },
    cssVarBlockName: (x) => `--${t.value}-${e}-${x}`
  };
}, Im = Xt(0), _g = 2e3, gg = Symbol("zIndexContextKey"), _D = (e) => {
  const n = e || Mu(gg, void 0), t = mt(() => {
    const f = Er(n);
    return nD(f) ? f : _g;
  }), a = mt(() => t.value + Im.value);
  return {
    initialZIndex: t,
    currentZIndex: a,
    nextZIndex: () => (Im.value++, a.value)
  };
};
sD({
  type: String,
  values: aD,
  required: !1
});
const gD = Symbol("size"), vg = Symbol(), wu = Xt();
function yg(e, n = void 0) {
  const t = Su() ? Mu(vg, wu) : wu;
  return e ? mt(() => {
    var a, u;
    return (u = (a = t.value) == null ? void 0 : a[e]) != null ? u : n;
  }) : t;
}
function vD(e, n) {
  const t = yg(), a = mD(e, mt(() => {
    var m;
    return ((m = t.value) == null ? void 0 : m.namespace) || tf;
  })), u = fD(mt(() => {
    var m;
    return (m = t.value) == null ? void 0 : m.locale;
  })), f = _D(mt(() => {
    var m;
    return ((m = t.value) == null ? void 0 : m.zIndex) || _g;
  })), d = mt(() => {
    var m;
    return Er(n) || ((m = t.value) == null ? void 0 : m.size) || "";
  });
  return yD(mt(() => Er(t) || {})), {
    ns: a,
    locale: u,
    zIndex: f,
    size: d
  };
}
const yD = (e, n, t = !1) => {
  var a;
  const u = !!Su(), f = u ? yg() : void 0, d = (a = n == null ? void 0 : n.provide) != null ? a : u ? PL : void 0;
  if (!d) {
    rD("provideGlobalConfig", "provideGlobalConfig() can only be used inside setup().");
    return;
  }
  const m = mt(() => {
    const g = Er(e);
    return f != null && f.value ? bD(f.value, g) : g;
  });
  return d(vg, m), d(pg, mt(() => m.value.locale)), d(mg, mt(() => m.value.namespace)), d(gg, mt(() => m.value.zIndex)), d(gD, {
    size: mt(() => m.value.size || "")
  }), (t || !wu.value) && (wu.value = m.value), m;
}, bD = (e, n) => {
  var t;
  const a = [.../* @__PURE__ */ new Set([...Om(e), ...Om(n)])], u = {};
  for (const f of a)
    u[f] = (t = n[f]) != null ? t : e[f];
  return u;
};
function wD(e) {
  let n;
  const t = Xt(!1), a = lf({
    ...e,
    originalPosition: "",
    originalOverflow: "",
    visible: !1
  });
  function u(b) {
    a.text = b;
  }
  function f() {
    const b = a.parent, T = h.ns;
    if (!b.vLoadingAddClassList) {
      let A = b.getAttribute("loading-number");
      A = Number.parseInt(A) - 1, A ? b.setAttribute("loading-number", A.toString()) : (bu(b, T.bm("parent", "relative")), b.removeAttribute("loading-number")), bu(b, T.bm("parent", "hidden"));
    }
    d(), w.unmount();
  }
  function d() {
    var b, T;
    (T = (b = h.$el) == null ? void 0 : b.parentNode) == null || T.removeChild(h.$el);
  }
  function m() {
    var b;
    e.beforeClose && !e.beforeClose() || (t.value = !0, clearTimeout(n), n = window.setTimeout(g, 400), a.visible = !1, (b = e.closed) == null || b.call(e));
  }
  function g() {
    if (!t.value)
      return;
    const b = a.parent;
    t.value = !1, b.vLoadingAddClassList = void 0, f();
  }
  const y = oe({
    name: "ElLoading",
    setup(b, { expose: T }) {
      const { ns: A, zIndex: x } = vD("loading");
      return T({
        ns: A,
        zIndex: x
      }), () => {
        const Z = a.spinner || a.svg, H = ss("svg", {
          class: "circular",
          viewBox: a.svgViewBox ? a.svgViewBox : "0 0 50 50",
          ...Z ? { innerHTML: Z } : {}
        }, [
          ss("circle", {
            class: "path",
            cx: "25",
            cy: "25",
            r: "20",
            fill: "none"
          })
        ]), Y = a.text ? ss("p", { class: A.b("text") }, [a.text]) : void 0;
        return ss(xL, {
          name: A.b("fade"),
          onAfterLeave: g
        }, {
          default: k(() => [
            OL(z("div", {
              style: {
                backgroundColor: a.background || ""
              },
              class: [
                A.b("mask"),
                a.customClass,
                a.fullscreen ? "is-fullscreen" : ""
              ]
            }, [
              ss("div", {
                class: A.b("spinner")
              }, [H, Y])
            ]), [[NL, a.visible]])
          ])
        });
      };
    }
  }), w = IL(y), h = w.mount(document.createElement("div"));
  return {
    ...kL(a),
    setText: u,
    removeElLoadingChild: d,
    close: m,
    handleAfterLeave: g,
    vm: h,
    get $el() {
      return h.$el;
    }
  };
}
let tu;
const nf = function(e = {}) {
  if (!Nf)
    return;
  const n = LD(e);
  if (n.fullscreen && tu)
    return tu;
  const t = wD({
    ...n,
    closed: () => {
      var u;
      (u = n.closed) == null || u.call(n), n.fullscreen && (tu = void 0);
    }
  });
  SD(n, n.parent, t), km(n, n.parent, t), n.parent.vLoadingAddClassList = () => km(n, n.parent, t);
  let a = n.parent.getAttribute("loading-number");
  return a ? a = `${Number.parseInt(a) + 1}` : a = "1", n.parent.setAttribute("loading-number", a), n.parent.appendChild(t.$el), Cu(() => t.visible.value = n.visible), n.fullscreen && (tu = t), t;
}, LD = (e) => {
  var n, t, a, u;
  let f;
  return If(e.target) ? f = (n = document.querySelector(e.target)) != null ? n : document.body : f = e.target || document.body, {
    parent: f === document.body || e.body ? document.body : f,
    background: e.background || "",
    svg: e.svg || "",
    svgViewBox: e.svgViewBox || "",
    spinner: e.spinner || !1,
    text: e.text || "",
    fullscreen: f === document.body && ((t = e.fullscreen) != null ? t : !0),
    lock: (a = e.lock) != null ? a : !1,
    customClass: e.customClass || "",
    visible: (u = e.visible) != null ? u : !0,
    target: f
  };
}, SD = async (e, n, t) => {
  const { nextZIndex: a } = t.vm.zIndex || t.vm._.exposed.zIndex, u = {};
  if (e.fullscreen)
    t.originalPosition.value = Ca(document.body, "position"), t.originalOverflow.value = Ca(document.body, "overflow"), u.zIndex = a();
  else if (e.parent === document.body) {
    t.originalPosition.value = Ca(document.body, "position"), await Cu();
    for (const f of ["top", "left"]) {
      const d = f === "top" ? "scrollTop" : "scrollLeft";
      u[f] = `${e.target.getBoundingClientRect()[f] + document.body[d] + document.documentElement[d] - Number.parseInt(Ca(document.body, `margin-${f}`), 10)}px`;
    }
    for (const f of ["height", "width"])
      u[f] = `${e.target.getBoundingClientRect()[f]}px`;
  } else
    t.originalPosition.value = Ca(n, "position");
  for (const [f, d] of Object.entries(u))
    t.$el.style[f] = d;
}, km = (e, n, t) => {
  const a = t.vm.ns || t.vm._.exposed.ns;
  ["absolute", "fixed", "sticky"].includes(t.originalPosition.value) ? bu(n, a.bm("parent", "relative")) : Nm(n, a.bm("parent", "relative")), e.fullscreen && e.lock ? Nm(n, a.bm("parent", "hidden")) : bu(n, a.bm("parent", "hidden"));
}, rf = Symbol("ElLoading"), Dm = (e, n) => {
  var t, a, u, f;
  const d = n.instance, m = (b) => Bu(n.value) ? n.value[b] : void 0, g = (b) => {
    const T = If(b) && (d == null ? void 0 : d[b]) || b;
    return T && Xt(T);
  }, y = (b) => g(m(b) || e.getAttribute(`element-loading-${AI(b)}`)), w = (t = m("fullscreen")) != null ? t : n.modifiers.fullscreen, h = {
    text: y("text"),
    svg: y("svg"),
    svgViewBox: y("svgViewBox"),
    spinner: y("spinner"),
    background: y("background"),
    customClass: y("customClass"),
    fullscreen: w,
    target: (a = m("target")) != null ? a : w ? void 0 : e,
    body: (u = m("body")) != null ? u : n.modifiers.body,
    lock: (f = m("lock")) != null ? f : n.modifiers.lock
  };
  e[rf] = {
    options: h,
    instance: nf(h)
  };
}, CD = (e, n) => {
  for (const t of Object.keys(n))
    af(n[t]) && (n[t].value = e[t]);
}, $m = {
  mounted(e, n) {
    n.value && Dm(e, n);
  },
  updated(e, n) {
    const t = e[rf];
    n.oldValue !== n.value && (n.value && !n.oldValue ? Dm(e, n) : n.value && n.oldValue ? Bu(n.value) && CD(n.value, t.options) : t == null || t.instance.close());
  },
  unmounted(e) {
    var n;
    (n = e[rf]) == null || n.instance.close();
  }
}, MD = {
  install(e) {
    e.directive("loading", $m), e.config.globalProperties.$loading = nf;
  },
  directive: $m,
  service: nf
}, bg = oe({
  name: We.watcher,
  emits: ["update:model-value"],
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    schema: {
      type: Object,
      required: !0
    },
    locale: {
      type: String,
      required: !0
    }
  },
  render() {
    return null;
  },
  computed: {
    watchingScope() {
      return ke.get(this.modelValue, this.schema.properties.watchingScope);
    }
  },
  watch: {
    async watchingScope(e) {
      if (e) {
        const n = MD.service({
          lock: !0
        }), { url: t, queryKey: a, responseScope: u } = this.schema.properties;
        try {
          const f = await ng.httpWatcher({
            url: t,
            query: { [a]: e },
            locale: this.locale
          });
          this.$emit("update:model-value", ke.set(this.modelValue, u, f));
        } finally {
          n.close();
        }
      }
    }
  }
}), TD = oe({
  name: We.tabs,
  mixins: [Cs],
  emits: ["update:model-value", "submit", "validate-field"],
  props: {
    errorScopes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      elementComponent: {
        [`${We.button}`]: Le(Xm),
        [`${We.control}`]: Le(ig),
        [`${We.table}`]: Le(rg),
        [`${We.text}`]: Le(og),
        [`${We.watcher}`]: Le(bg)
      }
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:model-value", e);
      }
    }
  },
  methods: {
    isError(e) {
      return e.filter((a) => a.type === We.control).map((a) => a.scope).some((a) => this.errorScopes.includes(a));
    },
    submit() {
      this.$emit("submit");
    },
    validateField(e) {
      this.$emit("validate-field", e);
    }
  }
}), ED = "_component_1ixfk_1", AD = "_alert_1ixfk_4", PD = "_component__tabs_1ixfk_13", xD = {
  component: ED,
  alert: AD,
  "component__label-error": "_component__label-error_1ixfk_7",
  component__tabs: PD
}, OD = ["id"];
function ND(e, n, t, a, u, f) {
  const d = D("icon-warning-filled"), m = D("el-tab-pane"), g = D("el-tabs");
  return e.isShown ? (V(), ue("div", {
    key: 0,
    id: e.schema.id,
    class: J(e.$style.component)
  }, [
    z(g, {
      class: J(e.$style.component__tabs),
      type: "border-card"
    }, {
      default: k(() => [
        (V(!0), ue(st, null, Et(e.schema.elements, (y, w) => (V(), X(m, {
          key: `${w}-${y.id}`,
          id: y.id
        }, {
          label: k(() => [
            e.isError(y.elements) ? (V(), X(d, {
              key: 0,
              class: J(e.$style["component__label-error"])
            }, null, 8, ["class"])) : Ze("", !0),
            ae("span", null, wt(y.title[e.locale]), 1)
          ]),
          default: k(() => [
            (V(!0), ue(st, null, Et(y.elements, (h, b) => (V(), X(Gi(e.elementComponent[h.type]), {
              modelValue: e.model,
              "onUpdate:modelValue": n[0] || (n[0] = (T) => e.model = T),
              key: `element${b}`,
              schema: h,
              "error-scopes": e.errorScopes,
              locale: e.locale,
              readonly: e.readonly,
              onSubmit: e.submit,
              onValidateField: e.validateField
            }, null, 40, ["modelValue", "schema", "error-scopes", "locale", "readonly", "onSubmit", "onValidateField"]))), 128))
          ]),
          _: 2
        }, 1032, ["id"]))), 128))
      ]),
      _: 1
    }, 8, ["class"])
  ], 10, OD)) : Ze("", !0);
}
const ID = {
  $style: xD
}, kD = /* @__PURE__ */ ce(TD, [["render", ND], ["__cssModules", ID]]), DD = oe({
  name: We.layout,
  mixins: [Cs],
  emits: ["update:model-value", "submit", "validate-field"],
  props: {
    errorScopes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      LayoutComponent: {
        [`${Ar.horizontal}`]: Le(y1),
        [`${Ar.vertical}`]: Le(M1)
      },
      elementComponent: {
        [`${We.button}`]: Le(Xm),
        [`${We.control}`]: Le(ig),
        [`${We.layout}`]: We.layout,
        [`${We.table}`]: Le(rg),
        [`${We.tabs}`]: Le(kD),
        [`${We.text}`]: Le(og),
        [`${We.watcher}`]: Le(bg)
      }
    };
  },
  computed: {
    properties() {
      return this.schema.properties;
    },
    model: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:model-value", e);
      }
    }
  },
  methods: {
    submit() {
      this.$emit("submit");
    },
    validateField(e) {
      this.$emit("validate-field", e);
    }
  }
});
function $D(e, n, t, a, u, f) {
  return e.isShown ? (V(), X(Gi(e.LayoutComponent[e.properties.type]), {
    key: 0,
    modelValue: e.model,
    "onUpdate:modelValue": n[1] || (n[1] = (d) => e.model = d),
    id: e.schema.id
  }, {
    default: k(({ className: d }) => [
      (V(!0), ue(st, null, Et(e.schema.elements, (m, g) => (V(), X(Gi(e.elementComponent[m.type]), {
        modelValue: e.model,
        "onUpdate:modelValue": n[0] || (n[0] = (y) => e.model = y),
        key: m.id || g,
        class: J(d),
        schema: m,
        "error-scopes": e.errorScopes,
        locale: e.locale,
        readonly: e.readonly,
        onSubmit: e.submit,
        onValidateField: e.validateField
      }, null, 40, ["modelValue", "class", "schema", "error-scopes", "locale", "readonly", "onSubmit", "onValidateField"]))), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "id"])) : Ze("", !0);
}
const RD = /* @__PURE__ */ ce(DD, [["render", $D]]), zD = oe({
  emits: ["update:model-value", "submit"],
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    schema: {
      type: Object,
      required: !0
    },
    locale: {
      type: String,
      required: !0
    },
    readonly: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      showError: !1,
      errorScopes: []
    };
  },
  computed: {
    valueFields() {
      return this.errorScopes.map((e) => {
        const n = e.split(".");
        return ke.get(this.modelValue, n);
      });
    },
    errorAllRequired() {
      return this.valueFields.every((e) => !e);
    },
    errorUnexpectedFormat() {
      return this.valueFields.every((e) => e);
    },
    model: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:model-value", e);
      }
    }
  },
  methods: {
    validateField(e) {
      this.$refs.elForm.validateField(e, () => null);
    },
    resetFields(e) {
      this.$refs.elForm.resetFields(e);
    },
    async onSubmitForm() {
      const e = this.$refs.elForm;
      await e.validate((n) => {
        n && this.$emit("submit"), this.showError = !n, e.$el.scrollIntoView({ behavior: "smooth" });
      });
    },
    onValidate(e, n) {
      this.errorScopes = this.errorScopes.filter((t) => t !== e), n || (this.errorScopes = this.errorScopes.concat(e));
    }
  },
  components: {
    LayoutComponent: RD
  }
});
function BD(e, n, t, a, u, f) {
  const d = D("el-form-item"), m = D("layout-component"), g = D("el-form");
  return V(), X(g, {
    model: e.model,
    class: "form-schema",
    "hide-required-asterisk": "",
    "label-position": "top",
    "inline-message": "",
    ref: "elForm",
    onValidate: e.onValidate
  }, {
    default: k(() => [
      e.$slots.error && e.showError ? (V(), X(d, { key: 0 }, {
        default: k(() => [
          Ke(e.$slots, "error", {
            errorAllRequired: e.errorAllRequired,
            errorUnexpectedFormat: e.errorUnexpectedFormat
          })
        ]),
        _: 3
      })) : Ze("", !0),
      z(m, {
        modelValue: e.model,
        "onUpdate:modelValue": n[0] || (n[0] = (y) => e.model = y),
        schema: e.schema,
        "error-scopes": e.errorScopes,
        locale: e.locale,
        readonly: e.readonly,
        onValidateField: e.validateField,
        onResetFields: e.resetFields,
        onSubmit: e.onSubmitForm
      }, null, 8, ["modelValue", "schema", "error-scopes", "locale", "readonly", "onValidateField", "onResetFields", "onSubmit"])
    ]),
    _: 3
  }, 8, ["model", "onValidate"]);
}
const FD = /* @__PURE__ */ ce(zD, [["render", BD]]), UD = /^(https?:\/\/|\/\/)/i, VD = oe({
  props: {
    href: {
      type: [String, Object]
    },
    target: {
      type: String
    },
    underline: {
      type: Boolean
    },
    underlineHover: {
      type: Boolean
    },
    style: {
      type: Object
    },
    icon: {
      type: String
    },
    tabindex: {
      type: [String, Number]
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    isInternalLink() {
      return typeof this.href == "string" && !UD.test(this.href) || typeof this.href < "u" && this.href !== null && typeof this.href == "object";
    }
  }
}), HD = "_component_1bhwi_1", jD = "_component__prepend_1bhwi_11", ZD = "_component__apend_1bhwi_15", WD = "_underline_1bhwi_23", GD = {
  component: HD,
  component__prepend: jD,
  component__apend: ZD,
  underline: WD,
  "underline-hover": "_underline-hover_1bhwi_26"
};
function qD(e, n, t, a, u, f) {
  const d = D("router-link"), m = D("el-link");
  return e.isInternalLink ? (V(), X(d, {
    key: 0,
    class: J([e.$style.component, {
      [e.$style.underline]: e.underline,
      [e.$style["underline-hover"]]: e.underlineHover
    }]),
    to: e.href,
    target: e.target,
    tabindex: e.tabindex,
    style: lu(e.style),
    disabled: e.disabled
  }, {
    default: k(() => [
      e.$slots.prepend ? (V(), ue("span", {
        key: 0,
        class: J(e.$style.component__prepend)
      }, [
        Ke(e.$slots, "prepend")
      ], 2)) : Ze("", !0),
      Ke(e.$slots, "default"),
      e.$slots.append ? (V(), ue("span", {
        key: 1,
        class: J(e.$style.component__append)
      }, [
        Ke(e.$slots, "append")
      ], 2)) : Ze("", !0)
    ]),
    _: 3
  }, 8, ["class", "to", "target", "tabindex", "style", "disabled"])) : (V(), X(m, {
    key: 1,
    class: J([e.$style.component, {
      [e.$style.underline]: e.underline,
      [e.$style["underline-hover"]]: e.underlineHover
    }]),
    href: e.href,
    target: e.target,
    underline: !1,
    tabindex: e.tabindex,
    style: lu(e.style),
    disabled: e.disabled
  }, {
    default: k(() => [
      e.$slots.prepend ? (V(), ue("span", {
        key: 0,
        class: J(e.$style.component__prepend)
      }, [
        Ke(e.$slots, "prepend")
      ], 2)) : Ze("", !0),
      Ke(e.$slots, "default"),
      e.$slots.append ? (V(), ue("span", {
        key: 1,
        class: J(e.$style.component__append)
      }, [
        Ke(e.$slots, "append")
      ], 2)) : Ze("", !0)
    ]),
    _: 3
  }, 8, ["class", "href", "target", "tabindex", "style", "disabled"]));
}
const KD = {
  $style: GD
}, YD = /* @__PURE__ */ ce(VD, [["render", qD], ["__cssModules", KD]]), Rm = ":", QD = 250;
let Ih = null;
const JD = oe({
  emits: ["search"],
  props: {
    query: {
      type: Object,
      required: !0
    },
    filter: {
      type: Object,
      required: !0
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      selectValue: void 0,
      visible: !1
    };
  },
  computed: {
    model() {
      return Object.entries(this.query).reduce((e, [n, t]) => {
        const a = Array.isArray(t) && t.length === 0;
        return t && !a ? [...e, `${n}${Rm} ${t}`] : e;
      }, []);
    }
  },
  methods: {
    filterMethod(e) {
      e && (this.selectValue = e || void 0);
    },
    search() {
      this.$emit("search", {
        ...this.filter,
        search: this.selectValue
      }), this.visible = !1, this.$nextTick(this.$refs.elSelect.blur), this.$nextTick(this.$refs.elSelect.focus);
    },
    onRemoveTagClick(e) {
      const [n] = e.split(Rm), t = Object.entries(this.query).reduce((a, [u, f]) => u === n.trim() ? { ...a } : { ...a, [u]: f }, {});
      this.$emit("search", { ...t }), this.$nextTick(this.$refs.elSelect.blur), this.$nextTick(this.$refs.elSelect.focus);
    },
    onClearClick() {
      this.$emit("search", {}), this.$nextTick(this.$refs.elSelect.focus);
    },
    onSelectBlur() {
      Ih && clearTimeout(Ih), Ih = setTimeout(() => {
        var e;
        this.selectValue = (e = this.query) == null ? void 0 : e.search;
      }, QD);
    }
  },
  components: {
    OnClickOutside: g_
  }
}), XD = "_component_1wxq0_1", e$ = "_component__popper_1wxq0_10", t$ = {
  component: XD,
  component__popper: e$
};
function n$(e, n, t, a, u, f) {
  const d = D("el-select"), m = D("el-row"), g = D("el-form"), y = D("el-popover"), w = D("on-click-outside");
  return V(), ue("div", {
    class: J(e.$style.component)
  }, [
    z(w, {
      onTrigger: n[4] || (n[4] = (h) => e.visible = !1)
    }, {
      default: k(() => [
        z(y, {
          visible: e.visible,
          teleported: !1,
          title: e.title,
          width: "100%",
          ref: "elPopover",
          onHide: n[2] || (n[2] = (h) => e.visible = !1),
          onKeyup: n[3] || (n[3] = Ma((h) => e.visible = !1, ["esc"]))
        }, {
          reference: k(() => [
            z(d, {
              "model-value": e.model,
              "filter-method": e.filterMethod,
              "popper-class": e.$style.component__popper,
              multiple: "",
              filterable: "",
              clearable: "",
              placeholder: "Search",
              ref: "elSelect",
              onClick: n[0] || (n[0] = (h) => e.visible = !0),
              onKeyup: [
                n[1] || (n[1] = Ma(fo((h) => e.visible = !0, ["ctrl"]), ["space"])),
                Ma(e.search, ["enter"])
              ],
              onRemoveTag: e.onRemoveTagClick,
              onClear: e.onClearClick,
              onBlur: e.onSelectBlur
            }, null, 8, ["model-value", "filter-method", "popper-class", "onKeyup", "onRemoveTag", "onClear", "onBlur"])
          ]),
          default: k(() => [
            z(g, {
              size: "default",
              onKeyup: Ma(e.search, ["enter"])
            }, {
              default: k(() => [
                z(m, { gutter: 8 }, {
                  default: k(() => [
                    Ke(e.$slots, "searchFilters")
                  ]),
                  _: 3
                }),
                z(m, { gutter: 8 }, {
                  default: k(() => [
                    Ke(e.$slots, "searchActions", { searchAction: e.search })
                  ]),
                  _: 3
                })
              ]),
              _: 3
            }, 8, ["onKeyup"])
          ]),
          _: 3
        }, 8, ["visible", "title"])
      ]),
      _: 3
    })
  ], 2);
}
const i$ = {
  $style: t$
}, wg = /* @__PURE__ */ ce(JD, [["render", n$], ["__cssModules", i$]]);
let kh = null;
const r$ = oe({
  props: {
    columns: {
      type: Array,
      required: !0
    },
    pagination: {
      type: Object
    },
    size: {
      type: String,
      default: "default"
    }
  },
  data() {
    return {
      EnumSort: vn,
      PageSizes: jm,
      sortProp: null,
      sortOrder: null
    };
  },
  methods: {
    isIconSortUpOrDown(e) {
      if (this.pagination) {
        const n = this.pagination.searchInput.sort;
        return n && n[e];
      }
      return e === this.sortProp && this.sortOrder;
    },
    isIconSortUp(e) {
      if (this.pagination) {
        const n = this.pagination.searchInput.sort;
        return n && n[e] === vn.asc;
      }
      return this.sortOrder === vn.asc;
    },
    getOrder(e) {
      var t;
      const n = (t = this.pagination) == null ? void 0 : t.searchInput.sort;
      return Object.keys(n).findIndex((a) => a === e) + 1;
    },
    handlePaginationSort(e) {
      var t, a, u;
      let n = (t = this.pagination) == null ? void 0 : t.searchInput.sort;
      n && n[e] === vn.asc ? n = { ...n, [e]: vn.desc } : n && n[e] === vn.desc ? n = Object.entries(n).reduce((f, [d, m]) => d === e ? { ...f } : { ...f, [d]: m }, {}) : n = { ...n, [e]: vn.asc }, (u = this.pagination) == null || u.setSearchInput({ ...(a = this.pagination) == null ? void 0 : a.searchInput, sort: n }), kh && clearTimeout(kh), kh = setTimeout(() => {
        var f;
        (f = this.pagination) == null || f.searchAction();
      }, vn.time);
    },
    handleSort(e) {
      this.sortProp !== e && (this.sortOrder = null), this.sortProp = e, this.sortOrder === vn.desc ? this.sortOrder = null : (this.sortOrder = this.sortOrder === vn.asc ? vn.desc : vn.asc, this.$refs.elTable.sort(this.sortProp, this.sortOrder));
    },
    onSortClick(e) {
      this.pagination ? this.handlePaginationSort(e) : this.handleSort(e);
    },
    onPageSizeUpdate(e) {
      this.pagination && (this.pagination.setSearchInput({
        ...this.pagination.searchInput,
        perPage: e
      }), this.pagination.searchAction());
    },
    onCurrentPageUpdate(e) {
      this.pagination && (this.pagination.setSearchInput({
        ...this.pagination.searchInput,
        page: e
      }), this.pagination.searchAction());
    }
  }
}), o$ = "_cell_2wz1j_1", s$ = "_ascending_2wz1j_4", a$ = "_descending_2wz1j_7", l$ = "_component_2wz1j_11", u$ = "_component__badge_2wz1j_24", c$ = "_pagination__panel_2wz1j_46", h$ = "_pagination_2wz1j_46", f$ = {
  "el-table": "_el-table_2wz1j_1",
  cell: o$,
  "sort-caret": "_sort-caret_2wz1j_4",
  ascending: s$,
  descending: a$,
  component: l$,
  "component__table-sort": "_component__table-sort_2wz1j_15",
  component__badge: u$,
  pagination__panel: c$,
  pagination: h$
}, d$ = { key: 2 };
function p$(e, n, t, a, u, f) {
  const d = D("icon-sort-up"), m = D("icon-sort-down"), g = D("icon-sort"), y = D("el-icon"), w = D("helper-link"), h = D("el-table-column"), b = D("el-divider"), T = D("el-pagination"), A = D("el-table");
  return V(), X(A, {
    class: J([e.$style.component, { [e.$style.pagination]: !!e.pagination }]),
    size: e.size,
    ref: "elTable"
  }, Tt({
    default: k(() => [
      (V(!0), ue(st, null, Et(e.columns, (x, Z) => (V(), X(h, {
        key: Z,
        resizable: !1,
        prop: x.prop,
        width: x.width || "auto",
        "min-width": x.minWidth || "auto",
        align: x.align,
        type: x.type
      }, Tt({
        header: k(() => [
          e.$slots[`header_${x.prop}`] ? Ke(e.$slots, `header_${x.prop}`, { key: 0 }) : Ze("", !0),
          x.sortable ? (V(), X(w, {
            key: 1,
            class: J(e.$style["component__table-sort"]),
            onClick: (H) => e.onSortClick(x.prop)
          }, {
            default: k(() => [
              ae("span", null, wt(x.label), 1),
              z(y, { size: 14 }, {
                default: k(() => [
                  e.isIconSortUpOrDown(x.prop) ? (V(), ue(st, { key: 0 }, [
                    e.isIconSortUp(x.prop) ? (V(), X(d, { key: 0 })) : (V(), X(m, { key: 1 })),
                    e.pagination ? (V(), ue("div", {
                      key: 2,
                      class: J(e.$style.component__badge)
                    }, [
                      ae("span", null, wt(e.getOrder(x.prop)), 1)
                    ], 2)) : Ze("", !0)
                  ], 64)) : (V(), X(g, { key: 1 }))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["class", "onClick"])) : (V(), ue("span", d$, wt(x.label), 1))
        ]),
        _: 2
      }, [
        e.$slots[`column_${x.prop}`] ? {
          name: "default",
          fn: k(({ row: H, $index: Y }) => [
            Ke(e.$slots, `column_${x.prop}`, {
              row: H,
              $index: Y
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["prop", "width", "min-width", "align", "type"]))), 128))
    ]),
    _: 2
  }, [
    e.pagination && e.pagination.searchOutput ? {
      name: "append",
      fn: k(() => {
        var x, Z, H, Y, ee, re;
        return [
          z(b),
          z(T, {
            "page-size": (Z = (x = e.pagination) == null ? void 0 : x.searchOutput) == null ? void 0 : Z.perPage,
            "page-sizes": e.PageSizes,
            "current-page": (Y = (H = e.pagination) == null ? void 0 : H.searchOutput) == null ? void 0 : Y.page,
            class: J(e.$style.pagination__panel),
            total: (re = (ee = e.pagination) == null ? void 0 : ee.searchOutput) == null ? void 0 : re.totalRecords,
            layout: "sizes, prev, pager, next",
            small: "",
            "onUpdate:pageSize": e.onPageSizeUpdate,
            "onUpdate:currentPage": e.onCurrentPageUpdate
          }, null, 8, ["page-size", "page-sizes", "current-page", "class", "total", "onUpdate:pageSize", "onUpdate:currentPage"])
        ];
      }),
      key: "0"
    } : void 0
  ]), 1032, ["class", "size"]);
}
const m$ = {
  $style: f$
}, Lg = /* @__PURE__ */ ce(r$, [["render", p$], ["__cssModules", m$]]), _$ = oe({
  props: {
    columns: {
      type: Array,
      required: !0
    },
    searchInput: {
      type: Object,
      required: !0
    },
    searchOutput: {
      type: Object
    },
    searchAction: {
      type: Function,
      required: !0
    },
    setSearchInput: {
      type: Function,
      required: !0
    },
    route: {
      type: Object,
      required: !0
    },
    router: {
      type: Object,
      required: !0
    },
    querySearch: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "default"
    },
    border: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      EnumSort: vn
    };
  },
  computed: {
    query() {
      var e;
      return ((e = this.route.query) == null ? void 0 : e.filter) || {};
    },
    filter() {
      return this.searchInput.filter || {};
    },
    tableData() {
      var e;
      return (e = this.searchOutput) == null ? void 0 : e.content;
    },
    pagination() {
      return {
        searchInput: this.searchInput,
        searchOutput: this.searchOutput,
        searchAction: this.search,
        setSearchInput: this.setSearchInput
      };
    }
  },
  mounted() {
    if (this.searchOutput) {
      const e = { ...this.searchInput.request };
      this.router.push({ query: e });
    } else
      this.setSearchInput(this.route.query), this.search();
  },
  methods: {
    async search() {
      const { page: e, perPage: n } = await this.searchAction(), t = {
        ...this.searchInput.request,
        page: e,
        perPage: n
      };
      this.router.push({ query: t });
    },
    onQuerySearch(e) {
      this.setSearchInput({ filter: e }), this.search();
    }
  },
  components: {
    QuerySearchComponent: wg,
    TableComponent: Lg
  }
}), g$ = "_cell_1tu8v_1", v$ = "_ascending_1tu8v_4", y$ = "_descending_1tu8v_7", b$ = "_component_1tu8v_11", w$ = "_component__badge_1tu8v_29", L$ = {
  "el-table": "_el-table_1tu8v_1",
  cell: g$,
  "sort-caret": "_sort-caret_1tu8v_4",
  ascending: v$,
  descending: y$,
  component: b$,
  "component__table-sort": "_component__table-sort_1tu8v_20",
  component__badge: w$
}, S$ = { key: 1 };
function C$(e, n, t, a, u, f) {
  const d = D("query-search-component"), m = D("table-component");
  return V(), ue("div", {
    class: J(e.$style.component)
  }, [
    e.querySearch ? (V(), X(d, {
      key: 0,
      query: e.query,
      filter: e.filter,
      onSearch: e.onQuerySearch
    }, {
      searchFilters: k(() => [
        Ke(e.$slots, "searchFilters")
      ]),
      searchActions: k(({ searchAction: g }) => [
        Ke(e.$slots, "searchActions", { searchAction: g })
      ]),
      _: 3
    }, 8, ["query", "filter", "onSearch"])) : Ze("", !0),
    e.searchOutput ? (V(), X(m, {
      key: 1,
      data: e.tableData,
      columns: e.columns,
      pagination: e.pagination,
      border: e.border,
      size: e.size,
      "table-layout": "fixed"
    }, Tt({ _: 2 }, [
      Et(e.columns, (g, y) => ({
        name: `header_${g.prop}`,
        fn: k(() => [
          e.$slots[`header_${g.prop}`] ? Ke(e.$slots, `header_${g.prop}`, { key: 0 }) : Ze("", !0)
        ])
      })),
      Et(e.columns, (g, y) => ({
        name: `column_${g.prop}`,
        fn: k(({ row: w, $index: h }) => [
          e.$slots[`column_${g.prop}`] ? Ke(e.$slots, `column_${g.prop}`, {
            key: 0,
            row: w,
            $index: h
          }) : (V(), ue("span", S$, wt(w[g.prop]), 1))
        ])
      }))
    ]), 1032, ["data", "columns", "pagination", "border", "size"])) : Ze("", !0)
  ], 2);
}
const M$ = {
  $style: L$
}, T$ = /* @__PURE__ */ ce(_$, [["render", C$], ["__cssModules", M$]]), AR = {
  install: (e) => {
    e.component("HelperAppDialogs", gS);
  }
}, PR = {
  install: (e) => {
    e.component("HelperAppFooter", xS);
  }
}, xR = {
  install: (e) => {
    e.component("HelperAppHeader", mC);
  }
}, OR = {
  install: (e) => {
    e.component("HelperDialog", Ls);
  }
}, NR = {
  install: (e) => {
    e.component("HelperFormError", uf);
  }
}, IR = {
  install: (e) => {
    e.component("HelperFormSchema", FD);
  }
}, kR = {
  install: (e) => {
    e.component("HelperLink", YD);
  }
}, DR = {
  install: (e) => {
    e.component("HelperQuerySearch", wg);
  }
}, $R = {
  install: (e) => {
    e.component("HelperQueryTable", T$);
  }
}, RR = {
  install: (e) => {
    e.component("HelperTable", Lg);
  }
}, E$ = {
  languages: [],
  i18n: null
}, A$ = {
  getLanguages({ state: e, commit: n }, { action: t, i18n: a }) {
    return t().then((u) => (n("setLanguages", u), n("setI18n", a), e.languages.forEach(({ code: f }) => {
      a.global.setLocaleMessage(f, {});
    }), u));
  }
}, P$ = {
  currentLanguage(e) {
    return e.languages.find(({ code: n }) => {
      var t;
      return n === ((t = e.i18n) == null ? void 0 : t.global.locale);
    });
  }
}, x$ = {
  setLanguages(e, n) {
    e.languages = n || [];
  },
  setI18n(e, n) {
    e.i18n = n || null;
  },
  setCurrentLanguage(e, n) {
    localStorage.setItem("currentLanguage", n), e.i18n && (e.i18n.global.locale = n);
  }
}, O$ = {
  namespaced: !0,
  state: E$,
  actions: A$,
  getters: P$,
  mutations: x$
}, zR = {
  name: "LanguagesStore",
  module: O$
};
function N$() {
  return Sg().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function Sg() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const I$ = typeof Proxy == "function", k$ = "devtools-plugin:setup", D$ = "plugin:settings:set";
let rs, of;
function $$() {
  var e;
  return rs !== void 0 || (typeof window < "u" && window.performance ? (rs = !0, of = window.performance) : typeof global < "u" && (!((e = global.perf_hooks) === null || e === void 0) && e.performance) ? (rs = !0, of = global.perf_hooks.performance) : rs = !1), rs;
}
function R$() {
  return $$() ? of.now() : Date.now();
}
class z$ {
  constructor(n, t) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = n, this.hook = t;
    const a = {};
    if (n.settings)
      for (const d in n.settings) {
        const m = n.settings[d];
        a[d] = m.defaultValue;
      }
    const u = `__vue-devtools-plugin-settings__${n.id}`;
    let f = Object.assign({}, a);
    try {
      const d = localStorage.getItem(u), m = JSON.parse(d);
      Object.assign(f, m);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return f;
      },
      setSettings(d) {
        try {
          localStorage.setItem(u, JSON.stringify(d));
        } catch {
        }
        f = d;
      },
      now() {
        return R$();
      }
    }, t && t.on(D$, (d, m) => {
      d === this.plugin.id && this.fallbacks.setSettings(m);
    }), this.proxiedOn = new Proxy({}, {
      get: (d, m) => this.target ? this.target.on[m] : (...g) => {
        this.onQueue.push({
          method: m,
          args: g
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (d, m) => this.target ? this.target[m] : m === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(m) ? (...g) => (this.targetQueue.push({
        method: m,
        args: g,
        resolve: () => {
        }
      }), this.fallbacks[m](...g)) : (...g) => new Promise((y) => {
        this.targetQueue.push({
          method: m,
          args: g,
          resolve: y
        });
      })
    });
  }
  async setRealTarget(n) {
    this.target = n;
    for (const t of this.onQueue)
      this.target.on[t.method](...t.args);
    for (const t of this.targetQueue)
      t.resolve(await this.target[t.method](...t.args));
  }
}
function B$(e, n) {
  const t = e, a = Sg(), u = N$(), f = I$ && t.enableEarlyProxy;
  if (u && (a.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !f))
    u.emit(k$, e, n);
  else {
    const d = f ? new z$(t, u) : null;
    (a.__VUE_DEVTOOLS_PLUGINS__ = a.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: t,
      setupFn: n,
      proxy: d
    }), d && n(d.proxiedTarget);
  }
}
/*!
 * vuex v4.1.0
 * (c) 2022 Evan You
 * @license MIT
 */
var F$ = "store";
function Lo(e, n) {
  Object.keys(e).forEach(function(t) {
    return n(e[t], t);
  });
}
function U$(e) {
  return e !== null && typeof e == "object";
}
function V$(e) {
  return e && typeof e.then == "function";
}
function ii(e, n) {
  if (!e)
    throw new Error("[vuex] " + n);
}
function H$(e, n) {
  return function() {
    return e(n);
  };
}
function Cg(e, n, t) {
  return n.indexOf(e) < 0 && (t && t.prepend ? n.unshift(e) : n.push(e)), function() {
    var a = n.indexOf(e);
    a > -1 && n.splice(a, 1);
  };
}
function Mg(e, n) {
  e._actions = /* @__PURE__ */ Object.create(null), e._mutations = /* @__PURE__ */ Object.create(null), e._wrappedGetters = /* @__PURE__ */ Object.create(null), e._modulesNamespaceMap = /* @__PURE__ */ Object.create(null);
  var t = e.state;
  Vu(e, t, [], e._modules.root, !0), zf(e, t, n);
}
function zf(e, n, t) {
  var a = e._state, u = e._scope;
  e.getters = {}, e._makeLocalGettersCache = /* @__PURE__ */ Object.create(null);
  var f = e._wrappedGetters, d = {}, m = {}, g = DL(!0);
  g.run(function() {
    Lo(f, function(y, w) {
      d[w] = H$(y, e), m[w] = mt(function() {
        return d[w]();
      }), Object.defineProperty(e.getters, w, {
        get: function() {
          return m[w].value;
        },
        enumerable: !0
        // for local getters
      });
    });
  }), e._state = lf({
    data: n
  }), e._scope = g, e.strict && q$(e), a && t && e._withCommit(function() {
    a.data = null;
  }), u && u.stop();
}
function Vu(e, n, t, a, u) {
  var f = !t.length, d = e._modules.getNamespace(t);
  if (a.namespaced && (e._modulesNamespaceMap[d] && process.env.NODE_ENV !== "production" && console.error("[vuex] duplicate namespace " + d + " for the namespaced module " + t.join("/")), e._modulesNamespaceMap[d] = a), !f && !u) {
    var m = Bf(n, t.slice(0, -1)), g = t[t.length - 1];
    e._withCommit(function() {
      process.env.NODE_ENV !== "production" && g in m && console.warn(
        '[vuex] state field "' + g + '" was overridden by a module with the same name at "' + t.join(".") + '"'
      ), m[g] = a.state;
    });
  }
  var y = a.context = j$(e, d, t);
  a.forEachMutation(function(w, h) {
    var b = d + h;
    Z$(e, b, w, y);
  }), a.forEachAction(function(w, h) {
    var b = w.root ? h : d + h, T = w.handler || w;
    W$(e, b, T, y);
  }), a.forEachGetter(function(w, h) {
    var b = d + h;
    G$(e, b, w, y);
  }), a.forEachChild(function(w, h) {
    Vu(e, n, t.concat(h), w, u);
  });
}
function j$(e, n, t) {
  var a = n === "", u = {
    dispatch: a ? e.dispatch : function(f, d, m) {
      var g = Lu(f, d, m), y = g.payload, w = g.options, h = g.type;
      if ((!w || !w.root) && (h = n + h, process.env.NODE_ENV !== "production" && !e._actions[h])) {
        console.error("[vuex] unknown local action type: " + g.type + ", global type: " + h);
        return;
      }
      return e.dispatch(h, y);
    },
    commit: a ? e.commit : function(f, d, m) {
      var g = Lu(f, d, m), y = g.payload, w = g.options, h = g.type;
      if ((!w || !w.root) && (h = n + h, process.env.NODE_ENV !== "production" && !e._mutations[h])) {
        console.error("[vuex] unknown local mutation type: " + g.type + ", global type: " + h);
        return;
      }
      e.commit(h, y, w);
    }
  };
  return Object.defineProperties(u, {
    getters: {
      get: a ? function() {
        return e.getters;
      } : function() {
        return Tg(e, n);
      }
    },
    state: {
      get: function() {
        return Bf(e.state, t);
      }
    }
  }), u;
}
function Tg(e, n) {
  if (!e._makeLocalGettersCache[n]) {
    var t = {}, a = n.length;
    Object.keys(e.getters).forEach(function(u) {
      if (u.slice(0, a) === n) {
        var f = u.slice(a);
        Object.defineProperty(t, f, {
          get: function() {
            return e.getters[u];
          },
          enumerable: !0
        });
      }
    }), e._makeLocalGettersCache[n] = t;
  }
  return e._makeLocalGettersCache[n];
}
function Z$(e, n, t, a) {
  var u = e._mutations[n] || (e._mutations[n] = []);
  u.push(function(d) {
    t.call(e, a.state, d);
  });
}
function W$(e, n, t, a) {
  var u = e._actions[n] || (e._actions[n] = []);
  u.push(function(d) {
    var m = t.call(e, {
      dispatch: a.dispatch,
      commit: a.commit,
      getters: a.getters,
      state: a.state,
      rootGetters: e.getters,
      rootState: e.state
    }, d);
    return V$(m) || (m = Promise.resolve(m)), e._devtoolHook ? m.catch(function(g) {
      throw e._devtoolHook.emit("vuex:error", g), g;
    }) : m;
  });
}
function G$(e, n, t, a) {
  if (e._wrappedGetters[n]) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] duplicate getter key: " + n);
    return;
  }
  e._wrappedGetters[n] = function(f) {
    return t(
      a.state,
      // local state
      a.getters,
      // local getters
      f.state,
      // root state
      f.getters
      // root getters
    );
  };
}
function q$(e) {
  xr(function() {
    return e._state.data;
  }, function() {
    process.env.NODE_ENV !== "production" && ii(e._committing, "do not mutate vuex store state outside mutation handlers.");
  }, { deep: !0, flush: "sync" });
}
function Bf(e, n) {
  return n.reduce(function(t, a) {
    return t[a];
  }, e);
}
function Lu(e, n, t) {
  return U$(e) && e.type && (t = n, n = e, e = e.type), process.env.NODE_ENV !== "production" && ii(typeof e == "string", "expects string as the type, but found " + typeof e + "."), { type: e, payload: n, options: t };
}
var K$ = "vuex bindings", zm = "vuex:mutations", Dh = "vuex:actions", os = "vuex", Y$ = 0;
function Q$(e, n) {
  B$(
    {
      id: "org.vuejs.vuex",
      app: e,
      label: "Vuex",
      homepage: "https://next.vuex.vuejs.org/",
      logo: "https://vuejs.org/images/icons/favicon-96x96.png",
      packageName: "vuex",
      componentStateTypes: [K$]
    },
    function(t) {
      t.addTimelineLayer({
        id: zm,
        label: "Vuex Mutations",
        color: Bm
      }), t.addTimelineLayer({
        id: Dh,
        label: "Vuex Actions",
        color: Bm
      }), t.addInspector({
        id: os,
        label: "Vuex",
        icon: "storage",
        treeFilterPlaceholder: "Filter stores..."
      }), t.on.getInspectorTree(function(a) {
        if (a.app === e && a.inspectorId === os)
          if (a.filter) {
            var u = [];
            xg(u, n._modules.root, a.filter, ""), a.rootNodes = u;
          } else
            a.rootNodes = [
              Pg(n._modules.root, "")
            ];
      }), t.on.getInspectorState(function(a) {
        if (a.app === e && a.inspectorId === os) {
          var u = a.nodeId;
          Tg(n, u), a.state = eR(
            nR(n._modules, u),
            u === "root" ? n.getters : n._makeLocalGettersCache,
            u
          );
        }
      }), t.on.editInspectorState(function(a) {
        if (a.app === e && a.inspectorId === os) {
          var u = a.nodeId, f = a.path;
          u !== "root" && (f = u.split("/").filter(Boolean).concat(f)), n._withCommit(function() {
            a.set(n._state.data, f, a.state.value);
          });
        }
      }), n.subscribe(function(a, u) {
        var f = {};
        a.payload && (f.payload = a.payload), f.state = u, t.notifyComponentUpdate(), t.sendInspectorTree(os), t.sendInspectorState(os), t.addTimelineEvent({
          layerId: zm,
          event: {
            time: Date.now(),
            title: a.type,
            data: f
          }
        });
      }), n.subscribeAction({
        before: function(a, u) {
          var f = {};
          a.payload && (f.payload = a.payload), a._id = Y$++, a._time = Date.now(), f.state = u, t.addTimelineEvent({
            layerId: Dh,
            event: {
              time: a._time,
              title: a.type,
              groupId: a._id,
              subtitle: "start",
              data: f
            }
          });
        },
        after: function(a, u) {
          var f = {}, d = Date.now() - a._time;
          f.duration = {
            _custom: {
              type: "duration",
              display: d + "ms",
              tooltip: "Action duration",
              value: d
            }
          }, a.payload && (f.payload = a.payload), f.state = u, t.addTimelineEvent({
            layerId: Dh,
            event: {
              time: Date.now(),
              title: a.type,
              groupId: a._id,
              subtitle: "end",
              data: f
            }
          });
        }
      });
    }
  );
}
var Bm = 8702998, J$ = 6710886, X$ = 16777215, Eg = {
  label: "namespaced",
  textColor: X$,
  backgroundColor: J$
};
function Ag(e) {
  return e && e !== "root" ? e.split("/").slice(-2, -1)[0] : "Root";
}
function Pg(e, n) {
  return {
    id: n || "root",
    // all modules end with a `/`, we want the last segment only
    // cart/ -> cart
    // nested/cart/ -> cart
    label: Ag(n),
    tags: e.namespaced ? [Eg] : [],
    children: Object.keys(e._children).map(
      function(t) {
        return Pg(
          e._children[t],
          n + t + "/"
        );
      }
    )
  };
}
function xg(e, n, t, a) {
  a.includes(t) && e.push({
    id: a || "root",
    label: a.endsWith("/") ? a.slice(0, a.length - 1) : a || "Root",
    tags: n.namespaced ? [Eg] : []
  }), Object.keys(n._children).forEach(function(u) {
    xg(e, n._children[u], t, a + u + "/");
  });
}
function eR(e, n, t) {
  n = t === "root" ? n : n[t];
  var a = Object.keys(n), u = {
    state: Object.keys(e.state).map(function(d) {
      return {
        key: d,
        editable: !0,
        value: e.state[d]
      };
    })
  };
  if (a.length) {
    var f = tR(n);
    u.getters = Object.keys(f).map(function(d) {
      return {
        key: d.endsWith("/") ? Ag(d) : d,
        editable: !1,
        value: sf(function() {
          return f[d];
        })
      };
    });
  }
  return u;
}
function tR(e) {
  var n = {};
  return Object.keys(e).forEach(function(t) {
    var a = t.split("/");
    if (a.length > 1) {
      var u = n, f = a.pop();
      a.forEach(function(d) {
        u[d] || (u[d] = {
          _custom: {
            value: {},
            display: d,
            tooltip: "Module",
            abstract: !0
          }
        }), u = u[d]._custom.value;
      }), u[f] = sf(function() {
        return e[t];
      });
    } else
      n[t] = sf(function() {
        return e[t];
      });
  }), n;
}
function nR(e, n) {
  var t = n.split("/").filter(function(a) {
    return a;
  });
  return t.reduce(
    function(a, u, f) {
      var d = a[u];
      if (!d)
        throw new Error('Missing module "' + u + '" for path "' + n + '".');
      return f === t.length - 1 ? d : d._children;
    },
    n === "root" ? e : e.root._children
  );
}
function sf(e) {
  try {
    return e();
  } catch (n) {
    return n;
  }
}
var ri = function(n, t) {
  this.runtime = t, this._children = /* @__PURE__ */ Object.create(null), this._rawModule = n;
  var a = n.state;
  this.state = (typeof a == "function" ? a() : a) || {};
}, Og = { namespaced: { configurable: !0 } };
Og.namespaced.get = function() {
  return !!this._rawModule.namespaced;
};
ri.prototype.addChild = function(n, t) {
  this._children[n] = t;
};
ri.prototype.removeChild = function(n) {
  delete this._children[n];
};
ri.prototype.getChild = function(n) {
  return this._children[n];
};
ri.prototype.hasChild = function(n) {
  return n in this._children;
};
ri.prototype.update = function(n) {
  this._rawModule.namespaced = n.namespaced, n.actions && (this._rawModule.actions = n.actions), n.mutations && (this._rawModule.mutations = n.mutations), n.getters && (this._rawModule.getters = n.getters);
};
ri.prototype.forEachChild = function(n) {
  Lo(this._children, n);
};
ri.prototype.forEachGetter = function(n) {
  this._rawModule.getters && Lo(this._rawModule.getters, n);
};
ri.prototype.forEachAction = function(n) {
  this._rawModule.actions && Lo(this._rawModule.actions, n);
};
ri.prototype.forEachMutation = function(n) {
  this._rawModule.mutations && Lo(this._rawModule.mutations, n);
};
Object.defineProperties(ri.prototype, Og);
var So = function(n) {
  this.register([], n, !1);
};
So.prototype.get = function(n) {
  return n.reduce(function(t, a) {
    return t.getChild(a);
  }, this.root);
};
So.prototype.getNamespace = function(n) {
  var t = this.root;
  return n.reduce(function(a, u) {
    return t = t.getChild(u), a + (t.namespaced ? u + "/" : "");
  }, "");
};
So.prototype.update = function(n) {
  Ng([], this.root, n);
};
So.prototype.register = function(n, t, a) {
  var u = this;
  a === void 0 && (a = !0), process.env.NODE_ENV !== "production" && Ig(n, t);
  var f = new ri(t, a);
  if (n.length === 0)
    this.root = f;
  else {
    var d = this.get(n.slice(0, -1));
    d.addChild(n[n.length - 1], f);
  }
  t.modules && Lo(t.modules, function(m, g) {
    u.register(n.concat(g), m, a);
  });
};
So.prototype.unregister = function(n) {
  var t = this.get(n.slice(0, -1)), a = n[n.length - 1], u = t.getChild(a);
  if (!u) {
    process.env.NODE_ENV !== "production" && console.warn(
      "[vuex] trying to unregister module '" + a + "', which is not registered"
    );
    return;
  }
  u.runtime && t.removeChild(a);
};
So.prototype.isRegistered = function(n) {
  var t = this.get(n.slice(0, -1)), a = n[n.length - 1];
  return t ? t.hasChild(a) : !1;
};
function Ng(e, n, t) {
  if (process.env.NODE_ENV !== "production" && Ig(e, t), n.update(t), t.modules)
    for (var a in t.modules) {
      if (!n.getChild(a)) {
        process.env.NODE_ENV !== "production" && console.warn(
          "[vuex] trying to add a new module '" + a + "' on hot reloading, manual reload is needed"
        );
        return;
      }
      Ng(
        e.concat(a),
        n.getChild(a),
        t.modules[a]
      );
    }
}
var Fm = {
  assert: function(e) {
    return typeof e == "function";
  },
  expected: "function"
}, iR = {
  assert: function(e) {
    return typeof e == "function" || typeof e == "object" && typeof e.handler == "function";
  },
  expected: 'function or object with "handler" function'
}, Um = {
  getters: Fm,
  mutations: Fm,
  actions: iR
};
function Ig(e, n) {
  Object.keys(Um).forEach(function(t) {
    if (n[t]) {
      var a = Um[t];
      Lo(n[t], function(u, f) {
        ii(
          a.assert(u),
          rR(e, t, f, u, a.expected)
        );
      });
    }
  });
}
function rR(e, n, t, a, u) {
  var f = n + " should be " + u + ' but "' + n + "." + t + '"';
  return e.length > 0 && (f += ' in module "' + e.join(".") + '"'), f += " is " + JSON.stringify(a) + ".", f;
}
function oR(e) {
  return new bn(e);
}
var bn = function e(n) {
  var t = this;
  n === void 0 && (n = {}), process.env.NODE_ENV !== "production" && (ii(typeof Promise < "u", "vuex requires a Promise polyfill in this browser."), ii(this instanceof e, "store must be called with the new operator."));
  var a = n.plugins;
  a === void 0 && (a = []);
  var u = n.strict;
  u === void 0 && (u = !1);
  var f = n.devtools;
  this._committing = !1, this._actions = /* @__PURE__ */ Object.create(null), this._actionSubscribers = [], this._mutations = /* @__PURE__ */ Object.create(null), this._wrappedGetters = /* @__PURE__ */ Object.create(null), this._modules = new So(n), this._modulesNamespaceMap = /* @__PURE__ */ Object.create(null), this._subscribers = [], this._makeLocalGettersCache = /* @__PURE__ */ Object.create(null), this._scope = null, this._devtools = f;
  var d = this, m = this, g = m.dispatch, y = m.commit;
  this.dispatch = function(b, T) {
    return g.call(d, b, T);
  }, this.commit = function(b, T, A) {
    return y.call(d, b, T, A);
  }, this.strict = u;
  var w = this._modules.root.state;
  Vu(this, w, [], this._modules.root), zf(this, w), a.forEach(function(h) {
    return h(t);
  });
}, Ff = { state: { configurable: !0 } };
bn.prototype.install = function(n, t) {
  n.provide(t || F$, this), n.config.globalProperties.$store = this;
  var a = this._devtools !== void 0 ? this._devtools : process.env.NODE_ENV !== "production" || !1;
  a && Q$(n, this);
};
Ff.state.get = function() {
  return this._state.data;
};
Ff.state.set = function(e) {
  process.env.NODE_ENV !== "production" && ii(!1, "use store.replaceState() to explicit replace store state.");
};
bn.prototype.commit = function(n, t, a) {
  var u = this, f = Lu(n, t, a), d = f.type, m = f.payload, g = f.options, y = { type: d, payload: m }, w = this._mutations[d];
  if (!w) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] unknown mutation type: " + d);
    return;
  }
  this._withCommit(function() {
    w.forEach(function(b) {
      b(m);
    });
  }), this._subscribers.slice().forEach(function(h) {
    return h(y, u.state);
  }), process.env.NODE_ENV !== "production" && g && g.silent && console.warn(
    "[vuex] mutation type: " + d + ". Silent option has been removed. Use the filter functionality in the vue-devtools"
  );
};
bn.prototype.dispatch = function(n, t) {
  var a = this, u = Lu(n, t), f = u.type, d = u.payload, m = { type: f, payload: d }, g = this._actions[f];
  if (!g) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] unknown action type: " + f);
    return;
  }
  try {
    this._actionSubscribers.slice().filter(function(w) {
      return w.before;
    }).forEach(function(w) {
      return w.before(m, a.state);
    });
  } catch (w) {
    process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in before action subscribers: "), console.error(w));
  }
  var y = g.length > 1 ? Promise.all(g.map(function(w) {
    return w(d);
  })) : g[0](d);
  return new Promise(function(w, h) {
    y.then(function(b) {
      try {
        a._actionSubscribers.filter(function(T) {
          return T.after;
        }).forEach(function(T) {
          return T.after(m, a.state);
        });
      } catch (T) {
        process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in after action subscribers: "), console.error(T));
      }
      w(b);
    }, function(b) {
      try {
        a._actionSubscribers.filter(function(T) {
          return T.error;
        }).forEach(function(T) {
          return T.error(m, a.state, b);
        });
      } catch (T) {
        process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in error action subscribers: "), console.error(T));
      }
      h(b);
    });
  });
};
bn.prototype.subscribe = function(n, t) {
  return Cg(n, this._subscribers, t);
};
bn.prototype.subscribeAction = function(n, t) {
  var a = typeof n == "function" ? { before: n } : n;
  return Cg(a, this._actionSubscribers, t);
};
bn.prototype.watch = function(n, t, a) {
  var u = this;
  return process.env.NODE_ENV !== "production" && ii(typeof n == "function", "store.watch only accepts a function."), xr(function() {
    return n(u.state, u.getters);
  }, t, Object.assign({}, a));
};
bn.prototype.replaceState = function(n) {
  var t = this;
  this._withCommit(function() {
    t._state.data = n;
  });
};
bn.prototype.registerModule = function(n, t, a) {
  a === void 0 && (a = {}), typeof n == "string" && (n = [n]), process.env.NODE_ENV !== "production" && (ii(Array.isArray(n), "module path must be a string or an Array."), ii(n.length > 0, "cannot register the root module by using registerModule.")), this._modules.register(n, t), Vu(this, this.state, n, this._modules.get(n), a.preserveState), zf(this, this.state);
};
bn.prototype.unregisterModule = function(n) {
  var t = this;
  typeof n == "string" && (n = [n]), process.env.NODE_ENV !== "production" && ii(Array.isArray(n), "module path must be a string or an Array."), this._modules.unregister(n), this._withCommit(function() {
    var a = Bf(t.state, n.slice(0, -1));
    delete a[n[n.length - 1]];
  }), Mg(this);
};
bn.prototype.hasModule = function(n) {
  return typeof n == "string" && (n = [n]), process.env.NODE_ENV !== "production" && ii(Array.isArray(n), "module path must be a string or an Array."), this._modules.isRegistered(n);
};
bn.prototype.hotUpdate = function(n) {
  this._modules.update(n), Mg(this, !0);
};
bn.prototype._withCommit = function(n) {
  var t = this._committing;
  this._committing = !0, n(), this._committing = t;
};
Object.defineProperties(bn.prototype, Ff);
const sR = {
  loading: 0
}, aR = {
  isLoading(e) {
    return !!e.loading;
  }
}, lR = {
  startLoading(e) {
    e.loading += 1;
  },
  endLoading(e) {
    e.loading -= 1;
  }
}, BR = oR({
  state: sR,
  getters: aR,
  mutations: lR
}), uR = {
  getRenditions(e, {
    action: n,
    i18n: t
  }) {
    const a = t.global.locale;
    return n(a).then((u) => {
      const f = u.reduce((d, m) => ({
        ...d,
        [`${m.module}.${m.code}`]: m.rendition
      }), {});
      t.global.setLocaleMessage(a, f);
    });
  }
}, cR = {
  namespaced: !0,
  actions: uR
}, FR = {
  name: "RenditionsStore",
  module: cR
}, hR = {
  security: null
}, fR = {
  getSecurity({ commit: e }, n) {
    return n().then((t) => (e("setSecurity", t), t));
  },
  securityLogout({ state: e, commit: n }, t) {
    return t().then((a) => {
      if (e.security) {
        const { oauth2LogoutUrl: u } = e.security;
        n("setSecurity"), window.location.href = u;
      }
      return a;
    });
  }
}, dR = {
  login(e) {
    var n;
    return (n = e.security) == null ? void 0 : n.login;
  },
  roles(e) {
    var n;
    return ((n = e.security) == null ? void 0 : n.roles) || [];
  },
  features(e) {
    var n;
    return ((n = e.security) == null ? void 0 : n.features) || [];
  },
  isSuperAdmin(e, n) {
    const [t] = n.roles;
    return t === FL.superAdmin;
  },
  hasFeature(e, n) {
    return (t, a = Lp.or) => {
      const u = Array.isArray(t) ? t : [t];
      return n.isSuperAdmin ? !0 : n.features.length === 0 ? !1 : a === Lp.and ? u.every((f) => n.features.includes(f)) : u.some((f) => n.features.includes(f));
    };
  }
}, pR = {
  setSecurity(e, n) {
    e.security = n || null;
  }
}, mR = {
  namespaced: !0,
  state: hR,
  actions: fR,
  getters: dR,
  mutations: pR
}, UR = {
  name: "SecurityStore",
  module: mR
};
export {
  Ss as Condition,
  gi as DefaultMapOptions,
  BL as DefaultPage,
  zL as DefaultPageSize,
  Or as Element,
  PC as ElementButton,
  OC as ElementControl,
  hf as ElementLayout,
  Gm as ElementTab,
  kC as ElementTable,
  DC as ElementTabs,
  RC as ElementText,
  NC as ElementWatcher,
  Qm as EnumAlign,
  u1 as EnumDatePicker,
  We as EnumElement,
  Ym as EnumLogicalCondition,
  Ea as EnumOperator,
  _o as EnumPropertiesButton,
  ye as EnumPropertiesControl,
  Ar as EnumPropertiesLayout,
  Nn as EnumPropertiesText,
  h1 as EnumRuleTrigger,
  c1 as EnumRuleType,
  vn as EnumSort,
  yR as Feature,
  TR as FormSchema,
  ER as FormSubmitted,
  Rh as GoogleMutantOptions,
  AR as HelperAppDialogs,
  PR as HelperAppFooter,
  xR as HelperAppHeader,
  OR as HelperDialog,
  NR as HelperFormError,
  IR as HelperFormSchema,
  kR as HelperLink,
  DR as HelperQuerySearch,
  $R as HelperQueryTable,
  RR as HelperTable,
  Ye as Language,
  zR as LanguagesStore,
  BR as LoaderStore,
  Ta as LocaleI18n,
  $L as MarkerOptions,
  Lp as Operator,
  vR as PageSizeAll,
  jm as PageSizes,
  zC as PropertiesButtonMapSelect,
  BC as PropertiesButtonSubmit,
  cn as PropertiesControl,
  FC as PropertiesControlArrayStrings,
  UC as PropertiesControlCheckbox,
  VC as PropertiesControlDate,
  HC as PropertiesControlEditor,
  jC as PropertiesControlMapDraw,
  ZC as PropertiesControlNumber,
  WC as PropertiesControlRadio,
  GC as PropertiesControlSelect,
  qC as PropertiesControlSelectRemote,
  KC as PropertiesControlSelectSearch,
  YC as PropertiesControlSelectTree,
  QC as PropertiesControlString,
  JC as PropertiesControlSwitch,
  XC as PropertiesControlTextarea,
  e1 as PropertiesControlTime,
  qm as PropertiesLayout,
  t1 as PropertiesLayoutHorizontal,
  Km as PropertiesLayoutVertical,
  n1 as PropertiesTable,
  i1 as PropertiesTabs,
  Tu as PropertiesText,
  r1 as PropertiesTextAlert,
  o1 as PropertiesTextDescription,
  s1 as PropertiesTextHeadline,
  a1 as PropertiesTextLabel,
  l1 as PropertiesWatcher,
  f1 as PropertyColumn,
  cu as PropertyEnum,
  MR as PropertyRule,
  ff as PropertyTree,
  bR as Rendition,
  FR as RenditionsStore,
  FL as Role,
  wR as SearchInput,
  LR as SearchInputFilter,
  SR as SearchOutput,
  UR as SecurityStore,
  RL as ShapeOptions,
  cf as getElementByType,
  AC as getPropertiesButtonByType,
  xC as getPropertiesControlByType,
  IC as getPropertiesLayoutByType,
  $C as getPropertiesTextByType
};
